webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["a"] = ({
  request: function request(method, uri) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var debug = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    if (!method) {
      console.error('API function call requires method argument');
      return;
    }
    if (!uri) {
      console.error('API function call requires uri argument');
      return;
    }
    var url = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].serverURI + uri;
    var jwt = window.localStorage.getItem('token');
    var headers;
    if (jwt) {
      headers = {
        'Content-Type': 'text/plain',
        'X-Authorization': jwt
      };
    } else {
      headers = {
        'Content-Type': 'text/plain'
      };
    }
    return __WEBPACK_IMPORTED_MODULE_0_axios___default()({
      method: method,
      url: url,
      data: data,
      headers: headers
    });
  }
});

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(528)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(634),
  /* scopeId */
  "data-v-5d141ea6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = verifyFields;
/* harmony export (immutable) */ __webpack_exports__["a"] = persistToNewProviderStorage;
/* harmony export (immutable) */ __webpack_exports__["b"] = saveDataToLocalStorage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);


function verifyFields(data, validation) {
  return data.model.length === 0 && validation === false && data.required;
}

function persistToNewProviderStorage(inputValue, inputName) {
  var newProvider = JSON.parse(localStorage.getItem('newProviderPeru'));
  if (!newProvider) {
    newProvider = {};
  }
  newProvider[inputName] = inputValue;
  localStorage.setItem('newProviderPeru', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newProvider));
}

function saveDataToLocalStorage(inputValue, inputName) {
  persistToNewProviderStorage(inputValue, inputName);
}

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(536)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(644),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  serverURI: 'http://admin-suppliersone.artfosdev.com/index.php/',
  fixedLayout: false,
  hideLogoOnMobile: false
});

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var ESPERANDO_CONFIRMACION = '1';
var ACEPTADO = '2';
var DEVUELTO = '3';
var MODIFICADO = '4';
var SUSPENDIDO = '5';
var RECHAZADO = '6';

/* harmony default export */ __webpack_exports__["a"] = ({
  ESPERANDO_CONFIRMACION: ESPERANDO_CONFIRMACION,
  ACEPTADO: ACEPTADO,
  DEVUELTO: DEVUELTO,
  MODIFICADO: MODIFICADO,
  SUSPENDIDO: SUSPENDIDO,
  RECHAZADO: RECHAZADO
});

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  getTotal: function getTotal(model) {
    var condition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1';

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('GET', 'api/count/' + model + '?condition=' + condition).then(function (count) {
        resolve(parseInt(count.data));
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getQueryForApi: function getQueryForApi(queryInfo) {
    var _this = this;

    if (!queryInfo) return '';
    var query = '?';

    query += 'pageSize=' + queryInfo.pageSize;
    query += '&page=' + queryInfo.page;

    if (queryInfo.sort && queryInfo.sort.prop) {
      query += '&orderProp=' + queryInfo.sort.prop;
      query += '&order=';
      if (queryInfo.sort.order === 'ascending') query += 'ASC';else if (queryInfo.sort.order === 'descending') query += 'DESC';else query += 'null';
    }

    if (queryInfo.filters.length > 0) {
      var condition = '&condition=(';
      queryInfo.filters.forEach(function (filter, idFilter) {
        condition += idFilter > 0 ? ') AND (' : '';
        if (Array.isArray(filter.prop)) {
          console.log(filter.prop);
          filter.prop.forEach(function (prop, idProp) {
            condition += idProp > 0 ? ' OR ' : '';
            condition += _this.getCondition(prop, filter.value, filter.type);
          });
        } else {
          condition += _this.getCondition(filter.prop, filter.value, filter.type);
        }
      });
      condition += ')';
      query += encodeURI(condition);
    }
    return query;
  },
  like: function like(prop, value) {
    return prop + ' like \'%' + value + '%\' ';
  },
  dateRange: function dateRange(prop, from, to) {
    return prop + ' >= \'' + from + '\' AND ' + prop + ' <= \'' + to + '\' ';
  },
  getCondition: function getCondition(prop, value, type) {
    if (value === null) value = '';

    switch (type) {
      case 'dateRange':
        return value ? this.dateRange(prop, value[0], value[1]) : '1';
      case 'multiSelect':
        var cond = value.length > 0 ? '' : '1';
        value.forEach(function (val, i) {
          cond += i > 0 ? ' OR ' : '';
          cond += prop + '=' + val;
        });
        return cond;
      case '=':
        return prop + ' = \'' + value + '\' ';
      default:
        return this.like(prop, value);
    }
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var DATOS_GENERALES = '1';
var DATOS_BANCARIOS = '2';
var DATOS_IMPOSITIVOS = '3';
var DATOS_GENERALES_NAME = 'generalData';
var DATOS_BANCARIOS_NAME = 'paymentData';
var DATOS_IMPOSITIVOS_NAME = 'taxData';

/* harmony default export */ __webpack_exports__["a"] = ({
  DATOS_GENERALES: DATOS_GENERALES,
  DATOS_BANCARIOS: DATOS_BANCARIOS,
  DATOS_IMPOSITIVOS: DATOS_IMPOSITIVOS,
  DATOS_GENERALES_NAME: DATOS_GENERALES_NAME,
  DATOS_BANCARIOS_NAME: DATOS_BANCARIOS_NAME,
  DATOS_IMPOSITIVOS_NAME: DATOS_IMPOSITIVOS_NAME
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var COMPRAS = '1';
var PAGOS = '2';
var AUTOGESTION = '3';
var MENSAJES = '4';
var REPORTES = '5';
var INSTRUCTIVOS = '6';
var MAESTRO_PROVEEDORES = '7';
var ADMIN_PORTAL = '15';
var ADMIN_SISTEMA = '18';
var PROVEEDOR = '19';
var AUDITORIA = '20';
var ACTIVADOR_USUARIOS = '21';
var ALERTA_MENSAJES = '22';
var AUTORIZADOR_DG = '23';
var AUTORIZADOR_DI = '24';
var AUTORIZADOR_DP = '25';
var AUTORIZADOR_DG_PE = '26';
var AUTORIZADOR_DI_PE = '27';
var AUTORIZADOR_DP_PE = '28';

/* harmony default export */ __webpack_exports__["a"] = ({
  COMPRAS: COMPRAS,
  PAGOS: PAGOS,
  AUTOGESTION: AUTOGESTION,
  MENSAJES: MENSAJES,
  REPORTES: REPORTES,
  INSTRUCTIVOS: INSTRUCTIVOS,
  MAESTRO_PROVEEDORES: MAESTRO_PROVEEDORES,
  ADMIN_PORTAL: ADMIN_PORTAL,
  ADMIN_SISTEMA: ADMIN_SISTEMA,
  PROVEEDOR: PROVEEDOR,
  AUDITORIA: AUDITORIA,
  ACTIVADOR_USUARIOS: ACTIVADOR_USUARIOS,
  ALERTA_MENSAJES: ALERTA_MENSAJES,
  AUTORIZADOR_DG: AUTORIZADOR_DG,
  AUTORIZADOR_DI: AUTORIZADOR_DI,
  AUTORIZADOR_DP: AUTORIZADOR_DP,
  AUTORIZADOR_DG_PE: AUTORIZADOR_DG_PE,
  AUTORIZADOR_DI_PE: AUTORIZADOR_DI_PE,
  AUTORIZADOR_DP_PE: AUTORIZADOR_DP_PE
});

/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(541)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(649),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(651),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export servers */
/* unused harmony export stats */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return timeline; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


var servers = [{
  name: 'www01',
  status: 'success',
  icon: 'globe',
  description: 'Web server that runs our sites'
}, {
  name: 'sql01',
  status: 'danger',
  icon: 'database',
  description: 'mySQL server used for reporting'
}, {
  name: 'mongoDB01',
  status: 'info',
  icon: 'file-code-o',
  description: 'Main DB server'
}, {
  name: 'ldap01',
  status: 'success',
  icon: 'key',
  description: 'Authentication server'
}, {
  name: 'mgmt01',
  status: 'success',
  icon: 'home',
  description: 'Management server with all tools'
}, {
  name: 'bkup01',
  status: 'warning',
  icon: 'backward',
  description: 'Backup server'
}];

var stats = [{
  header: '8390',
  text: 'Visitors'
}, {
  header: '30%',
  text: 'Referrals'
}, {
  header: '70%',
  text: 'Organic'
}];

var timeline = [{
  id: 1,
  icon: 'fa-book',
  color: 'blue',
  title: 'DOCUMENTACIÓN PRESENTADA',
  time: __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('day').fromNow(),
  body: 'Esta es una lista de la documentación presentada hasta el momento.',
  buttons: [{
    type: 'primary',
    message: 'Declaración jurada',
    href: 'https://github.com/misterGF/CoPilot',
    target: '_blank'
  }, {
    type: 'primary',
    message: 'Certificación de firmas',
    href: 'https://github.com/misterGF/CoPilot',
    target: '_blank'
  }]
}, {
  id: 10,
  icon: 'fa-folder-open-o',
  color: 'blue',
  title: 'DESCARGA DE DOCUMENTOS',
  time: __WEBPACK_IMPORTED_MODULE_0_moment___default()().endOf('day').fromNow(),
  body: 'Descarga de documentos',
  buttons: [{
    type: 'primary',
    message: 'Instructivo de carga',
    href: 'https://github.com/misterGF/CoPilot',
    target: '_blank'
  }]
}, {
  id: 3,
  icon: 'fa-file-sound-o',
  color: 'purple',
  title: 'ALERTAS',
  time: __WEBPACK_IMPORTED_MODULE_0_moment___default()('20130620', 'YYYYMMDD').fromNow(),
  body: '<div class="embed-responsive embed-responsive-16by9">ALERTAS </div>'
}];

/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(547)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(658),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(530)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(636),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(518)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(622),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(638),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(542)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(650),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */,
/* 286 */,
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = domain;
/* harmony export (immutable) */ __webpack_exports__["a"] = count;
/* harmony export (immutable) */ __webpack_exports__["c"] = prettyDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = pluralize;
var urlParser = document.createElement('a');

function domain(url) {
  urlParser.href = url;
  return urlParser.hostname;
}

function count(arr) {
  return arr.length;
}

function prettyDate(date) {
  var a = new Date(date);
  return a.toDateString();
}

function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }

  return time + label + 's';
}

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Dash_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_vue__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_404_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_404_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_Dashboard_vue__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_views_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_views_Dashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_Solicitud_vue__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_views_Solicitud_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_views_Solicitud_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_Individual_vue__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_views_Individual_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_views_Individual_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_Search_vue__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_views_Search_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_views_Search_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_BuyOrders_vue__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_views_BuyOrders_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_views_BuyOrders_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_BillsManagement_vue__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_views_BillsManagement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_views_BillsManagement_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_ChangePsw_vue__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_views_ChangePsw_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_views_ChangePsw_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_views_Comments_vue__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_views_Comments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_views_Comments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_views_SelfData_vue__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_views_SelfData_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_views_SelfData_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_CommentDetail_vue__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_views_CommentDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_views_CommentDetail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_views_AllComments_vue__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_views_AllComments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_views_AllComments_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_views_Reestablecer_vue__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_views_Reestablecer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_views_Reestablecer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_views_PswReestablecida_vue__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_views_PswReestablecida_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_views_PswReestablecida_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_views_InvoiceDetail_vue__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_views_InvoiceDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_views_InvoiceDetail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_views_Reports_vue__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_views_Reports_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_views_Reports_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_views_FinSolicitud_vue__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_views_FinSolicitud_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_views_FinSolicitud_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_views_AllContacts_vue__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_views_AllContacts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_views_AllContacts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_views_AllProviders_vue__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_views_AllProviders_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_views_AllProviders_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_views_Licitaciones_vue__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_views_Licitaciones_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_views_Licitaciones_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_views_Manuals_vue__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_views_Manuals_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_views_Manuals_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_views_ContactDetail_vue__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_views_ContactDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_views_ContactDetail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_views_SubmitDocumentation_vue__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_views_SubmitDocumentation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_views_SubmitDocumentation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_views_AltaDeUsuario_vue__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_views_AltaDeUsuario_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_views_AltaDeUsuario_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_views_ConfirmProvider_vue__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_views_ConfirmProvider_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_views_ConfirmProvider_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_views_CompanyData_vue__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_views_CompanyData_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_views_CompanyData_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_views_NewProviders_vue__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_views_NewProviders_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_views_NewProviders_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_views_ReportTable_vue__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_views_ReportTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_views_ReportTable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_views_ProviderDetail_vue__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_views_ProviderDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_views_ProviderDetail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_views_AltaDeUsuarioPeru_vue__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_views_AltaDeUsuarioPeru_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_views_AltaDeUsuarioPeru_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_views_ConfirmProviderPeru_vue__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_views_ConfirmProviderPeru_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_views_ConfirmProviderPeru_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_views_News_vue__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_views_News_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_views_News_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_views_Prebill_vue__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_views_Prebill_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_views_Prebill_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_views_Bill_vue__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_views_Bill_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_views_Bill_vue__);






































var routes = [{
  path: '/login',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Login_vue___default.a
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dash_vue___default.a,
  children: [{
    path: 'dashboard',
    alias: '',
    component: __WEBPACK_IMPORTED_MODULE_3__components_views_Dashboard_vue___default.a,
    name: 'Dashboard',
    meta: { description: '' }
  }, {
    path: 'solicitud',
    component: __WEBPACK_IMPORTED_MODULE_4__components_views_Solicitud_vue___default.a,
    name: 'Solicitud',
    meta: { description: 'de nuevo usuario del Portal' }
  }, {
    path: 'individual',
    component: __WEBPACK_IMPORTED_MODULE_5__components_views_Individual_vue___default.a,
    name: 'Individual',
    meta: { description: 'Consulta individual de Factura' }
  }, {
    path: 'search',
    component: __WEBPACK_IMPORTED_MODULE_6__components_views_Search_vue___default.a,
    name: 'Búsqueda',
    meta: { description: 'Consulta por filtro' }
  }, {
    path: 'billsManagement',
    component: __WEBPACK_IMPORTED_MODULE_8__components_views_BillsManagement_vue___default.a,
    name: 'Consulta de Facturas, NC, ND',
    meta: {}
  }, {
    path: 'buyOrders',
    component: __WEBPACK_IMPORTED_MODULE_7__components_views_BuyOrders_vue___default.a,
    name: 'OC (Orden de Compra)',
    meta: {}
  }, {
    path: 'toBill',
    component: __WEBPACK_IMPORTED_MODULE_7__components_views_BuyOrders_vue___default.a,
    name: 'Ordenes de Compra',
    meta: {}
  }, {
    path: 'paymentManagement',
    component: __WEBPACK_IMPORTED_MODULE_6__components_views_Search_vue___default.a,
    name: 'Consulta de facturas',
    meta: {}
  }, {
    path: 'prebill',
    component: __WEBPACK_IMPORTED_MODULE_34__components_views_Prebill_vue___default.a,
    name: 'Precarga de facturas',
    meta: {}
  }, {
    path: 'changePsw',
    component: __WEBPACK_IMPORTED_MODULE_9__components_views_ChangePsw_vue___default.a,
    name: 'Cambiar clave',
    meta: { description: 'Cambio de contraseña' }
  }, {
    path: 'selfdata',
    component: __WEBPACK_IMPORTED_MODULE_11__components_views_SelfData_vue___default.a,
    name: 'Mis datos',
    meta: { description: 'Visualice y actualice sus datos' }
  }, {
    path: 'comments',
    component: __WEBPACK_IMPORTED_MODULE_10__components_views_Comments_vue___default.a,
    name: 'Actualizar datos',
    meta: { description: 'Envíe un pedido al administrador' }
  }, {
    path: 'commentDetail',
    component: __WEBPACK_IMPORTED_MODULE_12__components_views_CommentDetail_vue___default.a,
    name: 'Comentario',
    meta: { description: 'Detalles del comentario' }
  }, {
    path: 'allComments',
    component: __WEBPACK_IMPORTED_MODULE_13__components_views_AllComments_vue___default.a,
    name: 'Mensajes'
  }, {
    path: 'reestablecer',
    component: __WEBPACK_IMPORTED_MODULE_14__components_views_Reestablecer_vue___default.a,
    name: 'Reestablecer contraseña',
    meta: { description: '' }
  }, {
    path: 'pswreestablecida',
    component: __WEBPACK_IMPORTED_MODULE_15__components_views_PswReestablecida_vue___default.a,
    name: 'Clave Reestablecida',
    meta: { description: '' }
  }, {
    path: 'invoicedetail',
    component: __WEBPACK_IMPORTED_MODULE_16__components_views_InvoiceDetail_vue___default.a,
    name: 'Ordenes de Compra',
    meta: { description: 'Detalles' }
  }, {
    path: 'reports',
    component: __WEBPACK_IMPORTED_MODULE_17__components_views_Reports_vue___default.a,
    name: 'Reportes',
    meta: { description: '' }
  }, {
    path: 'finSolicitud',
    component: __WEBPACK_IMPORTED_MODULE_18__components_views_FinSolicitud_vue___default.a,
    name: 'FinSolicitud',
    meta: { description: 'Finalizar registro' }
  }, {
    path: 'contacts',
    component: __WEBPACK_IMPORTED_MODULE_19__components_views_AllContacts_vue___default.a,
    name: 'Contactos',
    meta: { description: '' }
  }, {
    path: 'providers',
    component: __WEBPACK_IMPORTED_MODULE_20__components_views_AllProviders_vue___default.a,
    name: 'Proveedores',
    meta: { description: '' }
  }, {
    path: 'compulsas',
    component: __WEBPACK_IMPORTED_MODULE_21__components_views_Licitaciones_vue___default.a,
    name: 'Compulsas',
    meta: { description: '' }
  }, {
    path: 'manuals',
    component: __WEBPACK_IMPORTED_MODULE_22__components_views_Manuals_vue___default.a,
    name: 'Instructivos',
    meta: { description: '' }
  }, {
    path: 'news',
    component: __WEBPACK_IMPORTED_MODULE_33__components_views_News_vue___default.a,
    name: 'Noticias',
    meta: { description: '' }
  }, {
    path: 'submitDocumentation',
    component: __WEBPACK_IMPORTED_MODULE_24__components_views_SubmitDocumentation_vue___default.a,
    name: 'Presentar Documentación',
    meta: { description: '' }
  }, {
    path: 'contactDetail',
    component: __WEBPACK_IMPORTED_MODULE_23__components_views_ContactDetail_vue___default.a,
    name: 'Detalle del Contacto',
    meta: { description: '' }
  }, {
    path: 'userActivationAR',
    component: __WEBPACK_IMPORTED_MODULE_25__components_views_AltaDeUsuario_vue___default.a,
    name: 'Proveedores',
    meta: { description: '' }
  }, {
    path: 'userActivationPE',
    component: __WEBPACK_IMPORTED_MODULE_31__components_views_AltaDeUsuarioPeru_vue___default.a,
    name: 'Proveedores Peru',
    meta: { description: '' }
  }, {
    path: 'newProviders',
    component: __WEBPACK_IMPORTED_MODULE_28__components_views_NewProviders_vue___default.a,
    name: 'Alta de proveedor',
    meta: { description: '' }
  }, {
    path: 'ProvidersTable',
    component: __WEBPACK_IMPORTED_MODULE_29__components_views_ReportTable_vue___default.a,
    name: 'Reporte de proveedores',
    meta: { description: '' }
  }, {
    path: 'providerDetail/:id',
    component: __WEBPACK_IMPORTED_MODULE_30__components_views_ProviderDetail_vue___default.a,
    name: 'Detalles del proveedor',
    meta: { description: '' }
  }, {
    path: 'confirmProvider/:country(AR|PE)/:id',
    component: __WEBPACK_IMPORTED_MODULE_26__components_views_ConfirmProvider_vue___default.a,
    name: 'Confirmar proveedor',
    meta: { description: '' }
  }, {
    path: 'companyData/:id/:step/:country',
    component: __WEBPACK_IMPORTED_MODULE_27__components_views_CompanyData_vue___default.a,
    name: 'Datos de la Compañia',
    meta: { description: '' }
  }, {
    path: 'confirmProviderPeru/:country/:id',
    component: __WEBPACK_IMPORTED_MODULE_32__components_views_ConfirmProviderPeru_vue___default.a,
    name: 'Confirmar proveedor',
    meta: { description: '' }
  }, {
    path: 'bill/:id',
    component: __WEBPACK_IMPORTED_MODULE_35__components_views_Bill_vue___default.a,
    name: '',
    meta: { description: '' }
  }]
}, {
  path: '*',
  component: __WEBPACK_IMPORTED_MODULE_2__components_404_vue___default.a
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(371);







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var getDefaultState = function getDefaultState() {
  return {
    callingAPI: false,
    userReturned: false,
    apiCalls: 0,
    searching: '',
    serverURI: 'http://10.110.1.136:8080',
    user: null,
    token: null,
    ordenesCompra: [],
    otherOperations: [],
    buyOrderDocumentType: [],
    buyOrderDocumentStatus: [],
    frontendModules: [],
    rolesHasModules: [],
    facturas: [],
    messages: [],
    provMessages: [],
    receivedNew: [],
    contacts: [],
    documents: [],
    compulsas: [],
    providers: [],
    countStatus: [],
    companyDataStatus: [],
    services: [],
    countries: [],
    groupCompanies: [],
    news: [],
    provinces: [],
    banks: [],
    bankBranches: [],
    accountTypes: [],
    regimenTypes: [],
    jurisdictions: [],
    retentionRegimes: [],
    retentionRegimesVAT: [],
    retentionRegimesOTROS: [],
    retentionCategories: [],
    companyDataStage: [],
    retentionCategoriesVAT: [],
    retentionCategoriesOTROS: [],
    sussRetentionCategory: [],
    ibRetentionCategory: [],
    allCertification: [],
    invoiceMask: [/[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
    userInfo: {
      messages: [],
      notifications: [],
      tasks: []
    }
  };
};

var state = getDefaultState();

var mutations = {
  TOGGLE_LOADING: function TOGGLE_LOADING(state) {
    state.callingAPI = !state.callingAPI;
  },
  START_LOADING: function START_LOADING(state) {
    state.apiCalls++;
  },
  STOP_LOADING: function STOP_LOADING(state) {
    state.apiCalls--;
  },
  TOGGLE_SEARCHING: function TOGGLE_SEARCHING(state) {
    state.searching = state.searching === '' ? 'loading' : '';
  },
  SET_USER: function SET_USER(state, user) {
    state.user = user;
  },
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_BUYORDERS: function SET_BUYORDERS(state, ordenesCompra) {
    state.ordenesCompra = ordenesCompra;
  },
  SET_OTHEROPERATIONS: function SET_OTHEROPERATIONS(state, otherOperations) {
    state.otherOperations = otherOperations;
  },
  SET_MESSAGES: function SET_MESSAGES(state, messages) {
    state.messages = messages;
  },
  SET_PROVMESSAGES: function SET_PROVMESSAGES(state, provMessages) {
    state.provMessages = provMessages;
  },
  SET_RECEIVEDNEW: function SET_RECEIVEDNEW(state, receivedNew) {
    state.receivedNew = receivedNew;
  },
  SET_STATUS: function SET_STATUS(state, status) {
    state.status = status;
  },
  SET_BUYORDERSTATUS: function SET_BUYORDERSTATUS(state, buyorderstatus) {
    state.buyOrderStatus = buyorderstatus;
  },
  SET_COUNTSTATUS: function SET_COUNTSTATUS(state, countstatus) {
    state.countStatus = countstatus;
  },
  SET_BUYORDERDOCUMENTTYPE: function SET_BUYORDERDOCUMENTTYPE(state, buyOrderDocumentType) {
    state.buyOrderDocumentType = buyOrderDocumentType;
  },
  SET_BUYORDERDOCUMENTTYPECODE: function SET_BUYORDERDOCUMENTTYPECODE(state, buyOrderDocumentTypeCode) {
    state.buyOrderDocumentTypeCode = buyOrderDocumentTypeCode;
  },
  SET_BUYORDERDOCUMENTSTATUS: function SET_BUYORDERDOCUMENTSTATUS(state, buyOrderDocumentStatus) {
    state.buyOrderDocumentStatus = buyOrderDocumentStatus;
  },
  SET_CONTACTS: function SET_CONTACTS(state, contacts) {
    state.contacts = contacts;
  },
  CONCAT_PROVIDERS: function CONCAT_PROVIDERS(state, providers) {
    state.providers = state.providers.concat(providers);
  },
  SET_PROVIDERS: function SET_PROVIDERS(state, providers) {
    state.providers = providers;
  },
  SET_DOCUMENTS: function SET_DOCUMENTS(state, documents) {
    state.documents = documents;
  },
  SET_COMPULSAS: function SET_COMPULSAS(state, compulsas) {
    state.compulsas = compulsas;
  },
  SET_FRONTENDMODULES: function SET_FRONTENDMODULES(state, frontendModules) {
    state.frontendModules = frontendModules;
  },
  SET_ROLESHASMODULES: function SET_ROLESHASMODULES(state, rolesHasModules) {
    state.rolesHasModules = rolesHasModules;
  },
  SET_COMPANYDATASTATUS: function SET_COMPANYDATASTATUS(state, companyDataStatus) {
    state.companyDataStatus = companyDataStatus;
  },
  RESET_STATE: function RESET_STATE(state) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state, getDefaultState());
  },
  SET_COMPANYDATASTAGE: function SET_COMPANYDATASTAGE(state, companyDataStage) {
    state.companyDataStage = companyDataStage;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: state,
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
  mutations: mutations
}));

/***/ }),
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(538)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(646),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var OC_LIBERADA_SAP = '1';
var OC_DISPONIBLE_PROVEEDOR = '2';
var OC_A_FACTURAR = '3';
var OC_NO_DISPONIBLE_PROVEEDOR = '7';
var OC_FACTURADA = '9';

/* harmony default export */ __webpack_exports__["a"] = ({
  OC_LIBERADA_SAP: OC_LIBERADA_SAP,
  OC_DISPONIBLE_PROVEEDOR: OC_DISPONIBLE_PROVEEDOR,
  OC_A_FACTURAR: OC_A_FACTURAR,
  OC_NO_DISPONIBLE_PROVEEDOR: OC_NO_DISPONIBLE_PROVEEDOR,
  OC_FACTURADA: OC_FACTURADA
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate_dist_locale_es__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate_dist_locale_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vee_validate_dist_locale_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vee_validate__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__routes__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_resource__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_session__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__filters__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_App_vue__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_App_vue__);

















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('count', __WEBPACK_IMPORTED_MODULE_10__filters__["a" /* count */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('domain', __WEBPACK_IMPORTED_MODULE_10__filters__["b" /* domain */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('prettyDate', __WEBPACK_IMPORTED_MODULE_10__filters__["c" /* prettyDate */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('pluralize', __WEBPACK_IMPORTED_MODULE_10__filters__["d" /* pluralize */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_session___default.a);

var config = {
  aria: true,
  classNames: {},
  classes: false,
  delay: 0,
  errorBagName: 'errores',
  events: 'input|blur',
  fieldsBagName: 'campos',
  inject: true,
  locale: 'es'
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vee_validate__["a" /* default */], config);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('ValidationProvider', __WEBPACK_IMPORTED_MODULE_4_vee_validate__["b" /* ValidationProvider */]);
__WEBPACK_IMPORTED_MODULE_4_vee_validate__["c" /* Validator */].localize('es', __WEBPACK_IMPORTED_MODULE_3_vee_validate_dist_locale_es___default.a);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_6__routes__["a" /* default */],
  mode: 'history',
  linkExactActiveClass: 'active',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  }
});

router.beforeEach(function (to, from, next) {
  var urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('e') && window.location.pathname === '/' && to.path === '/') {
    next({
      path: '/pswreestablecida',
      query: { email: urlParams.get('e') }
    });
  }
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  }) && (!router.app.$store.state.token || router.app.$store.state.token === 'null')) {
    window.console.log('Not authenticated');
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */], router);

if (window.localStorage) {
  var localUserString = window.localStorage.getItem('user') || 'null';
  var localUser = JSON.parse(localUserString);

  if (localUser && __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state.user !== localUser) {
    __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit('SET_USER', localUser);
    __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit('SET_TOKEN', window.localStorage.getItem('token'));
  }
}

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  http: {
    emulateJSON: true,
    emulateHTTP: true
  },
  el: '#root',
  router: router,
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_11__components_App_vue___default.a);
  }
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        width: { type: String, default: '238px' },
        readonly: { type: Boolean, default: false },
        value: { type: String, default: '' },
        format: { type: String, default: 'YYYY-MM-DD' }
    },
    data: function data() {
        return {
            show: false,
            days: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
            months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            date: [],
            now: new Date()
        };
    },

    watch: {
        now: function now() {
            this.update();
        },
        show: function show() {
            this.update();
        }
    },
    methods: {
        close: function close() {
            this.show = false;
        },
        update: function update() {
            var arr = [];
            var time = new Date(this.now);
            time.setMonth(time.getMonth(), 1);
            var curFirstDay = time.getDay();
            curFirstDay === 0 && (curFirstDay = 7);
            time.setDate(0);
            var lastDayCount = time.getDate();
            for (var i = curFirstDay; i > 0; i--) {
                arr.push({
                    text: lastDayCount - i + 1,
                    time: new Date(time.getFullYear(), time.getMonth(), lastDayCount - i + 1),
                    status: 'date-pass'
                });
            }

            time.setMonth(time.getMonth() + 2, 0);
            var curDayCount = time.getDate();
            time.setDate(1);
            var value = this.value || this.stringify(new Date());
            for (var _i = 0; _i < curDayCount; _i++) {
                var tmpTime = new Date(time.getFullYear(), time.getMonth(), _i + 1);
                var status = '';
                this.stringify(tmpTime) === value && (status = 'date-active');
                arr.push({
                    text: _i + 1,
                    time: tmpTime,
                    status: status
                });
            }

            var j = 1;
            while (arr.length < 42) {
                arr.push({
                    text: j,
                    time: new Date(time.getFullYear(), time.getMonth() + 1, j),
                    status: 'date-future'
                });
                j++;
            }
            this.date = arr;
        },
        yearClick: function yearClick(flag) {
            this.now.setFullYear(this.now.getFullYear() + flag);
            this.now = new Date(this.now);
        },
        monthClick: function monthClick(flag) {
            this.now.setMonth(this.now.getMonth() + flag);
            this.now = new Date(this.now);
        },
        pickDate: function pickDate(index) {
            this.show = false;
            this.now = new Date(this.date[index].time);
            this.value = this.stringify();
        },
        parse: function parse(str) {
            var time = new Date(str);
            return isNaN(time.getTime()) ? null : time;
        },
        stringify: function stringify() {
            var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.now;
            var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.format;

            var year = time.getFullYear();
            var month = time.getMonth() + 1;
            var date = time.getDate();
            var monthName = this.months[time.getMonth()];

            var map = {
                YYYY: year,
                MMM: monthName,
                MM: ('0' + month).slice(-2),
                M: month,
                DD: ('0' + date).slice(-2),
                D: date
            };
            return format.replace(/Y+|M+|D+/g, function (str) {
                return map[str];
            });
        },
        leave: function leave(e) {
            if (!this.$el.contains(e.target)) {
                this.close();
            }
        }
    },
    ready: function ready() {
        this.now = this.parse(this.value) || new Date();
        document.addEventListener('click', this.leave, false);
    },
    beforeDestroy: function beforeDestroy() {
        document.removeEventListener('click', this.leave, false);
    }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotFound'
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  data: function data() {
    return {
      section: 'Head'
    };
  },

  methods: {
    logout: function logout() {
      this.$store.commit('SET_USER', null);
      this.$store.commit('SET_TOKEN', null);

      if (window.localStorage) {
        window.localStorage.setItem('user', null);
        window.localStorage.setItem('token', null);
      }
      this.$session.destroy();
      this.$router.push('/login');
    }
  }
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hideseek__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hideseek___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_hideseek__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dash',
  components: {
    Sidebar: __WEBPACK_IMPORTED_MODULE_5__Sidebar___default.a
  },
  data: function data() {
    return {
      entorno: '',
      year: new Date().getFullYear(),

      classes: {
        fixed_layout: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].fixedLayout,
        hide_logo: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* default */].hideLogoOnMobile
      },
      error: '',
      enviados: [],
      recibidos: [],
      recibidosNew: [],
      invoices: [],
      modalUnauthorized: false,
      timmerMessage: null
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])(['userInfo', 'user']), {
    receivedNew: function receivedNew() {
      if (this.$store.state.messages.length > 0) {
        return this.$store.state.provMessages.filter(function (el) {
          return el.messages !== undefined && el.messages.find(function (msg) {
            return msg.status === '0' && msg.idReceptor === '0';
          });
        });
      } else {
        return [];
      }
    },
    providerNewMessages: function providerNewMessages() {
      var _this = this;

      if (this.$store.state.messages.length > 0) {
        return this.$store.state.messages.filter(function (el) {
          return el.idReceptor === _this.idUser && el.status === '0';
        });
      } else {
        return [];
      }
    },
    newPayments: function newPayments() {
      return this.$store.state.ordenesCompra.filter(function (el) {
        return el.view === '0' && el.statusId === '6';
      });
    },
    newContacts: function newContacts() {
      if (this.$store.state.contacts.length > 0) {
        return this.$store.state.contacts.filter(function (el) {
          return el.idProviderStatus === '1';
        });
      } else {
        return [];
      }
    },
    newCompulsas: function newCompulsas() {
      if (this.$store.state.compulsas.length > 0 && this.user.isProvider) {
        return this.$store.state.compulsas.filter(function (el) {
          return el.visto === '0';
        });
      }
      return [];
    },
    idUser: function idUser() {
      if (this.user) {
        return this.user.idUser;
      }
      return false;
    },
    fullscreenLoading: function fullscreenLoading() {
      return this.$store.state.apiCalls > 0;
    }
  }),
  methods: {
    getEntorno: function getEntorno() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('get', 'api/findConfiguration/ENTORNO').then(function (response) {
        _this2.entorno = response.data['value'];
      }).catch(function (error) {
        console.log(error);
      });
    },
    getFrontendModulesAndRolesHasModules: function getFrontendModulesAndRolesHasModules() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/frontendModules').then(function (response) {
        _this3.$store.commit('SET_FRONTENDMODULES', response.data);
      });
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/rolesHasModules').then(function (response) {
        _this3.$store.commit('SET_ROLESHASMODULES', response.data);
      });
    },
    postLogout: function postLogout() {
      var data = {
        userId: this.user.idUser,
        companyId: this.user.idCompany
      };
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('POST', 'api/logout', { data: data }).then(function (response) {
        if (response.status === 200) {
          console.log('Succesfull Logout');
          return;
        } else {
          console.log('Failed to Logout user');
        }
      }).catch(function (error) {
        console.error(error);
      });
    },
    logoutFromError: function logoutFromError() {
      var _this4 = this;

      if (this.modalUnauthorized) {
        return;
      }
      this.modalUnauthorized = true;
      this.$alert('Se venció la sesión, por favor vuelva a iniciar sesión', 'Advertencia', {
        confirmButtonText: 'OK',
        type: 'warning',
        lockScroll: false,
        closable: false
      }).then(function () {
        if (_this4.$store.state.user) {
          _this4.postLogout();
          _this4.logoutMethods();
        }
      }).catch(function () {
        if (_this4.$store.state.user) {
          _this4.logoutMethods();
        }
      });
    },
    logout: function logout() {
      var _this5 = this;

      this.$confirm('¿Realmente desea cerrar sesión?', 'Advertencia', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        lockScroll: false
      }).then(function () {
        _this5.postLogout();
        _this5.logoutMethods();
      }).catch(function () {});
    },
    logoutMethods: function logoutMethods() {
      localStorage.removeItem('user');
      this.$store.commit('SET_USER', '');
      this.$store.commit('SET_TOKEN', '');
      this.$store.commit('SET_MESSAGES', '');
      this.$store.commit('RESET_STATE');
      window.localStorage.removeItem('token');
      this.$router.push('/login');
    },
    changeloading: function changeloading() {
      this.$store.commit('TOGGLE_SEARCHING');
    },
    getCompanyStage: function getCompanyStage() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/companyStage').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this6.$store.commit('SET_COMPANYDATASTAGE', data);
        }
      }).catch(function (error) {
        _this6.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getBuyOrders: function getBuyOrders() {
      var _this7 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var newInvoicesLenght = _this7.newInvoices.length;
        var newPaymentLenght = _this7.newPayments.length;
        var idUser = _this7.idUser;


        _this7.$store.commit('START_LOADING');

        __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/getBuyOrder/' + idUser).then(function (response) {
          var data = response.data;

          if (data.error) {
            return;
          }

          if (data) {
            _this7.$store.commit('SET_BUYORDERS', data.filter(function (el) {
              return el.nic !== null;
            }));
            _this7.$store.commit('SET_OTHEROPERATIONS', data.filter(function (el) {
              return el.nic === null;
            }));

            if (newInvoicesLenght < _this7.newInvoices.length && !_this7.user.isProvider) {
              if (_this7.newInvoices.length > 1) {
                _this7.notify('Ha recibido ' + _this7.newInvoices.length + ' nuevos documentos para verificar');
              } else {
                _this7.notify('Ha recibido un nuevo documento');
              }
            }
            if (newPaymentLenght < _this7.newPayments.length && _this7.user.isProvider) {
              if (_this7.newPayments.length > 1) {
                _this7.notify('Ha recibido ' + _this7.newPayments.length + ' nuevas ordenes de pagos');
              } else {
                _this7.notify('Ha recibido ' + _this7.newPayments.length + ' nueva orden de pago');
              }
            }
            _this7.$store.commit('STOP_LOADING');
            resolve(data);
          }
        }).catch(function (error) {
          _this7.$store.commit('TOGGLE_LOADING');
          console.log(error);
          _this7.$store.commit('STOP_LOADING');
          reject(error);
        });
      });
    },
    getBuyOrderStatus: function getBuyOrderStatus() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/buyOrderStatus?idUser=' + this.idUser).then(function (response) {
        var data = response.data;

        if (data.error) {
          return;
        }

        if (data) {
          _this8.$store.commit('SET_BUYORDERSTATUS', data);
        }
      }).catch(function (error) {
        _this8.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getCompanyDataStatus: function getCompanyDataStatus() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/companyDataStatus').then(function (response) {
        var data = response.data;

        if (data.error) {
          return;
        }

        if (data) {
          _this9.$store.commit('SET_COMPANYDATASTATUS', data);
        }
      }).catch(function (error) {
        _this9.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getBuyOrderDocumentStatus: function getBuyOrderDocumentStatus() {
      var _this10 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/buyOrderDocumentStatus').then(function (response) {
        var data = response.data;

        if (data.error) {
          return;
        }

        if (data) {
          data.forEach(function (stat) {
            stat.description = _this10.user.isProvider ? stat.descriptionProvider : stat.descriptionBackend;
          });
          _this10.$store.commit('SET_BUYORDERDOCUMENTSTATUS', data);
        }
      }).catch(function (error) {
        _this10.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getAllBuyOrderStatus: function getAllBuyOrderStatus() {
      var _this11 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/buyOrderStatus').then(function (response) {
        var data = response.data;

        if (data.error) {
          return;
        }

        if (data) {
          _this11.$store.state.countStatus = data;
          _this11.$store.commit('SET_BUYORDERSTATUS', data);
        }
      }).catch(function (error) {
        _this11.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getContacts: function getContacts() {
      var _this12 = this;

      this.$store.commit('START_LOADING');
      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/provider').then(function (response) {
        var newContactsLength = _this12.newContacts.length;
        var data = response.data;

        if (data.error) {
          return;
        }
        if (data) {
          _this12.$store.commit('SET_CONTACTS', data);
          if (newContactsLength < _this12.newContacts.length && !_this12.user.isProvider) {}
        }
        _this12.$store.commit('STOP_LOADING');
      }).catch(function (error) {
        _this12.$store.commit('TOGGLE_LOADING');
        _this12.$store.commit('STOP_LOADING');
        console.log(error);
      });
    },
    getBuyOrderDocumentType: function getBuyOrderDocumentType() {
      var _this13 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/buyOrderDocumentType').then(function (response) {
        var data = response.data;

        if (data.error) {
          return;
        }
        if (data) {
          _this13.$store.commit('SET_BUYORDERDOCUMENTTYPE', data);
        }
      }).catch(function (error) {
        _this13.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getLicitaciones: function getLicitaciones() {
      var _this14 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var compulsasLenght = _this14.newCompulsas.length;
        _this14.$store.commit('START_LOADING');
        __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/getLicitaciones?id=' + _this14.user.idUser).then(function (response) {
          var data = response.data;

          if (data.error) {
            return;
          }
          if (data) {
            _this14.$store.commit('SET_COMPULSAS', data);
            if (compulsasLenght < _this14.newCompulsas.length) {
              if (_this14.newCompulsas.length > 1) {
                _this14.notify('Has sido invitado a ' + _this14.newCompulsas.length + ' compulsas');
              } else {
                _this14.notify('Has sido invitado a ' + _this14.newCompulsas.length + ' compulsa');
              }
            }
            _this14.$store.commit('STOP_LOADING');
            resolve(data);
          }
        }).catch(function (error) {
          _this14.$store.commit('TOGGLE_LOADING');
          console.log(error);
          _this14.$store.commit('STOP_LOADING');
          reject(error);
        });
      });
    },
    notify: function notify(notificationMessage) {
      this.$notify({
        title: '',
        type: 'warning',
        message: notificationMessage,
        duration: 20000,
        showClose: true,
        offset: 50
      });
    },
    checkComments: function checkComments() {
      var currentPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      var _this15 = this;

      var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
      var searchQuery = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

        if (!_this15.$store.state.user) {
          return;
        }

        if (_this15.idUser) {
          __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/getMessages/messages/' + _this15.idUser + '?pageSize=' + pageSize + '&currentPage=' + currentPage + '&searchQuery=' + searchQuery).then(function (response) {
            var data = response.data;

            if (data.error) {
              return;
            }

            if (data.messages) {
              _this15.$store.commit('SET_MESSAGES', data.messages);
            }
            if (data.provMessages) {
              _this15.$store.commit('SET_PROVMESSAGES', data.provMessages);
              if (_this15.recievedNew !== undefined) {}
            }

            resolve();
          }).catch(function (error) {
            _this15.$store.commit('TOGGLE_LOADING');
            console.log(error);

            reject(error);
          });
        }
      });
    },
    getCountries: function getCountries() {
      var _this16 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/country').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this16.$store.state.countries = data;
        }
      }).catch(function (error) {
        _this16.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getGroupCompanies: function getGroupCompanies() {
      var _this17 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/groupCompanies').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this17.$store.state.groupCompanies = data;
        }
      }).catch(function (error) {
        _this17.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getNews: function getNews() {
      var _this18 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/news').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this18.$store.state.news = data;
        }
      }).catch(function (error) {
        _this18.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getProvinces: function getProvinces() {
      var _this19 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/province').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this19.$store.state.provinces = data;
        }
      }).catch(function (error) {
        _this19.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getServices: function getServices() {
      var _this20 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/rubros').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this20.$store.state.services = data;
        }
      }).catch(function (error) {
        _this20.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getRetentionCategories: function getRetentionCategories() {
      var _this21 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/categoryRetain').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this21.$store.state.retentionCategories = data;
        }
      }).catch(function (error) {
        _this21.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getRetentionCategoriesVAT: function getRetentionCategoriesVAT() {
      var _this22 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/categoryRetainVAT').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this22.$store.state.retentionCategoriesVAT = data;
        }
      }).catch(function (error) {
        _this22.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getRetentionCategoriesOTROS: function getRetentionCategoriesOTROS() {
      var _this23 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/categoryRetainOTROS').then(function (response) {
        var data = response.data.filter(function (category) {
          return category.codCountry === 'AR';
        });
        if (data.error) {
          return;
        }
        if (data) {
          _this23.$store.state.retentionCategoriesOTROS = data;
        }
      }).catch(function (error) {
        _this23.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getSussRetentionCategories: function getSussRetentionCategories() {
      var _this24 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/sussCategoryRetain').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this24.$store.state.sussRetentionCategory = data;
        }
      }).catch(function (error) {
        _this24.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getIbRetentionCategories: function getIbRetentionCategories() {
      var _this25 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/ibCategoryRetain').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this25.$store.state.ibRetentionCategory = data;
        }
      }).catch(function (error) {
        _this25.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getRegimenTypes: function getRegimenTypes() {
      var _this26 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/agreementRegimeType').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this26.$store.state.regimenTypes = data;
        }
      }).catch(function (error) {
        _this26.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getRetentionRegimes: function getRetentionRegimes() {
      var _this27 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/retentionRegime').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this27.$store.state.retentionRegimes = data;
        }
      }).catch(function (error) {
        _this27.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getRetentionRegimesVAT: function getRetentionRegimesVAT() {
      var _this28 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/retentionRegimeVAT').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this28.$store.state.retentionRegimesVAT = data;
        }
      }).catch(function (error) {
        _this28.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getRetentionRegimesOTROS: function getRetentionRegimesOTROS() {
      var _this29 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/retentionRegimeOTROS').then(function (response) {
        var data = response.data.filter(function (regime) {
          return regime.codCountry === 'AR';
        });
        if (data.error) {
          return;
        }
        if (data) {
          _this29.$store.state.retentionRegimesOTROS = data;
        }
      }).catch(function (error) {
        _this29.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getJurisdictions: function getJurisdictions() {
      var _this30 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/jurisdictions').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this30.$store.state.jurisdictions = data;
        }
      }).catch(function (error) {
        _this30.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getBanks: function getBanks() {
      var _this31 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/bank').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this31.$store.state.banks = data.filter(function (bank) {
            return bank.codCountry === 'AR';
          });
        }
      }).catch(function (error) {
        _this31.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getBankBranchs: function getBankBranchs() {
      var _this32 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/bankBranch').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this32.$store.state.bankBranches = data;
        }
      }).catch(function (error) {
        _this32.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getBankAccountTypes: function getBankAccountTypes() {
      var _this33 = this;

      __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/generic/bankAccountType').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this33.$store.state.accountTypes = data.filter(function (bankAccountType) {
            return bankAccountType.codCountry === 'AR';
          });
        }
      }).catch(function (error) {
        _this33.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getInformation: function getInformation() {
      this.getEntorno();
      if (this.$store.state.user) {
        this.getFrontendModulesAndRolesHasModules();

        this.checkComments();
        this.getBuyOrderStatus();
        this.getAllBuyOrderStatus();
        this.getCompanyDataStatus();
        this.getContacts();

        this.getLicitaciones();
        this.getBuyOrderDocumentType();
        this.getBuyOrderDocumentStatus();
        this.getCompanyStage();
      }
      this.getCountries();
      this.getGroupCompanies();
      this.getNews();
      this.getProvinces();
      this.getServices();
      this.getRetentionCategories();
      this.getRetentionCategoriesVAT();
      this.getRetentionCategoriesOTROS();
      this.getSussRetentionCategories();
      this.getIbRetentionCategories();
      this.getRegimenTypes();
      this.getRetentionRegimes();
      this.getRetentionRegimesVAT();
      this.getRetentionRegimesOTROS();
      this.getJurisdictions();
      this.getBanks();
      this.getBankBranchs();
      this.getBankAccountTypes();
    },
    refreshToken: function refreshToken() {
      var token = window.localStorage.getItem('token');
      if (token) {
        __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].request('GET', 'api/refreshToken').then(function (response) {
          if (response.data.token) {
            window.localStorage.setItem('token', response.data.token);
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    }
  },
  mounted: function mounted() {
    var _this34 = this;

    if (this.idUser) {
      this.modalUnauthorized = false;
      var UNAUTHORIZED = 401;
      __WEBPACK_IMPORTED_MODULE_8_axios___default.a.interceptors.response.use(function (response) {
        return response;
      }, function (error) {
        var status = error.response ? error.response.status : null;
        if (_this34.idUser && status === UNAUTHORIZED) {
          _this34.logoutFromError();
        }
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
      });
      this.getInformation();

      this.checkComments();
      setInterval(function () {
        return _this34.getInformation();
      }, 1000 * 60 * 15);
    } else {
      this.getInformation();
    }
  },
  beforeMount: function beforeMount() {
    var _this35 = this;

    var UNAUTHORIZED = 401;
    __WEBPACK_IMPORTED_MODULE_8_axios___default.a.interceptors.response.use(function (response) {
      return response;
    }, function (error) {
      var _JSON$stringify = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error),
          status = _JSON$stringify.status;

      if (_this35.idUser && status === UNAUTHORIZED) {
        _this35.logoutFromError();
      }
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
    });
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timmerMessage);
  }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  data: function data(router) {
    return {
      section: 'Login',
      loading: '',
      loadingGif: false,
      username: '',
      password: '',
      response: '',
      paramError: null,
      paramErrorProv: null,
      configuration: '',
      flags: false,
      entorno: '',
      availableCountries: []
    };
  },
  mounted: function mounted() {
    window.localStorage.removeItem('token');
  },

  methods: {
    getEticalCode: function getEticalCode() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('get', 'api/findConfiguration/CODETI').then(function (response) {
        _this.configuration = response.data['value'];
      }).catch(function (error) {
        console.log(error);
      });
    },
    getEntorno: function getEntorno() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('get', 'api/findConfiguration/ENTORNO').then(function (response) {
        _this2.entorno = response.data['value'];
      }).catch(function (error) {
        console.log(error);
      });
    },
    checkCreds: function checkCreds() {
      var _this3 = this;

      this.loadingGif = true;
      var username = this.username;
      var password = this.password;

      window.localStorage.removeItem('token');

      this.toggleLoading();
      this.resetResponse();
      this.$store.commit('TOGGLE_LOADING');

      var that = this;
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('POST', 'api/login', { username: username, password: password }, false).then(function (response) {
        _this3.loadingGif = false;
        _this3.toggleLoading();

        var data = response.data;

        if (data.error) {
          var errorName = data.error;
          console.log(errorName);
          if (errorName) {
            if (errorName === 'Usuario bloqueado') {
              that.$confirm('El usuario se encuentra bloqueado ¿Desea reestablecer su contraseña?', 'Atención', {
                confirmButtonText: 'Enviar',
                cancelButtonText: 'Cancelar',
                type: 'warning'
              }).then(function () {
                that.$router.push('/reestablecer').then(function (response) {});
              }).catch(function (error) {
                console.log(error);
              });
            } else {
              that.response = errorName === 'InvalidCredentialsError' ? 'Usuario o clave incorrectos. Intente nuevamente.' : errorName;
            }
          } else {
            that.response = data.error;
          }

          return;
        }

        if (data.user) {
          _this3.$store.commit('SET_USER', data.user);
          _this3.$store.commit('SET_TOKEN', data.token);

          if (window.localStorage) {
            _this3.$session.start();
            _this3.$session.set('jwt', data.token);

            window.localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.user));
            window.localStorage.setItem('token', data.token);
          }
          if (data.reqPsw === '2') {
            _this3.$router.push(data.redirect ? data.redirect : '/');
          } else {
            _this3.$router.push(data.redirect ? data.redirect : '/');
          }
        }
      }).catch(function (error) {
        _this3.$store.commit('TOGGLE_LOADING');
        console.log(error);

        _this3.response = 'Error al conectarse con el servidor, contacte al administrador.';
        _this3.toggleLoading();
        _this3.loadingGif = false;
      });
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'cargando' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
    }
  },
  beforeMount: function beforeMount() {
    var _this4 = this;

    this.getEticalCode();
    this.getEntorno();
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('get', 'api/checkParam?id=AP-001').then(function (response) {
      var data = response.data;
      console.log(data.error);
      if (data.error) {
        _this4.paramErrorProv = data.error;
      }
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('get', 'api/checkParam?id=SUN-001').then(function (response) {
      var data = response.data;
      console.log('SUN-001', data);
      _this4.availableCountries = data;
    }).catch(function (error) {
      console.log(error);
    });
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(25);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      serverURI: __WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].serverURI,
      pFilePath: '',
      pFileName: '',
      pTargetDir: '',
      finalFilePath: '',
      partialPath: '',
      urlUpl: ''
    };
  },

  name: 'PdfFile',
  props: {
    titulo: String,
    id: String,
    prop: String,
    pdfFilePath: String,
    pdfFileName: String,
    habModificaPdf: Boolean,
    country: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    this.getUploadPath();
  },

  methods: {
    persisteNewProvider: function persisteNewProvider(inputValue, inputName) {
      var country = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ARG';

      if (country === 'ARG') {
        var newProvider = JSON.parse(localStorage.getItem('newProvider'));
        if (!newProvider) {
          newProvider = {};
        }
        newProvider[inputName] = inputValue;
        localStorage.setItem('newProvider', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newProvider));
      }
      if (country === 'PER') {
        var _newProvider = JSON.parse(localStorage.getItem('newProviderPeru'));
        if (!_newProvider) {
          _newProvider = {};
        }
        _newProvider[inputName] = inputValue;
        localStorage.setItem('newProviderPeru', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_newProvider));
      }
    },
    getUploadPath: function getUploadPath() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('get', 'api/findConfiguration?attribute=URL-UPL').then(function (response) {
        _this.urlUpl = _this.validateParams(response.data['value']);
      }).catch(function (error) {
        console.log(error);
      });
    },
    getDataFromLocalStorage: function getDataFromLocalStorage(inputType, inputId) {
      console.log(inputType);

      var newProvider = JSON.parse(localStorage.getItem('newProvider'));
      if (newProvider) {
        var data = newProvider[inputId];
        if (data) {
          inputType[inputId] = data;
        }
      }
    },
    handlePdf: function handlePdf(response, file, fileList) {
      var param = response;
      this.pFilePath = this.validateParams(param.ruta);
      this.pFileName = param.original_file_name;
      this.finalFilePath = this.pFilePath + this.pFileName;
      this.$emit('update:pdfFilePath', this.pFileName);
      this.persisteNewProvider(this.pFileName, this.prop);
    },
    validateParams: function validateParams(param) {
      if (!param.endsWith('/')) {
        return param + '/';
      }
      return param;
    },
    handleRemove: function handleRemove(response, file, fileList) {
      var _this2 = this;

      var data = new FormData();
      data.append('folder', 'altaProveedor');
      data.append('file', '');
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('POST', 'api/uploadPdfFile', data).then(function (response) {
        _this2.pFilePath = '';
      });
      this.pFilePath = '';
    },
    removePdf: function removePdf(response, file, fileList) {
      this.persisteNewProvider('', this.prop, this.country);
      this.$refs.refFile.clearFiles();
      this.pFilePath = '';
      this.pFileName = '';
      this.$emit('update:pdfFilePath', '');
    },
    handleExceed: function handleExceed(response, file, fileList) {
      this.$message.warning('Para cargar el archivo debe borrar el anterior');
    }
  },
  watch: {
    handle: function handle(val) {
      this.$emit('update:pdfFilePath', val);
    }
  },
  computed: {
    filePath: function filePath() {
      this.pFilePath = this.pdfFilePath;
      if (this.pFilePath !== '') {
        return this.urlUpl + this.pFilePath;
      }
      return '';
    },
    fileName: function fileName() {
      this.pFileName = this.pdfFileName;
      return this.pFileName;
    }
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SidebarMenu__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Sidebar',
  props: ['displayName', 'pictureUrl'],
  components: { SidebarMenu: __WEBPACK_IMPORTED_MODULE_0__SidebarMenu___default.a },
  mounted: function mounted() {
    window.jQuery('[data-toggle="hideseek"]').off().hideseek();
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SidebarName',
  data: function data() {
    return {
      menu: ''
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['userInfo', 'user'])),
  methods: {
    logout: function logout() {
      var _this = this;

      this.$confirm('¿Realmente desea cerrar sesión?', 'Advertencia', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        lockScroll: false
      }).then(function () {
        localStorage.removeItem('user');
        _this.$store.commit('SET_USER', '');
        _this.$store.commit('SET_TOKEN', '');
        _this.$store.commit('SET_MESSAGES', '');
        _this.$store.commit('SET_PROVMESSAGES', '');
        window.localStorage.removeItem('token');
        _this.$router.push('/login');
      }).catch(function () {});
    },
    reload: function reload() {
      location.replace('./');
    }
  }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date_picker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);





__webpack_require__(0);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Settings',
  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_3_vue_date_picker___default.a
  },
  data: function data(router) {
    var _this = this;

    return {
      section: 'AllComments',
      loading: '',
      rubros: [],
      showModalMessage: false,
      showModalMassiveMessage: false,
      providersParaCompulsa: [],
      showModalMassiveMessageRecipients: false,
      message: '',
      searchQuery: '',
      loadMessagesFlag: false,
      currentPage: 1,
      pageSize: 20,
      timmerMessage: 0,
      conversation: null,
      loadingMsg: false,
      providersSelected: [],
      providersMessages: [],
      idProvider: null,
      newMessage: '',
      messageLength: 0,
      oldMessageLength: 0,
      idUser: this.$store.state.user.idUser,
      titles: [{
        prop: '',
        label: 'Compañía',
        align: 'center'
      }, {
        prop: 'cuit',
        label: 'CUIT',
        align: 'center'
      }],
      filtersRubro: [{
        prop: ['idRubro'],
        value: '',
        filterFn: function filterFn(row, filterItem) {
          return row.rubros.some(function (el) {
            return filterItem.value.includes(el.idRubro);
          });
        }
      }, {
        prop: ['cuit', 'company'],
        value: ''
      }],
      filters: [{
        prop: ['email'],
        value: ''
      }, {
        prop: ['userStatus'],
        value: '2'
      }],
      actionCol: {
        label: 'Acciones',
        props: {
          align: 'center'
        },
        buttons: [{
          props: {
            type: 'primary',
            icon: 'el-icon-view',
            circle: true
          },
          handler: function handler(row) {
            _this.verMensaje(row);
          }
        }]
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])(['user']), {
    datetime: function datetime() {
      return new Date();
    },
    providers: function providers() {
      return this.$store.state.providers;
    },
    contacts: function contacts() {
      return this.$store.state.contacts.slice().sort(function (a, b) {
        return a.status - b.status;
      });
    },
    provMessages: function provMessages() {
      var _this2 = this;

      if (this.conversation !== null && this.loadMessagesFlag) {
        setTimeout(function () {
          _this2.conversation = _this2.$store.state.provMessages.find(function (el) {
            return el.idUser === _this2.message.idUser;
          }).messages.sort(_this2.orderByDate);
        }, 1);
      }
      this.providersMessages = this.$store.state.provMessages;
      return this.$store.state.provMessages;
    },
    myMessages: function myMessages() {
      var _this3 = this;

      if (this.$store.state.messages.length > 0) {
        setTimeout(function () {
          return _this3.updateScroll('messages-container');
        }, 1);
      }
      return this.$store.state.messages;
    }
  }),
  methods: {
    sendFilterResponse: function sendFilterResponse() {
      this.$parent.checkComments(1, 20, this.searchQuery);
    },
    loadData: function loadData(queryInfo) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this4.loading = true;
                _this4.pageSize = queryInfo.pageSize;
                _this4.currentPage = queryInfo.page;
                _this4.conversation = null;
                _this4.$parent.checkComments(_this4.currentPage, _this4.pageSize);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    updateChat: function updateChat(id) {
      var _this5 = this;

      var messageLengthValue = this.conversation.length;
      if (this.conversation.length > 0) {
        if (this.conversation[0].idEmisor !== this.idUser) {
          this.idProvider = this.conversation[0].idEmisor;
        }
        if (this.conversation[0].idReceptor !== this.idUser) {
          this.idProvider = this.conversation[0].idReceptor;
        }
        this.timmerMessage = setInterval(function () {
          _this5.getProviderMessages(_this5.idProvider);
          if (messageLengthValue !== _this5.messageLength) {
            _this5.$parent.checkComments();
            messageLengthValue = _this5.messageLength;
          }
        }, 1000 * 3);
        this.updateScroll(id);
      }
    },
    getRubros: function getRubros() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('GET', 'api/generic/rubros').then(function (response) {
        var data = response.data;

        if (data.error) {
          return;
        }
        if (data) {
          _this6.rubros = data;
        }
      }).catch(function (error) {
        _this6.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getProviderMessages: function getProviderMessages(idProvider) {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('GET', 'api/getProviderMessages' + '?idProvider=' + idProvider).then(function (response) {
        var data = response.data;
        _this7.messageLength = response.data;

        if (data.error) {
          return;
        }
        if (data) {
          _this7.rubros = data;
        }
      }).catch(function (error) {
        _this7.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    compareStatusMessages: function compareStatusMessages(a, b) {
      if (a.messages.length === 0) {
        return 1;
      }
      if (b.messages.length === 0) {
        return -1;
      }
      if (a.messages[a.messages.length - 1].status < b.messages[b.messages.length - 1].status) {
        return -1;
      } else if (a.messages[a.messages.length - 1].status > b.messages[b.messages.length - 1].status) {
        return 1;
      }
      return 0;
    },
    sortMessagesPerDate: function sortMessagesPerDate(messages) {
      var _this8 = this;

      return messages.sort(function (a, b) {
        var lastMessageA = a.messages && a.messages.length > 0 ? new Date(_this8.getMostRecentMessage(a.messages).date) : new Date(0);
        var lastMessageB = b.messages && b.messages.length > 0 ? new Date(_this8.getMostRecentMessage(b.messages).date) : new Date(0);
        return lastMessageB - lastMessageA;
      });
    },
    getMostRecentMessage: function getMostRecentMessage(messages) {
      var mostRecentMessage = messages.reduce(function (previous, current) {
        var previousDate = new Date(previous.date);
        var currentDate = new Date(current.date);
        return previousDate > currentDate ? previous : current;
      });
      return mostRecentMessage;
    },
    orderByDate: function orderByDate(a, b) {
      if (a.date < b.date) {
        return -1;
      } else {
        return 1;
      }
    },
    formatMessage: function formatMessage(msg) {
      if (msg === null) {
        return 'N/A';
      }
      return msg.replace(/\n/g, ' <br/> ');
    },
    formatDate: function formatDate(date) {
      var mydate = new Date(date);
      var month = ['Ene.', 'Feb.', 'Mar.', 'Abr.', 'May.', 'Jun.', 'Jul.', 'Ago.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'][mydate.getMonth()];
      var str = mydate.getHours() + ':' + (mydate.getMinutes() >= 10 ? mydate.getMinutes() : '0' + mydate.getMinutes());
      if (!(this.datetime.getDate() === mydate.getDate() && this.datetime.getMonth() === mydate.getMonth() && this.datetime.getYear() === mydate.getYear())) {
        str = mydate.getDate() + ' ' + month;
      }
      return str;
    },
    seeMessage: function seeMessage(row) {
      this.message = row;
      this.conversation = row.messages.sort(this.orderByDate);
      this.showModalMessage = true;
      this.updateMsgStatus(row.idUser, 1);
      this.providersMessages = this.sortMessagesPerDate(this.$store.state.provMessages);
    },
    openMassiveMessage: function openMassiveMessage() {
      this.showModalMassiveMessageRecipients = false;
      this.showModalMassiveMessage = true;
    },
    selectMassiveMessageRecipients: function selectMassiveMessageRecipients() {
      this.showModalMassiveMessageRecipients = true;
    },
    updateMsgStatus: function updateMsgStatus(idProvider, mode) {
      var _this9 = this;

      if (this.myMessages.length > 0) {
        if (this.myMessages.filter(function (el) {
          return el.status === '0' && el.idReceptor === _this9.idUser;
        }).length === 0) {
          return;
        }
      }
      if (this.providersMessages.length > 0 && this.providersMessages.find(function (el) {
        return el.idUser === idProvider;
      }).messages) {
        if (this.providersMessages.find(function (el) {
          return el.idUser === idProvider;
        }).messages.filter(function (msg) {
          return msg.status === '0' && msg.idEmisor === idProvider;
        }).length === 0) {
          return;
        }
      }
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('GET', 'api/statusMessages/' + idProvider + '/' + mode).then(function (response) {
        _this9.$parent.checkComments();
      });
    },
    updateScroll: function updateScroll(id) {
      var element = document.getElementById(id);
      element.scrollTop = element.scrollHeight + 100;
      this.loadMessagesFlag = true;
    },
    closeMessage: function closeMessage() {
      this.showModalMessage = false;
      this.conversation = null;
      this.loadMessagesFlag = false;
      clearInterval(this.timmerMessage);
      this.timmerMessage = 0;
    },
    sendMessage: function sendMessage(id) {
      var _this10 = this;

      this.newMessage = this.newMessage.trim().replace(/^\s+|\s+$/g, '');
      if (this.newMessage === '') {
        return;
      }
      this.loadingMsg = true;
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('POST', 'api/sendMessages', { 'idEmisor': this.idUser, 'idReceptor': id, 'message': this.newMessage, 'messageType': 1 }).then(function (response) {
        _this10.$parent.checkComments().then(function () {
          if (_this10.providersMessages.length > 0) {
            _this10.conversation = _this10.providersMessages.find(function (el) {
              return el.idUser === _this10.message.idUser;
            }).messages;
            _this10.updateMsgStatus(id, 1);
          }
          if (_this10.myMessages.length > 0) {
            _this10.updateMsgStatus(_this10.idUser, 2);
          }
          _this10.currentPage = 1;
          _this10.loadingMsg = false;
          _this10.newMessage = '';

          setTimeout(function () {
            return _this10.updateScroll('messages-container');
          }, 1);
        });
        var lastMessageDate = void 0;
        if (_this10.user.isProvider) {
          lastMessageDate = Date.parse(_this10.myMessages[_this10.myMessages.length - 1].date, 'Y-m-d h:m:s');
        } else {
          lastMessageDate = _this10.conversation[_this10.conversation.length - 1] ? Date.parse(_this10.conversation[_this10.conversation.length - 1].date, 'Y-m-d h:m:s') : null;
        }
        var currentDate = new Date();
        if ((currentDate - lastMessageDate) / 1000 > 7200) {
          __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('GET', 'api/enviarMailMensajeNuevo/' + id);
        }
      });
    },
    sendMassiveMessage: function sendMassiveMessage(providers) {
      var _this11 = this;

      this.showModalMassiveMessage = false;
      this.newMessage = this.newMessage.trim().replace(/^\s+|\s+$/g, '');
      if (this.newMessage === '') {
        return;
      }
      this.loadingMsg = true;
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('POST', 'api/sendMassiveMessages', { 'idEmisor': this.idUser, 'idReceptor': providers, 'message': this.newMessage, 'messageType': 1 }).then(function (response) {
        _this11.$parent.checkComments().then(function () {});
        _this11.$message({
          message: 'El mensaje masivo se ha enviado correctamente.',
          type: 'success'
        });
      });
    }
  },
  beforeMount: function beforeMount() {
    this.getRubros();
  },
  mounted: function mounted() {
    var _this12 = this;

    if (this.myMessages.length > 0) {
      setTimeout(this.updateScroll('messages-container'), 1);
      setTimeout(this.updateMsgStatus(this.idUser, 2), 1);
    }
    if (this.user.isProvider) {
      this.timmerMessage = setInterval(function () {
        return _this12.$parent.checkComments(_this12.currentPage, _this12.pageSize);
      }, 1000 * 3);
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.closeMessage();
    next();
  }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_picker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_data_tables__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_es__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(5);




__webpack_require__(0);










__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_es___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_data_tables___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Settings',
  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_2_vue_date_picker___default.a
  },
  data: function data(router) {
    return {
      providerStatus: [],
      providers: [],
      currentProviderId: '',
      editing: false,
      modalTitle: '',
      section: 'AllProviders',
      loading: '',
      showModal: false,
      contact: {
        name: '',
        email: '',
        idProviderStatus: '',
        idCompany: ''
      },
      titles: [{
        prop: 'user',
        label: 'Usuario'
      }, {
        prop: 'company',
        label: 'Compañía'
      }, {
        prop: 'fiscalId',
        label: 'Identificación Fiscal'
      }, {
        prop: 'idType',
        label: 'Tipo de identificación'
      }, {
        prop: 'date',
        label: 'Fecha'
      }, {
        prop: 'status',
        label: 'Estado'
      }],
      filters: [{
        prop: ['user', 'company', 'status'],
        value: ''
      }, {
        prop: ['idProviderStatus'],
        value: ''
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_vuex__["b" /* mapState */])(['user']), {
    datetime: function datetime() {
      return new Date();
    },
    contacts: function contacts() {
      var _this = this;

      if (this.user.isProvider && this.user.isAdmin === '1') {
        return this.$store.state.contacts.slice().sort(function (a, b) {
          return a.status - b.status;
        }).filter(function (element) {
          return element.idCompany === _this.user.idCompany;
        });
      } else {
        return this.$store.state.contacts.slice().sort(function (a, b) {
          return a.status - b.status;
        });
      }
    }
  }),
  methods: {
    modalAddContact: function modalAddContact() {
      this.contact = {
        name: '',
        mail: '',
        idProviderStatus: '',
        idCompany: ''
      };
      this.modalTitle = 'Agregar un contacto';
      this.editing = false;
      this.showModal = true;
    },
    getProviderStatus: function getProviderStatus() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('GET', 'api/generic/statusProvider').then(function (response) {
        _this2.providerStatus = response.data;
      });
    },
    createContact: function createContact() {
      var _this3 = this;

      if (this.user.isAdmin) {
        this.contact.idCompany = this.user.company.idCompany;
      }
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('POST', 'api/generic/user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        name: this.contact.name,
        requiresNewPassword: 0,
        email: this.contact.user,
        idCompany: this.contact.idCompany
      })).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('POST', 'api/generic/provider', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          idCompany: _this3.contact.idCompany,
          idUser: response.data.idUser,
          idComments: 0,
          idProviderStatus: 1,
          providerDeleted: 0,
          calification: 0,
          reasonCalification: 0,
          aceptoTerminos: 0
        })).then(function (response) {
          _this3.showModal = false;
          _this3.$parent.getContacts();
          _this3.$message({
            type: 'success',
            message: 'Se ha creado el contacto'
          }).catch(function (error) {
            console.log(error);
            _this3.$message({
              type: 'danger',
              message: 'Error al crear el contacto'
            });
          });
        });
      });
    },
    saveContact: function saveContact() {
      var _this4 = this;

      console.log(this.contact);
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('POST', 'api/generic/provider/' + this.currentProviderId, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        idCompany: this.contact.idCompany,
        idProviderStatus: this.contact.idProviderStatus
      })).then(function (response) {
        _this4.showModal = false;
        _this4.$parent.getContacts();
        _this4.$message({
          type: 'success',
          message: 'Se ha guardado el contacto'
        });
      }).catch(function (error) {
        console.log(error);
        _this4.$message({
          type: 'danger',
          message: 'Error al guardar el contacto'
        });
      });
    },
    sendActivationMail: function sendActivationMail(row) {
      var _this5 = this;

      this.$confirm('¿Está seguro que desea enviar el mail de activación a este usuario?', 'Atención', {
        confirmButtonText: 'Enviar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('GET', 'api/sendMailProvider/Provider/' + row.idProvider).then(function (response) {
          _this5.$parent.getContacts();
          _this5.$message({
            type: 'success',
            message: 'Se ha enviado el email'
          });
        }).catch(function (error) {
          console.log(error);
          _this5.$message({
            type: 'danger',
            message: 'Error al enviar el email'
          });
        });
      });
    },
    detail: function detail(row) {
      this.$router.push('/contactDetail?u=' + row.idProvider);
    },
    viewDetails: function viewDetails(row) {
      this.currentProviderId = row.idProvider;
      this.contact = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(row));
      this.modalTitle = 'Editar Contacto';
      this.editing = true;
      this.showModal = true;
      return;
    },
    hideModal: function hideModal() {
      this.showModal = false;
    },
    getProviders: function getProviders() {
      var _this6 = this;

      this.$store.commit('START_LOADING');
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('GET', 'api/generic/company?select=idCompany,company').then(function (response) {
        _this6.providers = response.data;
        console.log(_this6.providers);
        _this6.$store.commit('STOP_LOADING');
      }).catch(function (error) {
        console.log(error);
        _this6.$store.commit('STOP_LOADING');
      });
    },
    getProviderTest: function getProviderTest() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('GET', 'api/generic/provider').then(function (response) {
        _this7.providers = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  beforeMount: function beforeMount() {
    this.getProviderStatus();

    this.getProviderTest();
  }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date_picker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_data_tables__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_es__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_locale__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_apiHelper__ = __webpack_require__(43);





__webpack_require__(0);












__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_es___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_data_tables___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Settings',
  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_3_vue_date_picker___default.a,
    'countries-group': __WEBPACK_IMPORTED_MODULE_6_element_ui__["ButtonGroup"]
  },
  data: function data(router) {
    return {
      previousDocuments: [],
      newProvFlags: false,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      section: 'AllComments',
      loading: '',
      showModal: false,
      showModalComment: false,
      showModalDocumentation: false,
      showModalOperations: false,
      showModalDetails: false,
      showModalAssociatedUsers: false,
      showModalDocumentRecord: false,
      currentCompany: [],
      currentIdRubro: [],
      company: '',
      documents: [],
      filteredDocuments: [],
      filteredDocumentsRecord: [],
      rubros: [],
      selectedRow: null,
      comment: null,
      companyNew: {
        nombre: '',
        razonSocial: '',

        cuit: '',
        idCompanyStatus: '',
        descripcion: ''
      },
      titles: [{
        prop: 'company',
        label: 'Compañía',
        align: 'center',
        sortable: 'custom'
      }, {
        prop: 'fiscalId',
        label: 'Identificación Fiscal',
        align: 'center',
        sortable: 'custom'
      }, {
        prop: 'idType',
        label: 'Tipo de Identificación',
        align: 'center',
        sortable: 'custom'
      }, {
        prop: 'status',
        label: 'Estado',
        align: 'center'
      }],
      filters: [{
        prop: ['companyName', 'fiscalId', 'company'],
        value: ''
      }],
      titlesOperations: [{
        prop: 'nic',
        label: 'OC'
      }, {
        prop: 'fecha_liberacion',
        label: 'Liberación'
      }],
      titlesAssociatedUsers: [{
        prop: 'name',
        label: 'Usuarios Asociados'
      }],
      titlesDocumentRecord: [{
        prop: 'document_record',
        label: 'Historial de documentos'
      }],
      filtersOperations: [{
        prop: ['nic'],
        value: ''
      }, {
        filterFn: function filterFn(row, filter) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(row).some(function (prop) {
            if (prop === 'fecha_liberacion') {
              if (filter.value !== null) {
                return new Date(row.fecha_liberacion).getTime() <= filter.value[1].getTime() && new Date(row.fecha_liberacion).getTime() >= filter.value[0].getTime();
              } else {
                return true;
              }
            }
          });
        },
        prop: ['fecha_liberacion'],
        value: ''
      }, {
        prop: 'statusId',
        value: ''
      }],
      filtersAssociatedUsers: [{
        prop: ['name'],
        value: ''
      }],
      filtersDocumentRecord: [{
        prop: ['document_record'],
        value: ''
      }],
      totalProviders: 0,
      providers: [],
      loadingProviders: false,
      currentApiCalls: 0,
      dummyFilter: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapState */])(['user']), {
    datetime: function datetime() {
      return new Date();
    },
    providersOrdered: function providersOrdered() {
      return this.providers.slice().sort(function (a, b) {
        return a.status - b.status;
      });
    },
    statusList: function statusList() {
      return this.$store.state.countStatus;
    }
  }),
  methods: {
    viewCompanyData: function viewCompanyData(step, idCompany, country) {
      this.$router.push('/companyData/' + idCompany + '/' + step + '/' + country);
    },
    goToNewProv: function goToNewProv(idCompany) {
      this.newProvFlags = !this.newProvFlags;
    },
    startLoading: function startLoading() {
      this.currentApiCalls++;
      this.loadingProviders = true;
    },
    stopLoading: function stopLoading() {
      this.currentApiCalls--;
      if (this.currentApiCalls === 0) this.loadingProviders = false;
    },
    getTotalProvider: function getTotalProvider() {
      var _this = this;

      var queryInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var substringPosition = queryInfo.search('condition=');
      var query = queryInfo.substring(substringPosition + 10);
      query = '(idCompanyStatus=2%20)';
      __WEBPACK_IMPORTED_MODULE_12__helpers_apiHelper__["a" /* default */].getTotal('companyCountriesStatus', query).then(function (count) {
        _this.totalProviders = count;
      });
    },
    getProviders: function getProviders() {
      var _this2 = this;

      var queryInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var query = __WEBPACK_IMPORTED_MODULE_12__helpers_apiHelper__["a" /* default */].getQueryForApi(queryInfo);
      this.startLoading();
      this.getTotalProvider(query);
      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('GET', 'api/listProviders' + query).then(function (response) {
        var data = response.data;

        if (data.error) {
          return;
        }
        if (data) {
          console.log(data);
          var provs = data.filter(function (prov) {
            return prov.idCompanyStatus === '2' || prov.idCompanyStatus === '5';
          });
          provs.forEach(function (el, index) {
            el.calification = parseInt(el.calification);
          });
          _this2.providers = provs;
        }
        _this2.stopLoading();
      }).catch(function (error) {
        _this2.$store.commit('TOGGLE_LOADING');
        console.log(error);
        _this2.loadingProviders = false;
      });
    },
    goToDetails: function goToDetails(idBuyOrder) {
      this.$router.push('/invoicedetail?i=' + idBuyOrder);
    },
    getStatusName: function getStatusName(statusId) {
      return this.statusList.find(function (el) {
        return el.statusId === statusId;
      }).description;
    },
    showModalCreateProvider: function showModalCreateProvider() {
      this.showModal = true;
      this.currentIdRubro = [];
    },
    showDetails: function showDetails(row) {
      var _this3 = this;

      this.currentCompany = row;
      this.currentIdRubro = [];
      if (this.currentCompany.rubros !== undefined) {
        this.currentCompany.rubros.forEach(function (item, index) {
          _this3.currentIdRubro[index] = item.idRubro;
        });
      }
      this.showModalDetails = true;
    },
    showDetailsTEST: function showDetailsTEST(row) {},
    getOperations: function getOperations(row) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('GET', 'api/companyOperations/' + row.idCompany).then(function (response) {
        _this4.showModalOperations = true;
        _this4.company = row;
        _this4.company.operations = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getDocumentation: function getDocumentation(row) {
      var _this5 = this;

      this.currentCompany = row;
      this.company = row;
      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('GET', 'api/generic/document').then(function (response) {
        _this5.documents = response.data;
        _this5.documents.forEach(function (doc) {
          if (_this5.company.documents.find(function (el) {
            return el.idDocument === doc.idDocument;
          }) === undefined) {
            _this5.company.documents.push({
              idDocument: doc.idDocument,
              documentName: doc.documentName,
              idProvider: _this5.company.idCompany,
              status: '0'
            });
          }
        });

        _this5.documents.forEach(function (document, index) {
          _this5.filteredDocuments[index] = _this5.currentCompany.documents.find(function (el) {
            return el.idProviderDocumentStatus === '2' && el.idDocument === String(index + 1);
          });
        });
        _this5.getDocumentRecord();
        _this5.showModalDocumentation = true;
      });
    },
    getAssociatedUsers: function getAssociatedUsers(row) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('GET', 'api/AssociatedUsers/' + row.idCompany).then(function (response) {
        _this6.showModalAssociatedUsers = true;
        _this6.company = row;
        _this6.company.users = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    saveCompany: function saveCompany() {
      var _this7 = this;

      if (this.companyNew.nombre !== '' && this.companyNew.razonSocial !== '' && this.companyNew.cuit !== '' && this.currentIdRubro !== undefined && this.currentIdRubro.length > 0) {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/company', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          company: this.companyNew.nombre,
          companyName: this.companyNew.razonSocial,
          idCompanyStatus: 2,
          cuit: this.companyNew.cuit,
          reasonCalification: this.companyNew.descripcion,
          idCompany: ''
        })).then(function (response) {
          _this7.currentIdRubro.forEach(function (item, index) {
            __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/rubrosCompany/', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
              idRubro: _this7.currentIdRubro[index],
              idCompany: response.data.idCompany
            })).then(function (response) {
              _this7.$message.success('Se ha agregado la nueva empresa', 'success');
              _this7.hideModal();
              _this7.$parent.getProviders();
            });
          });
        }).catch(function (error) {
          _this7.$message.error(error.response.data, 'error');
        });
      } else {
        this.$message.warning('Debe completar todos los campos', 'warning');
      }
    },
    openNodeUrl: function openNodeUrl(node, prop, treeNode) {
      if (!node.children) {
        var win = window.open(node.url, '_blank');
        win.focus();
      }
    },
    getDocumentRecord: function getDocumentRecord() {
      var _this8 = this;

      console.log(this.previousDocuments);
      this.documents.forEach(function (document, index2) {
        _this8.previousDocuments[index2] = [{ label: 'Documentos anteriores', children: [] }];
        _this8.previousDocuments[index2][0].children = _this8.currentCompany.documents.filter(function (el) {
          return el.idProviderDocumentStatus === '2' && el.idDocument === String(document.idDocument);
        });
        if (_this8.previousDocuments[index2][0].children.length === 0 || _this8.previousDocuments[index2][0] === undefined) {
          delete _this8.previousDocuments[index2];
        } else {
          _this8.previousDocuments[index2][0].children.forEach(function (docChildren) {
            docChildren.label = docChildren.emisionDate;
          });
        }
      });
    },
    updateCompany: function updateCompany() {
      var _this9 = this;

      if (this.currentCompany.company !== '' && this.currentCompany.companyName !== '' && this.currentCompany.cuit !== '' && this.currentIdRubro !== undefined && this.currentIdRubro.length > 0) {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/company/' + this.currentCompany.idCompany, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          company: this.currentCompany.company,
          companyName: this.currentCompany.companyName,
          cuit: this.currentCompany.cuit,
          address: this.currentCompany.address,
          billingAddress: this.currentCompany.billingAddress,
          comments: this.currentCompany.comments,
          reasonCalification: this.currentCompany.reasonCalification
        })).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('GET', 'api/deleteRubrosFromCompany/' + _this9.currentCompany.idCompany).then(function (response) {
            _this9.currentIdRubro.forEach(function (item, index) {
              __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/rubrosCompany/', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                idRubro: _this9.currentIdRubro[index],
                idCompany: _this9.currentCompany.idCompany
              })).then(function (response) {});
            });
            _this9.$message.success('Se ha actualizado la empresa correctamente', 'success');
            _this9.showModalDetails = false;
            _this9.$parent.getProviders();
          });
        });
      } else {
        this.$message.warning('Debe completar todos los campos', 'warning');
      }
    },
    saveDocumentation: function saveDocumentation() {
      var _this10 = this;

      var string = '';
      this.company.documents.forEach(function (el) {
        string += _this10.company.idCompany + 'o' + el.idDocument + 'o' + el.status + '_';
      });
      string = string.slice(0, -1);
      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('GET', 'api/updateDocumentation/' + this.company.idCompany + '/' + string).then(function (response) {
        _this10.closeDocumentation();
      });
    },
    closeDocumentation: function closeDocumentation() {
      this.showModalDocumentation = false;
      this.$parent.getProviders();
    },
    closeOperations: function closeOperations() {
      this.showModalOperations = false;
    },
    closeAssociatedUsers: function closeAssociatedUsers() {
      this.showModalAssociatedUsers = false;
    },
    closeDocumentRecord: function closeDocumentRecord() {
      this.showModalDocumentRecord = false;
    },
    toggleCalification: function toggleCalification(row) {
      if (this.selectedRow === row.idCompany) {
        this.selectedRow = null;
      } else {
        this.selectedRow = row.idCompany;
      }
    },
    hideModal: function hideModal() {
      this.showModal = false;
      this.currentIdRubro = [];
    },
    hideModalComment: function hideModalComment() {
      this.showModalComment = false;
    },
    updateCalification: function updateCalification(row, isModal) {
      var _this11 = this;

      var comment = '';
      if (row.reasonCalification.trim() === '' || row.reasonCalification === null) {
        if (isModal === 'true') {
          this.$message({
            type: 'warning',
            message: 'Descripción es Requerido'
          });
        } else {
          comment = '_';
        }
      } else {
        comment = row.reasonCalification.trim().replace(/\s+/g, '-');
        comment = comment.trim().replace(/[\n\r]+/g, '_');
        console.log('row', row);
        console.log('comment', comment);
        this.showModalComment = false;
      }

      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/updateCalification/Company/' + row.idCompany + '/' + row.calification + '/' + comment).then(function (response) {
        _this11.$parent.getProviders();
      }).catch(function (error) {
        _this11.$store.commit('TOGGLE_LOADING');
        _this11.$parent.getProviders();
        console.log(error);
      });
    },
    commentCompany: function commentCompany(row) {
      this.company = row;
      this.showModalComment = true;
    },
    stopCompany: function stopCompany(row) {
      var _this12 = this;

      this.$confirm('¿Realmente desea suspender la compañía?', 'Advertencia', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        lockScroll: false
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('GET', 'api/updateStopCompanyStatus/' + row.idCompany).then(function (response) {
          _this12.$parent.getProviders();
        });
      });
    },
    startCompany: function startCompany(row) {
      var _this13 = this;

      this.$confirm('¿Desea Activar la compañía?', 'Advertencia', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        lockScroll: false
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('GET', 'api/updateStartCompanyStatus/' + row.idCompany).then(function (response) {
          _this13.getProviders();
        });
      });
    },
    deleteCompany: function deleteCompany(row) {
      var _this14 = this;

      this.$confirm('¿Está seguro que desea eliminar esta Empresa?', 'Atención', {
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('GET', 'api/canDeleteCompany/' + row.idCompany).then(function (response) {
          if (response.data) {
            __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/delete/company/' + row.idCompany).then(function (response) {
              _this14.$parent.getProviders();
              _this14.$message({
                type: 'success',
                message: 'Se ha eliminado la Empresa'
              });
            }).catch(function (error) {
              console.log(error);
              _this14.$message({
                type: 'danger',
                message: 'Error al eliminar el Empresa'
              });
            });
          } else {
            _this14.$message({
              type: 'warning',
              message: 'La empresa contiene información asociada, no es posible eliminarla'
            });
          }
        });
      });
    },
    getRubros: function getRubros() {
      var _this15 = this;

      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('GET', 'api/generic/rubros').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this15.rubros = data;
        }
      }).catch(function (error) {
        _this15.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    updateFilter: function updateFilter(updatedFilter) {
      var index = this.filters.findIndex(function (f) {
        return f.prop === updatedFilter.prop;
      });
      this.filters[index].value = updatedFilter.value;
    }
  },
  beforeMount: function beforeMount() {
    this.getRubros();
  }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_date_picker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_text_mask__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_the_mask__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_company_stage__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_roles__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config_data_status__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__404_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__404_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PdfFile_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PdfFile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__PdfFile_vue__);





__webpack_require__(0);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AltaDeUsuario',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_4_vue_date_picker___default.a, TheMask: __WEBPACK_IMPORTED_MODULE_7_vue_the_mask___default.a, MaskedInput: __WEBPACK_IMPORTED_MODULE_5_vue_text_mask___default.a, PdfFile: __WEBPACK_IMPORTED_MODULE_13__PdfFile_vue___default.a, error404: __WEBPACK_IMPORTED_MODULE_12__404_vue___default.a },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])(['banks', 'user', 'bankBranches', 'accountTypes', 'regimenTypes', 'jurisdictions', 'retentionRegimes', 'retentionRegimesVAT', 'retentionRegimesOTROS', 'retentionCategories', 'retentionCategoriesVAT', 'retentionCategoriesOTROS']), {
    services: function services() {
      var services = this.$store.state.services;
      if (services.sort) {
        return services.sort(function (a, b) {
          return a.nombre > b.nombre;
        });
      }
    },
    countries: function countries() {
      if (this.$store.state.countries) {
        return this.$store.state.countries.sort(function (a, b) {
          return a.country > b.country;
        });
      }
    },
    sussRetentionCategory: function sussRetentionCategory() {
      var lista = this.$store.state.sussRetentionCategory.sort(function (a, b) {
        return a.categoryRetain > b.categoryRetain;
      });
      if (this.taxData.sussRetentionRegimen === '0') {
        return lista;
      } else {
        lista = lista.filter(function (a) {
          var auxiliar = a.auxiliar;
          var agenteRet = JSON.parse(auxiliar)['AgenteRet'] === 'true';
          if (agenteRet) {
            return a;
          }
        });
        return lista;
      }
    },
    groupCompanies: function groupCompanies() {
      return this.$store.state.groupCompanies.sort(function (a, b) {
        return a.groupCompany > b.groupCompany;
      });
    },
    storeRetentionRegime: function storeRetentionRegime() {
      return this.$store.state.retentionRegimes;
    },
    retentionRegimeList: function retentionRegimeList() {
      return this.$store.state.retentionRegimes.filter(function (el) {
        return el.idRetentionRegime === '3';
      });
    },
    statusList: function statusList() {
      return this.$store.state.companyDataStatus;
    }
  }),
  data: function data(router) {
    return {
      isLoading: true,
      jurisdictionsHabilitadas: [],
      jurisdicciones: true,
      status: __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */],
      operatesHere: true,
      userIsAdmin: false,
      userByRoles: false,
      otrosRetentionCategories: [],
      retentionCategories2: [],
      retentionCategoriesAliquot: [],
      ivaRetentionCategories: [],
      availableCountries: [],
      disabledDates: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },

      doc1276: false,
      jurisdictionSantaFe: '',
      auxJurId: '',
      provider: '',
      providerLoaded: false,
      rejectCompanyDataVisible: false,
      disabledData: false,
      habModificaPdf: false,
      error: null,
      newObservation: '',
      statusType: '',
      types: ['warning', 'success', 'danger'],
      steps: ['generalData', 'paymentData', 'taxData'],
      idCompany: this.$route.params.id,
      idStep: this.$route.params.step,
      showModalCertificationExgain: false,
      showModalCertificationsExgainList: false,
      certificationExgainList: [],
      auxFlagEmptyExgainList: false,
      certificationExgain: [],
      showModalCertificationDatosAdicionales: false,
      showModalForm1276: false,
      showModalCertificationRg2681: false,
      showModalCertificationRg2681List: false,
      certificationRg2681List: [],
      certificationRg2681: [],
      showModalCertificationSussList: false,
      showModalCertificationSuss: false,
      certificationSussList: [],
      certificationSuss: [],
      showModalCertificationRg18List: false,
      showModalCertificationRg18: false,
      certificationRg18List: [],
      certificationRg18: [],
      showModalCertificationRg17List: false,
      showModalCertificationRg17: false,
      certificationRg17List: [],
      certificationRg17: [],
      checked2: false,
      govInteraction: false,
      associatedPEP: false,
      step: 0,
      timeStampModifDate: '',
      editing: false,
      serverURI: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].serverURI,
      section: 'Solicitud',
      loading: '',
      providers: [],
      rut: '',
      options: [{
        value: '',
        label: ''
      }],
      dataAfip: '',
      value: '',
      configuration: '',
      jwt: window.localStorage.getItem('token'),
      codigoEtica: '',
      politicaAnticorrupcion: '',
      politicaRelacionamiento: '',
      emailSoporte: '',
      response: null,
      success: null,
      paramError: null,
      provinces: [],
      centrales: [],
      activeJurisdiction: '',
      activeJurisdictionSantaFe: '',
      coefficientFieldVerify: false,
      form1276loaded: false,
      form1276loadedAux: false,
      paramInvoices: null,
      rutMask: this.$store.state.rutMask,
      cuitMask: [/[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
      invoiceMask: this.$store.state.invoiceMask,
      terminosYCondVisible: false,
      checked: false,
      jurId: 0,
      jurisdictionsLength: 0,
      jurArray: [],
      generalData: {
        cuit: '',
        company: '',
        companyName: '',
        rubros: [],
        centrales: [],
        start_date: '',
        address: '',
        addressNumber: '',
        idProvince: '',
        idCountry: '',
        idGroupCompany: '',
        zipCode: '',
        city: '',
        paymentEmail: '',
        receiptEmail: '',
        typeIVA: '',
        personType: '',
        personSubType: '',
        personSubTypeOther: '',
        pdfAfip: '',
        namePrincipalContact: '',
        surnamePrincipalContact: '',
        phonePrincipalContact: '',
        emailPrincipalContact: '',
        nameCommercialContact: '',
        surnameCommercialContact: '',
        phoneCommercialContact: '',
        emailCommercialContact: '',
        modifDate: ''
      },
      rulesGeneralData: {
        cuit: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }, {
          type: 'number',
          message: 'Solo están permitidos los números',
          trigger: ['blur', 'change']
        }],
        company: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        start_date: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        centrales: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        rubros: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        address: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        addressNumber: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        idProvince: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        zipCode: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        city: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        idCountry: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        idGroupCompany: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        phonePrincipalContact: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        phoneCommercialContact: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        namePrincipalContact: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        nameCommercialContact: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        surnamePrincipalContact: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        surnameCommercialContact: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        emailPrincipalContact: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }, {
          type: 'email',
          message: 'Debe ingresar un correo electrónico válido',
          trigger: 'blur'
        }],
        emailCommercialContact: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }, {
          type: 'email',
          message: 'Debe ingresar un correo electrónico válido',
          trigger: 'blur'
        }],
        paymentEmail: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }, {
          type: 'email',
          message: 'Debe ingresar un correo electrónico válido',
          trigger: 'blur'
        }],
        receiptEmail: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }, {
          type: 'email',
          message: 'Debe ingresar un correo electrónico válido',
          trigger: 'blur'
        }],
        typeIVA: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        personType: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        personSubType: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        personSubTypeOther: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        pdfAfip: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }]
      },
      paymentData: {
        idBankBranch: '',
        idBank: '',
        accountNumber: '',
        idBankAccountType: '',
        cbu: '',
        pdfBank: ''
      },
      rulesPaymentData: {
        idBank: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        accountNumber: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        idBankAccountType: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        cbu: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }, {
          pattern: '[0-9]{22}',
          message: 'Deben ser 22 números',
          trigger: ['blur', 'change']
        }],
        pdfBank: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }]
      },
      jurisdictionData: {
        idJurisdiction: '',
        coefficient: null,
        aliquot: null,
        certficateDetailsVisible: false,
        form1276Visible: false,
        certificateNumber: '',
        certificateFrom: null,
        certificateTo: null,
        certificatePdf: '',
        retentionAgentHas: 0,
        retentionAgentVisible: false,
        retentionAgentDate: null,
        retentionAgentPdf: '',
        form1276pdf: '',
        perceptionAgentHas: 0,
        agentDontOperateHere: false,
        perceptionAgentVisible: false,
        perceptionAgentDate: null,
        perceptionAgentPdf: ''
      },
      taxData: {
        pdfIb: '',
        ibType: '',
        pdfsExempt: '',
        idAgreementRegimeType: '',
        pdfCM05: '',
        jurisdictionHeadquarters: '',
        jurisdictions: [],
        earningsRetentionType: '',
        retentionRegimen: '',
        idEarningCategoryRetain: '',
        earningsExclusionNumber: '',
        earningsExclusionFrom: null,
        earningsExclusionTo: null,
        earningsExclusionPdf: '',
        sussEmployeer: 0,
        sussRetentionRegimen: 0,
        sussIdCategoryRetain: '',
        sussExclusionNumber: '',
        sussExclusionFrom: null,
        sussExclusionTo: null,
        sussExclusionPdf: '',
        ivaRetentionAgent: 0,
        ivaResolutionPdf: '',
        ivaIdRetentionRegime: '',
        ivaIdCategoryRetain: '',
        ivaExclusionNumber: '',
        otrosIdRetentionRegime: '',
        otrosIdCategoryRetain: '',
        ivaExclusionFrom: null,
        ivaExclusionTo: null,
        ivaExclusionPdf: ''
      },
      rulesTaxData: {
        pdfIb: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        ibType: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        pdfsExempt: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        idAgreementRegimeType: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        pdfCM05: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        jurisdictionHeadquarters: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],

        earningsRetentionType: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        retentionRegimen: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        idEarningCategoryRetain: [{
          required: !!this.retentionCategories2,
          message: 'Campo obligatorio',
          trigger: 'change'
        }],
        earningsExclusionFrom: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        earningsExclusionTo: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        earningsExclusionPdf: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        sussExclusionFrom: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        sussExclusionTo: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        sussExclusionPdf: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        ivaExclusionFrom: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        ivaExclusionTo: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        ivaExclusionPdf: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }]
      },
      rulesTaxDataIvaResolutionPdf: {
        ivaResolutionPdf: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }]
      },
      rulesTaxDataOtros: {
        ivaResolutionPdf: [{
          required: false,
          message: 'Campo no obligatorio',
          trigger: 'change'
        }]
      },
      rulesTaxDataForm1276Pdf: {
        form1276pdf: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }]
      },
      userData: {
        name: '',
        email: '',
        password: '',
        passwordRe: ''
      },
      rulesUserData: {
        email: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }, {
          type: 'email',
          message: 'Debe ingresar un correo electrónico válido',
          trigger: 'blur'
        }],
        password: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }, {
          min: 8,
          message: 'Debe tener mínimo 8 caracteres',
          trigger: 'change'
        }]
      }
    };
  },

  watch: {
    provider: function provider(val) {
      this.loadProvider();
    }
  },
  methods: {
    validateCoefficient: function validateCoefficient(key, jurId) {
      console.log('key ingresa: ', key);
      console.log(this.taxData.jurisdictions[jurId]);
      var allowedCharacters = /^\d+(,\d{0,4})?$/;
      if (!allowedCharacters.test(key)) {
        if (!allowedCharacters.test(key[key.length - 1])) {
          this.taxData.jurisdictions[jurId].coefficient = key.slice(0, -1);
          console.log('key correcta', this.taxData.jurisdictions[jurId].coefficient);
          return;
        }
        key = key.replace(/[^0-9,\b]+/g, '');
        var parts = key.split(/,/);
        var integerPart = parts[0];
        var decimalPart = parts[1] || '';

        decimalPart = decimalPart.slice(0, 4);
        this.taxData.jurisdictions[jurId].coefficient = integerPart + (decimalPart ? ',' + decimalPart : '');
        console.log('key sale: ', this.taxData.jurisdictions[jurId].coefficient);
      } else {
        console.log('key correcta: ', key);
        this.taxData.jurisdictions[jurId].coefficient = key;
      }
    },
    decimalCoefficient: function decimalCoefficient(coef) {
      return coef.indexOf(',') !== -1 && coef.split(',')[0].length > 0 && coef.split(',')[1].length > 0;
    },
    clearAlicuotValue: function clearAlicuotValue(jurId) {
      var _this = this;

      this.taxData.jurisdictions.forEach(function (jur, index) {
        if (jur.idJurisdiction === jurId) {
          _this.taxData.jurisdictions[index].aliquot = '';
        }
      });
    },
    changeAlicoutJurisdiction: function changeAlicoutJurisdiction(jurId) {
      if (jurId !== null && jurId !== '') {
        var data = this.$store.state.ibRetentionCategory.filter(function (ret) {
          return ret.idJurisdictions === jurId;
        }).sort(function (a, b) {
          return a.categoryRetain > b.categoryRetain;
        });
        this.updateAliquot(jurId);
        this.clearAlicuotValue(jurId);
        return data;
      }
    },
    isAlicuotList: function isAlicuotList(jurId) {
      if (jurId !== null && jurId !== '') {
        var data = this.$store.state.ibRetentionCategory.filter(function (ret) {
          return ret.idJurisdictions === jurId;
        });
        return data.length > 0;
      }
    },
    getJurisdictionData: function getJurisdictionData(jurId) {
      if (jurId) {
        var jurisdiction = this.jurisdictions[jurId];

        console.log(jurisdiction);
      }
    },
    sussIdCategoryRetainClear: function sussIdCategoryRetainClear() {
      if (localStorage.getItem('sussIdCategoryRetainkey') === null) {
        this.taxData.sussIdCategoryRetain = '';
      }
    },
    notify: function notify(notificationMessage) {
      this.$notify({
        title: '',
        type: 'warning',
        message: notificationMessage,
        duration: 10000,
        showClose: true,
        offset: 50
      });
    },
    editData: function editData() {
      this.editing = true;
      this.disabledGeneralData();
      if (this.generalData.idCountry) {
        this.updateProvinces(this.generalData.idCountry);
      }
    },
    cancelData: function cancelData() {
      this.editing = false;
      this.disabledGeneralData();
    },
    saveData: function saveData() {
      var _this2 = this;

      this.$confirm('Sus Datos se remitirán a Albanesi para su verificación', 'Atención', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(function () {
        _this2.editing = false;
        _this2.disabledGeneralData();
        _this2.providerUpdateData();
      });
    },
    calculateHabModificaPdf: function calculateHabModificaPdf() {
      var provider = !!this.provider && this.provider !== '';
      this.habModificaPdf = !provider || this.editing || !this.disabledData;
    },
    disabledGeneralData: function disabledGeneralData() {
      if (this.user && this.idCompany) {
        if (this.user.isProvider) {
          if (this.editing) {
            this.disabledData = false;
            this.calculateHabModificaPdf();
            return;
          } else {
            if (this.provider) {
              if (this.provider[this.activeTab()].idCompanyDataStatus === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].DEVUELTO) {
                this.disabledData = false;
                this.calculateHabModificaPdf();
                return;
              }
            }
          }
        } else {
          if (this.provider) {
            if (this.provider[this.activeTab()].idCompanyDataStatus !== __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ACEPTADO) {
              this.disabledData = false;
              this.calculateHabModificaPdf();
              return;
            }
          }
        }
      } else {
        this.disabledData = false;
        this.calculateHabModificaPdf();
        return;
      }
      this.disabledData = true;
      this.calculateHabModificaPdf();
    },
    closeCertificationExgain: function closeCertificationExgain() {
      this.showModalCertificationExgain = false;
    },
    closeCertificationsExgainList: function closeCertificationsExgainList() {
      this.showModalCertificationsExgainList = false;
    },
    closeCertificationRg2681: function closeCertificationRg2681() {
      this.showModalCertificationRg2681 = false;
    },
    closeCertificationsRg2681List: function closeCertificationsRg2681List() {
      this.showModalCertificationRg2681List = false;
    },
    closeCertificationSuss: function closeCertificationSuss() {
      this.showModalCertificationSuss = false;
    },
    closeCertificationsSussList: function closeCertificationsSussList() {
      this.showModalCertificationSussList = false;
    },
    closeCertificationRg18: function closeCertificationRg18() {
      this.showModalCertificationRg18 = false;
    },
    closeCertificationsRg18List: function closeCertificationsRg18List() {
      this.showModalCertificationRg18List = false;
    },
    closeCertificationRg17: function closeCertificationRg17() {
      this.showModalCertificationRg17 = false;
    },
    closeCertificationsRg17List: function closeCertificationsRg17List() {
      this.showModalCertificationRg17List = false;
    },
    coeficienteValidacionTest: function coeficienteValidacionTest() {
      return this.taxData.jurisdictions.some(function (el) {
        if (el.coefficient === null || el.coefficient === undefined) {} else {
          return el.coefficient.indexOf('.') > -1;
        }
      });
    },
    verifySantaFeJurisdiction: function verifySantaFeJurisdiction() {
      var _this3 = this;

      this.taxData.jurisdictions.forEach(function (juris) {
        if (juris.idJurisdiction === '13') {
          if (_this3.activeJurisdictionSantaFe !== '') {
            if (_this3.taxData.jurisdictions[_this3.activeJurisdictionSantaFe]['form1276pdf'] !== null) {
              console.log('hay una jurisdiccion santa fe con form1276 OK');
              _this3.form1276loaded = true;
            } else if (_this3.taxData.jurisdictions[_this3.activeJurisdictionSantaFe]['form1276pdf'] === null) {
              console.log('hay una jurisdiccion santa fe con form1276 No cargado');
              _this3.form1276loaded = false;
            }
          } else {
            console.log('hay una jurisdiccion santa fe con form ERROR');
            _this3.form1276loaded = false;
          }
        } else {
          _this3.form1276loaded = true;
        }
      });
    },
    getCertificationExgain: function getCertificationExgain(id) {
      var _this4 = this;

      this.certificationExgain = [];

      this.certificationExgainList.forEach(function (certif) {
        if (certif.IdCertificationExGain === id) {
          _this4.certificationExgain.push({
            id: certif.IdCertificationExGain,
            cuit: certif.cuit,
            state: certif.state,
            publication: certif.publication,
            validity: certif.validity,
            period: certif.period,
            percentage: certif.percentage,
            number: certif.number,
            resolution: certif.resolution
          });
        }
      });

      this.showModalCertificationExgain = true;
    },
    openCertificationExgainList: function openCertificationExgainList() {
      if (this.user !== null) {
        this.certificationExgainList = [];
        this.getCertificationExgainList();
      }
      this.showModalCertificationsExgainList = true;
    },
    getCertificationExgainList: function getCertificationExgainList() {
      var _this5 = this;

      this.providers[0].certifExgain.forEach(function (certif) {
        _this5.certificationExgainList.push({
          IdCertificationExGain: certif.IdCertificationExGain,
          number: certif.number,
          publication: certif.publication,
          validity: certif.validity,
          cuit: certif.cuit,
          state: certif.state,
          period: certif.period,
          percentage: certif.percentage,
          resolution: certif.resolution
        });
      });

      console.log(this.certificationExgainList);
    },
    getCertificationRg2681: function getCertificationRg2681(id) {
      var _this6 = this;

      this.certificationRg2681 = [];

      this.certificationRg2681List.forEach(function (certif) {
        if (certif.idCertificationRG2681 === id) {
          _this6.certificationRg2681.push({
            id: certif.idCertificationRG2681,
            cuit: certif.cuit,
            type: certif.type,
            state: certif.state,
            stateDescription: certif.stateDescription,
            emision: certif.emision,
            administrationDate: certif.administrationDate,
            auth: certif.auth,
            ddjj: certif.ddjj,
            subsection: certif.subsection,
            since: certif.since,
            until: certif.until,
            number: certif.number,
            orderJud: certif.orderJud,
            modificationDate: certif.modificationDate
          });
        }
      });
      console.log(this.certificationRg2681[0].cuit);
      this.showModalCertificationRg2681 = true;
    },
    openCertificationRg2681List: function openCertificationRg2681List() {
      if (this.user !== null) {
        this.certificationRg2681List = [];
        this.getCertificationRg2681List();
      }
      this.showModalCertificationRg2681List = true;
    },
    getCertificationRg2681List: function getCertificationRg2681List() {
      var _this7 = this;

      this.providers[0].certifRg2681.forEach(function (certif) {
        _this7.certificationRg2681List.push({
          idCertificationRG2681: certif.idCertificationRG2681,
          cuit: certif.cuit,
          type: certif.type,
          state: certif.state,
          stateDescription: certif.stateDescription,
          emision: certif.emision,
          administrationDate: certif.administrationDate,
          auth: certif.auth,
          ddjj: certif.ddjj,
          subsection: certif.subsection,
          since: certif.since,
          until: certif.until,
          number: certif.number,
          orderJud: certif.orderJud,
          modificationDate: certif.modificationDate
        });
      });

      console.log(this.certificationRg2681List);
    },
    getCertificationSuss: function getCertificationSuss(id) {
      var _this8 = this;

      this.certificationSuss = [];

      this.certificationSussList.forEach(function (certif) {
        if (certif.idCertificaction === id) {
          _this8.certificationSuss.push({
            id: certif.idCertificaction,
            cuit: certif.cuit,
            state: certif.state,
            since: certif.since,
            until: certif.until,
            number: certif.number,
            period: certif.period,
            resolution: certif.resolution,
            percentage: certif.percentage
          });
        }
      });
      this.showModalCertificationSuss = true;
    },
    openCertificationSussList: function openCertificationSussList() {
      if (this.user !== null) {
        this.certificationSussList = [];
        this.getCertificationSussList();
      }
      this.showModalCertificationSussList = true;
    },
    getCertificationSussList: function getCertificationSussList() {
      var _this9 = this;

      this.providers[0].certifSuss.forEach(function (certif) {
        _this9.certificationSussList.push({
          idCertificaction: certif.idCertificaction,
          cuit: certif.cuit,
          state: certif.state,
          since: certif.since,
          until: certif.until,
          number: certif.number,
          period: certif.period,
          resolution: certif.resolution,
          percentage: certif.percentage
        });
      });
    },
    getCertificationRg18: function getCertificationRg18(id) {
      var _this10 = this;

      this.certificationRg18 = [];

      this.certificationRg18List.forEach(function (certif) {
        if (certif.idCertificationRG18 === id) {
          _this10.certificationRg18.push({
            id: certif.idCertificationRG18,
            cuit: certif.cuit,
            type: certif.type,
            since: certif.since,
            until: certif.until,
            name: certif.name
          });
        }
      });
      this.showModalCertificationRg18 = true;
    },
    openCertificationRg18List: function openCertificationRg18List() {
      if (this.user !== null) {
        this.certificationRg18List = [];
        this.getCertificationRg18List();
      }
      this.showModalCertificationRg18List = true;
    },
    getCertificationRg18List: function getCertificationRg18List() {
      var _this11 = this;

      this.providers[0].certifRg18.forEach(function (certif) {
        _this11.certificationRg18List.push({
          idCertificationRG18: certif.idCertificationRG18,
          cuit: certif.cuit,
          type: certif.type,
          since: certif.since,
          until: certif.until,
          name: certif.name
        });
      });
    },
    getCertificationRg17: function getCertificationRg17(id) {
      var _this12 = this;

      this.certificationRg17 = [];

      this.certificationRg17List.forEach(function (certif) {
        if (certif.idCertificationRG17 === id) {
          _this12.certificationRg17.push({
            id: certif.idCertificationRG2681,
            cuit: certif.cuit,
            type: certif.type,
            rg: certif.rg,
            percentage: certif.percentage,
            since: certif.since,
            until: certif.until,
            name: certif.name
          });
        }
      });
      this.showModalCertificationRg17 = true;
    },
    openCertificationRg17List: function openCertificationRg17List() {
      if (this.user !== null) {
        this.certificationRg17List = [];
        this.getCertificationRg17List();
      }
      this.showModalCertificationRg17List = true;
    },
    getCertificationRg17List: function getCertificationRg17List() {
      var _this13 = this;

      this.providers[0].certifRg17.forEach(function (certif) {
        _this13.certificationRg17List.push({
          idCertificationRG17: certif.idCertificationRG2681,
          cuit: certif.cuit,
          type: certif.type,
          rg: certif.rg,
          percentage: certif.percentage,
          since: certif.since,
          until: certif.until,
          name: certif.name
        });
      });
    },
    getStatusNameOfTab: function getStatusNameOfTab() {
      var tabIdCompanyStatus = this.provider[this.activeTab()].idCompanyDataStatus;
      this.statusType = this.types[tabIdCompanyStatus - 1];
      return this.getStatusName(tabIdCompanyStatus);
    },
    getStatusName: function getStatusName(idCompanyDataStatus) {
      return this.statusList.find(function (el) {
        return el.idCompanyDataStatus === idCompanyDataStatus;
      }).description;
    },
    activeTab: function activeTab() {
      return this.steps[this.step];
    },
    handleCloseCompanyDataRejection: function handleCloseCompanyDataRejection() {
      this.newObservation = '';
    },
    reSendCompanyData: function reSendCompanyData() {
      var _this14 = this;

      var valido = this.validateFormFromStep();
      if (!valido) {
        return;
      }
      this.setCurrentTimeStamp();
      console.log(this.timeStampModifDate);
      this.$confirm('¿Está seguro que desea aceptar los datos?', 'Advertencia', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(function () {
        _this14.provider['generalData'] = _this14.generalData;
        _this14.provider['taxData'] = _this14.taxData;
        _this14.provider['paymentData'] = _this14.paymentData;
        console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this14.generalData.company));
        console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this14.provider));
        console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this14.activeTab()));
        _this14.provider[_this14.activeTab()].idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION;
        _this14.provider.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION;
        _this14.provider[_this14.activeTab()].modifDate = _this14.timeStampModifDate;
        _this14.$store.state.userReturned = true;
        _this14.updateCompanyData(_this14.activeTab(), _this14.provider[_this14.activeTab()]);
        console.log(_this14.$store.state.userReturned + '_ OK');
      }).catch(function () {
        _this14.$store.commit('TOGGLE_LOADING');
      });
    },
    companyData: function companyData() {
      var _this15 = this;

      if (this.idCompany) {
        __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/generic/companyCountriesStatus' + '?condition=idCompany=' + this.idCompany).then(function (response) {
          var data = response.data;
          if (data.error) {
            return;
          }
          if (data) {
            _this15.providers = data;
            _this15.provider = _this15.providers[0];
            _this15.disabledGeneralData();
          }
        }).catch(function (error) {
          _this15.$store.commit('TOGGLE_LOADING');
          console.log(error);
        });
      }
    },
    setCurrentTimeStamp: function setCurrentTimeStamp() {
      var d = new Date();
      var currDate = d.getDate();
      var currMonth = d.getMonth() + 1;
      var currYear = d.getFullYear();
      var currHour = d.getHours();
      var currMinutes = d.getMinutes();
      var currSeconds = d.getSeconds();
      this.timeStampModifDate = '' + currYear + '-' + (currMonth <= 9 ? '0' + currMonth : currMonth) + '-' + (currDate <= 9 ? '0' + currDate : currDate) + ' ' + (currHour <= 9 ? '0' + currHour : currHour) + ':' + (currMinutes <= 9 ? '0' + currMinutes : currMinutes) + ':' + (currSeconds <= 9 ? '0' + currSeconds : currSeconds);
    },
    checkRoles: function checkRoles(currentStep) {
      var permission = false;
      this.user.roles.forEach(function (role) {
        switch (role.rolesId) {
          case __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DG:
            if (currentStep === 0) {
              permission = true;
            }
            break;
          case __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DI:
            if (currentStep === 2) {
              permission = true;
            }
            break;
          case __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DP:
            if (currentStep === 1) {
              permission = true;
            }
            break;
          case __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].ADMIN_SISTEMA:
            permission = true;
            break;
          default:
            break;
        }
      });
      return permission;
    },
    acceptCompanyData: function acceptCompanyData() {
      var _this16 = this;

      var solicitud = true;
      if (this.provider.idStage === '3') {
        solicitud = false;
      }
      var permission = this.checkRoles(this.step);
      if (!permission) {
        console.log('Permision es :' + permission);
        this.$router.push('/newProviders');
        this.$alert('No tiene los permisos requeridos para realizar esta accion', 'Permisos Insuficientes', {
          confirmButtonText: 'Aceptar',
          callback: function callback(action) {
            _this16.$router.push('/newProviders');
          }
        });
        return;
      }

      this.$confirm('¿Está seguro que desea aceptar los datos?', 'Advertencia', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(function () {
        _this16.provider[_this16.activeTab()] = _this16[_this16.activeTab()];
        _this16.provider[_this16.activeTab()].idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ACEPTADO;
        _this16.provider[_this16.activeTab()].idUser = _this16.user.idUser;
        _this16.provider.signUpStatus++;
        _this16.updateCompanyData(_this16.activeTab(), _this16.provider[_this16.activeTab()]);
        if (solicitud) {
          _this16.solicitudActivarUsuario();
        }
        _this16.$parent.getProviders();
        if (!_this16.checkRoles(_this16.step + 1)) {
          _this16.$router.push('/newProviders');
        }
      }).catch(function () {});
    },
    verifyPermission: function verifyPermission() {
      var _this17 = this;

      var permission = this.checkRoles(this.step);
      if (!permission) {
        this.$router.push('/newProviders');
        this.$alert('No tiene los permisos requeridos para realizar esta accion', 'Permisos Insuficientes', {
          confirmButtonText: 'Aceptar',
          callback: function callback(action) {
            _this17.$router.push('/newProviders');
          }
        });
        return;
      }
      this.rejectCompanyDataVisible = true;
    },
    getProvinces: function getProvinces() {
      var _this18 = this;

      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/generic/province').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this18.provinces = data;
        }
      }).catch(function (error) {
        _this18.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getCentrales: function getCentrales() {
      var _this19 = this;

      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/generic/central').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          console.log(data);
          _this19.centrales = data;
        }
      });
    },
    getRetentionCategories: function getRetentionCategories() {
      var _this20 = this;

      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/generic/categoryRetain').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this20.retentionCategories2 = data;
        }
      }).catch(function (error) {
        _this20.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getRetentionCategoriesVAT: function getRetentionCategoriesVAT() {
      var _this21 = this;

      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/generic/categoryRetainVAT').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this21.ivaRetentionCategories = data;
        }
      }).catch(function (error) {
        _this21.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getRetentionCategoriesOTROS: function getRetentionCategoriesOTROS() {
      var _this22 = this;

      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/generic/categoryRetainOTROS').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this22.otrosRetentionCategories = data.filter(function (category) {
            return category.codCountry === 'AR';
          });
        }
      }).catch(function (error) {
        _this22.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getIbRetentionCategories: function getIbRetentionCategories() {
      var _this23 = this;

      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/generic/ibCategoryRetain').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this23.retentionCategoriesAliquot = data;
        }
      }).catch(function (error) {
        _this23.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    rejectCompanyData: function rejectCompanyData() {
      var _this24 = this;

      if (this.newObservation === '') {
        this.$message.warning('Falta completar el motivo');
        return;
      }
      this.$confirm('¿Está seguro que desea rechazar los datos por este motivo?', 'Advertencia', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(function () {
        _this24.provider[_this24.activeTab()] = _this24[_this24.activeTab()];
        _this24.provider[_this24.activeTab()].idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].DEVUELTO;
        _this24.provider[_this24.activeTab()].idUser = _this24.user.idUser;
        _this24.provider[_this24.activeTab()].observation = _this24.newObservation;
        _this24.updateCompanyData(_this24.activeTab(), _this24.provider[_this24.activeTab()]);
        _this24.$router.push('/newProviders');
      }).catch(function () {});
    },
    isSystemAdmin: function isSystemAdmin() {
      var _this25 = this;

      if (this.user) {
        this.user.roles.forEach(function (role) {
          if (role.rolesId === __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].ADMIN_SISTEMA) {
            _this25.userIsAdmin = true;
          }
          if (role.rolesId === __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DG || role.rolesId === __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DI || role.rolesId === __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DP) {
            _this25.userByRoles = true;
          }
        });
      }
    },
    providerUpdateData: function providerUpdateData() {
      this.provider[this.activeTab()] = this[this.activeTab()];
      this.provider[this.activeTab()].idUser = this.user.idUser;
      this.provider[this.activeTab()].idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION;
      this.setCurrentTimeStamp();
      this.provider[this.activeTab()].modifDate = this.timeStampModifDate;
      this.provider.idCompanyStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION;
      this.provider.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].MODIFICADO;
      this.provider.isExport = '0';
      this.updateCompanyData(this.activeTab(), this.provider[this.activeTab()]);
    },
    activationOrReject: function activationOrReject() {
      var _this26 = this;

      var genD = this.provider.generalData.idCompanyDataStatus;
      var payD = this.provider.paymentData.idCompanyDataStatus;
      var taxD = this.provider.taxData.idCompanyDataStatus;

      if (genD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ACEPTADO && payD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ACEPTADO && taxD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ACEPTADO) {
        this.provider.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ACEPTADO;
        this.provider.idCompanyStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ACEPTADO;
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/sendMailUserActivation/' + _this26.provider.idCompany).then(function () {});
        }, 900);
      } else {
        if (genD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].DEVUELTO || payD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].DEVUELTO || taxD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].DEVUELTO) {
          this.provider.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].DEVUELTO;
          this.provider.idCompanyStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].RECHAZADO;
          setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/sendMailUserReject/' + _this26.provider.idCompany).then(function () {});
          }, 900);
        }
      }
    },
    updateCompanyData: function updateCompanyData(dataType, data) {
      var _this27 = this;

      var genD = this.provider.generalData.idCompanyDataStatus;
      var payD = this.provider.paymentData.idCompanyDataStatus;
      var taxD = this.provider.taxData.idCompanyDataStatus;
      this.activationOrReject();

      if (genD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION) {
        this.provider.idStage = __WEBPACK_IMPORTED_MODULE_9__config_company_stage__["a" /* default */].DATOS_GENERALES;
      } else if (payD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION) {
        this.provider.idStage = __WEBPACK_IMPORTED_MODULE_9__config_company_stage__["a" /* default */].DATOS_BANCARIOS;
      } else if (taxD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION) {
        this.provider.idStage = __WEBPACK_IMPORTED_MODULE_9__config_company_stage__["a" /* default */].DATOS_IMPOSITIVOS;
      }

      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', 'api/generic/company/' + this.provider.idCompany, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.provider)).then(function () {
        var idCompanyData = void 0;
        switch (dataType) {
          case 'generalData':
            idCompanyData = data.idGeneralData;
            break;
          case 'paymentData':
            idCompanyData = data.idPaymentData;
            break;
          case 'taxData':
            idCompanyData = data.idTaxData;
            break;
        }
        _this27.$store.commit('START_LOADING');
        __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', 'api/generic/' + dataType + '/' + idCompanyData, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data)).then(function (response) {
          switch (dataType) {
            case 'generalData':
              _this27.provider.cuit = _this27.generalData.cuit;
              _this27.provider.company = _this27.generalData.company;
              _this27.provider.companyName = _this27.generalData.companyName;
              __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', 'api/generic/company/' + _this27.provider.idCompany, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this27.provider)).then(function () {
                __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/deleteRubrosFromCompany/' + _this27.provider.idCompany).then(function (response) {
                  _this27.generalData.rubros.forEach(function (item, index) {
                    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', 'api/generic/rubrosCompany/', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                      idRubro: item,
                      idCompany: _this27.provider.idCompany
                    }));
                  });
                });
              });
              break;
            case 'taxData':
              _this27.taxData.jurisdictions.forEach(function (item) {
                __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', 'api/generic/companyJurisdictionData/' + item.idCompanyJurisdictionData, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(item));
              });
              break;
          }
          _this27.rejectCompanyDataVisible = false;
          _this27.newObservation = '';
          _this27.$store.commit('STOP_LOADING');
          _this27.provider[dataType] = response.data;

          _this27.user.roles.forEach(function (role) {
            if (role.rolesId === __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DG && _this27.step === 0) {
              _this27.$router.push('/newProviders');
            }
            if (role.rolesId === __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DI && _this27.step === 1) {
              _this27.$router.push('/newProviders');
            }
            if (role.rolesId === __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DP && _this27.step === 2) {
              _this27.$router.push('/newProviders');
            }
          });

          _this27.$message.success('Estado cambiado satisfactoriamente');
        }).catch(function (error) {
          console.log(error);
          _this27.$store.commit('STOP_LOADING');
          _this27.$message.danger('Error al cambiar el estado');
        });
      });
    },
    isSantaFe: function isSantaFe(idJurisdiction) {
      var jurisdiction = this.jurisdictions.find(function (prov) {
        return prov.idJurisdictions === idJurisdiction;
      });
      if (jurisdiction) {
        return jurisdiction.jurisdictions === 'Santa Fe';
      }
      return false;
    },
    addDoc1276: function addDoc1276(idJurisdiction) {
      if (this.taxData.ibType === 'Local') {
        if (idJurisdiction === '13') {
          this.doc1276 = true;
        } else {
          this.doc1276 = false;
        }
      }
      if (this.taxData.ibType === 'Multilateral') {
        if (idJurisdiction === '13') {
          this.doc1276 = true;
        }
      }
    },
    coefficientValidate: function coefficientValidate(rule, value, callback) {
      if (!(value && Math.floor(value) <= 9 && value.toString().length === 6)) {
        callback(new Error());
      }
      callback();
    },
    aliquotValidate: function aliquotValidate(rule, value, callback) {
      if (!value) {
        callback();
      }
      if (!(value && Math.floor(value) <= 9 && value.toString().length === 4)) {
        callback(new Error());
      }
    },
    openModalTerminosYCond: function openModalTerminosYCond() {
      var valido = this.validateFormFromStep();
      if (valido) {
        this.terminosYCondVisible = true;
      }
    },
    openModalCertificateDetails: function openModalCertificateDetails(index) {
      this.activeJurisdiction = index;
      this.showModalCertificationDatosAdicionales = true;
    },
    openModalForm1276: function openModalForm1276(index) {
      this.activeJurisdiction = index;
      this.activeJurisdictionSantaFe = index;
      this.showModalForm1276 = true;
    },
    openModalRetentionAgent: function openModalRetentionAgent(index) {
      this.activeJurisdiction = index;
      this.taxData.jurisdictions[index].retentionAgentVisible = this.taxData.jurisdictions[index].retentionAgentHas === '1';
    },
    openModalPerceptionAgent: function openModalPerceptionAgent(index) {
      this.activeJurisdiction = index;
      this.taxData.jurisdictions[index].perceptionAgentVisible = this.taxData.jurisdictions[index].perceptionAgentHas === '1';
    },
    handleIbType: function handleIbType() {
      if (this.taxData.ibType === 'Multilateral' && this.taxData.jurisdictions.length === 1) {
        this.addJurisdiction();
      } else if (this.taxData.jurisdictions.length === 2) {
        this.deleteJurisdiction(this.taxData.jurisdictions[1]);
      }
    },
    addJurisdiction: function addJurisdiction() {
      this.taxData.jurisdictions.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.jurisdictionData));
      this.saveJurisdiction();
    },
    saveJurisdiction: function saveJurisdiction() {
      this.saveDataToLocalStorage(this.taxData.jurisdictions, 'jurisdictionsArray');
      this.saveDataToLocalStorage(this.taxData.jurisdictions.length, 'jurisdictionLength');
    },
    deleteJurisdiction: function deleteJurisdiction(item) {
      var index = this.taxData.jurisdictions.indexOf(item);
      if (index !== -1) {
        this.taxData.jurisdictions.splice(index, 1);
      }
      this.saveJurisdiction();
    },
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning('Solo se permite un archivo');
    },
    nextStep: function nextStep() {
      var valido = false;
      if (this.step === 2) {
        this.verifySantaFeJurisdiction();
        this.coeficienteValidacionTest();

        valido = this.validateFormFromStep();
        if (valido) {
          if (this.form1276loaded === true) {
            var that = this;
            this.$refs['taxDataForm'].validate(function (valid) {
              if (valid) {
                that.step++;
                that.disabledGeneralData();
              }
            });
          } else {
            this.step = 2;
            if (this.form1276loaded === false) {
              this.notify('Formulario 1276 obligatorio');
            }
            this.form1276loadedAux = true;
          }
        }
      } else {
        valido = this.validateFormFromStep();
        if (valido) {
          this.step++;
          this.disabledGeneralData();
        }
      }
      this.calculateHabModificaPdf();
    },
    previousStep: function previousStep() {
      this.step--;
      if (this.step === 2) {
        this.jurisdicciones = true;
      }
      this.disabledGeneralData();
      this.calculateHabModificaPdf();
    },
    previousStepView: function previousStepView() {
      this.step--;
    },
    nextStepView: function nextStepView() {
      this.step++;
    },
    validacionGeneralDataForm: function validacionGeneralDataForm() {
      if (!this.generalData.pdfAfip) {
        this.notify('Comprobante alta de AFIP es Obligatorio');
        return false;
      }
      return true;
    },
    validacionBanklDataForm: function validacionBanklDataForm() {
      if (!this.paymentData.pdfBank) {
        this.notify('Pdf de Constancia es Obligatorio');
        return false;
      }
      return true;
    },
    validacionTaxDataForm: function validacionTaxDataForm() {
      var _this28 = this;

      this.$refs['taxDataForm'].validate();
      var onlyNumbersRegex = /^[0-9]+$/;
      var jurisdictionFlag = false;
      if (!this.taxData.pdfIb) {
        this.notify('Formulario Constancia Ingresos Brutos Obligatorio');
        return false;
      } else if (this.taxData.ibType === 'Multilateral') {
        if (!this.taxData.idAgreementRegimeType) {
          this.notify('Se debe seleccionar un Regimen de Convenio de IIBB');
          return false;
        }
        if (!this.taxData.pdfCM05) {
          this.notify('Formulario CM05 Obligatorio');
          return false;
        }
        if (!this.taxData.jurisdictionHeadquarters) {
          this.notify('Debe seleccionar jurisdicción sede');
          return false;
        }
      } else if (this.taxData.ibType === 'Local') {
        if (!this.taxData.jurisdictionHeadquarters) {
          this.notify('Debe seleccionar jurisdicción sede');
          return false;
        }
      } else if (this.taxData.ibType === 'Exento') {
        if (!this.taxData.pdfsExempt || this.taxData.pdfsExempt === '') {
          this.notify('Formulario Contancia de Exento de IIBB es Obligatorio');
          return false;
        }
      } else if (!this.taxData.ibType) {
        this.notify('Se debe seleccionar un tipo de convenio de IIBB');
        return false;
      }
      if (!this.taxData.jurisdictions || !this.taxData.jurisdictions[0].aliquot && !this.taxData.jurisdictions[0].aliquota_value || !this.taxData.jurisdictions[0].coefficient) {
        this.notify('Faltan completar datos de jurisdicción de IIBB');
        return false;
      }
      this.taxData.jurisdictions.forEach(function (jurisdiction) {
        if (jurisdiction.idJurisdiction !== '') {
          if (!jurisdiction.coefficient) {
            _this28.notify('Falta completar Coef. Unificado');
            jurisdictionFlag = true;
            return;
          }
          if (!_this28.decimalCoefficient(jurisdiction.coefficient)) {
            _this28.notify('Coef. Unificado debe ser un número decimal');
            jurisdictionFlag = true;
            return;
          }
          if (jurisdiction.coefficient.length > 19) {
            _this28.notify('Coef. Unificado debe de ser menor a 20 digitos');
            jurisdictionFlag = true;
            return;
          }
          if (jurisdiction.certificateNumber !== '' && jurisdiction.certificateNumber !== null) {
            if (jurisdiction.certificateNumber.length > 0) {
              if (jurisdiction.certificateNumber.length > 19) {
                _this28.notify('N° de Certificado debe de ser menor a 20 digitos');
                jurisdictionFlag = true;
                return;
              }
              if (!onlyNumbersRegex.test(jurisdiction.certificateNumber)) {
                _this28.notify('N° de Certificado debe de contener solo valores númericos');
                jurisdictionFlag = true;
                return;
              }
            }
          }
          if (jurisdiction.certificateNumber === '') {
            jurisdiction.certificateNumber = null;
          }
          if (jurisdiction.idJurisdiction === '') {
            jurisdictionFlag = false;
            return;
          }
        }
      });
      if (jurisdictionFlag) {
        return false;
      }

      if (!this.taxData.jurisdictionHeadquarters) {
        this.notify('Se debe seleccionar una Jurisdicción Sede de IIBB');
        return false;
      }

      if (!this.taxData.earningsRetentionType) {
        this.notify('Se debe seleccionar el tipo de Retención de Ganancias');
        return false;
      }

      if (this.taxData.ivaExclusionPdf !== '') {
        if (this.taxData.ivaIdCategoryRetain === '') {
          this.notify('Se debe seleccionar la Categoría a Retener de IVA');
          return false;
        }
      }

      if (this.taxData.earningsRetentionType === 'Inscripto') {
        if (!this.taxData.retentionRegimen) {
          this.notify('Debe informar el Regimen de Retención de Ganancias');
          return false;
        }
        if (!this.taxData.idEarningCategoryRetain) {
          this.notify('Debe informar la Categoría a Retener de Ganancias');
          return false;
        }
      }
      return true;
    },
    validateFormFromStep: function validateFormFromStep() {
      var formName = void 0;
      switch (this.step) {
        case 0:
          formName = 'generalDataForm';
          break;
        case 1:
          formName = 'paymentDataForm';
          break;
        case 2:
          formName = 'taxDataForm';
          break;
        case 3:
          formName = 'userDataForm';
          break;
      }
      var respuesta = void 0;
      respuesta = this.validateForm(formName);
      if (respuesta) {
        if (formName === 'generalDataForm') {
          respuesta = this.validacionGeneralDataForm();
        } else if (formName === 'paymentDataForm') {
          respuesta = this.validacionBanklDataForm();
        } else if (formName === 'taxDataForm') {
          respuesta = this.validacionTaxDataForm();
        }
      }
      return respuesta;
    },
    updateProvinces: function updateProvinces(idCountry) {
      this.provinces = this.$store.state.provinces.filter(function (prov) {
        return prov.idCountry === idCountry;
      }).sort(function (a, b) {
        return a.province > b.province;
      });
    },
    updateRetentionCategory: function updateRetentionCategory(idRetention) {
      var temporal = this.$store.state.retentionCategories.filter(function (ret) {
        return ret.idRetentionRegime === idRetention;
      }).sort(function (a, b) {
        return a.categoryRetain > b.categoryRetain;
      });
      this.retentionCategories2 = temporal;
    },
    updateAliquot: function updateAliquot(idJurisdiction) {
      this.retentionCategoriesAliquot = this.$store.state.ibRetentionCategory.filter(function (ret) {
        return ret.idJurisdictions === idJurisdiction;
      }).sort(function (a, b) {
        return a.categoryRetain > b.categoryRetain;
      });

      if (idJurisdiction === '13') {
        this.doc1276 = true;
      } else {
        this.doc1276 = false;
      }
    },
    updateIvaRetentionCategory: function updateIvaRetentionCategory(idRetention) {
      this.ivaRetentionCategories = this.$store.state.retentionCategoriesVAT.filter(function (ret) {
        return ret.idRetentionRegime === idRetention;
      }).sort(function (a, b) {
        return a.categoryRetain > b.categoryRetain;
      });
    },
    updateOtrosRetentionCategory: function updateOtrosRetentionCategory(idRetention) {
      this.otrosRetentionCategories = this.$store.state.retentionCategoriesOTROS.filter(function (ret) {
        return ret.idRetentionRegime === idRetention;
      }).sort(function (a, b) {
        return a.categoryRetain > b.categoryRetain;
      });
    },
    handlePdfResolutionIva: function handlePdfResolutionIva(response, file, fileList) {
      this.taxData.ivaResolutionPdf = response;
    },
    handlePdfExclusionIva: function handlePdfExclusionIva(response, file, fileList) {
      this.taxData.ivaExclusionPdf = response;
    },
    handlePdfExclusionSuss: function handlePdfExclusionSuss(response, file, fileList) {
      this.taxData.sussExclusionPdf = response;
    },
    handlePdfExclusionEarnings: function handlePdfExclusionEarnings(response, file, fileList) {
      this.taxData.earningsExclusionPdf = response;
    },
    handlePdfCertificate: function handlePdfCertificate(response, file, fileList) {
      this.taxData.jurisdictions[this.activeJurisdiction].certificatePdf = response;
    },
    handlePdfRetentionAgent: function handlePdfRetentionAgent(response, file, fileList) {
      this.taxData.jurisdictions[this.activeJurisdiction].retentionAgentPdf = response;
    },
    handlePdfForm1276: function handlePdfForm1276(response, file, fileList) {
      this.taxData.jurisdictions[this.activeJurisdiction].form1276pdf = response;
    },
    handlePdfPerceptionAgent: function handlePdfPerceptionAgent(response, file, fileList) {
      this.taxData.jurisdictions[this.activeJurisdiction].perceptionAgentPdf = response;
    },
    validateForm: function validateForm(formName) {
      var that = this;
      var validated = true;
      if (that.$refs[formName]) {
        that.$refs[formName].validate(function (valid) {
          if (!valid) {
            validated = valid;
          }
        });
      } else {
        validated = false;
      }
      return validated;
    },
    editCuit: function editCuit() {
      this.dataAfip = '';
    },
    nextPage: function nextPage() {
      this.step++;
    },
    submitFormSolicitud: function submitFormSolicitud() {
      this.removeDataFromLocalStorage();
      this.solicitudActivarUsuario('1');
      if (this.checked2 === true && this.checked === true) {
        this.terminosYCondVisible = false;
        this.checkData();
      } else {
        this.checked2 = false;
        this.checked = false;
        this.terminosYCondVisible = true;
      }
    },
    clearInput: function clearInput(vueModel) {
      vueModel = '';
    },
    verifyCuit: function verifyCuit() {
      var _this29 = this;

      var cachedData = JSON.parse(localStorage.getItem('newProvider'));
      this.$refs['generalDataForm'].validateField('cuit', function (valid) {
        if (!valid) {
          _this29.$store.commit('START_LOADING');
          __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/getPersonaAfip/' + _this29.generalData.cuit).then(function (response) {
            if (typeof response.data === 'string') {
              _this29.dataAfip = '';
              _this29.$message({
                message: response.data.replace('Id', 'CUIT'),
                type: 'warning'
              });
            } else {
              if (!response.data.errorConstancia) {
                _this29.dataAfip = response.data.datosGenerales;
                if (_this29.dataAfip.tipoPersona === 'JURIDICA') {
                  _this29.generalData.company = _this29.dataAfip.razonSocial;
                } else if (!cachedData.company) {
                  _this29.generalData.company = (_this29.dataAfip.nombre ? _this29.dataAfip.nombre + ' ' : '') + _this29.dataAfip.apellido;
                }
                __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/allCertification/' + _this29.generalData.cuit).then(function (response) {
                  if (response.data['exgainCertification'].length === 0) {
                    _this29.auxFlagEmptyExgainList = true;
                  }
                  _this29.certificationExgainList = response.data['exgainCertification'];

                  _this29.certificationSussList = response.data['sussCertification'];
                  _this29.certificationRg18List = response.data['rg18Certification'];
                  _this29.certificationRg17List = response.data['rg17Certification'];
                  _this29.certificationRg2681List = response.data['rg2681Certification'];
                });
                _this29.$message({
                  message: 'CUIT verificado correctamente en AFIP',
                  type: 'success'
                });
              } else {
                var mensaje = '';
                if (typeof response.data.errorConstancia.error === 'string') {
                  mensaje = response.data.errorConstancia.error;
                } else {
                  mensaje = response.data.errorConstancia.error.join('\n');
                }
                _this29.$message({
                  message: 'Informa AFIP : \n' + mensaje,
                  type: 'error'
                });
              }
            }
            _this29.$store.commit('STOP_LOADING');
          }).catch(function (error) {
            console.log(error);
            _this29.$store.commit('STOP_LOADING');
          });
        }
      });
    },
    checkData: function checkData() {
      var _this30 = this;

      this.toggleLoading();
      this.resetResponse();
      this.$store.commit('TOGGLE_LOADING');

      var url = 'api/saveNewProvider';
      var url2 = '/login';
      if (this.user) {
        url = 'api/saveNewProviderRegister';
        url2 = '/providers';
      }
      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', url, {
        generalData: this.generalData,
        paymentData: this.paymentData,
        taxData: this.taxData,
        userData: this.userData,
        associatedPEP: this.associatedPEP,
        govInteraction: this.govInteraction
      }).then(function (response) {
        _this30.toggleLoading();
        var data = response.data;

        if (response.data.error) {
          var errorName = response.data.error.name;
          if (errorName) {
            console.log(errorName);
            _this30.checked = false;
            _this30.checked2 = false;
            if (errorName === 'InvalidArgumentError') {
              _this30.response = 'Los datos son incorrectos.';
            } else if (errorName === 'NotFoundError') {
              _this30.response = 'Se ha producido un error inesperado.';
            } else {
              _this30.response = errorName;
            }
          } else {
            _this30.response = data.error;
          }

          return;
        } else {
          if (data.success) {
            __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', 'api/sendSignUpMessage', {
              idEmisor: 1,
              idReceptor: response.data.idUser,
              message: 'Gracias por registrarse, Estamos revisando la información remitida',
              messageType: 1
            }).then(function (response) {});
            _this30.$alert('Sus datos se han remitido correctamente, muchas gracias!', 'Información Enviada', {
              confirmButtonText: 'Confirmar',
              callback: function callback(action) {
                _this30.$router.push(url2);
              }
            });
            _this30.success = data.success;
          }
        }
      }).catch(function (error) {
        _this30.$store.commit('TOGGLE_LOADING');
        _this30.invoices = null;
        console.log(error.response);
        _this30.response = 'Se ha producido un error, verifique los datos, en caso de persisitir, comuniquese con soporte.';
        if (error.response.data.error) {
          _this30.response = error.response.data.error;
        }
        _this30.toggleLoading();
      });
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'cargando' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
      this.success = '';
    },
    loadProvider: function loadProvider() {
      if (this.providerLoaded) {
        return;
      }
      this.providerLoaded = true;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.generalData, this.provider.generalData);
      this.generalData.cuit = parseInt(this.provider.cuit);
      this.generalData.company = this.provider.company;
      this.generalData.companyName = this.provider.companyName;
      this.generalData.rubros = this.provider.rubros.map(function (el) {
        return el.idRubro;
      });
      this.generalData.centrales = this.provider.centrales.map(function (el) {
        return el.idCentral;
      });
      this.updateProvinces(this.generalData.idCountry);
      this.updateRetentionCategory(this.provider.taxData.retentionRegimen);
      this.updateAliquot(this.provider.taxData.jurisdictions[0]['idJurisdiction']);

      this.updateIvaRetentionCategory(this.provider.taxData.ivaIdRetentionRegime);
      this.updateOtrosRetentionCategory(this.provider.taxData.otrosIdRetentionRegime);

      this.generalData.idProvince = this.provider.generalData.idProvince;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.paymentData, this.provider.paymentData);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.taxData, this.provider.taxData);
      this.dataAfip = 'a';

      if (!this.idStep) {
        this.step = parseInt(this.provider.idStage - 1);
      }
      for (var key in this.provider) {
        if (!this.provider.hasOwnProperty(key)) continue;

        var obj = this.provider[key];
        if (obj && obj.hasOwnProperty('idCompanyDataStatus')) {
          if (obj.idCompanyDataStatus !== __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ACEPTADO) {
            this.disabledGeneralData();
            return;
          }
        }
      }
    },
    checkProviderData: function checkProviderData() {
      if (this.provider && this.idCompany) {
        this.loadProvider();
      } else if (localStorage.getItem('jurisdictionsArraykey') === null) {
        this.addJurisdiction();
      }
    },
    solicitudActivarUsuario: function solicitudActivarUsuario() {
      var _this31 = this;

      var stage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var companyName = this.generalData.company;
      var idFiscal = this.generalData.cuit;

      if (!stage) {
        stage = this.provider.idStage;
      }
      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/solicitudActivarUsuario' + '?stage=' + stage + '&idFiscal=' + idFiscal + '&companyName=' + companyName).then(function (response) {
        _this31.toggleLoading();
      }).catch(function (error) {
        _this31.$store.commit('TOGGLE_LOADING');
        _this31.invoices = null;
        console.log(error);

        _this31.response = 'Error al conectarse con el servidor, contacte al administrador.';
        _this31.toggleLoading();
      });
    },
    saveDataToLocalStorage: function saveDataToLocalStorage(inputValue, inputName) {
      this.persistToNewProviderStorage(inputValue, inputName);
    },
    persistToNewProviderStorage: function persistToNewProviderStorage(inputValue, inputName) {
      var newProvider = JSON.parse(localStorage.getItem('newProvider'));
      if (!newProvider) {
        newProvider = {};
      }
      newProvider[inputName] = inputValue;
      localStorage.setItem('newProvider', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(newProvider));
    },
    recoverFromNewProviderStorage: function recoverFromNewProviderStorage() {
      var inputType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var inputId = arguments[1];

      var newProvider = JSON.parse(localStorage.getItem('newProvider'));
      if (newProvider) {
        var data = newProvider[inputId];
        if (data) {
          if (inputType) {
            inputType[inputId] = data;
          }
          return data;
        }
      }
      return {};
    },
    removeDataFromLocalStorage: function removeDataFromLocalStorage() {
      localStorage.removeItem('newProvider');
    },
    getJurisdictionsHabilitadas: function getJurisdictionsHabilitadas() {
      var _this32 = this;

      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/getEnabledJurisdictions').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          console.log('jurisdicciones habilitadas', data.data);
          _this32.jurisdictionsHabilitadas = data.data;
          console.log('store', _this32.$store.state.jurisdictions);
        }
      }).catch(function (error) {
        _this32.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    }
  },
  beforeMount: function beforeMount() {
    this.isSystemAdmin();
    this.companyData();
  },
  mounted: function mounted() {
    var _this33 = this;

    console.log(this.$store.state.jurisdictions);
    this.getJurisdictionsHabilitadas();
    this.getProvinces();
    this.getCentrales();
    this.getRetentionCategories();
    this.getRetentionCategoriesVAT();
    this.getRetentionCategoriesOTROS();
    this.getIbRetentionCategories();
    for (var key in this.generalData) {
      this.recoverFromNewProviderStorage(this.generalData, key);
    }
    for (var _key in this.paymentData) {
      this.recoverFromNewProviderStorage(this.paymentData, _key);
    }
    this.getRetentionCategories();
    for (var _key2 in this.taxData) {
      this.recoverFromNewProviderStorage(this.taxData, _key2);
    }
    for (var _key3 in this.userData) {
      this.recoverFromNewProviderStorage(this.userData, _key3);
    }
    this.jurisdictionsLength = this.recoverFromNewProviderStorage('', 'jurisdictionLength');
    this.jurArray = this.recoverFromNewProviderStorage('', 'jurisdictionsArray');
    for (var i = 0; i < this.jurisdictionsLength; i++) {
      this.taxData.jurisdictions.push(this.jurArray[i]);
    }
    if (this.user && this.user.isProvider && this.idCompany && this.idCompany !== this.user.company.idCompany) {
      this.$router.push('/');
    }
    this.checkProviderData();

    this.providerLoaded = false;
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('get', 'api/checkParam?id=AP-001').then(function (response) {
      var data = response.data;

      if (data.error) {
        if (!_this33.user) {
          _this33.paramError = data.error;
        }
      }
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('get', 'api/findConfiguration/TYC').then(function (response) {
      _this33.configuration = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('get', 'api/findConfiguration/CODETI').then(function (response) {
      _this33.codigoEtica = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('get', 'api/findConfiguration/POLANTI').then(function (response) {
      _this33.politicaAnticorrupcion = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('get', 'api/findConfiguration/POLREL').then(function (response) {
      _this33.politicaRelacionamiento = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('get', 'api/findConfiguration/EMAILSOPORTE').then(function (response) {
      _this33.emailSoporte = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('get', 'api/checkParam?id=SUF-001').then(function (response) {
      var data = response.data;

      if (data.error) {
        _this33.paramInvoices = data.error;
      }
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('get', 'api/checkParam?id=SUN-001').then(function (response) {
      var data = response.data;
      console.log('SUN-001', data);
      _this33.availableCountries = data;
      _this33.isLoading = false;
    }).catch(function (error) {
      console.log(error);
    });
    if (this.idStep) {
      this.step = parseInt(this.idStep);
    }
    this.disabledGeneralData();
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MySteps_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MySteps_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MySteps_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AltaID_vue__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AltaID_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AltaID_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AltaFormElements_vue__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AltaFormElements_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AltaFormElements_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_utils_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__404_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__404_vue__);












/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'steps-pagination': __WEBPACK_IMPORTED_MODULE_4__MySteps_vue___default.a,
    'alta-id': __WEBPACK_IMPORTED_MODULE_5__AltaID_vue___default.a,
    'alta-form': __WEBPACK_IMPORTED_MODULE_6__AltaFormElements_vue___default.a,
    error404: __WEBPACK_IMPORTED_MODULE_9__404_vue___default.a
  },
  data: function data() {
    return {
      idType: 'RUC',
      countryId: 256,
      response: null,
      success: null,
      loading: '',
      savedGeneralData: '',
      savedPaymentData: '',
      savedTaxData: '',
      savedUserData: '',
      codCountry: 'PE',
      id: { model: '', dataType: 'ID' },
      emailSoporte: 'soporte@albanesi.com.ar',
      step: 0,
      optionalPaymentFlag: { model: false, dataType: 'flag' },
      nextStepFlag: true,
      idStatus: 'accept',
      validateRuc: false,
      emptyFields: [],
      showTerminosYCondiciones: false,
      codigoEtica: '',
      politicaAnticorrupcion: '',
      politicaRelacionamiento: '',
      checked: false,
      checked2: false,
      locations: [],
      banks: [],
      bankAccountTypes: [],
      denominaciones: [],
      availableCountries: [],
      generalData: {
        company: {
          name: 'company',
          dataType: 'input',
          label: 'Razón Social / Denominación*',
          model: '',
          required: true
        },
        companyName: {
          name: 'companyName',
          dataType: 'input',
          label: 'Nombre comercial',
          model: '',
          required: false
        },
        activityField: {
          name: 'activityField',
          dataType: 'select',
          label: 'Campo de Actividad*',
          model: '',
          optionValue: [],
          placeholder: 'Seleccionar el Campo de actividad',
          required: true
        },
        country: {
          name: 'country',
          dataType: 'select',
          label: 'País*',
          model: 'Perú',
          optionValue: ['Perú'],
          placeholder: 'Seleccionar País',
          required: true
        },
        location: {
          name: 'location',
          dataType: 'select',
          label: 'Localidad*',
          model: '',
          optionValue: [],
          placeholder: 'Seleccionar Localidad',
          required: true
        },
        city: {
          name: 'city',
          dataType: 'input',
          label: 'Ciudad*',
          model: '',
          required: true
        },
        address: {
          name: 'address',
          name2: 'addressNumber',
          dataType: 'input-double',
          label: 'Calle*',
          label2: 'N°',
          model: '',
          model2: '',
          required: true
        },
        zip: {
          name: 'zip',
          dataType: 'input',
          label: 'Código Postal*',
          type: 'number',
          model: '',
          required: true
        },
        phone: {
          name: 'phone',
          dataType: 'input',
          label: 'Telefono*',
          type: 'number',
          model: '',
          required: true
        },
        email: {
          name: 'email',
          dataType: 'input',
          label: 'Email*',
          type: 'email',
          validate: 'email',
          model: '',
          required: true
        },
        pdfRuc: {
          name: 'pdfRuc',
          dataType: 'upload',
          label: 'Constancia de inscripcion RUC - Ficha RUC*',
          model: '',
          required: true
        }
      },
      paymentData1: {
        pdfPayment: {
          name: 'pdfPayment',
          dataType: 'upload',
          label: 'Instrucciones para acreditación de pagos*',
          model: '',
          required: true },
        bank: {
          name: 'bank',
          dataType: 'select',
          label: 'Banco*',
          model: '',
          optionValue: [],
          placeholder: 'Seleccionar Banco',
          required: true
        },
        bankAccount: {
          name: 'bankAccount',
          dataType: 'input',
          label: 'Nro de Cuenta*',
          validate: 'onlyNumbers',
          max: 11,
          model: '',
          required: true
        },
        accountType: {
          name: 'accountType',
          dataType: 'select',
          label: 'Tipo*',
          model: '',
          optionValue: '',
          placeholder: 'Seleccionar Tipo',
          required: true
        },
        currency: {
          name: 'currency',
          dataType: 'select',
          label: 'Moneda*',
          model: 'PEN',
          optionValue: ['PEN'],
          placeholder: 'Seleccionar Moneda',
          required: true
        },
        cciNumber: {
          name: 'cciNumber',
          dataType: 'input',
          label: 'Nro CCI*',
          max: 20,
          model: '',
          validate: 'onlyNumbers',
          required: true
        }
      },
      paymentData2: {
        bank2: {
          name: 'bank2',
          dataType: 'select',
          label: 'Banco',
          model: '',
          optionValue: [],
          placeholder: 'Seleccionar Banco',
          required: true
        },
        bankAccount2: {
          name: 'bankAccount2',
          dataType: 'input',
          label: 'Nro de Cuenta',
          max: 11,
          validate: 'onlyNumbers',
          model: '',
          required: true
        },
        accountType2: {
          name: 'accountType2',
          dataType: 'select',
          label: 'Tipo',
          model: '',
          optionValue: '',
          placeholder: 'Seleccionar Tipo',
          required: true
        },
        currency2: {
          name: 'currency2',
          dataType: 'select',
          label: 'Moneda',
          model: '',
          optionValue: ['PEN'],
          placeholder: 'Seleccionar Moneda',
          required: true
        },
        cciNumber2: {
          name: 'cciNumber2',
          dataType: 'input',
          label: 'Nro CCI',
          validate: 'onlyNumbers',
          max: 20,
          model: '',
          required: true
        }
      },
      paymentData3: {
        detractionBank: {
          name: 'detractionBank',
          dataType: 'input',
          label: 'Nro de Cuenta del Banco Nación*',
          max: 11,
          validate: 'onlyNumbers',
          model: '',
          required: true
        }
      },
      companyTaxData: {
        register: {
          name: 'register',
          dataType: 'input',
          label: 'Partida Registral',
          model: '',
          required: true
        },
        paymentType: {
          name: 'paymentType',
          dataType: 'select',
          label: 'Tipo de comprobantes a emitir',
          model: '',
          optionValue: [],
          placeholder: 'Seleccionar el tipo de comprobante',
          required: true
        },
        perceptionSwitch: {
          name: 'perceptionSwitch',
          dataType: 'switch-perception',
          label: 'Su empresa es agente de percepción?',
          model: false,
          companyDataPerception: {
            name: 'companyDataPerception',
            label: 'Alícuota*',
            model: '',
            required: true
          }
        },
        retentionSwitch: {
          name: 'retentionSwitch',
          dataType: 'switch-retention',
          label: 'Su empresa es agente de retención?',
          model: false,
          companyDataRetention: {
            name: 'companyDataRetention',
            label: 'Denominación*',
            model: '',
            optionValue: [],
            placeholder: 'Seleccionar el tipo de Denominación',
            required: true
          },
          companyRetentionFields: {
            name: 'companyRetentionFields',
            label: 'Alícuota*',
            model: '',
            placeholder: 'Seleccionar alicuota',
            required: true
          },
          companySuspensionNumber: {
            name: 'companySuspensionNumber',
            label: 'Número*',
            model: '',
            type: 'number',
            required: true
          },
          firstDate: {
            name: 'firstDate',
            model: '',
            required: true
          },
          lastDate: {
            name: 'lastDate',
            model: '',
            required: true
          },
          pdfSuspension: {
            name: 'pdfSuspension',
            model: '',
            label: 'Certificado de suspensión*',
            required: true
          }
        },
        detractionSwitch: {
          name: 'detractionSwitch',
          dataType: 'switch-detraction',
          label: 'Su empresa realiza actividades sujetas a detracción?',
          model: false
        }
      },
      userData: {
        userName: {
          name: 'name',
          dataType: 'input',
          label: 'Nombre y apellido',
          model: '',
          required: true
        },
        email: {
          name: 'email',
          dataType: 'input',
          label: 'Email',
          validate: 'email',
          model: '',
          required: true
        },
        password: {
          name: 'password',
          dataType: 'input',
          label: 'Contraseña',
          type: 'password',
          validate: 'password',
          model: '',
          required: true
        },
        repeatedPassword: {
          dataType: 'input',
          label: 'Repetir Contraseña',
          type: 'password',
          model: '',
          validate: 'repeated-password',
          samePassword: false,
          required: true
        }
      }
    };
  },

  methods: {
    persistToNewProviderStorage: __WEBPACK_IMPORTED_MODULE_7__helpers_utils_js__["a" /* persistToNewProviderStorage */],
    saveDataToLocalStorage: __WEBPACK_IMPORTED_MODULE_7__helpers_utils_js__["b" /* saveDataToLocalStorage */],
    validateSteps: function validateSteps() {
      this.emptyFields = [];
      if (this.nextStepFlag === false && this.step === 0) {
        this.validateData(this.generalData);
      }
      if (this.nextStepFlag === false && this.step === 1) {
        this.validateCompanyTaxData();
        this.validateData(this.companyTaxData);
      }
      if (this.nextStepFlag === false && this.step === 2) {
        this.validateData(this.paymentData1);
        if (this.optionalPaymentFlag.model) {
          this.validateData(this.paymentData2);
        }
        if (this.companyTaxData.detractionSwitch.model) {
          this.validateData(this.paymentData3);
        }
      }
      if (this.step === 3) {
        this.validateData(this.userData);
      }
      console.log(this.emptyFields);
    },
    nextStep: function nextStep() {
      this.nextStepFlag = false;
      this.validateSteps();
      if (this.nextStepFlag === false) {
        return;
      }
      if (this.step++ >= 3) {
        this.step = 0;
        this.validateRuc = false;
      }
    },
    backStep: function backStep() {
      this.nextStepFlag = false;
      var actualStep = this.step;
      this.step = actualStep - 1;
    },
    goBackPage: function goBackPage() {
      window.history.back();
    },
    validateIDHandler: function validateIDHandler(id) {
      this.id = id;
      if (id !== '' && this.idStatus === 'accept') {
        this.idStatus = 'edit';
        this.verifyRuc(id.model);
      } else if (this.idStatus === 'edit') {
        this.idStatus = 'accept';
        this.validateRuc = false;
      }
    },
    validateData: function validateData(stepData) {
      for (var key in stepData) {
        var data = stepData[key];

        this.validateEmail(data);

        this.validateNumbers(data);

        this.validatePasswords(data);

        if (data.required && (data.model === '' || data.model2 === '')) {
          this.emptyFields.push(data.label);
          this.nextStepFlag = false;
        }
      }
      if (this.emptyFields.length === 0 && this.step < 3) {
        this.nextStepFlag = true;
      }
    },
    validateEmail: function validateEmail(data) {
      if (data.validate === 'email') {
        var regex = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
        if (!regex.test(data.model)) {
          this.nextStepFlag = false;
          this.emptyFields.push(data.label);
        }
      }
    },
    validateNumbers: function validateNumbers(data) {
      if (data.validate === 'onlyNumbers') {
        var regex = /^[0-9]+$/;
        if (!regex.test(data.model) || data.model.length < data.max) {
          this.nextStepFlag = false;
          this.emptyFields.push(data.label);
        }
      }
    },
    validatePasswords: function validatePasswords(data) {
      if (data.validate === 'password' && data.model !== this.userData.repeatedPassword.model) {
        this.userData.repeatedPassword.samePassword = false;
        this.nextStepFlag = false;
        this.emptyFields.push(data.label);
      } else if (data.validate === 'password' && data.model === this.userData.repeatedPassword.model) {
        this.userData.repeatedPassword.samePassword = true;
      }
    },
    validateCompanyTaxData: function validateCompanyTaxData() {
      var _companyTaxData = this.companyTaxData,
          perceptionSwitch = _companyTaxData.perceptionSwitch,
          retentionSwitch = _companyTaxData.retentionSwitch;
      var companyDataRetention = retentionSwitch.companyDataRetention,
          companyRetentionFields = retentionSwitch.companyRetentionFields,
          firstDate = retentionSwitch.firstDate,
          lastDate = retentionSwitch.lastDate,
          pdfSuspension = retentionSwitch.pdfSuspension,
          companySuspensionNumber = retentionSwitch.companySuspensionNumber;

      if (perceptionSwitch.model && !perceptionSwitch.companyDataPerception.model) {
        this.emptyFields.push(perceptionSwitch.companyDataPerception.label);
        this.nextStepFlag = false;
      }
      if (retentionSwitch.model) {
        if (!companyDataRetention.model.length) {
          this.emptyFields.push(companyDataRetention.label);
          this.nextStepFlag = false;
        }
        if (!companyRetentionFields.model.length) {
          this.emptyFields.push(companyRetentionFields.label);
          this.nextStepFlag = false;
        }
        if (companyDataRetention.model.includes('Retencion Detracciones') && (!firstDate.model || !lastDate.model || !pdfSuspension.model || !companySuspensionNumber.model)) {
          this.emptyFields.push(companyDataRetention.label);
          this.nextStepFlag = false;
        }
      }
      if (!this.emptyFields.length) {
        this.nextStepFlag = true;
      }
    },
    recoverFromNewProviderStorage: function recoverFromNewProviderStorage() {
      var inputType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var inputId = arguments[1];

      var newProvider = JSON.parse(localStorage.getItem('newProviderPeru'));
      if (!newProvider) {
        return {};
      }
      var data = newProvider[inputId];
      if (!data) {
        return {};
      }
      if (inputType['dataType'] === 'ID' || inputType['dataType'] === 'flag') {
        inputType['model'] = data;
      }
      var input = inputType[inputId];
      if (!input) {
        return data;
      }
      var dataType = input.dataType;

      if (['input', 'select', 'upload', 'switch-detraction'].includes(dataType)) {
        input.model = data;
      }
      if (dataType === 'input-double') {
        input.model = data;
        input.model2 = data;
      }
      if (dataType === 'switch-perception') {
        input.model = data;
        input.companyDataPerception.model = newProvider.companyDataPerception;
      }
      if (dataType === 'switch-retention') {
        input.model = data;

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(input).forEach(function (value) {
          if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(value)) === 'object') {
            console.log(newProvider[value.name]);
            value.model = newProvider[value.name];
          }
        });
      }
      return data;
    },
    checkData: function checkData() {
      var _this = this;

      this.toggleLoading();
      this.resetResponse();
      this.manageDataObjects();
      this.$store.commit('TOGGLE_LOADING');

      var url = 'api/saveNewProvider';
      var url2 = '/login';
      if (this.user) {
        url = 'api/saveNewProviderRegister';
        url2 = '/providers';
      }
      __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].request('POST', url, {
        generalData: this.savedGeneralData,
        paymentData: this.savedPaymentData,
        taxData: this.savedTaxData,
        userData: this.savedUserData
      }).then(function (response) {
        _this.toggleLoading();
        var data = response.data;

        if (response.data.error) {
          var errorName = response.data.error.name;
          if (errorName) {
            console.log(errorName);
            _this.checked = false;
            _this.checked2 = false;
            if (errorName === 'InvalidArgumentError') {
              _this.response = 'Los datos son incorrectos.';
            } else if (errorName === 'NotFoundError') {
              _this.response = 'Se ha producido un error inesperado.';
            } else {
              _this.response = errorName;
            }
          } else {
            _this.response = data.error;
          }

          return;
        } else {
          if (data.success) {
            __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].request('POST', 'api/sendSignUpMessage', {
              idEmisor: 1,
              idReceptor: response.data.idUser,
              message: 'Gracias por registrarse, Estamos revisando la información remitida',
              messageType: 1
            }).then(function (response) {});
            _this.$alert('Sus datos se han remitido correctamente, muchas gracias!', 'Información Enviada', {
              confirmButtonText: 'Confirmar',
              callback: function callback(action) {
                _this.$router.push(url2);
              }
            });
            _this.success = data.success;
          }
        }
      }).catch(function (error) {
        _this.$store.commit('TOGGLE_LOADING');
        _this.invoices = null;
        console.log(error.response);
        _this.response = 'Se ha producido un error, verifique los datos, en caso de persisitir, comuniquese con soporte.';
        if (error.response.data) {
          var err = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(error.response.data)[0];
          _this.response = error.response.data[err][0];
        }
        console.log(_this.response);
        _this.toggleLoading();
      });
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'cargando' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
      this.success = '';
    },
    extractFieldValues: function extractFieldValues(data) {
      var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var extractedData = {};
      for (var key in data) {
        if (enabled) {
          if (data.hasOwnProperty(key)) {
            extractedData[data[key].name] = data[key].model;
          }
        }
        if (!enabled) {
          if (data.hasOwnProperty(key)) {
            extractedData[data[key].name] = '';
          }
        }
      }
      return extractedData;
    },
    manageDataObjects: function manageDataObjects() {
      var generalData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.extractFieldValues(this.generalData));
      generalData['ruc'] = this.id.model;
      generalData['' + this.generalData.address.name2] = this.generalData.address.model2;

      var paymentData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.extractFieldValues(this.paymentData1));
      if (this.optionalPaymentFlag.model) {
        paymentData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, paymentData, this.extractFieldValues(this.paymentData2));
      } else {
        paymentData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, paymentData, this.extractFieldValues(this.paymentData2, false));
      }
      if (this.companyTaxData.detractionSwitch.model) {
        paymentData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, paymentData, this.extractFieldValues(this.paymentData3));
      } else {
        paymentData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, paymentData, this.extractFieldValues(this.paymentData3, false));
      }

      var taxData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.extractFieldValues(this.companyTaxData));
      if (this.companyTaxData.perceptionSwitch.model) {
        taxData['' + this.companyTaxData.perceptionSwitch.companyDataPerception.name] = this.companyTaxData.perceptionSwitch.companyDataPerception.model;
      } else {
        taxData['' + this.companyTaxData.perceptionSwitch.companyDataPerception.name] = '';
      }
      if (this.companyTaxData.retentionSwitch.model) {
        taxData['' + this.companyTaxData.retentionSwitch.companyDataRetention.name] = this.companyTaxData.retentionSwitch.companyDataRetention.model;
        taxData['' + this.companyTaxData.retentionSwitch.companyRetentionFields.name] = this.companyTaxData.retentionSwitch.companyRetentionFields.model;
        taxData['' + this.companyTaxData.retentionSwitch.companySuspensionNumber.name] = this.companyTaxData.retentionSwitch.companySuspensionNumber.model;
        taxData['' + this.companyTaxData.retentionSwitch.firstDate.name] = this.companyTaxData.retentionSwitch.firstDate.model;
        taxData['' + this.companyTaxData.retentionSwitch.lastDate.name] = this.companyTaxData.retentionSwitch.lastDate.model;
        taxData['' + this.companyTaxData.retentionSwitch.pdfSuspension.name] = this.companyTaxData.retentionSwitch.pdfSuspension.model;
      } else {
        taxData['' + this.companyTaxData.retentionSwitch.companyDataRetention.name] = '';
        taxData['' + this.companyTaxData.retentionSwitch.companyRetentionFields.name] = '';
        taxData['' + this.companyTaxData.retentionSwitch.companySuspensionNumber.name] = '';
        taxData['' + this.companyTaxData.retentionSwitch.firstDate.name] = '';
        taxData['' + this.companyTaxData.retentionSwitch.lastDate.name] = '';
        taxData['' + this.companyTaxData.retentionSwitch.pdfSuspension.name] = '';
      }

      var userData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.extractFieldValues(this.userData));

      this.savedGeneralData = generalData;
      this.savedTaxData = taxData;
      this.savedPaymentData = paymentData;
      this.savedUserData = userData;
    },
    clearOptionalPaymentData: function clearOptionalPaymentData(switchValue) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_utils_js__["b" /* saveDataToLocalStorage */])(switchValue, 'paymentFlag');
      for (var key in this.paymentData2) {
        if (this.paymentData2.hasOwnProperty(key)) {
          this.paymentData2[key].model = '';
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_utils_js__["b" /* saveDataToLocalStorage */])('', key);
        }
      }
    },
    getLocations: function getLocations() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].request('GET', 'api/getProvincesByCountry?countryId=' + this.countryId).then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this2.locations = data;
          data.data.forEach(function (location) {
            _this2.generalData.location.optionValue.push(location.codRegion);
          });
        }
      }).catch(function (error) {
        _this2.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getRubros: function getRubros() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].request('GET', 'api/getRubrosPeru').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          data.data.forEach(function (activity) {
            _this3.generalData.activityField.optionValue.push(activity.activity);
          });
        }
      }).catch(function (error) {
        _this3.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getDenomination: function getDenomination() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].request('GET', 'api/getRetentionRegimenCountry?codCountry=' + this.codCountry).then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this4.denominaciones = data;

          data.data.forEach(function (regime) {
            _this4.companyTaxData.retentionSwitch.companyDataRetention.optionValue.push({ 'retentionRegime': regime.retentionRegime, 'idRetentionRegime': regime.idRetentionRegime });
          });
        }
      }).catch(function (error) {
        _this4.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getBank: function getBank() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].request('GET', 'api/getBankByCountry?codCountry=' + this.codCountry).then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this5.banks = data;
          data.data.forEach(function (bankData) {
            _this5.paymentData1.bank.optionValue.push(bankData.bank);
            _this5.paymentData2.bank2.optionValue.push(bankData.bank);
          });
        }
      }).catch(function (error) {
        _this5.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getReceiptType: function getReceiptType() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].request('GET', 'api/getReceiptTypePeru').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          data.data.forEach(function (receipt) {
            _this6.companyTaxData.paymentType.optionValue.push({ label: receipt.receiptType, value: receipt.idReceiptType });
          });
        }
      }).catch(function (error) {
        _this6.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    verifyRuc: function verifyRuc(ruc) {
      var _this7 = this;

      this.$store.commit('START_LOADING');
      __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].request('GET', 'api/getPersonaSunat/' + ruc).then(function (response) {
        if (typeof response.data === 'string') {
          _this7.dataAfip = '';
          _this7.$message({
            message: response.data.replace('Id', 'RUC'),
            type: 'warning'
          });
        } else {
          _this7.validateRuc = true;
          if (!response.data.errorConstancia) {
            _this7.dataAfip = response.data.datosGenerales;
            _this7.$message({
              message: 'RUC verificado correctamente',
              type: 'success'
            });
          } else {
            var mensaje = '';
            if (typeof response.data.errorConstancia.error === 'string') {
              mensaje = response.data.errorConstancia.error;
            } else {
              mensaje = response.data.errorConstancia.error.join('\n');
            }
            _this7.$message({
              message: 'Informa : \n' + mensaje,
              type: 'error'
            });
          }
        }
        _this7.$store.commit('STOP_LOADING');
      }).catch(function (error) {
        _this7.$store.commit('STOP_LOADING');
        if (error && error.response && error.response.status === 400) {
          _this7.$message({
            message: error.response.data,
            type: 'error'
          });
        } else {
          _this7.$message.error('Error conectando con el servidor');
        }
      });
    },
    openModalTerminosYCondiciones: function openModalTerminosYCondiciones() {
      this.validateSteps();
      if (this.emptyFields.length === 0) {
        this.showTerminosYCondiciones = true;
      }
    },
    submitFormSolicitud: function submitFormSolicitud() {
      this.solicitudActivarUsuario('1');
      if (this.checked2 && this.checked) {
        this.showTerminosYCondiciones = false;
        this.checkData();
        localStorage.removeItem('newProviderPeru');
      } else {
        this.checked2 = false;
        this.checked = false;
        this.showTerminosYCondiciones = true;
      }
    },
    solicitudActivarUsuario: function solicitudActivarUsuario() {
      var _this8 = this;

      var stage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var companyName = this.generalData.company;
      var idFiscal = this.generalData.cuit;
      var idType = this.idType;
      if (!stage) {
        stage = this.provider.idStage;
      }
      __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].request('GET', 'api/solicitudActivarUsuario' + '?stage=' + stage + '&idFiscal=' + idFiscal + '&companyName=' + companyName + '&idType=' + idType).then(function (response) {
        _this8.toggleLoading();
      }).catch(function (error) {
        _this8.$store.commit('TOGGLE_LOADING');
        _this8.invoices = null;
        console.log(error);

        _this8.response = 'Error al conectarse con el servidor, contacte al administrador.';
        _this8.toggleLoading();
      });
    },
    getBankAccountTypes: function getBankAccountTypes() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].request('GET', 'api/generic/bankAccountType').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          var accountTypes = data.filter(function (bankAccountType) {
            return bankAccountType.codCountry === 'PE';
          });
          _this9.bankAccountTypes = data.filter(function (bankAccountType) {
            return bankAccountType.codCountry === 'PE';
          });
          _this9.paymentData1.accountType.optionValue = accountTypes.map(function (accountType) {
            return accountType.bankAccountType;
          });
          _this9.paymentData2.accountType2.optionValue = accountTypes.map(function (accountType) {
            return accountType.bankAccountType;
          });
        }
      }).catch(function (error) {
        _this9.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    }
  },
  mounted: function mounted() {
    var _this10 = this;

    this.getRubros();
    this.getLocations();
    this.getDenomination();
    this.getReceiptType();
    this.getBank();
    this.getBankAccountTypes();

    this.recoverFromNewProviderStorage(this.id, 'id');

    for (var key in this.generalData) {
      this.recoverFromNewProviderStorage(this.generalData, key);
    }

    for (var _key in this.companyTaxData) {
      this.recoverFromNewProviderStorage(this.companyTaxData, _key);
    }

    for (var _key2 in this.paymentData1) {
      this.recoverFromNewProviderStorage(this.paymentData1, _key2);
    }
    this.recoverFromNewProviderStorage(this.optionalPaymentFlag, 'paymentFlag');
    for (var _key3 in this.paymentData2) {
      this.recoverFromNewProviderStorage(this.paymentData2, _key3);
    }
    for (var _key4 in this.paymentData3) {
      this.recoverFromNewProviderStorage(this.paymentData3, _key4);
    }

    for (var _key5 in this.userData) {
      this.recoverFromNewProviderStorage(this.userData, _key5);
    }
    __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].request('get', 'api/findConfiguration/TYC').then(function (response) {
      _this10.configuration = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].request('get', 'api/findConfiguration/CODETI').then(function (response) {
      _this10.codigoEtica = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].request('get', 'api/findConfiguration/POLANTI').then(function (response) {
      _this10.politicaAnticorrupcion = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].request('get', 'api/findConfiguration/POLREL').then(function (response) {
      _this10.politicaRelacionamiento = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].request('get', 'api/checkParam?id=SUN-001').then(function (response) {
      var data = response.data;
      console.log('SUN-001', data);
      _this10.availableCountries = data;
    }).catch(function (error) {
      console.log(error);
    });
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PdfFile_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PdfFile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PdfFile_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SimpleInput_vue__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SimpleInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SimpleInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DoubleInput_vue__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DoubleInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DoubleInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectInput_vue__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SelectInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SwitchPerception_vue__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SwitchPerception_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SwitchPerception_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SwitchRetention_vue__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SwitchRetention_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SwitchRetention_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SwitchDetraction_vue__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SwitchDetraction_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SwitchDetraction_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_utils_js__ = __webpack_require__(14);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'pdf-file': __WEBPACK_IMPORTED_MODULE_0__PdfFile_vue___default.a,
    'simple-input': __WEBPACK_IMPORTED_MODULE_1__SimpleInput_vue___default.a,
    'double-input': __WEBPACK_IMPORTED_MODULE_2__DoubleInput_vue___default.a,
    'select-input': __WEBPACK_IMPORTED_MODULE_3__SelectInput_vue___default.a,
    'switch-perception': __WEBPACK_IMPORTED_MODULE_4__SwitchPerception_vue___default.a,
    'switch-retention': __WEBPACK_IMPORTED_MODULE_5__SwitchRetention_vue___default.a,
    'switch-detraction': __WEBPACK_IMPORTED_MODULE_6__SwitchDetraction_vue___default.a
  },
  data: function data() {
    return {
      habModificaPdf: true
    };
  },

  props: {
    dataForm: {
      type: Object,
      required: true
    },
    validation: {
      type: Boolean
    },
    disabled: {
      type: Boolean,
      default: false
    },
    locations: {
      type: [Array, Object]
    },
    banks: {
      type: [Array, Object]
    },
    bankAccountTypes: {
      type: [Array, Object]
    },
    denominaciones: {
      type: [Array, Object]
    }
  },
  computed: {},
  methods: {
    verifyFields: __WEBPACK_IMPORTED_MODULE_7__helpers_utils_js__["c" /* verifyFields */]
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_utils_js__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      validateID: false
    };
  },

  props: {
    type: {
      type: String,
      default: 'ID'
    },
    idStatus: {
      type: String,
      default: 'accept'
    },
    id: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    idLength: function idLength() {
      return this.id.model.length;
    },
    isDisabled: function isDisabled() {
      return this.idStatus === 'edit';
    },
    buttonText: function buttonText() {
      return this.idStatus === 'edit' ? 'Editar ' + this.type : 'Verificar ' + this.type;
    },
    buttonType: function buttonType() {
      return this.idStatus === 'edit' ? 'warning' : 'primary';
    }
  },
  methods: {
    buttonClickHandler: function buttonClickHandler() {
      this.$emit('validate-id', this.id);
    },

    persistToNewProviderStorage: __WEBPACK_IMPORTED_MODULE_0__helpers_utils_js__["a" /* persistToNewProviderStorage */],
    saveDataToLocalStorage: __WEBPACK_IMPORTED_MODULE_0__helpers_utils_js__["b" /* saveDataToLocalStorage */]
  }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PdfFile_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PdfFile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PdfFile_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UploadOrder_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UploadOrder_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__UploadOrder_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Prebill',
  components: {
    'pdf-file': __WEBPACK_IMPORTED_MODULE_1__PdfFile_vue___default.a,
    'upload-order': __WEBPACK_IMPORTED_MODULE_2__UploadOrder_vue___default.a
  },
  props: {
    loadOperationType: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      isLoading: false,
      providers: [],
      document: {
        documenttype: '',
        ocType: '',
        ocNumbers: [],
        pdfDoc: '',
        migoNumber: '',
        codigoAFIP: '',
        letra: '',
        numero: '',
        proveedor: '',
        fechaVencimiento: '',
        NroCAE: '',
        importeTotal: '',
        importeImpuesto: '',
        porcentajeImpuesto: '',
        moneda: '',
        tipoDeCambio: ''
      },
      documentType: [{ value: '1', label: 'Factura' }, { value: '2', label: 'Nota de crédito' }, { value: '3', label: 'Nota de débito' }],
      acceptanceType: [{ value: '1', label: 'HES' }, { value: '2', label: 'MIGO' }],
      habModificaPdf: true
    };
  },

  methods: {
    getBill: function getBill() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].request('GET', 'api/getBill').then(function (response) {
        _this.document = response.data;
        console.log('document', _this.document);
      }).catch(function (error) {
        _this.$message.error('Error al obtener la factura');
        console.log(error);
      });
    },
    getProviders: function getProviders() {
      var _this2 = this;

      this.$store.commit('START_LOADING');
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].request('GET', 'api/listCompany').then(function (response) {
        _this2.providers = response.data;
        console.log('providers', _this2.providers);
        _this2.$store.commit('STOP_LOADING');
      }).catch(function (error) {
        console.log(error);
        _this2.$store.commit('STOP_LOADING');
      });
    }
  },
  beforeMount: function beforeMount() {
    this.getProviders();
    this.getBill();
  }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_picker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_text_mask__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_editor__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UploadReceipt_vue__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UploadReceipt_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__UploadReceipt_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_apiHelper__ = __webpack_require__(43);




__webpack_require__(0);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Search',
  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_2_vue_date_picker___default.a,
    MaskedInput: __WEBPACK_IMPORTED_MODULE_4_vue_text_mask___default.a,
    VueEditor: __WEBPACK_IMPORTED_MODULE_6_vue2_editor__["a" /* VueEditor */],
    'upload-receipt': __WEBPACK_IMPORTED_MODULE_7__UploadReceipt_vue___default.a
  },
  data: function data(router) {
    return {
      buyOrder: '',
      showModalAprobar: false,
      showModalRechazar: false,
      queryBackup: null,
      statusCount: [],
      filtroNic: '',
      filtroCuit: '',
      totalDocuments: 0,
      currentApiCalls: 0,
      loadingBuyOrderDocuments: false,
      loadingStatus: false,
      currentApiStatusCalls: 0,
      buyOrderDocuments: [],
      section: 'Search',
      loading: '',
      tipoFecha: 'emision',
      estado: '',
      response: '',
      desde: '',
      hasta: '',
      cliente: '',
      referencia: '',
      codes: [],
      fecha: '',
      facturas: this.$store.state.facturas,
      providers: null,
      nuevoDocumento: {
        idBuyOrder: '',
        pdf: '',
        documentType: '',
        documentCode: '',
        letra: '',
        numero: '',
        fechaVencimiento: '',
        cae: '',
        oc: '',
        hes: '',
        migo: '',
        total: '',
        impuesto: '',
        porcentajeImpuesto: '',
        moneda: '',
        tipoCambio: '',
        visto: 0,
        idBuyOrderDocumentStatus: 1,
        mensajeRechazo: '',
        documentComment: ''
      },
      clients: [],
      buyOrderDocument: '',
      newPaymentOrder: {
        pdf: '',
        comment: ''
      },
      showModalPaymentOrder: false,
      showModalConfirmarDocumentacion: false,
      showModal: false,
      confirmPayment: false,
      documentosAceptados: [],
      documentosRechazados: [],
      nuevoMensajeRechazo: '',
      rejectReasons: [{
        value: 'Daño en las mercaderías, cuando no estuviesen expedidas o entregadas por su cuenta y riesgo.'
      }, {
        value: 'Vicios, defectos y diferencias en la calidad o en la cantidad debidamente comprobados.'
      }, {
        value: 'Divergencias en los plazos o en los precios estipulados.'
      }, {
        value: 'No Correspondencia con los servicios o la obra efectivamente contratados.'
      }, {
        value: 'Existencia de vicios formales que causen su inhabilidad tanto como titulo ejecutivo y valor no caratular, así como documento comercial.'
      }, {
        value: 'Falta de entrega de la mercadería o prestación del servicio.'
      }],
      receptor: '',
      idUser: this.$store.state.user.idUser,
      filtrados: [],
      table: '',
      vue: this,
      rutMask: this.$store.state.rutMask,
      invoiceMask: this.$store.state.invoiceMask,
      filters: [{
        prop: 'idBuyOrderDocumentStatus',
        value: '',
        type: 'multiSelect'
      }, {
        prop: ['date'],
        value: '',
        type: 'dateRange'
      }, {
        prop: 'nic',
        value: ''
      }, {
        prop: 'FiscalId',
        value: ''
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])(['user']), {
    statusList: function statusList() {
      var status = this.$store.state.buyOrderDocumentStatus;
      return status;
    },
    buyOrderDocumentType: function buyOrderDocumentType() {
      return this.$store.state.buyOrderDocumentType;
    },
    buyOrderDocumentTypeCode: function buyOrderDocumentTypeCode() {
      return this.$store.state.buyOrderDocumentTypeCode;
    },
    typeList: function typeList() {
      var types = this.$store.state.buyOrderDocumentType;
      return types;
    }
  }),
  methods: {
    getTotalBuyOrderDocument: function getTotalBuyOrderDocument() {
      var _this = this;

      var queryInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var substringPosition = queryInfo.search('condition=');
      var query = queryInfo.substring(substringPosition + 10);
      if (this.user.isProvider) {
        __WEBPACK_IMPORTED_MODULE_8__helpers_apiHelper__["a" /* default */].getTotal('buyOrderDocument', query + ' AND buyOrder.idCompany =' + this.user.company.idCompany).then(function (count) {
          _this.totalDocuments = count;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_8__helpers_apiHelper__["a" /* default */].getTotal('buyOrderDocument', query).then(function (count) {
          _this.totalDocuments = count;
        });
      }
    },
    getCountByStatus: function getCountByStatus() {
      var _this2 = this;

      var _loop = function _loop(index) {
        _this2.startLoadingStatus();
        if (_this2.user.isProvider) {
          __WEBPACK_IMPORTED_MODULE_8__helpers_apiHelper__["a" /* default */].getTotal('buyOrderDocument', 'idBuyOrderDocumentStatus = ' + index + ' AND buyOrder.idCompany =' + _this2.user.company.idCompany).then(function (count) {
            _this2.statusCount[index] = count;
            _this2.stopLoadingStatus();
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_8__helpers_apiHelper__["a" /* default */].getTotal('buyOrderDocument', 'idBuyOrderDocumentStatus = ' + index).then(function (count) {
            _this2.statusCount[index] = count;
            _this2.stopLoadingStatus();
          });
        }
      };

      for (var index = 1; index <= 4; index++) {
        _loop(index);
      }
    },
    startLoadingStatus: function startLoadingStatus() {
      this.currentApiStatusCalls++;
      this.loadingStatus = true;
    },
    stopLoadingStatus: function stopLoadingStatus() {
      this.currentApiStatusCalls--;
      if (this.currentApiStatusCalls === 0) this.loadingStatus = false;
    },
    startLoading: function startLoading() {
      this.currentApiCalls++;
      this.loadingBuyOrderDocuments = true;
    },
    stopLoading: function stopLoading() {
      this.currentApiCalls--;
      if (this.currentApiCalls === 0) this.loadingBuyOrderDocuments = false;
    },
    getBuyOrderDocuments: function getBuyOrderDocuments() {
      var _this3 = this;

      var queryInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.queryBackup = queryInfo;
      var query = __WEBPACK_IMPORTED_MODULE_8__helpers_apiHelper__["a" /* default */].getQueryForApi(queryInfo);
      this.getTotalBuyOrderDocument(query);
      this.startLoading();
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('GET', 'api/getBuyOrderDocument/' + this.user.idUser + query).then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          var documents = data;
          _this3.buyOrderDocuments = documents;
          console.log('documents', documents);
        }
        _this3.stopLoading();
      }).catch(function (error) {
        _this3.$store.commit('TOGGLE_LOADING');
        console.log(error);
        _this3.loadingBuyOrderDocuments = false;
      });
    },
    getBuyOrderDocumentDetails: function getBuyOrderDocumentDetails() {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('GET', 'api/getBuyOrderDocumentDetails/').then(function (res) {
        return console.log(res.data);
      }).catch(function (err) {
        return console.log(err);
      });
    },
    openModalPaymentOrder: function openModalPaymentOrder(buyOrderDocument) {
      this.showModalPaymentOrder = true;
      this.buyOrderDocument = buyOrderDocument;
    },
    uploadPayment: function uploadPayment() {
      var _this4 = this;

      if (this.newPaymentOrder.comment === null) {
        this.$alert('Para confirmar la operación debe detallar la información de Pago', 'Advertencia', {
          confirmButtonText: 'Aceptar',
          type: 'warning',
          lockScroll: false
        });
      } else {
        this.$confirm('¿Realmente desea adjuntar el comprobante?', 'Advertencia', {
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          type: 'warning',
          lockScroll: false
        }).then(function () {
          var formData = new FormData();
          formData.append('file', _this4.$refs.filePayment.files[0]);
          formData.append('folder', 'payments');
          __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('POST', 'api/uploadFile', formData).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('POST', 'api/generic/paymentOrder', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
              'pdf': response.data,
              'comment': _this4.newPaymentOrder.comment
            })).then(function (response2) {
              _this4.buyOrderDocument.idBuyOrderDocumentStatus = '4';
              _this4.buyOrderDocument.idPaymentOrder = response2.data.idPaymentOrder;
              __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('POST', 'api/generic/buyOrderDocument/' + _this4.buyOrderDocument.idBuyOrderDocument, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this4.buyOrderDocument)).then(function (response3) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('GET', 'api/sendMailBuyOrderDocumentStatus/' + _this4.buyOrderDocument.idBuyOrderDocument);
                _this4.hideModalPaymentOrder();
                _this4.getBuyOrderDocuments(_this4.queryBackup);
              });
            });
          });
        }).catch(function () {});
      }
    },
    resetNewPaymentOrder: function resetNewPaymentOrder() {
      this.newPaymentOrder = {
        pdf: '',
        comment: ''
      };
      this.buyOrderDocument = '';
    },
    hideModalPaymentOrder: function hideModalPaymentOrder() {
      this.showModalPaymentOrder = false;
      this.resetNewPaymentOrder();
    },
    handleIncluirDocumento: function handleIncluirDocumento(row, idBuyOrderDocumentStatus) {
      if (idBuyOrderDocumentStatus === 2) {
        if (!this.documentosAceptados.includes(row)) {
          this.documentosRechazados = this.documentosRechazados.filter(function (el) {
            return el !== row;
          });
          this.documentosAceptados.push(row);
        } else {
          this.documentosAceptados = this.documentosAceptados.filter(function (el) {
            return el !== row;
          });
        }
      }
      if (idBuyOrderDocumentStatus === 3) {
        if (!this.documentosRechazados.includes(row)) {
          this.documentosAceptados = this.documentosAceptados.filter(function (el) {
            return el !== row;
          });
          this.documentosRechazados.push(row);
        } else {
          this.documentosRechazados = this.documentosRechazados.filter(function (el) {
            return el !== row;
          });
        }
      }
    },
    cerrarModalConfirmarDocumentacion: function cerrarModalConfirmarDocumentacion() {
      this.showModalConfirmarDocumentacion = false;
      this.documentosRechazados.forEach(function (el) {
        el.mensajeRechazo = '';
      });
    },
    abrirModalConfirmacion: function abrirModalConfirmacion() {
      this.showModalConfirmarDocumentacion = true;
    },
    confirmarDocumentos: function confirmarDocumentos() {
      var cantidadMensajesRechazados = this.documentosRechazados.filter(function (document) {
        return document['mensajeRechazo'] === null || document['mensajeRechazo'] === '';
      }).length;
      var mensajeAlert = 'Debe completar los campos "Mensaje"';
      if (cantidadMensajesRechazados === 0) {
        this.cambiarEstadoDocumentos(this.documentosRechazados, 3);
        this.cambiarEstadoDocumentos(this.documentosAceptados, 2);
        this.documentosAceptados = [];
        this.documentosRechazados = [];
        this.cerrarModalConfirmarDocumentacion();
      } else {
        if (cantidadMensajesRechazados === 1) {
          mensajeAlert = 'Debe completar el campo "Mensaje"';
        }
        this.$message({
          type: 'warning',
          message: mensajeAlert
        });
      }
    },
    cambiarEstadoDocumentos: function cambiarEstadoDocumentos(documentos, idBuyOrderDocumentStatus) {
      var _this5 = this;

      documentos.forEach(function (doc) {
        _this5.cambiarEstadoDocumento(doc, idBuyOrderDocumentStatus);
      });
    },
    cambiarEstadoDocumento: function cambiarEstadoDocumento(documento, estado) {
      documento.idBuyOrderDocumentStatus = estado.toString();
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('POST', 'api/generic/buyOrderDocument/' + documento.idBuyOrderDocument, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(documento)).then(function (response) {
        if (estado === 3) {
          __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('GET', 'api/sendMailBuyOrderDocumentStatus/' + documento.idBuyOrderDocument);
        }
      });
    },
    mostrarMensajeCompleto: function mostrarMensajeCompleto(mensaje) {
      this.$alert(mensaje, 'Mensaje', {
        confirmButtonText: 'OK'
      });
    },
    searchStatus: function searchStatus(status) {
      this.filters[0].value = [status];
    },
    getTypeName: function getTypeName(idBuyOrderDocumentType) {
      if (this.typeList.length > 0) {
        return this.typeList.find(function (el) {
          return el.idBuyOrderDocumentType === idBuyOrderDocumentType;
        }).description;
      } else {
        return '-';
      }
    },
    getStatusName: function getStatusName(idBuyOrderDocumentStatus) {
      if (this.statusList.length > 0) {
        return this.statusList.find(function (el) {
          return el.idBuyOrderDocumentStatus === idBuyOrderDocumentStatus;
        }).description;
      } else {
        return '-';
      }
    },
    goToDetails: function goToDetails(idBuyOrder) {
      this.$router.push('/bill/' + idBuyOrder);
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'cargando' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
    },
    compareViewNics: function compareViewNics(a, b) {
      if (a.view < b.view) {
        return -1;
      } else if (a.view > b.view) {
        return 1;
      }

      return 0;
    },
    compareViewInvoice: function compareViewInvoice(a, b) {
      if (!a.factura) {
        return 1;
      }
      if (!b.factura) {
        return -1;
      }
      if (a.factura.visto < b.factura.visto) {
        return -1;
      } else if (a.factura.visto > b.factura.visto) {
        return 1;
      }
      return 0;
    }
  },
  beforeMount: function beforeMount() {
    this.getCountByStatus();
  }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ButtonGroup',
  props: {
    filter: {
      type: Object,
      required: true
    },
    showAllButton: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    allButtonType: function allButtonType() {
      return this.selectedCountries.includes('All') ? 'primary' : '';
    },
    countries: function countries() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.habilitateFilter);
    }
  },
  data: function data() {
    return {
      selectedCountries: ['All'],
      habilitateFilter: {}
    };
  },

  methods: {
    filterPerCountry: function filterPerCountry(country) {
      this.selectedCountries = [country];
      var filterValue = country === 'All' ? '' : country;

      this.$emit('update-filter', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.filter, {
        value: filterValue
      }));
    },
    getButtonType: function getButtonType(codCountry) {
      return this.selectedCountries.includes(codCountry) ? 'primary' : '';
    },
    getCountryName: function getCountryName(codCountry) {
      if (codCountry === 'AR') {
        return 'Argentina';
      } else if (codCountry === 'PE') {
        return 'Perú';
      }
      return '';
    },
    getHabilitationParams: function getHabilitationParams() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('get', 'api/checkParam?id=FIL-001').then(function (response) {
        var data = response.data;
        _this.habilitateFilter = data;
        if (data.error) {
          _this.paramInvoices = data.error;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    getInitialFilter: function getInitialFilter() {
      var _this2 = this;

      setTimeout(function () {
        if (!_this2.showAllButton) {
          if (_this2.countries.length === 1 || _this2.countries.every(function (country) {
            return country.codCountry !== 'AR';
          })) {
            var _countries = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_this2.countries, 1),
                firstCountry = _countries[0];

            _this2.selectedCountries = [firstCountry.codCountry];
            _this2.filterValue = [firstCountry.codCountry];
          } else {
            _this2.selectedCountries = ['AR'];
            _this2.filterValue = ['AR'];
          }
        } else {
          _this2.selectedCountries = ['All'];
          _this2.filterValue = [''];
        }
        _this2.$emit('update-filter', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this2.filter, {
          value: _this2.filterValue
        }));
      }, 500);
    }
  },
  beforeMount: function beforeMount() {
    this.getHabilitationParams();
    this.getInitialFilter();
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_picker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_text_mask__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_apiHelper__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UploadOrder_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UploadOrder_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__UploadOrder_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_buy_order_status__ = __webpack_require__(369);




__webpack_require__(0);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BuyOrders',
  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_2_vue_date_picker___default.a,
    MaskedInput: __WEBPACK_IMPORTED_MODULE_4_vue_text_mask___default.a,
    'upload-order': __WEBPACK_IMPORTED_MODULE_7__UploadOrder_vue___default.a
  },
  data: function data(router) {
    return {
      statusCount: [],
      totalBuyOrders: 0,
      nicFilter: '',
      buyOrders: [],
      loadingBuyOrders: false,
      loadingStatus: false,
      currentApiCalls: 0,
      currentApiStatusCalls: 0,
      dummyFilter: '',
      section: 'Search',
      loading: '',
      tipoFecha: 'emision',
      estado: '',
      response: '',
      desde: '',
      hasta: '',
      showModal: false,
      cliente: '',
      referencia: '',
      fecha: '',
      facturas: this.$store.state.facturas,
      providers: null,
      clients: [],
      receptor: '',
      idUser: this.$store.state.user.idUser,
      filtrados: [],
      table: '',
      vue: this,
      rutMask: this.$store.state.rutMask,
      invoiceMask: this.$store.state.invoiceMask,
      titles: [{
        prop: 'nic',
        label: 'OC',
        sortable: 'custom'
      }, {
        prop: 'company',
        label: 'Proveedor'
      }],
      filters: [{
        prop: 'statusId',
        value: '',
        type: 'multiSelect'
      }, {
        prop: 'fecha_liberacion',
        type: 'dateRange',
        value: ''
      }, {
        prop: 'nic',
        value: ''
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])(['user']), {
    statusList: function statusList() {
      var filtro = this.filterBuyOrderStatusBySituation(this.user.isProvider);
      var status = this.$store.state.countStatus.filter(function (el) {
        return filtro.includes(el.statusId);
      });
      return status;
    }
  }),
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (to === from) {
      this.filters[0].value = from.params.statusId;
    }
    next();
  },
  saveNIC: function saveNIC() {
    var _this = this;

    if (this.companyNew.nombre !== '' && this.companyNew.razonSocial !== '' && this.companyNew.cuit !== '' && this.currentIdRubro !== undefined && this.currentIdRubro.length > 0) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('POST', 'api/generic/company', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ 'company': this.companyNew.nombre, 'companyName': this.companyNew.razonSocial, 'idCompanyStatus': 2, 'cuit': this.companyNew.cuit, 'reasonCalification': this.companyNew.descripcion, 'idCompany': '' })).then(function (response) {
        _this.currentIdRubro.forEach(function (item, index) {
          __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('POST', 'api/generic/rubrosCompany/', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ 'idRubro': _this.currentIdRubro[index], 'idCompany': response.data.idCompany })).then(function (response) {
            _this.$message.success('Se ha agregado la nueva empresa', 'success');
            _this.hideModal();
            _this.$parent.getProviders();
          });
        });
      }).catch(function (error) {
        _this.$message.error(error.response.data, 'error');
      });
    } else {
      this.$message.warning('Debe completar todos los campos', 'warning');
    }
  },
  mounted: function mounted() {
    if (this.$route.params.statusId) {
      this.filters[0].value = this.$route.params.statusId;
    }
  },

  methods: {
    filterBuyOrderStatusBySituation: function filterBuyOrderStatusBySituation(isProvider) {
      if (isProvider) {
        return [__WEBPACK_IMPORTED_MODULE_8__config_buy_order_status__["a" /* default */].OC_DISPONIBLE_PROVEEDOR, __WEBPACK_IMPORTED_MODULE_8__config_buy_order_status__["a" /* default */].OC_A_FACTURAR, __WEBPACK_IMPORTED_MODULE_8__config_buy_order_status__["a" /* default */].OC_FACTURADA];
      } else {
        return [__WEBPACK_IMPORTED_MODULE_8__config_buy_order_status__["a" /* default */].OC_LIBERADA_SAP, __WEBPACK_IMPORTED_MODULE_8__config_buy_order_status__["a" /* default */].OC_DISPONIBLE_PROVEEDOR, __WEBPACK_IMPORTED_MODULE_8__config_buy_order_status__["a" /* default */].OC_A_FACTURAR, __WEBPACK_IMPORTED_MODULE_8__config_buy_order_status__["a" /* default */].OC_NO_DISPONIBLE_PROVEEDOR, __WEBPACK_IMPORTED_MODULE_8__config_buy_order_status__["a" /* default */].OC_FACTURADA];
      }
    },
    startLoadingStatus: function startLoadingStatus() {
      this.currentApiStatusCalls++;
      this.loadingStatus = true;
    },
    stopLoadingStatus: function stopLoadingStatus() {
      this.currentApiStatusCalls--;
      if (this.currentApiStatusCalls === 0) this.loadingStatus = false;
    },
    startLoading: function startLoading() {
      this.currentApiCalls++;
      this.loadingBuyOrders = true;
    },
    stopLoading: function stopLoading() {
      this.currentApiCalls--;
      if (this.currentApiCalls === 0) this.loadingBuyOrders = false;
    },
    getCondition: function getCondition() {
      var condition = '(';
      var pathStatus = this.filterBuyOrderStatusBySituation(this.user.isProvider);
      for (var index = 0; index < pathStatus.length;) {
        condition += 'statusId = ' + pathStatus[index];
        index++;
        if (index < pathStatus.length) {
          condition += ' OR ';
        }
      }
      condition += ')';
      return condition;
    },
    getTotalBuyOrder: function getTotalBuyOrder() {
      var _this2 = this;

      var queryInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var substringPosition = queryInfo.search('condition=');
      var query = queryInfo.substring(substringPosition + 10);
      var condition = this.getCondition();
      if (this.user.isProvider) {
        __WEBPACK_IMPORTED_MODULE_5__helpers_apiHelper__["a" /* default */].getTotal('buyOrder', query + ' AND ' + condition + ' AND idCompany =' + this.user.company.idCompany).then(function (count) {
          _this2.totalBuyOrders = count;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_5__helpers_apiHelper__["a" /* default */].getTotal('buyOrder', query + ' AND ' + condition).then(function (count) {
          _this2.totalBuyOrders = count;
        });
      }
    },
    getBuyOrders: function getBuyOrders() {
      var _this3 = this;

      var queryInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var condition = this.getCondition();
      var query = __WEBPACK_IMPORTED_MODULE_5__helpers_apiHelper__["a" /* default */].getQueryForApi(queryInfo);
      this.startLoading();
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('GET', 'api/getBuyOrder/' + this.user.idUser + query + ' AND ' + condition).then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          var orders = data;
          _this3.buyOrders = orders;
        }
        _this3.stopLoading();
      }).catch(function (error) {
        _this3.$store.commit('TOGGLE_LOADING');
        console.log(error);
        _this3.loadingBuyOrders = false;
      });
      this.getTotalBuyOrder(query);
    },
    searchStatus: function searchStatus(status) {
      this.filters[0].value = [status];
    },
    getStatusName: function getStatusName(statusId) {
      if (this.statusList.length > 0) {
        return this.statusList.find(function (el) {
          return el.statusId === statusId;
        }).description;
      } else {
        return '-';
      }
    },
    getCountByStatus: function getCountByStatus() {
      var _this4 = this;

      this.filterBuyOrderStatusBySituation(this.user.isProvider).forEach(function (item) {
        _this4.startLoadingStatus();
        if (_this4.user.isProvider) {
          __WEBPACK_IMPORTED_MODULE_5__helpers_apiHelper__["a" /* default */].getTotal('buyOrder', 'statusId = ' + item + ' AND idCompany =' + _this4.user.company.idCompany).then(function (count) {
            _this4.statusCount[item] = count;
            _this4.stopLoadingStatus();
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_5__helpers_apiHelper__["a" /* default */].getTotal('buyOrder', 'statusId = ' + item).then(function (count) {
            _this4.statusCount[item] = count;
            _this4.stopLoadingStatus();
          });
        }
      });
    },
    goToDetails: function goToDetails(idBuyOrder) {
      this.$router.push('/invoicedetail?i=' + idBuyOrder);
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'cargando' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
    },
    compareViewNics: function compareViewNics(a, b) {
      if (a.view < b.view) {
        return -1;
      } else if (a.view > b.view) {
        return 1;
      }

      return 0;
    },
    compareViewInvoice: function compareViewInvoice(a, b) {
      if (!a.factura) {
        return 1;
      }
      if (!b.factura) {
        return -1;
      }
      if (a.factura.visto < b.factura.visto) {
        return -1;
      } else if (a.factura.visto > b.factura.visto) {
        return 1;
      }
      return 0;
    }
  },
  beforeMount: function beforeMount() {
    this.getCountByStatus();
  }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_date_picker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(2);


__webpack_require__(0);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Settings',
  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_0_vue_date_picker___default.a
  },
  data: function data(router) {
    return {
      section: 'ChangePsw',
      loading: '',
      actualPsw: '',
      newPsw: '',
      newPswRe: '',
      response: null,
      idUser: this.$store.state.user.idUser
    };
  },

  computed: {
    datetime: function datetime() {
      return new Date();
    }
  },
  methods: {
    changePassword: function changePassword() {
      var _this = this;

      this.$confirm('¿Realmente desea cambiar la contraseña?', 'Advertencia', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        lockScroll: false
      }).then(function () {
        var idUser = _this.idUser,
            actualPsw = _this.actualPsw,
            newPsw = _this.newPsw,
            newPswRe = _this.newPswRe;


        _this.toggleLoading();
        _this.resetResponse();
        _this.$store.commit('TOGGLE_LOADING');

        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('GET', 'api/reestablecerPsw').then(function (response) {
          _this.toggleLoading();
        }).catch(function (error) {
          _this.$store.commit('TOGGLE_LOADING');
          _this.invoices = null;
          console.log(error);

          _this.response = 'Error al conectarse con el servidor, contacte al administrador.';
          _this.toggleLoading();
        });

        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('POST', 'api/changePsw', { idUser: idUser, actualPsw: actualPsw, newPsw: newPsw, newPswRe: newPswRe }).then(function (response) {
          _this.toggleLoading();
          _this.invoices = null;

          var data = response.data;

          if (response.data.error) {
            var errorName = response.data.error.name;
            if (errorName) {
              if (errorName === 'InvalidArgumentError') {
                _this.response = 'Los datos suministrados son incorrectos.';
              } else if (errorName === 'NotFoundError') {
                _this.response = 'La factura no se encuentra.';
              } else {
                _this.response = errorName;
              }
            } else {
              _this.response = data.error;
            }
            return;
          } else {
            if (data.success) {
              localStorage.removeItem('user');
              _this.$store.commit('SET_USER', '');
              _this.$store.commit('SET_TOKEN', '');
              _this.$router.push('/login');
            }
          }
        }).catch(function (error) {
          _this.$store.commit('TOGGLE_LOADING');
          _this.invoices = null;
          console.log(error);

          _this.response = 'Error al conectarse con el servidor, contacte al administrador.';
          _this.toggleLoading();
        });
      });
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'cargando' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
      this.success = '';
    }
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_date_picker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(2);


__webpack_require__(0);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Settings',
  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_0_vue_date_picker___default.a
  },
  data: function data(router) {
    return {
      section: 'CommentDetail',
      loading: '',
      answers: this.$store.state.answers,
      answersNew: this.$store.state.answersNew,
      comments: this.$store.state.comments,
      answer: '',
      idUser: this.$store.state.user.idUser,
      c: this.$route.query.c
    };
  },

  computed: {
    datetime: function datetime() {
      return new Date();
    }
  },
  methods: {
    checkComments: function checkComments() {
      var _this = this;

      var idUser = this.idUser;

      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('GET', 'api/getComments?idUser=' + idUser).then(function (response) {
        var data = response.data;

        if (data.error) {
          return;
        }

        if (data.answers) {
          _this.answersNew = [];
          _this.answers = data.answers;
          _this.$store.commit('SET_ANSWERS', data.answers);
          for (var j = 0; j < _this.answers.length; j++) {
            if (_this.answers[j].statusComments === '2') {
              _this.answersNew.push(_this.answers[j]);
            }
          }
          if (_this.answersNew.length >= 0) {
            _this.$store.commit('SET_ANSWERSNEW', _this.answersNew);
            _this.answersNew = _this.$store.state.answersNew;
          }
        }
      }).catch(function (error) {
        _this.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    this.answers = this.$store.state.answers;
    for (var j = 0; j < this.answers.length; j++) {
      if (this.answers[j].idComments === this.c) {
        this.answer = this.answers[j];
      }
    }
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('get', 'api/readComment?idComments=' + this.answer.idComments).then(function (response) {
      _this2.checkComments();
    }).catch(function (error) {
      console.log(error);
    });
  },

  filters: {
    truncate: function truncate(string, value) {
      return string.substring(0, value) + '...';
    }
  }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_date_picker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(2);


__webpack_require__(0);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Settings',
  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_0_vue_date_picker___default.a
  },
  data: function data(router) {
    return {
      section: 'ChangePsw',
      loading: '',
      comment: '',
      response: null,
      success: null,
      idUser: this.$store.state.user.idUser
    };
  },

  computed: {
    datetime: function datetime() {
      return new Date();
    }
  },
  methods: {
    sendComment: function sendComment() {
      var _this = this;

      var idUser = this.idUser,
          comment = this.comment;


      this.toggleLoading();
      this.resetResponse();
      this.$store.commit('TOGGLE_LOADING');

      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('GET', 'api/sendComment?idUser=' + idUser + '&comment=' + comment).then(function (response) {
        _this.toggleLoading();
        _this.invoices = null;

        var data = response.data;

        if (response.data.error) {
          var errorName = response.data.error.name;
          if (errorName) {
            if (errorName === 'InvalidArgumentError') {
              _this.response = 'Los datos suministrados son incorrectos.';
            } else if (errorName === 'NotFoundError') {
              _this.response = 'La factura no se encuentra.';
            } else {
              _this.response = errorName;
            }
          } else {
            _this.response = data.error;
          }

          return;
        } else {
          if (data.success) {
            _this.success = data.success;
          }
        }
      }).catch(function (error) {
        _this.$store.commit('TOGGLE_LOADING');
        _this.invoices = null;
        console.log(error);

        _this.response = 'Error al conectarse con el servidor, contacte al administrador.';
        _this.toggleLoading();
      });
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'cargando' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
      this.success = '';
    }
  }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_date_picker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_text_mask__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_the_mask__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_company_stage__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_roles__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config_data_status__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__MySteps_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__MySteps_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__MySteps_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CompanyDataPeru_vue__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CompanyDataPeru_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__CompanyDataPeru_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PdfFile_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PdfFile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__PdfFile_vue__);





__webpack_require__(0);













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CompanyData',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_4_vue_date_picker___default.a, TheMask: __WEBPACK_IMPORTED_MODULE_7_vue_the_mask___default.a, MaskedInput: __WEBPACK_IMPORTED_MODULE_5_vue_text_mask___default.a, PdfFile: __WEBPACK_IMPORTED_MODULE_14__PdfFile_vue___default.a, 'steps-pagination': __WEBPACK_IMPORTED_MODULE_12__MySteps_vue___default.a, CompanyDataPeru: __WEBPACK_IMPORTED_MODULE_13__CompanyDataPeru_vue___default.a },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])(['banks', 'user', 'bankBranches', 'accountTypes', 'regimenTypes', 'jurisdictions', 'retentionRegimes', 'retentionRegimesVAT', 'retentionRegimesOTROS', 'retentionCategories', 'retentionCategoriesVAT', 'retentionCategoriesOTROS', 'ibRetentionCategory']), {
    services: function services() {
      var services = this.$store.state.services;
      if (services.sort) {
        return services.sort(function (a, b) {
          return a.nombre > b.nombre;
        });
      }
    },
    countries: function countries() {
      if (this.$store.state.countries) {
        return this.$store.state.countries.sort(function (a, b) {
          return a.country > b.country;
        });
      }
    },
    sussRetentionCategory: function sussRetentionCategory() {
      var lista = this.$store.state.sussRetentionCategory.sort(function (a, b) {
        return a.categoryRetain > b.categoryRetain;
      });
      if (this.taxData.sussRetentionRegimen === '0') {
        return lista;
      } else {
        lista = lista.filter(function (a) {
          var auxiliar = a.auxiliar;
          var agenteRet = JSON.parse(auxiliar)['AgenteRet'] === 'true';
          if (agenteRet) {
            return a;
          }
        });
        return lista;
      }
    },
    groupCompanies: function groupCompanies() {
      return this.$store.state.groupCompanies.sort(function (a, b) {
        return a.groupCompany > b.groupCompany;
      });
    },
    storeRetentionRegime: function storeRetentionRegime() {
      return this.$store.state.retentionRegimes;
    },
    retentionRegimeList: function retentionRegimeList() {
      return this.$store.state.retentionRegimes.filter(function (el) {
        return el.idRetentionRegime === '3';
      });
    },
    statusList: function statusList() {
      return this.$store.state.companyDataStatus;
    }
  }),
  data: function data(router) {
    return {
      jurisdictionsHabilitadas: [],
      jurisdicciones: true,
      jurisdictionFlag: false,
      status: __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */],
      userIsAdmin: false,
      userByRoles: false,
      otrosRetentionCategories: [],
      retentionCategories2: [],
      retentionCategoriesAliquot: [],
      ivaRetentionCategories: [],
      disabledDates: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },

      doc1276: false,
      jurisdictionSantaFe: '',
      auxJurId: '',
      provider: '',
      providerLoaded: false,
      rejectCompanyDataVisible: false,
      disabledData: false,
      habModificaPdf: false,
      error: null,
      newObservation: '',
      statusType: '',
      types: ['warning', 'success', 'danger'],
      steps: ['generalData', 'paymentData', 'taxData'],
      idCompany: this.$route.params.id,
      idStep: this.$route.params.step,
      showModalCertificationExgain: false,
      showModalCertificationsExgainList: false,
      certificationExgainList: [],
      auxFlagEmptyExgainList: false,
      certificationExgain: [],
      showModalCertificationDatosAdicionales: false,
      showModalForm1276: false,
      showModalCertificationRg2681: false,
      showModalCertificationRg2681List: false,
      certificationRg2681List: [],
      certificationRg2681: [],
      showModalCertificationSussList: false,
      showModalCertificationSuss: false,
      certificationSussList: [],
      certificationSuss: [],
      showModalCertificationRg18List: false,
      showModalCertificationRg18: false,
      certificationRg18List: [],
      certificationRg18: [],
      showModalCertificationRg17List: false,
      showModalCertificationRg17: false,
      certificationRg17List: [],
      certificationRg17: [],
      checked2: false,
      step: 0,
      timeStampModifDate: '',
      editing: false,
      serverURI: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].serverURI,
      section: 'Solicitud',
      loading: '',
      providers: [],
      rut: '',
      actualCountry: this.$route.params.country,
      options: [{
        value: '',
        label: ''
      }],
      dataAfip: '',
      value: '',
      configuration: '',
      jwt: window.localStorage.getItem('token'),
      codigoEtica: '',
      politicaAnticorrupcion: '',
      politicaRelacionamiento: '',
      response: null,
      success: null,
      paramError: null,
      provinces: [],
      activeJurisdiction: '',
      activeJurisdictionSantaFe: '',
      coefficientFieldVerify: false,
      form1276loaded: false,
      form1276loadedAux: false,
      paramInvoices: null,
      rutMask: this.$store.state.rutMask,
      cuitMask: [/[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
      invoiceMask: this.$store.state.invoiceMask,
      terminosYCondVisible: false,
      checked: false,
      jurId: 0,
      generalData: {
        cuit: '',
        company: '',
        companyName: '',
        rubros: [],
        centrales: [],
        address: '',
        addressNumber: '',
        idProvince: '',
        idCountry: '',
        idGroupCompany: '',
        zipCode: '',
        city: '',
        paymentEmail: '',
        receiptEmail: '',
        typeIVA: '',
        personType: '',
        personSubType: '',
        personSubTypeOther: '',
        pdfAfip: '',
        namePrincipalContact: '',
        surnamePrincipalContact: '',
        phonePrincipalContact: '',
        emailPrincipalContact: '',
        nameCommercialContact: '',
        surnameCommercialContact: '',
        phoneCommercialContact: '',
        emailCommercialContact: '',
        modifDate: ''
      },
      rulesGeneralData: {
        cuit: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }, {
          type: 'number',
          message: 'Solo están permitidos los números',
          trigger: ['blur', 'change']
        }],
        company: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        rubros: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        centrales: [{ required: false, message: 'Campo obligatorio', trigger: 'change' }],
        address: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        addressNumber: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        idProvince: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        zipCode: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        city: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        idCountry: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        idGroupCompany: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        phonePrincipalContact: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        phoneCommercialContact: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        namePrincipalContact: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        nameCommercialContact: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        surnamePrincipalContact: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        surnameCommercialContact: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        emailPrincipalContact: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }, {
          type: 'email',
          message: 'Debe ingresar un correo electrónico válido',
          trigger: 'blur'
        }],
        emailCommercialContact: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }, {
          type: 'email',
          message: 'Debe ingresar un correo electrónico válido',
          trigger: 'blur'
        }],
        paymentEmail: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }, {
          type: 'email',
          message: 'Debe ingresar un correo electrónico válido',
          trigger: 'blur'
        }],
        receiptEmail: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }, {
          type: 'email',
          message: 'Debe ingresar un correo electrónico válido',
          trigger: 'blur'
        }],
        typeIVA: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        personType: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        personSubType: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        personSubTypeOther: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        pdfAfip: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }]
      },
      paymentData: {
        idBankBranch: '',
        idBank: '',
        accountNumber: '',
        idBankAccountType: '',
        cbu: '',
        pdfBank: ''
      },
      rulesPaymentData: {
        idBank: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        accountNumber: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        idBankAccountType: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        cbu: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }, {
          pattern: '[0-9]{22}',
          message: 'Deben ser 22 números',
          trigger: ['blur', 'change']
        }],
        pdfBank: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }]
      },
      jurisdictionData: {
        idJurisdiction: '',
        coefficient: null,
        aliquot: null,
        certficateDetailsVisible: false,
        form1276Visible: false,
        certificateNumber: '',
        certificateFrom: null,
        agentDontOperateHere: false,
        certificateTo: null,
        certificatePdf: '',
        retentionAgentHas: 0,
        retentionAgentVisible: false,
        retentionAgentDate: null,
        retentionAgentPdf: '',
        form1276pdf: '',
        perceptionAgentHas: 0,
        perceptionAgentVisible: false,
        perceptionAgentDate: null,
        perceptionAgentPdf: ''
      },
      taxData: {
        pdfIb: '',
        ibType: '',
        pdfsExempt: '',
        idAgreementRegimeType: '',
        pdfCM05: '',
        jurisdictionHeadquarters: '',
        jurisdictions: [],
        earningsRetentionType: '',
        retentionRegimen: '',
        idEarningCategoryRetain: '',
        earningsExclusionNumber: '',
        earningsExclusionFrom: null,
        earningsExclusionTo: null,
        earningsExclusionPdf: '',
        sussEmployeer: 0,
        sussRetentionRegimen: 0,
        sussIdCategoryRetain: '',
        sussExclusionNumber: '',
        sussExclusionFrom: null,
        sussExclusionTo: null,
        sussExclusionPdf: '',
        ivaRetentionAgent: 0,
        ivaResolutionPdf: '',
        ivaIdRetentionRegime: '',
        ivaIdCategoryRetain: '',
        ivaExclusionNumber: '',
        otrosIdRetentionRegime: '',
        otrosIdCategoryRetain: '',
        ivaExclusionFrom: null,
        ivaExclusionTo: null,
        ivaExclusionPdf: ''
      },
      rulesTaxData: {
        pdfIb: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        ibType: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        pdfsExempt: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        idAgreementRegimeType: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        pdfCM05: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        jurisdictionHeadquarters: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],

        earningsRetentionType: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        retentionRegimen: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        idEarningCategoryRetain: [{
          required: !!this.retentionCategories2,
          message: 'Campo obligatorio',
          trigger: 'change'
        }],
        earningsExclusionFrom: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        earningsExclusionTo: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        earningsExclusionPdf: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        sussExclusionFrom: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        sussExclusionTo: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        sussExclusionPdf: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        ivaExclusionFrom: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        ivaExclusionTo: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        ivaExclusionPdf: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }]
      },
      rulesTaxDataIvaResolutionPdf: {
        ivaResolutionPdf: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }]
      },
      rulesTaxDataOtros: {
        ivaResolutionPdf: [{
          required: false,
          message: 'Campo no obligatorio',
          trigger: 'change'
        }]
      },
      rulesTaxDataForm1276Pdf: {
        form1276pdf: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }]
      },
      userData: {
        name: '',
        email: '',
        password: '',
        passwordRe: ''
      },
      rulesUserData: {
        email: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }, {
          type: 'email',
          message: 'Debe ingresar un correo electrónico válido',
          trigger: 'blur'
        }],
        password: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }, {
          min: 8,
          message: 'Debe tener mínimo 8 caracteres',
          trigger: 'change'
        }]
      }
    };
  },

  watch: {
    provider: function provider(val) {
      this.loadProvider();
    }
  },
  methods: {
    validateCoefficient: function validateCoefficient(key, jurId) {
      console.log('key ingresa: ', key);
      console.log(this.taxData.jurisdictions[jurId]);
      var allowedCharacters = /^\d+(,\d{0,4})?$/;
      if (!allowedCharacters.test(key)) {
        if (!allowedCharacters.test(key[key.length - 1])) {
          this.taxData.jurisdictions[jurId].coefficient = key.slice(0, -1);
          console.log('key correcta', this.taxData.jurisdictions[jurId].coefficient);
          return;
        }
        key = key.replace(/[^0-9,\b]+/g, '');
        var parts = key.split(/,/);
        var integerPart = parts[0];
        var decimalPart = parts[1] || '';

        decimalPart = decimalPart.slice(0, 4);
        this.taxData.jurisdictions[jurId].coefficient = integerPart + (decimalPart ? ',' + decimalPart : '');
        console.log('key sale: ', this.taxData.jurisdictions[jurId].coefficient);
      } else {
        console.log('key correcta: ', key);
        this.taxData.jurisdictions[jurId].coefficient = key;
      }
    },
    decimalCoefficient: function decimalCoefficient(coef) {
      return coef.indexOf(',') !== -1 && coef.split(',')[0].length > 0 && coef.split(',')[1].length > 0;
    },
    clearAlicuotValue: function clearAlicuotValue(jurId) {
      var _this = this;

      this.taxData.jurisdictions.forEach(function (jur, index) {
        if (jur.idJurisdiction === jurId) {
          _this.taxData.jurisdictions[index].aliquot = '';
        }
      });
    },
    changeAlicoutJurisdiction: function changeAlicoutJurisdiction(jurId) {
      if (jurId !== null && jurId !== '') {
        var data = this.$store.state.ibRetentionCategory.filter(function (ret) {
          return ret.idJurisdictions === jurId;
        }).sort(function (a, b) {
          return a.categoryRetain > b.categoryRetain;
        });

        this.clearAlicuotValue(jurId);
        return data;
      }
    },
    isAlicuotList: function isAlicuotList(jurId) {
      if (jurId !== null && jurId !== '') {
        var data = this.$store.state.ibRetentionCategory.filter(function (ret) {
          return ret.idJurisdictions === jurId;
        });
        return data.length > 0;
      }
    },
    getJurisdictionData: function getJurisdictionData(jurId) {
      if (jurId) {
        var jurisdiction = this.jurisdictions[jurId];

        console.log(jurisdiction);
      }
    },
    sussIdCategoryRetainClear: function sussIdCategoryRetainClear() {
      this.taxData.sussIdCategoryRetain = '';
    },
    notify: function notify(notificationMessage) {
      this.$notify({
        title: '',
        type: 'warning',
        message: notificationMessage,
        duration: 10000,
        showClose: true,
        offset: 50
      });
    },
    editData: function editData() {
      this.editing = true;
      this.disabledGeneralData();
    },
    cancelData: function cancelData() {
      this.editing = false;
      this.disabledGeneralData();
    },
    saveData: function saveData() {
      var _this2 = this;

      this.$confirm('Sus Datos se remitirán a Albanesi para su verificación', 'Atención', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(function () {
        _this2.editing = false;
        _this2.disabledGeneralData();
        _this2.providerUpdateData();
      });
    },
    calculateHabModificaPdf: function calculateHabModificaPdf() {
      var provider = !!this.provider && this.provider !== '';
      this.habModificaPdf = !provider || this.editing || !this.disabledData;
    },
    disabledGeneralData: function disabledGeneralData() {
      if (this.user && this.idCompany) {
        if (this.user.isProvider) {
          if (this.editing) {
            this.disabledData = false;
            this.calculateHabModificaPdf();
            return;
          } else {
            if (this.provider) {
              if (this.provider[this.activeTab()].idCompanyDataStatus === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].DEVUELTO) {
                this.disabledData = false;
                this.calculateHabModificaPdf();
                return;
              }
            }
          }
        } else {
          if (this.provider) {
            if (this.provider[this.activeTab()].idCompanyDataStatus !== __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ACEPTADO) {
              this.disabledData = false;
              this.calculateHabModificaPdf();
              return;
            }
          }
        }
      } else {
        this.disabledData = false;
        this.calculateHabModificaPdf();
        return;
      }
      this.disabledData = true;
      this.calculateHabModificaPdf();
    },
    closeCertificationExgain: function closeCertificationExgain() {
      this.showModalCertificationExgain = false;
    },
    closeCertificationsExgainList: function closeCertificationsExgainList() {
      this.showModalCertificationsExgainList = false;
    },
    closeCertificationRg2681: function closeCertificationRg2681() {
      this.showModalCertificationRg2681 = false;
    },
    closeCertificationsRg2681List: function closeCertificationsRg2681List() {
      this.showModalCertificationRg2681List = false;
    },
    closeCertificationSuss: function closeCertificationSuss() {
      this.showModalCertificationSuss = false;
    },
    closeCertificationsSussList: function closeCertificationsSussList() {
      this.showModalCertificationSussList = false;
    },
    closeCertificationRg18: function closeCertificationRg18() {
      this.showModalCertificationRg18 = false;
    },
    closeCertificationsRg18List: function closeCertificationsRg18List() {
      this.showModalCertificationRg18List = false;
    },
    closeCertificationRg17: function closeCertificationRg17() {
      this.showModalCertificationRg17 = false;
    },
    closeCertificationsRg17List: function closeCertificationsRg17List() {
      this.showModalCertificationRg17List = false;
    },
    coeficienteValidacionTest: function coeficienteValidacionTest() {
      return this.taxData.jurisdictions.some(function (el) {
        if (el.coefficient === null || el.coefficient === undefined) {} else {
          return el.coefficient.indexOf('.') > -1;
        }
      });
    },
    verifySantaFeJurisdiction: function verifySantaFeJurisdiction() {
      var _this3 = this;

      this.taxData.jurisdictions.forEach(function (juris) {
        if (juris.idJurisdiction === '13') {
          if (_this3.activeJurisdictionSantaFe !== '') {
            if (_this3.taxData.jurisdictions[_this3.activeJurisdictionSantaFe]['form1276pdf'] !== null) {
              console.log('hay una jurisdiccion santa fe con form1276 OK');
              _this3.form1276loaded = true;
            } else if (_this3.taxData.jurisdictions[_this3.activeJurisdictionSantaFe]['form1276pdf'] === null) {
              console.log('hay una jurisdiccion santa fe con form1276 No cargado');
              _this3.form1276loaded = false;
            }
          } else {
            console.log('hay una jurisdiccion santa fe con form ERROR');
            _this3.form1276loaded = false;
          }
        } else {
          _this3.form1276loaded = true;
        }
      });
    },
    getCertificationExgain: function getCertificationExgain(id) {
      var _this4 = this;

      this.certificationExgain = [];

      this.certificationExgainList.forEach(function (certif) {
        if (certif.IdCertificationExGain === id) {
          _this4.certificationExgain.push({
            id: certif.IdCertificationExGain,
            cuit: certif.cuit,
            state: certif.state,
            publication: certif.publication,
            validity: certif.validity,
            period: certif.period,
            percentage: certif.percentage,
            number: certif.number,
            resolution: certif.resolution
          });
        }
      });

      this.showModalCertificationExgain = true;
    },
    openCertificationExgainList: function openCertificationExgainList() {
      if (this.user !== null) {
        this.certificationExgainList = [];
        this.getCertificationExgainList();
      }
      this.showModalCertificationsExgainList = true;
    },
    getCertificationExgainList: function getCertificationExgainList() {
      var _this5 = this;

      this.providers[0].certifExgain.forEach(function (certif) {
        _this5.certificationExgainList.push({
          IdCertificationExGain: certif.IdCertificationExGain,
          number: certif.number,
          publication: certif.publication,
          validity: certif.validity,
          cuit: certif.cuit,
          state: certif.state,
          period: certif.period,
          percentage: certif.percentage,
          resolution: certif.resolution
        });
      });

      console.log(this.certificationExgainList);
    },
    getCertificationRg2681: function getCertificationRg2681(id) {
      var _this6 = this;

      this.certificationRg2681 = [];

      this.certificationRg2681List.forEach(function (certif) {
        if (certif.idCertificationRG2681 === id) {
          _this6.certificationRg2681.push({
            id: certif.idCertificationRG2681,
            cuit: certif.cuit,
            type: certif.type,
            state: certif.state,
            stateDescription: certif.stateDescription,
            emision: certif.emision,
            administrationDate: certif.administrationDate,
            auth: certif.auth,
            ddjj: certif.ddjj,
            subsection: certif.subsection,
            since: certif.since,
            until: certif.until,
            number: certif.number,
            orderJud: certif.orderJud,
            modificationDate: certif.modificationDate
          });
        }
      });
      console.log(this.certificationRg2681[0].cuit);
      this.showModalCertificationRg2681 = true;
    },
    openCertificationRg2681List: function openCertificationRg2681List() {
      if (this.user !== null) {
        this.certificationRg2681List = [];
        this.getCertificationRg2681List();
      }
      this.showModalCertificationRg2681List = true;
    },
    getCertificationRg2681List: function getCertificationRg2681List() {
      var _this7 = this;

      this.providers[0].certifRg2681.forEach(function (certif) {
        _this7.certificationRg2681List.push({
          idCertificationRG2681: certif.idCertificationRG2681,
          cuit: certif.cuit,
          type: certif.type,
          state: certif.state,
          stateDescription: certif.stateDescription,
          emision: certif.emision,
          administrationDate: certif.administrationDate,
          auth: certif.auth,
          ddjj: certif.ddjj,
          subsection: certif.subsection,
          since: certif.since,
          until: certif.until,
          number: certif.number,
          orderJud: certif.orderJud,
          modificationDate: certif.modificationDate
        });
      });

      console.log(this.certificationRg2681List);
    },
    getCertificationSuss: function getCertificationSuss(id) {
      var _this8 = this;

      this.certificationSuss = [];

      this.certificationSussList.forEach(function (certif) {
        if (certif.idCertificaction === id) {
          _this8.certificationSuss.push({
            id: certif.idCertificaction,
            cuit: certif.cuit,
            state: certif.state,
            since: certif.since,
            until: certif.until,
            number: certif.number,
            period: certif.period,
            resolution: certif.resolution,
            percentage: certif.percentage
          });
        }
      });
      this.showModalCertificationSuss = true;
    },
    openCertificationSussList: function openCertificationSussList() {
      if (this.user !== null) {
        this.certificationSussList = [];
        this.getCertificationSussList();
      }
      this.showModalCertificationSussList = true;
    },
    getCertificationSussList: function getCertificationSussList() {
      var _this9 = this;

      this.providers[0].certifSuss.forEach(function (certif) {
        _this9.certificationSussList.push({
          idCertificaction: certif.idCertificaction,
          cuit: certif.cuit,
          state: certif.state,
          since: certif.since,
          until: certif.until,
          number: certif.number,
          period: certif.period,
          resolution: certif.resolution,
          percentage: certif.percentage
        });
      });
    },
    getCertificationRg18: function getCertificationRg18(id) {
      var _this10 = this;

      this.certificationRg18 = [];

      this.certificationRg18List.forEach(function (certif) {
        if (certif.idCertificationRG18 === id) {
          _this10.certificationRg18.push({
            id: certif.idCertificationRG18,
            cuit: certif.cuit,
            type: certif.type,
            since: certif.since,
            until: certif.until,
            name: certif.name
          });
        }
      });
      this.showModalCertificationRg18 = true;
    },
    openCertificationRg18List: function openCertificationRg18List() {
      if (this.user !== null) {
        this.certificationRg18List = [];
        this.getCertificationRg18List();
      }
      this.showModalCertificationRg18List = true;
    },
    getCertificationRg18List: function getCertificationRg18List() {
      var _this11 = this;

      this.providers[0].certifRg18.forEach(function (certif) {
        _this11.certificationRg18List.push({
          idCertificationRG18: certif.idCertificationRG18,
          cuit: certif.cuit,
          type: certif.type,
          since: certif.since,
          until: certif.until,
          name: certif.name
        });
      });
    },
    getCertificationRg17: function getCertificationRg17(id) {
      var _this12 = this;

      this.certificationRg17 = [];

      this.certificationRg17List.forEach(function (certif) {
        if (certif.idCertificationRG17 === id) {
          _this12.certificationRg17.push({
            id: certif.idCertificationRG2681,
            cuit: certif.cuit,
            type: certif.type,
            rg: certif.rg,
            percentage: certif.percentage,
            since: certif.since,
            until: certif.until,
            name: certif.name
          });
        }
      });
      this.showModalCertificationRg17 = true;
    },
    openCertificationRg17List: function openCertificationRg17List() {
      if (this.user !== null) {
        this.certificationRg17List = [];
        this.getCertificationRg17List();
      }
      this.showModalCertificationRg17List = true;
    },
    getCertificationRg17List: function getCertificationRg17List() {
      var _this13 = this;

      this.providers[0].certifRg17.forEach(function (certif) {
        _this13.certificationRg17List.push({
          idCertificationRG17: certif.idCertificationRG2681,
          cuit: certif.cuit,
          type: certif.type,
          rg: certif.rg,
          percentage: certif.percentage,
          since: certif.since,
          until: certif.until,
          name: certif.name
        });
      });
    },
    getStatusNameOfTab: function getStatusNameOfTab() {
      var tabIdCompanyStatus = this.provider[this.activeTab()].idCompanyDataStatus;
      this.statusType = this.types[tabIdCompanyStatus - 1];
      return this.getStatusName(tabIdCompanyStatus);
    },
    getStatusName: function getStatusName(idCompanyDataStatus) {
      return this.statusList.find(function (el) {
        return el.idCompanyDataStatus === idCompanyDataStatus;
      }).description;
    },
    activeTab: function activeTab() {
      return this.steps[this.step];
    },
    handleCloseCompanyDataRejection: function handleCloseCompanyDataRejection() {
      this.newObservation = '';
    },
    reSendCompanyData: function reSendCompanyData() {
      var _this14 = this;

      var valido = this.validateFormFromStep();
      if (!valido) {
        return;
      }
      this.setCurrentTimeStamp();
      console.log(this.timeStampModifDate);
      this.$confirm('¿Está seguro que desea aceptar los datos?', 'Advertencia', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(function () {
        _this14.provider['generalData'] = _this14.generalData;
        _this14.provider['taxData'] = _this14.taxData;
        _this14.provider['paymentData'] = _this14.paymentData;
        console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this14.generalData.company));
        console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this14.provider));
        console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this14.activeTab()));
        _this14.provider[_this14.activeTab()].idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION;
        _this14.provider.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION;
        _this14.provider[_this14.activeTab()].modifDate = _this14.timeStampModifDate;
        _this14.$store.state.userReturned = true;
        _this14.updateCompanyData(_this14.activeTab(), _this14.provider[_this14.activeTab()]);
        _this14.solicitudActivarUsuario();
        console.log(_this14.$store.state.userReturned + '_ OK');
      }).catch(function () {
        _this14.$store.commit('TOGGLE_LOADING');
      });
    },
    companyData: function companyData() {
      var _this15 = this;

      if (this.idCompany) {
        __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/ListCompanyData' + '?idCompany=' + this.idCompany + '&actualCountry=' + this.actualCountry).then(function (response) {
          var data = response.data;
          if (data.error) {
            return;
          }
          if (data) {
            _this15.providers = data;
            _this15.provider = _this15.providers[0];
            _this15.disabledGeneralData();
          }
        }).catch(function (error) {
          _this15.$store.commit('TOGGLE_LOADING');
          console.log(error);
        });
      }
    },
    setCurrentTimeStamp: function setCurrentTimeStamp() {
      var d = new Date();
      var currDate = d.getDate();
      var currMonth = d.getMonth() + 1;
      var currYear = d.getFullYear();
      var currHour = d.getHours();
      var currMinutes = d.getMinutes();
      var currSeconds = d.getSeconds();
      this.timeStampModifDate = '' + currYear + '-' + (currMonth <= 9 ? '0' + currMonth : currMonth) + '-' + (currDate <= 9 ? '0' + currDate : currDate) + ' ' + (currHour <= 9 ? '0' + currHour : currHour) + ':' + (currMinutes <= 9 ? '0' + currMinutes : currMinutes) + ':' + (currSeconds <= 9 ? '0' + currSeconds : currSeconds);
    },
    checkRoles: function checkRoles(currentStep) {
      var permission = false;
      this.user.roles.forEach(function (role) {
        switch (role.rolesId) {
          case __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DG:
            if (currentStep === 0) {
              permission = true;
            }
            break;
          case __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DI:
            if (currentStep === 2) {
              permission = true;
            }
            break;
          case __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DP:
            if (currentStep === 1) {
              permission = true;
            }
            break;
          case __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].ADMIN_SISTEMA:
            permission = true;
            break;
          default:
            break;
        }
      });
      return permission;
    },
    acceptCompanyData: function acceptCompanyData() {
      var _this16 = this;

      var solicitud = true;
      if (this.provider.idStage === '3') {
        solicitud = false;
      }
      var permission = this.checkRoles(this.step);
      if (!permission) {
        console.log('Permision es :' + permission);
        this.$router.push('/newProviders');
        this.$alert('No tiene los permisos requeridos para realizar esta accion', 'Permisos Insuficientes', {
          confirmButtonText: 'Aceptar',
          callback: function callback(action) {
            _this16.$router.push('/newProviders');
          }
        });
        return;
      }

      this.$confirm('¿Está seguro que desea aceptar los datos?', 'Advertencia', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(function () {
        _this16.provider[_this16.activeTab()] = _this16[_this16.activeTab()];
        _this16.provider[_this16.activeTab()].idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ACEPTADO;
        _this16.provider[_this16.activeTab()].idUser = _this16.user.idUser;
        _this16.provider.signUpStatus++;
        _this16.updateCompanyData(_this16.activeTab(), _this16.provider[_this16.activeTab()]);
        if (solicitud) {
          _this16.solicitudActivarUsuario();
        }
        _this16.$parent.getProviders();
        if (!_this16.checkRoles(_this16.step + 1)) {
          _this16.$router.push('/newProviders');
        }
      }).catch(function () {});
    },
    verifyPermission: function verifyPermission() {
      var _this17 = this;

      var permission = this.checkRoles(this.step);
      if (!permission) {
        this.$router.push('/newProviders');
        this.$alert('No tiene los permisos requeridos para realizar esta accion', 'Permisos Insuficientes', {
          confirmButtonText: 'Aceptar',
          callback: function callback(action) {
            _this17.$router.push('/newProviders');
          }
        });
        return;
      }
      this.rejectCompanyDataVisible = true;
    },
    rejectCompanyData: function rejectCompanyData() {
      var _this18 = this;

      if (this.newObservation === '') {
        this.$message.warning('Falta completar el motivo');
        return;
      }
      this.$confirm('¿Está seguro que desea rechazar los datos por este motivo?', 'Advertencia', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(function () {
        _this18.provider[_this18.activeTab()] = _this18[_this18.activeTab()];
        _this18.provider[_this18.activeTab()].idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].DEVUELTO;
        _this18.provider[_this18.activeTab()].idUser = _this18.user.idUser;
        _this18.provider[_this18.activeTab()].observation = _this18.newObservation;
        _this18.updateCompanyData(_this18.activeTab(), _this18.provider[_this18.activeTab()]);
        _this18.$router.push('/newProviders');
      }).catch(function () {});
    },
    isSystemAdmin: function isSystemAdmin() {
      var _this19 = this;

      if (this.user) {
        this.user.roles.forEach(function (role) {
          if (role.rolesId === __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].ADMIN_SISTEMA) {
            _this19.userIsAdmin = true;
          }
          if (role.rolesId === __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DG || role.rolesId === __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DI || role.rolesId === __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DP) {
            _this19.userByRoles = true;
          }
        });
      }
    },
    providerUpdateData: function providerUpdateData() {
      var _this20 = this;

      this.provider[this.activeTab()] = this[this.activeTab()];
      this.provider[this.activeTab()].idUser = this.user.idUser;
      this.provider[this.activeTab()].idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION;
      this.setCurrentTimeStamp();
      this.provider[this.activeTab()].modifDate = this.timeStampModifDate;
      this.provider.idCompanyStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION;
      this.provider.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].MODIFICADO;
      this.provider.isExport = '0';

      this.taxData.jurisdictions.forEach(function (jurisdiction) {
        if (!_this20.decimalCoefficient(jurisdiction.coefficient)) {
          _this20.notify('Coef. Unificado debe ser un número decimal');
          _this20.jurisdictionFlag = true;
        }
      });
      if (this.jurisdictionFlag) {
        this.jurisdictionFlag = false;
        return;
      } else {
        this.updateCompanyData(this.activeTab(), this.provider[this.activeTab()]);
      }
    },
    activationOrReject: function activationOrReject() {
      var _this21 = this;

      var genD = this.provider.generalData.idCompanyDataStatus;
      var payD = this.provider.paymentData.idCompanyDataStatus;
      var taxD = this.provider.taxData.idCompanyDataStatus;

      if (genD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ACEPTADO && payD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ACEPTADO && taxD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ACEPTADO) {
        this.provider.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ACEPTADO;
        this.provider.idCompanyStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ACEPTADO;
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/sendMailUserActivation/' + _this21.provider.idCompany).then(function () {});
        }, 900);
      } else {
        if (genD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].DEVUELTO || payD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].DEVUELTO || taxD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].DEVUELTO) {
          this.provider.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].DEVUELTO;
          this.provider.idCompanyStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].RECHAZADO;
          setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/sendMailUserReject/' + _this21.provider.idCompany).then(function () {});
          }, 900);
        }
      }
    },
    updateCompanyData: function updateCompanyData(dataType, data) {
      var _this22 = this;

      var genD = this.provider.generalData.idCompanyDataStatus;
      var payD = this.provider.paymentData.idCompanyDataStatus;
      var taxD = this.provider.taxData.idCompanyDataStatus;
      this.activationOrReject();

      if (genD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION) {
        this.provider.idStage = __WEBPACK_IMPORTED_MODULE_9__config_company_stage__["a" /* default */].DATOS_GENERALES;
      } else if (payD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION) {
        this.provider.idStage = __WEBPACK_IMPORTED_MODULE_9__config_company_stage__["a" /* default */].DATOS_BANCARIOS;
      } else if (taxD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION) {
        this.provider.idStage = __WEBPACK_IMPORTED_MODULE_9__config_company_stage__["a" /* default */].DATOS_IMPOSITIVOS;
      }

      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', 'api/generic/company/' + this.provider.idCompany, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.provider)).then(function () {
        console.log(dataType);
        var idCompanyData = void 0;
        switch (dataType) {
          case 'generalData':
            idCompanyData = _this22.provider.idCompany;
            break;
          case 'paymentData':
            idCompanyData = _this22.provider.idCompany;
            break;
          case 'taxData':
            idCompanyData = _this22.provider.idCompany;
            break;
        }
        _this22.$store.commit('START_LOADING');
        __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', 'api/generic/' + dataType + '/' + idCompanyData, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data)).then(function (response) {
          switch (dataType) {
            case 'generalData':
              _this22.provider.cuit = _this22.generalData.cuit;
              _this22.provider.company = _this22.generalData.company;
              _this22.provider.companyName = _this22.generalData.companyName;
              __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', 'api/generic/company/' + _this22.provider.idCompany, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this22.provider)).then(function () {
                __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/deleteRubrosFromCompany/' + _this22.provider.idCompany).then(function (response) {
                  _this22.generalData.rubros.forEach(function (item, index) {
                    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', 'api/generic/rubrosCompany/', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
                      idRubro: item,
                      idCompany: _this22.provider.idCompany
                    }));
                  });
                });
              });
              break;
          }
          _this22.rejectCompanyDataVisible = false;
          _this22.newObservation = '';
          _this22.$store.commit('STOP_LOADING');
          _this22.provider[dataType] = response.data;

          _this22.user.roles.forEach(function (role) {
            if (role.rolesId === __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DG && _this22.step === 0) {
              _this22.$router.push('/newProviders');
            }
            if (role.rolesId === __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DI && _this22.step === 1) {
              _this22.$router.push('/newProviders');
            }
            if (role.rolesId === __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DP && _this22.step === 2) {
              _this22.$router.push('/newProviders');
            }
          });

          _this22.$message.success('Estado cambiado satisfactoriamente');
        }).catch(function (error) {
          console.log(error);
          _this22.$store.commit('STOP_LOADING');
          _this22.$message.danger('Error al cambiar el estado');
        });
      });
    },
    isSantaFe: function isSantaFe(idJurisdiction) {
      var jurisdiction = this.jurisdictions.find(function (prov) {
        return prov.idJurisdictions === idJurisdiction;
      });
      if (jurisdiction) {
        return jurisdiction.jurisdictions === 'Santa Fe';
      }
      return false;
    },
    addDoc1276: function addDoc1276(idJurisdiction) {
      if (this.taxData.ibType === 'Local') {
        if (idJurisdiction === '13') {
          this.doc1276 = true;
        } else {
          this.doc1276 = false;
        }
      }
      if (this.taxData.ibType === 'Multilateral') {
        if (idJurisdiction === '13') {
          this.doc1276 = true;
        }
      }
    },
    coefficientValidate: function coefficientValidate(rule, value, callback) {
      if (!(value && Math.floor(value) <= 9 && value.toString().length === 6)) {
        callback(new Error());
      }
      callback();
    },
    aliquotValidate: function aliquotValidate(rule, value, callback) {
      if (!value) {
        callback();
      }
      if (!(value && Math.floor(value) <= 9 && value.toString().length === 4)) {
        callback(new Error());
      }
    },
    openModalTerminosYCond: function openModalTerminosYCond() {
      var valido = this.validateFormFromStep();
      if (valido) {
        this.terminosYCondVisible = true;
      }
    },
    openModalCertificateDetails: function openModalCertificateDetails(index) {
      this.activeJurisdiction = index;
      this.showModalCertificationDatosAdicionales = true;
    },
    openModalForm1276: function openModalForm1276(index) {
      this.activeJurisdiction = index;
      this.activeJurisdictionSantaFe = index;
      this.showModalForm1276 = true;
    },
    openModalRetentionAgent: function openModalRetentionAgent(index) {
      this.activeJurisdiction = index;
      this.taxData.jurisdictions[index].retentionAgentVisible = this.taxData.jurisdictions[index].retentionAgentHas === '1';
    },
    openModalPerceptionAgent: function openModalPerceptionAgent(index) {
      this.activeJurisdiction = index;
      this.taxData.jurisdictions[index].perceptionAgentVisible = this.taxData.jurisdictions[index].perceptionAgentHas === '1';
    },
    handleIbType: function handleIbType() {
      if (this.taxData.ibType === 'Multilateral' && this.taxData.jurisdictions.length === 1) {
        this.addJurisdiction();
      } else if (this.taxData.jurisdictions.length === 2) {
        this.deleteJurisdiction(this.taxData.jurisdictions[1]);
      }
    },
    addJurisdiction: function addJurisdiction() {
      this.taxData.jurisdictions.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.jurisdictionData));
    },
    deleteJurisdiction: function deleteJurisdiction(item) {
      var index = this.taxData.jurisdictions.indexOf(item);
      if (index !== -1) {
        this.taxData.jurisdictions.splice(index, 1);
      }
    },
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning('Solo se permite un archivo');
    },
    nextStep: function nextStep() {
      var valido = false;
      if (this.step === 2) {
        this.verifySantaFeJurisdiction();
        this.coeficienteValidacionTest();

        valido = this.validateFormFromStep();
        if (valido) {
          if (this.form1276loaded === true) {
            var that = this;
            this.$refs['taxDataForm'].validate(function (valid) {
              if (valid) {
                that.step++;
                that.disabledGeneralData();
              }
            });
          } else {
            this.step = 2;
            if (this.form1276loaded === false) {
              this.notify('Formulario 1276 obligatorio');
            }
            this.form1276loadedAux = true;
          }
        }
      } else {
        valido = this.validateFormFromStep();
        if (valido) {
          this.step++;
          this.disabledGeneralData();
        }
      }
      this.calculateHabModificaPdf();
    },
    previousStep: function previousStep() {
      this.step--;
      if (this.step === 2) {
        this.jurisdicciones = true;
      }
      this.disabledGeneralData();
      this.calculateHabModificaPdf();
    },
    previousStepView: function previousStepView() {
      this.step--;
    },
    nextStepView: function nextStepView() {
      this.step++;
    },
    validacionGeneralDataForm: function validacionGeneralDataForm() {
      if (!this.generalData.pdfAfip) {
        this.notify('Comprobante alta de AFIP es Obligatorio');
        return false;
      }
      return true;
    },
    validacionBanklDataForm: function validacionBanklDataForm() {
      if (!this.paymentData.pdfBank) {
        this.notify('Pdf de Constancia es Obligatorio');
        return false;
      }
      return true;
    },
    validacionTaxDataForm: function validacionTaxDataForm() {
      this.$refs['taxDataForm'].validate();
      if (!this.taxData.pdfIb) {
        this.notify('Formulario Constancia Ingresos Brutos Obligatorio');
        return false;
      } else if (this.taxData.ibType === 'Multilateral') {
        if (!this.taxData.idAgreementRegimeType) {
          this.notify('Se debe seleccionar un Regimen de Convenio de IIBB');
          return false;
        }
        if (!this.taxData.pdfCM05) {
          this.notify('Formulario CM05 Obligatorio');
          return false;
        }
        if (!this.taxData.jurisdictionHeadquarters) {
          this.notify('Debe seleccionar jurisdicción sede');
          return false;
        }
      } else if (this.taxData.ibType === 'Local') {
        if (!this.taxData.jurisdictionHeadquarters) {
          this.notify('Debe seleccionar jurisdicción sede');
          return false;
        }
      } else if (this.taxData.ibType === 'Exento') {
        if (!this.taxData.pdfsExempt || this.taxData.pdfsExempt === '') {
          this.notify('Formulario Contancia de Exento de IIBB es Obligatorio');
          return false;
        }
      } else if (!this.taxData.ibType) {
        this.notify('Se debe seleccionar un tipo de convenio de IIBB');
        return false;
      }
      if (!this.taxData.jurisdictions || !this.taxData.jurisdictions[0].aliquot && !this.taxData.jurisdictions[0].aliquota_value || !this.taxData.jurisdictions[0].coefficient) {
        this.notify('Faltan completar datos de jurisdicción de IIBB');
        return false;
      }

      if (!this.taxData.jurisdictionHeadquarters) {
        this.notify('Se debe seleccionar una Jurisdicción Sede de IIBB');
        return false;
      }

      if (!this.taxData.earningsRetentionType) {
        this.notify('Se debe seleccionar el tipo de Retención de Ganancias');
        return false;
      }

      if (this.taxData.ivaExclusionPdf !== '') {
        if (this.taxData.ivaIdCategoryRetain === '') {
          this.notify('Se debe seleccionar la Categoría a Retener de IVA');
          return false;
        }
      }

      if (this.taxData.earningsRetentionType === 'Inscripto') {
        if (!this.taxData.retentionRegimen) {
          this.notify('Debe informar el Regimen de Retención de Ganancias');
          return false;
        }
        if (!this.taxData.idEarningCategoryRetain) {
          this.notify('Debe informar la Categoría a Retener de Ganancias');
          return false;
        }
      }
      return true;
    },
    validateFormFromStep: function validateFormFromStep() {
      var formName = void 0;
      switch (this.step) {
        case 0:
          formName = 'generalDataForm';
          break;
        case 1:
          formName = 'paymentDataForm';
          break;
        case 2:
          formName = 'taxDataForm';
          break;
        case 3:
          formName = 'userDataForm';
          break;
      }
      var respuesta = void 0;
      respuesta = this.validateForm(formName);
      if (respuesta) {
        if (formName === 'generalDataForm') {
          respuesta = this.validacionGeneralDataForm();
        } else if (formName === 'paymentDataForm') {
          respuesta = this.validacionBanklDataForm();
        } else if (formName === 'taxDataForm') {
          respuesta = this.validacionTaxDataForm();
        }
      }
      return respuesta;
    },
    updateProvinces: function updateProvinces(idCountry) {
      this.generalData.idProvince = '';
      this.provinces = this.$store.state.provinces.filter(function (prov) {
        return prov.idCountry === idCountry;
      }).sort(function (a, b) {
        return a.province > b.province;
      });
    },
    updateRetentionCategory: function updateRetentionCategory(idRetention) {
      this.taxData.idEarningCategoryRetain = '';
      var temporal = this.$store.state.retentionCategories.filter(function (ret) {
        return ret.idRetentionRegime === idRetention;
      }).sort(function (a, b) {
        return a.categoryRetain > b.categoryRetain;
      });
      this.retentionCategories2 = temporal;
    },
    updateAliquot: function updateAliquot(idJurisdiction, index) {
      var _this23 = this;

      this.retentionCategoriesAliquot[index] = this.ibRetentionCategory.filter(function (ret) {
        return ret.idJurisdictions === idJurisdiction;
      }).sort(function (a, b) {
        return a.categoryRetain > b.categoryRetain;
      });
      if (this.provider.taxData.jurisdictions[index].aliquot) {
        var findAliquotName = this.ibRetentionCategory.filter(function (ret) {
          return ret.idCategoryRetain === _this23.provider.taxData.jurisdictions[index].aliquot;
        })[0].categoryRetain;
        this.provider.taxData.jurisdictions[index].aliquot = findAliquotName;
      }

      if (idJurisdiction === '13') {
        this.doc1276 = true;
      } else {
        this.doc1276 = false;
      }
    },
    updateIvaRetentionCategory: function updateIvaRetentionCategory(idRetention) {
      this.ivaRetentionCategories = this.$store.state.retentionCategoriesVAT.filter(function (ret) {
        return ret.idRetentionRegime === idRetention;
      }).sort(function (a, b) {
        return a.categoryRetain > b.categoryRetain;
      });
    },
    updateOtrosRetentionCategory: function updateOtrosRetentionCategory(idRetention) {
      this.otrosRetentionCategories = this.$store.state.retentionCategoriesOTROS.filter(function (ret) {
        return ret.idRetentionRegime === idRetention;
      }).sort(function (a, b) {
        return a.categoryRetain > b.categoryRetain;
      });
    },
    handlePdfResolutionIva: function handlePdfResolutionIva(response, file, fileList) {
      this.taxData.ivaResolutionPdf = response;
    },
    handlePdfExclusionIva: function handlePdfExclusionIva(response, file, fileList) {
      this.taxData.ivaExclusionPdf = response;
    },
    handlePdfExclusionSuss: function handlePdfExclusionSuss(response, file, fileList) {
      this.taxData.sussExclusionPdf = response;
    },
    handlePdfExclusionEarnings: function handlePdfExclusionEarnings(response, file, fileList) {
      this.taxData.earningsExclusionPdf = response;
    },
    handlePdfCertificate: function handlePdfCertificate(response, file, fileList) {
      this.taxData.jurisdictions[this.activeJurisdiction].certificatePdf = response;
    },
    handlePdfRetentionAgent: function handlePdfRetentionAgent(response, file, fileList) {
      this.taxData.jurisdictions[this.activeJurisdiction].retentionAgentPdf = response;
    },
    handlePdfForm1276: function handlePdfForm1276(response, file, fileList) {
      this.taxData.jurisdictions[this.activeJurisdiction].form1276pdf = response;
    },
    handlePdfPerceptionAgent: function handlePdfPerceptionAgent(response, file, fileList) {
      this.taxData.jurisdictions[this.activeJurisdiction].perceptionAgentPdf = response;
    },
    validateForm: function validateForm(formName) {
      var that = this;
      var validated = true;
      if (that.$refs[formName]) {
        that.$refs[formName].validate(function (valid) {
          if (!valid) {
            validated = valid;
          }
        });
      } else {
        validated = false;
      }
      return validated;
    },
    editCuit: function editCuit() {
      this.dataAfip = '';
    },
    nextPage: function nextPage() {
      this.step++;
    },
    submitFormSolicitud: function submitFormSolicitud() {
      this.solicitudActivarUsuario('1');
      if (this.checked2 === true && this.checked === true) {
        this.terminosYCondVisible = false;
        this.checkData();
      } else {
        this.checked2 = false;
        this.checked = false;
        this.terminosYCondVisible = true;
      }
    },
    clearInput: function clearInput(vueModel) {
      vueModel = '';
    },
    verifyCuit: function verifyCuit() {
      var _this24 = this;

      this.$refs['generalDataForm'].validateField('cuit', function (valid) {
        if (!valid) {
          _this24.$store.commit('START_LOADING');
          __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/getPersonaAfip/' + _this24.generalData.cuit).then(function (response) {
            if (typeof response.data === 'string') {
              _this24.dataAfip = '';
              _this24.$message({
                message: response.data.replace('Id', 'CUIT'),
                type: 'warning'
              });
            } else {
              if (!response.data.errorConstancia) {
                _this24.dataAfip = response.data.datosGenerales;
                if (_this24.dataAfip.tipoPersona === 'JURIDICA') {
                  _this24.generalData.company = _this24.dataAfip.razonSocial;
                } else {
                  _this24.generalData.company = (_this24.dataAfip.nombre ? _this24.dataAfip.nombre + ' ' : '') + _this24.dataAfip.apellido;
                }
                __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/allCertification/' + _this24.generalData.cuit).then(function (response) {
                  if (response.data['exgainCertification'].length === 0) {
                    _this24.auxFlagEmptyExgainList = true;
                  }
                  _this24.certificationExgainList = response.data['exgainCertification'];

                  _this24.certificationSussList = response.data['sussCertification'];
                  _this24.certificationRg18List = response.data['rg18Certification'];
                  _this24.certificationRg17List = response.data['rg17Certification'];
                  _this24.certificationRg2681List = response.data['rg2681Certification'];
                });
                _this24.$message({
                  message: 'CUIT verificado correctamente en AFIP',
                  type: 'success'
                });
              } else {
                var mensaje = '';
                if (typeof response.data.errorConstancia.error === 'string') {
                  mensaje = response.data.errorConstancia.error;
                } else {
                  mensaje = response.data.errorConstancia.error.join('\n');
                }
                _this24.$message({
                  message: 'Informa AFIP : \n' + mensaje,
                  type: 'error'
                });
              }
            }
            _this24.$store.commit('STOP_LOADING');
          }).catch(function (error) {
            console.log(error);
            _this24.$store.commit('STOP_LOADING');
          });
        }
      });
    },
    checkData: function checkData() {
      var _this25 = this;

      this.toggleLoading();
      this.resetResponse();
      this.$store.commit('TOGGLE_LOADING');

      var url = 'api/saveNewProvider';
      var url2 = '/login';
      if (this.user) {
        url = 'api/saveNewProviderRegister';
        url2 = '/providers';
      }
      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', url, {
        generalData: this.generalData,
        paymentData: this.paymentData,
        taxData: this.taxData,
        userData: this.userData
      }).then(function (response) {
        _this25.toggleLoading();
        var data = response.data;

        if (response.data.error) {
          var errorName = response.data.error.name;
          if (errorName) {
            console.log(errorName);
            _this25.checked = false;
            _this25.checked2 = false;
            if (errorName === 'InvalidArgumentError') {
              _this25.response = 'Los datos son incorrectos.';
            } else if (errorName === 'NotFoundError') {
              _this25.response = 'Se ha producido un error inesperado.';
            } else {
              _this25.response = errorName;
            }
          } else {
            _this25.response = data.error;
          }

          return;
        } else {
          if (data.success) {
            __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', 'api/sendSignUpMessage', {
              idEmisor: 1,
              idReceptor: response.data.idUser,
              message: 'Gracias por registrarse, Estamos revisando la información remitida',
              messageType: 1
            }).then(function (response) {});
            _this25.$alert('Sus datos se han remitido correctamente, muchas gracias!', 'Información Enviada', {
              confirmButtonText: 'Confirmar',
              callback: function callback(action) {
                _this25.$router.push(url2);
              }
            });
            _this25.success = data.success;
          }
        }
      }).catch(function (error) {
        _this25.$store.commit('TOGGLE_LOADING');
        _this25.invoices = null;
        console.log(error);

        _this25.response = error.response.data;
        _this25.toggleLoading();
      });
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'cargando' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
      this.success = '';
    },
    loadProvider: function loadProvider() {
      if (this.providerLoaded) {
        return;
      }
      this.providerLoaded = true;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.generalData, this.provider.generalData);
      this.generalData.cuit = parseInt(this.provider.cuit);
      this.generalData.company = this.provider.company;
      this.generalData.companyName = this.provider.companyName;
      this.generalData.rubros = this.provider.rubros.map(function (el) {
        return el.idRubro;
      });
      this.generalData.centrales = this.generalData.centrales = this.provider.generalData.centrales !== undefined ? this.provider.generalData.centrales.map(function (el) {
        return el;
      }) : undefined;
      this.updateProvinces(this.generalData.idCountry);
      this.updateRetentionCategory(this.provider.taxData.retentionRegimen);
      if (this.provider && this.provider.taxData) {
        if (this.provider.taxData.retentionRegimen) {
          this.updateRetentionCategory(this.provider.taxData.retentionRegimen);
        }
      }
      this.setIbJurisdiction();

      this.updateIvaRetentionCategory(this.provider.taxData.ivaIdRetentionRegime);
      this.updateOtrosRetentionCategory(this.provider.taxData.otrosIdRetentionRegime);

      this.generalData.idProvince = this.provider.generalData.idProvince;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.paymentData, this.provider.paymentData);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.taxData, this.provider.taxData);
      this.dataAfip = 'a';

      if (!this.idStep) {
        this.step = parseInt(this.provider.idStage - 1);
      }
      for (var key in this.provider) {
        if (!this.provider.hasOwnProperty(key)) continue;

        var obj = this.provider[key];
        if (obj && obj.hasOwnProperty('idCompanyDataStatus')) {
          if (obj.idCompanyDataStatus !== __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ACEPTADO) {
            this.disabledGeneralData();
            return;
          }
        }
      }
    },
    checkProviderData: function checkProviderData() {
      if (this.provider && this.idCompany) {
        this.loadProvider();
      } else {
        this.addJurisdiction();
      }
    },
    solicitudActivarUsuario: function solicitudActivarUsuario() {
      var _this26 = this;

      var stage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!stage) {
        stage = this.provider.idStage;
      }
      var companyName = this.provider.generalData.company;
      var idFiscal = this.provider.generalData.cuit;
      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/solicitudActivarUsuario' + '?stage=' + stage + '&idFiscal=' + idFiscal + '&companyName=' + companyName).then(function (response) {
        _this26.toggleLoading();
      }).catch(function (error) {
        _this26.$store.commit('TOGGLE_LOADING');
        _this26.invoices = null;
        console.log(error);

        _this26.response = 'Error al conectarse con el servidor, contacte al administrador.';
        _this26.toggleLoading();
      });
    },
    setIbJurisdiction: function setIbJurisdiction() {
      var _this27 = this;

      if (this.provider.taxData.jurisdictions) {
        setTimeout(function () {
          _this27.provider.taxData.jurisdictions.forEach(function (jur, index) {
            _this27.updateAliquot(jur['idJurisdiction'], index);
          });
        }, 500);
      }
    },
    getJurisdictionsHabilitadas: function getJurisdictionsHabilitadas() {
      var _this28 = this;

      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/getEnabledJurisdictions').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          console.log(data.data);
          _this28.jurisdictionsHabilitadas = data.data;
          console.log('store', _this28.$store.state.jurisdictions);
        }
      }).catch(function (error) {
        _this28.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    }
  },
  beforeMount: function beforeMount() {
    this.isSystemAdmin();
    this.companyData();
  },
  created: function created() {
    if (this.ibRetentionCategory.length === 0) {
      console.log('no hay ib retention category');
      this.$parent.getIbRetentionCategories();
    }
    console.log('hay ib retention category');
  },
  mounted: function mounted() {
    var _this29 = this;

    this.getJurisdictionsHabilitadas();
    if (this.user && this.user.isProvider && this.idCompany && this.idCompany !== this.user.company.idCompany) {
      this.$router.push('/');
    }
    this.checkProviderData();

    this.providerLoaded = false;
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('get', 'api/checkParam?id=AP-001').then(function (response) {
      var data = response.data;

      if (data.error) {
        if (!_this29.user) {
          _this29.paramError = data.error;
        }
      }
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('get', 'api/findConfiguration/TYC').then(function (response) {
      _this29.configuration = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('get', 'api/findConfiguration/CODETI').then(function (response) {
      _this29.codigoEtica = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('get', 'api/findConfiguration/POLANTI').then(function (response) {
      _this29.politicaAnticorrupcion = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('get', 'api/findConfiguration/POLREL').then(function (response) {
      _this29.politicaRelacionamiento = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('get', 'api/checkParam?id=SUF-001').then(function (response) {
      var data = response.data;

      if (data.error) {
        _this29.paramInvoices = data.error;
      }
    }).catch(function (error) {
      console.log(error);
    });
    if (this.idStep) {
      this.step = parseInt(this.idStep);
    }
    this.disabledGeneralData();
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MySteps_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MySteps_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__MySteps_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AltaID_vue__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AltaID_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__AltaID_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AltaFormElements_vue__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AltaFormElements_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__AltaFormElements_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_utils_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config_company_stage__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config_roles__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config_data_status__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuex__ = __webpack_require__(5);

















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'steps-pagination': __WEBPACK_IMPORTED_MODULE_6__MySteps_vue___default.a,
    'alta-id': __WEBPACK_IMPORTED_MODULE_7__AltaID_vue___default.a,
    'alta-form': __WEBPACK_IMPORTED_MODULE_8__AltaFormElements_vue___default.a
  },
  data: function data() {
    return {
      idType: 'RUC',
      status: __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */],
      countryId: 256,
      response: null,
      rejectCompanyDataVisible: false,
      newObservation: '',
      success: null,
      loading: '',
      editing: false,
      savedGeneralData: '',
      savedPaymentData: '',
      savedTaxData: '',
      generalDataAccepted: false,
      paymentDataAccepted: false,
      taxDataAccepted: false,
      generalDataRejected: false,
      paymentDataRejected: false,
      taxDataRejected: false,
      savedUserData: '',
      codCountry: 'PE',
      id: { model: '', dataType: 'ID' },
      emailSoporte: 'soporte@albanesi.com.ar',
      step: +this.$route.params.step,
      optionalPaymentFlag: { model: false, dataType: 'flag' },
      nextStepFlag: true,
      idStatus: 'accept',
      validateRuc: false,
      emptyFields: [],
      showTerminosYCondiciones: false,
      codigoEtica: '',
      politicaAnticorrupcion: '',
      politicaRelacionamiento: '',
      checked: false,
      checked2: false,
      provider: null,
      idCompany: this.$route.params.id,
      actualCountry: this.$route.params.country,
      idStep: this.$route.params.step,
      providerLoaded: false,
      locations: [],
      banks: [],
      bankAccountTypes: [],
      generalData: {
        company: {
          name: 'company',
          dataType: 'input',
          label: 'Razón Social / Denominación*',
          model: '',
          required: true
        },
        companyName: {
          name: 'companyName',
          dataType: 'input',
          label: 'Nombre comercial',
          model: '',
          required: false
        },
        activityField: {
          name: 'activityField',
          dataType: 'select',
          label: 'Campo de Actividad*',
          model: '',
          optionValue: [],
          placeholder: 'Seleccionar el Campo de actividad',
          required: true
        },
        country: {
          name: 'country',
          dataType: 'select',
          label: 'País*',
          model: 'Perú',
          optionValue: ['Perú'],
          placeholder: 'Seleccionar País',
          required: true
        },
        location: {
          name: 'location',
          dataType: 'select',
          label: 'Localidad*',
          model: '',
          optionValue: [],
          placeholder: 'Seleccionar Localidad',
          required: true
        },
        city: {
          name: 'city',
          dataType: 'input',
          label: 'Ciudad*',
          model: '',
          required: true
        },
        address: {
          name: 'address',
          name2: 'addressNumber',
          dataType: 'input-double',
          label: 'Calle*',
          label2: 'N°',
          model: '',
          model2: '',
          required: true
        },
        zip: {
          name: 'zip',
          dataType: 'input',
          label: 'Código Postal*',
          type: 'number',
          model: '',
          required: true
        },
        phone: {
          name: 'phone',
          dataType: 'input',
          label: 'Telefono*',
          type: 'number',
          model: '',
          required: true
        },
        email: {
          name: 'email',
          dataType: 'input',
          label: 'Email*',
          type: 'email',
          validate: 'email',
          model: '',
          required: true
        },
        pdfRuc: {
          name: 'pdfRuc',
          dataType: 'upload',
          label: 'Constancia de inscripcion RUC - Ficha RUC*',
          model: '',
          required: true
        }
      },
      paymentData1: {
        pdfPayment: {
          name: 'pdfPayment',
          dataType: 'upload',
          label: 'Instrucciones para acreditación de pagos*',
          model: '',
          required: true },
        bank: {
          name: 'bank',
          dataType: 'select',
          label: 'Banco*',
          model: '',
          optionValue: [],
          placeholder: 'Seleccionar Banco',
          required: true
        },
        bankAccount: {
          name: 'bankAccount',
          dataType: 'input',
          label: 'Nro de Cuenta*',
          validate: 'onlyNumbers',
          max: 11,
          model: '',
          required: true
        },
        accountType: {
          name: 'accountType',
          dataType: 'select',
          label: 'Tipo*',
          model: '',
          optionValue: ['Cuenta corriente', 'Tipo test 2'],
          placeholder: 'Seleccionar Tipo',
          required: true
        },
        currency: {
          name: 'currency',
          dataType: 'select',
          label: 'Moneda*',
          model: 'PEN',
          optionValue: ['PEN'],
          placeholder: 'Seleccionar Moneda',
          required: true
        },
        cciNumber: {
          name: 'cciNumber',
          dataType: 'input',
          label: 'Nro CCI*',
          max: 20,
          model: '',
          validate: 'onlyNumbers',
          required: true
        }
      },
      paymentData2: {
        bank2: {
          name: 'bank2',
          dataType: 'select',
          label: 'Banco',
          model: '',
          optionValue: [],
          placeholder: 'Seleccionar Banco',
          required: true
        },
        bankAccount2: {
          name: 'bankAccount2',
          dataType: 'input',
          label: 'Nro de Cuenta',
          max: 11,
          validate: 'onlyNumbers',
          model: '',
          required: true
        },
        accountType2: {
          name: 'accountType2',
          dataType: 'select',
          label: 'Tipo',
          model: '',
          optionValue: ['Cuenta corriente', 'Tipo test 2'],
          placeholder: 'Seleccionar Tipo',
          required: true
        },
        currency2: {
          name: 'currency2',
          dataType: 'select',
          label: 'Moneda',
          model: '',
          optionValue: ['PEN'],
          placeholder: 'Seleccionar Moneda',
          required: true
        },
        cciNumber2: {
          name: 'cciNumber2',
          dataType: 'input',
          label: 'Nro CCI',
          validate: 'onlyNumbers',
          max: 20,
          model: '',
          required: true
        }
      },
      paymentData3: {
        detractionBank: {
          name: 'detractionBank',
          dataType: 'input',
          label: 'Nro de Cuenta del Banco Nación*',
          max: 11,
          validate: 'onlyNumbers',
          model: '',
          required: true
        }
      },
      companyTaxData: {
        register: {
          name: 'register',
          dataType: 'input',
          label: 'Partida Registral',
          model: '',
          required: true
        },
        paymentType: {
          name: 'paymentType',
          dataType: 'select',
          label: 'Tipo de comprobantes a emitir',
          model: '',
          optionValue: ['Factura', 'ND', 'NC', 'RC por honorarios', 'Giros de remision'],
          placeholder: 'Seleccionar el tipo de comprobante',
          required: true
        },
        perceptionSwitch: {
          name: 'perceptionSwitch',
          dataType: 'switch-perception',
          label: 'Su empresa es agente de percepción?',
          model: false,
          companyDataPerception: {
            name: 'companyDataPerception',
            label: 'Alícuota*',
            model: '',
            required: true
          }
        },
        retentionSwitch: {
          name: 'retentionSwitch',
          dataType: 'switch-retention',
          label: 'Su empresa es agente de retención?',
          model: false,
          companyDataRetention: {
            name: 'companyDataRetention',
            label: 'Denominación*',
            model: '',
            optionValue: [],
            placeholder: 'Seleccionar el tipo de Denominación',
            required: true
          },
          companyRetentionFields: {
            name: 'companyRetentionFields',
            label: 'Alícuota*',
            model: '',
            placeholder: 'Seleccionar alicuota',
            required: true
          },
          companySuspensionNumber: {
            name: 'companySuspensionNumber',
            label: 'Número*',
            model: '',
            type: 'number',
            required: true
          },
          firstDate: {
            name: 'firstDate',
            model: '',
            required: true
          },
          lastDate: {
            name: 'lastDate',
            model: '',
            required: true
          },
          pdfSuspension: {
            name: 'pdfSuspension',
            model: '',
            label: 'Certificado de suspensión*',
            required: true
          }
        },
        detractionSwitch: {
          name: 'detractionSwitch',
          dataType: 'switch-detraction',
          label: 'Su empresa realiza actividades sujetas a detracción?',
          model: false
        }
      },
      userData: {
        userName: {
          name: 'name',
          dataType: 'input',
          label: 'Nombre y apellido',
          model: '',
          required: true
        },
        email: {
          name: 'email',
          dataType: 'input',
          label: 'Email',
          validate: 'email',
          model: '',
          required: true
        },
        password: {
          name: 'password',
          dataType: 'input',
          label: 'Contraseña',
          type: 'password',
          validate: 'password',
          model: '',
          required: true
        },
        repeatedPassword: {
          dataType: 'input',
          label: 'Repetir Contraseña',
          type: 'password',
          model: '',
          validate: 'repeated-password',
          samePassword: false,
          required: true
        }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_vuex__["b" /* mapState */])(['user']), {
    isProvider: function isProvider() {
      return this.user.isProvider;
    }
  }),
  watch: {
    provider: {
      immediate: true,
      handler: function handler(val) {
        this.loadProvider();
      }
    },
    'provider.generalData.idCompanyDataStatus': function providerGeneralDataIdCompanyDataStatus(newStatus) {
      if (newStatus === this.status.DEVUELTO && this.user.isProvider) {
        this.editing = true;
      }
    },
    'provider.taxData.idCompanyDataStatus': function providerTaxDataIdCompanyDataStatus(newStatus) {
      if (newStatus === this.status.DEVUELTO && this.user.isProvider) {
        this.editing = true;
      }
    },
    'provider.paymentData.idCompanyDataStatus': function providerPaymentDataIdCompanyDataStatus(newStatus) {
      if (newStatus === this.status.DEVUELTO && this.user.isProvider) {
        this.editing = true;
      }
    }
  },
  methods: {
    companyData: function companyData() {
      if (this.idCompany) {
        var that = this;
        __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('GET', 'api/ListCompanyData' + '?idCompany=' + this.idCompany + '&actualCountry=' + this.actualCountry).then(function (response) {
          var data = response.data;
          if (data.error) {
            return;
          }
          if (data) {
            that.providers = data;
            that.provider = that.providers[0];
          }
        }).catch(function (error) {
          that.$store.commit('TOGGLE_LOADING');
          console.log(error);
        });
      }
    },
    loadProvider: function loadProvider() {
      if (this.provider) {
        this.providerLoaded = true;
        this.id.model = this.provider.fiscalId;
        this.generalData.company.model = this.provider.generalData.company;
        this.generalData.companyName.model = this.provider.generalData.companyName;
        this.generalData.activityField.model = this.provider.generalData.activityField;
        this.generalData.location.model = this.provider.generalData.location;
        this.generalData.city.model = this.provider.generalData.city;
        this.generalData.address.model = this.provider.generalData.address;
        this.generalData.address.model2 = this.provider.generalData.addressNumber;
        this.generalData.zip.model = this.provider.generalData.zip;
        this.generalData.phone.model = this.provider.generalData.phone;
        this.generalData.email.model = this.provider.generalData.email;
        this.generalData.pdfRuc.model = this.provider.generalData.pdfRuc;

        this.companyTaxData.register.model = this.provider.taxData.register;
        this.companyTaxData.paymentType.model = this.provider.taxData.paymentType;
        this.companyTaxData.perceptionSwitch.model = this.provider.taxData.perceptionSwitch;
        this.companyTaxData.perceptionSwitch.companyDataPerception.model = this.provider.taxData.companyDataPerception;
        this.companyTaxData.retentionSwitch.model = this.provider.taxData.retentionSwitch;
        this.companyTaxData.retentionSwitch.companyDataRetention.model = this.provider.taxData.companyDataRetention;
        this.companyTaxData.retentionSwitch.companyRetentionFields.model = this.provider.taxData.companyRetentionFields;
        this.companyTaxData.retentionSwitch.companySuspensionNumber.model = this.provider.taxData.companySuspensionNumber;
        this.companyTaxData.retentionSwitch.firstDate.model = this.provider.taxData.firstDate;
        this.companyTaxData.retentionSwitch.lastDate.model = this.provider.taxData.lastDate;
        this.companyTaxData.retentionSwitch.pdfSuspension.model = this.provider.taxData.pdfSuspension;
        this.companyTaxData.detractionSwitch.model = this.provider.taxData.detractionSwitch;

        this.paymentData1.pdfPayment.model = this.provider.paymentData.pdfPayment;
        this.paymentData1.bank.model = this.provider.paymentData.bank;
        this.paymentData1.bankAccount.model = this.provider.paymentData.bankAccount;
        this.paymentData1.accountType.model = this.provider.paymentData.accountType;
        this.paymentData1.cciNumber.model = this.provider.paymentData.cciNumber;
        this.paymentData2.bank2.model = this.provider.paymentData.bank2;
        this.paymentData2.bankAccount2.model = this.provider.paymentData.bankAccount2;
        this.paymentData2.accountType2.model = this.provider.paymentData.accountType2;
        this.paymentData2.currency2.model = this.provider.paymentData.currency2;
        this.paymentData2.cciNumber2.model = this.provider.paymentData.cciNumber2;
        this.paymentData3.detractionBank.model = this.provider.paymentData.detractionBank;
      }
    },

    persistToNewProviderStorage: __WEBPACK_IMPORTED_MODULE_9__helpers_utils_js__["a" /* persistToNewProviderStorage */],
    saveDataToLocalStorage: __WEBPACK_IMPORTED_MODULE_9__helpers_utils_js__["b" /* saveDataToLocalStorage */],
    validateSteps: function validateSteps() {
      this.emptyFields = [];
      if (this.nextStepFlag === false && this.step === 0) {
        this.validateData(this.generalData);
      }
      if (this.nextStepFlag === false && this.step === 1) {
        this.validateCompanyTaxData();
        this.validateData(this.companyTaxData);
      }
      if (this.nextStepFlag === false && this.step === 2) {
        this.validateData(this.paymentData1);
        if (this.optionalPaymentFlag.model) {
          this.validateData(this.paymentData2);
        }
        if (this.companyTaxData.detractionSwitch.model) {
          this.validateData(this.paymentData3);
        }
      }
      if (this.step === 3) {
        this.validateData(this.userData);
      }
      console.log(this.emptyFields);
    },
    nextStep: function nextStep() {
      this.nextStepFlag = false;
      this.validateSteps();
      if (this.nextStepFlag === false) {
        return;
      }
      if (this.step++ >= 3) {
        this.step = 0;
        this.validateRuc = false;
      }
    },
    backStep: function backStep() {
      this.nextStepFlag = false;
      var actualStep = this.step;
      this.step = actualStep - 1;
    },
    goBackPage: function goBackPage() {
      window.history.back();
    },
    validateIDHandler: function validateIDHandler(id) {
      this.id = id;
      if (id !== '' && this.idStatus === 'accept') {
        this.idStatus = 'edit';
        this.verifyRuc(id.model);
      } else if (this.idStatus === 'edit') {
        this.idStatus = 'accept';
        this.validateRuc = false;
      }
    },
    validateData: function validateData(stepData) {
      for (var key in stepData) {
        var data = stepData[key];

        this.validateEmail(data);

        this.validateNumbers(data);

        this.validatePasswords(data);

        if (data.required && (data.model === '' || data.model2 === '')) {
          this.emptyFields.push(data.label);
          this.nextStepFlag = false;
        }
      }
      if (this.emptyFields.length === 0 && this.step < 3) {
        this.nextStepFlag = true;
      }
    },
    validateEmail: function validateEmail(data) {
      if (data.validate === 'email') {
        var regex = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
        if (!regex.test(data.model)) {
          this.nextStepFlag = false;
          this.emptyFields.push(data.label);
        }
      }
    },
    validateNumbers: function validateNumbers(data) {
      if (data.validate === 'onlyNumbers') {
        var regex = /^[0-9]+$/;
        if (!regex.test(data.model) || data.model.length < data.max) {
          this.nextStepFlag = false;
          this.emptyFields.push(data.label);
        }
      }
    },
    validatePasswords: function validatePasswords(data) {
      if (data.validate === 'password' && data.model !== this.userData.repeatedPassword.model) {
        this.userData.repeatedPassword.samePassword = false;
        this.nextStepFlag = false;
        this.emptyFields.push(data.label);
      } else if (data.validate === 'password' && data.model === this.userData.repeatedPassword.model) {
        this.userData.repeatedPassword.samePassword = true;
      }
    },
    validateCompanyTaxData: function validateCompanyTaxData() {
      var _companyTaxData = this.companyTaxData,
          perceptionSwitch = _companyTaxData.perceptionSwitch,
          retentionSwitch = _companyTaxData.retentionSwitch;
      var companyDataRetention = retentionSwitch.companyDataRetention,
          companyRetentionFields = retentionSwitch.companyRetentionFields,
          firstDate = retentionSwitch.firstDate,
          lastDate = retentionSwitch.lastDate,
          pdfSuspension = retentionSwitch.pdfSuspension,
          companySuspensionNumber = retentionSwitch.companySuspensionNumber;

      if (perceptionSwitch.model && !perceptionSwitch.companyDataPerception.model) {
        this.emptyFields.push(perceptionSwitch.companyDataPerception.label);
        this.nextStepFlag = false;
      }
      if (retentionSwitch.model) {
        if (!companyDataRetention.model.length) {
          this.emptyFields.push(companyDataRetention.label);
          this.nextStepFlag = false;
        }
        if (!companyRetentionFields.model.length) {
          this.emptyFields.push(companyRetentionFields.label);
          this.nextStepFlag = false;
        }
        if (companyDataRetention.model.includes('Retencion Detracciones') && (!firstDate.model || !lastDate.model || !pdfSuspension.model || !companySuspensionNumber.model)) {
          this.emptyFields.push(companyDataRetention.label);
          this.nextStepFlag = false;
        }
      }
      if (!this.emptyFields.length) {
        this.nextStepFlag = true;
      }
    },
    recoverFromNewProviderStorage: function recoverFromNewProviderStorage() {
      var inputType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var inputId = arguments[1];

      var newProvider = JSON.parse(localStorage.getItem('newProviderPeru'));
      if (!newProvider) {
        return {};
      }
      var data = newProvider[inputId];
      if (!data) {
        return {};
      }
      if (inputType['dataType'] === 'ID' || inputType['dataType'] === 'flag') {
        inputType['model'] = data;
      }
      var input = inputType[inputId];
      if (!input) {
        return data;
      }
      var dataType = input.dataType;

      if (['input', 'select', 'upload', 'switch-detraction'].includes(dataType)) {
        input.model = data;
      }
      if (dataType === 'input-double') {
        input.model = data;
        input.model2 = data;
      }
      if (dataType === 'switch-perception') {
        input.model = data;
        input.companyDataPerception.model = newProvider.companyDataPerception;
      }
      if (dataType === 'switch-retention') {
        inputType[inputId].model = data;
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(input).forEach(function (value) {
          if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(value)) === 'object') {
            value.model = newProvider[value.name];
          }
        });
      }
      return data;
    },
    checkData: function checkData() {
      var _this = this;

      this.toggleLoading();
      this.resetResponse();
      this.manageDataObjects();
      this.$store.commit('TOGGLE_LOADING');

      var url = 'api/saveNewProvider';
      var url2 = '/login';
      if (this.user) {
        url = 'api/saveNewProviderRegister';
        url2 = '/providers';
      }
      __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('POST', url, {
        generalData: this.savedGeneralData,
        paymentData: this.savedPaymentData,
        taxData: this.savedTaxData,
        userData: this.savedUserData
      }).then(function (response) {
        _this.toggleLoading();
        var data = response.data;

        if (response.data.error) {
          var errorName = response.data.error.name;
          if (errorName) {
            console.log(errorName);
            _this.checked = false;
            _this.checked2 = false;
            if (errorName === 'InvalidArgumentError') {
              _this.response = 'Los datos son incorrectos.';
            } else if (errorName === 'NotFoundError') {
              _this.response = 'Se ha producido un error inesperado.';
            } else {
              _this.response = errorName;
            }
          } else {
            _this.response = data.error;
          }

          return;
        } else {
          if (data.success) {
            __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('POST', 'api/sendSignUpMessage', {
              idEmisor: 1,
              idReceptor: response.data.idUser,
              message: 'Gracias por registrarse, Estamos revisando la información remitida',
              messageType: 1
            }).then(function (response) {});
            _this.$alert('Sus datos se han remitido correctamente, muchas gracias!', 'Información Enviada', {
              confirmButtonText: 'Confirmar',
              callback: function callback(action) {
                _this.$router.push(url2);
              }
            });
            _this.success = data.success;
          }
        }
      }).catch(function (error) {
        _this.$store.commit('TOGGLE_LOADING');
        _this.invoices = null;
        console.log(error.response);
        _this.response = 'Se ha producido un error, verifique los datos, en caso de persisitir, comuniquese con soporte.';
        if (error.response.data) {
          var err = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(error.response.data)[0];
          _this.response = error.response.data[err][0];
        }
        console.log(_this.response);
        _this.toggleLoading();
      });
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'cargando' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
      this.success = '';
    },
    extractFieldValues: function extractFieldValues(data) {
      var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var extractedData = {};
      for (var key in data) {
        if (enabled) {
          if (data.hasOwnProperty(key)) {
            extractedData[data[key].name] = data[key].model;
          }
        }
        if (!enabled) {
          if (data.hasOwnProperty(key)) {
            extractedData[data[key].name] = '';
          }
        }
      }
      return extractedData;
    },
    manageDataObjects: function manageDataObjects() {
      var generalData = {};
      var paymentData = {};
      var taxData = {};
      var userData = {};
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(generalData, this.extractFieldValues(this.generalData));
      generalData['ruc'] = this.id.model;
      generalData['' + this.generalData.address.name2] = this.generalData.address.model2;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(paymentData, this.extractFieldValues(this.paymentData1));
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(paymentData, this.extractFieldValues(this.paymentData2));
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(paymentData, this.extractFieldValues(this.paymentData3));
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(taxData, this.extractFieldValues(this.companyTaxData));
      taxData['' + this.companyTaxData.perceptionSwitch.companyDataPerception.name] = this.companyTaxData.perceptionSwitch.companyDataPerception.model;
      taxData['' + this.companyTaxData.retentionSwitch.companyDataRetention.name] = this.companyTaxData.retentionSwitch.companyDataRetention.model;
      taxData['' + this.companyTaxData.retentionSwitch.companyRetentionFields.name] = this.companyTaxData.retentionSwitch.companyRetentionFields.model;
      taxData['' + this.companyTaxData.retentionSwitch.companySuspensionNumber.name] = this.companyTaxData.retentionSwitch.companySuspensionNumber.model;
      taxData['' + this.companyTaxData.retentionSwitch.firstDate.name] = this.companyTaxData.retentionSwitch.firstDate.model;
      taxData['' + this.companyTaxData.retentionSwitch.lastDate.name] = this.companyTaxData.retentionSwitch.lastDate.model;
      taxData['' + this.companyTaxData.retentionSwitch.pdfSuspension.name] = this.companyTaxData.retentionSwitch.pdfSuspension.model;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(userData, this.extractFieldValues(this.userData));
      this.savedGeneralData = generalData;
      this.savedTaxData = taxData;
      this.savedPaymentData = paymentData;
      this.savedUserData = userData;
    },
    getLocations: function getLocations() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('GET', 'api/getProvincesByCountry?countryId=' + this.countryId).then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this2.locations = data;
          data.data.forEach(function (location) {
            _this2.generalData.location.optionValue.push(location.codRegion);
          });
        }
      }).catch(function (error) {
        _this2.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getRubros: function getRubros() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('GET', 'api/getRubrosPeru').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          data.data.forEach(function (activity) {
            _this3.generalData.activityField.optionValue.push(activity.activity);
          });
        }
      }).catch(function (error) {
        _this3.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getDenomination: function getDenomination() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('GET', 'api/getRetentionRegimenCountry?codCountry=' + this.codCountry).then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          data.data.forEach(function (regime) {
            _this4.companyTaxData.retentionSwitch.companyDataRetention.optionValue.push({ 'retentionRegime': regime.retentionRegime, 'idRetentionRegime': regime.idRetentionRegime });
          });
        }
      }).catch(function (error) {
        _this4.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getBank: function getBank() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('GET', 'api/getBankByCountry?codCountry=' + this.codCountry).then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this5.banks = data;
          data.data.forEach(function (bankData) {
            _this5.paymentData1.bank.optionValue.push(bankData.bank);
            _this5.paymentData2.bank2.optionValue.push(bankData.bank);
          });
        }
      }).catch(function (error) {
        _this5.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    verifyRuc: function verifyRuc(ruc) {
      var _this6 = this;

      var cachedData = JSON.parse(localStorage.getItem('newProvider'));

      this.$store.commit('START_LOADING');
      __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('GET', 'api/getPersonaSunat/' + ruc).then(function (response) {
        if (typeof response.data === 'string') {
          _this6.dataAfip = '';
          _this6.$message({
            message: response.data.replace('Id', 'RUC'),
            type: 'warning'
          });
        } else {
          _this6.validateRuc = true;
          if (!response.data.errorConstancia) {
            _this6.dataAfip = response.data.datosGenerales;
            if (_this6.dataAfip.tipoPersona === 'JURIDICA') {
              _this6.generalData.company = _this6.dataAfip.razonSocial;
            } else if (!cachedData.company) {
              _this6.generalData.company = (_this6.dataAfip.nombre ? _this6.dataAfip.nombre + ' ' : '') + _this6.dataAfip.apellido;
            }
            __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('GET', 'api/allCertification/' + _this6.generalData.cuit).then(function (response) {
              if (response.data['exgainCertification'].length === 0) {
                _this6.auxFlagEmptyExgainList = true;
              }
              _this6.certificationExgainList = response.data['exgainCertification'];

              _this6.certificationSussList = response.data['sussCertification'];
              _this6.certificationRg18List = response.data['rg18Certification'];
              _this6.certificationRg17List = response.data['rg17Certification'];
              _this6.certificationRg2681List = response.data['rg2681Certification'];
            });
            _this6.$message({
              message: 'RUC verificado correctamente en SUNAT',
              type: 'success'
            });
          } else {
            var mensaje = '';
            if (typeof response.data.errorConstancia.error === 'string') {
              mensaje = response.data.errorConstancia.error;
            } else {
              mensaje = response.data.errorConstancia.error.join('\n');
            }
            _this6.$message({
              message: 'Informa SUNAT: \n' + mensaje,
              type: 'error'
            });
          }
        }
        _this6.$store.commit('STOP_LOADING');
      }).catch(function (error) {
        _this6.$store.commit('STOP_LOADING');
        if (error && error.response && error.response.status === '400') {
          _this6.$message({
            message: error.response.data,
            type: 'error'
          });
        } else {
          _this6.$message.error('Error conectando con el servidor');
        }
      });
    },
    modifyData: function modifyData(dataType) {
      var _this7 = this;

      this.$confirm('Sus Datos se remitirán a Albanesi para su verificación', 'Atención', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(function () {
        _this7.editing = false;
        _this7.solicitudActivarUsuario();
        _this7.saveData(dataType);
      });
    },
    saveData: function saveData(dataType) {
      var generalData = {};
      var paymentData = {};
      var taxData = {};
      if (dataType === __WEBPACK_IMPORTED_MODULE_11__config_company_stage__["a" /* default */].DATOS_GENERALES_NAME) {
        generalData = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, this.extractFieldValues(this.generalData));
        generalData['' + this.generalData.address.name2] = this.generalData.address.model2;
        this.updateCompanyData(dataType, generalData);
      }
      if (dataType === __WEBPACK_IMPORTED_MODULE_11__config_company_stage__["a" /* default */].DATOS_BANCARIOS_NAME) {
        paymentData = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, this.extractFieldValues(this.paymentData1));
        if (this.optionalPaymentFlag.model) {
          paymentData = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, paymentData, this.extractFieldValues(this.paymentData2));
        } else {
          paymentData = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, paymentData, this.extractFieldValues(this.paymentData2, false));
        }
        if (this.companyTaxData.detractionSwitch.model) {
          paymentData = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, paymentData, this.extractFieldValues(this.paymentData3));
        } else {
          paymentData = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, paymentData, this.extractFieldValues(this.paymentData3, false));
        }
        this.updateCompanyData(dataType, paymentData);
      }
      if (dataType === __WEBPACK_IMPORTED_MODULE_11__config_company_stage__["a" /* default */].DATOS_IMPOSITIVOS_NAME) {
        taxData = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, this.extractFieldValues(this.companyTaxData));
        taxData['' + this.companyTaxData.perceptionSwitch.companyDataPerception.name] = this.companyTaxData.perceptionSwitch.companyDataPerception.model;
        if (this.companyTaxData.perceptionSwitch.model) {} else {
          taxData['' + this.companyTaxData.perceptionSwitch.companyDataPerception.name] = '';
        }
        if (this.companyTaxData.retentionSwitch.model) {
          taxData['' + this.companyTaxData.retentionSwitch.companyDataRetention.name] = this.companyTaxData.retentionSwitch.companyDataRetention.model;
          taxData['' + this.companyTaxData.retentionSwitch.companyRetentionFields.name] = this.companyTaxData.retentionSwitch.companyRetentionFields.model;
          taxData['' + this.companyTaxData.retentionSwitch.companySuspensionNumber.name] = this.companyTaxData.retentionSwitch.companySuspensionNumber.model;
          taxData['' + this.companyTaxData.retentionSwitch.firstDate.name] = this.companyTaxData.retentionSwitch.firstDate.model;
          taxData['' + this.companyTaxData.retentionSwitch.lastDate.name] = this.companyTaxData.retentionSwitch.lastDate.model;
          taxData['' + this.companyTaxData.retentionSwitch.pdfSuspension.name] = this.companyTaxData.retentionSwitch.pdfSuspension.model;
        } else {
          taxData['' + this.companyTaxData.retentionSwitch.companyDataRetention.name] = '';
          taxData['' + this.companyTaxData.retentionSwitch.companyRetentionFields.name] = '';
          taxData['' + this.companyTaxData.retentionSwitch.companySuspensionNumber.name] = '';
          taxData['' + this.companyTaxData.retentionSwitch.firstDate.name] = '';
          taxData['' + this.companyTaxData.retentionSwitch.lastDate.name] = '';
          taxData['' + this.companyTaxData.retentionSwitch.pdfSuspension.name] = '';
        }
        this.updateCompanyData(dataType, taxData);
      }
    },
    clearOptionalPaymentData: function clearOptionalPaymentData(switchValue) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helpers_utils_js__["b" /* saveDataToLocalStorage */])(switchValue, 'paymentFlag');
      for (var key in this.paymentData2) {
        if (this.paymentData2.hasOwnProperty(key)) {
          this.paymentData2[key].model = '';
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helpers_utils_js__["b" /* saveDataToLocalStorage */])('', key);
        }
      }
    },
    updateCompanyData: function updateCompanyData(dataType, data) {
      var _this8 = this;

      var originalStage = this.provider.idStage;

      if (dataType === __WEBPACK_IMPORTED_MODULE_11__config_company_stage__["a" /* default */].DATOS_GENERALES_NAME) {
        data.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION;
        this.provider.idStage = __WEBPACK_IMPORTED_MODULE_11__config_company_stage__["a" /* default */].DATOS_GENERALES;
        this.provider.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION;
      }
      if (dataType === __WEBPACK_IMPORTED_MODULE_11__config_company_stage__["a" /* default */].DATOS_IMPOSITIVOS_NAME) {
        data.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION;
        this.provider.idStage = __WEBPACK_IMPORTED_MODULE_11__config_company_stage__["a" /* default */].DATOS_BANCARIOS;
        this.provider.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION;
      }
      if (dataType === __WEBPACK_IMPORTED_MODULE_11__config_company_stage__["a" /* default */].DATOS_BANCARIOS_NAME) {
        data.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION;
        this.provider.idStage = __WEBPACK_IMPORTED_MODULE_11__config_company_stage__["a" /* default */].DATOS_IMPOSITIVOS;
        this.provider.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION;
      }

      __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('POST', 'api/generic/company/' + this.provider.idCompany, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.provider)).then(function () {
        var idCompanyData = void 0;
        switch (dataType) {
          case __WEBPACK_IMPORTED_MODULE_11__config_company_stage__["a" /* default */].DATOS_GENERALES_NAME:
            idCompanyData = _this8.provider.idCompany;
            break;
          case __WEBPACK_IMPORTED_MODULE_11__config_company_stage__["a" /* default */].DATOS_BANCARIOS_NAME:
            idCompanyData = _this8.provider.idCompany;
            break;
          case __WEBPACK_IMPORTED_MODULE_11__config_company_stage__["a" /* default */].DATOS_IMPOSITIVOS_NAME:
            idCompanyData = _this8.provider.idCompany;
            break;
        }
        _this8.$store.commit('START_LOADING');
        __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('POST', 'api/generic/' + dataType + '/' + idCompanyData, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)).then(function (response) {
          switch (dataType) {
            case 'generalData':
              _this8.provider.ruc = _this8.generalData.ruc;
              _this8.provider.company = _this8.generalData.company.model;
              _this8.provider.companyName = _this8.generalData.companyName.model;
              __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('POST', 'api/generic/company/' + _this8.provider.idCompany, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this8.provider));
              break;
          }

          _this8.provider.idStage = originalStage;

          _this8.$store.commit('STOP_LOADING');
          _this8.provider[dataType] = response.data;

          _this8.user.roles.forEach(function (role) {
            if (role.rolesId === __WEBPACK_IMPORTED_MODULE_12__config_roles__["a" /* default */].AUTORIZADOR_DG && _this8.step === 0) {
              _this8.$router.push('/newProviders');
            }
            if (role.rolesId === __WEBPACK_IMPORTED_MODULE_12__config_roles__["a" /* default */].AUTORIZADOR_DI && _this8.step === 1) {
              _this8.$router.push('/newProviders');
            }
            if (role.rolesId === __WEBPACK_IMPORTED_MODULE_12__config_roles__["a" /* default */].AUTORIZADOR_DP && _this8.step === 2) {
              _this8.$router.push('/newProviders');
            }
          });

          _this8.$message.success('Estado cambiado satisfactoriamente');
        }).catch(function (error) {
          console.log(error);
          _this8.$store.commit('STOP_LOADING');
        });
      });
    },
    rejectCompanyData: function rejectCompanyData(dataType) {
      var _this9 = this;

      if (this.newObservation === '') {
        this.$message.warning('Falta completar el motivo');
        return;
      }
      this.$confirm('¿Está seguro que desea rechazar los datos por este motivo?', 'Advertencia', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(function () {
        if (dataType === 'generalData') {
          _this9.generalDataRejected = true;
        }
        if (dataType === 'paymentData') {
          _this9.paymentDataRejected = true;
        }
        if (dataType === 'taxData') {
          _this9.taxDataRejected = true;
        }
        _this9.saveData(dataType);
        _this9.$router.push('/newProviders');
      }).catch(function () {});
    },
    getBankAccountTypes: function getBankAccountTypes() {
      var _this10 = this;

      __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('GET', 'api/generic/bankAccountType').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          var accountTypes = data.filter(function (bankAccountType) {
            return bankAccountType.codCountry === 'PE';
          });
          _this10.bankAccountTypes = data.filter(function (bankAccountType) {
            return bankAccountType.codCountry === 'PE';
          });
          _this10.paymentData1.accountType.optionValue = accountTypes.map(function (accountType) {
            return accountType.bankAccountType;
          });
          _this10.paymentData2.accountType2.optionValue = accountTypes.map(function (accountType) {
            return accountType.bankAccountType;
          });
        }
      }).catch(function (error) {
        _this10.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    openModalTerminosYCondiciones: function openModalTerminosYCondiciones() {
      this.validateSteps();
      if (this.emptyFields.length === 0) {
        this.showTerminosYCondiciones = true;
      }
    },
    submitFormSolicitud: function submitFormSolicitud() {
      this.solicitudActivarUsuario('1');
      if (this.checked2 && this.checked) {
        this.showTerminosYCondiciones = false;
        this.checkData();
      } else {
        this.checked2 = false;
        this.checked = false;
        this.showTerminosYCondiciones = true;
      }
    },
    solicitudActivarUsuario: function solicitudActivarUsuario() {
      var _this11 = this;

      var stage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var companyName = this.generalData.company;
      var idFiscal = this.generalData.cuit;
      if (!stage) {
        stage = this.provider.idStage;
      }
      __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('GET', 'api/solicitudActivarUsuario' + '?stage=' + stage + '&idFiscal=' + idFiscal + '&companyName=' + companyName).then(function (response) {
        _this11.toggleLoading();
      }).catch(function (error) {
        _this11.$store.commit('TOGGLE_LOADING');
        _this11.invoices = null;
        console.log(error);

        _this11.response = 'Error al conectarse con el servidor, contacte al administrador.';
        _this11.toggleLoading();
      });
    },
    checkProviderData: function checkProviderData() {
      if (this.provider && this.idCompany) {
        this.loadProvider();
      }
    },
    acceptCompanyData: function acceptCompanyData(StepType) {
      var _this12 = this;

      var solicitud = true;
      if (this.provider.idStage === '2') {
        solicitud = false;
      }

      this.$confirm('¿Está seguro que desea aceptar los datos?', 'Advertencia', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(function () {
        if (StepType === 'generalData') {
          _this12.generalDataAccepted = true;
        }
        if (StepType === 'paymentData') {
          _this12.paymentDataAccepted = true;
        }
        if (StepType === 'taxData') {
          _this12.taxDataAccepted = true;
        }

        _this12.saveData(StepType);
        _this12.$router.push('/newProviders');
        if (solicitud) {
          _this12.solicitudActivarUsuario();
        }
        _this12.$parent.getProviders();
        if (!_this12.checkRoles(_this12.step + 1)) {
          _this12.$router.push('/newProviders');
        }
      }).catch(function () {});
    }
  },
  beforeMount: function beforeMount() {
    this.idCompany = this.$route.params.id;
    this.actualCountry = this.$route.params.country;
    this.companyData();
    this.getBankAccountTypes();
    this.checkProviderData();
    this.getRubros();
    this.getLocations();
    this.getDenomination();
    this.getBank();
  },
  mounted: function mounted() {
    var _this13 = this;

    this.recoverFromNewProviderStorage(this.id, 'id');

    for (var key in this.generalData) {
      this.recoverFromNewProviderStorage(this.generalData, key);
    }

    for (var _key in this.companyTaxData) {
      this.recoverFromNewProviderStorage(this.companyTaxData, _key);
    }

    for (var _key2 in this.paymentData1) {
      this.recoverFromNewProviderStorage(this.paymentData1, _key2);
    }
    this.recoverFromNewProviderStorage(this.optionalPaymentFlag, 'paymentFlag');
    for (var _key3 in this.paymentData2) {
      this.recoverFromNewProviderStorage(this.paymentData2, _key3);
    }
    for (var _key4 in this.paymentData3) {
      this.recoverFromNewProviderStorage(this.paymentData3, _key4);
    }

    for (var _key5 in this.userData) {
      this.recoverFromNewProviderStorage(this.userData, _key5);
    }
    __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('get', 'api/findConfiguration/TYC').then(function (response) {
      _this13.configuration = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('get', 'api/findConfiguration/CODETI').then(function (response) {
      _this13.codigoEtica = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('get', 'api/findConfiguration/POLANTI').then(function (response) {
      _this13.politicaAnticorrupcion = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('get', 'api/findConfiguration/POLREL').then(function (response) {
      _this13.politicaRelacionamiento = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_date_picker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_text_mask__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_the_mask__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_company_stage__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_roles__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config_data_status__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PdfFile_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PdfFile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__PdfFile_vue__);





__webpack_require__(0);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConfirmProvider',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_4_vue_date_picker___default.a, TheMask: __WEBPACK_IMPORTED_MODULE_7_vue_the_mask___default.a, MaskedInput: __WEBPACK_IMPORTED_MODULE_5_vue_text_mask___default.a, PdfFile: __WEBPACK_IMPORTED_MODULE_12__PdfFile_vue___default.a },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])(['banks', 'user', 'bankBranches', 'accountTypes', 'regimenTypes', 'jurisdictions', 'retentionRegimes', 'retentionRegimesVAT', 'retentionRegimesOTROS', 'retentionCategories', 'retentionCategoriesVAT', 'retentionCategoriesOTROS', 'ibRetentionCategory']), {
    services: function services() {
      var services = this.$store.state.services;
      if (services.sort) {
        return services.sort(function (a, b) {
          return a.nombre > b.nombre;
        });
      }
    },
    actualCountryFull: function actualCountryFull() {
      if (this.actualCountry === 'AR') {
        return 'Argentina';
      }
      if (this.actualCountry === 'PE') {
        return 'Perú';
      }
    },
    countries: function countries() {
      if (this.$store.state.countries) {
        return this.$store.state.countries.sort(function (a, b) {
          return a.country > b.country;
        });
      }
    },
    sussRetentionCategory: function sussRetentionCategory() {
      var lista = this.$store.state.sussRetentionCategory.sort(function (a, b) {
        return a.categoryRetain > b.categoryRetain;
      });
      if (this.taxData.sussRetentionRegimen === '0') {
        return lista;
      } else {
        lista = lista.filter(function (a) {
          var auxiliar = a.auxiliar;
          var agenteRet = JSON.parse(auxiliar)['AgenteRet'] === 'true';
          if (agenteRet) {
            return a;
          }
        });
        return lista;
      }
    },
    groupCompanies: function groupCompanies() {
      return this.$store.state.groupCompanies.sort(function (a, b) {
        return a.groupCompany > b.groupCompany;
      });
    },
    storeRetentionRegime: function storeRetentionRegime() {
      return this.$store.state.retentionRegimes;
    },
    retentionRegimeList: function retentionRegimeList() {
      return this.$store.state.retentionRegimes.filter(function (el) {
        return el.idRetentionRegime === '3';
      });
    },
    statusList: function statusList() {
      return this.$store.state.companyDataStatus;
    }
  }),
  data: function data(router) {
    return {
      jurisdictionsHabilitadas: [],
      jurisdicciones: true,
      jurisdictionFlag: false,
      status: __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */],
      userIsAdmin: false,
      userByRoles: false,
      otrosRetentionCategories: [],
      retentionCategories2: [],
      retentionCategoriesAliquot: [],
      ivaRetentionCategories: [],
      disabledDates: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },

      doc1276: false,
      jurisdictionSantaFe: '',
      auxJurId: '',
      provider: '',
      actualCountry: '',
      providerLoaded: false,
      rejectCompanyDataVisible: false,
      disabledData: false,
      habModificaPdf: false,
      error: null,
      newObservation: '',
      statusType: '',
      types: ['warning', 'success', 'danger'],
      steps: ['generalData', 'paymentData', 'taxData'],
      idCompany: this.$route.params.id,
      idStep: this.$route.params.step,
      showModalCertificationExgain: false,
      showModalCertificationsExgainList: false,
      certificationExgainList: [],
      auxFlagEmptyExgainList: false,
      certificationExgain: [],
      showModalCertificationDatosAdicionales: false,
      showModalForm1276: false,
      showModalCertificationRg2681: false,
      showModalCertificationRg2681List: false,
      certificationRg2681List: [],
      certificationRg2681: [],
      showModalCertificationSussList: false,
      showModalCertificationSuss: false,
      certificationSussList: [],
      certificationSuss: [],
      showModalCertificationRg18List: false,
      showModalCertificationRg18: false,
      certificationRg18List: [],
      certificationRg18: [],
      showModalCertificationRg17List: false,
      showModalCertificationRg17: false,
      certificationRg17List: [],
      certificationRg17: [],
      checked2: false,
      aliquotData: {},
      step: 0,
      timeStampModifDate: '',
      editing: false,
      serverURI: __WEBPACK_IMPORTED_MODULE_8__config__["a" /* default */].serverURI,
      section: 'Solicitud',
      loading: '',
      providers: [],
      rut: '',
      options: [{
        value: '',
        label: ''
      }],
      dataAfip: '',
      value: '',
      configuration: '',
      jwt: window.localStorage.getItem('token'),
      codigoEtica: '',
      politicaAnticorrupcion: '',
      politicaRelacionamiento: '',
      response: null,
      success: null,
      paramError: null,
      provinces: [],
      centrales: [],
      activeJurisdiction: '',
      activeJurisdictionSantaFe: '',
      coefficientFieldVerify: false,
      form1276loaded: false,
      form1276loadedAux: false,
      paramInvoices: null,
      rutMask: this.$store.state.rutMask,
      cuitMask: [/[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
      invoiceMask: this.$store.state.invoiceMask,
      terminosYCondVisible: false,
      checked: false,
      jurId: 0,
      generalData: {
        cuit: '',
        company: '',
        companyName: '',
        rubros: [],
        centrales: [],
        start_date: '',
        address: '',
        addressNumber: '',
        jurisdictionData: {},
        idProvince: '',
        idCountry: '',
        idGroupCompany: '',
        zipCode: '',
        city: '',
        paymentEmail: '',
        receiptEmail: '',
        typeIVA: '',
        personType: '',
        personSubType: '',
        personSubTypeOther: '',
        pdfAfip: '',
        namePrincipalContact: '',
        surnamePrincipalContact: '',
        phonePrincipalContact: '',
        emailPrincipalContact: '',
        nameCommercialContact: '',
        surnameCommercialContact: '',
        phoneCommercialContact: '',
        emailCommercialContact: '',
        modifDate: ''
      },
      rulesGeneralData: {
        cuit: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }, {
          type: 'number',
          message: 'Solo están permitidos los números',
          trigger: ['blur', 'change']
        }],
        company: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        rubros: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        start_date: [{ required: false, message: 'Campo obligatorio', trigger: 'blur' }],
        centrales: [{ required: false, message: 'Campo obligatorio', trigger: 'blur' }],
        address: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        addressNumber: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        idProvince: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        zipCode: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        city: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        idCountry: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        idGroupCompany: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        phonePrincipalContact: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        phoneCommercialContact: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        namePrincipalContact: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        nameCommercialContact: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        surnamePrincipalContact: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        surnameCommercialContact: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        emailPrincipalContact: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }, {
          type: 'email',
          message: 'Debe ingresar un correo electrónico válido',
          trigger: 'blur'
        }],
        emailCommercialContact: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }, {
          type: 'email',
          message: 'Debe ingresar un correo electrónico válido',
          trigger: 'blur'
        }],
        paymentEmail: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }, {
          type: 'email',
          message: 'Debe ingresar un correo electrónico válido',
          trigger: 'blur'
        }],
        receiptEmail: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }, {
          type: 'email',
          message: 'Debe ingresar un correo electrónico válido',
          trigger: 'blur'
        }],
        typeIVA: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        personType: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        personSubType: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        personSubTypeOther: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        pdfAfip: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }]
      },
      paymentData: {
        idBankBranch: '',
        idBank: '',
        accountNumber: '',
        idBankAccountType: '',
        cbu: '',
        pdfBank: ''
      },
      rulesPaymentData: {
        idBank: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        accountNumber: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }],
        idBankAccountType: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        cbu: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }, {
          pattern: '[0-9]{22}',
          message: 'Deben ser 22 números',
          trigger: ['blur', 'change']
        }],
        pdfBank: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }]
      },
      jurisdictionData: {
        idJurisdiction: '',
        coefficient: null,
        aliquot: null,
        certficateDetailsVisible: false,
        certificateNumber: '',
        certificateFrom: null,
        certificateTo: null,
        agentDontOperateHere: false,
        certificatePdf: '',
        retentionAgentHas: 0,
        retentionAgentVisible: false,
        retentionAgentDate: null,
        retentionAgentPdf: '',
        form1276pdf: '',
        perceptionAgentHas: 0,
        perceptionAgentVisible: false,
        perceptionAgentDate: null,
        perceptionAgentPdf: ''
      },
      taxData: {
        pdfIb: '',
        ibType: '',
        pdfsExempt: '',
        idAgreementRegimeType: '',
        pdfCM05: '',
        jurisdictionHeadquarters: '',
        jurisdictions: [],
        earningsRetentionType: '',
        retentionRegimen: '',
        idEarningCategoryRetain: '',
        earningsExclusionNumber: '',
        earningsExclusionFrom: null,
        earningsExclusionTo: null,
        earningsExclusionPdf: '',
        sussEmployeer: 0,
        sussRetentionRegimen: 0,
        sussIdCategoryRetain: '',
        sussExclusionNumber: '',
        sussExclusionFrom: null,
        sussExclusionTo: null,
        sussExclusionPdf: '',
        ivaRetentionAgent: 0,
        ivaResolutionPdf: '',
        ivaIdRetentionRegime: '',
        ivaIdCategoryRetain: '',
        ivaExclusionNumber: '',
        otrosIdRetentionRegime: '',
        otrosIdCategoryRetain: '',
        ivaExclusionFrom: null,
        ivaExclusionTo: null,
        ivaExclusionPdf: ''
      },
      rulesTaxData: {
        pdfIb: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        ibType: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        pdfsExempt: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        idAgreementRegimeType: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        pdfCM05: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        jurisdictionHeadquarters: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],

        earningsRetentionType: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        retentionRegimen: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        idEarningCategoryRetain: [{
          required: !!this.retentionCategories2,
          message: 'Campo obligatorio',
          trigger: 'change'
        }],
        earningsExclusionFrom: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        earningsExclusionTo: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        earningsExclusionPdf: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        sussExclusionFrom: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        sussExclusionTo: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        sussExclusionPdf: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        ivaExclusionFrom: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        ivaExclusionTo: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }],
        ivaExclusionPdf: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }]
      },
      rulesTaxDataIvaResolutionPdf: {
        ivaResolutionPdf: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }]
      },
      rulesTaxDataOtros: {
        ivaResolutionPdf: [{
          required: false,
          message: 'Campo no obligatorio',
          trigger: 'change'
        }]
      },
      rulesTaxDataForm1276Pdf: {
        form1276pdf: [{ required: true, message: 'Campo obligatorio', trigger: 'change' }]
      },
      userData: {
        name: '',
        email: '',
        password: '',
        passwordRe: ''
      },
      rulesUserData: {
        email: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }, {
          type: 'email',
          message: 'Debe ingresar un correo electrónico válido',
          trigger: 'blur'
        }],
        password: [{ required: true, message: 'Campo obligatorio', trigger: 'blur' }, {
          min: 8,
          message: 'Debe tener mínimo 8 caracteres',
          trigger: 'change'
        }]
      }
    };
  },

  watch: {
    provider: function provider(val) {
      this.loadProvider();
    }
  },
  methods: {
    validateCoefficient: function validateCoefficient(key, jurId) {
      console.log('key ingresa: ', key);
      console.log(this.taxData.jurisdictions[jurId]);
      var allowedCharacters = /^\d+(,\d{0,4})?$/;
      if (!allowedCharacters.test(key)) {
        if (!allowedCharacters.test(key[key.length - 1])) {
          this.taxData.jurisdictions[jurId].coefficient = key.slice(0, -1);
          console.log('key correcta', this.taxData.jurisdictions[jurId].coefficient);
          return;
        }
        key = key.replace(/[^0-9,\b]+/g, '');
        var parts = key.split(/,/);
        var integerPart = parts[0];
        var decimalPart = parts[1] || '';

        decimalPart = decimalPart.slice(0, 4);
        this.taxData.jurisdictions[jurId].coefficient = integerPart + (decimalPart ? ',' + decimalPart : '');
        console.log('key sale: ', this.taxData.jurisdictions[jurId].coefficient);
      } else {
        console.log('key correcta: ', key);
        this.taxData.jurisdictions[jurId].coefficient = key;
      }
    },
    decimalCoefficient: function decimalCoefficient(coef) {
      return coef.indexOf(',') !== -1 && coef.split(',')[0].length > 0 && coef.split(',')[1].length > 0;
    },
    clearAlicuotValue: function clearAlicuotValue(jurId) {
      var _this = this;

      this.taxData.jurisdictions.forEach(function (jur, index) {
        if (jur.idJurisdiction === jurId) {
          _this.taxData.jurisdictions[index].aliquot = '';
        }
      });
    },
    changeAlicoutJurisdiction: function changeAlicoutJurisdiction(jurId) {
      if (jurId !== null && jurId !== '') {
        var data = this.$store.state.ibRetentionCategory.filter(function (ret) {
          return ret.idJurisdictions === jurId;
        }).sort(function (a, b) {
          return a.categoryRetain > b.categoryRetain;
        });
        this.clearAlicuotValue(jurId);
        return data;
      }
    },
    isAlicuotList: function isAlicuotList(jurId) {
      if (jurId !== null && jurId !== '') {
        var data = this.$store.state.ibRetentionCategory.filter(function (ret) {
          return ret.idJurisdictions === jurId;
        });
        return data.length > 0;
      }
    },
    sussIdCategoryRetainClear: function sussIdCategoryRetainClear() {
      this.taxData.sussIdCategoryRetain = '';
    },
    notify: function notify(notificationMessage) {
      this.$notify({
        title: '',
        type: 'warning',
        message: notificationMessage,
        duration: 10000,
        showClose: true,
        offset: 50
      });
    },
    editData: function editData() {
      this.editing = true;
      this.disabledGeneralData();
    },
    cancelData: function cancelData() {
      this.editing = false;
      this.disabledGeneralData();
    },
    saveData: function saveData() {
      var _this2 = this;

      this.$confirm('Sus Datos se remitirán a Albanesi para su verificación', 'Atención', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(function () {
        _this2.editing = false;
        _this2.disabledGeneralData();
        _this2.providerUpdateData();
      });
    },
    calculateHabModificaPdf: function calculateHabModificaPdf() {
      var provider = !!this.provider && this.provider !== '';
      this.habModificaPdf = !provider || this.editing || !this.disabledData;
    },
    disabledGeneralData: function disabledGeneralData() {
      if (this.user && this.idCompany) {
        if (this.user.isProvider) {
          if (this.editing) {
            this.disabledData = false;
            this.calculateHabModificaPdf();
            return;
          } else {
            if (this.provider) {
              if (this.provider[this.activeTab()].idCompanyDataStatus === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].DEVUELTO) {
                this.disabledData = false;
                this.calculateHabModificaPdf();
                return;
              }
            }
          }
        } else {
          if (this.provider) {
            var activeTab = this.activeTab();
            console.log();
            if (this.provider[activeTab]) {
              if (this.provider[activeTab].idCompanyDataStatus !== __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ACEPTADO) {
                this.disabledData = false;
                this.calculateHabModificaPdf();
                return;
              }
            }
          }
        }
      } else {
        this.disabledData = false;
        this.calculateHabModificaPdf();
        return;
      }
      this.disabledData = true;
      this.calculateHabModificaPdf();
    },
    closeCertificationExgain: function closeCertificationExgain() {
      this.showModalCertificationExgain = false;
    },
    closeCertificationsExgainList: function closeCertificationsExgainList() {
      this.showModalCertificationsExgainList = false;
    },
    closeCertificationRg2681: function closeCertificationRg2681() {
      this.showModalCertificationRg2681 = false;
    },
    closeCertificationsRg2681List: function closeCertificationsRg2681List() {
      this.showModalCertificationRg2681List = false;
    },
    closeCertificationSuss: function closeCertificationSuss() {
      this.showModalCertificationSuss = false;
    },
    closeCertificationsSussList: function closeCertificationsSussList() {
      this.showModalCertificationSussList = false;
    },
    closeCertificationRg18: function closeCertificationRg18() {
      this.showModalCertificationRg18 = false;
    },
    closeCertificationsRg18List: function closeCertificationsRg18List() {
      this.showModalCertificationRg18List = false;
    },
    closeCertificationRg17: function closeCertificationRg17() {
      this.showModalCertificationRg17 = false;
    },
    closeCertificationsRg17List: function closeCertificationsRg17List() {
      this.showModalCertificationRg17List = false;
    },
    coeficienteValidacionTest: function coeficienteValidacionTest() {
      return this.taxData.jurisdictions.some(function (el) {
        if (el.coefficient === null || el.coefficient === undefined) {} else {
          return el.coefficient.indexOf('.') > -1;
        }
      });
    },
    verifySantaFeJurisdiction: function verifySantaFeJurisdiction() {
      var _this3 = this;

      this.taxData.jurisdictions.forEach(function (juris) {
        if (juris.idJurisdiction === '13') {
          if (_this3.activeJurisdictionSantaFe !== '') {
            if (_this3.taxData.jurisdictions[_this3.activeJurisdictionSantaFe]['form1276pdf'] !== null) {
              console.log('hay una jurisdiccion santa fe con form1276 OK');
              _this3.form1276loaded = true;
            } else if (_this3.taxData.jurisdictions[_this3.activeJurisdictionSantaFe]['form1276pdf'] === null) {
              console.log('hay una jurisdiccion santa fe con form1276 No cargado');
              _this3.form1276loaded = false;
            }
          } else {
            console.log('hay una jurisdiccion santa fe con form ERROR');
            _this3.form1276loaded = false;
          }
        } else {
          _this3.form1276loaded = true;
        }
      });
    },
    getCertificationExgain: function getCertificationExgain(id) {
      var _this4 = this;

      this.certificationExgain = [];

      this.certificationExgainList.forEach(function (certif) {
        if (certif.IdCertificationExGain === id) {
          _this4.certificationExgain.push({
            id: certif.IdCertificationExGain,
            cuit: certif.cuit,
            state: certif.state,
            publication: certif.publication,
            validity: certif.validity,
            period: certif.period,
            percentage: certif.percentage,
            number: certif.number,
            resolution: certif.resolution
          });
        }
      });

      this.showModalCertificationExgain = true;
    },
    openCertificationExgainList: function openCertificationExgainList() {
      if (this.user !== null) {
        this.certificationExgainList = [];
        this.getCertificationExgainList();
      }
      this.showModalCertificationsExgainList = true;
    },
    getCertificationExgainList: function getCertificationExgainList() {
      var _this5 = this;

      this.providers[0].certifExgain.forEach(function (certif) {
        _this5.certificationExgainList.push({
          IdCertificationExGain: certif.IdCertificationExGain,
          number: certif.number,
          publication: certif.publication,
          validity: certif.validity,
          cuit: certif.cuit,
          state: certif.state,
          period: certif.period,
          percentage: certif.percentage,
          resolution: certif.resolution
        });
      });

      console.log(this.certificationExgainList);
    },
    getCertificationRg2681: function getCertificationRg2681(id) {
      var _this6 = this;

      this.certificationRg2681 = [];

      this.certificationRg2681List.forEach(function (certif) {
        if (certif.idCertificationRG2681 === id) {
          _this6.certificationRg2681.push({
            id: certif.idCertificationRG2681,
            cuit: certif.cuit,
            type: certif.type,
            state: certif.state,
            stateDescription: certif.stateDescription,
            emision: certif.emision,
            administrationDate: certif.administrationDate,
            auth: certif.auth,
            ddjj: certif.ddjj,
            subsection: certif.subsection,
            since: certif.since,
            until: certif.until,
            number: certif.number,
            orderJud: certif.orderJud,
            modificationDate: certif.modificationDate
          });
        }
      });
      console.log(this.certificationRg2681[0].cuit);
      this.showModalCertificationRg2681 = true;
    },
    openCertificationRg2681List: function openCertificationRg2681List() {
      if (this.user !== null) {
        this.certificationRg2681List = [];
        this.getCertificationRg2681List();
      }
      this.showModalCertificationRg2681List = true;
    },
    getCertificationRg2681List: function getCertificationRg2681List() {
      var _this7 = this;

      this.providers[0].certifRg2681.forEach(function (certif) {
        _this7.certificationRg2681List.push({
          idCertificationRG2681: certif.idCertificationRG2681,
          cuit: certif.cuit,
          type: certif.type,
          state: certif.state,
          stateDescription: certif.stateDescription,
          emision: certif.emision,
          administrationDate: certif.administrationDate,
          auth: certif.auth,
          ddjj: certif.ddjj,
          subsection: certif.subsection,
          since: certif.since,
          until: certif.until,
          number: certif.number,
          orderJud: certif.orderJud,
          modificationDate: certif.modificationDate
        });
      });

      console.log(this.certificationRg2681List);
    },
    getCertificationSuss: function getCertificationSuss(id) {
      var _this8 = this;

      this.certificationSuss = [];

      this.certificationSussList.forEach(function (certif) {
        if (certif.idCertificaction === id) {
          _this8.certificationSuss.push({
            id: certif.idCertificaction,
            cuit: certif.cuit,
            state: certif.state,
            since: certif.since,
            until: certif.until,
            number: certif.number,
            period: certif.period,
            resolution: certif.resolution,
            percentage: certif.percentage
          });
        }
      });
      this.showModalCertificationSuss = true;
    },
    openCertificationSussList: function openCertificationSussList() {
      if (this.user !== null) {
        this.certificationSussList = [];
        this.getCertificationSussList();
      }
      this.showModalCertificationSussList = true;
    },
    getCertificationSussList: function getCertificationSussList() {
      var _this9 = this;

      this.providers[0].certifSuss.forEach(function (certif) {
        _this9.certificationSussList.push({
          idCertificaction: certif.idCertificaction,
          cuit: certif.cuit,
          state: certif.state,
          since: certif.since,
          until: certif.until,
          number: certif.number,
          period: certif.period,
          resolution: certif.resolution,
          percentage: certif.percentage
        });
      });
    },
    getCertificationRg18: function getCertificationRg18(id) {
      var _this10 = this;

      this.certificationRg18 = [];

      this.certificationRg18List.forEach(function (certif) {
        if (certif.idCertificationRG18 === id) {
          _this10.certificationRg18.push({
            id: certif.idCertificationRG18,
            cuit: certif.cuit,
            type: certif.type,
            since: certif.since,
            until: certif.until,
            name: certif.name
          });
        }
      });
      this.showModalCertificationRg18 = true;
    },
    openCertificationRg18List: function openCertificationRg18List() {
      if (this.user !== null) {
        this.certificationRg18List = [];
        this.getCertificationRg18List();
      }
      this.showModalCertificationRg18List = true;
    },
    getCertificationRg18List: function getCertificationRg18List() {
      var _this11 = this;

      this.providers[0].certifRg18.forEach(function (certif) {
        _this11.certificationRg18List.push({
          idCertificationRG18: certif.idCertificationRG18,
          cuit: certif.cuit,
          type: certif.type,
          since: certif.since,
          until: certif.until,
          name: certif.name
        });
      });
    },
    getCertificationRg17: function getCertificationRg17(id) {
      var _this12 = this;

      this.certificationRg17 = [];

      this.certificationRg17List.forEach(function (certif) {
        if (certif.idCertificationRG17 === id) {
          _this12.certificationRg17.push({
            id: certif.idCertificationRG2681,
            cuit: certif.cuit,
            type: certif.type,
            rg: certif.rg,
            percentage: certif.percentage,
            since: certif.since,
            until: certif.until,
            name: certif.name
          });
        }
      });
      this.showModalCertificationRg17 = true;
    },
    openCertificationRg17List: function openCertificationRg17List() {
      if (this.user !== null) {
        this.certificationRg17List = [];
        this.getCertificationRg17List();
      }
      this.showModalCertificationRg17List = true;
    },
    getCertificationRg17List: function getCertificationRg17List() {
      var _this13 = this;

      this.providers[0].certifRg17.forEach(function (certif) {
        _this13.certificationRg17List.push({
          idCertificationRG17: certif.idCertificationRG2681,
          cuit: certif.cuit,
          type: certif.type,
          rg: certif.rg,
          percentage: certif.percentage,
          since: certif.since,
          until: certif.until,
          name: certif.name
        });
      });
    },
    getStatusNameOfTab: function getStatusNameOfTab() {
      var tabIdCompanyStatus = this.provider[this.activeTab()].idCompanyDataStatus;
      this.statusType = this.types[tabIdCompanyStatus - 1];
      return this.getStatusName(tabIdCompanyStatus);
    },
    getStatusName: function getStatusName(idCompanyDataStatus) {
      return this.statusList.find(function (el) {
        return el.idCompanyDataStatus === idCompanyDataStatus;
      }).description;
    },
    activeTab: function activeTab() {
      return this.steps[this.step];
    },
    handleCloseCompanyDataRejection: function handleCloseCompanyDataRejection() {
      this.newObservation = '';
    },
    reSendCompanyData: function reSendCompanyData() {
      var _this14 = this;

      var valido = this.validateFormFromStep();
      if (!valido) {
        return;
      }
      this.setCurrentTimeStamp();
      console.log(this.timeStampModifDate);
      this.$confirm('¿Está seguro que desea aceptar los datos?', 'Advertencia', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(function () {
        _this14.provider['generalData'] = _this14.generalData;
        _this14.provider['taxData'] = _this14.taxData;
        _this14.provider['paymentData'] = _this14.paymentData;
        console.log('data original', _this14.provider['taxData']);
        console.log('data nueva a ver', _this14.provider['taxData']);
        _this14.provider[_this14.activeTab()].idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION;
        _this14.provider.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION;
        _this14.provider[_this14.activeTab()].modifDate = _this14.timeStampModifDate;
        _this14.$store.state.userReturned = true;
        _this14.updateCompanyData(_this14.activeTab(), _this14.provider[_this14.activeTab()]);
        console.log(_this14.$store.state.userReturned + '_ OK');
      }).catch(function () {
        _this14.$store.commit('TOGGLE_LOADING');
      });
    },
    companyData: function companyData() {
      if (this.idCompany) {
        var that = this;
        __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/ListCompanyData' + '?idCompany=' + this.idCompany + '&actualCountry=' + this.actualCountry).then(function (response) {
          var data = response.data;
          if (data.error) {
            return;
          }
          if (data) {
            that.providers = data;
            that.provider = that.providers[0];
            that.disabledGeneralData();
          }
        }).catch(function (error) {
          that.$store.commit('TOGGLE_LOADING');
          console.log(error);
        });
      }
    },
    getCentrales: function getCentrales() {
      var _this15 = this;

      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/generic/central').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this15.centrales = data;
        }
      });
    },
    setCurrentTimeStamp: function setCurrentTimeStamp() {
      var d = new Date();
      var currDate = d.getDate();
      var currMonth = d.getMonth() + 1;
      var currYear = d.getFullYear();
      var currHour = d.getHours();
      var currMinutes = d.getMinutes();
      var currSeconds = d.getSeconds();
      this.timeStampModifDate = '' + currYear + '-' + (currMonth <= 9 ? '0' + currMonth : currMonth) + '-' + (currDate <= 9 ? '0' + currDate : currDate) + ' ' + (currHour <= 9 ? '0' + currHour : currHour) + ':' + (currMinutes <= 9 ? '0' + currMinutes : currMinutes) + ':' + (currSeconds <= 9 ? '0' + currSeconds : currSeconds);
    },
    checkRoles: function checkRoles(currentStep) {
      var permission = false;
      this.user.roles.forEach(function (role) {
        switch (role.rolesId) {
          case __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DG:
            if (currentStep === 0) {
              permission = true;
            }
            break;
          case __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DI:
            if (currentStep === 2) {
              permission = true;
            }
            break;
          case __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DP:
            if (currentStep === 1) {
              permission = true;
            }
            break;
          case __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].ADMIN_SISTEMA:
            permission = true;
            break;
          default:
            break;
        }
      });
      return permission;
    },
    acceptCompanyData: function acceptCompanyData() {
      var _this16 = this;

      var solicitud = true;
      if (this.provider.idStage === '3') {
        solicitud = false;
      }
      var permission = this.checkRoles(this.step);
      if (!permission) {
        console.log('Permision es :' + permission);
        this.$router.push('/newProviders');
        this.$alert('No tiene los permisos requeridos para realizar esta accion', 'Permisos Insuficientes', {
          confirmButtonText: 'Aceptar',
          callback: function callback(action) {
            _this16.$router.push('/newProviders');
          }
        });
        return;
      }

      this.$confirm('¿Está seguro que desea aceptar los datos?', 'Advertencia', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(function () {
        _this16.provider[_this16.activeTab()] = _this16[_this16.activeTab()];
        _this16.provider[_this16.activeTab()].idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ACEPTADO;
        _this16.provider[_this16.activeTab()].idUser = _this16.user.idUser;
        _this16.provider.signUpStatus++;
        _this16.updateCompanyData(_this16.activeTab(), _this16.provider[_this16.activeTab()]);
        if (solicitud) {
          _this16.solicitudActivarUsuario();
        }
        _this16.$parent.getProviders();
        if (!_this16.checkRoles(_this16.step + 1)) {
          _this16.$router.push('/newProviders');
        }
      }).catch(function () {});
    },
    verifyPermission: function verifyPermission() {
      var _this17 = this;

      var permission = this.checkRoles(this.step);
      if (!permission) {
        this.$router.push('/newProviders');
        this.$alert('No tiene los permisos requeridos para realizar esta accion', 'Permisos Insuficientes', {
          confirmButtonText: 'Aceptar',
          callback: function callback(action) {
            _this17.$router.push('/newProviders');
          }
        });
        return;
      }
      this.rejectCompanyDataVisible = true;
    },
    rejectCompanyData: function rejectCompanyData() {
      var _this18 = this;

      if (this.newObservation === '') {
        this.$message.warning('Falta completar el motivo');
        return;
      }
      this.$confirm('¿Está seguro que desea rechazar los datos por este motivo?', 'Advertencia', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(function () {
        _this18.provider[_this18.activeTab()] = _this18[_this18.activeTab()];
        _this18.provider[_this18.activeTab()].idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].DEVUELTO;
        _this18.provider[_this18.activeTab()].idUser = _this18.user.idUser;
        _this18.provider[_this18.activeTab()].observation = _this18.newObservation;
        _this18.updateCompanyData(_this18.activeTab(), _this18.provider[_this18.activeTab()]);
        _this18.$router.push('/newProviders');
      }).catch(function () {});
    },
    isSystemAdmin: function isSystemAdmin() {
      var _this19 = this;

      if (this.user) {
        this.user.roles.forEach(function (role) {
          if (role.rolesId === __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].ADMIN_SISTEMA) {
            _this19.userIsAdmin = true;
          }
          if (role.rolesId === __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DG || role.rolesId === __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DI || role.rolesId === __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DP) {
            _this19.userByRoles = true;
          }
        });
      }
    },
    providerUpdateData: function providerUpdateData() {
      var _this20 = this;

      console.log('activeTab', this[this.activeTab()]);
      this.provider[this.activeTab()] = this[this.activeTab()];
      console.log('nuevo active tab test', this[this.activeTab()]);
      this.provider[this.activeTab()].idUser = this.user.idUser;
      this.provider[this.activeTab()].idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION;
      this.setCurrentTimeStamp();
      this.provider[this.activeTab()].modifDate = this.timeStampModifDate;
      this.provider.idCompanyStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION;
      this.provider.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].MODIFICADO;
      this.provider.isExport = '0';

      this.taxData.jurisdictions.forEach(function (jurisdiction) {
        if (!_this20.decimalCoefficient(jurisdiction.coefficient)) {
          _this20.notify('Coef. Unificado debe ser un número decimal');
          _this20.jurisdictionFlag = true;
        }
      });
      if (this.jurisdictionFlag) {
        this.jurisdictionFlag = false;
        return;
      } else {
        this.updateCompanyData(this.activeTab(), this.provider[this.activeTab()]);
      }
    },
    activationOrReject: function activationOrReject() {
      var _this21 = this;

      var genD = this.provider.generalData.idCompanyDataStatus;
      var payD = this.provider.paymentData.idCompanyDataStatus;
      var taxD = this.provider.taxData.idCompanyDataStatus;

      if (genD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ACEPTADO && payD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ACEPTADO && taxD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ACEPTADO) {
        this.provider.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ACEPTADO;
        this.provider.idCompanyStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ACEPTADO;
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/sendMailUserActivation/' + _this21.provider.idCompany).then(function () {});
        }, 900);
      } else {
        if (genD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].DEVUELTO || payD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].DEVUELTO || taxD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].DEVUELTO) {
          this.provider.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].DEVUELTO;
          this.provider.idCompanyStatus = __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].RECHAZADO;
          setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/sendMailUserReject/' + _this21.provider.idCompany).then(function () {});
          }, 900);
        }
      }
    },
    updateCompanyData: function updateCompanyData(dataType, data) {
      var _this22 = this;

      var genD = this.provider.generalData.idCompanyDataStatus;
      var payD = this.provider.paymentData.idCompanyDataStatus;
      var taxD = this.provider.taxData.idCompanyDataStatus;
      this.activationOrReject();

      if (genD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION) {
        this.provider.idStage = __WEBPACK_IMPORTED_MODULE_9__config_company_stage__["a" /* default */].DATOS_GENERALES;
      } else if (payD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION) {
        this.provider.idStage = __WEBPACK_IMPORTED_MODULE_9__config_company_stage__["a" /* default */].DATOS_BANCARIOS;
      } else if (taxD === __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION) {
        this.provider.idStage = __WEBPACK_IMPORTED_MODULE_9__config_company_stage__["a" /* default */].DATOS_IMPOSITIVOS;
      }
      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', 'api/generic/company/' + this.provider.idCompany, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.provider)).then(function () {
        var idCompanyData = void 0;
        switch (dataType) {
          case 'generalData':
            idCompanyData = _this22.provider.idCompany;
            break;
          case 'paymentData':
            idCompanyData = _this22.provider.idCompany;
            break;
          case 'taxData':
            idCompanyData = _this22.provider.idCompany;
            break;
        }
        _this22.$store.commit('START_LOADING');
        __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', 'api/generic/' + dataType + '/' + idCompanyData, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data)).then(function (response) {
          switch (dataType) {
            case 'generalData':
              _this22.provider.cuit = _this22.generalData.cuit;
              _this22.provider.company = _this22.generalData.company;
              _this22.provider.companyName = _this22.generalData.companyName;
              __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', 'api/generic/company/' + _this22.provider.idCompany, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this22.provider));
              break;
          }
          _this22.rejectCompanyDataVisible = false;
          _this22.newObservation = '';
          _this22.$store.commit('STOP_LOADING');
          _this22.provider[dataType] = response.data;
          _this22.user.roles.forEach(function (role) {
            if (role.rolesId === __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DG) {
              _this22.$router.push('/newProviders');
            }
            if (role.rolesId === __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DI) {
              _this22.$router.push('/newProviders');
            }
            if (role.rolesId === __WEBPACK_IMPORTED_MODULE_10__config_roles__["a" /* default */].AUTORIZADOR_DP) {
              _this22.$router.push('/newProviders');
            }
          });

          _this22.$message.success('Estado cambiado satisfactoriamente');
        }).catch(function (error) {
          console.log(error);
          _this22.$store.commit('STOP_LOADING');
          _this22.$message.danger('Error al cambiar el estado');
        });
      });
    },
    isSantaFe: function isSantaFe(idJurisdiction) {
      var jurisdiction = this.jurisdictions.find(function (prov) {
        return prov.idJurisdictions === idJurisdiction;
      });
      if (jurisdiction) {
        return jurisdiction.jurisdictions === 'Santa Fe';
      }
      return false;
    },
    addDoc1276: function addDoc1276(idJurisdiction) {
      if (this.taxData.ibType === 'Local') {
        if (idJurisdiction === '13') {
          this.doc1276 = true;
        } else {
          this.doc1276 = false;
        }
      }
      if (this.taxData.ibType === 'Multilateral') {
        if (idJurisdiction === '13') {
          this.doc1276 = true;
        }
      }
    },
    coefficientValidate: function coefficientValidate(rule, value, callback) {
      if (!(value && Math.floor(value) <= 9 && value.toString().length === 6)) {
        callback(new Error());
      }
      callback();
    },
    aliquotValidate: function aliquotValidate(rule, value, callback) {
      if (!value) {
        callback();
      }
      if (!(value && Math.floor(value) <= 9 && value.toString().length === 4)) {
        callback(new Error());
      }
    },
    openModalTerminosYCond: function openModalTerminosYCond() {
      var valido = this.validateFormFromStep();
      if (valido) {
        this.terminosYCondVisible = true;
      }
    },
    openModalCertificateDetails: function openModalCertificateDetails(index) {
      this.activeJurisdiction = index;
      this.showModalCertificationDatosAdicionales = true;
    },
    openModalForm1276: function openModalForm1276(index) {
      this.activeJurisdiction = index;
      this.activeJurisdictionSantaFe = index;
      this.showModalForm1276 = true;
    },
    openModalRetentionAgent: function openModalRetentionAgent(index) {
      this.activeJurisdiction = index;
      this.taxData.jurisdictions[index].retentionAgentVisible = this.taxData.jurisdictions[index].retentionAgentHas === '1';
    },
    openModalPerceptionAgent: function openModalPerceptionAgent(index) {
      this.activeJurisdiction = index;
      this.taxData.jurisdictions[index].perceptionAgentVisible = this.taxData.jurisdictions[index].perceptionAgentHas === '1';
    },
    handleIbType: function handleIbType() {
      if (this.taxData.ibType === 'Multilateral' && this.taxData.jurisdictions.length === 1) {
        this.addJurisdiction();
      } else if (this.taxData.jurisdictions.length === 2) {
        this.deleteJurisdiction(this.taxData.jurisdictions[1]);
      }
    },
    addJurisdiction: function addJurisdiction() {
      this.taxData.jurisdictions.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.jurisdictionData));
    },
    deleteJurisdiction: function deleteJurisdiction(item) {
      var index = this.taxData.jurisdictions.indexOf(item);
      if (index !== -1) {
        this.taxData.jurisdictions.splice(index, 1);
      }
    },
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning('Solo se permite un archivo');
    },
    nextStep: function nextStep() {
      var valido = false;
      if (this.step === 2) {
        this.verifySantaFeJurisdiction();
        this.coeficienteValidacionTest();

        valido = this.validateFormFromStep();
        if (valido) {
          if (this.form1276loaded === true) {
            var that = this;
            this.$refs['taxDataForm'].validate(function (valid) {
              if (valid) {
                that.step++;
                that.disabledGeneralData();
              }
            });
          } else {
            this.step = 2;
            if (this.form1276loaded === false) {
              this.notify('Formulario 1276 obligatorio');
            }
            this.form1276loadedAux = true;
          }
        }
      } else {
        valido = this.validateFormFromStep();
        if (valido) {
          this.step++;
          this.disabledGeneralData();
        }
      }
      this.calculateHabModificaPdf();
    },
    previousStep: function previousStep() {
      this.step--;
      if (this.step === 2) {
        this.jurisdicciones = true;
      }
      this.disabledGeneralData();
      this.calculateHabModificaPdf();
    },
    previousStepView: function previousStepView() {
      this.step--;
    },
    nextStepView: function nextStepView() {
      this.step++;
    },
    validacionGeneralDataForm: function validacionGeneralDataForm() {
      if (!this.generalData.pdfAfip) {
        this.notify('Comprobante alta de AFIP es Obligatorio');
        return false;
      }
      return true;
    },
    validacionBanklDataForm: function validacionBanklDataForm() {
      if (!this.paymentData.pdfBank) {
        this.notify('Pdf de Constancia es Obligatorio');
        return false;
      }
      return true;
    },
    validacionTaxDataForm: function validacionTaxDataForm() {
      this.$refs['taxDataForm'].validate();
      if (!this.taxData.pdfIb) {
        this.notify('Formulario Constancia Ingresos Brutos Obligatorio');
        return false;
      } else if (this.taxData.ibType === 'Multilateral') {
        if (!this.taxData.idAgreementRegimeType) {
          this.notify('Se debe seleccionar un Regimen de Convenio de IIBB');
          return false;
        }
        if (!this.taxData.pdfCM05) {
          this.notify('Formulario CM05 Obligatorio');
          return false;
        }
        if (!this.taxData.jurisdictionHeadquarters) {
          this.notify('Debe seleccionar jurisdicción sede');
          return false;
        }
      } else if (this.taxData.ibType === 'Local') {
        if (!this.taxData.jurisdictionHeadquarters) {
          this.notify('Debe seleccionar jurisdicción sede');
          return false;
        }
      } else if (this.taxData.ibType === 'Exento') {
        if (!this.taxData.pdfsExempt || this.taxData.pdfsExempt === '') {
          this.notify('Formulario Contancia de Exento de IIBB es Obligatorio');
          return false;
        }
      } else if (!this.taxData.ibType) {
        this.notify('Se debe seleccionar un tipo de convenio de IIBB');
        return false;
      }
      if (!this.taxData.jurisdictions || !this.taxData.jurisdictions[0].aliquot && !this.taxData.jurisdictions[0].aliquota_value || !this.taxData.jurisdictions[0].coefficient) {
        this.notify('Faltan completar datos de jurisdicción de IIBB');
        return false;
      }

      if (!this.taxData.jurisdictionHeadquarters) {
        this.notify('Se debe seleccionar una Jurisdicción Sede de IIBB');
        return false;
      }

      if (!this.taxData.earningsRetentionType) {
        this.notify('Se debe seleccionar el tipo de Retención de Ganancias');
        return false;
      }

      if (this.taxData.ivaExclusionPdf !== '') {
        if (this.taxData.ivaIdCategoryRetain === '') {
          this.notify('Se debe seleccionar la Categoría a Retener de IVA');
          return false;
        }
      }

      if (this.taxData.earningsRetentionType === 'Inscripto') {
        if (!this.taxData.retentionRegimen) {
          this.notify('Debe informar el Regimen de Retención de Ganancias');
          return false;
        }
        if (!this.taxData.idEarningCategoryRetain) {
          this.notify('Debe informar la Categoría a Retener de Ganancias');
          return false;
        }
      }
      return true;
    },
    validateFormFromStep: function validateFormFromStep() {
      var formName = void 0;
      switch (this.step) {
        case 0:
          formName = 'generalDataForm';
          break;
        case 1:
          formName = 'paymentDataForm';
          break;
        case 2:
          formName = 'taxDataForm';
          break;
        case 3:
          formName = 'userDataForm';
          break;
      }
      var respuesta = void 0;
      respuesta = this.validateForm(formName);
      if (respuesta) {
        if (formName === 'generalDataForm') {
          respuesta = this.validacionGeneralDataForm();
        } else if (formName === 'paymentDataForm') {
          respuesta = this.validacionBanklDataForm();
        } else if (formName === 'taxDataForm') {
          respuesta = this.validacionTaxDataForm();
        }
      }
      return respuesta;
    },
    updateProvinces: function updateProvinces(idCountry) {
      this.provinces = this.$store.state.provinces.filter(function (prov) {
        return prov.idCountry === idCountry;
      }).sort(function (a, b) {
        return a.province > b.province;
      });
    },
    updateRetentionCategory: function updateRetentionCategory(idRetention) {
      this.taxData.idEarningCategoryRetain = '';
      var temporal = this.$store.state.retentionCategories.filter(function (ret) {
        return ret.idRetentionRegime === idRetention;
      }).sort(function (a, b) {
        return a.categoryRetain > b.categoryRetain;
      });
      this.retentionCategories2 = temporal;
    },
    updateAliquot: function updateAliquot(idJurisdiction, index) {
      this.retentionCategoriesAliquot[index] = this.ibRetentionCategory.filter(function (ret) {
        return ret.idJurisdictions === idJurisdiction;
      }).sort(function (a, b) {
        return a.categoryRetain > b.categoryRetain;
      });
      if (this.provider.taxData.jurisdictions[index].aliquot) {}

      if (idJurisdiction === '13') {
        this.doc1276 = true;
      } else {
        this.doc1276 = false;
      }
    },
    updateIvaRetentionCategory: function updateIvaRetentionCategory(idRetention) {
      this.ivaRetentionCategories = this.$store.state.retentionCategoriesVAT.filter(function (ret) {
        return ret.idRetentionRegime === idRetention;
      }).sort(function (a, b) {
        return a.categoryRetain > b.categoryRetain;
      });
    },
    updateOtrosRetentionCategory: function updateOtrosRetentionCategory(idRetention) {
      this.otrosRetentionCategories = this.$store.state.retentionCategoriesOTROS.filter(function (ret) {
        return ret.idRetentionRegime === idRetention;
      }).sort(function (a, b) {
        return a.categoryRetain > b.categoryRetain;
      });
    },
    handlePdfResolutionIva: function handlePdfResolutionIva(response, file, fileList) {
      this.taxData.ivaResolutionPdf = response;
    },
    handlePdfExclusionIva: function handlePdfExclusionIva(response, file, fileList) {
      this.taxData.ivaExclusionPdf = response;
    },
    handlePdfExclusionSuss: function handlePdfExclusionSuss(response, file, fileList) {
      this.taxData.sussExclusionPdf = response;
    },
    handlePdfExclusionEarnings: function handlePdfExclusionEarnings(response, file, fileList) {
      this.taxData.earningsExclusionPdf = response;
    },
    handlePdfCertificate: function handlePdfCertificate(response, file, fileList) {
      this.taxData.jurisdictions[this.activeJurisdiction].certificatePdf = response;
    },
    handlePdfRetentionAgent: function handlePdfRetentionAgent(response, file, fileList) {
      this.taxData.jurisdictions[this.activeJurisdiction].retentionAgentPdf = response;
    },
    handlePdfForm1276: function handlePdfForm1276(response, file, fileList) {
      this.taxData.jurisdictions[this.activeJurisdiction].form1276pdf = response;
    },
    handlePdfPerceptionAgent: function handlePdfPerceptionAgent(response, file, fileList) {
      this.taxData.jurisdictions[this.activeJurisdiction].perceptionAgentPdf = response;
    },
    validateForm: function validateForm(formName) {
      var that = this;
      var validated = true;
      if (that.$refs[formName]) {
        that.$refs[formName].validate(function (valid) {
          if (!valid) {
            validated = valid;
          }
        });
      } else {
        validated = false;
      }
      return validated;
    },
    editCuit: function editCuit() {
      this.dataAfip = '';
    },
    nextPage: function nextPage() {
      this.step++;
    },
    submitFormSolicitud: function submitFormSolicitud() {
      this.solicitudActivarUsuario('1');
      if (this.checked2 === true && this.checked === true) {
        this.terminosYCondVisible = false;
        this.checkData();
      } else {
        this.checked2 = false;
        this.checked = false;
        this.terminosYCondVisible = true;
      }
    },
    clearInput: function clearInput(vueModel) {
      vueModel = '';
    },
    verifyCuit: function verifyCuit() {
      var _this23 = this;

      this.$refs['generalDataForm'].validateField('cuit', function (valid) {
        if (!valid) {
          _this23.$store.commit('START_LOADING');
          __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/getPersonaAfip/' + _this23.generalData.cuit).then(function (response) {
            if (typeof response.data === 'string') {
              _this23.dataAfip = '';
              _this23.$message({
                message: response.data.replace('Id', 'CUIT'),
                type: 'warning'
              });
            } else {
              if (!response.data.errorConstancia) {
                _this23.dataAfip = response.data.datosGenerales;
                if (_this23.dataAfip.tipoPersona === 'JURIDICA') {
                  _this23.generalData.company = _this23.dataAfip.razonSocial;
                } else {
                  _this23.generalData.company = (_this23.dataAfip.nombre ? _this23.dataAfip.nombre + ' ' : '') + _this23.dataAfip.apellido;
                }
                __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/allCertification/' + _this23.generalData.cuit).then(function (response) {
                  if (response.data['exgainCertification'].length === 0) {
                    _this23.auxFlagEmptyExgainList = true;
                  }
                  _this23.certificationExgainList = response.data['exgainCertification'];

                  _this23.certificationSussList = response.data['sussCertification'];
                  _this23.certificationRg18List = response.data['rg18Certification'];
                  _this23.certificationRg17List = response.data['rg17Certification'];
                  _this23.certificationRg2681List = response.data['rg2681Certification'];
                });
                _this23.$message({
                  message: 'CUIT verificado correctamente en AFIP',
                  type: 'success'
                });
              } else {
                var mensaje = '';
                if (typeof response.data.errorConstancia.error === 'string') {
                  mensaje = response.data.errorConstancia.error;
                } else {
                  mensaje = response.data.errorConstancia.error.join('\n');
                }
                _this23.$message({
                  message: 'Informa AFIP : \n' + mensaje,
                  type: 'error'
                });
              }
            }
            _this23.$store.commit('STOP_LOADING');
          }).catch(function (error) {
            console.log(error);
            _this23.$store.commit('STOP_LOADING');
          });
        }
      });
    },
    checkData: function checkData() {
      var _this24 = this;

      this.toggleLoading();
      this.resetResponse();
      this.$store.commit('TOGGLE_LOADING');

      var url = 'api/saveNewProvider';
      var url2 = '/login';
      if (this.user) {
        url = 'api/saveNewProviderRegister';
        url2 = '/providers';
      }
      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', url, {
        generalData: this.generalData,
        paymentData: this.paymentData,
        taxData: this.taxData,
        userData: this.userData
      }).then(function (response) {
        _this24.toggleLoading();
        var data = response.data;

        if (response.data.error) {
          var errorName = response.data.error.name;
          if (errorName) {
            console.log(errorName);
            _this24.checked = false;
            _this24.checked2 = false;
            if (errorName === 'InvalidArgumentError') {
              _this24.response = 'Los datos son incorrectos.';
            } else if (errorName === 'NotFoundError') {
              _this24.response = 'Se ha producido un error inesperado.';
            } else {
              _this24.response = errorName;
            }
          } else {
            _this24.response = data.error;
          }

          return;
        } else {
          if (data.success) {
            __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', 'api/sendSignUpMessage', {
              idEmisor: 1,
              idReceptor: response.data.idUser,
              message: 'Gracias por registrarse, Estamos revisando la información remitida',
              messageType: 1
            }).then(function (response) {});
            _this24.$alert('Sus datos se han remitido correctamente, muchas gracias!', 'Información Enviada', {
              confirmButtonText: 'Confirmar',
              callback: function callback(action) {
                _this24.$router.push(url2);
              }
            });
            _this24.success = data.success;
          }
        }
      }).catch(function (error) {
        _this24.$store.commit('TOGGLE_LOADING');
        _this24.invoices = null;
        console.log(error);

        _this24.response = error.response.data;
        _this24.toggleLoading();
      });
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'cargando' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
      this.success = '';
    },
    loadProvider: function loadProvider() {
      console.log(this.provider);
      if (this.providerLoaded) {
        return;
      }
      this.providerLoaded = true;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.generalData, this.provider.generalData);
      this.generalData.cuit = parseInt(this.provider.cuit);
      this.generalData.company = this.provider.company;
      this.generalData.companyName = this.provider.companyName;
      this.generalData.rubros = this.provider.rubros.map(function (el) {
        return el.idRubro;
      });
      this.generalData.centrales = this.provider.generalData.centrales !== undefined ? this.provider.generalData.centrales.map(function (el) {
        return el;
      }) : undefined;
      this.updateProvinces(this.generalData.idCountry);
      if (this.provider && this.provider.taxData) {
        if (this.provider.taxData.retentionRegimen) {
          this.updateRetentionCategory(this.provider.taxData.retentionRegimen);
        }
      }
      this.setIbJurisdiction();

      this.updateIvaRetentionCategory(this.provider.taxData.ivaIdRetentionRegime);
      this.updateOtrosRetentionCategory(this.provider.taxData.otrosIdRetentionRegime);

      this.generalData.idProvince = this.provider.generalData.idProvince;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.paymentData, this.provider.paymentData);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.taxData, this.provider.taxData);
      this.dataAfip = 'a';

      if (!this.idStep) {
        this.step = parseInt(this.provider.idStage - 1);
      }
      for (var key in this.provider) {
        if (!this.provider.hasOwnProperty(key)) continue;

        var obj = this.provider[key];
        if (obj && obj.hasOwnProperty('idCompanyDataStatus')) {
          if (obj.idCompanyDataStatus !== __WEBPACK_IMPORTED_MODULE_11__config_data_status__["a" /* default */].ACEPTADO) {
            this.disabledGeneralData();
            return;
          }
        }
      }
    },
    checkProviderData: function checkProviderData() {
      if (this.provider && this.idCompany) {
        this.loadProvider();
      } else {
        this.addJurisdiction();
      }
    },
    solicitudActivarUsuario: function solicitudActivarUsuario() {
      var _this25 = this;

      var stage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!stage) {
        stage = this.provider.idStage;
      }
      var companyName = this.provider.company;
      var idFiscal = this.provider.cuit;
      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/solicitudActivarUsuario' + '?stage=' + stage + '&idFiscal=' + idFiscal + '&companyName=' + companyName).then(function (response) {
        _this25.toggleLoading();
      }).catch(function (error) {
        _this25.$store.commit('TOGGLE_LOADING');
        _this25.invoices = null;
        console.log(error);

        _this25.response = 'Error al conectarse con el servidor, contacte al administrador.';
        _this25.toggleLoading();
      });
    },
    setIbJurisdiction: function setIbJurisdiction() {
      var _this26 = this;

      setTimeout(function () {
        _this26.provider.taxData.jurisdictions.forEach(function (jur, index) {
          _this26.updateAliquot(_this26.provider.taxData.jurisdictions[index]['idJurisdiction'], index);
        });
      }, 500);
    },
    getJurisdictionsHabilitadas: function getJurisdictionsHabilitadas() {
      var _this27 = this;

      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/getEnabledJurisdictions').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          console.log('jurisdictions habilitadas', data.data);
          _this27.jurisdictionsHabilitadas = data.data;
          console.log('store', _this27.$store.state.jurisdictions);
        }
      }).catch(function (error) {
        _this27.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    }
  },
  beforeMount: function beforeMount() {
    this.actualCountry = this.$route.params.country;
    console.log(this.actualCountry);
    this.isSystemAdmin();
    this.companyData();
    this.getCentrales();
  },
  mounted: function mounted() {
    var _this28 = this;

    this.getJurisdictionsHabilitadas();
    console.log(this.user.roles);
    if (this.user && this.user.isProvider && this.idCompany && this.idCompany !== this.user.company.idCompany) {
      this.$router.push('/');
    }
    this.checkProviderData();

    this.providerLoaded = false;
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('get', 'api/checkParam?id=AP-001').then(function (response) {
      var data = response.data;

      if (data.error) {
        if (!_this28.user) {
          _this28.paramError = data.error;
        }
      }
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('get', 'api/findConfiguration/TYC').then(function (response) {
      _this28.configuration = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('get', 'api/findConfiguration/CODETI').then(function (response) {
      _this28.codigoEtica = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('get', 'api/findConfiguration/POLANTI').then(function (response) {
      _this28.politicaAnticorrupcion = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('get', 'api/findConfiguration/POLREL').then(function (response) {
      _this28.politicaRelacionamiento = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('get', 'api/checkParam?id=SUF-001').then(function (response) {
      var data = response.data;

      if (data.error) {
        _this28.paramInvoices = data.error;
      }
    }).catch(function (error) {
      console.log(error);
    });
    if (this.idStep) {
      this.step = parseInt(this.idStep);
    }
    this.disabledGeneralData();
  }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MySteps_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MySteps_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MySteps_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AltaID_vue__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AltaID_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AltaID_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AltaFormElements_vue__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AltaFormElements_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__AltaFormElements_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_utils_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config_company_stage__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config_roles__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config_data_status__ = __webpack_require__(37);
















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'steps-pagination': __WEBPACK_IMPORTED_MODULE_5__MySteps_vue___default.a,
    'alta-id': __WEBPACK_IMPORTED_MODULE_6__AltaID_vue___default.a,
    'alta-form': __WEBPACK_IMPORTED_MODULE_8__AltaFormElements_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapState */])(['user'])),
  data: function data() {
    return {
      idType: 'RUC',
      status: __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */],
      countryId: 256,
      response: null,
      rejectCompanyDataVisible: false,
      newObservation: '',
      success: null,
      loading: '',
      editing: false,
      savedGeneralData: '',
      savedPaymentData: '',
      savedTaxData: '',
      userByRoles: false,
      userIsAdmin: false,
      generalDataAccepted: false,
      paymentDataAccepted: false,
      taxDataAccepted: false,
      generalDataRejected: false,
      paymentDataRejected: false,
      taxDataRejected: false,
      savedUserData: '',
      codCountry: 'PE',
      id: { model: '', dataType: 'ID' },
      emailSoporte: 'soporte@albanesi.com.ar',
      step: 1,
      optionalPaymentFlag: { model: false, dataType: 'flag' },
      nextStepFlag: true,
      idStatus: 'accept',
      validateRuc: false,
      emptyFields: [],
      showTerminosYCondiciones: false,
      codigoEtica: '',
      politicaAnticorrupcion: '',
      politicaRelacionamiento: '',
      checked: false,
      checked2: false,
      provider: null,
      idCompany: this.$route.params.id,
      actualCountry: this.$route.params.country,
      idStep: this.$route.params.step,
      providerLoaded: false,
      locations: [],
      banks: [],
      bankAccountTypes: [],
      generalData: {
        company: {
          name: 'company',
          dataType: 'input',
          label: 'Razón Social / Denominación*',
          model: '',
          required: true
        },
        companyName: {
          name: 'companyName',
          dataType: 'input',
          label: 'Nombre comercial',
          model: '',
          required: false
        },
        activityField: {
          name: 'activityField',
          dataType: 'select',
          label: 'Campo de Actividad*',
          model: '',
          optionValue: [],
          placeholder: 'Seleccionar el Campo de actividad',
          required: true
        },
        country: {
          name: 'country',
          dataType: 'select',
          label: 'País*',
          model: 'Perú',
          optionValue: ['Perú'],
          placeholder: 'Seleccionar País',
          required: true
        },
        location: {
          name: 'location',
          dataType: 'select',
          label: 'Localidad*',
          model: '',
          optionValue: [],
          placeholder: 'Seleccionar Localidad',
          required: true
        },
        city: {
          name: 'city',
          dataType: 'input',
          label: 'Ciudad*',
          model: '',
          required: true
        },
        address: {
          name: 'address',
          name2: 'addressNumber',
          dataType: 'input-double',
          label: 'Calle*',
          label2: 'N°',
          model: '',
          model2: '',
          required: true
        },
        zip: {
          name: 'zip',
          dataType: 'input',
          label: 'Código Postal*',
          type: 'number',
          model: '',
          required: true
        },
        phone: {
          name: 'phone',
          dataType: 'input',
          label: 'Telefono*',
          type: 'number',
          model: '',
          required: true
        },
        email: {
          name: 'email',
          dataType: 'input',
          label: 'Email*',
          type: 'email',
          validate: 'email',
          model: '',
          required: true
        },
        pdfRuc: {
          name: 'pdfRuc',
          dataType: 'upload',
          label: 'Constancia de inscripcion RUC - Ficha RUC*',
          model: '',
          required: true
        }
      },
      paymentData1: {
        pdfPayment: {
          name: 'pdfPayment',
          dataType: 'upload',
          label: 'Instrucciones para acreditación de pagos*',
          model: '',
          required: true },
        bank: {
          name: 'bank',
          dataType: 'select',
          label: 'Banco*',
          model: '',
          optionValue: [],
          placeholder: 'Seleccionar Banco',
          required: true
        },
        bankAccount: {
          name: 'bankAccount',
          dataType: 'input',
          label: 'Nro de Cuenta*',
          validate: 'onlyNumbers',
          max: 11,
          model: '',
          required: true
        },
        accountType: {
          name: 'accountType',
          dataType: 'select',
          label: 'Tipo*',
          model: '',
          optionValue: '',
          placeholder: 'Seleccionar Tipo',
          required: true
        },
        currency: {
          name: 'currency',
          dataType: 'select',
          label: 'Moneda*',
          model: 'PEN',
          optionValue: ['PEN'],
          placeholder: 'Seleccionar Moneda',
          required: true
        },
        cciNumber: {
          name: 'cciNumber',
          dataType: 'input',
          label: 'Nro CCI*',
          max: 20,
          model: '',
          validate: 'onlyNumbers',
          required: true
        }
      },
      paymentData2: {
        bank2: {
          name: 'bank2',
          dataType: 'select',
          label: 'Banco',
          model: '',
          optionValue: [],
          placeholder: 'Seleccionar Banco',
          required: true
        },
        bankAccount2: {
          name: 'bankAccount2',
          dataType: 'input',
          label: 'Nro de Cuenta',
          max: 11,
          validate: 'onlyNumbers',
          model: '',
          required: true
        },
        accountType2: {
          name: 'accountType2',
          dataType: 'select',
          label: 'Tipo',
          model: '',
          optionValue: '',
          placeholder: 'Seleccionar Tipo',
          required: true
        },
        currency2: {
          name: 'currency2',
          dataType: 'select',
          label: 'Moneda',
          model: '',
          optionValue: ['PEN'],
          placeholder: 'Seleccionar Moneda',
          required: true
        },
        cciNumber2: {
          name: 'cciNumber2',
          dataType: 'input',
          label: 'Nro CCI',
          validate: 'onlyNumbers',
          max: 20,
          model: '',
          required: true
        }
      },
      paymentData3: {
        detractionBank: {
          name: 'detractionBank',
          dataType: 'input',
          label: 'Nro de Cuenta del Banco Nación*',
          max: 11,
          validate: 'onlyNumbers',
          model: '',
          required: true
        }
      },
      companyTaxData: {
        register: {
          name: 'register',
          dataType: 'input',
          label: 'Partida Registral',
          model: '',
          required: true
        },
        paymentType: {
          name: 'paymentType',
          dataType: 'select',
          label: 'Tipo de comprobantes a emitir',
          model: '',
          optionValue: ['Factura', 'ND', 'NC', 'RC por honorarios', 'Giros de remision'],
          placeholder: 'Seleccionar el tipo de comprobante',
          required: true
        },
        perceptionSwitch: {
          name: 'perceptionSwitch',
          dataType: 'switch-perception',
          label: 'Su empresa es agente de percepción?',
          model: false,
          companyDataPerception: {
            name: 'companyDataPerception',
            label: 'Alícuota*',
            model: '',
            required: true
          }
        },
        retentionSwitch: {
          name: 'retentionSwitch',
          dataType: 'switch-retention',
          label: 'Su empresa es agente de retención?',
          model: false,
          companyDataRetention: {
            name: 'companyDataRetention',
            label: 'Denominación*',
            model: '',
            optionValue: [],
            placeholder: 'Seleccionar el tipo de Denominación',
            required: true
          },
          companyRetentionFields: {
            name: 'companyRetentionFields',
            label: 'Alícuota*',
            model: '',
            placeholder: 'Seleccionar alicuota',
            required: true
          },
          companySuspensionNumber: {
            name: 'companySuspensionNumber',
            label: 'Número*',
            model: '',
            type: 'number',
            required: true
          },
          firstDate: {
            name: 'firstDate',
            model: '',
            required: true
          },
          lastDate: {
            name: 'lastDate',
            model: '',
            required: true
          },
          pdfSuspension: {
            name: 'pdfSuspension',
            model: '',
            label: 'Certificado de suspensión*',
            required: true
          }
        },
        detractionSwitch: {
          name: 'detractionSwitch',
          dataType: 'switch-detraction',
          label: 'Su empresa realiza actividades sujetas a detracción?',
          model: false
        }
      },
      userData: {
        userName: {
          name: 'name',
          dataType: 'input',
          label: 'Nombre y apellido',
          model: '',
          required: true
        },
        email: {
          name: 'email',
          dataType: 'input',
          label: 'Email',
          validate: 'email',
          model: '',
          required: true
        },
        password: {
          name: 'password',
          dataType: 'input',
          label: 'Contraseña',
          type: 'password',
          validate: 'password',
          model: '',
          required: true
        },
        repeatedPassword: {
          dataType: 'input',
          label: 'Repetir Contraseña',
          type: 'password',
          model: '',
          validate: 'repeated-password',
          samePassword: false,
          required: true
        }
      }
    };
  },

  watch: {
    provider: {
      immediate: true,
      handler: function handler(val) {
        this.loadProvider();
      }
    }
  },
  methods: {
    companyData: function companyData() {
      if (this.idCompany) {
        var that = this;
        __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('GET', 'api/ListCompanyData' + '?idCompany=' + this.idCompany + '&actualCountry=' + this.actualCountry).then(function (response) {
          var data = response.data;
          if (data.error) {
            return;
          }
          if (data) {
            that.providers = data;
            that.provider = that.providers[0];
          }
        }).catch(function (error) {
          that.$store.commit('TOGGLE_LOADING');
          console.log(error);
        });
      }
    },
    isSystemAdmin: function isSystemAdmin() {
      var _this = this;

      if (this.user) {
        this.user.roles.forEach(function (role) {
          if (role.rolesId === __WEBPACK_IMPORTED_MODULE_12__config_roles__["a" /* default */].ADMIN_SISTEMA) {
            _this.userIsAdmin = true;
          }
          if (role.rolesId === __WEBPACK_IMPORTED_MODULE_12__config_roles__["a" /* default */].AUTORIZADOR_DG_PE || role.rolesId === __WEBPACK_IMPORTED_MODULE_12__config_roles__["a" /* default */].AUTORIZADOR_DI_PE || role.rolesId === __WEBPACK_IMPORTED_MODULE_12__config_roles__["a" /* default */].AUTORIZADOR_DP_PE) {
            _this.userByRoles = true;
          }
        });
      }
    },
    loadProvider: function loadProvider() {
      if (this.provider) {
        this.step = this.provider.idStage - 1;

        this.providerLoaded = true;
        this.id.model = this.provider.fiscalId;
        this.generalData.company.model = this.provider.generalData.company;
        this.generalData.companyName.model = this.provider.generalData.companyName;
        this.generalData.activityField.model = this.provider.generalData.activityField;
        this.generalData.location.model = this.provider.generalData.location;

        this.generalData.city.model = this.provider.generalData.city;
        this.generalData.address.model = this.provider.generalData.address;
        this.generalData.address.model2 = this.provider.generalData.addressNumber;
        this.generalData.zip.model = this.provider.generalData.zip;
        this.generalData.phone.model = this.provider.generalData.phone;
        this.generalData.email.model = this.provider.generalData.email;
        this.generalData.pdfRuc.model = this.provider.generalData.pdfRuc;

        this.companyTaxData.register.model = this.provider.taxData.register;
        this.companyTaxData.paymentType.model = this.provider.taxData.paymentType;
        this.companyTaxData.perceptionSwitch.model = this.provider.taxData.perceptionSwitch;
        this.companyTaxData.perceptionSwitch.companyDataPerception.model = this.provider.taxData.companyDataPerception;
        this.companyTaxData.retentionSwitch.model = this.provider.taxData.retentionSwitch;
        this.companyTaxData.retentionSwitch.companyDataRetention.model = this.provider.taxData.companyDataRetention;
        this.companyTaxData.retentionSwitch.companyRetentionFields.model = this.provider.taxData.companyRetentionFields;
        this.companyTaxData.retentionSwitch.companySuspensionNumber.model = this.provider.taxData.companySuspensionNumber;
        this.companyTaxData.retentionSwitch.firstDate.model = this.provider.taxData.firstDate;
        this.companyTaxData.retentionSwitch.lastDate.model = this.provider.taxData.lastDate;
        this.companyTaxData.retentionSwitch.pdfSuspension.model = this.provider.taxData.pdfSuspension;
        this.companyTaxData.detractionSwitch.model = this.provider.taxData.detractionSwitch;

        this.paymentData1.pdfPayment.model = this.provider.paymentData.pdfPayment;
        this.paymentData1.bank.model = this.provider.paymentData.bank;
        this.paymentData1.bankAccount.model = this.provider.paymentData.bankAccount;
        this.paymentData1.accountType.model = this.provider.paymentData.accountType;
        this.paymentData1.cciNumber.model = this.provider.paymentData.cciNumber;
        this.paymentData2.bank2.model = this.provider.paymentData.bank2;
        this.paymentData2.bankAccount2.model = this.provider.paymentData.bankAccount2;
        this.paymentData2.accountType2.model = this.provider.paymentData.accountType2;
        this.paymentData2.currency2.model = this.provider.paymentData.currency2;
        this.paymentData2.cciNumber2.model = this.provider.paymentData.cciNumber2;
        this.paymentData3.detractionBank.model = this.provider.paymentData.detractionBank;
      }
    },

    persistToNewProviderStorage: __WEBPACK_IMPORTED_MODULE_9__helpers_utils_js__["a" /* persistToNewProviderStorage */],
    saveDataToLocalStorage: __WEBPACK_IMPORTED_MODULE_9__helpers_utils_js__["b" /* saveDataToLocalStorage */],
    validateSteps: function validateSteps() {
      this.emptyFields = [];
      if (this.nextStepFlag === false && this.step === 0) {
        this.validateData(this.generalData);
      }
      if (this.nextStepFlag === false && this.step === 1) {
        this.validateCompanyTaxData();
        this.validateData(this.companyTaxData);
      }
      if (this.nextStepFlag === false && this.step === 2) {
        this.validateData(this.paymentData1);
        if (this.optionalPaymentFlag.model) {
          this.validateData(this.paymentData2);
        }
        if (this.companyTaxData.detractionSwitch.model) {
          this.validateData(this.paymentData3);
        }
      }
      if (this.step === 3) {
        this.validateData(this.userData);
      }
      console.log(this.emptyFields);
    },
    nextStep: function nextStep() {
      this.nextStepFlag = false;
      this.validateSteps();
      if (this.nextStepFlag === false) {
        return;
      }
      if (this.step++ >= 3) {
        this.step = 0;
        this.validateRuc = false;
      }
    },
    backStep: function backStep() {
      this.nextStepFlag = false;
      var actualStep = this.step;
      this.step = actualStep - 1;
    },
    goBackPage: function goBackPage() {
      window.history.back();
    },
    validateIDHandler: function validateIDHandler(id) {
      this.id = id;
      if (id !== '' && this.idStatus === 'accept') {
        this.idStatus = 'edit';
        this.verifyRuc(id.model);
      } else if (this.idStatus === 'edit') {
        this.idStatus = 'accept';
        this.validateRuc = false;
      }
    },
    validateData: function validateData(stepData) {
      for (var key in stepData) {
        var data = stepData[key];

        this.validateEmail(data);

        this.validateNumbers(data);

        this.validatePasswords(data);

        if (data.required && (data.model === '' || data.model2 === '')) {
          this.emptyFields.push(data.label);
          this.nextStepFlag = false;
        }
      }
      if (this.emptyFields.length === 0 && this.step < 3) {
        this.nextStepFlag = true;
      }
    },
    validateEmail: function validateEmail(data) {
      if (data.validate === 'email') {
        var regex = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
        if (!regex.test(data.model)) {
          this.nextStepFlag = false;
          this.emptyFields.push(data.label);
        }
      }
    },
    validateNumbers: function validateNumbers(data) {
      if (data.validate === 'onlyNumbers') {
        var regex = /^[0-9]+$/;
        if (!regex.test(data.model) || data.model.length < data.max) {
          this.nextStepFlag = false;
          this.emptyFields.push(data.label);
        }
      }
    },
    validatePasswords: function validatePasswords(data) {
      if (data.validate === 'password' && data.model !== this.userData.repeatedPassword.model) {
        this.userData.repeatedPassword.samePassword = false;
        this.nextStepFlag = false;
        this.emptyFields.push(data.label);
      } else if (data.validate === 'password' && data.model === this.userData.repeatedPassword.model) {
        this.userData.repeatedPassword.samePassword = true;
      }
    },
    validateCompanyTaxData: function validateCompanyTaxData() {
      var _companyTaxData = this.companyTaxData,
          perceptionSwitch = _companyTaxData.perceptionSwitch,
          retentionSwitch = _companyTaxData.retentionSwitch;
      var companyDataRetention = retentionSwitch.companyDataRetention,
          companyRetentionFields = retentionSwitch.companyRetentionFields,
          firstDate = retentionSwitch.firstDate,
          lastDate = retentionSwitch.lastDate,
          pdfSuspension = retentionSwitch.pdfSuspension,
          companySuspensionNumber = retentionSwitch.companySuspensionNumber;

      if (perceptionSwitch.model && !perceptionSwitch.companyDataPerception.model) {
        this.emptyFields.push(perceptionSwitch.companyDataPerception.label);
        this.nextStepFlag = false;
      }
      if (retentionSwitch.model) {
        if (!companyDataRetention.model.length) {
          this.emptyFields.push(companyDataRetention.label);
          this.nextStepFlag = false;
        }
        if (!companyRetentionFields.model.length) {
          this.emptyFields.push(companyRetentionFields.label);
          this.nextStepFlag = false;
        }
        if (companyDataRetention.model.includes('Retencion Detracciones') && (!firstDate.model || !lastDate.model || !pdfSuspension.model || !companySuspensionNumber.model)) {
          this.emptyFields.push(companyDataRetention.label);
          this.nextStepFlag = false;
        }
      }
      if (!this.emptyFields.length) {
        this.nextStepFlag = true;
      }
    },
    recoverFromNewProviderStorage: function recoverFromNewProviderStorage() {
      var inputType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var inputId = arguments[1];

      var newProvider = JSON.parse(localStorage.getItem('newProviderPeru'));
      if (!newProvider) {
        return {};
      }
      var data = newProvider[inputId];
      if (!data) {
        return {};
      }
      if (inputType['dataType'] === 'ID' || inputType['dataType'] === 'flag') {
        inputType['model'] = data;
      }
      var input = inputType[inputId];
      if (!input) {
        return data;
      }
      var dataType = input.dataType;

      if (['input', 'select', 'upload', 'switch-detraction'].includes(dataType)) {
        input.model = data;
      }
      if (dataType === 'input-double') {
        input.model = data;
        input.model2 = data;
      }
      if (dataType === 'switch-perception') {
        input.model = data;
        input.companyDataPerception.model = newProvider.companyDataPerception;
      }
      if (dataType === 'switch-retention') {
        inputType[inputId].model = data;
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(input).forEach(function (value) {
          if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(value)) === 'object') {
            value.model = newProvider[value.name];
          }
        });
      }
      return data;
    },
    checkData: function checkData() {
      var _this2 = this;

      this.toggleLoading();
      this.resetResponse();
      this.manageDataObjects();
      this.$store.commit('TOGGLE_LOADING');

      var url = 'api/saveNewProvider';
      var url2 = '/login';
      if (this.user) {
        url = 'api/saveNewProviderRegister';
        url2 = '/providers';
      }
      __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('POST', url, {
        generalData: this.savedGeneralData,
        paymentData: this.savedPaymentData,
        taxData: this.savedTaxData,
        userData: this.savedUserData
      }).then(function (response) {
        _this2.toggleLoading();
        var data = response.data;

        if (response.data.error) {
          var errorName = response.data.error.name;
          if (errorName) {
            console.log(errorName);
            _this2.checked = false;
            _this2.checked2 = false;
            if (errorName === 'InvalidArgumentError') {
              _this2.response = 'Los datos son incorrectos.';
            } else if (errorName === 'NotFoundError') {
              _this2.response = 'Se ha producido un error inesperado.';
            } else {
              _this2.response = errorName;
            }
          } else {
            _this2.response = data.error;
          }

          return;
        } else {
          if (data.success) {
            __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('POST', 'api/sendSignUpMessage', {
              idEmisor: 1,
              idReceptor: response.data.idUser,
              message: 'Gracias por registrarse, Estamos revisando la información remitida',
              messageType: 1
            }).then(function (response) {});
            _this2.$alert('Sus datos se han remitido correctamente, muchas gracias!', 'Información Enviada', {
              confirmButtonText: 'Confirmar',
              callback: function callback(action) {
                _this2.$router.push(url2);
              }
            });
            _this2.success = data.success;
          }
        }
      }).catch(function (error) {
        _this2.$store.commit('TOGGLE_LOADING');
        _this2.invoices = null;
        console.log(error.response);
        _this2.response = 'Se ha producido un error, verifique los datos, en caso de persisitir, comuniquese con soporte.';
        if (error.response.data) {
          var err = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(error.response.data)[0];
          _this2.response = error.response.data[err][0];
        }
        console.log(_this2.response);
        _this2.toggleLoading();
      });
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'cargando' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
      this.success = '';
    },
    extractFieldValues: function extractFieldValues(data) {
      var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var extractedData = {};
      for (var key in data) {
        if (enabled) {
          if (data.hasOwnProperty(key)) {
            extractedData[data[key].name] = data[key].model;
          }
        }
        if (!enabled) {
          if (data.hasOwnProperty(key)) {
            extractedData[data[key].name] = '';
          }
        }
      }
      return extractedData;
    },
    manageDataObjects: function manageDataObjects() {
      var generalData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.extractFieldValues(this.generalData));
      generalData['ruc'] = this.id.model;
      generalData['' + this.generalData.address.name2] = this.generalData.address.model2;

      var paymentData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.extractFieldValues(this.paymentData1));
      if (this.optionalPaymentFlag.model) {
        paymentData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, paymentData, this.extractFieldValues(this.paymentData2));
      } else {
        paymentData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, paymentData, this.extractFieldValues(this.paymentData2, false));
      }
      if (this.companyTaxData.detractionSwitch.model) {
        paymentData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, paymentData, this.extractFieldValues(this.paymentData3));
      } else {
        paymentData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, paymentData, this.extractFieldValues(this.paymentData3, false));
      }

      var taxData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.extractFieldValues(this.companyTaxData));
      if (this.companyTaxData.perceptionSwitch.model) {
        taxData['' + this.companyTaxData.perceptionSwitch.companyDataPerception.name] = this.companyTaxData.perceptionSwitch.companyDataPerception.model;
      } else {
        taxData['' + this.companyTaxData.perceptionSwitch.companyDataPerception.name] = '';
      }
      if (this.companyTaxData.retentionSwitch.model) {
        taxData['' + this.companyTaxData.retentionSwitch.companyDataRetention.name] = this.companyTaxData.retentionSwitch.companyDataRetention.model;
        taxData['' + this.companyTaxData.retentionSwitch.companyRetentionFields.name] = this.companyTaxData.retentionSwitch.companyRetentionFields.model;
        taxData['' + this.companyTaxData.retentionSwitch.companySuspensionNumber.name] = this.companyTaxData.retentionSwitch.companySuspensionNumber.model;
        taxData['' + this.companyTaxData.retentionSwitch.firstDate.name] = this.companyTaxData.retentionSwitch.firstDate.model;
        taxData['' + this.companyTaxData.retentionSwitch.lastDate.name] = this.companyTaxData.retentionSwitch.lastDate.model;
        taxData['' + this.companyTaxData.retentionSwitch.pdfSuspension.name] = this.companyTaxData.retentionSwitch.pdfSuspension.model;
      } else {
        taxData['' + this.companyTaxData.retentionSwitch.companyDataRetention.name] = '';
        taxData['' + this.companyTaxData.retentionSwitch.companyRetentionFields.name] = '';
        taxData['' + this.companyTaxData.retentionSwitch.companySuspensionNumber.name] = '';
        taxData['' + this.companyTaxData.retentionSwitch.firstDate.name] = '';
        taxData['' + this.companyTaxData.retentionSwitch.lastDate.name] = '';
        taxData['' + this.companyTaxData.retentionSwitch.pdfSuspension.name] = '';
      }

      var userData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.extractFieldValues(this.userData));

      this.savedGeneralData = generalData;
      this.savedTaxData = taxData;
      this.savedPaymentData = paymentData;
      this.savedUserData = userData;
    },
    getLocations: function getLocations() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('GET', 'api/getProvincesByCountry?countryId=' + this.countryId).then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this3.locations = data;
          data.data.forEach(function (location) {
            _this3.generalData.location.optionValue.push(location.codRegion);
          });
        }
      }).catch(function (error) {
        _this3.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getRubros: function getRubros() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('GET', 'api/getRubrosPeru').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          data.data.forEach(function (activity) {
            _this4.generalData.activityField.optionValue.push(activity.activity);
          });
        }
      }).catch(function (error) {
        _this4.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getDenomination: function getDenomination() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('GET', 'api/getRetentionRegimenCountry?codCountry=' + this.codCountry).then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          data.data.forEach(function (regime) {
            _this5.companyTaxData.retentionSwitch.companyDataRetention.optionValue.push({ 'retentionRegime': regime.retentionRegime, 'idRetentionRegime': regime.idRetentionRegime });
          });
        }
      }).catch(function (error) {
        _this5.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getBank: function getBank() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('GET', 'api/getBankByCountry?codCountry=' + this.codCountry).then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          console.log('banks', data);
          _this6.banks = data;
          data.data.forEach(function (bankData) {
            _this6.paymentData1.bank.optionValue.push(bankData.bank);
            _this6.paymentData2.bank2.optionValue.push(bankData.bank);
          });
        }
      }).catch(function (error) {
        _this6.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    verifyRuc: function verifyRuc(ruc) {
      var _this7 = this;

      var cachedData = JSON.parse(localStorage.getItem('newProvider'));

      this.$store.commit('START_LOADING');
      __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('GET', 'api/getPersonaSunat/' + ruc).then(function (response) {
        if (typeof response.data === 'string') {
          _this7.dataAfip = '';
          _this7.$message({
            message: response.data.replace('Id', 'RUC'),
            type: 'warning'
          });
        } else {
          _this7.validateRuc = true;
          if (!response.data.errorConstancia) {
            _this7.dataAfip = response.data.datosGenerales;
            if (_this7.dataAfip.tipoPersona === 'JURIDICA') {
              _this7.generalData.company = _this7.dataAfip.razonSocial;
            } else if (!cachedData.company) {
              _this7.generalData.company = (_this7.dataAfip.nombre ? _this7.dataAfip.nombre + ' ' : '') + _this7.dataAfip.apellido;
            }
            __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('GET', 'api/allCertification/' + _this7.generalData.cuit).then(function (response) {
              if (response.data['exgainCertification'].length === 0) {
                _this7.auxFlagEmptyExgainList = true;
              }
              _this7.certificationExgainList = response.data['exgainCertification'];

              _this7.certificationSussList = response.data['sussCertification'];
              _this7.certificationRg18List = response.data['rg18Certification'];
              _this7.certificationRg17List = response.data['rg17Certification'];
              _this7.certificationRg2681List = response.data['rg2681Certification'];
            });
            _this7.$message({
              message: 'RUC verificado correctamente en SUNAT',
              type: 'success'
            });
          } else {
            var mensaje = '';
            if (typeof response.data.errorConstancia.error === 'string') {
              mensaje = response.data.errorConstancia.error;
            } else {
              mensaje = response.data.errorConstancia.error.join('\n');
            }
            _this7.$message({
              message: 'Informa SUNAT: \n' + mensaje,
              type: 'error'
            });
          }
        }
        _this7.$store.commit('STOP_LOADING');
      }).catch(function (error) {
        _this7.$store.commit('STOP_LOADING');
        if (error && error.response && error.response.status === '400') {
          _this7.$message({
            message: error.response.data,
            type: 'error'
          });
        } else {
          _this7.$message.error('Error conectando con el servidor');
        }
      });
    },
    modifyData: function modifyData(dataType) {
      var _this8 = this;

      this.$confirm('Sus Datos se remitirán a Albanesi para su verificación', 'Atención', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(function () {
        _this8.editing = false;
        _this8.provider.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].MODIFICADO;
        _this8.saveData(dataType);
      });
    },
    saveData: function saveData(dataType) {
      var generalData = {};
      var paymentData = {};
      var taxData = {};
      if (dataType === 'generalData') {
        generalData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.extractFieldValues(this.generalData));
        generalData['' + this.generalData.address.name2] = this.generalData.address.model2;
        this.updateCompanyData(dataType, generalData);
      }
      if (dataType === 'paymentData') {
        paymentData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.extractFieldValues(this.paymentData1));
        if (this.optionalPaymentFlag.model) {
          paymentData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, paymentData, this.extractFieldValues(this.paymentData2));
        } else {
          paymentData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, paymentData, this.extractFieldValues(this.paymentData2, false));
        }
        if (this.companyTaxData.detractionSwitch.model) {
          paymentData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, paymentData, this.extractFieldValues(this.paymentData3));
        } else {
          paymentData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, paymentData, this.extractFieldValues(this.paymentData3, false));
        }
        this.updateCompanyData(dataType, paymentData);
      }
      if (dataType === 'taxData') {
        taxData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.extractFieldValues(this.companyTaxData));
        taxData['' + this.companyTaxData.perceptionSwitch.companyDataPerception.name] = this.companyTaxData.perceptionSwitch.companyDataPerception.model;
        if (this.companyTaxData.perceptionSwitch.model) {} else {
          taxData['' + this.companyTaxData.perceptionSwitch.companyDataPerception.name] = '';
        }
        if (this.companyTaxData.retentionSwitch.model) {
          taxData['' + this.companyTaxData.retentionSwitch.companyDataRetention.name] = this.companyTaxData.retentionSwitch.companyDataRetention.model;
          taxData['' + this.companyTaxData.retentionSwitch.companyRetentionFields.name] = this.companyTaxData.retentionSwitch.companyRetentionFields.model;
          taxData['' + this.companyTaxData.retentionSwitch.companySuspensionNumber.name] = this.companyTaxData.retentionSwitch.companySuspensionNumber.model;
          taxData['' + this.companyTaxData.retentionSwitch.firstDate.name] = this.companyTaxData.retentionSwitch.firstDate.model;
          taxData['' + this.companyTaxData.retentionSwitch.lastDate.name] = this.companyTaxData.retentionSwitch.lastDate.model;
          taxData['' + this.companyTaxData.retentionSwitch.pdfSuspension.name] = this.companyTaxData.retentionSwitch.pdfSuspension.model;
        } else {
          taxData['' + this.companyTaxData.retentionSwitch.companyDataRetention.name] = '';
          taxData['' + this.companyTaxData.retentionSwitch.companyRetentionFields.name] = '';
          taxData['' + this.companyTaxData.retentionSwitch.companySuspensionNumber.name] = '';
          taxData['' + this.companyTaxData.retentionSwitch.firstDate.name] = '';
          taxData['' + this.companyTaxData.retentionSwitch.lastDate.name] = '';
          taxData['' + this.companyTaxData.retentionSwitch.pdfSuspension.name] = '';
        }
        this.updateCompanyData(dataType, taxData);
      }
    },
    updateCompanyData: function updateCompanyData(dataType, data) {
      var _this9 = this;

      if (this.generalDataAccepted) {
        data.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].ACEPTADO;
        data.idUser = this.user.idUser;
        this.provider.idStage = __WEBPACK_IMPORTED_MODULE_11__config_company_stage__["a" /* default */].DATOS_BANCARIOS;
        this.provider.idUser = this.user.idUser;
      }
      if (this.generalDataRejected) {
        data.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].DEVUELTO;
        this.provider.idStage = __WEBPACK_IMPORTED_MODULE_11__config_company_stage__["a" /* default */].DATOS_BANCARIOS;
        this.provider.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].DEVUELTO;
        this.provider.idUser = this.user.idUser;
        data.observation = this.newObservation;
        data.idUser = this.user.idUser;
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('GET', 'api/sendMailUserReject/' + _this9.provider.idCompany + '?codCountry=' + 'PE').then(function () {});
        }, 900);
      }
      if (this.taxDataAccepted) {
        data.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].ACEPTADO;
        this.provider.idStage = __WEBPACK_IMPORTED_MODULE_11__config_company_stage__["a" /* default */].DATOS_IMPOSITIVOS;
        this.provider.idUser = this.user.idUser;
        data.idUser = this.user.idUser;
      }
      if (this.taxDataRejected) {
        data.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].DEVUELTO;
        this.provider.idStage = __WEBPACK_IMPORTED_MODULE_11__config_company_stage__["a" /* default */].DATOS_IMPOSITIVOS;
        this.provider.idUser = this.user.idUser;
        data.observation = this.newObservation;
        this.provider.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].DEVUELTO;
        data.idUser = this.user.idUser;
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('GET', 'api/sendMailUserReject/' + _this9.provider.idCompany).then(function () {});
        }, 900);
      }
      if (this.paymentDataAccepted) {
        data.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].ACEPTADO;
        this.provider.idCompanyStatus = __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].ACEPTADO;
        this.provider.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].ACEPTADO;
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('GET', 'api/sendMailUserActivation/' + _this9.provider.idCompany).then(function () {});
        }, 900);
        this.provider.idUser = this.user.idUser;
        data.idUser = this.user.idUser;
      }
      if (this.paymentDataRejected) {
        data.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].DEVUELTO;
        data.observation = this.newObservation;
        this.provider.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].DEVUELTO;
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('GET', 'api/sendMailUserReject/' + _this9.provider.idCompany).then(function () {});
        }, 900);
        this.provider.idUser = this.user.idUser;
        data.idUser = this.user.idUser;
      }
      this.activationOrReject();

      __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('POST', 'api/generic/company/' + this.provider.idCompany, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.provider)).then(function () {
        var idCompanyData = void 0;
        switch (dataType) {
          case 'generalData':
            idCompanyData = _this9.provider.idCompany;
            break;
          case 'paymentData':
            idCompanyData = _this9.provider.idCompany;
            break;
          case 'taxData':
            idCompanyData = _this9.provider.idCompany;
            break;
        }
        _this9.$store.commit('START_LOADING');
        __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('POST', 'api/generic/' + dataType + '/' + idCompanyData, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)).then(function (response) {
          switch (dataType) {
            case 'generalData':
              _this9.provider.ruc = _this9.generalData.ruc;
              _this9.provider.company = _this9.generalData.company.model;
              _this9.provider.companyName = _this9.generalData.companyName.model;
              __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('POST', 'api/generic/company/' + _this9.provider.idCompany, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this9.provider));
              break;
          }

          _this9.$store.commit('STOP_LOADING');
          _this9.provider[dataType] = response.data;

          _this9.user.roles.forEach(function (role) {
            if (role.rolesId === __WEBPACK_IMPORTED_MODULE_12__config_roles__["a" /* default */].AUTORIZADOR_DG_PE || role.rolesId === __WEBPACK_IMPORTED_MODULE_12__config_roles__["a" /* default */].ADMIN_SISTEMA || role.rolesId === __WEBPACK_IMPORTED_MODULE_12__config_roles__["a" /* default */].ADMIN_PORTAL) {
              _this9.$router.push('/newProviders');
            }
            if (role.rolesId === __WEBPACK_IMPORTED_MODULE_12__config_roles__["a" /* default */].AUTORIZADOR_DI_PE || role.rolesId === __WEBPACK_IMPORTED_MODULE_12__config_roles__["a" /* default */].ADMIN_SISTEMA || role.rolesId === __WEBPACK_IMPORTED_MODULE_12__config_roles__["a" /* default */].ADMIN_PORTAL) {
              _this9.$router.push('/newProviders');
            }
            if (role.rolesId === __WEBPACK_IMPORTED_MODULE_12__config_roles__["a" /* default */].AUTORIZADOR_DP_PE || role.rolesId === __WEBPACK_IMPORTED_MODULE_12__config_roles__["a" /* default */].ADMIN_SISTEMA || role.rolesId === __WEBPACK_IMPORTED_MODULE_12__config_roles__["a" /* default */].ADMIN_PORTAL) {
              _this9.$router.push('/newProviders');
            }
          });

          _this9.$message.success('Estado cambiado satisfactoriamente');
        }).catch(function (error) {
          console.log(error);
          _this9.$store.commit('STOP_LOADING');
        });
      });
    },
    openRejectCompanyDataModal: function openRejectCompanyDataModal() {
      var _this10 = this;

      var permission = this.checkRoles(this.step);
      if (!permission) {
        console.log('Permision es :' + permission);
        this.$router.push('/newProviders');
        this.$alert('No tiene los permisos requeridos para realizar esta accion', 'Permisos Insuficientes', {
          confirmButtonText: 'Aceptar',
          callback: function callback(action) {
            _this10.$router.push('/newProviders');
          }
        });
        return;
      }
      this.rejectCompanyDataVisible = true;
    },
    clearOptionalPaymentData: function clearOptionalPaymentData(switchValue) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helpers_utils_js__["b" /* saveDataToLocalStorage */])(switchValue, 'paymentFlag');
      for (var key in this.paymentData2) {
        if (this.paymentData2.hasOwnProperty(key)) {
          this.paymentData2[key].model = '';
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helpers_utils_js__["b" /* saveDataToLocalStorage */])('', key);
        }
      }
    },
    rejectCompanyData: function rejectCompanyData(dataType) {
      var _this11 = this;

      if (this.newObservation === '') {
        this.$message.warning('Falta completar el motivo');
        return;
      }
      this.$confirm('¿Está seguro que desea rechazar los datos por este motivo?', 'Advertencia', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(function () {
        if (dataType === 'generalData') {
          _this11.generalDataRejected = true;
        }
        if (dataType === 'paymentData') {
          _this11.paymentDataRejected = true;
        }
        if (dataType === 'taxData') {
          _this11.taxDataRejected = true;
        }
        _this11.saveData(dataType);
        _this11.$router.push('/newProviders');
      }).catch(function () {});
    },
    openModalTerminosYCondiciones: function openModalTerminosYCondiciones() {
      this.validateSteps();
      if (this.emptyFields.length === 0) {
        this.showTerminosYCondiciones = true;
      }
    },
    submitFormSolicitud: function submitFormSolicitud() {
      this.solicitudActivarUsuario('1');
      if (this.checked2 && this.checked) {
        this.showTerminosYCondiciones = false;
        this.checkData();
      } else {
        this.checked2 = false;
        this.checked = false;
        this.showTerminosYCondiciones = true;
      }
    },
    solicitudActivarUsuario: function solicitudActivarUsuario() {
      var _this12 = this;

      var stage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var companyName = this.generalData.companyName.name;
      var idFiscal = this.id.model;
      var idType = this.idType;
      if (!stage) {
        stage = this.provider.idStage;
      }
      __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('GET', 'api/solicitudActivarUsuario' + '?stage=' + stage + '&idFiscal=' + idFiscal + '&companyName=' + companyName + '&idType=' + idType).then(function (response) {
        _this12.toggleLoading();
      }).catch(function (error) {
        _this12.$store.commit('TOGGLE_LOADING');
        _this12.invoices = null;
        console.log(error);

        _this12.response = 'Error al conectarse con el servidor, contacte al administrador.';
        _this12.toggleLoading();
      });
    },
    checkProviderData: function checkProviderData() {
      if (this.provider && this.idCompany) {
        this.loadProvider();
      }
    },
    checkRoles: function checkRoles(currentStep) {
      var permission = false;
      this.user.roles.forEach(function (role) {
        console.log(role.rolesId);
        switch (role.rolesId) {
          case __WEBPACK_IMPORTED_MODULE_12__config_roles__["a" /* default */].AUTORIZADOR_DG_PE:
            if (currentStep === 0) {
              permission = true;
            }
            break;
          case __WEBPACK_IMPORTED_MODULE_12__config_roles__["a" /* default */].AUTORIZADOR_DI_PE:
            if (currentStep === 1) {
              permission = true;
            }
            break;
          case __WEBPACK_IMPORTED_MODULE_12__config_roles__["a" /* default */].AUTORIZADOR_DP_PE:
            if (currentStep === 2) {
              permission = true;
            }
            break;
          case __WEBPACK_IMPORTED_MODULE_12__config_roles__["a" /* default */].ADMIN_SISTEMA:
            permission = true;
            break;
          default:
            break;
        }
      });
      return permission;
    },
    activationOrReject: function activationOrReject() {
      var _this13 = this;

      var genD = this.provider.generalData.idCompanyDataStatus;
      var payD = this.provider.paymentData.idCompanyDataStatus;
      var taxD = this.provider.taxData.idCompanyDataStatus;

      if (genD === __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].ACEPTADO && payD === __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].ACEPTADO && taxD === __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].ACEPTADO) {
        this.provider.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].ACEPTADO;
        this.provider.idCompanyStatus = __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].ACEPTADO;
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('GET', 'api/sendMailUserActivation/' + _this13.provider.idCompany).then(function () {});
        }, 900);
      } else {
        if (genD === __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].DEVUELTO || payD === __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].DEVUELTO || taxD === __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].DEVUELTO) {
          this.provider.idCompanyDataStatus = __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].DEVUELTO;
          this.provider.idCompanyStatus = __WEBPACK_IMPORTED_MODULE_13__config_data_status__["a" /* default */].RECHAZADO;
          setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('GET', 'api/sendMailUserReject/' + _this13.provider.idCompany).then(function () {});
          }, 900);
        }
      }
    },
    getBankAccountTypes: function getBankAccountTypes() {
      var _this14 = this;

      __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('GET', 'api/generic/bankAccountType').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          var accountTypes = data.filter(function (bankAccountType) {
            return bankAccountType.codCountry === 'PE';
          });
          _this14.bankAccountTypes = data.filter(function (bankAccountType) {
            return bankAccountType.codCountry === 'PE';
          });
          _this14.paymentData1.accountType.optionValue = accountTypes.map(function (accountType) {
            return accountType.bankAccountType;
          });
          _this14.paymentData2.accountType2.optionValue = accountTypes.map(function (accountType) {
            return accountType.bankAccountType;
          });
        }
      }).catch(function (error) {
        _this14.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    acceptCompanyData: function acceptCompanyData(StepType) {
      var _this15 = this;

      var solicitud = true;
      if (this.provider.idStage === '3') {
        solicitud = false;
      }
      var permission = this.checkRoles(this.step);
      console.log('permission: ', permission);
      if (!permission) {
        console.log('Permision es :' + permission);
        this.$router.push('/newProviders');
        this.$alert('No tiene los permisos requeridos para realizar esta accion', 'Permisos Insuficientes', {
          confirmButtonText: 'Aceptar',
          callback: function callback(action) {
            _this15.$router.push('/newProviders');
          }
        });
        return;
      }
      this.$confirm('¿Está seguro que desea aceptar los datos?', 'Advertencia', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(function () {
        if (StepType === 'generalData') {
          _this15.generalDataAccepted = true;
        }
        if (StepType === 'paymentData') {
          _this15.paymentDataAccepted = true;
        }
        if (StepType === 'taxData') {
          _this15.taxDataAccepted = true;
        }

        _this15.saveData(StepType);
        if (solicitud) {
          _this15.solicitudActivarUsuario();
        }
        _this15.$parent.getProviders();
        if (!_this15.checkRoles(_this15.step + 1)) {
          _this15.$router.push('/newProviders');
        }
        _this15.$router.push('/newProviders');
      }).catch(function () {});
    }
  },
  beforeMount: function beforeMount() {
    this.isSystemAdmin();
    this.idCompany = this.$route.params.id;
    this.actualCountry = this.$route.params.country;
    this.companyData();
  },
  mounted: function mounted() {
    var _this16 = this;

    console.log(this.user);
    this.getBankAccountTypes();
    this.checkProviderData();
    this.getRubros();
    this.getLocations();
    this.getDenomination();
    this.getBank();

    this.recoverFromNewProviderStorage(this.id, 'id');

    for (var key in this.generalData) {
      this.recoverFromNewProviderStorage(this.generalData, key);
    }

    for (var _key in this.companyTaxData) {
      this.recoverFromNewProviderStorage(this.companyTaxData, _key);
    }

    for (var _key2 in this.paymentData1) {
      this.recoverFromNewProviderStorage(this.paymentData1, _key2);
    }
    this.recoverFromNewProviderStorage(this.optionalPaymentFlag, 'paymentFlag');
    for (var _key3 in this.paymentData2) {
      this.recoverFromNewProviderStorage(this.paymentData2, _key3);
    }
    for (var _key4 in this.paymentData3) {
      this.recoverFromNewProviderStorage(this.paymentData3, _key4);
    }

    for (var _key5 in this.userData) {
      this.recoverFromNewProviderStorage(this.userData, _key5);
    }
    __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('get', 'api/findConfiguration/TYC').then(function (response) {
      _this16.configuration = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('get', 'api/findConfiguration/CODETI').then(function (response) {
      _this16.codigoEtica = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('get', 'api/findConfiguration/POLANTI').then(function (response) {
      _this16.politicaAnticorrupcion = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_10__api__["a" /* default */].request('get', 'api/findConfiguration/POLREL').then(function (response) {
      _this16.politicaRelacionamiento = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
  }
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Settings',
  components: {},
  data: function data(router) {
    return {
      section: 'CommentDetail',
      loading: '',
      c: this.$route.query.c
    };
  },

  computed: {
    datetime: function datetime() {
      return new Date();
    }
  },
  methods: {}
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_data_tables__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_apiHelper__ = __webpack_require__(43);










__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_data_tables___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      menuBlocksGeneric: [{
        classEnabled: '',
        classDisabled: ''
      }],
      badgeChatValue: 0,
      badgeChatHidden: true,
      inactiveUser: false,
      returnedUser: false,
      moduleLoaded: false,
      urlPaymentPolicies: '',
      urlBuyPolicies: '',
      showModalPaymentPolicies: false,
      showModalBuyPolicies: false,
      showModalEthicsPolicies: false,
      ocCount: 0,
      ocFacturarCount: 0,
      ocGestPagoCount: 0,
      docPaymentOrderCount: 0,
      docReceivedCount: 0,
      newProviderCount: 0,
      newMessages: 0,
      adminNewMessages: 0,
      urlEthicsPolicies: '',
      titles: [{
        prop: 'nombre',
        label: 'Título'
      }, {
        prop: 'fecha_fin',
        label: 'Finaliza'
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['user', 'otherOperations', 'compulsas', 'messages', 'provMessages']), {
    menuBlocks: function menuBlocks() {
      var _this = this;

      return [{
        idModule: 1,
        imgEnabled: 'static/img/dashboard_icons/workflow-azul.png',
        imgDisabled: 'static/img/dashboard_icons/workflow-gris.png',
        inactiveCompany: false,
        title: 'Gestión de compulsas y licitaciones',
        links: [{
          route: '/compulsas',
          atClick: function atClick() {},
          title: 'Compulsa de precios',
          badgeHiddenCond: !(this.compCount.length > 0),
          badgeValue: this.compCount.length
        }, {
          route: '/',
          atClick: function atClick() {
            if (!_this.inactiveUser) {
              _this.showModalBuyPolicies = true;
            }
          },
          title: 'Política de compras',
          badgeHiddenCond: true,
          badgeValue: 0
        }]
      }, {
        idModule: 2,
        imgEnabled: 'static/img/dashboard_icons/gestionpagos-azul.png',
        imgDisabled: 'static/img/dashboard_icons/gestionpagos-gris.png',
        inactiveCompany: false,
        title: 'Gestión de facturas',
        links: [{
          route: '/toBill',
          atClick: function atClick() {},
          title: 'Carga de Facturas',
          badgeHiddenCond: this.user.isProvider ? !(this.ocFacturarCount > 0) : !(this.ocGestPagoCount > 0),
          badgeValue: this.user.isProvider ? this.ocFacturarCount : this.ocGestPagoCount
        }, {
          route: '/prebill',
          atClick: function atClick() {},
          title: 'Precarga de Facturas (sin OC)'
        }, {
          route: '/billsManagement',
          atClick: function atClick() {},
          title: 'Consulta de Facturas, NC, ND',
          badgeHiddenCond: this.user.isProvider ? !(this.docPaymentOrderCount > 0) : !(this.docReceivedCount > 0),
          badgeValue: this.user.isProvider ? this.docPaymentOrderCount : this.docReceivedCount
        }, {
          route: '',
          atClick: function atClick() {
            if (!_this.inactiveUser) {
              _this.showModalPaymentPolicies = true;
            }
          },
          title: 'Política de pagos',
          badgeHiddenCond: true,
          badgeValue: 0
        }]
      }, {
        idModule: 3,
        imgEnabled: 'static/img/dashboard_icons/autogestion-azul.png',
        imgDisabled: 'static/img/dashboard_icons/autogestion-gris.png',
        inactiveCompany: true,
        title: 'Autogestión',
        links: [{
          route: '/selfdata',
          atClick: function atClick() {},
          title: 'Mis datos',
          badgeHiddenCond: true,
          badgeValue: 0
        }, {
          route: '/changePsw',
          atClick: function atClick() {},
          title: 'Cambiar clave',
          badgeHiddenCond: true,
          badgeValue: 0
        }]
      }, {
        idModule: 4,
        imgEnabled: 'static/img/dashboard_icons/chat-azul.png',
        imgDisabled: 'static/img/dashboard_icons/chat-gris.png',
        inactiveCompany: true,
        title: 'Mensajes',
        links: [{
          route: '/allComments',
          atClick: function atClick() {},
          title: 'Ingresar al chat',
          badgeHiddenCondChat: this.user.isProvider ? !(this.newMessages > 0) : !(this.adminNewMessages > 0),
          badgeValue: this.user.isProvider ? this.newMessages : this.adminNewMessages
        }, {
          route: '/news',
          atClick: function atClick() {
            _this.showModalEthicsPolicies = true;
          },
          title: 'Novedades a Proveedores',
          badgeHiddenCond: true,
          badgeValue: 0
        }]
      }, {
        idModule: 5,
        imgEnabled: 'static/img/dashboard_icons/reportes-azul.png',
        imgDisabled: 'static/img/dashboard_icons/reportes-gris.png',
        inactiveCompany: false,
        title: 'Reportes',
        links: [{
          route: '/reports',
          atClick: function atClick() {},
          title: 'Consultar reportes',
          badgeHiddenCond: true,
          badgeValue: 0
        }]
      }, {
        idModule: 6,
        imgEnabled: 'static/img/dashboard_icons/instructivos-azul.png',
        imgDisabled: 'static/img/dashboard_icons/instructivos-gris.png',
        inactiveCompany: true,
        title: 'Instructivos',
        links: [{
          route: '/manuals',
          atClick: function atClick() {},
          title: 'Consultar instructivos ',
          badgeHiddenCond: true,
          badgeValue: 0
        }, {
          route: '',
          atClick: function atClick() {
            _this.showModalEthicsPolicies = true;
          },
          title: 'Código de conducta',
          badgeHiddenCond: true,
          badgeValue: 0
        }]
      }, {
        idModule: 7,
        imgEnabled: 'static/img/dashboard_icons/autogestionproveedores-azul.png',
        imgDisabled: 'static/img/dashboard_icons/autogestionproveedores-gris.png',
        inactiveCompany: false,
        title: 'Gestión de Proveedores',
        links: [{
          route: '/newProviders',
          atClick: function atClick() {},
          title: 'Alta/Modificación de proveedores',
          badgeHiddenCond: !(this.newProviderCount > 0),
          badgeValue: this.newProviderCount
        }, {
          route: '/ProvidersTable',
          atClick: function atClick() {},
          title: 'Reporte información de proveedores',
          badgeHiddenCond: true,
          badgeValue: 0
        }, {
          route: '/providers',
          atClick: function atClick() {},
          title: 'Gestión de proveedores registrados',
          badgeHiddenCond: true,
          badgeValue: 0
        }, {
          route: '/contacts',
          atClick: function atClick() {},
          title: 'Gestión de usuarios',
          badgeHiddenCond: !(this.usersToActivateCount.length > 0),
          badgeValue: this.usersToActivateCount.length
        }]
      }];
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    },
    newProviders: function newProviders() {
      return this.$store.state.providers.filter(function (prov) {
        return prov.idCompanyStatus === '1';
      });
    },
    usersToActivateCount: function usersToActivateCount() {
      return this.$store.state.contacts.filter(function (el) {
        return el.idProviderStatus === '1';
      });
    },
    compCount: function compCount() {
      return this.compulsas.filter(function (el) {
        return el.status.idLicitacionStatus === '2';
      });
    },
    documentationCount: function documentationCount() {
      return this.otherOperations;
    },
    frontendModules: function frontendModules() {
      var _this2 = this;

      var frontendModules = void 0;
      if (!this.user.isProvider) {
        frontendModules = this.$store.state.frontendModules.filter(function (mod) {
          return mod.visibleAdmin === '1';
        });
        frontendModules.forEach(function (fMod) {
          fMod.html = _this2.menuBlocks.find(function (mBlock) {
            return mBlock.idModule.toString() === fMod.idModule;
          });
        });
        return frontendModules.sort(function (a, b) {
          return a.orderAdmin > b.orderAdmin;
        });
      } else {
        frontendModules = this.$store.state.frontendModules.filter(function (mod) {
          return mod.visibleProvider === '1';
        });
        frontendModules.forEach(function (fMod) {
          fMod.html = _this2.menuBlocks.find(function (mBlock) {
            return mBlock.idModule.toString() === fMod.idModule;
          });
          if (!_this2.moduleLoaded) {
            _this2.moduleProv();
            _this2.moduleLoaded = true;
          }
        });
        return frontendModules.sort(function (a, b) {
          return a.orderProvider > b.orderProvider;
        });
      }
    },
    rowsModules: function rowsModules() {
      return [this.frontendModules.slice(0, Math.floor(this.frontendModules.length / 2)), this.frontendModules.slice(Math.ceil(this.frontendModules.length / 2) - this.frontendModules.length % 2)];
    },
    rolesHasModules: function rolesHasModules() {
      return this.$store.state.rolesHasModules;
    }
  }),
  methods: {
    getDocPaymentOrderCount: function getDocPaymentOrderCount() {
      var _this3 = this;

      if (this.user.isProvider) {
        __WEBPACK_IMPORTED_MODULE_5__helpers_apiHelper__["a" /* default */].getTotal('buyOrderDocumentByCompany', 'idBuyOrderDocumentStatus = 4 AND idCompany =' + this.user.company.idCompany).then(function (count) {
          _this3.docPaymentOrderCount = count;
        });
      }
    },
    getNotificationsMessages: function getNotificationsMessages() {
      var _this4 = this;

      if (this.user) return;
      if (this.user.idUser) {
        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('GET', 'api/getMessagesNotifications?id=' + this.user.idUser).then(function (response) {
          var data = response.data;
          if (typeof data !== 'number') {
            data = 0;
            _this4.badgeChatValue = 0;
            _this4.badgeChatHidden = true;
          } else {
            _this4.badgeChatValue = data;
            _this4.badgeChatHidden = false;
          }
          if (data.error) {
            return;
          }
          if (data) {
            _this4.$store.state.countries = data;
          }
        }).catch(function (error) {
          _this4.$store.commit('TOGGLE_LOADING');
          console.log(error);
        });
      }
    },
    getNewProviderCount: function getNewProviderCount() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_5__helpers_apiHelper__["a" /* default */].getTotal('companyCountriesStatus', 'idCompanyStatus = 1 OR idCompanyStatus = 4').then(function (count) {
        _this5.newProviderCount = count;
      });
    },
    getNewMessagesCount: function getNewMessagesCount() {
      this.adminNewMessages = this.badgeChatValue;
    },
    getDocReceivedCount: function getDocReceivedCount() {
      var _this6 = this;

      if (!this.user.isProvider) {
        __WEBPACK_IMPORTED_MODULE_5__helpers_apiHelper__["a" /* default */].getTotal('buyOrderDocument', 'idBuyOrderDocumentStatus = 1').then(function (count) {
          _this6.docReceivedCount = count;
        });
      }
    },
    getOcCount: function getOcCount() {
      var _this7 = this;

      if (this.user.isProvider) {
        __WEBPACK_IMPORTED_MODULE_5__helpers_apiHelper__["a" /* default */].getTotal('buyOrder', 'statusId = 2 AND idCompany =' + this.user.company.idCompany).then(function (count) {
          _this7.ocCount = count;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_5__helpers_apiHelper__["a" /* default */].getTotal('buyOrder', 'statusId = 1').then(function (count) {
          _this7.ocCount = count;
        });
      }
    },
    getOcFacturarCount: function getOcFacturarCount() {
      var _this8 = this;

      if (this.user.isProvider) {
        __WEBPACK_IMPORTED_MODULE_5__helpers_apiHelper__["a" /* default */].getTotal('buyOrder', 'statusId = 3 AND idCompany =' + this.user.company.idCompany).then(function (count) {
          _this8.ocFacturarCount = count;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_5__helpers_apiHelper__["a" /* default */].getTotal('buyOrder', 'statusId = 3').then(function (count) {
          _this8.ocFacturarCount = count;
        });
      }
    },
    getOcGestPagoCount: function getOcGestPagoCount() {
      var _this9 = this;

      if (this.user.isProvider) {
        __WEBPACK_IMPORTED_MODULE_5__helpers_apiHelper__["a" /* default */].getTotal('buyOrder', 'statusId = 9 AND idCompany =' + this.user.company.idCompany).then(function (count) {
          _this9.ocGestPagoCount = count;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_5__helpers_apiHelper__["a" /* default */].getTotal('buyOrder', 'statusId = 9').then(function (count) {
          _this9.ocGestPagoCount = count;
        });
      }
    },
    userHasModule: function userHasModule(module) {
      var found = false;
      var rolesHasThisModule = this.rolesHasModules.filter(function (roleMod) {
        return roleMod.idModule === module.idModule;
      });
      this.user.roles.forEach(function (userRole) {
        if (rolesHasThisModule.some(function (roleModule) {
          return roleModule.rolesId === userRole.rolesId;
        })) {
          found = true;
          return;
        }
      });
      return this.user.isProvider || found;
    },
    moduleVisible: function moduleVisible(module) {
      return this.user.isProvider && module.visibleProvider === '1' || !this.user.isProvider && module.visibleAdmin === '1';
    },
    moduleProv: function moduleProv() {
      if (this.user.isProvider && this.user.isAdmin === '1') {
        var gestionUsuarios = {
          route: '/contacts',
          atClick: function atClick() {},
          title: 'Gestión de usuarios',
          badgeHiddenCond: true,
          badgeValue: 0
        };
        this.menuBlocks[2].links.push(gestionUsuarios);
      }
    },
    goToBidding: function goToBidding(selected) {
      this.$router.push({ 'name': 'Compulsas', params: { licitacion: selected } });
    }
  },
  mounted: function mounted() {
    var _this10 = this;

    this.timmerMessage = setInterval(function () {
      return _this10.getNotificationsMessages();
    }, 1000 * 15);
    if (this.$route.query.finSolicitud === '1') {
      this.$router.push('/finSolicitud?t=' + this.$route.query.t);
    } else if (this.$route.query.i === '1') {
      this.$router.push('/pswreestablecida?e=' + this.$route.query.e);
    } else {
      if (!this.user) {
        this.$router.push('/login');
      } else if (this.user.company && this.user.company.idCompanyDataStatus === '1') {
        this.inactiveUser = true;
      } else if (this.user.company && this.user.company.idCompanyDataStatus === '3') {
        this.returnedUser = true;
      }
    }
  },
  unmounted: function unmounted() {
    if (this.timmerMessage) {
      clearInterval(this.timmerMessage);
    }
  },
  beforeUpdate: function beforeUpdate() {
    this.newMessages = this.badgeChatValue;
  },
  beforeMount: function beforeMount() {
    var _this11 = this;

    this.getNotificationsMessages();
    this.getOcCount();
    this.getOcFacturarCount();
    this.getOcGestPagoCount();
    this.getDocPaymentOrderCount();
    this.getDocReceivedCount();
    this.getNewProviderCount();
    this.getNewMessagesCount();
    if (this.$route.query.finSolicitud === '1') {
      this.$router.push('/finSolicitud?t=' + this.$route.query.t);
    } else if (this.$route.query.i === '1') {
      this.$router.push('/pswreestablecida?e=' + this.$route.query.e);
    } else {
      if (!this.$store.state.user) {
        this.$router.push('/login');
      }
    }
    if (this.user.company && this.user.company.idCompanyDataStatus === '1') {
      this.inactiveUser = true;
    } else if (this.user.company && this.user.company.idCompanyDataStatus === '3') {
      this.returnedUser = true;
    }

    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', 'api/findConfiguration/POLPAG').then(function (response) {
      _this11.urlPaymentPolicies = response.data['value'];
    });
    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', 'api/findConfiguration/POLCOM').then(function (response) {
      _this11.urlBuyPolicies = response.data['value'];
    });
    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', 'api/findConfiguration/CODETI').then(function (response) {
      _this11.urlEthicsPolicies = response.data['value'];
    });
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_utils_js__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  props: {
    data: {
      type: Object,
      required: true
    },
    validation: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  computed: {},
  methods: {
    verifyFieldsDoubleInput: function verifyFieldsDoubleInput(data) {
      return data.model2.length === 0 && this.validation === false && data.required;
    },

    verifyFields: __WEBPACK_IMPORTED_MODULE_0__helpers_utils_js__["c" /* verifyFields */],
    persistToNewProviderStorage: __WEBPACK_IMPORTED_MODULE_0__helpers_utils_js__["a" /* persistToNewProviderStorage */],
    saveDataToLocalStorage: __WEBPACK_IMPORTED_MODULE_0__helpers_utils_js__["b" /* saveDataToLocalStorage */]
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_date_picker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(2);


__webpack_require__(0);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Settings',
  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_0_vue_date_picker___default.a
  },
  data: function data(router) {
    return {
      section: 'FinSolicitud',
      loading: '',
      newPsw: '',
      newPswRe: '',
      response: null
    };
  },

  computed: {
    datetime: function datetime() {
      return new Date();
    }
  },

  methods: {
    changePassword: function changePassword() {
      var _this = this;

      var token = this.$route.query.t;
      var newPsw = this.newPsw,
          newPswRe = this.newPswRe;

      this.toggleLoading();
      this.resetResponse();
      this.$store.commit('TOGGLE_LOADING');

      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('POST', 'api/changePsw', { 'token': token, newPsw: newPsw, newPswRe: newPswRe }).then(function (response) {
        _this.toggleLoading();
        _this.invoices = null;

        var data = response.data;

        if (response.data.error) {
          var errorName = response.data.error.name;
          if (errorName) {
            if (errorName === 'InvalidArgumentError') {
              _this.response = 'Los datos suministrados son incorrectos.';
            } else if (errorName === 'NotFoundError') {
              _this.response = 'La factura no se encuentra.';
            } else {
              _this.response = errorName;
            }
          } else {
            _this.response = data.error;
          }

          return;
        } else {
          if (data.success) {
            _this.$alert('A continuación, ingrese con su nueva cuenta', 'Registro completado', {
              confirmButtonText: 'OK',
              callback: function callback() {
                localStorage.removeItem('user');
                _this.$store.commit('SET_USER', '');
                _this.$store.commit('SET_TOKEN', '');
                _this.$router.push('/login');
              }
            });
          }
        }
      }).catch(function (error) {
        _this.$store.commit('TOGGLE_LOADING');
        _this.invoices = null;
        console.log(error);

        _this.response = 'Error al conectarse con el servidor, contacte al administrador.';
        _this.toggleLoading();
      });
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'cargando' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
      this.success = '';
    }
  }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_text_mask__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_text_mask__);


__webpack_require__(0);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Individual',
  components: {
    MaskedInput: __WEBPACK_IMPORTED_MODULE_1_vue_text_mask___default.a
  },
  data: function data(router) {
    return {
      section: 'Individual',
      loading: '',
      rut: '',
      typeDoc: 'factura',
      numberInvoice: '',
      amount: '',
      invoices: null,
      dateEmission: '',
      response: null,
      paramError: null,
      rutMask: this.$store.state.rutMask,
      invoiceMask: this.$store.state.invoiceMask
    };
  },

  computed: {
    datetime: function datetime() {
      return new Date();
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].request('get', 'api/checkParam?id=CIF-001').then(function (response) {
      var data = response.data;

      if (data.error) {
        _this.paramError = data.error;
      }
    }).catch(function (error) {
      console.log(error);
    });
  },

  methods: {
    checkIndividuals: function checkIndividuals() {
      var _this2 = this;

      console.log(dateEmission);
      var rut = this.rut,
          typeDoc = this.typeDoc,
          numberInvoice = this.numberInvoice,
          dateEmission = this.dateEmission,
          amount = this.amount;


      this.toggleLoading();
      this.resetResponse();
      this.$store.commit('TOGGLE_LOADING');

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].request('GET', 'api/listByAnonymous' + '?rut=' + rut + '&typeDoc=' + typeDoc + '&numberInvoice=' + numberInvoice + '&dateEmission=' + dateEmission + '&amount=' + amount).then(function (response) {
        _this2.toggleLoading();
        _this2.invoices = null;

        var data = response.data;

        if (response.data.error) {
          var errorName = response.data.error.name;
          if (errorName) {
            if (errorName === 'InvalidArgumentError') {
              _this2.response = 'Los datos suministrados son incorrectos.';
            } else if (errorName === 'NotFoundError') {
              _this2.response = 'La factura no se encuentra.';
            } else {
              _this2.response = errorName;
            }
          } else {
            _this2.response = data.error;
          }

          return;
        } else {
          if (data) {
            _this2.invoices = data;
          }
        }
      }).catch(function (error) {
        _this2.$store.commit('TOGGLE_LOADING');
        _this2.invoices = null;
        console.log(error);

        _this2.response = 'Error al conectarse con el servidor, contacte al administrador.';
        _this2.toggleLoading();
      });
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'cargando' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
    }
  }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_date_picker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_editor__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UploadOrder_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__UploadOrder_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__UploadOrder_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__UploadReceipt_vue__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__UploadReceipt_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__UploadReceipt_vue__);






__webpack_require__(0);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Settings',
  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_4_vue_date_picker___default.a,
    VueEditor: __WEBPACK_IMPORTED_MODULE_7_vue2_editor__["a" /* VueEditor */],
    'upload-receipt': __WEBPACK_IMPORTED_MODULE_9__UploadReceipt_vue___default.a,
    'upload-order': __WEBPACK_IMPORTED_MODULE_8__UploadOrder_vue___default.a
  },
  data: function data(router) {
    return {
      buyOrder: '',
      centerDialogVisible: false,
      section: 'Search',
      loading: false,
      idUser: this.$store.state.user.idUser,
      idBuyOrder: this.$route.query.i,
      showModalCreateDocument: false,
      showModalConfirmarDocumentacion: false,
      showModalPaymentOrder: false,
      buyOrderDocument: '',
      newPaymentOrder: {
        pdf: '',
        comment: ''
      },
      documentoRechazado: [],
      nuevoDocumento: {
        idBuyOrder: '',
        pdf: '',
        letra: '',
        numero: '',
        lineas: [],
        impuestos: [],
        fechaVencimiento: null,
        documentType: '',
        importeTotal: 0,
        importeImpuesto: 0,
        importePorcentaje: '',
        moneda: '',
        importeOtrosImpuesto: 0,
        importeTotalImpuesto: 0,
        tipoCambio: '',
        visto: 0,
        idBuyOrderDocumentStatus: 1,
        mensajeRechazo: '',
        documentComment: ''
      },
      lineaData: {
        codigo: '',
        descripcion: '',
        cantidad: 0,
        medida: '',
        precio: 0,
        porBoni: 0,
        importeBoni: 0,
        subtotal: 0,
        iva: '',
        subtotalIva: 0
      },
      impuestoData: {
        detalle: '',
        descripcion: '',
        baseImponible: 0,
        alicuota: 0,
        importe: 0
      },
      showUpload: false,
      confirmPayment: false,
      documentosAceptados: [],
      documentosRechazados: [],
      nuevoMensajeRechazo: '',
      rejectReasons: [{
        value: 'Daño en las mercaderías, cuando no estuviesen expedidas o entregadas por su cuenta y riesgo.'
      }, {
        value: 'Vicios, defectos y diferencias en la calidad o en la cantidad debidamente comprobados.'
      }, {
        value: 'Divergencias en los plazos o en los precios estipulados.'
      }, {
        value: 'No Correspondencia con los servicios o la obra efectivamente contratados.'
      }, {
        value: 'Existencia de vicios formales que causen su inhabilidad tanto como titulo ejecutivo y valor no caratular, así como documento comercial.'
      }, {
        value: 'Falta de entrega de la mercadería o prestación del servicio.'
      }],
      filters: [{
        prop: 'documentType',
        value: []
      }, {
        prop: 'idBuyOrderDocumentStatus',
        value: []
      }],
      titleDocument: [{
        prop: 'date',
        label: 'Fecha de carga'
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])(['user', 'lineas', 'otherOperations']), {
    statusList: function statusList() {
      if (this.buyOrder.nic === null) {
        var lista = this.$store.state.countStatus.filter(function (el) {
          return el.statusId === '1' || el.statusId === '2' || el.statusId === '3' || el.statusId === '7';
        });
        return lista;
      }
      return this.$store.state.countStatus;
    },
    buyOrderDocumentType: function buyOrderDocumentType() {
      return this.$store.state.buyOrderDocumentType;
    },
    buyOrderDocumentTypeCode: function buyOrderDocumentTypeCode() {
      return this.$store.state.buyOrderDocumentTypeCode;
    },
    buyOrderDocumentStatus: function buyOrderDocumentStatus() {
      return this.$store.state.buyOrderDocumentStatus;
    },
    documentType: function documentType() {
      return this.$store.state.documentType;
    }
  }),
  methods: {
    getBuyOrder: function getBuyOrder() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('GET', 'api/getBuyOrderByPk/' + this.$route.query.i).then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          var orders = data;
          _this.buyOrder = orders[0];
        }
      });
    },
    finishDocumentUploading: function finishDocumentUploading() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/finishDocumentUploading', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.idBuyOrder)).then(function (response) {
        _this2.$message.success('El estado de la orden de compra ha sido actualizado', 'success');
        _this2.hideModal();
        _this2.centerDialogVisible = false;
      }).catch(function (error) {
        _this2.$message.error(error.response.data, 'error');
      });
    },
    addLinea: function addLinea() {
      this.nuevoDocumento.lineas.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.lineaData));
      this.calcularLineas();
    },
    addImpuesto: function addImpuesto() {
      this.nuevoDocumento.impuestos.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.impuestoData));
    },
    updateLinea: function updateLinea(linea) {
      linea.importeBoni = linea.precio * linea.cantidad * (linea.porBoni / 100);
      linea.subtotal = linea.precio * linea.cantidad - linea.importeBoni;
      linea.subtotalIva = linea.subtotal * linea.iva;
      this.nuevoDocumento.importeTotal = this.nuevoDocumento.importeTotal + linea.subtotal;
      this.calcularLineas();
    },
    calcularLineas: function calcularLineas() {
      this.nuevoDocumento.importeImpuesto = 0;
      this.nuevoDocumento.importeTotal = 0;
      this.nuevoDocumento.importeTotalImpuesto = 0;
      for (var j = 0; j < this.nuevoDocumento.lineas.length; j++) {
        this.nuevoDocumento.importeTotal = this.nuevoDocumento.importeTotal + this.nuevoDocumento.lineas[j].subtotal;
        this.nuevoDocumento.importeImpuesto = this.nuevoDocumento.importeImpuesto + this.nuevoDocumento.lineas[j].subtotalIva;
      }
      this.nuevoDocumento.importeTotalImpuesto = this.nuevoDocumento.importeOtrosImpuesto + this.nuevoDocumento.importeImpuesto;
    },
    calcularImpuestos: function calcularImpuestos() {
      this.nuevoDocumento.importeOtrosImpuesto = 0;
      this.nuevoDocumento.importeTotalImpuesto = 0;
      for (var j = 0; j < this.nuevoDocumento.impuestos.length; j++) {
        this.nuevoDocumento.importeOtrosImpuesto = this.nuevoDocumento.importeOtrosImpuesto + this.nuevoDocumento.impuestos[j].importe;
      }
      this.nuevoDocumento.importeTotalImpuesto = this.nuevoDocumento.importeOtrosImpuesto + this.nuevoDocumento.importeImpuesto;
    },
    updateImpuesto: function updateImpuesto(impuesto) {
      console.log(impuesto);
      impuesto.importe = impuesto.baseImponible * (impuesto.alicuota / 100);
      this.calcularImpuestos();
    },
    deleteLinea: function deleteLinea(item) {
      var index = this.nuevoDocumento.lineas.indexOf(item);
      if (index !== -1) {
        this.nuevoDocumento.lineas.splice(index, 1);
      }
      this.calcular();
    },
    deleteImpuesto: function deleteImpuesto(item) {
      var index = this.nuevoDocumento.impuestos.indexOf(item);
      if (index !== -1) {
        this.nuevoDocumento.impuestos.splice(index, 1);
      }
      this.calcularImpuestos();
    },
    openModalPaymentOrder: function openModalPaymentOrder(buyOrderDocument) {
      this.showModalPaymentOrder = true;
      this.buyOrderDocument = buyOrderDocument;
    },
    hideModal: function hideModal() {
      this.resetNuevoDocumento();
      this.showModalCreateDocument = false;
    },
    datetime: function datetime() {
      var date = new Date();
      return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
    },
    handleFileChange: function handleFileChange() {
      this.showUpload = this.$refs.fileBuyOrder && this.$refs.fileBuyOrder.files.length > 0 || this.$refs.filePayment && this.$refs.filePayment.files.length > 0;
    },
    uploadBuyOrder: function uploadBuyOrder() {
      var _this3 = this;

      this.$confirm('¿Realmente desea adjuntar este pdf a la OC?', 'Advertencia', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        lockScroll: false
      }).then(function () {
        var formData = new FormData();
        formData.append('file', _this3.$refs.fileBuyOrder.files[0]);
        formData.append('folder', 'buyOrders');
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/uploadFile', formData).then(function (response) {
          _this3.buyOrder.pdf = response.data;
          __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/buyOrder/' + _this3.buyOrder.idBuyOrder, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this3.buyOrder)).then(function (response2) {
            __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/buyOrderHistory', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({ 'idBuyOrder': _this3.buyOrder.idBuyOrder, 'detalle': _this3.$store.state.countStatus[2].description, 'date': _this3.datetime() })).then(function (response3) {
              _this3.getBuyOrder();
              _this3.hideModal();
            });
          });
        });
      }).catch(function () {});
    },
    uploadPayment: function uploadPayment() {
      var _this4 = this;

      if (this.newPaymentOrder.comment === null) {
        this.$alert('Para confirmar la operación debe detallar la información de Pago', 'Advertencia', {
          confirmButtonText: 'Aceptar',
          type: 'warning',
          lockScroll: false
        });
      } else {
        this.$confirm('¿Realmente desea adjuntar el comprobante?', 'Advertencia', {
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          type: 'warning',
          lockScroll: false
        }).then(function () {
          var formData = new FormData();
          formData.append('file', _this4.$refs.filePayment.files[0]);
          formData.append('folder', 'payments');
          __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/uploadFile', formData).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/paymentOrder', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
              'pdf': response.data,
              'comment': _this4.newPaymentOrder.comment
            })).then(function (response2) {
              _this4.buyOrderDocument.idBuyOrderDocumentStatus = '4';
              _this4.buyOrderDocument.idPaymentOrder = response2.data.idPaymentOrder;
              __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/buyOrderDocument/' + _this4.buyOrderDocument.idBuyOrderDocument, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this4.buyOrderDocument)).then(function (response3) {
                __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('GET', 'api/sendMailBuyOrderDocumentStatus/' + _this4.buyOrderDocument.idBuyOrderDocument);
                _this4.hideModalPaymentOrder();
                _this4.getBuyOrder();
              });
            });
          });
        }).catch(function () {});
      }
    },
    tieneFacturaAceptada: function tieneFacturaAceptada() {
      return this.buyOrder.documents && this.buyOrder.documents.find(function (el) {
        return el.documentType === '1' && (el.idBuyOrderDocumentStatus === '2' || el.idBuyOrderDocumentStatus === '4');
      }) !== undefined;
    },
    mostrarMensajeCompleto: function mostrarMensajeCompleto(mensaje) {
      this.$alert(mensaje, 'Mensaje', {
        confirmButtonText: 'OK'
      });
    },
    createDocument: function createDocument() {
      var _this5 = this;

      if (this.nuevoDocumento.documentType === '') {
        this.$message({
          type: 'warning',
          message: 'Elija el tipo de documento'
        });
        return;
      }
      if (this.$refs.fileDocument.files[0] === undefined) {
        this.$message({
          type: 'warning',
          message: 'Seleccione un archivo'
        });
        return;
      }
      if (this.nuevoDocumento.hes === '') {
        this.$message({
          type: 'warning',
          message: 'Seleccione una HES'
        });
        return;
      }
      this.$confirm('Está por adjuntar y enviar el documento ¿Está seguro?', 'Advertencia', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        lockScroll: false
      }).then(function () {
        var formData = new FormData();
        formData.append('file', _this5.$refs.fileDocument.files[0]);
        formData.append('folder', 'documents');
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/uploadFile', formData).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/buyOrderDocument', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({ 'documentComment': _this5.nuevoDocumento.documentComment, 'visto': 0, 'lyrics': _this5.nuevoDocumento.letra, 'expirationDate': _this5.nuevoDocumento.fechaVencimiento, 'total': _this5.nuevoDocumento.importeTotal, 'totalTax': _this5.nuevoDocumento.importeImpuesto, 'currency': _this5.nuevoDocumento.moneda, 'exchange': _this5.nuevoDocumento.tipoCambio, 'documentType': _this5.nuevoDocumento.documentType, 'idBuyOrder': _this5.buyOrder.idBuyOrder, 'pdf': response.data, 'idBuyOrderDocumentStatus': 1 })).then(function (buyOrderDocument) {
            __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/buyOrderHistory', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({ 'idBuyOrder': _this5.buyOrder.idBuyOrder, 'detalle': _this5.$store.state.countStatus[2].description, 'date': _this5.datetime() })).then(function (response4) {
              __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('GET', 'api/sendMailBuyOrderDocumentStatus/' + buyOrderDocument.data.idBuyOrderDocument);
              if (_this5.nuevoDocumento.hes) {
                __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/associateHesWithDocument', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({ 'idBuyOrderDocument': buyOrderDocument.data.idBuyOrderDocument, 'hes': _this5.nuevoDocumento.hes })).then(function (response5) {
                  _this5.getBuyOrder();
                  _this5.hideModal();
                });
              } else {
                _this5.getBuyOrder();
                _this5.hideModal();
              }
            });
          });
        });
      }).catch(function () {});
    },
    handleIncluirDocumento: function handleIncluirDocumento(row, idBuyOrderDocumentStatus) {
      if (idBuyOrderDocumentStatus === 2) {
        if (!this.documentosAceptados.includes(row)) {
          this.documentosRechazados = this.documentosRechazados.filter(function (el) {
            return el !== row;
          });
          this.documentosAceptados.push(row);
        } else {
          this.documentosAceptados = this.documentosAceptados.filter(function (el) {
            return el !== row;
          });
        }
      }
      if (idBuyOrderDocumentStatus === 3) {
        if (!this.documentosRechazados.includes(row)) {
          this.documentosAceptados = this.documentosAceptados.filter(function (el) {
            return el !== row;
          });
          this.documentosRechazados.push(row);
        } else {
          this.documentosRechazados = this.documentosRechazados.filter(function (el) {
            return el !== row;
          });
        }
      }
    },
    cerrarModalConfirmarDocumentacion: function cerrarModalConfirmarDocumentacion() {
      this.showModalConfirmarDocumentacion = false;
      this.documentosRechazados.forEach(function (el) {
        el.mensajeRechazo = '';
      });
    },
    abrirModalConfirmacion: function abrirModalConfirmacion() {
      this.showModalConfirmarDocumentacion = true;
    },
    confirmarDocumentos: function confirmarDocumentos() {
      var cantidadMensajesRechazados = this.documentosRechazados.filter(function (document) {
        return document['mensajeRechazo'] === null || document['mensajeRechazo'] === '';
      }).length;
      var mensajeAlert = 'Debe completar los campos "Mensaje"';
      if (cantidadMensajesRechazados === 0) {
        this.cambiarEstadoDocumentos(this.documentosRechazados, 3);
        this.cambiarEstadoDocumentos(this.documentosAceptados, 2);
        this.documentosAceptados = [];
        this.documentosRechazados = [];
        this.cerrarModalConfirmarDocumentacion();
      } else {
        if (cantidadMensajesRechazados === 1) {
          mensajeAlert = 'Debe completar el campo "Mensaje"';
        }
        this.$message({
          type: 'warning',
          message: mensajeAlert
        });
      }
    },
    cambiarEstadoDocumentos: function cambiarEstadoDocumentos(documentos, idBuyOrderDocumentStatus) {
      var _this6 = this;

      documentos.forEach(function (doc) {
        _this6.cambiarEstadoDocumento(doc, idBuyOrderDocumentStatus);
      });
    },
    cambiarEstadoDocumento: function cambiarEstadoDocumento(documento, estado) {
      documento.idBuyOrderDocumentStatus = estado.toString();
      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/buyOrderDocument/' + documento.idBuyOrderDocument, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(documento)).then(function (response) {
        if (estado === 3) {
          __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('GET', 'api/sendMailBuyOrderDocumentStatus/' + documento.idBuyOrderDocument);
        }
      });
    },
    clavarVisto: function clavarVisto() {
      var _this7 = this;

      if (this.user.isProvider) {
        if (this.buyOrder.view === '0' && (this.buyOrder.statusId === '2' || this.buyOrder.statusId === '3' || this.buyOrder.statusId === '6' || this.buyOrder.statusId === '8')) {
          this.buyOrder.view = 1;
          __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/buyOrder/' + this.buyOrder.idBuyOrder, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.buyOrder)).then(function (response) {
            _this7.getBuyOrder();
          });
        }
      } else {
        if (this.buyOrder && this.buyOrder.view === '0' && this.buyOrder.statusId === '9') {
          this.buyOrder.view = 1;
          __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/buyOrder/' + this.buyOrder.idBuyOrder, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.buyOrder)).then(function (response) {
            _this7.getBuyOrder();
          });
        }
      }
    },
    activarBuyOrder: function activarBuyOrder() {
      var _this8 = this;

      this.$confirm('¿Realmente desea activar la OC?', 'Advertencia', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        lockScroll: false
      }).then(function () {
        _this8.changeBuyOrderStatus('2');
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/buyOrderHistory', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({ 'idBuyOrder': _this8.buyOrder.idBuyOrder, 'detalle': _this8.$store.state.countStatus[2].description, 'date': _this8.datetime() })).then(function () {
          _this8.$parent.getBuyOrders();
        });
      }).catch(function () {});
    },
    rechazarBuyOrder: function rechazarBuyOrder() {
      var _this9 = this;

      this.$confirm('¿Realmente desea rechazar la OC?', 'Advertencia', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        lockScroll: false
      }).then(function () {
        _this9.changeBuyOrderStatus('7');
      }).catch(function () {});
    },
    changeBuyOrderStatus: function changeBuyOrderStatus(statusId) {
      var _this10 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this10.buyOrder.statusId = statusId;
        _this10.buyOrder.view = 0;
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/buyOrder/' + _this10.buyOrder.idBuyOrder, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this10.buyOrder)).then(function (response) {
          _this10.getBuyOrder();
          if (response.data.statusId === '2' || response.data.statusId === '9' || response.data.statusId === '8' || response.data.statusId === '6') {
            __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('GET', 'api/SendMailBuyOrderStatus/' + _this10.buyOrder.idBuyOrder);
          }
          resolve(response);
        });
      });
    },
    getTypeName: function getTypeName(id) {
      var type = this.buyOrderDocumentType.find(function (el) {
        return parseInt(el.idBuyOrderDocumentType) === parseInt(id);
      });
      if (type) {
        return type.description;
      } else {
        return '';
      }
    },
    getStatusName: function getStatusName(idBuyOrderDocumentStatus) {
      return this.buyOrderDocumentStatus.find(function (el) {
        return el.idBuyOrderDocumentStatus === idBuyOrderDocumentStatus.toString();
      }).description;
    },
    getBuyOrderStatusName: function getBuyOrderStatusName(id) {
      console.log('--> ' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.statusList));
      if (!this.statusList.length) return '-';
      return this.statusList.find(function (el) {
        return el.statusId === id;
      }).description;
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'cargando' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
    },
    resetNuevoDocumento: function resetNuevoDocumento() {
      this.nuevoDocumento = {
        idBuyOrder: '',
        importeTotal: 0,
        importeImpuesto: 0,
        importePorcentaje: '',
        moneda: '',
        importeOtrosImpuesto: 0,
        importeTotalImpuesto: 0,
        pdf: '',
        date: '',
        documentType: '',
        visto: 0,
        idBuyOrderDocumentStatus: 1,
        mensajeRechazo: '',
        hes: [],
        lineas: [],
        impuestos: [],
        migo: []
      };
    },
    resetNewPaymentOrder: function resetNewPaymentOrder() {
      this.newPaymentOrder = {
        pdf: '',
        comment: ''
      };
      this.buyOrderDocument = '';
    },
    hideModalPaymentOrder: function hideModalPaymentOrder() {
      this.showModalPaymentOrder = false;
      this.resetNewPaymentOrder();
    }
  },
  mounted: function mounted() {
    this.clavarVisto();
  },
  beforeMount: function beforeMount() {
    this.getBuyOrder();
  }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date_picker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_data_tables__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_es__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_locale__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_editor__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config__ = __webpack_require__(25);





__webpack_require__(0);












__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale_lang_es___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_data_tables___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Settings',
  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_3_vue_date_picker___default.a,
    VueEditor: __WEBPACK_IMPORTED_MODULE_12_vue2_editor__["a" /* VueEditor */]
  },
  data: function data(router) {
    return {
      licitacionesStatus: [],
      section: 'Licitaciones',
      loading: '',
      licitacionNueva: {
        'nombre': '',
        'cuerpo': '',
        'fecha_inicio': '',
        'fecha_fin': '',
        'supervisor': ''
      },
      newQuestion: '',
      newAnswer: '',
      respuestas: {},
      extensionDate: null,
      documentComment: '',
      showFileList: false,
      questions: '',
      respuestaFrecuente: '',
      queries: [],
      FAQ: [],
      currentIdBuyer: [],
      buyers: [],
      boss: [],
      esConsultaFrecuente: 0,
      licitacionAlert: false,
      showModalLicitacion: false,
      showModalLicitacionProviders: false,
      showModalFAQ: false,
      licitacion: '',
      erroresLicitacion: [],
      rubros: [],
      showModal: false,
      serverURI: __WEBPACK_IMPORTED_MODULE_13__config__["a" /* default */].serverURI,
      activeQuestions: ['1', '2', '3'],
      editing: false,
      editTec: false,
      editEco: false,
      needUpload: false,
      canConfirm: false,
      extendDateDialog: false,
      checkBoxSendMail: false,
      providersParaCompulsa: [],
      offerAmount: 0,
      providersSelected: [],
      propuestasTable: [{
        prop: 'idProvider',
        label: 'Proveedor'
      }, {
        prop: 'fecha_carga',
        label: 'Fecha carga'
      }],
      titles: [{
        prop: 'nombre',
        label: 'Nombre'
      }, {
        prop: 'fecha_creacion',
        label: 'Fecha creación'
      }, {
        prop: 'fecha_inicio',
        label: 'Inicio'
      }, {
        prop: 'fecha_fin',
        label: 'Fin'
      }],
      filtersLic: [{
        prop: ['idProvider'],
        value: ''
      }],
      filtersRubro: [{
        prop: ['idRubro'],
        value: '',
        filterFn: function filterFn(row, filterItem) {
          return row.rubros.some(function (el) {
            return filterItem.value.includes(el.idRubro);
          });
        }
      }, {
        prop: ['cuit', 'companyName'],
        value: ''
      }],
      filters: [{
        prop: ['nombre'],
        value: ''
      }, {
        prop: ['status'],
        value: '',
        filterFn: function filterFn(row, filterItem) {
          return filterItem.value.includes(row.status.descripcion);
        }
      }],
      providers: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapState */])(['user']), {
    datetime: function datetime() {
      return new Date();
    },
    cerroLicitacion: function cerroLicitacion() {
      return new Date(this.licitacion.fecha_fin).getTime() <= this.datetime.getTime();
    },
    contacts: function contacts() {
      return this.$store.state.contacts;
    },
    licitaciones: function licitaciones() {
      return this.$store.state.compulsas;
    },
    showUpload: function showUpload() {
      return this.licitacion.visto !== '2' && (this.licitacion.oferta_tec && !this.editTec || this.$refs.fileOfertaTec && this.$refs.fileOfertaTec.files.length > 0) && (this.licitacion.oferta_eco && !this.editEco || this.$refs.fileOfertaEco && this.$refs.fileOfertaEco.files.length > 0);
    }
  }),
  mounted: function mounted() {
    if (this.$route.params.licitacion) {
      this.licitacion = this.$route.params.licitacion;
      this.seeDetails(this.licitacion);
    }
  },

  methods: {
    getCompanyName: function getCompanyName(row) {
      return row.companyName === '' ? row.company : row.companyName;
    },
    submitUpload: function submitUpload() {
      this.$refs.upload.submit();
    },
    handlePdfCompulsa: function handlePdfCompulsa(response, file, fileList) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/licitacionesDocumentos', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ 'idLicitacion': this.licitacion.idLicitacion, 'url': response, comment: this.documentComment })).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('GET', 'api/generic/licitacionesDocumentos/' + response.data.idDocument).then(function (response) {
          var document = { idLicitacion: _this.licitacion.idLicitacion, url: response.data.url, date: response.data.date, comment: _this.documentComment };
          _this.licitacion.documents.push(document);
          _this.documentComment = '';
        });
      });
      this.$refs.upload.clearFiles();
      this.$message({
        message: 'El documento se ha subido correctamente.',
        type: 'success'
      });
    },
    questionsWithoutResponse: function questionsWithoutResponse(row) {
      var consultas = row.consultas.filter(function (consulta) {
        return consulta.replyTo === null;
      }).length;
      var respuestas = row.consultas.filter(function (consulta) {
        return consulta.replyTo !== null;
      }).length;
      return consultas - respuestas;
    },
    openModal: function openModal() {
      this.showModal = true;
      this.editing = false;
    },
    uploadOferta: function uploadOferta(type) {
      var _this2 = this;

      var formData = new FormData();
      formData.append('folder', 'licitacionesOfertas');
      if (type === 'tec') {
        formData.append('file', this.$refs.fileOfertaTec.files[0]);
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/uploadFile', formData).then(function (ofertaTec) {
          _this2.licitacion.oferta_tec = ofertaTec.data;
          _this2.editTec = false;
          __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/crearOferta', { 'idLicitacion': _this2.licitacion.idLicitacion, 'provider': _this2.user.idProvider, 'pdf': _this2.licitacion.oferta_tec, 'oferta': type });
        });
      } else if (type === 'eco') {
        formData.append('file', this.$refs.fileOfertaEco.files[0]);
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/uploadFile', formData).then(function (ofertaEco) {
          _this2.licitacion.oferta_eco = ofertaEco.data;
          _this2.editEco = false;
          __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/crearOferta', { 'idLicitacion': _this2.licitacion.idLicitacion, 'provider': _this2.user.idProvider, 'pdf': ofertaEco.data, 'oferta': type });
        });
      }
      this.needUpload = true;
    },
    getLicitacionesStatus: function getLicitacionesStatus() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('GET', 'api/generic/licitacionesStatus').then(function (response) {
        _this3.licitacionesStatus = response.data;
      });
    },
    pastDateToday: function pastDateToday(date) {
      return !(date.getTime() > Date.now() - 24 * 60 * 60 * 1000);
    },
    pastDateInitialDate: function pastDateInitialDate(date) {
      return !(date.getTime() > new Date(this.licitacionNueva.fecha_inicio));
    },
    checkFinalDate: function checkFinalDate() {
      if (this.licitacionNueva.fecha_fin && new Date(this.licitacionNueva.fecha_inicio) > new Date(this.licitacionNueva.fecha_fin)) {
        this.licitacionNueva.fecha_fin = new Date(this.licitacionNueva.fecha_inicio);
      }
    },
    extendLicitacionDate: function extendLicitacionDate(licitacion) {
      var _this4 = this;

      if (licitacion.status.descripcion === 'Cancelada') {
        this.$message({
          type: 'error',
          message: 'No puede prorrogar una compulsa cancelada'
        });
        return;
      } else {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/licitaciones/' + licitacion.idLicitacion, { 'fecha_fin': this.extensionDate }).then(function () {
          _this4.licitacion.fecha_fin = _this4.extensionDate;
          if (_this4.checkBoxSendMail) {
            licitacion.proveedores.forEach(function (provider) {
              __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('GET', 'api/sendMailExtendedDateCompulsa/' + provider.idProvider);
            });
          }
          _this4.$parent.getLicitaciones();
          _this4.extensionDate = '';
        });
        this.extendDateDialog = false;
      }
    },
    licitacionTerminada: function licitacionTerminada() {
      return this.licitacion.idLicitacionStatus === '4' || this.licitacion.idLicitacionStatus === '3';
    },
    recargarDetalles: function recargarDetalles() {
      var _this5 = this;

      this.$parent.getLicitaciones().then(function () {
        _this5.licitacion = _this5.licitaciones.find(function (el) {
          return el.idLicitacion === _this5.licitacion.idLicitacion;
        });
        _this5.seeDetails(_this5.licitacion);
      });
    },
    actualizarTipoConsulta: function actualizarTipoConsulta(consulta) {
      var _this6 = this;

      var messageType = consulta.messageType === '1' ? '1' : '2';
      consulta = { idReceptor: consulta.idReceptor, idLicitacion: consulta.idLicitacion, idMessage: consulta.idMessage, message: consulta.message, replyTo: consulta.replyTo, messageType: messageType };
      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/licitacionConsulta/' + consulta.idMessage, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(consulta)).then(function () {
        _this6.recargarDetalles();
      });
    },
    ordenarConsultas: function ordenarConsultas() {
      var _this7 = this;

      this.FAQ = this.licitacion.consultas.filter(function (el) {
        return el.messageType === '1';
      });
      this.FAQ.forEach(function (el, index) {
        _this7.FAQ[index].respuesta = _this7.licitacion.consultas.find(function (preg) {
          return preg.idMessage === el.replyTo;
        });
        if (!_this7.FAQ[index].respuesta) {
          _this7.FAQ[index].respuesta = { message: '' };
        }
      });
      this.queries = this.licitacion.consultas.filter(function (el) {
        return el.messageType === '2';
      });
      this.queries.forEach(function (el, index) {
        _this7.queries[index].respuesta = _this7.licitacion.consultas.find(function (resp) {
          return resp.idMessage === el.replyTo;
        });
        if (!_this7.queries[index].respuesta) {
          _this7.queries[index].respuesta = { message: '' };
        }
      });
    },
    guardarProveedores: function guardarProveedores() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/guardarProveedoresLicitacion', { 'idLicitacion': this.licitacion.idLicitacion, 'providers': this.providersSelected }).then(function (response) {
        _this8.showModalLicitacionProviders = false;
        _this8.$parent.getLicitaciones();
        _this8.providersSelected = [];
      });
    },
    invitarProviders: function invitarProviders() {
      var _this9 = this;

      var providers = '';
      this.providersSelected.forEach(function (provider) {
        providers += '<li>' + _this9.providers.find(function (unProvider) {
          return unProvider.idCompany === provider;
        }).companyName + '</li>';
      });

      this.$confirm('¿Realmente desea invitar a los proveedores seleccionados? Esta acción enviará correos a los proveedores y no permitirá cambiarlos <br /> <strong>Proveedores seleccionados:</strong>' + providers, 'Advertencia', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        lockScroll: false,
        dangerouslyUseHTMLString: true
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/invitarProveedoresLicitacion', { 'idLicitacion': _this9.licitacion.idLicitacion, 'providers': _this9.providersSelected }).then(function (response) {
          _this9.showModalLicitacionProviders = false;
          _this9.$parent.getLicitaciones();
        });
      });
    },
    needProviders: function needProviders(row) {
      if (row) {
        return row.status.idLicitacionStatus === '1';
      } else {
        return false;
      }
    },
    sendConsultaFrecuente: function sendConsultaFrecuente() {
      var _this10 = this;

      if (this.newQuestion === '' || this.respuestaFrecuente === '') {
        this.$message({
          type: 'warning',
          message: 'Complete los campos vacios'
        });
        return;
      }
      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/licitacionesConsulta', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ 'idLicitacion': this.licitacion.idLicitacion, 'idEmisor': this.user.idUser, 'messageType': 0, 'idReceptor': '0', 'message': this.respuestaFrecuente, 'replyTo': null })).then(function (response) {
        _this10.sendConsulta(response.data.idMessage, 0, 1).then(function (response) {
          _this10.newQuestion = '';
          _this10.respuestaFrecuente = '';
          _this10.showModalFAQ = false;
          _this10.$parent.getLicitaciones();
          _this10.recargarDetalles();
          _this10.ordenarConsultas();
        });
      });
    },
    sendConsulta: function sendConsulta(replyToId, idReceptor, messageType) {
      var _this11 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (_this11.newQuestion === '') {
          _this11.$message({
            type: 'warning',
            message: 'Complete los campos vacios'
          });
          return;
        }
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/licitacionesConsulta', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ 'idLicitacion': _this11.licitacion.idLicitacion, 'idEmisor': _this11.user.idUser, 'messageType': messageType, 'idReceptor': idReceptor, 'message': _this11.newQuestion, 'replyTo': replyToId })).then(function (response) {
          _this11.newQuestion = '';
          _this11.showModalFAQ = false;
          _this11.$message({
            type: 'success',
            message: 'El mensaje ha sido enviado'
          });
          _this11.$parent.getLicitaciones();
          _this11.recargarDetalles();
          resolve(response.data);
        });
      });
    },
    sendAnswer: function sendAnswer(idMessage, idReceptor, message, consulta) {
      var _this12 = this;

      var that = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (message === '' || message === undefined) {
          that.$message({
            type: 'warning',
            message: 'La respuesta no puede estar vacia'
          });
          return;
        }
        var respuesta = _this12.respuestas[idMessage];
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/licitacionesConsulta', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ 'idLicitacion': that.licitacion.idLicitacion, 'idEmisor': that.user.idUser, 'messageType': 0, 'idReceptor': idReceptor, 'message': respuesta, 'replyTo': null })).then(function (response) {
          consulta = { idReceptor: consulta.idReceptor, idLicitacion: consulta.idLicitacion, idMessage: consulta.idMessage, message: consulta.message, replyTo: response.data.idMessage };
          __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/licitacionConsulta/' + idMessage, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(consulta));
          _this12.$set(_this12.respuestas, idMessage, '');
          that.showModalFAQ = false;
          that.$message({
            type: 'success',
            message: 'El mensaje ha sido enviado'
          });
          that.$parent.getLicitaciones();
          that.recargarDetalles();
          that.ordenarConsultas();
          resolve(response.data);
        });
      });
    },
    deleteLicitacionesConsulta: function deleteLicitacionesConsulta(item) {
      var _this13 = this;

      this.$confirm('¿Está seguro que desea eliminar esta pregunta?', 'Atención', {
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('GET', 'api/deleteLicitacionesConsulta/' + item.idMessage).then(function (response) {
          _this13.recargarDetalles();
          if (response.data) {
            _this13.$message({
              type: 'success',
              message: 'Se ha eliminado la pregunta'
            });
          } else {
            _this13.$message({
              type: 'warning',
              message: 'No es posible eliminar la pregunta'
            });
          }
        });
      });
    },
    uploadOfertas: function uploadOfertas() {
      var _this14 = this;

      this.$confirm('¿Está seguro de subir estas ofertas?', 'Advertencia', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        lockScroll: false
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/propuestas', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ 'idLicitacion': _this14.licitacion.idLicitacion, 'idProvider': _this14.user.idProvider, 'oferta_tec': _this14.licitacion.oferta_tec, 'oferta_eco': _this14.licitacion.oferta_eco, 'status': 2 })).then(function (response) {
          _this14.$message.success('Se han subido las ofertas', 'success');
          _this14.$parent.getLicitaciones();
          _this14.needUpload = false;
          _this14.canConfirm = true;
        });
      }).catch(function () {});
    },
    confirmOfertas: function confirmOfertas() {
      var _this15 = this;

      this.$confirm('¿Está seguro que desea confirmas las ofertas? Luego no se podrán modificar', 'Advertencia', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        lockScroll: false
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/licitacionProvider/' + _this15.licitacion.idLicitacionProvider, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ 'status': 2 })).then(function (response) {
          _this15.$message.success('Se han subido las ofertas', 'success');
          _this15.$parent.getLicitaciones();
          _this15.showModalLicitacion = false;
        });
      }).catch(function () {});
    },
    getRubros: function getRubros() {
      var _this16 = this;

      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('GET', 'api/generic/rubros').then(function (response) {
        var data = response.data;

        if (data.error) {
          return;
        }
        if (data) {
          _this16.rubros = data;
        }
      }).catch(function (error) {
        _this16.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getBuyers: function getBuyers() {
      var _this17 = this;

      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('GET', 'api/getUserWithJobs/1').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this17.buyers = data;
        }
      }).catch(function (error) {
        _this17.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getBoss: function getBoss() {
      var _this18 = this;

      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('GET', 'api/getUserWithJobs/2').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this18.boss = data;
        }
      }).catch(function (error) {
        _this18.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    resetLicitacion: function resetLicitacion() {
      var _this19 = this;

      this.editEco = false;
      this.editTec = false;
      this.needUpload = false;
      this.licitacion = this.licitaciones.find(function (el) {
        return el.idLicitacion === _this19.licitacionNueva.idLicitacion;
      });
      this.licitacionNueva.nombre = '';
      this.licitacionNueva.cuerpo = '';
      this.licitacionNueva.fecha_inicio = '';
      this.licitacionNueva.fecha_fin = '';
      this.licitacionNueva.supervisor = '';
      this.currentIdBuyer = [];
      this.erroresLicitacion = [];
      this.licitacionAlert = false;
    },
    verificarLicitacion: function verificarLicitacion() {
      this.erroresLicitacion = [];
      this.licitacionAlert = false;
      if (this.licitacionNueva.nombre === '') {
        this.erroresLicitacion.push('Se requiere el nombre');
        this.licitacionAlert = true;
      }
      if (this.licitacionNueva.cuerpo === '') {
        this.erroresLicitacion.push('Se requiere la descripción');
        this.licitacionAlert = true;
      }
      if (this.licitacionNueva.fecha_inicio === '') {
        this.erroresLicitacion.push('Se requiere la fecha de inicio');
        this.licitacionAlert = true;
      }
      if (this.licitacionNueva.fecha_fin === '') {
        this.erroresLicitacion.push('Se requiere la fecha de finalización');
        this.licitacionAlert = true;
      }
      if (this.currentIdBuyer === '') {
        this.erroresLicitacion.push('Se requiereasignar a un comprador');
        this.licitacionAlert = true;
      }
      if (this.licitacionAlert === true) {
        return false;
      }
      return true;
    },
    uploadInvoice: function uploadInvoice() {},
    guardarLicitacion: function guardarLicitacion() {
      var _this20 = this;

      if (this.editing) {
        if (this.verificarLicitacion()) {
          this.licitacionNueva.status = this.licitacionNueva.status.idLicitacionStatus;
          __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/licitaciones/' + this.licitacionNueva.idLicitacion, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.licitacionNueva)).then(function (response) {
            _this20.currentIdBuyer.forEach(function (item, index) {
              __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/licitacionesCompradores', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ 'idLicitacion': response.data.idLicitacion, 'idUser': item })).then(function (response) {});
            });
            _this20.$message.success('Se ha modificado la compulsa', 'success');
            _this20.hideModal();
            _this20.$parent.getProviders();
          }).then(function (response) {
            _this20.$parent.getLicitaciones();
            _this20.$message.success('Se ha guardado la compulsa', 'success');
            _this20.hideModal();
          });
        }
        return;
      }
      this.licitacionNueva.status = 1;
      if (this.verificarLicitacion()) {
        delete this.licitacionNueva.proveedores;
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/licitaciones', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.licitacionNueva)).then(function (response) {
          _this20.currentIdBuyer.forEach(function (item, index) {
            __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/createLicitacionesCompradores/', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ 'idLicitacion': response.data.idLicitacion, 'idUser': item })).then(function (response) {
              _this20.$message.success('Se ha agregado la nueva licitacion', 'success');
              _this20.hideModal();
              _this20.$parent.getLicitaciones();
            });
          });
        });
      }
    },
    seeDetails: function seeDetails(row) {
      var _this21 = this;

      this.licitacion = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(row));
      if (this.licitacion.status.idLicitacionStatus === '1') {
        this.licitacionNueva = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.licitacion));
        this.currentIdBuyer = [];
        if (this.licitacionNueva.buyers && this.licitacionNueva.buyers.length > 0) {
          this.licitacionNueva.buyers.forEach(function (item, index) {
            _this21.currentIdBuyer.push(item.idUser);
          });
        }
        this.showModal = true;
        this.editing = true;
        return;
      }
      this.editing = false;
      this.ordenarConsultas();
      if (this.user.isProvider) {
        this.clavarVistoCompulsa();
      }
      this.showModalLicitacion = true;
      if (!this.user.isProvider) {
        this.offerAmount = this.licitacion.propuestas.filter(function (offer) {
          return offer.status === '2';
        }).length;
      }
    },
    seeFAQ: function seeFAQ(row) {
      this.licitacion = row;
      this.ordenarConsultas();
      this.showModalFAQ = true;
    },
    seeProviders: function seeProviders(row) {
      var _this22 = this;

      this.licitacion = row;
      this.providersParaCompulsa = [];
      this.providersSelected = [];
      if (this.needProviders(this.licitacion)) {
        this.licitacion.proveedores.forEach(function (el, index) {
          _this22.providersSelected[index] = _this22.contacts.find(function (cont) {
            return cont.idProvider === el.idProvider;
          }).idCompany;
        });
        this.providers.forEach(function (prov, index) {
          if (_this22.contacts.some(function (cont) {
            return cont.idCompany === prov.idCompany;
          })) {
            _this22.providersParaCompulsa.push(prov);
          }
        });
      } else {
        var i = 0;
        this.licitacion.proveedores.forEach(function (el) {
          var prov = _this22.providers.find(function (prov) {
            return prov.idCompany === _this22.contacts.find(function (cont) {
              return cont.idProvider === el.idProvider;
            }).idCompany;
          });
          if (_this22.providersParaCompulsa.indexOf(prov) === -1) {
            _this22.providersParaCompulsa[i++] = prov;
          }
        });
      }
      this.showModalLicitacionProviders = true;
    },
    cancelarLicitacion: function cancelarLicitacion(row) {
      var _this23 = this;

      this.$confirm('¿Realmente desea cancelar la compulsa? Esta acción es irreversible', 'Advertencia', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        lockScroll: false
      }).then(function () {
        var date = new Date();
        var FormattedDate = date.toISOString().slice(0, 10);
        var data = {
          idLicitacion: row.idLicitacion,
          status: '4',
          fecha_fin: FormattedDate
        };
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/licitaciones/' + row.idLicitacion, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data)).then(function (response) {
          _this23.$parent.getLicitaciones();
        });
      });
    },
    borrarLicitacion: function borrarLicitacion(row) {
      var _this24 = this;

      this.$confirm('¿Realmente desea eliminar la compulsa? Esta acción es irreversible', 'Advertencia', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        lockScroll: false
      }).then(function () {
        var data = {
          idLicitacion: row.idLicitacion,
          status: '5'
        };
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/licitaciones/' + row.idLicitacion, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data)).then(function (response) {
          _this24.$parent.getLicitaciones();
        });
      });
    },
    clavarVistoCompulsa: function clavarVistoCompulsa(idLicitacion) {
      var _this25 = this;

      if (this.user.isProvider && this.licitacion.visto === '0') {
        __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('POST', 'api/generic/licitacionProvider/' + this.licitacion.idLicitacionProvider, { 'idLicitacionProvider': this.licitacion.idLicitacionProvider, 'idLicitacion': this.licitacion.idLicitacion, 'idProvider': this.user.idProvider, 'status': '1' }).then(function (response) {
          _this25.$parent.getLicitaciones();
        });
      }
    },
    hideModal: function hideModal() {
      this.showModal = false;
      this.resetLicitacion();
    },
    getProviders: function getProviders() {
      var _this26 = this;

      this.$store.commit('START_LOADING');
      __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].request('GET', 'api/approvedListCompany').then(function (response) {
        _this26.providers = response.data;
        _this26.$store.commit('STOP_LOADING');
      }).catch(function (error) {
        console.log(error);
        _this26.$store.commit('STOP_LOADING');
      });
    }
  },
  beforeMount: function beforeMount() {
    this.getBuyers();
    this.getBoss();
    this.getRubros();
    this.getLicitacionesStatus();
    this.getProviders();
    this.$parent.getLicitaciones();
  }
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_date_picker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__demo__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);



__webpack_require__(0);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Settings',
  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_1_vue_date_picker___default.a
  },
  data: function data(router) {
    return {
      section: 'ChangePsw',
      loading: '',
      manuals: [],
      manualsInstructive: [],
      manualsNorms: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    datetime: function datetime() {
      return new Date();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])(['userInfo', 'user']), {
    timeline: function timeline() {
      return __WEBPACK_IMPORTED_MODULE_3__demo__["a" /* timeline */];
    }
  }),
  mounted: function mounted() {
    this.getManual();
  },

  methods: {
    getManual: function getManual(row) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('get', 'api/generic/manual').then(function (response) {
        if (Array.isArray(response.data)) {
          _this.manuals = response.data;
        }
        _this.manualsInstructive = _this.manuals.filter(function (el) {
          return el.category === '0';
        });
        _this.manualsNorms = _this.manuals.filter(function (el) {
          return el.category === '1';
        });
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    activeStep: {
      type: Number,
      default: 0
    },
    isConfirmProvider: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_picker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_data_tables__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_es__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_data_status__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ButtonGroup_vue__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ButtonGroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ButtonGroup_vue__);




__webpack_require__(0);












__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale_lang_es___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_data_tables___default.a);

var stepOptions = ['Datos Generales', 'Datos Bancarios', 'Datos Impositivos'];
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Settings',
  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_2_vue_date_picker___default.a,
    'countries-group': __WEBPACK_IMPORTED_MODULE_12__ButtonGroup_vue___default.a
  },
  data: function data(router) {
    return {
      newProvidersPeru: [],
      isIndeterminate: true,
      loadingProviders: true,
      checkAll: false,
      checkedSteps: ['Datos Generales', 'Datos Bancarios'],
      steps: stepOptions,
      section: 'AllComments',
      loading: '',
      companyDataStagePeru: [],
      showModal: false,
      showModalComment: false,
      showModalDocumentation: false,
      showModalOperations: false,
      showModalDetails: false,
      showModalAssociatedUsers: false,
      currentCompany: [],
      providers: [],
      CUIT: '',
      RUC: '',
      currentIdRubro: [],
      company: '',
      companyDataStatus: [],
      companyDataStage: [],
      documents: [],
      filteredDocuments: [],
      rubros: [],
      selectedRow: null,
      comment: null,
      country: 'Argentina',
      companyNew: {
        'nombre': '',
        'razonSocial': '',

        'fiscalId': '',
        'idCompanyStatus': '',
        'idCompanyDataStatus': '',
        'idStage': '',
        'descripcion': ''
      },
      titles: [{
        prop: 'company',
        label: 'Compañía',
        align: 'center'
      }, {
        prop: 'fiscalId',
        label: 'Identificación Fiscal',
        align: 'center'
      }, {
        prop: 'idType',
        label: 'Tipo de identificación',
        align: 'center'
      }, {
        prop: 'creationDate',
        label: 'Fecha de Creación',
        align: 'center'
      }, {
        prop: 'companyDataStatus',
        label: 'Estado Empresa',
        align: 'center'
      }, {
        prop: 'companyStage',
        label: 'Etapa',
        align: 'center'
      }],
      titlesPeru: [{
        prop: 'company',
        label: 'Compañía',
        align: 'center'
      }, {
        prop: 'fiscalId',
        label: 'Identificación Fiscal',
        align: 'center'
      }, {
        prop: 'idType',
        label: 'Tipo de identificación',
        align: 'center'
      }, {
        prop: 'creationDate',
        label: 'Fecha de Creación',
        align: 'center'
      }, {
        prop: 'companyDataStatus',
        label: 'Estado Empresa',
        align: 'center'
      }, {
        prop: 'companyStage',
        label: 'Etapa',
        align: 'center'
      }],
      filters: [{
        prop: ['company', 'fiscalId', 'companyDataStatus'],
        value: ''
      }, {
        prop: ['idCompanyDataStatus'],
        value: ''
      }, {
        prop: ['idStage'],
        value: ''
      }, {
        prop: 'codCountry',
        value: ''
      }],
      titlesOperations: [{
        prop: 'nic',
        label: 'OC'
      }, {
        prop: 'fecha_liberacion',
        label: 'Liberación'
      }],
      titlesAssociatedUsers: [{
        prop: 'name',
        label: 'Usuarios Asociados'
      }],
      filtersOperations: [{
        prop: ['nic'],
        value: ''
      }, {
        filterFn: function filterFn(row, filter) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(row).some(function (prop) {
            if (prop === 'fecha_liberacion') {
              if (filter.value !== null) {
                return new Date(row.fecha_liberacion).getTime() <= filter.value[1].getTime() && new Date(row.fecha_liberacion).getTime() >= filter.value[0].getTime();
              } else {
                return true;
              }
            }
          });
        },
        prop: ['fecha_liberacion'],
        value: ''
      }, {
        prop: 'idCompanyDataStatus',
        value: ''
      }, {
        prop: 'idStage',
        value: ''
      }],
      filtersAssociatedUsers: [{
        prop: ['name'],
        value: ''
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapState */])(['user']), {
    datetime: function datetime() {
      return new Date();
    },
    newProviders: function newProviders() {
      return this.providers.filter(function (prov) {
        return prov.idCompanyDataStatus === __WEBPACK_IMPORTED_MODULE_10__config_data_status__["a" /* default */].ESPERANDO_CONFIRMACION || prov.idCompanyDataStatus === __WEBPACK_IMPORTED_MODULE_10__config_data_status__["a" /* default */].DEVUELTO || prov.idCompanyDataStatus === __WEBPACK_IMPORTED_MODULE_10__config_data_status__["a" /* default */].MODIFICADO;
      });
    },
    statusList: function statusList() {
      return this.$store.state.companyDataStatus.filter(function (el) {
        return el.idCompanyDataStatus !== __WEBPACK_IMPORTED_MODULE_10__config_data_status__["a" /* default */].ACEPTADO;
      });
    },
    stageList: function stageList() {
      return this.$store.state.companyDataStage;
    },
    bothButtonType: function bothButtonType() {
      return this.country === 'All' ? 'primary' : '';
    },
    argButtonType: function argButtonType() {
      return this.country === 'Argentina' ? 'primary' : '';
    },
    peruButtonType: function peruButtonType() {
      return this.country === 'Peru' ? 'primary' : '';
    },
    idTypeName: function idTypeName() {}
  }),
  methods: {
    updateFilter: function updateFilter(updatedFilter) {
      this.filters[3].value = updatedFilter.value;
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedSteps = val ? stepOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedStepsChange: function handleCheckedStepsChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.steps.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.steps.length;
    },
    getCompanyStage: function getCompanyStage() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('GET', 'api/generic/companyStage').then(function (response) {
        _this.companyDataStage = response.data;
      });
    },
    allProviders: function allProviders() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('GET', 'api/listCompany').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this2.providers = data;
          _this2.loadingProviders = false;
        }
      }).catch(function (error) {
        _this2.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    getCountByStatus: function getCountByStatus(statusId) {
      var argProviders = this.providers.filter(function (el) {
        return el.codCountry === 'AR';
      });
      var perProviders = this.providers.filter(function (el) {
        return el.codCountry === 'PE';
      });
      if (statusId !== '2' && this.country === 'Argentina') {
        return argProviders.filter(function (el) {
          return el.idCompanyDataStatus === statusId;
        }).length;
      }
      if (statusId !== '2' && this.country === 'Peru') {
        return perProviders.filter(function (el) {
          return el.idCompanyDataStatus === statusId;
        }).length;
      } else {
        return this.providers.filter(function (el) {
          return el.idCompanyDataStatus === statusId;
        }).length;
      }
    },
    getCountByStage: function getCountByStage(stageId) {
      return this.providers.filter(function (el) {
        return el.idStage === stageId && el.idCompanyDataStatus !== __WEBPACK_IMPORTED_MODULE_10__config_data_status__["a" /* default */].ACEPTADO;
      }).length;
    },
    goToDetails: function goToDetails(idCompany, idFIT, codCountry) {
      if (idFIT === '1') {
        this.$router.push('/confirmProvider/' + codCountry + '/' + idCompany);
      }
      if (idFIT === '2') {
        this.$router.push('/confirmProviderPeru/' + codCountry + '/' + idCompany);
      }
    },
    searchStatus: function searchStatus(status) {
      this.filters[1].value = [status];
    },
    searchStage: function searchStage(stage) {
      this.filters[2].value = [stage];
    },
    getStatusName: function getStatusName(idCompanyDataStatus) {
      return this.statusList.find(function (el) {
        return el.idCompanyDataStatus === idCompanyDataStatus;
      }).description;
    },
    showDetails: function showDetails(row) {
      var _this3 = this;

      this.currentCompany = row;
      this.currentIdRubro = [];
      if (this.currentCompany.rubros !== undefined) {
        this.currentCompany.rubros.forEach(function (item, index) {
          _this3.currentIdRubro[index] = item.idRubro;
        });
      }
      this.showModalDetails = true;
    },
    getCompanyDataStatus: function getCompanyDataStatus() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('GET', 'api/generic/companyDataStatus').then(function (response) {
        _this4.companyDataStatus = response.data.filter(function (el) {
          return el.idCompanyDataStatus !== __WEBPACK_IMPORTED_MODULE_10__config_data_status__["a" /* default */].ACEPTADO;
        });
      });
    },
    getDocumentation: function getDocumentation(row) {
      var _this5 = this;

      this.currentCompany = row;
      this.company = row;
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('GET', 'api/generic/document').then(function (response) {
        _this5.documents = response.data;
        _this5.documents.forEach(function (doc) {
          if (_this5.company.documents.find(function (el) {
            return el.idDocument === doc.idDocument;
          }) === undefined) {
            _this5.company.documents.push({ 'idDocument': doc.idDocument, 'documentName': doc.documentName, 'idProvider': _this5.company.idCompany, 'status': '0' });
          }
        });
        _this5.documents.forEach(function (document, index) {
          _this5.filteredDocuments[index] = _this5.currentCompany.documents.find(function (el) {
            return el.id === '2' && el.idDocument === String(index + 1);
          });
        });
        _this5.showModalDocumentation = true;
      });
    },
    getAssociatedUsers: function getAssociatedUsers(row) {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('GET', 'api/AssociatedUsers/' + row.idCompany).then(function (response) {
        _this6.showModalAssociatedUsers = true;
        _this6.company = row;
        _this6.company.users = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    stopCompany: function stopCompany(row) {
      var _this7 = this;

      this.$confirm('¿Realmente desea suspender la compañía?', 'Advertencia', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        lockScroll: false
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('GET', 'api/updateStopCompanyStatus/' + row.idCompany).then(function (response) {
          _this7.$parent.getProviders();
        });
      });
    },
    startCompany: function startCompany(row) {
      var _this8 = this;

      this.$confirm('¿Desea Activar la compañía?', 'Advertencia', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        lockScroll: false
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('GET', 'api/updateStartCompanyStatus/' + row.idCompany).then(function (response) {
          _this8.$parent.getProviders();
        });
      });
    },
    getRubros: function getRubros() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('GET', 'api/generic/rubros').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this9.rubros = data;
        }
      }).catch(function (error) {
        _this9.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    }
  },
  beforeMount: function beforeMount() {
    this.getRubros();
    this.getCompanyDataStatus();
    this.allProviders();
  },
  mounted: function mounted() {
    this.getCompanyStage();
  }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_date_picker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__demo__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);



__webpack_require__(0);







__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Settings',
  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_1_vue_date_picker___default.a
  },
  data: function data(router) {
    return {
      section: 'News',
      loading: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    datetime: function datetime() {
      return new Date();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])(['userInfo', 'user']), {
    timeline: function timeline() {
      return __WEBPACK_IMPORTED_MODULE_3__demo__["a" /* timeline */];
    },
    news: function news() {
      return this.$store.state.news.sort(function (a, b) {
        return new Date(a.dateLine) - new Date(b.dateLine);
      });
    }
  }),
  beforeMount: function beforeMount() {},

  methods: {}
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PdfFile_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PdfFile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PdfFile_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UploadOrder_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UploadOrder_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__UploadOrder_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Prebill',
  components: {
    'pdf-file': __WEBPACK_IMPORTED_MODULE_2__PdfFile_vue___default.a,
    'upload-order': __WEBPACK_IMPORTED_MODULE_3__UploadOrder_vue___default.a
  },
  props: {
    loadOperationType: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      showModal: false,
      isLoading: false,
      providers: [],
      formRules: {
        documenttype: [{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }],
        codigoAFIP: [{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }, { pattern: /^[0-9]+$/, message: 'Solo se permiten números en este campo', trigger: 'change' }],
        letra: [{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }, { pattern: /^[A-Za-z]+$/, message: 'Solo se permiten letras en este campo', trigger: 'change' }],
        numero: [{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }, { pattern: /^[0-9]+$/, message: 'Solo se permiten números en este campo', trigger: 'change' }],
        proveedor: [{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }],
        fechaVencimiento: [{ type: 'date', required: true, message: 'Este campo es obligatorio', trigger: 'change' }],
        NroCAE: [{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }, { pattern: /^[0-9]+$/, message: 'Solo se permiten números en este campo', trigger: 'change' }],
        pdfDoc: [{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }],
        importeTotal: [{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }, { pattern: /^[0-9]+(\.[0-9]+)?$/, message: 'Solo se permiten números decimales en este campo', trigger: 'change' }],
        importeImpuesto: [{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }, { pattern: /^[0-9]+(\.[0-9]+)?$/, message: 'Solo se permiten números decimales en este campo', trigger: 'change' }],
        porcentajeImpuesto: [{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }, { pattern: /^[0-9]+(\.[0-9]+)?$/, message: 'Solo se permiten números decimales en este campo', trigger: 'change' }],
        moneda: [{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }, { pattern: /^[A-Za-z]+$/, message: 'Solo se permiten letras en este campo', trigger: 'change' }],
        tipoDeCambio: [{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }, { pattern: /^[0-9]+(\.[0-9]+)?$/, message: 'Solo se permiten números decimales en este campo', trigger: 'change' }]
      },
      document: {
        documenttype: '',
        ocType: '',
        ocNumbers: [],
        pdfDoc: '',
        migoNumber: '',
        codigoAFIP: '',
        letra: '',
        numero: '',
        proveedor: '',
        fechaVencimiento: '',
        NroCAE: '',
        importeTotal: '',
        importeImpuesto: '',
        porcentajeImpuesto: '',
        moneda: '',
        tipoDeCambio: ''
      },
      documentType: [{ value: '1', label: 'Factura' }, { value: '2', label: 'Nota de crédito' }, { value: '3', label: 'Nota de débito' }],
      acceptanceType: [{ value: '1', label: 'HES' }, { value: '2', label: 'MIGO' }],
      habModificaPdf: true
    };
  },

  methods: {
    addOcNumber: function addOcNumber() {
      this.document.ocNumbers.push({ value: '' });
    },
    deleteOcNumber: function deleteOcNumber(index) {
      this.document.ocNumbers.splice(index, 1);
    },
    validateForm: function validateForm() {
      var _this = this;

      this.$refs.formRef.validate(function (valid) {
        if (valid) {
          _this.showModal = true;
        } else {
          _this.$message.error('Debe completar todos los campos');
        }
      });
    },
    clog: function clog() {
      console.log('document', this.document);
      this.showModal = false;
    },
    getProviders: function getProviders() {
      var _this2 = this;

      this.$store.commit('START_LOADING');
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('GET', 'api/listCompany').then(function (response) {
        _this2.providers = response.data;
        console.log('providers', _this2.providers);
        _this2.$store.commit('STOP_LOADING');
      }).catch(function (error) {
        console.log(error);
        _this2.$store.commit('STOP_LOADING');
      });
    },
    createDocument: function createDocument() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('POST', 'api/createPrebill', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.document)).then(function (response) {
        console.log('data', response.data);
        _this3.$message({
          message: 'Documento creado correctamente',
          type: 'success',
          duration: 5000
        });
        _this3.$router.push('/');
      }).catch(function (error) {
        _this3.$message({
          message: 'Ha fallado la carga del documento',
          type: 'error',
          duration: 5000
        });
        console.log(error);
      });
    }
  },
  beforeMount: function beforeMount() {
    this.getProviders();
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      idCompany: this.$route.params.id,
      activeTab: 'generalData',
      types: ['warning', 'success', 'danger'],
      statusType: '',
      rejectCompanyDataVisible: false,
      newObservation: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['user', 'providers']), {
    provider: function provider() {
      var _this = this;

      return this.providers.find(function (prov) {
        return prov.idCompany === _this.idCompany;
      });
    },
    statusList: function statusList() {
      return this.$store.state.companyDataStatus;
    }
  }),
  methods: {
    handleCloseCompanyDataRejection: function handleCloseCompanyDataRejection() {
      this.newObservation = '';
    },
    acceptCompanyData: function acceptCompanyData() {
      var _this2 = this;

      this.$confirm('¿Está seguro que desea aceptar los datos?', 'Advertencia', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(function () {
        _this2.provider[_this2.activeTab].idCompanyDataStatus = '2';
        _this2.provider[_this2.activeTab].idUser = _this2.user.idUser;
        _this2.updateCompanyData(_this2.activeTab, _this2.provider[_this2.activeTab]);
      }).catch(function () {});
    },
    rejectCompanyData: function rejectCompanyData() {
      var _this3 = this;

      if (this.newObservation === '') {
        this.$message.warning('Falta completar el motivo');
        return;
      }
      this.$confirm('¿Está seguro que desea rechazar los datos por este motivo?', 'Advertencia', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(function () {
        _this3.provider[_this3.activeTab].idCompanyDataStatus = '3';
        _this3.provider[_this3.activeTab].idUser = _this3.user.idUser;
        _this3.provider[_this3.activeTab].observation = _this3.newObservation;
        _this3.updateCompanyData(_this3.activeTab, _this3.provider[_this3.activeTab]);
      }).catch(function () {});
    },
    updateCompanyData: function updateCompanyData(dataType, data) {
      var _this4 = this;

      var idCompanyData = void 0;
      switch (dataType) {
        case 'generalData':
          idCompanyData = data.idGeneralData;
          break;
        case 'paymentData':
          idCompanyData = data.idPaymentData;
          break;
        case 'taxData':
          idCompanyData = data.idTaxData;
          break;
      }
      this.$store.commit('START_LOADING');
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('POST', 'api/generic/' + dataType + '/' + idCompanyData, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)).then(function (response) {
        _this4.rejectCompanyDataVisible = false;
        _this4.newObservation = '';
        _this4.$store.commit('STOP_LOADING');
        _this4.provider[dataType] = response.data;
        _this4.$message.success('Estado cambiado satisfactoriamente');
      }).catch(function (error) {
        console.log(error);
        _this4.$store.commit('STOP_LOADING');
        _this4.$message.danger('Error al cambiar el estado');
      });
    },
    getStatusNameOfTab: function getStatusNameOfTab() {
      var tabIdCompanyStatus = this.provider[this.activeTab].idCompanyDataStatus;
      this.statusType = this.types[tabIdCompanyStatus - 1];
      return this.getStatusName(tabIdCompanyStatus);
    },
    getStatusName: function getStatusName(idCompanyDataStatus) {
      return this.statusList.find(function (el) {
        return el.idCompanyDataStatus === idCompanyDataStatus;
      }).description;
    },
    handlePdfsExempt: function handlePdfsExempt(url) {
      var win = window.open(url, '_blank');
      win.focus();
    },
    agreementRegimeTypeName: function agreementRegimeTypeName(idAgreementRegimeType) {
      var founded = this.$store.state.regimenTypes.find(function (reg) {
        return reg.idAgreementRegimeType === idAgreementRegimeType;
      });
      return founded ? founded.agreementRegimeType : '-';
    },
    jurisdictionName: function jurisdictionName(idJurisdictions) {
      return this.$store.state.jurisdictions.find(function (jur) {
        return jur.idJurisdictions === idJurisdictions;
      }).jurisdictions;
    },
    countryName: function countryName(idCountry) {
      return this.$store.state.countries.find(function (country) {
        return country.idCountry === idCountry;
      }).country;
    },
    provinceName: function provinceName(idProvince) {
      return this.$store.state.provinces.find(function (prov) {
        return prov.idProvince === idProvince;
      }).province;
    },
    bankBranchName: function bankBranchName(idBankBranch) {
      var founded = this.$store.state.bankBranches.find(function (bb) {
        return bb.idBankBranch === idBankBranch;
      });
      return founded ? founded.bankBranch : '-';
    },
    bankName: function bankName(idBank) {
      return this.$store.state.banks.find(function (el) {
        return el.idBank === idBank;
      }).bank;
    },
    bankAccountName: function bankAccountName(idBankAccountType) {
      return this.$store.state.accountTypes.find(function (ac) {
        return ac.idBankAccountType === idBankAccountType;
      }).bankAccountType;
    }
  },
  mounted: function mounted() {},
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_date_picker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(2);


__webpack_require__(0);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Settings',
  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_0_vue_date_picker___default.a
  },
  data: function data(router) {
    return {
      section: 'CommentDetail',
      loading: '',
      response: null,
      success: null,
      email: this.$route.query.e
    };
  },

  computed: {
    datetime: function datetime() {
      return new Date();
    }
  },
  methods: {
    checkPsw: function checkPsw() {
      var _this = this;

      var parametros = new URLSearchParams(window.location.search);
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('GET', 'api/reestablecerPsw?email=' + parametros.get('email')).then(function (response) {
        var data = response.data;

        if (data.error) {
          _this.response = data.error;
        }
        if (data.success) {
          _this.success = data.success;
        }
      }).catch(function (error) {
        _this.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    }
  },
  mounted: function mounted() {
    this.checkPsw();
  },

  filters: {
    truncate: function truncate(string, value) {
      return string.substring(0, value) + '...';
    }
  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_date_picker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(2);


__webpack_require__(0);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Restablecer',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_0_vue_date_picker___default.a },
  computed: {
    datetime: function datetime() {
      return new Date();
    }
  },
  data: function data(router) {
    return {
      section: 'Reestablecer',
      loading: '',
      loadingGif: false,
      email: '',
      response: null,
      success: null
    };
  },

  methods: {
    clearInput: function clearInput(vueModel) {
      vueModel = '';
    },
    checkData: function checkData() {
      var _this = this;

      var email = this.email;


      this.loadingGif = true;
      this.toggleLoading();
      this.resetResponse();
      this.$store.commit('TOGGLE_LOADING');
      this.$confirm('¿Realmente desea Restablecer su Contraseña?', 'Advertencia', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        lockScroll: false
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('GET', 'api/solicitarReestablecimientoPsw' + '?email=' + email).then(function (response) {
          _this.loadingGif = false;
          _this.toggleLoading();
          var data = response.data;

          if (response.data.error) {
            var errorName = response.data.error.name;
            if (errorName) {
              console.log(errorName);
              if (errorName === 'InvalidArgumentError') {
                _this.response = 'Los datos suministrados son incorrectos.';
              } else if (errorName === 'NotFoundError') {
                _this.response = 'Se ha producido un error inesperado.';
              } else {
                _this.response = errorName;
              }
            } else {
              _this.response = data.error;
            }

            return;
          } else {
            if (data.success) {
              _this.success = data.success;
              _this.email = '';
            }
          }
        }).catch(function (error) {
          _this.$store.commit('TOGGLE_LOADING');
          _this.invoices = null;
          console.log(error);

          _this.response = 'Error al conectarse con el servidor, contacte al administrador.';
          _this.toggleLoading();
        });
      }).catch(function (error) {
        _this.loadingGif = false;
        console.log(error);
      });
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'cargando' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
      this.success = '';
    }
  }
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_data_tables__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_data_tables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_data_tables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_es__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ButtonGroup_vue__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ButtonGroup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ButtonGroup_vue__);




__webpack_require__(0);








__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_es___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_data_tables___default.a);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'countries-group': __WEBPACK_IMPORTED_MODULE_9__ButtonGroup_vue___default.a
  },
  data: function data() {
    return {
      country: '',
      providersData: [],
      loading: false,
      download_report_visible: true,
      titles: [{
        prop: 'Compania',
        label: 'Compañía',
        align: 'left'
      }, {
        prop: 'idFiscal',
        label: 'Identificación Fiscal',
        align: 'center'
      }, {
        prop: 'idType',
        label: 'Tipo de Identificación',
        align: 'center'
      }, {
        prop: 'Proovedor_fecha_creacion',
        label: 'Fecha de creación',
        align: 'center'
      }, {
        prop: 'Acepto_Codigo_etica',
        label: 'Cod.Ética',
        align: 'center'
      }, {
        prop: 'Acepto_Codigo_compliance',
        label: 'Cod.Compliance',
        align: 'center'
      }, {
        prop: 'Importacion_SAP',
        label: 'Importación SAP',
        align: 'center'
      }, {
        prop: 'Etapa',
        label: 'Etapa',
        align: 'center'
      }, {
        prop: 'Aprobar_DG',
        label: 'Aprobación D.Generales',
        align: 'center'
      }, {
        prop: 'DG_Aprobado_por',
        label: 'Aprobado por',
        align: 'center'
      }, {
        prop: 'Aprobar_DI',
        label: 'Aprobación D.Impositivos',
        align: 'center'
      }, {
        prop: 'DI_Aprobado_por',
        label: 'Aprobado por',
        align: 'center'
      }, {
        prop: 'Aprobar_DB',
        label: 'Aprobación D.Bancarios',
        align: 'center'
      }, {
        prop: 'DB_Aprobado_por',
        label: 'Aprobado por',
        align: 'center'
      }, {
        prop: 'Rechazar_DG',
        label: 'Rechazo D.Generales',
        align: 'center'
      }, {
        prop: 'DG_Rechazado_por',
        label: 'Rechazado por',
        align: 'center'
      }, {
        prop: 'Rechazar_DI',
        label: 'Rechazo D.Impositivos',
        align: 'center'
      }, {
        prop: 'DI_Rechazado_por',
        label: 'Rechazado por',
        align: 'center'
      }, {
        prop: 'Rechazar_DB',
        label: 'Rechazo D.Bancarios',
        align: 'center'
      }, {
        prop: 'DB_Rechazado_por',
        label: 'Rechazado por',
        align: 'center'
      }],
      filters: [{
        prop: ['Compania', 'idFiscal', 'Etapa'],
        value: ''
      }, {
        prop: 'codCountry',
        value: ''
      }]
    };
  },

  watch: {
    loading: {
      handler: 'performFiltering',
      immediate: true
    }
  },
  methods: {
    performFiltering: function performFiltering() {
      if (!this.loading) {
        this.download_report_visible = true;
      }
    },
    filtrando: function filtrando() {
      var d = this.filterLogs(this.providersData);
      this.download_report_visible = d.length > 0;
    },
    getProvidersData: function getProvidersData() {
      var _this = this;

      this.loading = true;
      var that = this;
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('GET', 'api/getProvidersLog').then(function (response) {
        that.loading = false;
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this.renameOldData(data);
          _this.filtrando();
          return data.data;
        }
      }).catch(function (error) {
        that.loading = false;
        _this.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    renameOldData: function renameOldData(data) {
      this.providersData = data.data.map(function (obj) {
        for (var key in obj) {
          if (obj.hasOwnProperty(key) && typeof obj[key] === 'string') {
            if (obj[key] === '1999-12-12 00:00:00' || obj[key] === null) {
              obj[key] = '✓';
            } else {
              var dateRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
              if (dateRegex.test(obj[key])) {
                obj[key] = obj[key].slice(0, 16);
              }
            }
          } else if (obj.hasOwnProperty(key) && obj[key] === null) {
            obj[key] = '✓';
          }
        }
        return obj;
      });
    },
    downloadProvidersData: function downloadProvidersData() {
      var data = this.providersData;
      var filteredData = this.filterLogs(data);
      console.log(filteredData);
      if (filteredData.length === 0) {
        alert('No puedes generar un reporte con la tabla vacia');
        return;
      }
      var csvData = this.makeCsvLogs(filteredData);
      this.downloadCsv(csvData);
    },
    filterLogs: function filterLogs(data) {
      var search = this.filters[0].value.toLowerCase();
      var country = this.filters[1].value;
      var searchedProviders = [];
      var companyName = '';
      var companyFiscalId = '';
      var companyStage = '';

      data.map(function (data) {
        companyName = data.Compania.toLowerCase();
        companyFiscalId = data.idFiscal;
        companyStage = data.Etapa.toLowerCase();

        if ((search === '' || companyName.includes(search) || companyFiscalId.includes(search) || companyStage.includes(search)) && (country === '' || data.codCountry === country)) {
          searchedProviders.push(data);
        }
      });

      return searchedProviders;
    },
    makeCsvLogs: function makeCsvLogs(data) {
      var csvRows = [];
      this.headers = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data[0]);
      csvRows.push(this.headers.join(','));
      data.map(function (data) {
        var values = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(data).join(',');
        csvRows.push(values);
      });
      return csvRows.join('\n');
    },
    downloadCsv: function downloadCsv(data) {
      var blob = new Blob([data], { type: 'text/csv' });
      var url = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', 'logs.csv');
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    updateFilter: function updateFilter(updatedFilter) {
      var index = this.filters.findIndex(function (f) {
        return f.prop === updatedFilter.prop;
      });
      this.filters[index].value = updatedFilter.value;
      this.filtrando();
    }
  },
  beforeMount: function beforeMount() {
    this.getProvidersData();
  }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_date_picker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chart_js__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(5);



__webpack_require__(0);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Search',
  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_1_vue_date_picker___default.a
  },
  data: function data(router) {
    return {
      generateRandomNumbers: function generateRandomNumbers(numbers, max, min) {
        var a = [];
        for (var i = 0; i < numbers; i++) {
          a.push(Math.floor(Math.random() * (max - min + 1)) + max);
        }
        return a;
      },

      titles: [{
        prop: 'companyName',
        label: 'Compañía',
        align: 'center'
      }, {
        prop: 'cuit',
        label: 'CUIT',
        align: 'center'
      }],
      filters: [{
        prop: ['companyName', 'cuit'],
        value: ''
      }],
      filtersCalif: [{
        prop: ['companyName', 'cuit'],
        value: ''
      }],
      section: 'Search',
      loading: '',
      clients: [],
      idUser: this.$store.state.user.idUser,
      table: '',
      showChart: true,
      vue: this,
      providers: [],
      buyOrders: []
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.getBuyOrders();
    this.getProviders();
    if (!this.$store.state.countStatus) {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('get', 'api/countStatus?idUser=' + this.idUser).then(function (response) {
        var data = response.data;

        if (data.status) {
          _this.$store.commit('SET_COUNTSTATUS', data.status);
          _this.status = data.status;
        }
      }).catch(function (error) {
        console.log(error);
      });
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('get', 'api/getStatus').then(function (response) {
        var data = response.data;

        if (data.status) {
          _this.$store.commit('SET_STATUS', data.status);
          _this.statusList = data.status;
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])(['user']), {
    datetime: function datetime() {
      return new Date();
    },
    isMobile: function isMobile() {
      return window.innerWidth <= 800 && window.innerHeight <= 600;
    },
    personalNumbers: function personalNumbers() {
      return this.generateRandomNumbers(12, 1000000, 10000);
    },
    coPilotNumbers: function coPilotNumbers() {
      return this.generateRandomNumbers(12, 1000000, 10000);
    },
    activeProviders: function activeProviders() {
      var _this2 = this;

      return this.providers.filter(function (el) {
        return _this2.hasProviderActive(el);
      });
    },
    calificatedProviders: function calificatedProviders() {
      return this.providers.sort(function (a, b) {
        return a.calification < b.calification ? 1 : -1;
      });
    },
    statusList: function statusList() {
      console.log(this.$store.state.countStatus);
      return this.$store.state.countStatus;
    },
    colors: function colors() {
      var colors = [];
      colors[0] = '#040200';
      colors[1] = '#b9060b';
      colors[2] = '#FF8000';
      colors[3] = '#FFBF00';
      colors[4] = '#4cd6ff';
      colors[5] = '#01DF01';
      colors[6] = '#01DFA5';
      colors[7] = '#0174DF';
      colors[8] = '#0101DF';
      colors[9] = '#A901DB';
      colors[10] = '#DF01A5';
      colors[11] = '#DF013A';
      colors[12] = '#6E6E6E';
      return colors;
    },
    datasetOperationsPerMonth: function datasetOperationsPerMonth() {
      var demo = [[13, 14, 15, 6, 1, 2, 0, 0, 0, 0, 0, 0], [21, 11, 12, 1, 1, 1, 0, 0, 0, 0, 0, 0], [11, 12, 11, 0, 3, 2, 0, 0, 0, 0, 0, 0], [12, 11, 10, 6, 1, 1, 0, 0, 0, 0, 0, 0], [12, 11, 12, 1, 1, 1, 0, 0, 0, 0, 0, 0]];
      var a = [];

      for (var i = 0; i < this.statusList.length; i++) {
        a[i] = {
          label: this.statusList[i].description,

          backgroundColor: this.colors[i],

          data: demo[i]
        };
      }
      return a;
    },
    labelsChart: function labelsChart() {
      var labels = [];
      var date = new Date();
      for (var i = 0; i < 12; i++) {
        labels[i] = i + 1 + '/' + date.getFullYear();
      }
      return labels;
    },
    userIsPayments: function userIsPayments() {
      var isPayment = this.user.roles.find(function (role) {
        return role.rolesId === '2';
      });
      return this.user.isProvider || isPayment !== undefined;
    }
  }),
  mounted: function mounted() {},

  methods: {
    graphReport: function graphReport() {
      var ctx;
      var config;
      ctx = document.getElementById('nicBar').getContext('2d');
      config = {
        type: 'bar',
        data: {
          labels: this.labelsChart,
          datasets: this.datasetOperationsPerMonth
        },
        options: {
          responsive: true,
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
                callback: function callback(value) {
                  if (value % 1 === 0) {
                    return value;
                  }
                }
              }
            }]
          },
          maintainAspectRatio: !this.isMobile,
          legend: {
            position: 'bottom',
            display: true
          },
          tooltips: {
            mode: 'label',
            xPadding: 10,
            yPadding: 10,
            bodySpacing: 10
          }
        }
      };
      new __WEBPACK_IMPORTED_MODULE_3_chart_js___default.a(ctx, config);
    },
    getBuyOrders: function getBuyOrders() {
      var _this3 = this;

      if (this.user.isProvider) {
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('GET', 'api/generic/buyOrder?select=fecha_liberacion,statusId,idCompany&condition=idCompany=' + this.user.company.idCompany).then(function (response) {
          var data = response.data;
          if (data.error) {
            return;
          }
          if (data) {
            var orders = data;
            _this3.buyOrders = orders;
            _this3.graphReport();
          }
        }).catch(function (error) {
          _this3.$store.commit('TOGGLE_LOADING');
          console.log(error);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('GET', 'api/generic/buyOrder?select=fecha_liberacion, statusId').then(function (response) {
          var data = response.data;
          if (data.error) {
            return;
          }
          if (data) {
            var orders = data;
            _this3.buyOrders = orders;
            _this3.graphReport();
          }
        }).catch(function (error) {
          _this3.$store.commit('TOGGLE_LOADING');
          console.log(error);
        });
      }
    },
    getCountPerMonth: function getCountPerMonth(statusId) {
      var buyOrdersMonth = [];
      var j = 12;
      while (j) {
        buyOrdersMonth[--j] = 0;
      }
      var d = new Date();
      var m = d.getMonth();
      var y = d.getFullYear();
      for (var i = 0; i < this.buyOrders.length; i++) {
        var month = Number(this.buyOrders[i].fecha_liberacion.substring(5, 7));
        var year = Number(this.buyOrders[i].fecha_liberacion.substring(0, 4));
        if (this.buyOrders[i].statusId === statusId && month <= m + 1 && year === y) {
          buyOrdersMonth[month - 1] += 1;
        }
      }
      return buyOrdersMonth;
    },
    getInvoices: function getInvoices() {
      this.invoices = this.$store.state.invoices;
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'cargando' : '';
    },
    hasProviderActive: function hasProviderActive(provider) {
      return this.$store.state.contacts.some(function (cont) {
        return cont.idCompany === provider.idCompany && cont.idProviderStatus === '2';
      });
    },
    getProviders: function getProviders() {
      var _this4 = this;

      this.$store.commit('START_LOADING');
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('GET', 'api/generic/company?select=idCompany,companyName,cuit,calification').then(function (response) {
        _this4.providers = response.data;
        _this4.providers.forEach(function (el, index) {
          el.calification = parseInt(el.calification);
        });
        _this4.$store.commit('STOP_LOADING');
      }).catch(function (error) {
        console.log(error);
        _this4.$store.commit('STOP_LOADING');
      });
    }
  }
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_picker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_text_mask__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_apiHelper__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(5);




__webpack_require__(0);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Search',
  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_2_vue_date_picker___default.a,
    MaskedInput: __WEBPACK_IMPORTED_MODULE_4_vue_text_mask___default.a
  },
  data: function data(router) {
    return {
      statusCount: [],
      totalBuyOrders: 0,
      nicFilter: '',
      buyOrders: [],
      loadingBuyOrders: false,
      loadingStatus: false,
      currentApiCalls: 0,
      currentApiStatusCalls: 0,
      dummyFilter: '',
      section: 'Search',
      loading: '',
      tipoFecha: 'emision',
      estado: '',
      response: '',
      desde: '',
      hasta: '',
      showModal: false,
      cliente: '',
      referencia: '',
      fecha: '',
      facturas: this.$store.state.facturas,
      providers: null,
      clients: [],
      receptor: '',
      idUser: this.$store.state.user.idUser,
      filtrados: [],
      table: '',
      vue: this,
      rutMask: this.$store.state.rutMask,
      invoiceMask: this.$store.state.invoiceMask,
      titles: [{
        prop: 'nic',
        label: 'OC',
        sortable: 'custom'
      }, {
        prop: 'company',
        label: 'Proveedor'
      }],
      filters: [{
        prop: 'statusId',
        value: '',
        type: 'multiSelect'
      }, {
        prop: 'fecha_liberacion',
        type: 'dateRange',
        value: ''
      }, {
        prop: 'nic',
        value: ''
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])(['user']), {
    statusList: function statusList() {
      var _this = this;

      var status = this.$store.state.countStatus.filter(function (el) {
        return _this.statusByPath().includes(el.statusId);
      });
      return status;
    }
  }),
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (to === from) {
      this.filters[0].value = from.params.statusId;
    }
    next();
  },
  saveNIC: function saveNIC() {
    var _this2 = this;

    if (this.companyNew.nombre !== '' && this.companyNew.razonSocial !== '' && this.companyNew.cuit !== '' && this.currentIdRubro !== undefined && this.currentIdRubro.length > 0) {
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('POST', 'api/generic/company', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ 'company': this.companyNew.nombre, 'companyName': this.companyNew.razonSocial, 'idCompanyStatus': 2, 'cuit': this.companyNew.cuit, 'reasonCalification': this.companyNew.descripcion, 'idCompany': '' })).then(function (response) {
        _this2.currentIdRubro.forEach(function (item, index) {
          __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('POST', 'api/generic/rubrosCompany/', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ 'idRubro': _this2.currentIdRubro[index], 'idCompany': response.data.idCompany })).then(function (response) {
            _this2.$message.success('Se ha agregado la nueva empresa', 'success');
            _this2.hideModal();
            _this2.$parent.getProviders();
          });
        });
      }).catch(function (error) {
        _this2.$message.error(error.response.data, 'error');
      });
    } else {
      this.$message.warning('Debe completar todos los campos', 'warning');
    }
  },
  mounted: function mounted() {
    if (this.$route.params.statusId) {
      this.filters[0].value = this.$route.params.statusId;
    }
  },

  methods: {
    statusByPath: function statusByPath() {
      switch (this.$route.path) {
        case '/buyOrders':
          return ['1', '2', '7'];
        case '/toBill':
          return ['3', '9'];
        default:
          return ['1', '2', '3', '7', '9'];
      }
    },
    startLoadingStatus: function startLoadingStatus() {
      this.currentApiStatusCalls++;
      this.loadingStatus = true;
    },
    stopLoadingStatus: function stopLoadingStatus() {
      this.currentApiStatusCalls--;
      if (this.currentApiStatusCalls === 0) this.loadingStatus = false;
    },
    startLoading: function startLoading() {
      this.currentApiCalls++;
      this.loadingBuyOrders = true;
    },
    stopLoading: function stopLoading() {
      this.currentApiCalls--;
      if (this.currentApiCalls === 0) this.loadingBuyOrders = false;
    },
    getCondition: function getCondition() {
      var condition = '(';
      var pathStatus = this.statusByPath();
      for (var index = 0; index < pathStatus.length;) {
        condition += 'statusId = ' + pathStatus[index];
        index++;
        if (index < pathStatus.length) {
          condition += ' OR ';
        }
      }
      condition += ')';
      return condition;
    },
    getTotalBuyOrder: function getTotalBuyOrder() {
      var _this3 = this;

      var queryInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var substringPosition = queryInfo.search('condition=');
      var query = queryInfo.substring(substringPosition + 10);
      var condition = this.getCondition();
      if (this.user.isProvider) {
        __WEBPACK_IMPORTED_MODULE_5__helpers_apiHelper__["a" /* default */].getTotal('buyOrder', query + ' AND ' + condition + ' AND idCompany =' + this.user.company.idCompany).then(function (count) {
          _this3.totalBuyOrders = count;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_5__helpers_apiHelper__["a" /* default */].getTotal('buyOrder', query + ' AND ' + condition).then(function (count) {
          _this3.totalBuyOrders = count;
        });
      }
    },
    getBuyOrders: function getBuyOrders() {
      var _this4 = this;

      var queryInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var condition = this.getCondition();
      var query = __WEBPACK_IMPORTED_MODULE_5__helpers_apiHelper__["a" /* default */].getQueryForApi(queryInfo);
      this.startLoading();
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('GET', 'api/getBuyOrder/' + this.user.idUser + query + ' AND ' + condition).then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          var orders = data;
          _this4.buyOrders = orders;
        }
        _this4.stopLoading();
      }).catch(function (error) {
        _this4.$store.commit('TOGGLE_LOADING');
        console.log(error);
        _this4.loadingBuyOrders = false;
      });
      this.getTotalBuyOrder(query);
    },
    searchStatus: function searchStatus(status) {
      this.filters[0].value = [status];
    },
    getStatusName: function getStatusName(statusId) {
      if (this.statusList.length > 0) {
        return this.statusList.find(function (el) {
          return el.statusId === statusId;
        }).description;
      } else {
        return '-';
      }
    },
    getCountByStatus: function getCountByStatus() {
      var _this5 = this;

      this.statusByPath().forEach(function (item) {
        _this5.startLoadingStatus();
        if (_this5.user.isProvider) {
          __WEBPACK_IMPORTED_MODULE_5__helpers_apiHelper__["a" /* default */].getTotal('buyOrder', 'statusId = ' + item + ' AND idCompany =' + _this5.user.company.idCompany).then(function (count) {
            _this5.statusCount[item] = count;
            _this5.stopLoadingStatus();
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_5__helpers_apiHelper__["a" /* default */].getTotal('buyOrder', 'statusId = ' + item).then(function (count) {
            _this5.statusCount[item] = count;
            _this5.stopLoadingStatus();
          });
        }
      });
    },
    goToDetails: function goToDetails(idBuyOrder) {
      this.$router.push('/invoicedetail?i=' + idBuyOrder);
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'cargando' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
    },
    compareViewNics: function compareViewNics(a, b) {
      if (a.view < b.view) {
        return -1;
      } else if (a.view > b.view) {
        return 1;
      }

      return 0;
    },
    compareViewInvoice: function compareViewInvoice(a, b) {
      if (!a.factura) {
        return 1;
      }
      if (!b.factura) {
        return -1;
      }
      if (a.factura.visto < b.factura.visto) {
        return -1;
      } else if (a.factura.visto > b.factura.visto) {
        return 1;
      }
      return 0;
    }
  },
  beforeMount: function beforeMount() {
    this.getCountByStatus();
  }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_utils_js__ = __webpack_require__(14);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      paramsCountry: this.$route.params.country,
      cond: true
    };
  },

  props: {
    data: {
      type: Object,
      required: true
    },
    validation: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    locations: {
      type: [Object, Array]
    },
    banks: {
      type: [Object, Array]
    },
    bankAccountTypes: {
      type: [Object, Array]
    }
  },
  watch: {
    'data.model': {
      immediate: true,
      handler: function handler(newValue) {
        if (newValue) {
          this.updateSelectOptions();
        }
      }
    }
  },
  methods: {
    verifyFields: __WEBPACK_IMPORTED_MODULE_0__helpers_utils_js__["c" /* verifyFields */],
    persistToNewProviderStorage: __WEBPACK_IMPORTED_MODULE_0__helpers_utils_js__["a" /* persistToNewProviderStorage */],
    saveDataToLocalStorage: __WEBPACK_IMPORTED_MODULE_0__helpers_utils_js__["b" /* saveDataToLocalStorage */],
    updateSelectOptions: function updateSelectOptions() {
      var _this = this;

      if (this.$props.data.name === 'location') {
        this.data.optionValue = this.$props.data.optionValue.map(function (opt) {
          if (typeof opt === 'string') {
            return {
              label: opt,
              value: _this.$props.locations.data.find(function (loc) {
                return loc.codRegion === opt;
              }).idProvince
            };
          } else {
            return opt;
          }
        });
      }

      if (this.$props.data.name === 'bank' || this.$props.data.name === 'bank2') {
        if (this.$props.data.model !== '') {
          this.data.optionValue = this.$props.data.optionValue.map(function (opt) {
            if (typeof opt === 'string') {
              return {
                label: opt,
                value: _this.$props.banks.data.find(function (bank) {
                  return bank.bank === opt;
                }).idBank
              };
            } else {
              return opt;
            }
          });
        }
      }

      if (this.$props.data.name === 'accountType' || this.$props.data.name === 'accountType2') {
        this.data.optionValue = this.$props.data.optionValue.map(function (opt) {
          if (typeof opt === 'string') {
            return {
              label: opt,
              value: _this.$props.bankAccountTypes.find(function (bankAccountType) {
                return bankAccountType.codeERP === opt;
              }).idBankAccountType
            };
          } else {
            return opt;
          }
        });
      }

      this.$props.data.optionValue = this.$props.data.optionValue.map(function (opt, index) {
        if (typeof opt === 'string') {
          return {
            label: opt,
            value: index + 1
          };
        } else {
          return opt;
        }
      });

      var optionModel = void 0;
      if ((this.$props.data.name === 'bank' || this.$props.data.name === 'bank2') && !this.paramsCountry) {
        optionModel = this.$props.data.optionValue.find(function (opt) {
          return opt.value === _this.$props.data.model;
        });
      } else {
        optionModel = this.$props.data.optionValue.find(function (opt) {
          return opt.value === Number(_this.$props.data.model);
        });
      }
      if (optionModel) {
        this.data.model = optionModel.value;
      }
    }
  },
  mounted: function mounted() {
    if (this.data.model || !this.paramsCountry) {
      this.updateSelectOptions();
    }
  }
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_picker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__demo__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui__);




__webpack_require__(0);







__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_element_ui___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Settings',
  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_2_vue_date_picker___default.a
  },
  data: function data(router) {
    return {
      section: 'ChangePsw',
      loading: '',
      comment: '',
      response: null,
      success: null,
      idUser: this.$store.state.user.idUser,
      address: '',
      billingAddress: '',
      comments: '',
      currentCountry: '',
      availableCountries: [],
      countryData: {
        AR: { name: 'Argentina', idFIT: 1 },
        PE: { name: 'Perú', idFIT: 2 }
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    datetime: function datetime() {
      return new Date();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])(['userInfo', 'user']), {
    idFIT: function idFIT() {
      return this.user.company.idFIT;
    },
    timeline: function timeline() {
      return __WEBPACK_IMPORTED_MODULE_5__demo__["a" /* timeline */];
    }
  }),
  beforeMount: function beforeMount() {
    var _this = this;

    this.address = this.user.company.address;
    this.billingAddress = this.user.company.billingAddress;
    this.comments = this.user.company.comments;
    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('get', 'api/checkParam?id=SUN-001').then(function (response) {
      var data = response.data;
      console.log('SUN-001', data);
      _this.availableCountries = data;
    }).catch(function (error) {
      console.log(error);
    });
  },

  methods: {
    viewCompanyData: function viewCompanyData(step) {
      this.$router.push('/companyData/' + this.user.company.idCompany + '/' + step + '/' + this.currentCountry);
    },
    loadDocument: function loadDocument(url) {
      var win = window.open(url, '_blank');
      win.focus();
    },
    nameChange: function nameChange(row) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', 'api/generic/user/' + this.idUser, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.user)).then(function (response) {
        _this2.$store.commit('SET_USER', _this2.user);
        localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.user));
      }).catch(function (error) {
        console.log(error);
      });
    },
    companyChange: function companyChange(row) {
      var _this3 = this;

      this.user.company.address = this.address;
      this.user.company.billingAddress = this.billingAddress;
      this.user.company.comments = this.comments;
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('post', 'api/generic/company/' + this.user.company.idCompany, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.user.company)).then(function (response) {
        _this3.$message({
          type: 'success',
          message: 'Se han guardado los datos'
        });
        localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.user));
      }).catch(function (error) {
        console.log(error);
      });
    },
    sendComment: function sendComment() {
      var _this4 = this;

      var idUser = this.idUser,
          comment = this.comment;


      this.toggleLoading();
      this.resetResponse();
      this.$store.commit('TOGGLE_LOADING');

      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].request('GET', 'api/sendComment?idUser=' + idUser + '&comment=' + comment).then(function (response) {
        _this4.toggleLoading();
        _this4.invoices = null;

        var data = response.data;

        if (response.data.error) {
          var errorName = response.data.error.name;
          if (errorName) {
            if (errorName === 'InvalidArgumentError') {
              _this4.response = 'Los datos suministrados son incorrectos.';
            } else if (errorName === 'NotFoundError') {
              _this4.response = 'La factura no se encuentra.';
            } else {
              _this4.response = errorName;
            }
          } else {
            _this4.response = data.error;
          }

          return;
        } else {
          if (data.success) {
            _this4.success = data.success;
          }
        }
      }).catch(function (error) {
        _this4.$store.commit('TOGGLE_LOADING');
        _this4.invoices = null;
        console.log(error);

        _this4.response = 'Error al conectarse con el servidor, contacte al administrador.';
        _this4.toggleLoading();
      });
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'cargando' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
      this.success = '';
    }
  }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_utils_js__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  props: {
    data: {
      type: Object,
      required: true
    },
    validation: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  computed: {
    formattedData: function formattedData() {
      var data = this.data.model;
      if (data.length === 11) {
        return data.slice(0, 2) + '-' + data.slice(2, 5) + '-' + data.slice(5);
      }
      return data;
    }
  },
  methods: {
    verifyFields: __WEBPACK_IMPORTED_MODULE_0__helpers_utils_js__["c" /* verifyFields */],
    saveDataToLocalStorage: __WEBPACK_IMPORTED_MODULE_0__helpers_utils_js__["b" /* saveDataToLocalStorage */],
    persistToNewProviderStorage: __WEBPACK_IMPORTED_MODULE_0__helpers_utils_js__["a" /* persistToNewProviderStorage */],
    verifyEmail: function verifyEmail(data) {
      var regex = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
      return !regex.test(data.model) && data.model.length > 0 && data.validate === 'email' && this.validation === false;
    },
    verifyNumbers: function verifyNumbers(data) {
      var regex = /^[0-9]+$/;
      return (!regex.test(data.model) || data.model.length < data.max) && data.model.length > 0 && data.validate === 'onlyNumbers' && this.validation === false;
    },
    verifyPasswords: function verifyPasswords(data) {
      return data.validate === 'repeated-password' && !data.samePassword && this.validation === false && data.model.length > 0;
    },
    verifyPasswordLength: function verifyPasswordLength(data) {
      return data.validate === 'password' && data.model.length < 6 && this.validation === false && data.model.length > 0;
    }
  }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_date_picker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_text_mask__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_the_mask__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_recaptcha__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__recaptcha__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__recaptcha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__recaptcha__);


__webpack_require__(0);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Solicitud',
  components: { datepicker: __WEBPACK_IMPORTED_MODULE_0_vue_date_picker___default.a, TheMask: __WEBPACK_IMPORTED_MODULE_3_vue_the_mask___default.a, MaskedInput: __WEBPACK_IMPORTED_MODULE_1_vue_text_mask___default.a, VueRecaptcha: __WEBPACK_IMPORTED_MODULE_4_vue_recaptcha__["a" /* default */], gRecaptcha: __WEBPACK_IMPORTED_MODULE_5__recaptcha___default.a },
  computed: {
    datetime: function datetime() {
      return new Date();
    }
  },
  data: function data(router) {
    return {
      captcha: false,
      checked2: false,
      section: 'Solicitud',
      loading: '',
      rut: '',
      configuration: '',
      codigoEtica: '',
      invoice0: '',
      date0: '',
      invoice1: '',
      date1: '',
      invoice2: '',
      date2: '',
      name: '',
      reason: '',
      email: '',
      response: null,
      success: null,
      paramError: null,
      paramInvoices: null,
      rutMask: this.$store.state.rutMask,
      cuitMask: [/[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
      invoiceMask: this.$store.state.invoiceMask,
      centerDialogVisible: false,
      checked: false,
      siteKey: '6LdsJtEUAAAAAKYTuuM3rWVyttE2EuQzwMp_ZwnO'
    };
  },

  methods: {
    captchaVerificado: function captchaVerificado() {
      this.captcha = true;
    },
    submitFormSolicitud: function submitFormSolicitud() {
      if (this.checked2 === true && this.checked === true) {
        this.centerDialogVisible = false;
        this.checkData();
      } else {
        this.checked2 = false;
        this.checked = false;
        this.centerDialogVisible = true;
      }
    },
    clearInput: function clearInput(vueModel) {
      vueModel = '';
    },
    checkData: function checkData() {
      var _this = this;

      if (this.rut.length !== 11) {
        this.$message({
          message: 'El CUIT debe tener 11 caracteres.',
          type: 'warning'
        });
        return;
      }
      var rut = this.rut,
          invoice0 = this.invoice0,
          date0 = this.date0,
          invoice1 = this.invoice1,
          date1 = this.date1,
          invoice2 = this.invoice2,
          date2 = this.date2,
          name = this.name,
          reason = this.reason,
          email = this.email;

      this.toggleLoading();
      this.resetResponse();
      this.$store.commit('TOGGLE_LOADING');

      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('GET', 'api/solicitudUsuario' + '?rut=' + rut + '&invoice0=' + invoice0 + '&date0=' + date0 + '&invoice1=' + invoice1 + '&date1=' + date1 + '&invoice2=' + invoice2 + '&date2=' + date2 + '&name=' + name + '&reason=' + reason + '&email=' + email).then(function (response) {
        _this.toggleLoading();

        var data = response.data;

        if (response.data.error) {
          var errorName = response.data.error.name;
          if (errorName) {
            console.log(errorName);
            _this.checked = false;
            _this.checked2 = false;
            if (errorName === 'InvalidArgumentError') {
              _this.response = 'Los datos son incorrectos.';
            } else if (errorName === 'NotFoundError') {
              _this.response = 'se ha producido un error inesperado.';
            } else {
              _this.response = errorName;
            }
          } else {
            _this.response = data.error;
          }

          return;
        } else {
          if (data.success) {
            _this.success = data.success;
            _this.clearFields();
          }
        }
      }).catch(function (error) {
        _this.$store.commit('TOGGLE_LOADING');
        _this.invoices = null;
        console.log(error);

        _this.response = 'Error al conectarse con el servidor, contacte al administrador.';
        _this.toggleLoading();
      });
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'cargando' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
      this.success = '';
    },
    clearFields: function clearFields() {
      this.name = '';
      this.rut = '';
      this.reason = '';
      this.email = '';
      this.checked = false;
      this.checked2 = false;
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    window.localStorage.removeItem('token');
    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('get', 'api/checkParam?id=SUN-001').then(function (response) {
      var data = response.data;
      console.log(data.error);

      if (data.error) {
        _this2.paramError = data.error;
      }
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('get', 'api/findConfiguration/TYC').then(function (response) {
      _this2.configuration = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('get', 'api/findConfiguration/CODETI').then(function (response) {
      _this2.codigoEtica = response.data['value'];
    }).catch(function (error) {
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('get', 'api/checkParam?id=SUF-001').then(function (response) {
      var data = response.data;

      if (data.error) {
        _this2.paramInvoices = data.error;
      }
    }).catch(function (error) {
      console.log(error);
    });
  }
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date_picker__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_text_mask__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(2);





__webpack_require__(0);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Search',
  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_3_vue_date_picker___default.a,
    MaskedInput: __WEBPACK_IMPORTED_MODULE_4_vue_text_mask___default.a
  },
  data: function data(router) {
    return {
      idCompany: '',
      documentosAceptados: [],
      documentosRechazados: [],
      providerDocumentStatus: [],
      emisionDate: '',
      idDocument: '',
      documentType: [],
      showModalDocumentation: false,
      showModalConfirmarDocumentacion: false,
      section: 'Search',
      loading: '',
      tipoFecha: 'emision',
      estado: '',
      response: '',
      desde: '',
      hasta: '',
      cliente: '',
      referencia: '',
      fecha: '',
      facturas: this.$store.state.facturas,
      clients: [],
      receptor: '',
      idUser: this.$store.state.user.idUser,
      filtrados: [],
      table: '',
      vue: this,
      rutMask: this.$store.state.rutMask,
      invoiceMask: this.$store.state.invoiceMask,
      titles: [{
        prop: 'idCompany',
        label: 'Proveedor',
        forProvider: false
      }, {
        prop: 'fecha_liberacion',
        label: 'Fecha',
        forProvider: true
      }],
      filters: [{
        prop: 'idProviderDocumentStatus',
        value: ''
      }, {
        filterFn: function filterFn(row, filter) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(row).some(function (prop) {
            if (prop === 'emisionDate') {
              if (filter.value !== null) {
                return new Date(row.emisionDate).getTime() <= filter.value[1].getTime() && new Date(row.emisionDate).getTime() >= filter.value[0].getTime();
              } else {
                return true;
              }
            }
          });
        },
        prop: ['emisionDate'],
        value: ''
      }, {
        prop: 'nic',
        value: ''
      }],
      providers: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])(['user']), {
    otherOperations: function otherOperations() {
      return this.$store.state.otherOperations.sort(this.compareViewNics);
    },
    statusList: function statusList() {
      var status = this.$store.state.countStatus.filter(function (el) {
        return el.statusId === '4' || el.statusId === '5' || el.statusId === '8';
      });
      return status;
    },
    datetime: function datetime() {
      return new Date();
    },
    documents: function documents() {
      return this.$store.state.documents;
    }
  }),
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (to === from) {
      this.filters[0].value = from.params.statusId;
    }
    next();
  },
  mounted: function mounted() {
    if (this.$route.params.statusId) {
      this.filters[0].value = this.$route.params.statusId;
    }
  },
  beforeMount: function beforeMount() {
    this.getProviders();
    this.getDocumentType();
    this.getDocuments();
    this.getProviderDocumentStatus();
  },

  methods: {
    getProviders: function getProviders() {
      var _this = this;

      this.$store.commit('START_LOADING');
      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/generic/company?select=idCompany,companyName').then(function (response) {
        _this.providers = response.data;
        _this.$store.commit('STOP_LOADING');
      }).catch(function (error) {
        console.log(error);
        _this.$store.commit('STOP_LOADING');
      });
    },
    cambiarEstadoDocumentos: function cambiarEstadoDocumentos(documentos, statusId) {
      var _this2 = this;

      documentos.forEach(function (doc) {
        _this2.cambiarEstadoDocumento(doc, statusId);
      });
    },
    cambiarEstadoDocumento: function cambiarEstadoDocumento(documento, estado) {
      documento.idProviderDocumentStatus = estado.toString();
      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', 'api/generic/providerDocument/' + documento.idProviderDocument, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(documento)).then(function (response) {});
    },
    confirmarDocumentos: function confirmarDocumentos() {
      this.cambiarEstadoDocumentos(this.documentosRechazados, 3);
      this.cambiarEstadoDocumentos(this.documentosAceptados, 2);
      this.documentosAceptados = [];
      this.documentosRechazados = [];
      this.cerrarModalConfirmarDocumentacion();
    },
    cerrarModalConfirmarDocumentacion: function cerrarModalConfirmarDocumentacion() {
      this.showModalConfirmarDocumentacion = false;
      this.documentosRechazados.forEach(function (el) {
        el.mensajeRechazo = '';
      });
    },
    handleIncluirDocumento: function handleIncluirDocumento(row, status) {
      if (status === 1) {
        if (!this.documentosAceptados.includes(row)) {
          this.documentosRechazados = this.documentosRechazados.filter(function (el) {
            return el !== row;
          });
          this.documentosAceptados.push(row);
        } else {
          this.documentosAceptados = this.documentosAceptados.filter(function (el) {
            return el !== row;
          });
        }
      }
      if (status === 2) {
        if (!this.documentosRechazados.includes(row)) {
          this.documentosAceptados = this.documentosAceptados.filter(function (el) {
            return el !== row;
          });
          this.documentosRechazados.push(row);
        } else {
          this.documentosRechazados = this.documentosRechazados.filter(function (el) {
            return el !== row;
          });
        }
      }
    },
    resetModal: function resetModal() {
      this.idCompany = '';
      this.emisionDate = '';
      this.idDocument = '';
      var input = this.$refs.fileDocument;
      input.type = 'text';
      input.type = 'file';
    },
    abrirModalConfirmacion: function abrirModalConfirmacion() {
      this.showModalConfirmarDocumentacion = true;
    },
    getDocumentType: function getDocumentType() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/generic/document').then(function (response) {
        _this3.documentType = response.data;
      });
    },
    getDocuments: function getDocuments() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/getProviderDocuments/' + this.user.idUser).then(function (response) {
        _this4.$store.commit('SET_DOCUMENTS', response.data);
      });
    },
    getProviderDocumentStatus: function getProviderDocumentStatus() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('GET', 'api/generic/providerDocumentStatus').then(function (response) {
        _this5.providerDocumentStatus = response.data;
        if (_this5.providerDocumentStatus[0].description === 'Enviado' && !_this5.user.isProvider) {
          _this5.providerDocumentStatus[0].description = 'Recibido';
        }
      });
    },
    createOperation: function createOperation() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', 'api/generic/buyOrder', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ 'nic': null, 'idCompany': this.user.company.idCompany, 'fecha_liberacion': this.datetime, 'pdf': null, 'statusId': 4, 'view': 0 })).then(function (response) {
        _this6.goToDetails(response.data.idBuyOrder);
      });
    },
    mostrarMensajeCompleto: function mostrarMensajeCompleto(mensaje) {
      this.$alert(mensaje, 'Mensaje', {
        confirmButtonText: 'OK'
      });
    },
    uploadDocumentation: function uploadDocumentation() {
      var _this7 = this;

      this.$confirm('¿Realmente desea adjuntar este pdf a la documentacion?', 'Advertencia', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        lockScroll: false
      }).then(function () {
        if ((!_this7.user.isProvider && _this7.idCompany || _this7.user.isProvider) && _this7.idDocument && _this7.$refs.fileDocument.files[0] && _this7.emisionDate) {
          var formData = new FormData();
          formData.append('file', _this7.$refs.fileDocument.files[0]);
          formData.append('folder', 'documentation');
          __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', 'api/uploadFile', formData).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].request('POST', 'api/generic/providerDocument', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ 'url': response.data, 'idCompany': _this7.user.isProvider ? _this7.user.company.idCompany : _this7.idCompany, 'idDocument': _this7.idDocument, 'idProviderDocumentStatus': _this7.user.isProvider ? 1 : 2, 'emisionDate': _this7.emisionDate, 'date': new Date().getFullYear() + '-' + new Date().getMonth() + '-' + new Date().getDate() })).then(function (response2) {
              _this7.showModalDocumentation = false;
              _this7.resetModal();
              _this7.getDocuments();
            });
          });
        } else {
          _this7.$message.warning('Falta completar los campos');
        }
      }).catch(function () {});
    },
    seeCreateOperationModal: function seeCreateOperationModal() {
      this.showModalCreateOperation = true;
    },
    searchStatus: function searchStatus(status) {
      this.filters[0].value = [status];
    },
    getStatusName: function getStatusName(statusId) {
      return this.statusList.find(function (estado) {
        return estado.statusId === statusId;
      }).description;
    },
    getCountByStatus: function getCountByStatus(statusId) {
      return this.documents.filter(function (el) {
        return el.idProviderDocumentStatus === statusId;
      }).length;
    },
    goToDetails: function goToDetails(idBuyOrder) {
      this.$router.push('/invoicedetail?i=' + idBuyOrder);
    },
    toggleLoading: function toggleLoading() {
      this.loading = this.loading === '' ? 'cargando' : '';
    },
    resetResponse: function resetResponse() {
      this.response = '';
    },
    compareViewNics: function compareViewNics(a, b) {
      if (a.view < b.view) {
        return -1;
      } else if (a.view > b.view) {
        return 1;
      }

      return 0;
    },
    compareViewInvoice: function compareViewInvoice(a, b) {
      if (!a.factura) {
        return 1;
      }
      if (!b.factura) {
        return -1;
      }
      if (a.factura.visto < b.factura.visto) {
        return -1;
      } else if (a.factura.visto > b.factura.visto) {
        return 1;
      }
      return 0;
    }
  }
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_utils_js__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  props: {
    data: {
      type: Object,
      required: true
    },
    validation: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  computed: {},
  methods: {
    persistToNewProviderStorage: __WEBPACK_IMPORTED_MODULE_0__helpers_utils_js__["a" /* persistToNewProviderStorage */],
    saveDataToLocalStorage: __WEBPACK_IMPORTED_MODULE_0__helpers_utils_js__["b" /* saveDataToLocalStorage */]
  }
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_utils_js__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  props: {
    data: {
      type: Object,
      required: true
    },
    validation: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  computed: {},
  methods: {
    verifyFields: __WEBPACK_IMPORTED_MODULE_0__helpers_utils_js__["c" /* verifyFields */],
    persistToNewProviderStorage: __WEBPACK_IMPORTED_MODULE_0__helpers_utils_js__["a" /* persistToNewProviderStorage */],
    saveDataToLocalStorage: __WEBPACK_IMPORTED_MODULE_0__helpers_utils_js__["b" /* saveDataToLocalStorage */]
  }
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PdfFile_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PdfFile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PdfFile_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_utils_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'pdf-file': __WEBPACK_IMPORTED_MODULE_0__PdfFile_vue___default.a
  },
  data: function data() {
    return {
      disabledDates: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },
      habModificaPdf: true,
      options: [],
      fieldAlert: '',
      retentionAliquotPeru: [],
      percepCobranza: [],
      impuestoSolid: [],
      renta4ta: [],
      rentaPersonas: [],
      rentaNoDomiciliados: [],
      retencionDetraccion: []
    };
  },

  props: {
    data: {
      type: Object,
      required: true
    },
    validation: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    denominaciones: {
      type: [Array, Object]
    }
  },
  computed: {},
  methods: {
    getRetentionAliquotPeru: function getRetentionAliquotPeru() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].request('GET', 'api/getRetentionAliquotPeru').then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this.retentionAliquotPeru = data;

          _this.generateAliquotOptions(_this.data.companyDataRetention.model);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    generateAliquotOptions: function generateAliquotOptions(selectedModels) {
      var _this2 = this;

      console.log('selectedModels', selectedModels);
      this.options = [];

      this.data.companyDataRetention.model.forEach(function (model) {
        _this2.retentionAliquotPeru.data.forEach(function (ret) {
          if (model === ret.idRetentionRegime) {
            _this2.options.push(ret);
          }
        });
      });
    },
    disabledDate: function disabledDate(date) {
      var fromDate = date;
      return date && date.valueOf() < fromDate.valueOf();
    },
    verifyFields: function verifyFields(data, validation) {
      if (data.model === null || data.model === undefined) {
        data.model = '';
      }

      return data.model.length === 0 && validation === false && data.required;
    },

    persistToNewProviderStorage: __WEBPACK_IMPORTED_MODULE_1__helpers_utils_js__["a" /* persistToNewProviderStorage */],
    saveDataToLocalStorage: __WEBPACK_IMPORTED_MODULE_1__helpers_utils_js__["b" /* saveDataToLocalStorage */]
  },
  watch: {
    'data.companyDataRetention.model': function dataCompanyDataRetentionModel(newVal) {
      this.generateAliquotOptions(newVal);
    },
    'data.model': function dataModel(newVal) {
      if (this.data.companyDataRetention.model.includes('Retención Detracciones')) {
        this.generateAliquotOptions(this.data.companyDataRetention.model);
      }
    }
  },
  mounted: function mounted() {
    this.getRetentionAliquotPeru();
  }
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PdfFile_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PdfFile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__PdfFile_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ButtonGroup',
  components: {
    'pdf-file': __WEBPACK_IMPORTED_MODULE_0__PdfFile_vue___default.a
  },
  props: {
    idBuyOrder: {
      type: String
    }
  },
  data: function data() {
    return {
      showModal: false,
      document: {
        ocType: '',
        hesNumbers: [],
        hesFile: [],
        migoFile: [],
        migoNumbers: [],
        migoDescription: [],
        hesDescription: [],
        idBuyOrder: this.idBuyOrder
      },
      acceptanceType: [{ value: '1', label: 'HES' }, { value: '2', label: 'MIGO' }],
      habModificaPdf: true,
      index: 0
    };
  },

  methods: {
    addOcNumber: function addOcNumber() {
      this.document.hesNumbers.push('');
      this.document.hesDescription.push('');
      this.document.hesFile.push('');
    },
    deleteOcNumber: function deleteOcNumber(index) {
      this.document.hesNumbers.splice(index, 1);
      this.document.hesDescription.splice(index, 1);
      this.document.hesFile.splice(index, 1);
    },
    addMigoNumber: function addMigoNumber() {
      this.document.migoNumbers.push('');
      this.document.migoDescription.push('');
      this.document.migoFile.push('');
    },
    deleteMigoNumber: function deleteMigoNumber(index) {
      this.document.migoNumbers.splice(index, 1);
      this.document.migoDescription.splice(index, 1);
      this.document.migoFile.splice(index, 1);
    },
    saveOperationData: function saveOperationData() {
      var _this = this;

      if (this.document.ocType === '1' && this.document.hesNumbers.length !== 0 && this.document.hesNumbers[0] !== '' && this.document.hesDescription[0] !== '' || this.document.ocType === '2' && this.document.migoNumber !== '' && this.document.hesNumbers[0] !== '' && this.document.migoDescription[0] !== '') {
        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].request('POST', 'api/saveOperationData', this.document).then(function (response) {
          _this.$message.success('Se ha guardado la informacion de la operacion correctamente', 'success');
          _this.showModal = false;
          _this.$router.push('/toBill');
        }).catch(function (error) {
          _this.$message.error(error.response.data, 'error');
        });
      } else {
        this.$message.warning('Debe completar los campos obligatorios', 'warning');
      }
    }
  },
  beforeMount: function beforeMount() {}
});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PdfFile_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PdfFile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PdfFile_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UploadOrder_vue__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UploadOrder_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__UploadOrder_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ButtonGroup',
  components: {
    'pdf-file': __WEBPACK_IMPORTED_MODULE_1__PdfFile_vue___default.a,
    'upload-order': __WEBPACK_IMPORTED_MODULE_2__UploadOrder_vue___default.a
  },
  props: {
    loadOperationType: {
      type: Boolean
    },
    idBuyOrder: {
      type: String
    },
    idCompany: {
      type: String
    }
  },
  data: function data() {
    return {
      showModal: false,
      document: {
        documenttype: '',
        ocType: '',
        ocNumbers: [],
        pdfDoc: '',
        migoNumber: '',
        codigoAFIP: '',
        letra: '',
        numero: '',
        fechaVencimiento: '',
        NroCAE: '',
        importeTotal: '',
        importeImpuesto: '',
        porcentajeImpuesto: '',
        moneda: '',
        tipoDeCambio: '',
        idBuyOrder: this.idBuyOrder,
        code: '',
        description: '',
        tipo: '',
        idCompany: this.idCompany
      },
      formRules: {
        operationCode: [{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }],
        documenttype: [{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }],
        codigoAFIP: [{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }, { pattern: /^[0-9]+$/, message: 'Solo se permiten números en este campo', trigger: 'change' }],
        letra: [{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }, { pattern: /^[A-Za-z]+$/, message: 'Solo se permiten letras en este campo', trigger: 'change' }],
        numero: [{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }, { pattern: /^[0-9]+$/, message: 'Solo se permiten números en este campo', trigger: 'change' }],
        proveedor: [{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }],
        fechaVencimiento: [{ type: 'date', required: true, message: 'Este campo es obligatorio', trigger: 'change' }],
        NroCAE: [{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }, { pattern: /^[0-9]+$/, message: 'Solo se permiten números en este campo', trigger: 'change' }],
        pdfDoc: [{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }],
        importeTotal: [{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }, { pattern: /^[0-9]+(\.[0-9]+)?$/, message: 'Solo se permiten números decimales en este campo', trigger: 'change' }],
        importeImpuesto: [{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }, { pattern: /^[0-9]+(\.[0-9]+)?$/, message: 'Solo se permiten números decimales en este campo', trigger: 'change' }],
        porcentajeImpuesto: [{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }, { pattern: /^[0-9]+(\.[0-9]+)?$/, message: 'Solo se permiten números decimales en este campo', trigger: 'change' }],
        moneda: [{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }, { pattern: /^[A-Za-z]+$/, message: 'Solo se permiten letras en este campo', trigger: 'change' }],
        tipoDeCambio: [{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }, { pattern: /^[0-9]+(\.[0-9]+)?$/, message: 'Solo se permiten números decimales en este campo', trigger: 'change' }]
      },
      hesMigo: [],
      documentType: [{ value: '1', label: 'Factura' }, { value: '2', label: 'Nota de crédito' }, { value: '3', label: 'Nota de débito' }],
      acceptanceType: [{ value: '1', label: 'HES' }, { value: '2', label: 'MIGO' }],
      habModificaPdf: true
    };
  },

  methods: {
    addOcNumber: function addOcNumber() {
      this.document.ocNumbers.push({ value: '' });
    },
    getHesMigoData: function getHesMigoData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('GET', 'api/getHesMigoData?buyOrder=' + this.idBuyOrder).then(function (response) {
        var data = response.data;
        if (data.error) {
          return;
        }
        if (data) {
          _this.hesMigo = data.data;
          console.log(_this.hesMigo);
        }
      }).catch(function (error) {
        _this.$store.commit('TOGGLE_LOADING');
        console.log(error);
      });
    },
    deleteOcNumber: function deleteOcNumber(index) {
      this.document.ocNumbers.splice(index, 1);
    },
    createDocumentWithOc: function createDocumentWithOc() {
      var _this2 = this;

      if (this.hesMigo.length === 0) {
        this.$message.error('No hay codigos disponibles para cargar una factura');
        return;
      }
      if (this.document.code === '') {
        this.$message.error('Falta seleccionar el codigo de operacion');
        return;
      }
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].request('POST', 'api/createDocumentWithOc', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.document)).then(function (response) {
        _this2.$message({
          message: 'Documento creado correctamente',
          type: 'success',
          duration: 5000
        });
        _this2.$router.push('/');
      }).catch(function (error) {
        console.log(error);
      });
    },
    updateDescriptionTipo: function updateDescriptionTipo() {
      var selectedCode = this.document.code;
      var selectedHes = this.hesMigo.find(function (item) {
        return item.idHes === selectedCode;
      });
      if (selectedHes) {
        this.document.description = selectedHes.description;
        this.document.tipo = selectedHes.type;
      } else {
        this.document.description = '';
        this.document.tipo = '';
      }
    },
    validateForm: function validateForm() {
      var _this3 = this;

      this.$refs.formRef.validate(function (valid) {
        if (valid) {
          _this3.createDocumentWithOc();
        } else {
          _this3.$message.error('Debe completar todos los campos');
        }
      });
    }
  },
  beforeMount: function beforeMount() {
    this.getHesMigoData();
  }
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);


if (typeof window !== 'undefined') {
  window.recaptchaLoaded = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    window.vueRecaptchaInit = resolve;
  });
  var recaptchaScript = document.createElement('script');
  recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaInit&render=explicit');
  recaptchaScript.setAttribute('async', '');
  recaptchaScript.setAttribute('defer', '');
  document.body.appendChild(recaptchaScript);
}
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    sitekey: String,
    callback: Function,
    validate: Function,
    badge: String,
    type: String,
    errorCallback: Function,
    tabindex: String,
    size: String
  },
  data: function data() {
    return {
      recaptchaId: 0
    };
  },
  created: function created() {
    var _this = this;

    if (typeof window === 'undefined') return;
    window.recaptchaLoaded.then(function () {
      try {
        var options = {
          sitekey: _this.sitekey
        };
        if (typeof _this.badge !== 'undefined') options.badge = _this.badge;
        if (typeof _this.type !== 'undefined') options.type = _this.type;
        if (typeof _this.tabindex !== 'undefined') options.tabindex = _this.dataTabidex;
        if (typeof _this.size === 'undefined') {
          options.size = 'checkbox';
          options.callback = _this.getToken;
        }

        var recaptchaDiv = document.createElement('div');
        recaptchaDiv.className = 'g-recaptcha';
        _this.$el.insertBefore(recaptchaDiv, _this.$el.childNodes[0]);
        _this.recaptchaId = window.grecaptcha.render(recaptchaDiv, options);
      } catch (e) {
        window.console.error(e);
      }
    });
  },

  methods: {
    submitData: function submitData(event) {
      event.preventDefault();
      if (typeof window === 'undefined') return;
      if (this.validate() === true || typeof this.validate === 'undefined') {
        if (typeof this.size === 'undefined') {
          window.grecaptcha.execute(this.recaptchaId);
        } else {
          this.getToken(window.grecaptcha.getResponse(this.recaptchaId));
        }
      }
    },
    getToken: function getToken(token) {
      if (typeof window === 'undefined') return;
      this.recaptchaId = token;
      this.callback(token);
    }
  }
});

/***/ }),
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 523 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 534 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 536 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 537 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 538 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 541 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 542 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 544 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 546 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 146,
	"./af.js": 146,
	"./ar": 153,
	"./ar-dz": 147,
	"./ar-dz.js": 147,
	"./ar-kw": 148,
	"./ar-kw.js": 148,
	"./ar-ly": 149,
	"./ar-ly.js": 149,
	"./ar-ma": 150,
	"./ar-ma.js": 150,
	"./ar-sa": 151,
	"./ar-sa.js": 151,
	"./ar-tn": 152,
	"./ar-tn.js": 152,
	"./ar.js": 153,
	"./az": 154,
	"./az.js": 154,
	"./be": 155,
	"./be.js": 155,
	"./bg": 156,
	"./bg.js": 156,
	"./bm": 157,
	"./bm.js": 157,
	"./bn": 159,
	"./bn-bd": 158,
	"./bn-bd.js": 158,
	"./bn.js": 159,
	"./bo": 160,
	"./bo.js": 160,
	"./br": 161,
	"./br.js": 161,
	"./bs": 162,
	"./bs.js": 162,
	"./ca": 163,
	"./ca.js": 163,
	"./cs": 164,
	"./cs.js": 164,
	"./cv": 165,
	"./cv.js": 165,
	"./cy": 166,
	"./cy.js": 166,
	"./da": 167,
	"./da.js": 167,
	"./de": 170,
	"./de-at": 168,
	"./de-at.js": 168,
	"./de-ch": 169,
	"./de-ch.js": 169,
	"./de.js": 170,
	"./dv": 171,
	"./dv.js": 171,
	"./el": 172,
	"./el.js": 172,
	"./en-au": 173,
	"./en-au.js": 173,
	"./en-ca": 174,
	"./en-ca.js": 174,
	"./en-gb": 175,
	"./en-gb.js": 175,
	"./en-ie": 176,
	"./en-ie.js": 176,
	"./en-il": 177,
	"./en-il.js": 177,
	"./en-in": 178,
	"./en-in.js": 178,
	"./en-nz": 179,
	"./en-nz.js": 179,
	"./en-sg": 180,
	"./en-sg.js": 180,
	"./eo": 181,
	"./eo.js": 181,
	"./es": 185,
	"./es-do": 182,
	"./es-do.js": 182,
	"./es-mx": 183,
	"./es-mx.js": 183,
	"./es-us": 184,
	"./es-us.js": 184,
	"./es.js": 185,
	"./et": 186,
	"./et.js": 186,
	"./eu": 187,
	"./eu.js": 187,
	"./fa": 188,
	"./fa.js": 188,
	"./fi": 189,
	"./fi.js": 189,
	"./fil": 190,
	"./fil.js": 190,
	"./fo": 191,
	"./fo.js": 191,
	"./fr": 194,
	"./fr-ca": 192,
	"./fr-ca.js": 192,
	"./fr-ch": 193,
	"./fr-ch.js": 193,
	"./fr.js": 194,
	"./fy": 195,
	"./fy.js": 195,
	"./ga": 196,
	"./ga.js": 196,
	"./gd": 197,
	"./gd.js": 197,
	"./gl": 198,
	"./gl.js": 198,
	"./gom-deva": 199,
	"./gom-deva.js": 199,
	"./gom-latn": 200,
	"./gom-latn.js": 200,
	"./gu": 201,
	"./gu.js": 201,
	"./he": 202,
	"./he.js": 202,
	"./hi": 203,
	"./hi.js": 203,
	"./hr": 204,
	"./hr.js": 204,
	"./hu": 205,
	"./hu.js": 205,
	"./hy-am": 206,
	"./hy-am.js": 206,
	"./id": 207,
	"./id.js": 207,
	"./is": 208,
	"./is.js": 208,
	"./it": 210,
	"./it-ch": 209,
	"./it-ch.js": 209,
	"./it.js": 210,
	"./ja": 211,
	"./ja.js": 211,
	"./jv": 212,
	"./jv.js": 212,
	"./ka": 213,
	"./ka.js": 213,
	"./kk": 214,
	"./kk.js": 214,
	"./km": 215,
	"./km.js": 215,
	"./kn": 216,
	"./kn.js": 216,
	"./ko": 217,
	"./ko.js": 217,
	"./ku": 218,
	"./ku.js": 218,
	"./ky": 219,
	"./ky.js": 219,
	"./lb": 220,
	"./lb.js": 220,
	"./lo": 221,
	"./lo.js": 221,
	"./lt": 222,
	"./lt.js": 222,
	"./lv": 223,
	"./lv.js": 223,
	"./me": 224,
	"./me.js": 224,
	"./mi": 225,
	"./mi.js": 225,
	"./mk": 226,
	"./mk.js": 226,
	"./ml": 227,
	"./ml.js": 227,
	"./mn": 228,
	"./mn.js": 228,
	"./mr": 229,
	"./mr.js": 229,
	"./ms": 231,
	"./ms-my": 230,
	"./ms-my.js": 230,
	"./ms.js": 231,
	"./mt": 232,
	"./mt.js": 232,
	"./my": 233,
	"./my.js": 233,
	"./nb": 234,
	"./nb.js": 234,
	"./ne": 235,
	"./ne.js": 235,
	"./nl": 237,
	"./nl-be": 236,
	"./nl-be.js": 236,
	"./nl.js": 237,
	"./nn": 238,
	"./nn.js": 238,
	"./oc-lnc": 239,
	"./oc-lnc.js": 239,
	"./pa-in": 240,
	"./pa-in.js": 240,
	"./pl": 241,
	"./pl.js": 241,
	"./pt": 243,
	"./pt-br": 242,
	"./pt-br.js": 242,
	"./pt.js": 243,
	"./ro": 244,
	"./ro.js": 244,
	"./ru": 245,
	"./ru.js": 245,
	"./sd": 246,
	"./sd.js": 246,
	"./se": 247,
	"./se.js": 247,
	"./si": 248,
	"./si.js": 248,
	"./sk": 249,
	"./sk.js": 249,
	"./sl": 250,
	"./sl.js": 250,
	"./sq": 251,
	"./sq.js": 251,
	"./sr": 253,
	"./sr-cyrl": 252,
	"./sr-cyrl.js": 252,
	"./sr.js": 253,
	"./ss": 254,
	"./ss.js": 254,
	"./sv": 255,
	"./sv.js": 255,
	"./sw": 256,
	"./sw.js": 256,
	"./ta": 257,
	"./ta.js": 257,
	"./te": 258,
	"./te.js": 258,
	"./tet": 259,
	"./tet.js": 259,
	"./tg": 260,
	"./tg.js": 260,
	"./th": 261,
	"./th.js": 261,
	"./tk": 262,
	"./tk.js": 262,
	"./tl-ph": 263,
	"./tl-ph.js": 263,
	"./tlh": 264,
	"./tlh.js": 264,
	"./tr": 265,
	"./tr.js": 265,
	"./tzl": 266,
	"./tzl.js": 266,
	"./tzm": 268,
	"./tzm-latn": 267,
	"./tzm-latn.js": 267,
	"./tzm.js": 268,
	"./ug-cn": 269,
	"./ug-cn.js": 269,
	"./uk": 270,
	"./uk.js": 270,
	"./ur": 271,
	"./ur.js": 271,
	"./uz": 273,
	"./uz-latn": 272,
	"./uz-latn.js": 272,
	"./uz.js": 273,
	"./vi": 274,
	"./vi.js": 274,
	"./x-pseudo": 275,
	"./x-pseudo.js": 275,
	"./yo": 276,
	"./yo.js": 276,
	"./zh-cn": 277,
	"./zh-cn.js": 277,
	"./zh-hk": 278,
	"./zh-hk.js": 278,
	"./zh-mo": 279,
	"./zh-mo.js": 279,
	"./zh-tw": 280,
	"./zh-tw.js": 280
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 553;

/***/ }),
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(534)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(642),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(514)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(618),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(516)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(620),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(545)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(655),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(535)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(643),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(522)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(626),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(523)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(627),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(507)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(610),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(544)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(654),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(521)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(625),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(505)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(608),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(533)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(641),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(525)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(631),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(548)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(659),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(539)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(647),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(509)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(612),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(549)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(661),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(540)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(648),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(508)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(611),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(506)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(609),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(532)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(640),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(652),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(517)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(621),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(515)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(619),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(510)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(613),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(520)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(624),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(512)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(616),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(546)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(656),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(527)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(633),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(543)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(653),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(639),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(513)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(617),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(524)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(629),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(531)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(637),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(511)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(614),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(526)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(632),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(628),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(519)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(623),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(657),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(529)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(635),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(537)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(645),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(630),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(607),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(660),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(615),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "switch-box"
  }, [_c('el-row', [_c('p', {}, [_vm._v("\n      " + _vm._s(_vm.data.label) + "\n    ")])]), _vm._v(" "), _c('el-form-item', [_c('el-switch', {
    staticStyle: {
      "--el-switch-on-color": "#13ce66",
      "--el-switch-off-color": "#ff4949"
    },
    attrs: {
      "disabled": _vm.disabled,
      "size": "",
      "active-text": "Si",
      "inactive-text": "No"
    },
    on: {
      "change": function($event) {
        return _vm.saveDataToLocalStorage(_vm.data.model, _vm.data.name)
      }
    },
    model: {
      value: (_vm.data.model),
      callback: function($$v) {
        _vm.$set(_vm.data, "model", $$v)
      },
      expression: "data.model"
    }
  })], 1), _vm._v(" "), (_vm.data.model) ? _c('el-form-item', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "label": _vm.data.companyDataPerception.label
    }
  }, [_c('el-col', {
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    class: _vm.verifyFields(_vm.data.companyDataPerception, _vm.validation) ? 'input-warning' : '',
    staticStyle: {
      "margin-left": "4%"
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": 'number'
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.data.companyDataPerception.model, _vm.data.companyDataPerception.name)
      }
    },
    model: {
      value: (_vm.data.companyDataPerception.model),
      callback: function($$v) {
        _vm.$set(_vm.data.companyDataPerception, "model", $$v)
      },
      expression: "data.companyDataPerception.model"
    }
  }), _vm._v(" "), (_vm.verifyFields(_vm.data.companyDataPerception, _vm.validation)) ? _c('el-alert', {
    staticClass: "message-warning",
    staticStyle: {
      "margin-left": "4%"
    },
    attrs: {
      "title": ("Falta completar: " + (_vm.data.companyDataPerception.label)),
      "type": "error",
      "closable": false
    }
  }) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('el-dialog', {
    attrs: {
      "title": "Cargar un Nuevo Comprobante",
      "visible": _vm.showModal,
      "width": "90%",
      "lock-scroll": false,
      "max-width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      }
    }
  }, [_c('p', [_vm._v("Datos del Documento ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Tipo Documento")])]), _vm._v(" "), _c('div', [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Tipo de documento"
    },
    model: {
      value: (_vm.nuevoDocumento.documentType),
      callback: function($$v) {
        _vm.$set(_vm.nuevoDocumento, "documentType", $$v)
      },
      expression: "nuevoDocumento.documentType"
    }
  }, _vm._l((_vm.buyOrderDocumentType), function(item) {
    return _c('el-option', {
      key: item.buyOrderDocumentType,
      attrs: {
        "value": item.idBuyOrderDocumentType,
        "label": item.description
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Código AFIP")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', [_c('el-select', {
    attrs: {
      "disabled": _vm.nuevoDocumento.documentType === '',
      "required": "",
      "placeholder": "Seleccionar "
    },
    model: {
      value: (_vm.nuevoDocumento.documentCode),
      callback: function($$v) {
        _vm.$set(_vm.nuevoDocumento, "documentCode", $$v)
      },
      expression: "nuevoDocumento.documentCode"
    }
  }, _vm._l((_vm.buyOrderDocumentTypeCode), function(item) {
    return _c('el-option', {
      key: item.idBuyOrderDocumentTypeCode,
      attrs: {
        "value": item.idBuyOrderDocumentTypeCode,
        "label": item.description
      }
    })
  }), 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Letra")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.buyOrder),
      callback: function($$v) {
        _vm.buyOrder = $$v
      },
      expression: "buyOrder"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Numero")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.buyOrder),
      callback: function($$v) {
        _vm.buyOrder = $$v
      },
      expression: "buyOrder"
    }
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.buyOrder),
      callback: function($$v) {
        _vm.buyOrder = $$v
      },
      expression: "buyOrder"
    }
  })], 1)]), _vm._v(" "), _c('p', [_vm._v("Datos CAE ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Fecha Vencimiento")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.buyOrder),
      callback: function($$v) {
        _vm.buyOrder = $$v
      },
      expression: "buyOrder"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Nª")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.buyOrder),
      callback: function($$v) {
        _vm.buyOrder = $$v
      },
      expression: "buyOrder"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("PDF (Obligatorio)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    ref: "fileBuyOrder",
    staticClass: "form-control-file",
    staticStyle: {
      "width": "80%",
      "float": "left"
    },
    attrs: {
      "type": "file",
      "accept": "application/pdf"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "6%"
    },
    attrs: {
      "type": "primary",
      "circle": "",
      "icon": "el-icon-upload"
    }
  })], 1)]), _vm._v(" "), _c('p', [_vm._v("Datos de Referencia ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("HES")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.buyOrder),
      callback: function($$v) {
        _vm.buyOrder = $$v
      },
      expression: "buyOrder"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("MIGO")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.buyOrder),
      callback: function($$v) {
        _vm.buyOrder = $$v
      },
      expression: "buyOrder"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("OC")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.buyOrder),
      callback: function($$v) {
        _vm.buyOrder = $$v
      },
      expression: "buyOrder"
    }
  })], 1)]), _vm._v(" "), _c('p', [_vm._v("Importes")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Importe Total")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.buyOrder),
      callback: function($$v) {
        _vm.buyOrder = $$v
      },
      expression: "buyOrder"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Importe Impuesto")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.buyOrder),
      callback: function($$v) {
        _vm.buyOrder = $$v
      },
      expression: "buyOrder"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Porcentaje Impuesto")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.buyOrder),
      callback: function($$v) {
        _vm.buyOrder = $$v
      },
      expression: "buyOrder"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Moneda")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.buyOrder),
      callback: function($$v) {
        _vm.buyOrder = $$v
      },
      expression: "buyOrder"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Tipo de Cambio")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.buyOrder),
      callback: function($$v) {
        _vm.buyOrder = $$v
      },
      expression: "buyOrder"
    }
  })], 1)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.saveNIC()
      }
    }
  }, [_vm._v("\n            Guardar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")])])]), _vm._v(" "), _c('h3', [_vm._v(" Panel de control ")]), _vm._v(" "), (_vm.statusList) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "'font-size": "15px",
      "text-align": "center"
    }
  }, _vm._l((_vm.statusList), function(item) {
    return _c('th', {
      key: item.idBuyOrderDocumentStatus,
      style: ('text-align: center; vertical-align: middle;width: ' + (100 / _vm.statusList.length) + '%')
    }, [_vm._v(_vm._s(item.description))])
  }), 0)]), _vm._v(" "), _c('tbody', [_c('tr', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingStatus),
      expression: "loadingStatus"
    }],
    staticStyle: {
      "font-size": "25px",
      "text-align": "center"
    }
  }, _vm._l((_vm.statusList), function(item) {
    return _c('td', {
      key: item.idBuyOrderDocumentStatus,
      staticClass: "statusHover",
      on: {
        "click": function($event) {
          return _vm.searchStatus(item.idBuyOrderDocumentStatus)
        }
      }
    }, [_vm._v(_vm._s(_vm.statusCount[item.idBuyOrderDocumentStatus]))])
  }), 0)])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.response) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Advertencia")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.response))])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('h3', [_vm._v(" Filtros ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "filter",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "xs": 24,
      "sm": 1,
      "md": 2
    }
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v(" OC ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 8,
      "md": 9
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "OC",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        _vm.filters[2].value = _vm.filtroNic
      },
      "blur": function($event) {
        _vm.filters[2].value = _vm.filtroNic
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.filters[2].value = _vm.filtroNic
      }
    },
    model: {
      value: (_vm.filtroNic),
      callback: function($$v) {
        _vm.filtroNic = $$v
      },
      expression: "filtroNic"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "filter",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "xs": 24,
      "sm": 1,
      "md": 1
    }
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v(" CUIT ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 8,
      "md": 9
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "CUIT",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        _vm.filters[3].value = _vm.filtroCuit
      },
      "blur": function($event) {
        _vm.filters[3].value = _vm.filtroCuit
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.filters[3].value = _vm.filtroCuit
      }
    },
    model: {
      value: (_vm.filtroCuit),
      callback: function($$v) {
        _vm.filtroCuit = $$v
      },
      expression: "filtroCuit"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "filter",
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "xs": 24,
      "sm": 1,
      "md": 2
    }
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v(" Estado ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 8,
      "md": 9
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "Estado",
      "multiple": ""
    },
    model: {
      value: (_vm.filters[0].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[0], "value", $$v)
      },
      expression: "filters[0].value"
    }
  }, _vm._l((_vm.statusList), function(item) {
    return _c('el-option', {
      key: item.idBuyOrderDocumentStatus,
      attrs: {
        "value": item.idBuyOrderDocumentStatus,
        "label": item.description
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "filter",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "xs": 24,
      "sm": 1,
      "md": 1
    }
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v(" Fecha ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 8,
      "md": 9
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "range-separator": "A",
      "start-placeholder": "Desde",
      "end-placeholder": "Hasta",
      "value-format": "yyyy-MM-dd",
      "unlink-panels": ""
    },
    model: {
      value: (_vm.filters[1].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[1], "value", $$v)
      },
      expression: "filters[1].value"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('h3', [_vm._v(" Resultados ")]), _vm._v(" "), _c('data-tables-server', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingBuyOrderDocuments),
      expression: "loadingBuyOrderDocuments"
    }],
    staticClass: "table-responsive",
    attrs: {
      "data": _vm.buyOrderDocuments,
      "total": _vm.totalDocuments,
      "pagination-props": {
        pageSizes: [10, 20, 30]
      },
      "filters": _vm.filters
    },
    on: {
      "query-change": _vm.getBuyOrderDocuments
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "OC"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.nic ? scope.row.nic : '-') + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "CUIT"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.cuit) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tipo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.getTypeName(scope.row.documentType)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Enviada"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.date) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Estado"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.getStatusName(scope.row.idBuyOrderDocumentStatus)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), (_vm.user.isProvider) ? _c('el-table-column', {
    attrs: {
      "label": "Info. Rechazo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.mensajeRechazo.length),
            expression: "scope.row.mensajeRechazo.length"
          }],
          attrs: {
            "icon": "el-icon-info",
            "type": "primary",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.mostrarMensajeCompleto(scope.row.mensajeRechazo)
            }
          }
        })]
      }
    }], null, false, 4043462319)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Archivo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.pdf !== '0') ? _c('a', {
          staticStyle: {
            "padding-right": "20px"
          },
          attrs: {
            "href": scope.row.pdf,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        }), _vm._v(" PDF\n            ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Acciones"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Ver operación",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-view",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.goToDetails(scope.row.idBuyOrderDocument)
            }
          }
        })], 1), _vm._v(" "), ((!_vm.user.isProvider && scope.row.idBuyOrderDocumentStatus === '2') || scope.row.idBuyOrderDocumentStatus === '4') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Orden de Pago",
            "placement": "top"
          }
        }, [((scope.row.documentType === '1' || scope.row.documentType === '3')) ? _c('el-button', {
          attrs: {
            "type": scope.row.idBuyOrderDocumentStatus === '2' ? 'primary' : 'success',
            "icon": "far fa-file-alt",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.openModalPaymentOrder(scope.row)
            }
          }
        }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (scope.row.idBuyOrderDocumentStatus === '3') ? _c('el-button', {
          attrs: {
            "icon": "el-icon-info",
            "type": "primary",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.mostrarMensajeCompleto(scope.row.documentComment)
            }
          }
        }) : _vm._e()]
      }
    }])
  }), _vm._v(" "), (!_vm.user.isProvider) ? _c('el-table-column', {
    attrs: {
      "label": "Guardar",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.idBuyOrderDocumentStatus === '1') ? [_c('el-button-group', [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Aprobar",
            "placement": "bottom-end"
          }
        }, [_c('el-button', {
          attrs: {
            "icon": "el-icon-success",
            "size": "big",
            "type": (_vm.documentosAceptados.includes(scope.row)) ? 'primary' : ''
          },
          on: {
            "click": function($event) {
              _vm.showModalAprobar = true
            }
          }
        })], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Rechazar",
            "placement": "bottom-end"
          }
        }, [_c('el-button', {
          attrs: {
            "icon": "el-icon-error",
            "size": "big",
            "type": (_vm.documentosRechazados.includes(scope.row)) ? 'primary' : ''
          },
          on: {
            "click": function($event) {
              _vm.showModalRechazar = true
            }
          }
        })], 1)], 1)] : undefined
      }
    }], null, true)
  }, [_c('template', {
    slot: "header"
  }, [_vm._v("\n              Administrar Facturas\n          ")])], 2) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.showModalAprobar,
      "title": "Confirmar acción",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalAprobar = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(" ¿Está seguro que desea aprobar esta factura? ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "2rem",
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.showModalAprobar = false
      }
    }
  }, [_vm._v("\n                Confirmar\n              ")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function () { return _vm.showModalAprobar = false; }
    }
  }, [_vm._v("\n                Cancelar\n              ")])], 1)])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.showModalRechazar,
      "title": "Confirmar acción",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalRechazar = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(" Seleccione el motivo por el que desea rechazar la factura ")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Motivo de rechazo"
    },
    model: {
      value: (_vm.nuevoDocumento.mensajeRechazo),
      callback: function($$v) {
        _vm.$set(_vm.nuevoDocumento, "mensajeRechazo", $$v)
      },
      expression: "nuevoDocumento.mensajeRechazo"
    }
  }, _vm._l((_vm.rejectReasons), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.value,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "2rem",
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.showModalRechazar = false
      }
    }
  }, [_vm._v("\n                Confirmar\n              ")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function () { return _vm.showModalRechazar = false; }
    }
  }, [_vm._v("\n                Cancelar\n              ")])], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "-10vh",
      "overflow": "hidden"
    },
    attrs: {
      "title": "Confirmar cambios",
      "visible": _vm.showModalConfirmarDocumentacion,
      "max-width": "700px",
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalConfirmarDocumentacion = $event
      },
      "close": function($event) {
        return _vm.cerrarModalConfirmarDocumentacion()
      }
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": 'Documentos aceptados (' + _vm.documentosAceptados.length + ')'
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.documentosAceptados
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Tipo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                          " + _vm._s(_vm.getTypeName(scope.row.documentType)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "date",
      "label": "Fecha"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Archivo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "padding-right": "20px"
          },
          attrs: {
            "href": scope.row.pdf,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        }), _vm._v(" PDF\n                          ")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": 'Documentos rechazados (' + _vm.documentosRechazados.length + ')'
    }
  }, [_c('el-table', {
    staticStyle: {
      "max-height": "calc("
    },
    attrs: {
      "data": _vm.documentosRechazados
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Tipo",
      "width": "130px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                          " + _vm._s(_vm.getTypeName(scope.row.documentType)) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "date",
      "label": "Fecha",
      "width": "200px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Archivo",
      "width": "90px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "padding-right": "20px"
          },
          attrs: {
            "href": scope.row.pdf,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        }), _vm._v(" PDF\n                          ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Mensaje",
      "span": 12
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "Seleccione un motivo"
          },
          model: {
            value: (scope.row.mensajeRechazo),
            callback: function($$v) {
              _vm.$set(scope.row, "mensajeRechazo", $$v)
            },
            expression: "scope.row.mensajeRechazo"
          }
        }, _vm._l((_vm.rejectReasons), function(reason) {
          return _c('el-option', {
            key: reason.value,
            attrs: {
              "label": reason.value,
              "value": reason.value
            }
          })
        }), 1)]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.cerrarModalConfirmarDocumentacion()
      }
    }
  }, [_vm._v("\n                    Cancelar\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.confirmarDocumentos()
      }
    }
  }, [_vm._v("\n                    Guardar\n                  ")])])], 1), _vm._v(" "), (_vm.buyOrderDocument) ? _c('el-dialog', {
    staticStyle: {
      "margin-top": "-10vh",
      "overflow": "hidden"
    },
    attrs: {
      "title": 'Orden de pago',
      "visible": _vm.showModalPaymentOrder,
      "width": "70%",
      "lock-scroll": false,
      "max-width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalPaymentOrder = $event
      },
      "close": function($event) {
        return _vm.resetNewPaymentOrder()
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_vm._v("Orden de Pago / Retenciones")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [(_vm.buyOrderDocument.paymentOrder && _vm.buyOrderDocument.paymentOrder.pdf) ? _c('td', [(_vm.buyOrderDocument.paymentOrder.pdf === '0') ? _c('span', [_vm._v("No se cargo un archivo")]) : _vm._e(), _vm._v(" "), (_vm.buyOrderDocument.paymentOrder.pdf !== '0') ? _c('a', {
    attrs: {
      "href": _vm.buyOrderDocument.paymentOrder.pdf,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v("  Ver")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider && (!_vm.buyOrderDocument.paymentOrder || !_vm.buyOrderDocument.paymentOrder.pdf)) ? _c('span', [_c('input', {
    ref: "filePayment",
    staticClass: "form-control-file",
    staticStyle: {
      "width": "80%",
      "float": "left"
    },
    attrs: {
      "type": "file",
      "accept": "application/pdf"
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_vm._v("Información de Pago")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('td', [(_vm.buyOrderDocument.idBuyOrderDocumentStatus === '4' && _vm.buyOrderDocument.paymentOrder) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.buyOrderDocument.paymentOrder.comment)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.buyOrderDocument.idBuyOrderDocumentStatus === '2' && !_vm.user.isProvider && !_vm.buyOrderDocument.paymentOrder) ? _c('span', [_c('vue-editor', {
    model: {
      value: (_vm.newPaymentOrder.comment),
      callback: function($$v) {
        _vm.$set(_vm.newPaymentOrder, "comment", $$v)
      },
      expression: "newPaymentOrder.comment"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.buyOrderDocument.paymentOrder) ? _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.hideModalPaymentOrder()
      }
    }
  }, [_vm._v("\n                    Cancelar\n                  ")]) : _vm._e(), _vm._v(" "), (!_vm.buyOrderDocument.paymentOrder) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.uploadPayment()
      }
    }
  }, [_vm._v("\n                    Guardar\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.buyOrderDocument.paymentOrder) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.hideModalPaymentOrder()
      }
    }
  }, [_vm._v("\n                    Aceptar\n                  ")]) : _vm._e()])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
}]}

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row col-md-12 entrada"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" Alias ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Nombre"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" Email ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Apellido"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" Email ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Email"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row col-md-12 entrada"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" Compañia ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Telefono"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" Estado ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-radio-group', [_c('el-radio-button', {
    attrs: {
      "label": "prospective"
    }
  }, [_vm._v("Solicitado")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "inactive"
    }
  }, [_vm._v("Inactivo")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "active"
    }
  }, [_vm._v("Activo")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "inactive"
    }
  }, [_vm._v("Rechazado")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "inactive"
    }
  }, [_vm._v("Supendido")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "inactive"
    }
  }, [_vm._v("Sin Acción")])], 1)], 1)]), _vm._v(" "), _vm._m(1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Contacto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 entrada",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("Guardar"), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary"
  }, [_vm._v("Cancelar")])])])
}]}

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLoading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticStyle: {
      "height": "100vh",
      "width": "100vw",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    }
  }) : (!_vm.availableCountries.some(function (country) { return country.codCountry === 'AR'; })) ? _c('div', [_c('error404')], 1) : _c('div', [_c('el-dialog', {
    attrs: {
      "title": "Certificado de exclusión: Retención Ganancias",
      "visible": _vm.showModalCertificationExgain,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationExgain = false
      }
    }
  }, [(this.certificationExgain[0]) ? _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticClass: "tg",
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "222px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0lax"
  }, [_vm._v("Certificado:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].number))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-j58y"
  }, [_vm._v("Cuit:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].cuit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Período fiscal:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].period))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Porcentaje:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].percentage))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Resolución:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].resolution))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Estado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].state))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Fecha de Publicación:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("\n                " + _vm._s(_vm.certificationExgain[0].publication) + "\n              ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Fecha de Vigencia:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].validity))])])])])], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationExgain
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Lista de certificados de exclusión: Retención Ganancias",
      "visible": _vm.showModalCertificationsExgainList,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationsExgainList = false
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "140px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "140px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "135px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "20px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Nro Certificado:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de emisión:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de vigencia:")])]), _vm._v(" "), _vm._l((_vm.certificationExgainList), function(item) {
    return _c('tr', {
      key: item.IdCertificationExGain
    }, [_c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.publication))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.validity))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4B"
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary",
        "plain": "",
        "icon": "el-icon-view"
      },
      on: {
        "click": function($event) {
          return _vm.getCertificationExgain(item.IdCertificationExGain)
        }
      }
    })], 1)])
  })], 2)])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationsExgainList
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Certificado de exención: RG2681",
      "visible": _vm.showModalCertificationRg2681,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationRg2681 = false
      }
    }
  }, [(this.certificationRg2681[0]) ? _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticClass: "tg",
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "222px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0lax"
  }, [_vm._v("Cuit:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].cuit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Tipo de sujeto:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].type))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Cod. Estado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].state))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Desc. Estado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("\n                " + _vm._s(_vm.certificationRg2681[0].stateDescription) + "\n              ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Fecha de Emisión del Certificado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].emision))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Fecha Adm. Formal:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("\n                " + _vm._s(_vm.certificationRg2681[0].administrationDate) + "\n              ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Autoriza Deducción:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].auth))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Obligado Pres. DDJJ:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].ddjj))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Código Inciso:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].subsection))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Vigencia desde:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].since))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Vigencia hasta:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].until))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Nro Certificado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].number))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Por orden judicial:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].orderJud))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Fecha última modificación:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("\n                " + _vm._s(_vm.certificationRg2681[0].modificationDate) + "\n              ")])])])])], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationRg2681
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Datos adicionales del certificado",
      "visible": _vm.showModalCertificationDatosAdicionales,
      "width": "30%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationDatosAdicionales = false
      }
    }
  }, [(_vm.taxData.jurisdictions[_vm.activeJurisdiction]) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "Seleccionar"
    },
    model: {
      value: (_vm.taxData.jurisdictions[_vm.activeJurisdiction].certificateFrom),
      callback: function($$v) {
        _vm.$set(_vm.taxData.jurisdictions[_vm.activeJurisdiction], "certificateFrom", $$v)
      },
      expression: "taxData.jurisdictions[activeJurisdiction].certificateFrom"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.disabledDates,
      "type": "date",
      "placeholder": "Seleccionar"
    },
    model: {
      value: (_vm.taxData.jurisdictions[_vm.activeJurisdiction].certificateTo),
      callback: function($$v) {
        _vm.$set(_vm.taxData.jurisdictions[_vm.activeJurisdiction], "certificateTo", $$v)
      },
      expression: "taxData.jurisdictions[activeJurisdiction].certificateTo"
    }
  })], 1), _vm._v(" "), _c('div', [_c('el-upload', {
    ref: 'jurisdictions\[' + _vm.jurId + '\]\[\'certificatePdf\'\]',
    staticClass: "upload-demo",
    attrs: {
      "id": "uploadCertificatePdf",
      "action": _vm.serverURI + 'api/uploadFile',
      "auto-upload": true,
      "accept": "application/pdf",
      "on-success": _vm.handlePdfCertificate,
      "on-exceed": _vm.handleExceed,
      "data": {
        folder: 'altaProveedor',
      },
      "limit": 1
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("Seleccionar archivo")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("\n            Solo se permiten archivos PDF\n          ")])], 1), _vm._v(" "), _c('span', [(_vm.taxData.jurisdictions[_vm.activeJurisdiction].certificatePdf) ? _c('a', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "href": _vm.taxData.jurisdictions[_vm.activeJurisdiction].certificatePdf,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" Ver\n          ")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showModalCertificationDatosAdicionales = false
      }
    }
  }, [_vm._v("Confirmar")])], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Formulario 1276",
      "visible": _vm.showModalForm1276,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalForm1276 = false
      }
    }
  }, [(_vm.taxData.jurisdictions[_vm.activeJurisdiction]) ? _c('div', [_c('div', [_c('el-upload', {
    ref: 'jurisdictions\[' + _vm.jurId + '\]\[\'form1276pdf\'\]',
    staticClass: "upload-demo",
    attrs: {
      "id": "uploadForm1276",
      "action": _vm.serverURI + 'api/uploadFile',
      "auto-upload": true,
      "accept": "application/pdf",
      "on-success": _vm.handlePdfForm1276,
      "on-exceed": _vm.handleExceed,
      "data": {
        folder: 'altaProveedor',
      },
      "limit": 1
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("Seleccionar archivo")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("\n            Solo se permiten archivos PDF\n          ")])], 1), _vm._v(" "), _c('span', [(_vm.taxData.jurisdictions[_vm.activeJurisdiction].form1276pdf) ? _c('a', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "href": _vm.taxData.jurisdictions[_vm.activeJurisdiction].form1276pdf,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" Ver\n          ")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showModalForm1276 = false
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveJurisdiction.apply(null, arguments)
      }
    }
  }, [_vm._v("Confirmar")])], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Lista de certificados de exención: RG2681",
      "visible": _vm.showModalCertificationRg2681List,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationRg2681List = false
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "140px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "140px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "135px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "20px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Nro Certificado:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de emisión:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de vigencia:")])]), _vm._v(" "), _vm._l((_vm.certificationRg2681List), function(item) {
    return _c('tr', {
      key: item.idCertificationRG2681
    }, [_c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.emision))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.until))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4B"
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary",
        "plain": "",
        "icon": "el-icon-view"
      },
      on: {
        "click": function($event) {
          return _vm.getCertificationRg2681(item.idCertificationRG2681)
        }
      }
    })], 1)])
  })], 2)])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationsRg2681List
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Certificado de exclusión: Retención SUSS",
      "visible": _vm.showModalCertificationSuss,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationSuss = false
      }
    }
  }, [(this.certificationSuss[0]) ? _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticClass: "tg",
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "222px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0lax"
  }, [_vm._v("Certificado:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].number))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-j58y"
  }, [_vm._v("Cuit:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].cuit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Período fiscal:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].period))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Porcentaje:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].percentage))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Resolución:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].resolution))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Estado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].state))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Fecha de Publicación:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].since))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Fecha de Vigencia:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].until))])])])])], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationSuss
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Lista de certificados de exclusión: SUSS",
      "visible": _vm.showModalCertificationSussList,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationSussList = false
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "140px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "140px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "135px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "20px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Nro Certificado:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de emisión:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de vigencia:")])]), _vm._v(" "), _vm._l((_vm.certificationSussList), function(item) {
    return _c('tr', {
      key: item.idCertificaction
    }, [_c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.since))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.until))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4B"
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary",
        "plain": "",
        "icon": "el-icon-view"
      },
      on: {
        "click": function($event) {
          return _vm.getCertificationSuss(item.idCertificaction)
        }
      }
    })], 1)])
  })], 2)])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationsSussList
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Certificado de agente de retención RG18: Retención I.V.A",
      "visible": _vm.showModalCertificationRg18,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationRg18 = false
      }
    }
  }, [(this.certificationRg18[0]) ? _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticClass: "tg",
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "222px"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-j58y"
  }, [_vm._v("Cuit:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg18[0].cuit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Razón Social:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg18[0].name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("INCISO RG:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg18[0].type))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Fecha de Publicación:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg18[0].since))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Fecha de Vigencia:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg18[0].until))])])])])], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationRg18
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Lista de agente de retención: RG18",
      "visible": _vm.showModalCertificationRg18List,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationRg18List = false
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "150px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de emisión:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de vigencia:")])]), _vm._v(" "), _vm._l((_vm.certificationRg18List), function(item) {
    return _c('tr', {
      key: item.idCertificationRG18
    }, [_c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.since))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.until))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4B"
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary",
        "plain": "",
        "icon": "el-icon-view"
      },
      on: {
        "click": function($event) {
          return _vm.getCertificationRg18(item.idCertificationRG18)
        }
      }
    })], 1)])
  })], 2)])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationsRg18List
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Certificado de exclusión RG17: Retención I.V.A",
      "visible": _vm.showModalCertificationRg17,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationRg17 = false
      }
    }
  }, [(this.certificationRg17[0]) ? _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticClass: "tg",
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "222px"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-j58y"
  }, [_vm._v("Cuit:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].cuit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Razón Social:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Porcentaje:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].percentage))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("INCISO RG:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].rg))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Tipo de Certificado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].type))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Fecha de Publicación:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].since))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Fecha de Vigencia:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].until))])])])])], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationRg17
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Lista de certificados de exclusión: RG17",
      "visible": _vm.showModalCertificationRg17List,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationRg17List = false
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "150px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de emisión:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de vigencia:")])]), _vm._v(" "), _vm._l((_vm.certificationRg17List), function(item) {
    return _c('tr', {
      key: item.idCertificationRG17
    }, [_c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.since))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.until))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4B"
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary",
        "plain": "",
        "icon": "el-icon-view"
      },
      on: {
        "click": function($event) {
          return _vm.getCertificationRg17(item.idCertificationRG17)
        }
      }
    })], 1)])
  })], 2)])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationsRg17List
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "-12vh",
      "height": "auto",
      "overflow-y": "hidden"
    },
    attrs: {
      "title": "Confirmar Alta de Proveedor",
      "visible": _vm.terminosYCondVisible,
      "width": "80%",
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.terminosYCondVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "60vh",
      "overflow": "auto"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.configuration))]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', [_c('div', [_vm._v("\n        ¿Usted, la sociedad, algún accionista, funcionario, Director, agente, afiliado o empleado clave de su Compañía es PEP, empleado o está asociado actualmente a un Funcionario Público?\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px",
      "margin-top": "10px"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Si",
      "size": "small",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.associatedPEP),
      callback: function($$v) {
        _vm.associatedPEP = $$v
      },
      expression: "associatedPEP"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v("\n          ¿Interactuará usted o, en caso de corresponder, su Compañía con una entidad gubernamental en nombre de cualquiera de las empresas del Grupo Albanesi?\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "40px",
      "margin-top": "15px"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Si",
      "size": "small",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.govInteraction),
      callback: function($$v) {
        _vm.govInteraction = $$v
      },
      expression: "govInteraction"
    }
  })], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked2),
      expression: "checked2"
    }],
    staticStyle: {
      "width": "15px",
      "float": "left",
      "margin-right": "5px"
    },
    attrs: {
      "type": "checkbox",
      "name": "aceptoCodigoEtica",
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.checked2) ? _vm._i(_vm.checked2, null) > -1 : (_vm.checked2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checked2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checked2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked2 = $$c
        }
      }
    }
  }), _vm._v("\n        Acepto el\n        "), _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.codigoEtica
    }
  }, [_vm._v("Código de Ética y Conducta")]), _vm._v(".\n      ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    staticStyle: {
      "width": "15px",
      "float": "left",
      "margin-right": "5px"
    },
    attrs: {
      "type": "checkbox",
      "name": "aceptoTerminos",
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, null) > -1 : (_vm.checked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked = $$c
        }
      }
    }
  }), _vm._v("\n        Acepto las políticas:\n        "), _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.politicaAnticorrupcion
    }
  }, [_vm._v("Política Anticorrupción")]), _vm._v("\n        y\n        "), _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.politicaRelacionamiento
    }
  }, [_vm._v("Política de Relacionamiento con Funcionarios Públicos.")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    staticStyle: {
      "position": "relative",
      "left": "45%"
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.checked2 || !_vm.checked
    },
    on: {
      "click": function($event) {
        return _vm.submitFormSolicitud()
      }
    }
  }, [_vm._v("\n          Aceptar\n        ")])])])]), _vm._v(" "), (!_vm.paramError && !_vm.provider) ? _c('h1', {
    staticClass: "text-center"
  }, [_vm._v("\n    SOLICITAR SER PROVEEDOR\n  ")]) : _vm._e(), _vm._v(" "), (!_vm.paramError && !_vm.provider) ? _c('p', {
    staticClass: "text-center"
  }, [_vm._v("\n    Complete el formulario\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('el-button', {
    staticStyle: {
      "display": "inline-block",
      "float": "right",
      "transition": "all 1s",
      "margin-right": "30px",
      "margin-top": "20px"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-left"
  }), _vm._v("\n      Volver\n    ")])], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [(_vm.paramError) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Advertencia")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.paramError))])])])])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('el-steps', {
    attrs: {
      "active": _vm.step,
      "finish-status": "success",
      "align-center": ""
    }
  }, [_c('el-step', {
    attrs: {
      "title": "Datos Generales"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "Datos Bancarios"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "Datos Impositivos"
    }
  }), _vm._v(" "), (!_vm.provider) ? _c('el-step', {
    attrs: {
      "title": "Usuario"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (!_vm.paramError) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [(_vm.step === 0) ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Datos Generales")]) : _vm._e(), _vm._v(" "), (_vm.provider.generalData) ? _c('span', [(_vm.step === 0) ? _c('h5', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "-3%"
    }
  }, [_vm._v("\n                Ultima modificación: " + _vm._s(_vm.provider.generalData.modifDate) + "\n              ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.step === 1) ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Datos de Pago")]) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Datos Impositivos")]) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Usuario")]) : _vm._e()]), _vm._v(" "), (
    _vm.user &&
    _vm.user.isProvider &&
    _vm.provider &&
    _vm.provider[_vm.activeTab()].idCompanyDataStatus ===
    _vm.status.ESPERANDO_CONFIRMACION
  ) ? _c('el-alert', {
    attrs: {
      "title": "Etapa en verificacion",
      "type": "warning",
      "description": "Los datos de esta etapa estan siendo verificados.",
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), (
    (_vm.user &&
      _vm.user.isProvider &&
      _vm.provider &&
      _vm.provider[_vm.activeTab()].idCompanyDataStatus === _vm.status.ACEPTADO) ||
    (_vm.user &&
      !_vm.user.isProvider &&
      _vm.provider &&
      _vm.provider[_vm.activeTab()].idCompanyDataStatus === _vm.status.ESPERANDO_CONFIRMACION)
  ) ? _c('div', {
    staticClass: "col-md-12"
  }, [(!_vm.editing) ? _c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.editData
    }
  }, [_vm._v("Editar")]) : _c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("Guardar")]), _vm._v(" "), (_vm.editing === true) ? _c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.cancelData
    }
  }, [_vm._v("Cancelar")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.providerLoaded && this.user && this.idCompany),
      expression: "!providerLoaded && this.user && this.idCompany"
    }],
    staticClass: "box-body"
  }, [_c('el-col', {
    staticStyle: {
      "width": "80%",
      "margin-left": "10%"
    }
  }, [(_vm.provider && false) ? _c('el-row', {
    staticStyle: {
      "height": "90px",
      "padding-top": "20px",
      "text-align": "right"
    }
  }, [_c('el-tag', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "effect": "dark",
      "type": _vm.statusType
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.getStatusNameOfTab()) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.step === 0) ? _c('el-form', {
    ref: "generalDataForm",
    attrs: {
      "model": _vm.generalData,
      "disabled": _vm.disabledData,
      "rules": _vm.rulesGeneralData,
      "label-position": "left",
      "label-width": "25%",
      "id": "formDatosGenerales"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "info-box-content"
  }, [_c('p', {
    staticClass: "text-danger"
  }, [_vm._v("\n                    Los campos acompañados con asterisco(*) son obligatorios.\n                  ")])]), _vm._v(" "), _c('el-divider', [_vm._v("Datos de la empresa.")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "CUIT (sin guiones)",
      "prop": "cuit"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "id": "cuit",
      "type": "text",
      "maxlength": "11",
      "show-word-limit": "",
      "disabled": _vm.dataAfip !== ''
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.cuit, 'cuit')
      }
    },
    model: {
      value: (_vm.generalData.cuit),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "cuit", _vm._n($$v))
      },
      expression: "generalData.cuit"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16,
      "align": "center"
    }
  }, [(!_vm.dataAfip) ? _c('el-button', {
    attrs: {
      "id": "verificarAFIP",
      "size": "mini",
      "disabled": _vm.generalData.cuit.toString().length !== 11,
      "type": "primary"
    },
    on: {
      "click": _vm.verifyCuit
    }
  }, [_vm._v("\n                      Verificar AFIP\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.dataAfip && !this.provider) ? _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "warning"
    },
    on: {
      "click": _vm.editCuit
    }
  }, [_vm._v("\n                      Editar\n                    ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dataAfip),
      expression: "dataAfip"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "Razón Social / Denominación",
      "prop": "company"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "255",
      "data-cy": "input-company"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.company, 'company')
      }
    },
    model: {
      value: (_vm.generalData.company),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "company", $$v)
      },
      expression: "generalData.company"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nombre de Fantasía",
      "prop": "companyName"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "255",
      "data-cy": "input-fantasyName"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.companyName, 'companyName')
      }
    },
    model: {
      value: (_vm.generalData.companyName),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "companyName", $$v)
      },
      expression: "generalData.companyName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Fecha de inicio de Actividades",
      "prop": "start_date"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "Inicio de Actividades"
    },
    on: {
      "change": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.start_date, 'start_date')
      }
    },
    model: {
      value: (_vm.generalData.start_date),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "start_date", $$v)
      },
      expression: "generalData.start_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "¿En qué central prestará el servicio?",
      "prop": "centrales"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "centrales",
      "multiple": "",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.centrales, 'centrales')
      }
    },
    model: {
      value: (_vm.generalData.centrales),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "centrales", $$v)
      },
      expression: "generalData.centrales"
    }
  }, _vm._l((_vm.centrales), function(item) {
    return _c('el-option', {
      key: item.idCentral,
      attrs: {
        "label": item.central,
        "value": item.idCentral
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Servicio / Actividad",
      "prop": "rubros"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "filterable": "",
      "clearable": "",
      "data-cy": "input-rubros"
    },
    on: {
      "change": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.rubros, 'rubros')
      }
    },
    model: {
      value: (_vm.generalData.rubros),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "rubros", $$v)
      },
      expression: "generalData.rubros"
    }
  }, _vm._l((_vm.services), function(item) {
    return _c('el-option', {
      key: item.idRubro,
      attrs: {
        "label": item.nombre,
        "value": item.idRubro
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "Calle",
      "prop": "address"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 19
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100",
      "data-cy": "input-address"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.address, 'address')
      }
    },
    model: {
      value: (_vm.generalData.address),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "address", $$v)
      },
      expression: "generalData.address"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "label": "Nº",
      "prop": "addressNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "200",
      "data-cy": "input-addressNumber"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.addressNumber, 'addressNumber')
      }
    },
    model: {
      value: (_vm.generalData.addressNumber),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "addressNumber", $$v)
      },
      expression: "generalData.addressNumber"
    }
  })], 1)], 1), _vm._v(" "), (_vm.provider.generalData) ? _c('span', [(
    _vm.provider.logCompanyGeneralData &&
    (_vm.provider.generalData.address !=
      _vm.provider.logCompanyGeneralData.address ||
      _vm.provider.generalData.addressNumber !=
      _vm.provider.logCompanyGeneralData
      .addressNumber)
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Código Postal",
      "prop": "zipCode"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "type": "text",
      "maxlength": "20",
      "data-cy": "input-zipCode"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.zipCode, 'zipCode')
      }
    },
    model: {
      value: (_vm.generalData.zipCode),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "zipCode", $$v)
      },
      expression: "generalData.zipCode"
    }
  })], 1), _vm._v(" "), (_vm.provider.generalData) ? _c('span', [(
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.zipCode !=
    _vm.provider.logCompanyGeneralData.zipCode
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                              Campo\n                              "), _vm._v("modificado\n                            ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "País",
      "prop": "idCountry"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "country",
      "filterable": "",
      "clearable": "",
      "data-cy": "input-country"
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.idCountry, 'idCountry')
      },
      "change": _vm.updateProvinces
    },
    model: {
      value: (_vm.generalData.idCountry),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "idCountry", $$v)
      },
      expression: "generalData.idCountry"
    }
  }, _vm._l((_vm.countries), function(item) {
    return _c('el-option', {
      key: item.idCountry,
      attrs: {
        "label": item.country,
        "value": item.idCountry
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.idCountry !=
    _vm.provider.logCompanyGeneralData.idCountry
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                              Campo\n                              "), _vm._v("modificado\n                            ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Provincia",
      "prop": "idProvince"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "state",
      "disabled": _vm.generalData.idCountry === '',
      "filterable": "",
      "clearable": "",
      "data-cy": "input-province"
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.idProvince, 'idProvince')
      }
    },
    model: {
      value: (_vm.generalData.idProvince),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "idProvince", $$v)
      },
      expression: "generalData.idProvince"
    }
  }, _vm._l((_vm.provinces), function(item) {
    return _c('el-option', {
      key: item.idProvince,
      attrs: {
        "label": item.province,
        "value": item.idProvince
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.idProvince !=
    _vm.provider.logCompanyGeneralData.idProvince
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Ciudad",
      "prop": "city"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "data-cy": "input-city",
      "maxlength": "100"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.city, 'city')
      }
    },
    model: {
      value: (_vm.generalData.city),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "city", $$v)
      },
      expression: "generalData.city"
    }
  })], 1), _vm._v(" "), (_vm.provider.generalData) ? _c('span', [(
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.city !=
    _vm.provider.logCompanyGeneralData.city
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                              Campo\n                              "), _vm._v("modificado\n                            ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "E-mail aviso de Pago",
      "prop": "paymentEmail"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100",
      "data-cy": "input-paymentEmail"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.paymentEmail, 'paymentEmail')
      }
    },
    model: {
      value: (_vm.generalData.paymentEmail),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "paymentEmail", $$v)
      },
      expression: "generalData.paymentEmail"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.paymentEmail !=
    _vm.provider.logCompanyGeneralData.paymentEmail
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "E-mail aviso de Recepción",
      "prop": "receiptEmail"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100",
      "data-cy": "input-receiptEmail"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.receiptEmail, 'receiptEmail')
      }
    },
    model: {
      value: (_vm.generalData.receiptEmail),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "receiptEmail", $$v)
      },
      expression: "generalData.receiptEmail"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.receiptEmail !=
    _vm.provider.logCompanyGeneralData.receiptEmail
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sujeto IVA",
      "prop": "typeIVA"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "sujeto",
      "filterable": "",
      "clearable": "",
      "data-cy": "input-typeIVA"
    },
    on: {
      "change": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.typeIVA, 'typeIVA')
      }
    },
    model: {
      value: (_vm.generalData.typeIVA),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "typeIVA", $$v)
      },
      expression: "generalData.typeIVA"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "IVA Responsable Inscripto",
      "value": "01"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IVA Responsable no Inscripto",
      "value": "02"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IVA No Responsable",
      "value": "03"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IVA Sujeto a exención",
      "value": "04"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IVA consumidor final",
      "value": "05"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Responsable Monotributo Bienes",
      "value": "06"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Responsable Monotributo Servicios",
      "value": "006"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Sujeto no Categorizado",
      "value": "07"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Proveedor del exterior",
      "value": "08"
    }
  })], 1)], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.typeIVA !=
    _vm.provider.logCompanyGeneralData.typeIVA
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                              Campo\n                              "), _vm._v("modificado\n                            ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Persona",
      "prop": "personType"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "persona",
      "filterable": "",
      "clearable": "",
      "data-cy": "input-personType"
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.personType, 'personType')
      },
      "change": function($event) {
        _vm.generalData.personSubType = ''
      }
    },
    model: {
      value: (_vm.generalData.personType),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "personType", $$v)
      },
      expression: "generalData.personType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Física",
      "value": "Física"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Jurídica",
      "value": "Jurídica"
    }
  })], 1)], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.personType !=
    _vm.provider.logCompanyGeneralData.personType
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                              Campo\n                              "), _vm._v("modificado\n                            ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.generalData.personType === 'Jurídica') ? _c('el-form-item', {
    attrs: {
      "label": "Subtipo",
      "prop": "personSubType"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "data-cy": "input-personSubType"
    },
    on: {
      "change": function($event) {
        _vm.generalData.personSubTypeOther = ''
      },
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.personSubType, 'personSubType')
      }
    },
    model: {
      value: (_vm.generalData.personSubType),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "personSubType", $$v)
      },
      expression: "generalData.personSubType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "S.A.",
      "value": "S.A."
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "S.R.L.",
      "value": "S.R.L."
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "S.H.",
      "value": "S.H."
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Otro",
      "value": "Otro"
    }
  })], 1)], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.personSubType !=
    _vm.provider.logCompanyGeneralData.personSubType
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                              Campo\n                              "), _vm._v("modificado\n                            ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.generalData.personSubType === 'Otro') ? _c('el-form-item', [_c('el-form-item', {
    attrs: {
      "label": "Otro subtipo",
      "prop": "personSubTypeOther"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.personSubTypeOther),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "personSubTypeOther", $$v)
      },
      expression: "generalData.personSubTypeOther"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.personSubTypeOther !=
    _vm.provider.logCompanyGeneralData
    .personSubTypeOther
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                                Campo\n                                "), _vm._v("modificado\n                              ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.generalData.pdfAfip,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "* Alta en AFIP actualizada a la fecha",
      "id": "altadeAfip",
      "prop": "pdfAfip"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.generalData, "pdfAfip", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.generalData, "pdfAfip", $event)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_vm._v("Contacto principal")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nombre",
      "prop": "namePrincipalContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100",
      "data-cy": "input-namePrincipalContact"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.namePrincipalContact, 'namePrincipalContact')
      }
    },
    model: {
      value: (_vm.generalData.namePrincipalContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "namePrincipalContact", $$v)
      },
      expression: "generalData.namePrincipalContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.namePrincipalContact !=
    _vm.provider.logCompanyGeneralData
    .namePrincipalContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Apellido",
      "prop": "surnamePrincipalContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100",
      "data-cy": "input-surnamePrincipalContact"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.surnamePrincipalContact, 'surnamePrincipalContact')
      }
    },
    model: {
      value: (_vm.generalData.surnamePrincipalContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "surnamePrincipalContact", $$v)
      },
      expression: "generalData.surnamePrincipalContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.surnamePrincipalContact !=
    _vm.provider.logCompanyGeneralData
    .surnamePrincipalContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Teléfono",
      "prop": "phonePrincipalContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100",
      "data-cy": "input-phonePrincipalContact"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.phonePrincipalContact, 'phonePrincipalContact')
      }
    },
    model: {
      value: (_vm.generalData.phonePrincipalContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "phonePrincipalContact", $$v)
      },
      expression: "generalData.phonePrincipalContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.phonePrincipalContact !=
    _vm.provider.logCompanyGeneralData
    .phonePrincipalContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "E-mail",
      "prop": "emailPrincipalContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100",
      "data-cy": "input-emailPrincipalContact"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.emailPrincipalContact, 'emailPrincipalContact')
      }
    },
    model: {
      value: (_vm.generalData.emailPrincipalContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "emailPrincipalContact", $$v)
      },
      expression: "generalData.emailPrincipalContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.emailPrincipalContact !=
    _vm.provider.logCompanyGeneralData
    .emailPrincipalContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_vm._v("Contacto comercial")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nombre",
      "prop": "nameCommercialContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100",
      "data-cy": "input-nameCommercialContact"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.nameCommercialContact, 'nameCommercialContact')
      }
    },
    model: {
      value: (_vm.generalData.nameCommercialContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "nameCommercialContact", $$v)
      },
      expression: "generalData.nameCommercialContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.nameCommercialContact !=
    _vm.provider.logCompanyGeneralData
    .nameCommercialContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Apellido",
      "prop": "surnameCommercialContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100",
      "data-cy": "input-surnameCommercialContact"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.surnameCommercialContact, 'surnameCommercialContact')
      }
    },
    model: {
      value: (_vm.generalData.surnameCommercialContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "surnameCommercialContact", $$v)
      },
      expression: "generalData.surnameCommercialContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.surnameCommercialContact !=
    _vm.provider.logCompanyGeneralData
    .surnameCommercialContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Teléfono",
      "prop": "phoneCommercialContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100",
      "data-cy": "input-phoneCommercialContact"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.phoneCommercialContact, 'phoneCommercialContact')
      }
    },
    model: {
      value: (_vm.generalData.phoneCommercialContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "phoneCommercialContact", $$v)
      },
      expression: "generalData.phoneCommercialContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.phoneCommercialContact !=
    _vm.provider.logCompanyGeneralData
    .phoneCommercialContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "E-mail",
      "prop": "emailCommercialContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100",
      "data-cy": "input-emailCommercialContact"
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.emailCommercialContact, 'emailCommercialContact')
      }
    },
    model: {
      value: (_vm.generalData.emailCommercialContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "emailCommercialContact", $$v)
      },
      expression: "generalData.emailCommercialContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.emailCommercialContact !=
    _vm.provider.logCompanyGeneralData
    .emailCommercialContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('br')], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.step === 1) ? _c('el-form', {
    ref: "paymentDataForm",
    attrs: {
      "model": _vm.paymentData,
      "disabled": _vm.disabledData,
      "rules": _vm.rulesPaymentData,
      "label-position": "left",
      "label-width": "25%",
      "id": "formDatosPagos"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(false) ? _c('div', [_c('el-divider', [_vm._v("Cheque")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sucursal de retiro",
      "prop": "idBankBranch"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.paymentData.idBankBranch),
      callback: function($$v) {
        _vm.$set(_vm.paymentData, "idBankBranch", $$v)
      },
      expression: "paymentData.idBankBranch"
    }
  }, _vm._l((_vm.bankBranches), function(item) {
    return _c('el-option', {
      key: item.idBankBranch,
      attrs: {
        "label": item.bankBranch,
        "value": item.idBankBranch
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.paymentData &&
    _vm.provider.logCompanyPaymentData &&
    _vm.provider.paymentData.idBankBranch !=
    _vm.provider.logCompanyPaymentData.idBankBranch
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-divider', [_vm._v("Transferencia")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Banco",
      "prop": "idBank"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "bank",
      "filterable": "",
      "clearable": "",
      "data-cy": "input-idBank"
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.paymentData.idBank, 'idBank')
      }
    },
    model: {
      value: (_vm.paymentData.idBank),
      callback: function($$v) {
        _vm.$set(_vm.paymentData, "idBank", $$v)
      },
      expression: "paymentData.idBank"
    }
  }, _vm._l((_vm.banks), function(item) {
    return _c('el-option', {
      key: item.idBank,
      attrs: {
        "label": item.bank,
        "value": item.idBank
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.paymentData &&
    _vm.provider.logCompanyPaymentData &&
    _vm.provider.paymentData.idBank !=
    _vm.provider.logCompanyPaymentData.idBank
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tipo de cuenta",
      "prop": "idBankAccountType"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "accounttype",
      "filterable": "",
      "clearable": "",
      "data-cy": "input-idBankAccountType"
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.paymentData.idBankAccountType, 'idBankAccountType')
      }
    },
    model: {
      value: (_vm.paymentData.idBankAccountType),
      callback: function($$v) {
        _vm.$set(_vm.paymentData, "idBankAccountType", $$v)
      },
      expression: "paymentData.idBankAccountType"
    }
  }, _vm._l((_vm.accountTypes), function(item) {
    return _c('el-option', {
      key: item.idBankAccountType,
      attrs: {
        "label": item.bankAccountType,
        "value": item.idBankAccountType
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.paymentData &&
    _vm.provider.logCompanyPaymentData &&
    _vm.provider.paymentData.idBankAccountType !=
    _vm.provider.logCompanyPaymentData.idBankAccountType
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nro. de cuenta",
      "prop": "accountNumber"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 15
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "id": "accountnumber",
      "maxlength": "50",
      "data-cy": "input-accountNumber"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.paymentData.accountNumber, 'accountNumber')
      }
    },
    model: {
      value: (_vm.paymentData.accountNumber),
      callback: function($$v) {
        _vm.$set(_vm.paymentData, "accountNumber", $$v)
      },
      expression: "paymentData.accountNumber"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.paymentData &&
    _vm.provider.logCompanyPaymentData &&
    _vm.provider.paymentData.accountNumber !=
    _vm.provider.logCompanyPaymentData.accountNumber
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nro. CBU",
      "prop": "cbu"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 15
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "id": "nrocbu",
      "maxlength": "22",
      "show-word-limit": "",
      "data-cy": "input-cbu"
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.paymentData.cbu, 'cbu')
      }
    },
    model: {
      value: (_vm.paymentData.cbu),
      callback: function($$v) {
        _vm.$set(_vm.paymentData, "cbu", $$v)
      },
      expression: "paymentData.cbu"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.paymentData &&
    _vm.provider.logCompanyPaymentData &&
    _vm.provider.paymentData.cbu !=
    _vm.provider.logCompanyPaymentData.cbu
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.paymentData.pdfBank,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "* Constancia",
      "id": "formPdfBank",
      "prop": "pdfBank"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.paymentData, "pdfBank", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.paymentData, "pdfBank", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('el-form', {
    ref: "taxDataForm",
    attrs: {
      "model": _vm.taxData,
      "disabled": _vm.disabledData,
      "rules": _vm.rulesTaxData,
      "label-position": "left",
      "label-width": "25%",
      "id": "formDatosImpositivosIb"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-divider', [_vm._v("Ingresos Brutos")]), _vm._v(" "), _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.pdfIb,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "* Constancia IB actualizada a la fecha",
      "id": "formIB",
      "prop": "pdfIb"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "pdfIb", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "pdfIb", $event)
      }
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tipo",
      "prop": "ibType"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "typeib",
      "clearable": "",
      "data-cy": "input-typeib"
    },
    on: {
      "change": _vm.handleIbType,
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.ibType, 'ibType')
      }
    },
    model: {
      value: (_vm.taxData.ibType),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ibType", $$v)
      },
      expression: "taxData.ibType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Multilateral",
      "value": "Multilateral"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Local",
      "value": "Local"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Exento",
      "value": "Exento"
    }
  })], 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ibType !=
    _vm.provider.logCompanyTaxData.ibType
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.taxData.ibType === 'Exento') ? _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.pdfsExempt,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "* Constancia de exento",
      "id": "uploadConstanciaExcento",
      "prop": "pdfsExempt"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "pdfsExempt", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "pdfsExempt", $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.taxData.ibType === 'Multilateral') ? _c('el-form-item', {
    attrs: {
      "label": "Regimen de convenio",
      "prop": "idAgreementRegimeType"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "regimenConvenio",
      "filterable": "",
      "clearable": "",
      "data-cy": "input-idAgreementRegimeType"
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.idAgreementRegimeType, 'idAgreementRegimeType')
      }
    },
    model: {
      value: (_vm.taxData.idAgreementRegimeType),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "idAgreementRegimeType", $$v)
      },
      expression: "taxData.idAgreementRegimeType"
    }
  }, _vm._l((_vm.regimenTypes), function(item) {
    return _c('el-option', {
      key: item.idAgreementRegimeType,
      attrs: {
        "label": item.agreementRegimeType,
        "value": item.idAgreementRegimeType
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.idAgreementRegimeType !=
    _vm.provider.logCompanyTaxData.idAgreementRegimeType
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.ibType === 'Multilateral') ? _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.pdfCM05,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "* CM05",
      "id": "uploadPdfCM05",
      "prop": "pdfCM05"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "pdfCM05", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "pdfCM05", $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.jurisdicciones) ? _c('el-form-item', {
    attrs: {
      "label": "Jurisdicción sede",
      "prop": "jurisdictionHeadquarters"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "jsede",
      "filterable": "",
      "clearable": "",
      "data-cy": "input-jurisdictionHeadquarters"
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.jurisdictionHeadquarters, 'jurisdictionHeadquarters')
      }
    },
    model: {
      value: (_vm.taxData.jurisdictionHeadquarters),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "jurisdictionHeadquarters", $$v)
      },
      expression: "taxData.jurisdictionHeadquarters"
    }
  }, _vm._l((_vm.jurisdictions), function(item) {
    return _c('el-option', {
      key: item.idJurisdictions,
      attrs: {
        "label": item.jurisdictions,
        "value": item.idJurisdictions
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.jurisdictionHeadquarters !=
    _vm.provider.logCompanyTaxData.jurisdictionHeadquarters
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "0",
      "prop": "jurisdictions"
    }
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "align": "center",
      "type": "flex",
      "justify": "center",
      "gutter": 10
    }
  }, [(this.doc1276 === false) ? _c('el-col', {
    staticStyle: {
      "padding-right": "45px"
    },
    attrs: {
      "span": 6
    }
  }, [_vm._v("\n                      Jurisdicción\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v("\n                      Jurisdicción\n                    ")]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v(" Alicuota** ")]), _vm._v(" "), (this.doc1276 === false) ? _c('el-col', {
    staticStyle: {
      "padding-right": "45px"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                      Coef. Unificado\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    staticStyle: {
      "padding-right": "1%"
    },
    attrs: {
      "span": 5
    }
  }, [_vm._v("\n                      Coef. Unificado\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === false) ? _c('el-col', {
    staticStyle: {
      "margin-right": "60px"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                      N° de Certificado\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    staticStyle: {
      "margin-right": "40px"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      N° de Certificado\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === false) ? _c('el-col', {
    staticStyle: {
      "margin-left": "-50px"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                      Datos adicionales\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    staticStyle: {
      "padding-left": "10px"
    },
    attrs: {
      "span": 6
    }
  }, [_vm._v("\n                      Datos adicionales\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === false) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("\n                      Agente de Retención\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    staticStyle: {
      "padding-left": "45px",
      "line-height": "30px"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      Agente de Retención\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === false) ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                      Agente de Percepción\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    staticStyle: {
      "padding-left": "50px",
      "line-height": "30px"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("\n                      Agente de Percepción\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    staticStyle: {
      "padding-left": "80px"
    },
    attrs: {
      "span": 3
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v("Formulario 1276\n                    ")]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  })], 1), _vm._v(" "), _vm._l((_vm.taxData.jurisdictions), function(jurisdict, jurId) {
    return _c('el-row', {
      key: jurId,
      staticStyle: {
        "text-align": "center",
        "margin-bottom": "15px"
      },
      attrs: {
        "align": "center",
        "type": "flex",
        "justify": "center",
        "gutter": 5
      }
    }, [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "'jurisdictions\\[' + jurId + '\\]\\[\\'idJurisdiction\\'\\]'"
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "95%"
      },
      attrs: {
        "filterable": "",
        "clearable": ""
      },
      on: {
        "input": _vm.saveJurisdiction,
        "change": function($event) {
          return _vm.changeAlicoutJurisdiction(
            jurisdict.idJurisdiction,
            jurId
          )
        }
      },
      model: {
        value: (jurisdict.idJurisdiction),
        callback: function($$v) {
          _vm.$set(jurisdict, "idJurisdiction", $$v)
        },
        expression: "jurisdict.idJurisdiction"
      }
    }, _vm._l((_vm.jurisdictionsHabilitadas), function(item) {
      return _c('el-option', {
        key: item.idJurisdictions,
        attrs: {
          "label": item.jurisdictions,
          "value": item.idJurisdictions
        }
      })
    }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [(!_vm.isAlicuotList(jurisdict.idJurisdiction, jurId)) ? _c('el-form-item', {
      attrs: {
        "prop": "'jurisdictions\\[' + jurId + '\\]\\[\\'aliquot\\'\\]'",
        "rules": [{
            required: _vm.isSantaFe(jurisdict.idJurisdiction),
            message: 'Campo obligatorio',
            trigger: 'change',
          },
          {
            trigger: 'change'
          } ]
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number"
      },
      model: {
        value: (jurisdict.aliquota_value),
        callback: function($$v) {
          _vm.$set(jurisdict, "aliquota_value", _vm._n($$v))
        },
        expression: "jurisdict.aliquota_value"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isAlicuotList(jurisdict.idJurisdiction, jurId)) ? _c('el-form-item', {
      attrs: {
        "prop": "'jurisdictions\\[' + jurId + '\\]\\[\\'aliquot\\'\\]'",
        "rules": [{
            required: _vm.isSantaFe(jurisdict.idJurisdiction),
            message: 'Campo obligatorio',
            trigger: 'change',
          },
          {
            trigger: 'change'
          } ]
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "filterable": "",
        "clearable": ""
      },
      model: {
        value: (jurisdict.aliquot),
        callback: function($$v) {
          _vm.$set(jurisdict, "aliquot", $$v)
        },
        expression: "jurisdict.aliquot"
      }
    }, _vm._l((_vm.retentionCategoriesAliquot), function(item) {
      return _c('el-option', {
        key: item.idCategoryRetain,
        attrs: {
          "label": item.categoryRetain,
          "value": item.idCategoryRetain
        }
      })
    }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'jurisdictions\[' + jurId + '\]\[\'coefficient\'\]'
      }
    }, [_c('el-input', {
      on: {
        "input": function($event) {
          return _vm.validateCoefficient($event, jurId)
        }
      },
      model: {
        value: (jurisdict.coefficient),
        callback: function($$v) {
          _vm.$set(jurisdict, "coefficient", $$v)
        },
        expression: "jurisdict.coefficient"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'certificateNumber\'\]'
      }
    }, [_c('el-input', {
      on: {
        "input": _vm.saveJurisdiction
      },
      model: {
        value: (jurisdict.certificateNumber),
        callback: function($$v) {
          _vm.$set(jurisdict, "certificateNumber", $$v)
        },
        expression: "jurisdict.certificateNumber"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-button', {
      attrs: {
        "type": "primary",
        "disabled": !jurisdict.certificateNumber
      },
      on: {
        "click": function($event) {
          return _vm.openModalCertificateDetails(jurId)
        }
      }
    }, [_vm._v("\n                        Editar\n                      ")]), _vm._v(" "), _c('el-dialog', {
      attrs: {
        "title": "Datos adicionales del certificado",
        "visible": jurisdict.certficateDetailsVisible,
        "width": "40%"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }]
    }, [_c('el-form-item', {
      attrs: {
        "label": "Desde",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'certificateFrom\'\]',
        "rules": [{
          required: true,
          message: 'Campo obligatorio',
          trigger: 'change',
        } ]
      }
    }, [_c('el-date-picker', {
      attrs: {
        "format": "dd/MM/yyyy",
        "value-format": "yyyy-MM-dd",
        "type": "date",
        "placeholder": "Seleccionar"
      },
      model: {
        value: (jurisdict.certificateFrom),
        callback: function($$v) {
          _vm.$set(jurisdict, "certificateFrom", $$v)
        },
        expression: "jurisdict.certificateFrom"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Hasta",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'certificateTo\'\]',
        "rules": [{
          required: true,
          message: 'Campo obligatorio',
          trigger: 'change',
        } ]
      }
    }, [_c('el-date-picker', {
      attrs: {
        "format": "dd/MM/yyyy",
        "value-format": "yyyy-MM-dd",
        "type": "date",
        "placeholder": "Seleccionar"
      },
      model: {
        value: (jurisdict.certificateTo),
        callback: function($$v) {
          _vm.$set(jurisdict, "certificateTo", $$v)
        },
        expression: "jurisdict.certificateTo"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Constancia",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'certificatePdf\'\]',
        "rules": [{
          required: true,
          message: 'Campo obligatorio',
          trigger: 'change',
        } ]
      }
    }, [(_vm.habModificaPdf) ? _c('el-upload', {
      ref: 'jurisdictions\[' +
        jurId +
        '\]\[\'certificatePdf\'\]',
      refInFor: true,
      staticClass: "upload-demo",
      attrs: {
        "action": _vm.serverURI + 'api/uploadFile',
        "auto-upload": true,
        "accept": "application/pdf",
        "on-success": _vm.handlePdfCertificate,
        "on-exceed": _vm.handleExceed,
        "data": {
          folder: 'altaProveedor',
        },
        "limit": 1
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "trigger",
        "size": "small",
        "type": "primary"
      },
      slot: "trigger"
    }, [_vm._v("Seleccionar archivo")]), _vm._v(" "), _c('div', {
      staticClass: "el-upload__tip",
      attrs: {
        "slot": "tip"
      },
      slot: "tip"
    }, [_vm._v("\n                                Solo se permiten archivos PDF\n                              ")])], 1) : _c('span', [(jurisdict.certificatePdf) ? _c('a', {
      staticStyle: {
        "padding-right": "20px"
      },
      attrs: {
        "href": jurisdict.certificatePdf,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o"
    }), _vm._v(" Ver\n                              ")]) : _c('span', [_vm._v(" - ")])])], 1), _vm._v(" "), _c('span', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          jurisdict.certficateDetailsVisible = false
        }
      }
    }, [_vm._v("Confirmar")])], 1)], 1)])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'retentionAgentHas\'\]'
      }
    }, [_c('el-switch', {
      attrs: {
        "active-text": "Si",
        "inactive-text": "No",
        "active-value": "1",
        "inactive-value": "0"
      },
      on: {
        "change": function($event) {
          return _vm.openModalRetentionAgent(jurId)
        },
        "input": _vm.saveJurisdiction
      },
      model: {
        value: (jurisdict.retentionAgentHas),
        callback: function($$v) {
          _vm.$set(jurisdict, "retentionAgentHas", $$v)
        },
        expression: "jurisdict.retentionAgentHas"
      }
    }), _vm._v(" "), (jurisdict.retentionAgentHas === '1') ? _c('el-button', {
      staticStyle: {
        "margin-left": "5px"
      },
      attrs: {
        "type": "success",
        "size": "small",
        "circle": "",
        "icon": "el-icon-edit"
      },
      on: {
        "click": function($event) {
          return _vm.openModalRetentionAgent(jurId)
        }
      }
    }) : _vm._e(), _vm._v(" "), (jurisdict.retentionAgentHas === '1') ? _c('el-form-item', {
      attrs: {
        "label": "",
        "label-width": "0",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'retentionAgentPdf\'\]'
      }
    }) : _vm._e(), _vm._v(" "), (jurisdict.retentionAgentHas === '1') ? _c('el-form-item', {
      attrs: {
        "label": "",
        "label-width": "0",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'retentionAgentDate\'\]'
      }
    }) : _vm._e(), _vm._v(" "), (jurisdict.retentionAgentHas === '1') ? _c('el-dialog', {
      attrs: {
        "title": "Agente de retención.",
        "visible": jurisdict.retentionAgentVisible,
        "width": "40%",
        "before-close": function () { return (jurisdict.retentionAgentHas = '0'); }
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Fecha de alta",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'retentionAgentDate\'\]'
      }
    }, [_c('el-date-picker', {
      attrs: {
        "format": "dd/MM/yyyy",
        "value-format": "yyyy-MM-dd",
        "type": "date",
        "placeholder": "Seleccionar"
      },
      on: {
        "input": _vm.saveJurisdiction
      },
      model: {
        value: (jurisdict.retentionAgentDate),
        callback: function($$v) {
          _vm.$set(jurisdict, "retentionAgentDate", $$v)
        },
        expression: "jurisdict.retentionAgentDate"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Constancia",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'retentionAgentPdf\'\]'
      }
    }, [(_vm.habModificaPdf) ? _c('el-upload', {
      ref: 'jurisdictions\[' +
        jurId +
        '\]\[\'retentionAgentPdf\'\]',
      refInFor: true,
      staticClass: "upload-demo",
      attrs: {
        "action": _vm.serverURI + 'api/uploadFile',
        "auto-upload": true,
        "accept": "application/pdf",
        "on-success": _vm.handlePdfRetentionAgent,
        "on-exceed": _vm.handleExceed,
        "data": {
          folder: 'altaProveedor',
        },
        "limit": 1
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "trigger",
        "size": "small",
        "type": "primary"
      },
      slot: "trigger"
    }, [_vm._v("Seleccionar archivo")]), _vm._v(" "), _c('div', {
      staticClass: "el-upload__tip",
      attrs: {
        "slot": "tip"
      },
      slot: "tip"
    }, [_vm._v("\n                                Solo se permiten archivos PDF\n                              ")])], 1) : _c('span', [(jurisdict.retentionAgentPdf) ? _c('a', {
      staticStyle: {
        "padding-right": "20px"
      },
      attrs: {
        "href": jurisdict.retentionAgentPdf,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o"
    }), _vm._v(" Ver\n                              ")]) : _c('span', [_vm._v(" - ")])])], 1), _vm._v(" "), _c('span', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          jurisdict.retentionAgentVisible = false
        }
      },
      nativeOn: {
        "click": function($event) {
          return _vm.saveJurisdiction.apply(null, arguments)
        }
      }
    }, [_vm._v("Confirmar")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'perceptionAgentHas\'\]'
      }
    }, [_c('el-col', {
      staticStyle: {
        "padding-right": "20px"
      },
      attrs: {
        "span": 25
      }
    }, [_c('el-switch', {
      attrs: {
        "active-text": "Si",
        "inactive-text": "No",
        "active-value": "1",
        "inactive-value": "0"
      },
      on: {
        "change": function($event) {
          return _vm.openModalPerceptionAgent(jurId)
        }
      },
      model: {
        value: (jurisdict.perceptionAgentHas),
        callback: function($$v) {
          _vm.$set(jurisdict, "perceptionAgentHas", $$v)
        },
        expression: "jurisdict.perceptionAgentHas"
      }
    })], 1), _vm._v(" "), (jurisdict.perceptionAgentHas === '1') ? _c('el-button', {
      staticStyle: {
        "margin-left": "5px"
      },
      attrs: {
        "type": "success",
        "size": "small",
        "circle": "",
        "icon": "el-icon-edit"
      },
      on: {
        "click": function($event) {
          return _vm.openModalPerceptionAgent(jurId)
        }
      }
    }) : _vm._e(), _vm._v(" "), (jurisdict.perceptionAgentHas === '1') ? _c('el-form-item', {
      attrs: {
        "label": "",
        "label-width": "0",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'retentionAgentPdf\'\]'
      }
    }) : _vm._e(), _vm._v(" "), (jurisdict.perceptionAgentHas === '1') ? _c('el-form-item', {
      attrs: {
        "label": "",
        "label-width": "0",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'perceptionAgentDate\'\]'
      }
    }) : _vm._e(), _vm._v(" "), (jurisdict.perceptionAgentHas === '1') ? _c('el-dialog', {
      attrs: {
        "title": "Agente de percepción.",
        "visible": jurisdict.perceptionAgentVisible,
        "width": "40%",
        "before-close": function () { return (jurisdict.perceptionAgentHas = '0'); }
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Fecha de alta",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'perceptionAgentDate\'\]'
      }
    }, [_c('el-date-picker', {
      attrs: {
        "format": "dd/MM/yyyy",
        "value-format": "yyyy-MM-dd",
        "type": "date",
        "placeholder": "Seleccionar"
      },
      model: {
        value: (jurisdict.perceptionAgentDate),
        callback: function($$v) {
          _vm.$set(jurisdict, "perceptionAgentDate", $$v)
        },
        expression: "jurisdict.perceptionAgentDate"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Constancia",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'perceptionAgentPdf\'\]'
      }
    }, [(_vm.habModificaPdf) ? _c('el-upload', {
      ref: 'jurisdictions\[' +
        jurId +
        '\]\[\'perceptionAgentPdf\'\]',
      refInFor: true,
      staticClass: "upload-demo",
      attrs: {
        "action": _vm.serverURI + 'api/uploadFile',
        "auto-upload": true,
        "accept": "application/pdf",
        "on-success": _vm.handlePdfPerceptionAgent,
        "on-exceed": _vm.handleExceed,
        "data": {
          folder: 'altaProveedor',
        },
        "limit": 1
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "trigger",
        "size": "small",
        "type": "primary"
      },
      slot: "trigger"
    }, [_vm._v("Seleccionar archivo")]), _vm._v(" "), _c('div', {
      staticClass: "el-upload__tip",
      attrs: {
        "slot": "tip"
      },
      slot: "tip"
    }, [_vm._v("\n                                Solo se permiten archivos PDF\n                              ")])], 1) : _c('span', [(jurisdict.perceptionAgentPdf) ? _c('a', {
      staticStyle: {
        "padding-right": "20px"
      },
      attrs: {
        "href": jurisdict.perceptionAgentPdf,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o"
    }), _vm._v(" Ver\n                              ")]) : _c('span', [_vm._v(" - ")])])], 1), _vm._v(" "), _c('span', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          jurisdict.perceptionAgentVisible = false
        }
      },
      nativeOn: {
        "click": function($event) {
          return _vm.saveJurisdiction.apply(null, arguments)
        }
      }
    }, [_vm._v("Confirmar")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), (jurisdict.idJurisdiction === '13') ? _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('el-form', {
      attrs: {
        "disabledData": false
      }
    }, [_c('el-button', {
      staticStyle: {
        "font-size": "10px"
      },
      attrs: {
        "size": "mini",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.openModalForm1276(jurId)
        }
      }
    }, [_vm._v("\n                          Seleccionar archivo\n                        ")])], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "",
        "label-width": "0",
        "prop": 'jurisdictions\[' + jurId + '\]\[\'form1276pdf\'\]',
        "rules": [{
          required: true,
          message: 'Constancia obligatoria',
          trigger: 'change',
        } ]
      }
    }), _vm._v(" "), _c('el-dialog', {
      attrs: {
        "title": "Formulario 1276",
        "visible": jurisdict.form1276Visible,
        "width": "40%"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }]
    }, [_c('el-form-item', {
      attrs: {
        "label": "Formulario 1276",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'form1276pdf\'\]',
        "rules": [{
          required: true,
          message: 'Campo obligatorio',
          trigger: 'change',
        } ]
      }
    }, [(_vm.habModificaPdf) ? _c('el-upload', {
      ref: 'jurisdictions\[' +
        jurId +
        '\]\[\'form1276pdf\'\]',
      refInFor: true,
      staticClass: "upload-demo",
      attrs: {
        "action": _vm.serverURI + 'api/uploadFile',
        "auto-upload": true,
        "accept": "application/pdf",
        "on-success": _vm.handlePdfForm1276,
        "on-exceed": _vm.handleExceed,
        "data": {
          folder: 'altaProveedor',
        },
        "limit": 1
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "trigger",
        "size": "small",
        "type": "primary"
      },
      slot: "trigger"
    }, [_vm._v("Seleccionar archivo")]), _vm._v(" "), _c('div', {
      staticClass: "el-upload__tip",
      attrs: {
        "slot": "tip"
      },
      slot: "tip"
    }, [_vm._v("\n                                Solo se permiten archivos PDF\n                              ")])], 1) : _c('span', [(jurisdict.form1276pdf) ? _c('a', {
      staticStyle: {
        "padding-right": "20px"
      },
      attrs: {
        "href": jurisdict.form1276pdf,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o"
    }), _vm._v(" Ver\n                              ")]) : _c('span', [_vm._v(" - ")])])], 1), _vm._v(" "), _c('span', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          jurisdict.form1276Visible = false
        }
      },
      nativeOn: {
        "click": function($event) {
          return _vm.saveJurisdiction.apply(null, arguments)
        }
      }
    }, [_vm._v("Confirmar")])], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), (['1', '2', '22', '14', '15'].includes(jurisdict.idJurisdiction)) ? _c('el-form-item', {
      staticStyle: {
        "width": "250px",
        "margin-right": "-250px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (jurisdict.agentDontOperateHere),
        expression: "jurisdict.agentDontOperateHere"
      }],
      staticStyle: {
        "width": "15px",
        "float": "left",
        "cursor": "pointer",
        "margin-right": "25px",
        "margin-top": "13px"
      },
      attrs: {
        "type": "checkbox",
        "name": "operaAqui",
        "required": ""
      },
      domProps: {
        "checked": Array.isArray(jurisdict.agentDontOperateHere) ? _vm._i(jurisdict.agentDontOperateHere, null) > -1 : (jurisdict.agentDontOperateHere)
      },
      on: {
        "change": function($event) {
          var $$a = jurisdict.agentDontOperateHere,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(jurisdict, "agentDontOperateHere", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(jurisdict, "agentDontOperateHere", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(jurisdict, "agentDontOperateHere", $$c)
          }
        }
      }
    }), _c('span', {
      staticStyle: {
        "margin-left": "-70px",
        "margin-top": "15px"
      }
    }, [_vm._v("No Presta Servicio aqui")])]) : _vm._e(), _vm._v(" "), (!['1', '2', '22', '14', '15'].includes(jurisdict.idJurisdiction) && jurisdict.idJurisdiction !== '13') ? _c('el-col', {
      staticStyle: {
        "margin-left": "-80px"
      },
      attrs: {
        "span": 3
      }
    }, [(
      ((_vm.taxData.ibType === 'Multilateral' && jurId > 1) ||
        (_vm.taxData.ibType !== 'Multilateral' &&
          jurId > 0)) &&
      !_vm.provider
    ) ? _c('el-button', {
      staticStyle: {
        "padding-left": "10px"
      },
      attrs: {
        "type": "warning",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.deleteJurisdiction(jurisdict)
        }
      }
    }, [_vm._v("X")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (['1', '2', '22', '14', '15'].includes(jurisdict.idJurisdiction)) ? _c('el-col', {
      staticStyle: {
        "float": "right",
        "margin-right": "-250px"
      },
      attrs: {
        "span": 5,
        "offset": 2
      }
    }, [(
      ((_vm.taxData.ibType === 'Multilateral' && jurId > 1) ||
        (_vm.taxData.ibType !== 'Multilateral' &&
          jurId > 0)) &&
      !_vm.provider
    ) ? _c('el-button', {
      staticStyle: {
        "padding-left": "10px"
      },
      attrs: {
        "type": "warning",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.deleteJurisdiction(jurisdict)
        }
      }
    }, [_vm._v("X")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (jurisdict.idJurisdiction === '13') ? _c('el-col', {
      staticStyle: {
        "margin-left": "-25px"
      },
      attrs: {
        "span": 3
      }
    }, [(
      ((_vm.taxData.ibType === 'Multilateral' && jurId > 1) ||
        (_vm.taxData.ibType !== 'Multilateral' &&
          jurId > 0)) &&
      !_vm.provider
    ) ? _c('el-button', {
      staticStyle: {
        "padding-left": "10px"
      },
      attrs: {
        "type": "warning",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.deleteJurisdiction(jurisdict)
        }
      }
    }, [_vm._v("X")]) : _vm._e()], 1) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.taxData.ibType === 'Multilateral') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.addJurisdiction()
      }
    }
  }, [_vm._v("Agregar jurisdicción")]) : _vm._e()], 2), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("** Alicuota a aplicar por el agente de retención")]), _vm._v(" "), _c('el-divider', [_vm._v("Retención Ganancias")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tipo",
      "prop": "earningsRetentionType"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "typeGanancias",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.earningsRetentionType, 'earningsRetentionType')
      }
    },
    model: {
      value: (_vm.taxData.earningsRetentionType),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "earningsRetentionType", $$v)
      },
      expression: "taxData.earningsRetentionType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Inscripto",
      "value": "Inscripto"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Exento",
      "value": "Exento"
    }
  })], 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.earningsRetentionType !=
    _vm.provider.logCompanyTaxData.earningsRetentionType
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), (
    _vm.taxData.earningsRetentionType === 'Inscripto' &&
    _vm.generalData.typeIVA !== '06'
  ) ? _c('el-form-item', {
    attrs: {
      "label": "Régimen de Retención",
      "prop": "retentionRegimen"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "retencion",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.updateRetentionCategory,
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.retentionRegimen, 'retentionRegimen')
      }
    },
    model: {
      value: (_vm.taxData.retentionRegimen),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "retentionRegimen", $$v)
      },
      expression: "taxData.retentionRegimen"
    }
  }, _vm._l((_vm.retentionRegimes), function(item) {
    return _c('el-option', {
      key: item.idRetentionRegime,
      attrs: {
        "label": item.retentionRegime,
        "value": item.idRetentionRegime
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.retentionRegimen !=
    _vm.provider.logCompanyTaxData.retentionRegimen
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
    _vm.taxData.earningsRetentionType === 'Inscripto' &&
    _vm.generalData.typeIVA === '06'
  ) ? _c('el-form-item', {
    attrs: {
      "label": "Régimen de Retención",
      "prop": "retentionRegimen"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.updateRetentionCategory,
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.retentionRegimen, 'retentionRegimen')
      }
    },
    model: {
      value: (_vm.taxData.retentionRegimen),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "retentionRegimen", $$v)
      },
      expression: "taxData.retentionRegimen"
    }
  }, _vm._l((_vm.retentionRegimeList), function(item) {
    return _c('el-option', {
      key: item.idRetentionRegime,
      attrs: {
        "label": item.retentionRegime,
        "value": item.idRetentionRegime
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.retentionRegimen !=
    _vm.provider.logCompanyTaxData.retentionRegimen
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.earningsRetentionType === 'Inscripto') ? _c('el-form-item', {
    attrs: {
      "label": "Categoría a retener",
      "prop": "idEarningCategoryRetain"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "categoriaR",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.idEarningCategoryRetain, 'idEarningCategoryRetain')
      }
    },
    model: {
      value: (_vm.taxData.idEarningCategoryRetain),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "idEarningCategoryRetain", $$v)
      },
      expression: "taxData.idEarningCategoryRetain"
    }
  }, _vm._l((_vm.retentionCategories2), function(item) {
    return _c('el-option', {
      key: item.idCategoryRetain,
      attrs: {
        "label": item.categoryRetain,
        "value": item.idCategoryRetain
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.idEarningCategoryRetain !=
    _vm.provider.logCompanyTaxData.idEarningCategoryRetain
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.user !== null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exclusión Retención Ganancias")]), _vm._v(" "), (_vm.provider && _vm.provider.certifExgain.length > 0) ? _c('span', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationExgainList()
      }
    }
  }, [_vm._v("Ver")])], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)])], 1) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exclusión Retención Ganancias")]), _vm._v(" "), (this.certificationExgainList.length > 0) ? _c('span', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationExgainList()
      }
    }
  }, [_vm._v("Ver")])], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)])], 1) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (this.user !== null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exención RG2681")]), _vm._v(" "), (_vm.provider && _vm.provider.certifRg2681.length > 0) ? _c('span', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationRg2681List()
      }
    }
  }, [_vm._v("Ver")])], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1), _vm._v(" "), _c('br'), _c('br')])], 1) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exención RG2681")]), _vm._v(" "), (this.certificationRg2681List.length > 0) ? _c('span', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationRg2681List()
      }
    }
  }, [_vm._v("Ver")])], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1), _vm._v(" "), _c('br'), _c('br')])], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": 'earningsExclusionNumber',
      "label": "Número"
    }
  }, [_c('el-input', {
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.earningsExclusionNumber, 'earningsExclusionNumber')
      }
    },
    model: {
      value: (_vm.taxData.earningsExclusionNumber),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "earningsExclusionNumber", $$v)
      },
      expression: "taxData.earningsExclusionNumber"
    }
  })], 1)], 1), _vm._v(" "), (_vm.taxData.earningsExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "0px",
      "label": "",
      "prop": 'earningsExclusionFrom'
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "disabled": !_vm.taxData.earningsExclusionNumber,
      "type": "date",
      "placeholder": "Desde"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.earningsExclusionFrom, 'earningsExclusionFrom')
      }
    },
    model: {
      value: (_vm.taxData.earningsExclusionFrom),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "earningsExclusionFrom", $$v)
      },
      expression: "taxData.earningsExclusionFrom"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.earningsExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "label-width": "0px",
      "prop": 'earningsExclusionTo'
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "disabled": !_vm.taxData.earningsExclusionNumber,
      "picker-options": _vm.disabledDates,
      "type": "date",
      "placeholder": "Hasta"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.earningsExclusionTo, 'earningsExclusionTo')
      }
    },
    model: {
      value: (_vm.taxData.earningsExclusionTo),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "earningsExclusionTo", $$v)
      },
      expression: "taxData.earningsExclusionTo"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.earningsExclusionNumber !=
    _vm.provider.logCompanyTaxData.earningsExclusionNumber
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Número' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.earningsExclusionFrom !=
    _vm.provider.logCompanyTaxData.earningsExclusionFrom
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Fecha desde' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.earningsExclusionTo !=
    _vm.provider.logCompanyTaxData.earningsExclusionTo
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Fecha hasta' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.earningsExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.earningsExclusionPdf,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "* Certificado exclusión",
      "id": "uploadPdfearningsExclusion",
      "prop": "earningsExclusionPdf"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "earningsExclusionPdf", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "earningsExclusionPdf", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', [(this.user !== null) ? _c('div', [(_vm.provider && _vm.provider.certifExgain.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [(this.certificationExgainList.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e()]), _vm._v(" "), _c('el-col', [(this.user !== null) ? _c('div', [(_vm.provider && _vm.provider.certifRg2681.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [(this.certificationRg2681List.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e()])], 1), _vm._v(" "), _c('el-divider', [_vm._v("Retención SUSS")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Empleador",
      "prop": 'sussEmployeer'
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Si",
      "inactive-text": "No",
      "active-value": "1",
      "inactive-value": "0"
    },
    on: {
      "change": function($event) {
        _vm.taxData.sussEmployeer ?
          (_vm.taxData.sussRetentionRegimen =
            _vm.taxData.sussEmployeer) :
          _vm.taxData.sussEmployeer
      }
    },
    model: {
      value: (_vm.taxData.sussEmployeer),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussEmployeer", $$v)
      },
      expression: "taxData.sussEmployeer"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.sussEmployeer !=
    _vm.provider.logCompanyTaxData.sussEmployeer
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Agente de retención",
      "prop": 'retentionRegime'
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-switch', {
    attrs: {
      "disabled": _vm.taxData.sussEmployeer === '0',
      "enabled": _vm.taxData.sussEmployeer === '1',
      "active-value": "1",
      "inactive-value": "0",
      "active-text": "Si",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.taxData.sussRetentionRegimen),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussRetentionRegimen", $$v)
      },
      expression: "taxData.sussRetentionRegimen"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.sussRetentionRegimen !=
    _vm.provider.logCompanyTaxData.sussRetentionRegimen
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), (
    _vm.taxData.sussEmployeer &&
    _vm.taxData.sussRetentionRegimen === '1'
  ) ? _c('el-form-item', {
    attrs: {
      "label": "Régimen a retener",
      "prop": "sussIdCategoryRetain"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.sussIdCategoryRetain, 'sussIdCategoryRetain')
      }
    },
    model: {
      value: (_vm.taxData.sussIdCategoryRetain),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussIdCategoryRetain", $$v)
      },
      expression: "taxData.sussIdCategoryRetain"
    }
  }, _vm._l((_vm.sussRetentionCategory), function(item) {
    return _c('el-option', {
      key: item.idCategoryRetain,
      attrs: {
        "label": item.categoryRetain,
        "value": item.idCategoryRetain
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.sussIdCategoryRetain !=
    _vm.provider.logCompanyTaxData.sussIdCategoryRetain
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
    _vm.taxData.sussEmployeer == '1' &&
    _vm.taxData.sussRetentionRegimen == '0'
  ) ? _c('el-form-item', {
    attrs: {
      "label": "Régimen a retener",
      "prop": "sussIdCategoryRetain"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.sussIdCategoryRetain, 'sussIdCategoryRetain')
      }
    },
    model: {
      value: (_vm.taxData.sussIdCategoryRetain),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussIdCategoryRetain", $$v)
      },
      expression: "taxData.sussIdCategoryRetain"
    }
  }, _vm._l((_vm.sussRetentionCategory), function(item) {
    return _c('el-option', {
      key: item.idCategoryRetain,
      attrs: {
        "label": item.categoryRetain,
        "value": item.idCategoryRetain
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.sussIdCategoryRetain !=
    _vm.provider.logCompanyTaxData.sussIdCategoryRetain
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.user !== null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exclusión")]), _vm._v(" "), (_vm.provider && _vm.provider.certifSuss.length > 0) ? _c('span', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationSussList()
      }
    }
  }, [_vm._v("Ver")])], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)])], 1) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exclusión")]), _vm._v(" "), (this.certificationSussList.length > 0) ? _c('span', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationSussList()
      }
    }
  }, [_vm._v("Ver")])], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)])], 1) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": 'sussExclusionNumber',
      "label": "Número"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "30"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.sussExclusionNumber, 'sussExclusionNumber')
      }
    },
    model: {
      value: (_vm.taxData.sussExclusionNumber),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussExclusionNumber", $$v)
      },
      expression: "taxData.sussExclusionNumber"
    }
  })], 1)], 1), _vm._v(" "), (_vm.taxData.sussExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "0px",
      "label": "",
      "prop": 'sussExclusionFrom'
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "disabled": !_vm.taxData.sussExclusionNumber,
      "type": "date",
      "placeholder": "Desde"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.sussExclusionFrom, 'sussExclusionFrom')
      }
    },
    model: {
      value: (_vm.taxData.sussExclusionFrom),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussExclusionFrom", $$v)
      },
      expression: "taxData.sussExclusionFrom"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.sussExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "label-width": "0px",
      "prop": 'sussExclusionTo'
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.disabledDates,
      "disabled": !_vm.taxData.sussExclusionNumber,
      "type": "date",
      "placeholder": "Hasta"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.sussExclusionTo, 'sussExclusionTo')
      }
    },
    model: {
      value: (_vm.taxData.sussExclusionTo),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussExclusionTo", $$v)
      },
      expression: "taxData.sussExclusionTo"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.sussExclusionNumber !=
    _vm.provider.logCompanyTaxData.sussExclusionNumber
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Número' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.sussExclusionFrom !=
    _vm.provider.logCompanyTaxData.sussExclusionFrom
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Fecha desde' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.earningsExclusionTo !=
    _vm.provider.logCompanyTaxData.sussExclusionTo
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Fecha hasta' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.sussExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.sussExclusionPdf,
      "habModificaPdf": !!_vm.taxData.sussExclusionNumber,
      "titulo": "* Exclusión",
      "id": "uploadPdfExclusion",
      "prop": "sussExclusionPdf"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "sussExclusionPdf", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "sussExclusionPdf", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', [(this.user !== null) ? _c('div', [(_vm.provider && _vm.provider.certifSuss.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [(this.certificationSussList.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e()])], 1), _vm._v(" "), _c('el-divider', [_vm._v("Retención I.V.A.")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "label": "¿Es agente de retención?",
      "prop": 'ivaRetentionAgent'
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Si",
      "inactive-text": "No",
      "active-value": "1",
      "inactive-value": "0"
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.ivaRetentionAgent, 'ivaRetentionAgent')
      }
    },
    model: {
      value: (_vm.taxData.ivaRetentionAgent),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ivaRetentionAgent", $$v)
      },
      expression: "taxData.ivaRetentionAgent"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ivaRetentionAgent !=
    _vm.provider.logCompanyTaxData.ivaRetentionAgent
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (this.user !== null) ? _c('div', {
    staticStyle: {
      "padding-left": "25%"
    }
  }, [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [(_vm.provider && _vm.provider.certifRg18.length > 0) ? _c('span', [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Certificado RG18")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationRg18List()
      }
    }
  }, [_vm._v("Ver")])], 1)], 1) : _c('span', [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Certificado RG18")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('el-tag', {
    staticStyle: {
      "margin-left": "0%"
    },
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [(this.certificationRg18List.length > 0) ? _c('span', [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Certificado RG18")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationRg18List()
      }
    }
  }, [_vm._v("Ver")])], 1)], 1) : _c('span', [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Certificado RG18")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('el-tag', {
    staticStyle: {
      "margin-left": "0%"
    },
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)], 1)])], 1) : _vm._e()], 1), _vm._v(" "), (
    _vm.taxData.ivaRetentionAgent &&
    _vm.taxData.ivaRetentionAgent !== '1'
  ) ? _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.ivaResolutionPdf,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "* Resolución",
      "id": "uploadPdfResolucion",
      "prop": "sussExclusionPdf"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "ivaResolutionPdf", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "ivaResolutionPdf", $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "taxDataForm",
    attrs: {
      "model": _vm.taxData,
      "id": "formDatosImpositivos",
      "label-position": "left",
      "label-width": "25%",
      "rules": _vm.rulesTaxDataIvaResolutionPdf
    }
  }, [(
    _vm.taxData.ivaRetentionAgent &&
    _vm.taxData.ivaRetentionAgent === '1'
  ) ? _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.ivaResolutionPdf,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "* Resolución",
      "id": "ivaResolutionPdf",
      "prop": "ivaResolutionPdf"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "ivaResolutionPdf", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "ivaResolutionPdf", $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Régimen de retención",
      "prop": "ivaIdRetentionRegime"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "regimenRetencion",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.updateIvaRetentionCategory,
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.ivaIdRetentionRegime, 'ivaIdRetentionRegime')
      }
    },
    model: {
      value: (_vm.taxData.ivaIdRetentionRegime),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ivaIdRetentionRegime", $$v)
      },
      expression: "taxData.ivaIdRetentionRegime"
    }
  }, _vm._l((_vm.retentionRegimesVAT), function(item) {
    return _c('el-option', {
      key: item.idRetentionRegime,
      attrs: {
        "label": item.retentionRegime,
        "value": item.idRetentionRegime
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ivaIdRetentionRegime !=
    _vm.provider.logCompanyTaxData.ivaIdRetentionRegime
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Categoría a retener",
      "prop": "ivaIdCategoryRetain"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "categoriaRetener",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.ivaIdCategoryRetain, 'ivaIdCategoryRetain')
      }
    },
    model: {
      value: (_vm.taxData.ivaIdCategoryRetain),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ivaIdCategoryRetain", $$v)
      },
      expression: "taxData.ivaIdCategoryRetain"
    }
  }, _vm._l((_vm.ivaRetentionCategories), function(item) {
    return _c('el-option', {
      key: item.idCategoryRetain,
      attrs: {
        "label": item.categoryRetain,
        "value": item.idCategoryRetain
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ivaIdCategoryRetain !=
    _vm.provider.logCompanyTaxData.ivaIdCategoryRetain
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1), _vm._v(" "), (this.user !== null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exclusión")]), _vm._v(" "), (_vm.provider && _vm.provider.certifRg17.length > 0) ? _c('span', [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Certificado RG17")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "0px"
    },
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationRg17List()
      }
    }
  }, [_vm._v("Ver")])], 1)], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)])], 1) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exclusión")]), _vm._v(" "), (this.certificationRg17List.length > 0) ? _c('span', [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Certificado RG17")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "0px"
    },
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationRg17List()
      }
    }
  }, [_vm._v("Ver")])], 1)], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)])], 1) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": 'ivaExclusionNumber',
      "label": "Número"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "30"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.ivaExclusionNumber, 'ivaExclusionNumber')
      }
    },
    model: {
      value: (_vm.taxData.ivaExclusionNumber),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ivaExclusionNumber", $$v)
      },
      expression: "taxData.ivaExclusionNumber"
    }
  })], 1)], 1), _vm._v(" "), (_vm.taxData.ivaExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "0px",
      "label": "",
      "prop": 'ivaExclusionFrom'
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "disabled": !_vm.taxData.ivaExclusionNumber,
      "type": "date",
      "placeholder": "Desde"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.ivaExclusionFrom, 'ivaExclusionFrom')
      }
    },
    model: {
      value: (_vm.taxData.ivaExclusionFrom),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ivaExclusionFrom", $$v)
      },
      expression: "taxData.ivaExclusionFrom"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.ivaExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "label-width": "0px",
      "prop": 'ivaExclusionTo'
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.disabledDates,
      "disabled": !_vm.taxData.ivaExclusionNumber,
      "type": "date",
      "placeholder": "Hasta"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.ivaExclusionTo, 'ivaExclusionTo')
      }
    },
    model: {
      value: (_vm.taxData.ivaExclusionTo),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ivaExclusionTo", $$v)
      },
      expression: "taxData.ivaExclusionTo"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ivaExclusionNumber !=
    _vm.provider.logCompanyTaxData.ivaExclusionNumber
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Número' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ivaExclusionFrom !=
    _vm.provider.logCompanyTaxData.ivaExclusionFrom
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Fecha desde' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ivaExclusionTo !=
    _vm.provider.logCompanyTaxData.ivaExclusionTo
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Fecha hasta' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.ivaExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.ivaExclusionPdf,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "",
      "id": "ivaExclusionPdf",
      "prop": "ivaExclusionPdf"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "ivaExclusionPdf", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "ivaExclusionPdf", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', [(this.user !== null) ? _c('div', [(_vm.provider && _vm.provider.certifRg17.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [(this.certificationRg17List.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e()])], 1), _vm._v(" "), _c('el-divider', [_vm._v("Otros impuestos")]), _vm._v(" "), _c('el-form', {
    ref: "taxDataForm",
    attrs: {
      "model": _vm.taxData,
      "id": "formDatosImpositivosOi",
      "label-position": "left",
      "label-width": "25%",
      "rules": _vm.rulesTaxDataOtros
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Régimen de retención",
      "prop": "otrosIdRetentionRegime"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "regimenRetencion",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.updateOtrosRetentionCategory,
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.otrosIdRetentionRegime, 'otrosIdRetentionRegime')
      }
    },
    model: {
      value: (_vm.taxData.otrosIdRetentionRegime),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "otrosIdRetentionRegime", $$v)
      },
      expression: "taxData.otrosIdRetentionRegime"
    }
  }, _vm._l((_vm.retentionRegimesOTROS), function(item) {
    return _c('el-option', {
      key: item.idRetentionRegime,
      attrs: {
        "label": item.retentionRegime,
        "value": item.idRetentionRegime
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.otrosIdRetentionRegime !=
    _vm.provider.logCompanyTaxData.otrosIdRetentionRegime
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "taxDataForm",
    attrs: {
      "model": _vm.taxData,
      "id": "formDatosImpositivosRe",
      "label-position": "left",
      "label-width": "25%",
      "rules": _vm.rulesTaxDataOtros
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Categoría a retener",
      "prop": "otrosIdCategoryRetain"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "categoriaRetener",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.taxData.otrosIdCategoryRetain, 'otrosIdCategoryRetain')
      }
    },
    model: {
      value: (_vm.taxData.otrosIdCategoryRetain),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "otrosIdCategoryRetain", $$v)
      },
      expression: "taxData.otrosIdCategoryRetain"
    }
  }, _vm._l((_vm.otrosRetentionCategories), function(item) {
    return _c('el-option', {
      key: item.idCategoryRetain,
      attrs: {
        "label": item.categoryRetain,
        "value": item.idCategoryRetain
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.otrosIdCategoryRetain !=
    _vm.provider.logCompanyTaxData.otrosIdCategoryRetain
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.step === 3 && !_vm.provider) ? _c('el-form', {
    ref: "userDataForm",
    attrs: {
      "model": _vm.userData,
      "rules": _vm.rulesUserData,
      "label-position": "left",
      "label-width": "25%",
      "id": "formUsuario"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nombre y Apellido",
      "prop": "name",
      "rules": [{
        required: true,
        message: 'Campo obligatorio',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "data-cy": "input-userName"
    },
    on: {
      "blur": function($event) {
        return _vm.saveDataToLocalStorage(_vm.userData.name, 'name')
      }
    },
    model: {
      value: (_vm.userData.name),
      callback: function($$v) {
        _vm.$set(_vm.userData, "name", $$v)
      },
      expression: "userData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Correo electrónico",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "data-cy": "input-userEmail"
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.userData.email, 'email')
      }
    },
    model: {
      value: (_vm.userData.email),
      callback: function($$v) {
        _vm.$set(_vm.userData, "email", $$v)
      },
      expression: "userData.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Contraseña",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "data-cy": "input-userPw"
    },
    model: {
      value: (_vm.userData.password),
      callback: function($$v) {
        _vm.$set(_vm.userData, "password", $$v)
      },
      expression: "userData.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Repetir contraseña",
      "prop": "passwordRe",
      "rules": [{
          pattern: _vm.userData.password,
          message: 'Las contraseñas deben coincidir',
          trigger: 'change',
        },
        {
          required: true,
          message: 'Campo obligatorio',
          trigger: '',
        } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "data-cy": "input-userPwRe"
    },
    model: {
      value: (_vm.userData.passwordRe),
      callback: function($$v) {
        _vm.$set(_vm.userData, "passwordRe", $$v)
      },
      expression: "userData.passwordRe"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider[_vm.activeTab()].idCompanyDataStatus ===
    _vm.status.ESPERANDO_CONFIRMACION &&
    !_vm.user.isProvider
  ) ? _c('div', {
    staticClass: "row text-center"
  }, [_c('el-divider', [_vm._v(" Aceptar datos ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "data-cy": "btn-rechazar"
    },
    on: {
      "click": function($event) {
        return _vm.verifyPermission()
      }
    }
  }, [_vm._v("\n                  Rechazar "), _c('i', {
    staticClass: "el-icon-close"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "data-cy": "btn-aceptar"
    },
    on: {
      "click": function($event) {
        return _vm.acceptCompanyData()
      }
    }
  }, [_vm._v("\n                  Aceptar "), _c('i', {
    staticClass: "el-icon-check"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider[_vm.activeTab()].idCompanyDataStatus ===
    _vm.status.DEVUELTO
  ) ? _c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Observaciones")])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_vm._v("\n                  " + _vm._s(_vm.provider[_vm.activeTab()].observation) + "\n                ")])]) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider[_vm.activeTab()].idCompanyDataStatus ===
    _vm.status.DEVUELTO &&
    _vm.user.isProvider
  ) ? _c('div', {
    staticClass: "row text-center"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.reSendCompanyData
    }
  }, [_vm._v("\n                  Volver a enviar los datos\n                ")])], 1) : _vm._e(), _vm._v(" "), (
    _vm.userByRoles ||
    (_vm.dataAfip &&
      (_vm.userIsAdmin || (_vm.user ? _vm.user.isProvider : true)))
  ) ? _c('el-button-group', [(_vm.step > 0 && !_vm.editing) ? _c('el-button', {
    attrs: {
      "data-cy": "btn-anterior",
      "type": "primary",
      "icon": "el-icon-arrow-left"
    },
    on: {
      "click": function($event) {
        return _vm.previousStep()
      }
    }
  }, [_vm._v("Anterior")]) : _vm._e(), _vm._v(" "), ((_vm.step < 2 || (_vm.step === 2 && !_vm.provider)) && !_vm.editing) ? _c('el-button', {
    attrs: {
      "data-cy": "btn-siguiente",
      "type": "primary",
      "icon": "el-icon-arrow-right"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("Siguiente")]) : _vm._e(), _vm._v(" "), (_vm.step === 3 && !_vm.provider) ? _c('el-button', {
    attrs: {
      "type": "success",
      "icon": "el-check"
    },
    on: {
      "click": _vm.openModalTerminosYCond
    }
  }, [_vm._v("Confirmar")]) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.response) ? _c('div', {
    staticClass: "col-md-12 text-center",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('div', {
    staticClass: "info-box-info"
  }, [_c('ul', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.response) + "\n                      ")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "col-md-12 text-center",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.success))])])])])]) : _vm._e()]), _vm._v(" "), (_vm.emailSoporte !== '') ? _c('div', {
    staticClass: "email__consultas-container"
  }, [_c('el-col', {
    staticClass: "email__consultas",
    attrs: {
      "span": 8
    }
  }, [_vm._v("Si tiene alguna duda o consulta técnica, por favor contactese con: "), _c('b', [_vm._v(_vm._s(_vm.emailSoporte))])])], 1) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Rechazar datos",
      "visible": _vm.rejectCompanyDataVisible,
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.rejectCompanyDataVisible = $event
      }
    }
  }, [_vm._v("\n      Escriba el motivo por el cual rechaza los datos:\n      "), _c('el-input', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "textarea",
      "rows": 4,
      "maxlength": "400",
      "placeholder": "Ingrese el motivo",
      "show-word-limit": true
    },
    model: {
      value: (_vm.newObservation),
      callback: function($$v) {
        _vm.newObservation = $$v
      },
      expression: "newObservation"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.rejectCompanyData()
      }
    }
  }, [_vm._v("\n          Aceptar\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-red"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-green"
  }, [_c('i', {
    staticClass: "ion ion-android-checkmark-circle"
  })])
}]}

/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box-content"
  }, [_c('div', [_c('h1', [_vm._v("SOLICITAR SER PROVEEDOR")]), _vm._v(" "), _c('h6', [_vm._v("Complete el formulario")]), _vm._v(" "), _c('div', {
    staticClass: "back-btn"
  }, [_c('el-button', {
    on: {
      "click": _vm.goBackPage
    }
  }, [_vm._v("< Volver")])], 1)]), _vm._v(" "), _c('div', [_c('steps-pagination', {
    attrs: {
      "activeStep": _vm.step,
      "isConfirmProvider": true
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.step == 0) ? _c('el-card', {
    staticClass: "box-card",
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "card-header"
        }, [_c('p', [_vm._v("Datos generales")])])]
      },
      proxy: true
    }], null, false, 725694500)
  }, [_vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "start"
    }
  }, [(!_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.editing = true
      }
    }
  }, [_vm._v("Editar")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.modifyData('generalData')
      }
    }
  }, [_vm._v("Guardar")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.editing = false
      }
    }
  }, [_vm._v("Cancelar")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5rem"
    }
  }, [(_vm.step === 0) ? _c('el-form', {
    ref: "generalDataForm",
    staticStyle: {
      "width": "80%",
      "margin": "auto"
    },
    attrs: {
      "label-width": "200px"
    }
  }, [_c('el-divider', [_vm._v("Datos de la empresa")]), _vm._v(" "), _c('alta-id', {
    attrs: {
      "idStatus": _vm.idStatus,
      "type": _vm.idType,
      "id": _vm.id,
      "disabled": true
    },
    on: {
      "validate-id": _vm.validateIDHandler
    }
  }), _vm._v(" "), _c('alta-form', {
    attrs: {
      "dataForm": _vm.generalData,
      "locations": _vm.locations,
      "validation": _vm.nextStepFlag,
      "disabled": !_vm.editing
    }
  }), _vm._v(" "), (
    _vm.provider &&
    _vm.provider.generalData.idCompanyDataStatus ===
    _vm.status.DEVUELTO
  ) ? _c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "300",
      "float": "left"
    }
  }, [_vm._v("Observaciones")])]), _vm._v(" "), _c('div', {
    staticClass: "text item",
    staticStyle: {
      "font-weight": "300"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.provider.generalData.observation) + "\n              ")])]) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider.generalData.idCompanyDataStatus === _vm.status.ESPERANDO_CONFIRMACION &&
    !_vm.user.isProvider
  ) ? _c('div', {
    staticClass: "row text-center"
  }, [_c('el-divider', [_vm._v(" Aceptar datos ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "data-cy": "btn-rechazar"
    },
    on: {
      "click": function($event) {
        return _vm.openRejectCompanyDataModal()
      }
    }
  }, [_vm._v("\n                Rechazar "), _c('i', {
    staticClass: "el-icon-close"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "data-cy": "btn-aceptar"
    },
    on: {
      "click": function($event) {
        return _vm.acceptCompanyData('generalData')
      }
    }
  }, [_vm._v("\n                Aceptar "), _c('i', {
    staticClass: "el-icon-check"
  })])], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Rechazar datos",
      "visible": _vm.rejectCompanyDataVisible,
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.rejectCompanyDataVisible = $event
      }
    }
  }, [_vm._v("\n            Escriba el motivo por el cual rechaza los datos:\n            "), _c('el-input', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "textarea",
      "rows": 4,
      "maxlength": "400",
      "placeholder": "Ingrese el motivo",
      "show-word-limit": true
    },
    model: {
      value: (_vm.newObservation),
      callback: function($$v) {
        _vm.newObservation = $$v
      },
      expression: "newObservation"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.rejectCompanyData('generalData')
      }
    }
  }, [_vm._v("\n              Aceptar\n              ")])], 1)], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("\n              Siguiente >\n            ")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.emailSoporte !== '') ? _c('div', {
    staticClass: "email__consultas-container",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('el-col', {
    staticClass: "email__consultas",
    attrs: {
      "span": 8
    }
  }, [_vm._v("Si tiene alguna duda o consulta técnica, por favor contactese\n            con: "), _c('b', [_vm._v(_vm._s(_vm.emailSoporte))])])], 1) : _vm._e()]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.step === 1) ? _c('el-card', {
    staticClass: "box-card",
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "card-header"
        }, [_c('p', [_vm._v("Datos Impositivos")])])]
      },
      proxy: true
    }], null, false, 498538162)
  }, [_vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "start"
    }
  }, [(!_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.editing = true
      }
    }
  }, [_vm._v("Editar")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.modifyData('taxData')
      }
    }
  }, [_vm._v("Guardar")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.editing = false
      }
    }
  }, [_vm._v("Cancelar")]) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "text-danger"
  }, [_vm._v("\n          Los campos acompañados con asterisco(*) son obligatorios\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.step == 1) ? _c('el-form', {
    staticStyle: {
      "width": "80%",
      "margin": "auto"
    },
    attrs: {
      "label-width": "200px"
    }
  }, [_c('el-divider', [_vm._v("Datos Impositivos")]), _vm._v(" "), _c('alta-form', {
    attrs: {
      "dataForm": _vm.companyTaxData,
      "validation": _vm.nextStepFlag,
      "disabled": !_vm.editing
    }
  }), _vm._v(" "), (
    _vm.provider &&
    _vm.provider.taxData.idCompanyDataStatus ===
    _vm.status.DEVUELTO
  ) ? _c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "300",
      "float": "left"
    }
  }, [_vm._v("Observaciones")])]), _vm._v(" "), _c('div', {
    staticClass: "text item",
    staticStyle: {
      "font-weight": "300"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.provider.taxData.observation) + "\n              ")])]) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider.taxData.idCompanyDataStatus === _vm.status.ESPERANDO_CONFIRMACION &&
    !_vm.user.isProvider
  ) ? _c('div', {
    staticClass: "row text-center"
  }, [_c('el-divider', [_vm._v(" Aceptar datos ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "data-cy": "btn-rechazar"
    },
    on: {
      "click": function($event) {
        return _vm.openRejectCompanyDataModal()
      }
    }
  }, [_vm._v("\n                Rechazar "), _c('i', {
    staticClass: "el-icon-close"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "data-cy": "btn-aceptar"
    },
    on: {
      "click": function($event) {
        return _vm.acceptCompanyData('taxData')
      }
    }
  }, [_vm._v("\n                Aceptar "), _c('i', {
    staticClass: "el-icon-check"
  })])], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Rechazar datos",
      "visible": _vm.rejectCompanyDataVisible,
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.rejectCompanyDataVisible = $event
      }
    }
  }, [_vm._v("\n            Escriba el motivo por el cual rechaza los datos:\n            "), _c('el-input', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "textarea",
      "rows": 4,
      "maxlength": "400",
      "placeholder": "Ingrese el motivo",
      "show-word-limit": true
    },
    model: {
      value: (_vm.newObservation),
      callback: function($$v) {
        _vm.newObservation = $$v
      },
      expression: "newObservation"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.rejectCompanyData('taxData')
      }
    }
  }, [_vm._v("\n              Aceptar\n              ")])], 1)], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-button-group', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.backStep
    }
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Siguiente >")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.emailSoporte !== '') ? _c('div', {
    staticClass: "email__consultas-container",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('el-col', {
    staticClass: "email__consultas",
    attrs: {
      "span": 8
    }
  }, [_vm._v("Si tiene alguna duda o consulta técnica, por favor contactese\n            con: "), _c('b', [_vm._v(_vm._s(_vm.emailSoporte))])])], 1) : _vm._e()]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.step === 2) ? _c('el-card', {
    staticClass: "box-card",
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "card-header"
        }, [_c('p', [_vm._v("Datos Bancarios")])])]
      },
      proxy: true
    }], null, false, 894485228)
  }, [_vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "start"
    }
  }, [(!_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.editing = true
      }
    }
  }, [_vm._v("Editar")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.modifyData('paymentData')
      }
    }
  }, [_vm._v("Guardar")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.editing = false
      }
    }
  }, [_vm._v("Cancelar")]) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "text-danger"
  }, [_vm._v("\n          Los campos acompañados con asterisco(*) son obligatorios\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.step == 2) ? _c('el-form', {
    staticStyle: {
      "width": "80%",
      "margin": "auto"
    },
    attrs: {
      "label-width": "200px"
    }
  }, [_c('el-divider', [_vm._v("Datos Bancarios 1")]), _vm._v(" "), _c('alta-form', {
    attrs: {
      "dataForm": _vm.paymentData1,
      "banks": _vm.banks,
      "bankAccountTypes": _vm.bankAccountTypes,
      "validation": _vm.nextStepFlag,
      "disabled": !_vm.editing
    }
  }), _vm._v(" "), _c('el-divider', [_vm._v("Datos Bancarios 2 (Opcional)")]), _vm._v(" "), _c('el-switch', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "disabled": !_vm.editing,
      "active-text": "Activar",
      "inactive-text": "Desactivar"
    },
    on: {
      "change": function($event) {
        return _vm.clearOptionalPaymentData(_vm.optionalPaymentFlag.model)
      }
    },
    model: {
      value: (_vm.optionalPaymentFlag.model),
      callback: function($$v) {
        _vm.$set(_vm.optionalPaymentFlag, "model", $$v)
      },
      expression: "optionalPaymentFlag.model"
    }
  }), _vm._v(" "), _c('alta-form', {
    attrs: {
      "dataForm": _vm.paymentData2,
      "banks": _vm.banks,
      "bankAccountTypes": _vm.bankAccountTypes,
      "disabled": !_vm.optionalPaymentFlag.model || !_vm.editing
    }
  }), _vm._v(" "), (_vm.companyTaxData.detractionSwitch.model) ? _c('el-divider') : _vm._e(), _vm._v(" "), (_vm.companyTaxData.detractionSwitch.model) ? _c('div', [_c('h6', [_vm._v("En caso de realizar actividades sujetas a detracción, por favor completar")]), _vm._v(" "), _c('alta-form', {
    attrs: {
      "dataForm": _vm.paymentData3,
      "validation": _vm.nextStepFlag,
      "disabled": !_vm.editing
    }
  })], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider.paymentData.idCompanyDataStatus ===
    _vm.status.DEVUELTO
  ) ? _c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "300",
      "float": "left"
    }
  }, [_vm._v("Observaciones")])]), _vm._v(" "), _c('div', {
    staticClass: "text item",
    staticStyle: {
      "font-weight": "300"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.provider.paymentData.observation) + "\n              ")])]) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider.paymentData.idCompanyDataStatus === _vm.status.ESPERANDO_CONFIRMACION &&
    !_vm.user.isProvider
  ) ? _c('div', {
    staticClass: "row text-center"
  }, [_c('el-divider', [_vm._v(" Aceptar datos ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "data-cy": "btn-rechazar"
    },
    on: {
      "click": function($event) {
        return _vm.openRejectCompanyDataModal()
      }
    }
  }, [_vm._v("\n                Rechazar "), _c('i', {
    staticClass: "el-icon-close"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "data-cy": "btn-aceptar"
    },
    on: {
      "click": function($event) {
        return _vm.acceptCompanyData('paymentData')
      }
    }
  }, [_vm._v("\n                Aceptar "), _c('i', {
    staticClass: "el-icon-check"
  })])], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Rechazar datos",
      "visible": _vm.rejectCompanyDataVisible,
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.rejectCompanyDataVisible = $event
      }
    }
  }, [_vm._v("\n            Escriba el motivo por el cual rechaza los datos:\n            "), _c('el-input', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "textarea",
      "rows": 4,
      "maxlength": "400",
      "placeholder": "Ingrese el motivo",
      "show-word-limit": true
    },
    model: {
      value: (_vm.newObservation),
      callback: function($$v) {
        _vm.newObservation = $$v
      },
      expression: "newObservation"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.rejectCompanyData('paymentData')
      }
    }
  }, [_vm._v("\n              Aceptar\n              ")])], 1)], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-button-group', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.backStep
    }
  }, [_vm._v("< Anterior")]), _vm._v(" "), (_vm.step <= 1) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Siguiente >")]) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.emailSoporte !== '') ? _c('div', {
    staticClass: "email__consultas-container",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('el-col', {
    staticClass: "email__consultas",
    attrs: {
      "span": 8
    }
  }, [_vm._v("Si tiene alguna duda o consulta técnica, por favor contactese\n            con: "), _c('b', [_vm._v(_vm._s(_vm.emailSoporte))])])], 1) : _vm._e()]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.step == 3) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card",
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "card-header"
        }, [_c('p', [_vm._v("Usuario")])])]
      },
      proxy: true
    }], null, false, 516869071)
  }, [_vm._v(" "), _c('p', {
    staticClass: "text-danger"
  }, [_vm._v("\n          Los campos acompañados con asterisco(*) son obligatorios\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-form', {
    staticStyle: {
      "width": "80%",
      "margin": "auto"
    },
    attrs: {
      "label-width": "200px"
    }
  }, [_c('alta-form', {
    attrs: {
      "dataForm": _vm.userData,
      "validation": _vm.nextStepFlag
    }
  }), _vm._v(" "), (this.response) ? _c('p', {
    staticStyle: {
      "color": "#a94442"
    }
  }, [_vm._v("\n            " + _vm._s(this.response) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('el-divider'), _vm._v(" "), (_vm.validateRuc) ? _c('el-button-group', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.backStep
    }
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.openModalTerminosYCondiciones
    }
  }, [_vm._v("Confirmar")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.emailSoporte !== '') ? _c('div', {
    staticClass: "email__consultas-container",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('el-col', {
    staticClass: "email__consultas",
    attrs: {
      "span": 8
    }
  }, [_vm._v("Si tiene alguna duda o consulta técnica, por favor contactese\n            con: "), _c('b', [_vm._v(_vm._s(_vm.emailSoporte))])])], 1) : _vm._e()])], 1), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "-12vh",
      "height": "auto",
      "overflow-y": "hidden"
    },
    attrs: {
      "title": "Confirmar Alta de Proveedor",
      "visible": _vm.showTerminosYCondiciones,
      "width": "80%",
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showTerminosYCondiciones = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "60vh",
      "overflow": "auto"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.configuration))]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked2),
      expression: "checked2"
    }],
    staticStyle: {
      "width": "15px",
      "margin": "0 5px 0 0",
      "padding-bottom": "5px"
    },
    attrs: {
      "type": "checkbox",
      "name": "aceptoCodigoEtica",
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.checked2) ? _vm._i(_vm.checked2, null) > -1 : (_vm.checked2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checked2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checked2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked2 = $$c
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Acepto el\n            "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.codigoEtica
    }
  }, [_vm._v("Código de Ética y Conducta\n            ")]), _vm._v(".\n          ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    staticStyle: {
      "width": "15px",
      "margin": "0 5px 0 0"
    },
    attrs: {
      "type": "checkbox",
      "name": "aceptoTerminos",
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, null) > -1 : (_vm.checked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked = $$c
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("\n            Acepto las políticas:\n            "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.politicaAnticorrupcion
    }
  }, [_vm._v("Política Anticorrupción")]), _vm._v("\n            y\n            "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.politicaRelacionamiento
    }
  }, [_vm._v("Política de Relacionamiento con Funcionarios Públicos.")])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    attrs: {
      "type": "submit",
      "disabled": !_vm.checked2 || !_vm.checked
    },
    on: {
      "click": function($event) {
        return _vm.submitFormSolicitud()
      }
    }
  }, [_vm._v("\n        Aceptar\n        ")])])])])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.actualCountry === 'AR') ? _c('div', [_c('el-dialog', {
    attrs: {
      "title": "Certificado de exclusión: Retención Ganancias",
      "visible": _vm.showModalCertificationExgain,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationExgain = false
      }
    }
  }, [(this.certificationExgain[0]) ? _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticClass: "tg",
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "222px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0lax"
  }, [_vm._v("Certificado:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].number))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-j58y"
  }, [_vm._v("Cuit:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].cuit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Período fiscal:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].period))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Porcentaje:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].percentage))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Resolución:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].resolution))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Estado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].state))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Fecha de Publicación:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("\n                " + _vm._s(_vm.certificationExgain[0].publication) + "\n              ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Fecha de Vigencia:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].validity))])])])])], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationExgain
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Lista de certificados de exclusión: Retención Ganancias",
      "visible": _vm.showModalCertificationsExgainList,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationsExgainList = false
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "140px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "140px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "135px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "20px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Nro Certificado:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de emisión:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de vigencia:")])]), _vm._v(" "), _vm._l((_vm.certificationExgainList), function(item) {
    return _c('tr', {
      key: item.IdCertificationExGain
    }, [_c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.publication))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.validity))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4B"
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary",
        "plain": "",
        "icon": "el-icon-view"
      },
      on: {
        "click": function($event) {
          return _vm.getCertificationExgain(item.IdCertificationExGain)
        }
      }
    })], 1)])
  })], 2)])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationsExgainList
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Certificado de exención: RG2681",
      "visible": _vm.showModalCertificationRg2681,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationRg2681 = false
      }
    }
  }, [(this.certificationRg2681[0]) ? _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticClass: "tg",
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "222px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0lax"
  }, [_vm._v("Cuit:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].cuit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Tipo de sujeto:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].type))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Cod. Estado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].state))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Desc. Estado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("\n                " + _vm._s(_vm.certificationRg2681[0].stateDescription) + "\n              ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Fecha de Emisión del Certificado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].emision))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Fecha Adm. Formal:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("\n                " + _vm._s(_vm.certificationRg2681[0].administrationDate) + "\n              ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Autoriza Deducción:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].auth))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Obligado Pres. DDJJ:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].ddjj))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Código Inciso:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].subsection))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Vigencia desde:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].since))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Vigencia hasta:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].until))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Nro Certificado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].number))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Por orden judicial:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].orderJud))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Fecha última modificación:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("\n                " + _vm._s(_vm.certificationRg2681[0].modificationDate) + "\n              ")])])])])], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationRg2681
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Datos adicionales del certificado",
      "visible": _vm.showModalCertificationDatosAdicionales,
      "width": "30%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationDatosAdicionales = false
      }
    }
  }, [(_vm.taxData.jurisdictions[_vm.activeJurisdiction]) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "Seleccionar"
    },
    model: {
      value: (_vm.taxData.jurisdictions[_vm.activeJurisdiction].certificateFrom),
      callback: function($$v) {
        _vm.$set(_vm.taxData.jurisdictions[_vm.activeJurisdiction], "certificateFrom", $$v)
      },
      expression: "taxData.jurisdictions[activeJurisdiction].certificateFrom"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.disabledDates,
      "type": "date",
      "placeholder": "Seleccionar"
    },
    model: {
      value: (_vm.taxData.jurisdictions[_vm.activeJurisdiction].certificateTo),
      callback: function($$v) {
        _vm.$set(_vm.taxData.jurisdictions[_vm.activeJurisdiction], "certificateTo", $$v)
      },
      expression: "taxData.jurisdictions[activeJurisdiction].certificateTo"
    }
  })], 1), _vm._v(" "), _c('div', [_c('el-upload', {
    ref: 'jurisdictions\[' + _vm.jurId + '\]\[\'certificatePdf\'\]',
    staticClass: "upload-demo",
    attrs: {
      "id": "uploadCertificatePdf",
      "action": _vm.serverURI + 'api/uploadFile',
      "auto-upload": true,
      "accept": "application/pdf",
      "on-success": _vm.handlePdfCertificate,
      "on-exceed": _vm.handleExceed,
      "data": {
        folder: 'altaProveedor',
      },
      "limit": 1
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("Seleccionar archivo")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("\n            Solo se permiten archivos PDF\n          ")])], 1), _vm._v(" "), _c('span', [(_vm.taxData.jurisdictions[_vm.activeJurisdiction].certificatePdf) ? _c('a', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "href": _vm.taxData.jurisdictions[_vm.activeJurisdiction].certificatePdf,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" Ver\n          ")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showModalCertificationDatosAdicionales = false
      }
    }
  }, [_vm._v("Confirmar")])], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Formulario 1276",
      "visible": _vm.showModalForm1276,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalForm1276 = false
      }
    }
  }, [(_vm.taxData.jurisdictions[_vm.activeJurisdiction]) ? _c('div', [_c('div', [_c('el-upload', {
    ref: 'jurisdictions\[' + _vm.jurId + '\]\[\'form1276pdf\'\]',
    staticClass: "upload-demo",
    attrs: {
      "id": "uploadForm1276",
      "action": _vm.serverURI + 'api/uploadFile',
      "auto-upload": true,
      "accept": "application/pdf",
      "on-success": _vm.handlePdfForm1276,
      "on-exceed": _vm.handleExceed,
      "data": {
        folder: 'altaProveedor',
      },
      "limit": 1
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("Seleccionar archivo")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("\n            Solo se permiten archivos PDF\n          ")])], 1), _vm._v(" "), _c('span', [(_vm.taxData.jurisdictions[_vm.activeJurisdiction].form1276pdf) ? _c('a', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "href": _vm.taxData.jurisdictions[_vm.activeJurisdiction].form1276pdf,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" Ver\n          ")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showModalForm1276 = false
      }
    }
  }, [_vm._v("Confirmar")])], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Lista de certificados de exención: RG2681",
      "visible": _vm.showModalCertificationRg2681List,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationRg2681List = false
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "140px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "140px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "135px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "20px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Nro Certificado:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de emisión:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de vigencia:")])]), _vm._v(" "), _vm._l((_vm.certificationRg2681List), function(item) {
    return _c('tr', {
      key: item.idCertificationRG2681
    }, [_c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.emision))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.until))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4B"
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary",
        "plain": "",
        "icon": "el-icon-view"
      },
      on: {
        "click": function($event) {
          return _vm.getCertificationRg2681(item.idCertificationRG2681)
        }
      }
    })], 1)])
  })], 2)])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationsRg2681List
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Certificado de exclusión: Retención SUSS",
      "visible": _vm.showModalCertificationSuss,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationSuss = false
      }
    }
  }, [(this.certificationSuss[0]) ? _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticClass: "tg",
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "222px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0lax"
  }, [_vm._v("Certificado:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].number))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-j58y"
  }, [_vm._v("Cuit:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].cuit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Período fiscal:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].period))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Porcentaje:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].percentage))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Resolución:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].resolution))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Estado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].state))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Fecha de Publicación:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].since))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Fecha de Vigencia:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].until))])])])])], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationSuss
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Lista de certificados de exclusión: SUSS",
      "visible": _vm.showModalCertificationSussList,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationSussList = false
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "140px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "140px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "135px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "20px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Nro Certificado:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de emisión:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de vigencia:")])]), _vm._v(" "), _vm._l((_vm.certificationSussList), function(item) {
    return _c('tr', {
      key: item.idCertificaction
    }, [_c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.since))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.until))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4B"
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary",
        "plain": "",
        "icon": "el-icon-view"
      },
      on: {
        "click": function($event) {
          return _vm.getCertificationSuss(item.idCertificaction)
        }
      }
    })], 1)])
  })], 2)])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationsSussList
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Certificado de agente de retención RG18: Retención I.V.A",
      "visible": _vm.showModalCertificationRg18,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationRg18 = false
      }
    }
  }, [(this.certificationRg18[0]) ? _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticClass: "tg",
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "222px"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-j58y"
  }, [_vm._v("Cuit:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg18[0].cuit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Razón Social:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg18[0].name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("INCISO RG:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg18[0].type))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Fecha de Publicación:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg18[0].since))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Fecha de Vigencia:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg18[0].until))])])])])], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationRg18
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Lista de agente de retención: RG18",
      "visible": _vm.showModalCertificationRg18List,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationRg18List = false
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "150px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de emisión:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de vigencia:")])]), _vm._v(" "), _vm._l((_vm.certificationRg18List), function(item) {
    return _c('tr', {
      key: item.idCertificationRG18
    }, [_c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.since))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.until))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4B"
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary",
        "plain": "",
        "icon": "el-icon-view"
      },
      on: {
        "click": function($event) {
          return _vm.getCertificationRg18(item.idCertificationRG18)
        }
      }
    })], 1)])
  })], 2)])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationsRg18List
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Certificado de exclusión RG17: Retención I.V.A",
      "visible": _vm.showModalCertificationRg17,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationRg17 = false
      }
    }
  }, [(this.certificationRg17[0]) ? _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticClass: "tg",
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "222px"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-j58y"
  }, [_vm._v("Cuit:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].cuit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Razón Social:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Porcentaje:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].percentage))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("INCISO RG:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].rg))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Tipo de Certificado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].type))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Fecha de Publicación:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].since))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Fecha de Vigencia:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].until))])])])])], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationRg17
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Lista de certificados de exclusión: RG17",
      "visible": _vm.showModalCertificationRg17List,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationRg17List = false
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "150px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de emisión:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de vigencia:")])]), _vm._v(" "), _vm._l((_vm.certificationRg17List), function(item) {
    return _c('tr', {
      key: item.idCertificationRG17
    }, [_c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.since))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.until))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4B"
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary",
        "plain": "",
        "icon": "el-icon-view"
      },
      on: {
        "click": function($event) {
          return _vm.getCertificationRg17(item.idCertificationRG17)
        }
      }
    })], 1)])
  })], 2)])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationsRg17List
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "-12vh",
      "height": "auto",
      "overflow-y": "hidden"
    },
    attrs: {
      "title": "Confirmar Alta de Proveedor",
      "visible": _vm.terminosYCondVisible,
      "width": "80%",
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.terminosYCondVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "60vh",
      "overflow": "auto"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.configuration))]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked2),
      expression: "checked2"
    }],
    staticStyle: {
      "width": "15px",
      "float": "left",
      "margin-right": "5px"
    },
    attrs: {
      "type": "checkbox",
      "name": "aceptoCodigoEtica",
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.checked2) ? _vm._i(_vm.checked2, null) > -1 : (_vm.checked2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checked2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checked2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked2 = $$c
        }
      }
    }
  }), _vm._v("\n        Acepto el\n        "), _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.codigoEtica
    }
  }, [_vm._v("Código de Ética y Conducta")]), _vm._v(".\n      ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    staticStyle: {
      "width": "15px",
      "float": "left",
      "margin-right": "5px"
    },
    attrs: {
      "type": "checkbox",
      "name": "aceptoTerminos",
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, null) > -1 : (_vm.checked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked = $$c
        }
      }
    }
  }), _vm._v("\n        Acepto las políticas:\n        "), _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.politicaAnticorrupcion
    }
  }, [_vm._v("Política Anticorrupción")]), _vm._v("\n        y\n        "), _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.politicaRelacionamiento
    }
  }, [_vm._v("Política de Relacionamiento con Funcionarios Públicos.")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    staticStyle: {
      "position": "relative",
      "left": "45%"
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.checked2 || !_vm.checked
    },
    on: {
      "click": function($event) {
        return _vm.submitFormSolicitud()
      }
    }
  }, [_vm._v("\n          Aceptar\n        ")])])])]), _vm._v(" "), (!_vm.paramError && !_vm.provider) ? _c('h1', {
    staticClass: "text-center"
  }, [_vm._v("\n    SOLICITAR SER PROVEEDOR\n  ")]) : _vm._e(), _vm._v(" "), (!_vm.paramError && !_vm.provider) ? _c('p', {
    staticClass: "text-center"
  }, [_vm._v("\n    Complete el formulario\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('el-button', {
    staticStyle: {
      "display": "inline-block",
      "float": "right",
      "transition": "all 1s",
      "margin-right": "30px",
      "margin-top": "20px"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-left"
  }), _vm._v("\n      Volver\n    ")])], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [(_vm.paramError) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Advertencia")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.paramError))])])])])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('el-steps', {
    attrs: {
      "active": _vm.step,
      "finish-status": "success",
      "align-center": ""
    }
  }, [_c('el-step', {
    attrs: {
      "title": "Datos Generales"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "Datos Bancarios"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "Datos Impositivos"
    }
  }), _vm._v(" "), (!_vm.provider) ? _c('el-step', {
    attrs: {
      "title": "Usuario"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (!_vm.paramError) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [(_vm.step === 0) ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Datos Generales")]) : _vm._e(), _vm._v(" "), (_vm.provider.generalData) ? _c('span', [(_vm.step === 0) ? _c('h5', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "-3%"
    }
  }, [_vm._v("\n                Ultima modificación: " + _vm._s(_vm.provider.generalData.modifDate) + "\n              ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.step === 1) ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Datos de Pago")]) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Datos Impositivos")]) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Usuario")]) : _vm._e()]), _vm._v(" "), (
    _vm.user &&
    _vm.user.isProvider &&
    _vm.provider &&
    _vm.provider[_vm.activeTab()].idCompanyDataStatus ===
    _vm.status.ESPERANDO_CONFIRMACION
  ) ? _c('el-alert', {
    attrs: {
      "title": "Etapa en verificacion",
      "type": "warning",
      "description": "Los datos de esta etapa estan siendo verificados.",
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), (
    (_vm.user &&
      _vm.user.isProvider &&
      _vm.provider &&
      _vm.provider[_vm.activeTab()].idCompanyDataStatus === _vm.status.ACEPTADO) ||
    (_vm.user &&
      !_vm.user.isProvider &&
      _vm.provider &&
      _vm.provider[_vm.activeTab()].idCompanyDataStatus === _vm.status.ESPERANDO_CONFIRMACION)
  ) ? _c('div', {
    staticClass: "col-md-12"
  }, [(!_vm.editing) ? _c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.editData
    }
  }, [_vm._v("Editar")]) : _c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("Guardar")]), _vm._v(" "), (_vm.editing === true) ? _c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.cancelData
    }
  }, [_vm._v("Cancelar")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.providerLoaded && this.user && this.idCompany),
      expression: "!providerLoaded && this.user && this.idCompany"
    }],
    staticClass: "box-body"
  }, [_c('el-col', {
    staticStyle: {
      "width": "80%",
      "margin-left": "10%"
    }
  }, [(_vm.provider && false) ? _c('el-row', {
    staticStyle: {
      "height": "90px",
      "padding-top": "20px",
      "text-align": "right"
    }
  }, [_c('el-tag', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "effect": "dark",
      "type": _vm.statusType
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.getStatusNameOfTab()) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.step === 0) ? _c('el-form', {
    ref: "generalDataForm",
    attrs: {
      "model": _vm.generalData,
      "disabled": _vm.disabledData,
      "rules": _vm.rulesGeneralData,
      "label-position": "left",
      "label-width": "25%",
      "id": "formDatosGenerales"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "info-box-content"
  }, [_c('p', {
    staticClass: "text-danger"
  }, [_vm._v("\n                    Los campos acompañados con asterisco(*) son obligatorios.\n                  ")])]), _vm._v(" "), _c('el-divider', [_vm._v("Datos de la empresa")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "CUIT (sin guiones)",
      "prop": "cuit"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "id": "cuit",
      "type": "text",
      "maxlength": "11",
      "show-word-limit": "",
      "disabled": _vm.dataAfip !== ''
    },
    model: {
      value: (_vm.generalData.cuit),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "cuit", _vm._n($$v))
      },
      expression: "generalData.cuit"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16,
      "align": "center"
    }
  }, [(!_vm.dataAfip) ? _c('el-button', {
    attrs: {
      "id": "verificarAFIP",
      "size": "mini",
      "disabled": _vm.generalData.cuit.toString().length !== 11,
      "type": "primary"
    },
    on: {
      "click": _vm.verifyCuit
    }
  }, [_vm._v("\n                      Verificar AFIP\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.dataAfip && !this.provider) ? _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "warning"
    },
    on: {
      "click": _vm.editCuit
    }
  }, [_vm._v("\n                      Editar\n                    ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dataAfip),
      expression: "dataAfip"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "Razón actualizada a la fecha Social / Denominación",
      "prop": "company"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "255"
    },
    model: {
      value: (_vm.generalData.company),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "company", $$v)
      },
      expression: "generalData.company"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nombre de Fantasía",
      "prop": "companyName"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "255"
    },
    model: {
      value: (_vm.generalData.companyName),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "companyName", $$v)
      },
      expression: "generalData.companyName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Servicio / Actividad",
      "prop": "rubros"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.generalData.rubros),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "rubros", $$v)
      },
      expression: "generalData.rubros"
    }
  }, _vm._l((_vm.services), function(item) {
    return _c('el-option', {
      key: item.idRubro,
      attrs: {
        "label": item.nombre,
        "value": item.idRubro
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Fecha de inicio de Actividades",
      "prop": "start_date"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "Inicio de Actividades"
    },
    on: {
      "change": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.start_date, 'start_date')
      }
    },
    model: {
      value: (_vm.generalData.start_date),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "start_date", $$v)
      },
      expression: "generalData.start_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "¿En qué central prestará el servicio?",
      "prop": "centrales"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.generalData.centrales),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "centrales", $$v)
      },
      expression: "generalData.centrales"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "Calle",
      "prop": "address"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 19
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.address),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "address", $$v)
      },
      expression: "generalData.address"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "label": "Nº",
      "prop": "addressNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "200"
    },
    model: {
      value: (_vm.generalData.addressNumber),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "addressNumber", $$v)
      },
      expression: "generalData.addressNumber"
    }
  })], 1)], 1), _vm._v(" "), (_vm.provider.generalData) ? _c('span', [(
    _vm.provider.logCompanyGeneralData &&
    (_vm.provider.generalData.address !=
      _vm.provider.logCompanyGeneralData.address ||
      _vm.provider.generalData.addressNumber !=
      _vm.provider.logCompanyGeneralData
      .addressNumber)
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Código Postal",
      "prop": "zipCode"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "type": "text",
      "maxlength": "20"
    },
    model: {
      value: (_vm.generalData.zipCode),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "zipCode", $$v)
      },
      expression: "generalData.zipCode"
    }
  })], 1), _vm._v(" "), (_vm.provider.generalData) ? _c('span', [(
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.zipCode !=
    _vm.provider.logCompanyGeneralData.zipCode
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                              Campo\n                              "), _vm._v("modificado\n                            ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "País",
      "prop": "idCountry"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "country",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.updateProvinces
    },
    model: {
      value: (_vm.generalData.idCountry),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "idCountry", $$v)
      },
      expression: "generalData.idCountry"
    }
  }, _vm._l((_vm.countries), function(item) {
    return _c('el-option', {
      key: item.idCountry,
      attrs: {
        "label": item.country,
        "value": item.idCountry
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.idCountry !=
    _vm.provider.logCompanyGeneralData.idCountry
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                              Campo\n                              "), _vm._v("modificado\n                            ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Provincia",
      "prop": "idProvince"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "state",
      "disabled": _vm.generalData.idCountry === '',
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.generalData.idProvince),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "idProvince", $$v)
      },
      expression: "generalData.idProvince"
    }
  }, _vm._l((_vm.provinces), function(item) {
    return _c('el-option', {
      key: item.idProvince,
      attrs: {
        "label": item.province,
        "value": item.idProvince
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.idProvince !=
    _vm.provider.logCompanyGeneralData.idProvince
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Ciudad",
      "prop": "city"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.city),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "city", $$v)
      },
      expression: "generalData.city"
    }
  })], 1), _vm._v(" "), (_vm.provider.generalData) ? _c('span', [(
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.city !=
    _vm.provider.logCompanyGeneralData.city
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                              Campo\n                              "), _vm._v("modificado\n                            ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "E-mail aviso de Pago",
      "prop": "paymentEmail"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.paymentEmail),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "paymentEmail", $$v)
      },
      expression: "generalData.paymentEmail"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.paymentEmail !=
    _vm.provider.logCompanyGeneralData.paymentEmail
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "E-mail aviso de Recepción",
      "prop": "receiptEmail"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.receiptEmail),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "receiptEmail", $$v)
      },
      expression: "generalData.receiptEmail"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.receiptEmail !=
    _vm.provider.logCompanyGeneralData.receiptEmail
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sujeto IVA",
      "prop": "typeIVA"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "sujeto",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.generalData.typeIVA),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "typeIVA", $$v)
      },
      expression: "generalData.typeIVA"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "IVA Responsable Inscripto",
      "value": "01"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IVA Responsable no Inscripto",
      "value": "02"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IVA No Responsable",
      "value": "03"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IVA Sujeto a exención",
      "value": "04"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IVA consumidor final",
      "value": "05"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Responsable Monotributo Bienes",
      "value": "06"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Responsable Monotributo Servicios",
      "value": "006"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Sujeto no Categorizado",
      "value": "07"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Proveedor del exterior",
      "value": "08"
    }
  })], 1)], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.typeIVA !=
    _vm.provider.logCompanyGeneralData.typeIVA
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                              Campo\n                              "), _vm._v("modificado\n                            ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Persona",
      "prop": "personType"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "persona",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.generalData.personSubType = ''
      }
    },
    model: {
      value: (_vm.generalData.personType),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "personType", $$v)
      },
      expression: "generalData.personType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Física",
      "value": "Física"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Jurídica",
      "value": "Jurídica"
    }
  })], 1)], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.personType !=
    _vm.provider.logCompanyGeneralData.personType
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                              Campo\n                              "), _vm._v("modificado\n                            ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.generalData.personType === 'Jurídica') ? _c('el-form-item', {
    attrs: {
      "label": "Subtipo",
      "prop": "personSubType"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        _vm.generalData.personSubTypeOther = ''
      }
    },
    model: {
      value: (_vm.generalData.personSubType),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "personSubType", $$v)
      },
      expression: "generalData.personSubType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "S.A.",
      "value": "S.A."
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "S.R.L.",
      "value": "S.R.L."
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "S.H.",
      "value": "S.H."
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Otro",
      "value": "Otro"
    }
  })], 1)], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.personSubType !=
    _vm.provider.logCompanyGeneralData.personSubType
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                              Campo\n                              "), _vm._v("modificado\n                            ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.generalData.personSubType === 'Otro') ? _c('el-form-item', [_c('el-form-item', {
    attrs: {
      "label": "Otro subtipo",
      "prop": "personSubTypeOther"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.personSubTypeOther),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "personSubTypeOther", $$v)
      },
      expression: "generalData.personSubTypeOther"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.personSubTypeOther !=
    _vm.provider.logCompanyGeneralData
    .personSubTypeOther
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                                Campo\n                                "), _vm._v("modificado\n                              ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.generalData.pdfAfip,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "* Alta de AFIP actualizada a la fecha",
      "id": "altadeAfip",
      "prop": "pdfAfip"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.generalData, "pdfAfip", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.generalData, "pdfAfip", $event)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_vm._v("Contacto principal")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nombre",
      "prop": "namePrincipalContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.namePrincipalContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "namePrincipalContact", $$v)
      },
      expression: "generalData.namePrincipalContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.namePrincipalContact !=
    _vm.provider.logCompanyGeneralData
    .namePrincipalContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Apellido",
      "prop": "surnamePrincipalContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.surnamePrincipalContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "surnamePrincipalContact", $$v)
      },
      expression: "generalData.surnamePrincipalContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.surnamePrincipalContact !=
    _vm.provider.logCompanyGeneralData
    .surnamePrincipalContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Teléfono",
      "prop": "phonePrincipalContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.phonePrincipalContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "phonePrincipalContact", $$v)
      },
      expression: "generalData.phonePrincipalContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.phonePrincipalContact !=
    _vm.provider.logCompanyGeneralData
    .phonePrincipalContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "E-mail",
      "prop": "emailPrincipalContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.emailPrincipalContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "emailPrincipalContact", $$v)
      },
      expression: "generalData.emailPrincipalContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.emailPrincipalContact !=
    _vm.provider.logCompanyGeneralData
    .emailPrincipalContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_vm._v("Contacto comercial")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nombre",
      "prop": "nameCommercialContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.nameCommercialContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "nameCommercialContact", $$v)
      },
      expression: "generalData.nameCommercialContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.nameCommercialContact !=
    _vm.provider.logCompanyGeneralData
    .nameCommercialContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Apellido",
      "prop": "surnameCommercialContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.surnameCommercialContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "surnameCommercialContact", $$v)
      },
      expression: "generalData.surnameCommercialContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.surnameCommercialContact !=
    _vm.provider.logCompanyGeneralData
    .surnameCommercialContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Teléfono",
      "prop": "phoneCommercialContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.phoneCommercialContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "phoneCommercialContact", $$v)
      },
      expression: "generalData.phoneCommercialContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.phoneCommercialContact !=
    _vm.provider.logCompanyGeneralData
    .phoneCommercialContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "E-mail",
      "prop": "emailCommercialContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.emailCommercialContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "emailCommercialContact", $$v)
      },
      expression: "generalData.emailCommercialContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.emailCommercialContact !=
    _vm.provider.logCompanyGeneralData
    .emailCommercialContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('br')], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.step === 1) ? _c('el-form', {
    ref: "paymentDataForm",
    attrs: {
      "model": _vm.paymentData,
      "disabled": _vm.disabledData,
      "rules": _vm.rulesPaymentData,
      "label-position": "left",
      "label-width": "25%",
      "id": "formDatosPagos"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(false) ? _c('div', [_c('el-divider', [_vm._v("Cheque")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sucursal de retiro",
      "prop": "idBankBranch"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.paymentData.idBankBranch),
      callback: function($$v) {
        _vm.$set(_vm.paymentData, "idBankBranch", $$v)
      },
      expression: "paymentData.idBankBranch"
    }
  }, _vm._l((_vm.bankBranches), function(item) {
    return _c('el-option', {
      key: item.idBankBranch,
      attrs: {
        "label": item.bankBranch,
        "value": item.idBankBranch
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.paymentData &&
    _vm.provider.logCompanyPaymentData &&
    _vm.provider.paymentData.idBankBranch !=
    _vm.provider.logCompanyPaymentData.idBankBranch
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-divider', [_vm._v("Transferencia")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Banco",
      "prop": "idBank"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "bank",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.paymentData.idBank),
      callback: function($$v) {
        _vm.$set(_vm.paymentData, "idBank", $$v)
      },
      expression: "paymentData.idBank"
    }
  }, _vm._l((_vm.banks), function(item) {
    return _c('el-option', {
      key: item.idBank,
      attrs: {
        "label": item.bank,
        "value": item.idBank
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.paymentData &&
    _vm.provider.logCompanyPaymentData &&
    _vm.provider.paymentData.idBank !=
    _vm.provider.logCompanyPaymentData.idBank
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tipo de cuenta",
      "prop": "idBankAccountType"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "accounttype",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.paymentData.idBankAccountType),
      callback: function($$v) {
        _vm.$set(_vm.paymentData, "idBankAccountType", $$v)
      },
      expression: "paymentData.idBankAccountType"
    }
  }, _vm._l((_vm.accountTypes), function(item) {
    return _c('el-option', {
      key: item.idBankAccountType,
      attrs: {
        "label": item.bankAccountType,
        "value": item.idBankAccountType
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.paymentData &&
    _vm.provider.logCompanyPaymentData &&
    _vm.provider.paymentData.idBankAccountType !=
    _vm.provider.logCompanyPaymentData.idBankAccountType
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nro. de cuenta",
      "prop": "accountNumber"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 15
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "id": "accountnumber",
      "maxlength": "50"
    },
    model: {
      value: (_vm.paymentData.accountNumber),
      callback: function($$v) {
        _vm.$set(_vm.paymentData, "accountNumber", $$v)
      },
      expression: "paymentData.accountNumber"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.paymentData &&
    _vm.provider.logCompanyPaymentData &&
    _vm.provider.paymentData.accountNumber !=
    _vm.provider.logCompanyPaymentData.accountNumber
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nro. CBU",
      "prop": "cbu"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 15
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "id": "nrocbu",
      "maxlength": "22",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.paymentData.cbu),
      callback: function($$v) {
        _vm.$set(_vm.paymentData, "cbu", $$v)
      },
      expression: "paymentData.cbu"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.paymentData &&
    _vm.provider.logCompanyPaymentData &&
    _vm.provider.paymentData.cbu !=
    _vm.provider.logCompanyPaymentData.cbu
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.paymentData.pdfBank,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "* Constancia",
      "id": "formPdfBank",
      "prop": "pdfBank"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.paymentData, "pdfBank", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.paymentData, "pdfBank", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('el-form', {
    ref: "taxDataForm",
    attrs: {
      "model": _vm.taxData,
      "disabled": _vm.disabledData,
      "rules": _vm.rulesTaxData,
      "label-position": "left",
      "label-width": "25%",
      "id": "formDatosImpositivosIb"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-divider', [_vm._v("Ingresos Brutos")]), _vm._v(" "), _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.pdfIb,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "* Constancia IB actualizada a la fecha",
      "id": "formIB",
      "prop": "pdfIb"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "pdfIb", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "pdfIb", $event)
      }
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tipo",
      "prop": "ibType"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "typeib",
      "clearable": ""
    },
    on: {
      "change": _vm.handleIbType
    },
    model: {
      value: (_vm.taxData.ibType),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ibType", $$v)
      },
      expression: "taxData.ibType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Multilateral",
      "value": "Multilateral"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Local",
      "value": "Local"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Exento",
      "value": "Exento"
    }
  })], 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ibType !=
    _vm.provider.logCompanyTaxData.ibType
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.taxData.ibType === 'Exento') ? _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.pdfsExempt,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "* Constancia de exento",
      "id": "uploadConstanciaExcento",
      "prop": "pdfExempt"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "pdfsExempt", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "pdfsExempt", $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.taxData.ibType === 'Multilateral') ? _c('el-form-item', {
    attrs: {
      "label": "Regimen de convenio",
      "prop": "idAgreementRegimeType"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "regimenConvenio",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.taxData.idAgreementRegimeType),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "idAgreementRegimeType", $$v)
      },
      expression: "taxData.idAgreementRegimeType"
    }
  }, _vm._l((_vm.regimenTypes), function(item) {
    return _c('el-option', {
      key: item.idAgreementRegimeType,
      attrs: {
        "label": item.agreementRegimeType,
        "value": item.idAgreementRegimeType
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.idAgreementRegimeType !=
    _vm.provider.logCompanyTaxData.idAgreementRegimeType
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.ibType === 'Multilateral') ? _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.pdfCM05,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "* CM05",
      "id": "uploadPdfCM05",
      "prop": "pdfCM05"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "pdfCM05", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "pdfCM05", $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.jurisdicciones) ? _c('el-form-item', {
    attrs: {
      "label": "Jurisdicción sede",
      "prop": "jurisdictionHeadquarters"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "jsede",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.taxData.jurisdictionHeadquarters),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "jurisdictionHeadquarters", $$v)
      },
      expression: "taxData.jurisdictionHeadquarters"
    }
  }, _vm._l((_vm.jurisdictions), function(item) {
    return _c('el-option', {
      key: item.idJurisdictions,
      attrs: {
        "label": item.jurisdictions,
        "value": item.idJurisdictions
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.jurisdictionHeadquarters !=
    _vm.provider.logCompanyTaxData.jurisdictionHeadquarters
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "0",
      "prop": "jurisdictions"
    }
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "align": "center",
      "type": "flex",
      "justify": "center",
      "gutter": 10
    }
  }, [(this.doc1276 === false) ? _c('el-col', {
    staticStyle: {
      "padding-right": "45px"
    },
    attrs: {
      "span": 6
    }
  }, [_vm._v("\n                      Jurisdicción\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v("\n                      Jurisdicción\n                    ")]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v(" Alicuota** ")]), _vm._v(" "), (this.doc1276 === false) ? _c('el-col', {
    staticStyle: {
      "padding-right": "45px"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                      Coef. Unificado\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    staticStyle: {
      "padding-right": "1%"
    },
    attrs: {
      "span": 5
    }
  }, [_vm._v("\n                      Coef. Unificado\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === false) ? _c('el-col', {
    staticStyle: {
      "margin-right": "60px"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                      N° de Certificado\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    staticStyle: {
      "margin-right": "40px"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      N° de Certificado\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === false) ? _c('el-col', {
    staticStyle: {
      "margin-left": "-50px"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                      Datos adicionales\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    staticStyle: {
      "padding-left": "10px"
    },
    attrs: {
      "span": 6
    }
  }, [_vm._v("\n                      Datos adicionales\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === false) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("\n                      Agente de Retención\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    staticStyle: {
      "padding-left": "45px",
      "line-height": "30px"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      Agente de Retención\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === false) ? _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      Agente de Percepción\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    staticStyle: {
      "padding-left": "50px",
      "line-height": "30px"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("\n                      Agente de Percepción\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    staticStyle: {
      "padding-left": "80px"
    },
    attrs: {
      "span": 3
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v("Formulario 1276\n                    ")]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  })], 1), _vm._v(" "), _vm._l((_vm.taxData.jurisdictions), function(jurisdict, jurId) {
    return _c('el-row', {
      key: jurId,
      staticStyle: {
        "text-align": "center",
        "margin-bottom": "15px"
      },
      attrs: {
        "align": "center",
        "type": "flex",
        "justify": "center",
        "gutter": 5
      }
    }, [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "'jurisdictions\\[' + jurId + '\\]\\[\\'idJurisdiction\\'\\]'"
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "95%"
      },
      attrs: {
        "filterable": "",
        "clearable": ""
      },
      on: {
        "change": function($event) {
          return _vm.changeAlicoutJurisdiction(
            jurisdict.idJurisdiction,
            jurId
          )
        }
      },
      model: {
        value: (jurisdict.idJurisdiction),
        callback: function($$v) {
          _vm.$set(jurisdict, "idJurisdiction", $$v)
        },
        expression: "jurisdict.idJurisdiction"
      }
    }, _vm._l((_vm.jurisdictionsHabilitadas), function(item) {
      return _c('el-option', {
        key: item.idJurisdictions,
        attrs: {
          "label": item.jurisdictions,
          "value": item.idJurisdictions
        }
      })
    }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [(!_vm.isAlicuotList(jurisdict.idJurisdiction, jurId)) ? _c('el-form-item', {
      attrs: {
        "prop": "'jurisdictions\\[' + jurId + '\\]\\[\\'aliquot\\'\\]'",
        "rules": [{
            required: _vm.isSantaFe(jurisdict.idJurisdiction),
            message: 'Campo obligatorio',
            trigger: 'change',
          },
          {
            trigger: 'change'
          } ]
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number",
        "disabled": !_vm.editing
      },
      model: {
        value: (jurisdict.aliquota_value),
        callback: function($$v) {
          _vm.$set(jurisdict, "aliquota_value", _vm._n($$v))
        },
        expression: "jurisdict.aliquota_value"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isAlicuotList(jurisdict.idJurisdiction, jurId)) ? _c('el-form-item', {
      attrs: {
        "prop": "'jurisdictions\\[' + jurId + '\\]\\[\\'aliquot\\'\\]'",
        "rules": [{
            required: _vm.isSantaFe(jurisdict.idJurisdiction),
            message: 'Campo obligatorio',
            trigger: 'change',
          },
          {
            trigger: 'change'
          } ]
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "filterable": "",
        "clearable": ""
      },
      model: {
        value: (jurisdict.aliquot),
        callback: function($$v) {
          _vm.$set(jurisdict, "aliquot", $$v)
        },
        expression: "jurisdict.aliquot"
      }
    }, _vm._l((_vm.retentionCategoriesAliquot[jurId]), function(item) {
      return _c('el-option', {
        key: item.idCategoryRetain,
        attrs: {
          "label": item.categoryRetain,
          "value": item.idCategoryRetain
        }
      })
    }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'jurisdictions\[' + jurId + '\]\[\'coefficient\'\]'
      }
    }, [_c('el-input', {
      on: {
        "input": function($event) {
          return _vm.validateCoefficient($event, jurId)
        }
      },
      model: {
        value: (jurisdict.coefficient),
        callback: function($$v) {
          _vm.$set(jurisdict, "coefficient", $$v)
        },
        expression: "jurisdict.coefficient"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'certificateNumber\'\]'
      }
    }, [_c('el-input', {
      model: {
        value: (jurisdict.certificateNumber),
        callback: function($$v) {
          _vm.$set(jurisdict, "certificateNumber", $$v)
        },
        expression: "jurisdict.certificateNumber"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-button', {
      attrs: {
        "type": "primary",
        "disabled": !jurisdict.certificateNumber
      },
      on: {
        "click": function($event) {
          return _vm.openModalCertificateDetails(jurId)
        }
      }
    }, [_vm._v("\n                        Editar\n                      ")]), _vm._v(" "), _c('el-dialog', {
      attrs: {
        "title": "Datos adicionales del certificado",
        "visible": jurisdict.certficateDetailsVisible,
        "width": "40%"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }]
    }, [_c('el-form-item', {
      attrs: {
        "label": "Desde",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'certificateFrom\'\]',
        "rules": [{
          required: true,
          message: 'Campo obligatorio',
          trigger: 'change',
        } ]
      }
    }, [_c('el-date-picker', {
      attrs: {
        "format": "dd/MM/yyyy",
        "value-format": "yyyy-MM-dd",
        "type": "date",
        "placeholder": "Seleccionar"
      },
      model: {
        value: (jurisdict.certificateFrom),
        callback: function($$v) {
          _vm.$set(jurisdict, "certificateFrom", $$v)
        },
        expression: "jurisdict.certificateFrom"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Hasta",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'certificateTo\'\]',
        "rules": [{
          required: true,
          message: 'Campo obligatorio',
          trigger: 'change',
        } ]
      }
    }, [_c('el-date-picker', {
      attrs: {
        "format": "dd/MM/yyyy",
        "value-format": "yyyy-MM-dd",
        "type": "date",
        "placeholder": "Seleccionar"
      },
      model: {
        value: (jurisdict.certificateTo),
        callback: function($$v) {
          _vm.$set(jurisdict, "certificateTo", $$v)
        },
        expression: "jurisdict.certificateTo"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Constancia",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'certificatePdf\'\]',
        "rules": [{
          required: true,
          message: 'Campo obligatorio',
          trigger: 'change',
        } ]
      }
    }, [(_vm.habModificaPdf) ? _c('el-upload', {
      ref: 'jurisdictions\[' +
        jurId +
        '\]\[\'certificatePdf\'\]',
      refInFor: true,
      staticClass: "upload-demo",
      attrs: {
        "action": _vm.serverURI + 'api/uploadFile',
        "auto-upload": true,
        "accept": "application/pdf",
        "on-success": _vm.handlePdfCertificate,
        "on-exceed": _vm.handleExceed,
        "data": {
          folder: 'altaProveedor',
        },
        "limit": 1
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "trigger",
        "size": "small",
        "type": "primary"
      },
      slot: "trigger"
    }, [_vm._v("Seleccionar archivo")]), _vm._v(" "), _c('div', {
      staticClass: "el-upload__tip",
      attrs: {
        "slot": "tip"
      },
      slot: "tip"
    }, [_vm._v("\n                                Solo se permiten archivos PDF\n                              ")])], 1) : _c('span', [(jurisdict.certificatePdf) ? _c('a', {
      staticStyle: {
        "padding-right": "20px"
      },
      attrs: {
        "href": jurisdict.certificatePdf,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o"
    }), _vm._v(" Ver\n                              ")]) : _c('span', [_vm._v(" - ")])])], 1), _vm._v(" "), _c('span', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          jurisdict.certficateDetailsVisible = false
        }
      }
    }, [_vm._v("Confirmar")])], 1)], 1)])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'retentionAgentHas\'\]'
      }
    }, [_c('el-switch', {
      attrs: {
        "active-text": "Si",
        "inactive-text": "No",
        "active-value": "1",
        "inactive-value": "0"
      },
      on: {
        "change": function($event) {
          return _vm.openModalRetentionAgent(jurId)
        }
      },
      model: {
        value: (jurisdict.retentionAgentHas),
        callback: function($$v) {
          _vm.$set(jurisdict, "retentionAgentHas", $$v)
        },
        expression: "jurisdict.retentionAgentHas"
      }
    }), _vm._v(" "), (jurisdict.retentionAgentHas === '1') ? _c('el-button', {
      staticStyle: {
        "margin-left": "5px"
      },
      attrs: {
        "type": "success",
        "size": "small",
        "circle": "",
        "icon": "el-icon-edit"
      },
      on: {
        "click": function($event) {
          return _vm.openModalRetentionAgent(jurId)
        }
      }
    }) : _vm._e(), _vm._v(" "), (jurisdict.retentionAgentHas === '1') ? _c('el-form-item', {
      attrs: {
        "label": "",
        "label-width": "0",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'retentionAgentPdf\'\]'
      }
    }) : _vm._e(), _vm._v(" "), (jurisdict.retentionAgentHas === '1') ? _c('el-form-item', {
      attrs: {
        "label": "",
        "label-width": "0",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'retentionAgentDate\'\]'
      }
    }) : _vm._e(), _vm._v(" "), (jurisdict.retentionAgentHas === '1') ? _c('el-dialog', {
      attrs: {
        "title": "Agente de retención.",
        "visible": jurisdict.retentionAgentVisible,
        "width": "40%",
        "before-close": function () { return (jurisdict.retentionAgentHas = '0'); }
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Fecha de alta",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'retentionAgentDate\'\]'
      }
    }, [_c('el-date-picker', {
      attrs: {
        "format": "dd/MM/yyyy",
        "value-format": "yyyy-MM-dd",
        "type": "date",
        "placeholder": "Seleccionar"
      },
      model: {
        value: (jurisdict.retentionAgentDate),
        callback: function($$v) {
          _vm.$set(jurisdict, "retentionAgentDate", $$v)
        },
        expression: "jurisdict.retentionAgentDate"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Constancia",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'retentionAgentPdf\'\]'
      }
    }, [(_vm.habModificaPdf) ? _c('el-upload', {
      ref: 'jurisdictions\[' +
        jurId +
        '\]\[\'retentionAgentPdf\'\]',
      refInFor: true,
      staticClass: "upload-demo",
      attrs: {
        "action": _vm.serverURI + 'api/uploadFile',
        "auto-upload": true,
        "accept": "application/pdf",
        "on-success": _vm.handlePdfRetentionAgent,
        "on-exceed": _vm.handleExceed,
        "data": {
          folder: 'altaProveedor',
        },
        "limit": 1
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "trigger",
        "size": "small",
        "type": "primary"
      },
      slot: "trigger"
    }, [_vm._v("Seleccionar archivo")]), _vm._v(" "), _c('div', {
      staticClass: "el-upload__tip",
      attrs: {
        "slot": "tip"
      },
      slot: "tip"
    }, [_vm._v("\n                                Solo se permiten archivos PDF\n                              ")])], 1) : _c('span', [(jurisdict.retentionAgentPdf) ? _c('a', {
      staticStyle: {
        "padding-right": "20px"
      },
      attrs: {
        "href": jurisdict.retentionAgentPdf,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o"
    }), _vm._v(" Ver\n                              ")]) : _c('span', [_vm._v(" - ")])])], 1), _vm._v(" "), _c('span', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          jurisdict.retentionAgentVisible = false
        }
      }
    }, [_vm._v("Confirmar")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'perceptionAgentHas\'\]'
      }
    }, [_c('el-col', {
      staticStyle: {
        "padding-right": "20px"
      },
      attrs: {
        "span": 25
      }
    }, [_c('el-switch', {
      attrs: {
        "active-text": "Si",
        "inactive-text": "No",
        "active-value": "1",
        "inactive-value": "0"
      },
      on: {
        "change": function($event) {
          return _vm.openModalPerceptionAgent(jurId)
        }
      },
      model: {
        value: (jurisdict.perceptionAgentHas),
        callback: function($$v) {
          _vm.$set(jurisdict, "perceptionAgentHas", $$v)
        },
        expression: "jurisdict.perceptionAgentHas"
      }
    })], 1), _vm._v(" "), (jurisdict.perceptionAgentHas === '1') ? _c('el-button', {
      staticStyle: {
        "margin-left": "5px"
      },
      attrs: {
        "type": "success",
        "size": "small",
        "circle": "",
        "icon": "el-icon-edit"
      },
      on: {
        "click": function($event) {
          return _vm.openModalPerceptionAgent(jurId)
        }
      }
    }) : _vm._e(), _vm._v(" "), (jurisdict.perceptionAgentHas === '1') ? _c('el-form-item', {
      attrs: {
        "label": "",
        "label-width": "0",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'retentionAgentPdf\'\]'
      }
    }) : _vm._e(), _vm._v(" "), (jurisdict.perceptionAgentHas === '1') ? _c('el-form-item', {
      attrs: {
        "label": "",
        "label-width": "0",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'perceptionAgentDate\'\]'
      }
    }) : _vm._e(), _vm._v(" "), (jurisdict.perceptionAgentHas === '1') ? _c('el-dialog', {
      attrs: {
        "title": "Agente de percepción.",
        "visible": jurisdict.perceptionAgentVisible,
        "width": "40%",
        "before-close": function () { return (jurisdict.perceptionAgentHas = '0'); }
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Fecha de alta",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'perceptionAgentDate\'\]'
      }
    }, [_c('el-date-picker', {
      attrs: {
        "format": "dd/MM/yyyy",
        "value-format": "yyyy-MM-dd",
        "type": "date",
        "placeholder": "Seleccionar"
      },
      model: {
        value: (jurisdict.perceptionAgentDate),
        callback: function($$v) {
          _vm.$set(jurisdict, "perceptionAgentDate", $$v)
        },
        expression: "jurisdict.perceptionAgentDate"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Constancia",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'perceptionAgentPdf\'\]'
      }
    }, [(_vm.habModificaPdf) ? _c('el-upload', {
      ref: 'jurisdictions\[' +
        jurId +
        '\]\[\'perceptionAgentPdf\'\]',
      refInFor: true,
      staticClass: "upload-demo",
      attrs: {
        "action": _vm.serverURI + 'api/uploadFile',
        "auto-upload": true,
        "accept": "application/pdf",
        "on-success": _vm.handlePdfPerceptionAgent,
        "on-exceed": _vm.handleExceed,
        "data": {
          folder: 'altaProveedor',
        },
        "limit": 1
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "trigger",
        "size": "small",
        "type": "primary"
      },
      slot: "trigger"
    }, [_vm._v("Seleccionar archivo")]), _vm._v(" "), _c('div', {
      staticClass: "el-upload__tip",
      attrs: {
        "slot": "tip"
      },
      slot: "tip"
    }, [_vm._v("\n                                Solo se permiten archivos PDF\n                              ")])], 1) : _c('span', [(jurisdict.perceptionAgentPdf) ? _c('a', {
      staticStyle: {
        "padding-right": "20px"
      },
      attrs: {
        "href": jurisdict.perceptionAgentPdf,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o"
    }), _vm._v(" Ver\n                              ")]) : _c('span', [_vm._v(" - ")])])], 1), _vm._v(" "), _c('span', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          jurisdict.perceptionAgentVisible = false
        }
      }
    }, [_vm._v("Confirmar")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), (jurisdict.idJurisdiction === '13') ? _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('el-form', {
      attrs: {
        "disabledData": false
      }
    }, [_c('el-button', {
      staticStyle: {
        "font-size": "10px"
      },
      attrs: {
        "size": "mini",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.openModalForm1276(jurId)
        }
      }
    }, [_vm._v("\n                          Seleccionar archivo\n                        ")])], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "",
        "label-width": "0",
        "prop": 'jurisdictions\[' + jurId + '\]\[\'form1276pdf\'\]',
        "rules": [{
          required: true,
          message: 'Constancia obligatoria',
          trigger: 'change',
        } ]
      }
    }), _vm._v(" "), _c('el-dialog', {
      attrs: {
        "title": "Formulario 1276",
        "visible": jurisdict.form1276Visible,
        "width": "40%"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }]
    }, [_c('el-form-item', {
      attrs: {
        "label": "Formulario 1276",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'form1276pdf\'\]',
        "rules": [{
          required: true,
          message: 'Campo obligatorio',
          trigger: 'change',
        } ]
      }
    }, [(_vm.habModificaPdf) ? _c('el-upload', {
      ref: 'jurisdictions\[' +
        jurId +
        '\]\[\'form1276pdf\'\]',
      refInFor: true,
      staticClass: "upload-demo",
      attrs: {
        "action": _vm.serverURI + 'api/uploadFile',
        "auto-upload": true,
        "accept": "application/pdf",
        "on-success": _vm.handlePdfForm1276,
        "on-exceed": _vm.handleExceed,
        "data": {
          folder: 'altaProveedor',
        },
        "limit": 1
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "trigger",
        "size": "small",
        "type": "primary"
      },
      slot: "trigger"
    }, [_vm._v("Seleccionar archivo")]), _vm._v(" "), _c('div', {
      staticClass: "el-upload__tip",
      attrs: {
        "slot": "tip"
      },
      slot: "tip"
    }, [_vm._v("\n                                Solo se permiten archivos PDF\n                              ")])], 1) : _c('span', [(jurisdict.form1276pdf) ? _c('a', {
      staticStyle: {
        "padding-right": "20px"
      },
      attrs: {
        "href": jurisdict.form1276pdf,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o"
    }), _vm._v(" Ver\n                              ")]) : _c('span', [_vm._v(" - ")])])], 1), _vm._v(" "), _c('span', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          jurisdict.form1276Visible = false
        }
      }
    }, [_vm._v("Confirmar")])], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), (['1', '2', '22', '14', '15'].includes(jurisdict.idJurisdiction)) ? _c('el-form-item', {
      staticStyle: {
        "width": "250px",
        "margin-right": "-250px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (jurisdict.agentDontOperateHere),
        expression: "jurisdict.agentDontOperateHere"
      }],
      staticStyle: {
        "width": "15px",
        "float": "left",
        "cursor": "pointer",
        "margin-right": "25px",
        "margin-top": "13px"
      },
      attrs: {
        "type": "checkbox",
        "name": "operaAqui",
        "disabled": !_vm.editing,
        "required": ""
      },
      domProps: {
        "checked": Array.isArray(jurisdict.agentDontOperateHere) ? _vm._i(jurisdict.agentDontOperateHere, null) > -1 : (jurisdict.agentDontOperateHere)
      },
      on: {
        "change": function($event) {
          var $$a = jurisdict.agentDontOperateHere,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(jurisdict, "agentDontOperateHere", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(jurisdict, "agentDontOperateHere", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(jurisdict, "agentDontOperateHere", $$c)
          }
        }
      }
    }), _c('span', {
      staticStyle: {
        "margin-left": "-80px",
        "margin-top": "15px"
      }
    }, [_vm._v("No Presta Servicio aqui")])]) : _vm._e(), _vm._v(" "), (!['1', '2', '22', '14', '15'].includes(jurisdict.idJurisdiction) && jurisdict.idJurisdiction !== '13') ? _c('el-col', {
      staticStyle: {
        "margin-left": "-75px"
      },
      attrs: {
        "span": 3
      }
    }, [(
      ((_vm.taxData.ibType === 'Multilateral' && jurId > 1) ||
        (_vm.taxData.ibType !== 'Multilateral' &&
          jurId > 0)) &&
      !_vm.provider
    ) ? _c('el-button', {
      staticStyle: {
        "padding-left": "10px"
      },
      attrs: {
        "type": "warning",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.deleteJurisdiction(jurisdict)
        }
      }
    }, [_vm._v("X")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (['1', '2', '22', '14', '15'].includes(jurisdict.idJurisdiction)) ? _c('el-col', {
      staticStyle: {
        "float": "right",
        "margin-right": "-250px"
      },
      attrs: {
        "span": 5,
        "offset": 2
      }
    }, [(
      ((_vm.taxData.ibType === 'Multilateral' && jurId > 1) ||
        (_vm.taxData.ibType !== 'Multilateral' &&
          jurId > 0)) &&
      !_vm.provider
    ) ? _c('el-button', {
      staticStyle: {
        "padding-left": "10px"
      },
      attrs: {
        "type": "warning",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.deleteJurisdiction(jurisdict)
        }
      }
    }, [_vm._v("X")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (jurisdict.idJurisdiction === '13') ? _c('el-col', {
      staticStyle: {
        "margin-left": "-25px"
      },
      attrs: {
        "span": 3
      }
    }, [(
      ((_vm.taxData.ibType === 'Multilateral' && jurId > 1) ||
        (_vm.taxData.ibType !== 'Multilateral' &&
          jurId > 0)) &&
      !_vm.provider
    ) ? _c('el-button', {
      staticStyle: {
        "padding-left": "10px"
      },
      attrs: {
        "type": "warning",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.deleteJurisdiction(jurisdict)
        }
      }
    }, [_vm._v("X")]) : _vm._e()], 1) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.taxData.ibType === 'Multilateral') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.addJurisdiction()
      }
    }
  }, [_vm._v("Agregar jurisdicción")]) : _vm._e()], 2), _vm._v(" "), _c('p', [_vm._v("** Alicuota a aplicar por el agente de retención")]), _vm._v(" "), _c('el-divider', [_vm._v("Retención Ganancias")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tipo",
      "prop": "earningsRetentionType"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "typeGanancias",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.taxData.earningsRetentionType),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "earningsRetentionType", $$v)
      },
      expression: "taxData.earningsRetentionType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Inscripto",
      "value": "Inscripto"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Exento",
      "value": "Exento"
    }
  })], 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.earningsRetentionType !=
    _vm.provider.logCompanyTaxData.earningsRetentionType
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), (
    _vm.taxData.earningsRetentionType === 'Inscripto' &&
    _vm.generalData.typeIVA !== '06'
  ) ? _c('el-form-item', {
    attrs: {
      "label": "Régimen de Retención",
      "prop": "retentionRegimen"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "retencion",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.updateRetentionCategory
    },
    model: {
      value: (_vm.taxData.retentionRegimen),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "retentionRegimen", $$v)
      },
      expression: "taxData.retentionRegimen"
    }
  }, _vm._l((_vm.retentionRegimes), function(item) {
    return _c('el-option', {
      key: item.idRetentionRegime,
      attrs: {
        "label": item.retentionRegime,
        "value": item.idRetentionRegime
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.retentionRegimen !=
    _vm.provider.logCompanyTaxData.retentionRegimen
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
    _vm.taxData.earningsRetentionType === 'Inscripto' &&
    _vm.generalData.typeIVA === '06'
  ) ? _c('el-form-item', {
    attrs: {
      "label": "Régimen de Retención",
      "prop": "retentionRegimen"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.updateRetentionCategory
    },
    model: {
      value: (_vm.taxData.retentionRegimen),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "retentionRegimen", $$v)
      },
      expression: "taxData.retentionRegimen"
    }
  }, _vm._l((_vm.retentionRegimeList), function(item) {
    return _c('el-option', {
      key: item.idRetentionRegime,
      attrs: {
        "label": item.retentionRegime,
        "value": item.idRetentionRegime
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.retentionRegimen !=
    _vm.provider.logCompanyTaxData.retentionRegimen
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.earningsRetentionType === 'Inscripto') ? _c('el-form-item', {
    attrs: {
      "label": "Categoría a retener",
      "prop": "idEarningCategoryRetain"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "categoriaR",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.taxData.idEarningCategoryRetain),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "idEarningCategoryRetain", $$v)
      },
      expression: "taxData.idEarningCategoryRetain"
    }
  }, _vm._l((_vm.retentionCategories2), function(item) {
    return _c('el-option', {
      key: item.idCategoryRetain,
      attrs: {
        "label": item.categoryRetain,
        "value": item.idCategoryRetain
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.idEarningCategoryRetain !=
    _vm.provider.logCompanyTaxData.idEarningCategoryRetain
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.user !== null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exclusión Retención Ganancias")]), _vm._v(" "), (_vm.provider && _vm.provider.certifExgain.length > 0) ? _c('span', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationExgainList()
      }
    }
  }, [_vm._v("Ver")])], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)])], 1) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exclusión Retención Ganancias")]), _vm._v(" "), (this.certificationExgainList.length > 0) ? _c('span', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationExgainList()
      }
    }
  }, [_vm._v("Ver")])], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)])], 1) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (this.user !== null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exención RG2681")]), _vm._v(" "), (_vm.provider && _vm.provider.certifRg2681.length > 0) ? _c('span', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationRg2681List()
      }
    }
  }, [_vm._v("Ver")])], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1), _vm._v(" "), _c('br'), _c('br')])], 1) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exención RG2681")]), _vm._v(" "), (this.certificationRg2681List.length > 0) ? _c('span', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationRg2681List()
      }
    }
  }, [_vm._v("Ver")])], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1), _vm._v(" "), _c('br'), _c('br')])], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": 'earningsExclusionNumber',
      "label": "Número"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.taxData.earningsExclusionNumber),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "earningsExclusionNumber", $$v)
      },
      expression: "taxData.earningsExclusionNumber"
    }
  })], 1)], 1), _vm._v(" "), (_vm.taxData.earningsExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "0px",
      "label": "",
      "prop": 'earningsExclusionFrom'
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "disabled": !_vm.taxData.earningsExclusionNumber,
      "type": "date",
      "placeholder": "Desde"
    },
    model: {
      value: (_vm.taxData.earningsExclusionFrom),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "earningsExclusionFrom", $$v)
      },
      expression: "taxData.earningsExclusionFrom"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.earningsExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "label-width": "0px",
      "prop": 'earningsExclusionTo'
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "disabled": !_vm.taxData.earningsExclusionNumber,
      "picker-options": _vm.disabledDates,
      "type": "date",
      "placeholder": "Hasta"
    },
    model: {
      value: (_vm.taxData.earningsExclusionTo),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "earningsExclusionTo", $$v)
      },
      expression: "taxData.earningsExclusionTo"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.earningsExclusionNumber !=
    _vm.provider.logCompanyTaxData.earningsExclusionNumber
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Número' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.earningsExclusionFrom !=
    _vm.provider.logCompanyTaxData.earningsExclusionFrom
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Fecha desde' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.earningsExclusionTo !=
    _vm.provider.logCompanyTaxData.earningsExclusionTo
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Fecha hasta' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.earningsExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.earningsExclusionPdf,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "* Certificado exclusión",
      "id": "uploadPdfearningsExclusion",
      "prop": "earningsExclusionPdf"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "earningsExclusionPdf", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "earningsExclusionPdf", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', [(this.user !== null) ? _c('div', [(_vm.provider && _vm.provider.certifExgain.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [(this.certificationExgainList.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e()]), _vm._v(" "), _c('el-col', [(this.user !== null) ? _c('div', [(_vm.provider && _vm.provider.certifRg2681.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [(this.certificationRg2681List.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e()])], 1), _vm._v(" "), _c('el-divider', [_vm._v("Retención SUSS")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Empleador",
      "prop": 'sussEmployeer'
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Si",
      "inactive-text": "No",
      "active-value": "1",
      "inactive-value": "0"
    },
    on: {
      "change": function($event) {
        _vm.taxData.sussEmployeer ?
          (_vm.taxData.sussRetentionRegimen =
            _vm.taxData.sussEmployeer) :
          _vm.taxData.sussEmployeer
      }
    },
    model: {
      value: (_vm.taxData.sussEmployeer),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussEmployeer", $$v)
      },
      expression: "taxData.sussEmployeer"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.sussEmployeer !=
    _vm.provider.logCompanyTaxData.sussEmployeer
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Agente de retención",
      "prop": 'retentionRegime'
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-switch', {
    attrs: {
      "disabled": _vm.taxData.sussEmployeer === '0',
      "active-value": "1",
      "inactive-value": "0",
      "active-text": "Si",
      "inactive-text": "No"
    },
    on: {
      "change": function($event) {
        return _vm.sussIdCategoryRetainClear()
      }
    },
    model: {
      value: (_vm.taxData.sussRetentionRegimen),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussRetentionRegimen", $$v)
      },
      expression: "taxData.sussRetentionRegimen"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.sussRetentionRegimen !=
    _vm.provider.logCompanyTaxData.sussRetentionRegimen
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), (
    _vm.taxData.sussEmployeer &&
    _vm.taxData.sussRetentionRegimen === '1'
  ) ? _c('el-form-item', {
    attrs: {
      "label": "Régimen a retener",
      "prop": "sussIdCategoryRetain"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.taxData.sussIdCategoryRetain),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussIdCategoryRetain", $$v)
      },
      expression: "taxData.sussIdCategoryRetain"
    }
  }, _vm._l((_vm.sussRetentionCategory), function(item) {
    return _c('el-option', {
      key: item.idCategoryRetain,
      attrs: {
        "label": item.categoryRetain,
        "value": item.idCategoryRetain
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.sussIdCategoryRetain !=
    _vm.provider.logCompanyTaxData.sussIdCategoryRetain
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
    _vm.taxData.sussEmployeer == '1' &&
    _vm.taxData.sussRetentionRegimen == '0'
  ) ? _c('el-form-item', {
    attrs: {
      "label": "Régimen a retener",
      "prop": "sussIdCategoryRetain"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.taxData.sussIdCategoryRetain),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussIdCategoryRetain", $$v)
      },
      expression: "taxData.sussIdCategoryRetain"
    }
  }, _vm._l((_vm.sussRetentionCategory), function(item) {
    return _c('el-option', {
      key: item.idCategoryRetain,
      attrs: {
        "label": item.categoryRetain,
        "value": item.idCategoryRetain
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.sussIdCategoryRetain !=
    _vm.provider.logCompanyTaxData.sussIdCategoryRetain
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.user !== null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exclusión")]), _vm._v(" "), (_vm.provider && _vm.provider.certifSuss.length > 0) ? _c('span', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationSussList()
      }
    }
  }, [_vm._v("Ver")])], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)])], 1) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exclusión")]), _vm._v(" "), (this.certificationSussList.length > 0) ? _c('span', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationSussList()
      }
    }
  }, [_vm._v("Ver")])], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)])], 1) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": 'sussExclusionNumber',
      "label": "Número"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "30"
    },
    model: {
      value: (_vm.taxData.sussExclusionNumber),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussExclusionNumber", $$v)
      },
      expression: "taxData.sussExclusionNumber"
    }
  })], 1)], 1), _vm._v(" "), (_vm.taxData.sussExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "0px",
      "label": "",
      "prop": 'sussExclusionFrom'
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "disabled": !_vm.taxData.sussExclusionNumber,
      "type": "date",
      "placeholder": "Desde"
    },
    model: {
      value: (_vm.taxData.sussExclusionFrom),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussExclusionFrom", $$v)
      },
      expression: "taxData.sussExclusionFrom"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.sussExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "label-width": "0px",
      "prop": 'sussExclusionTo'
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.disabledDates,
      "disabled": !_vm.taxData.sussExclusionNumber,
      "type": "date",
      "placeholder": "Hasta"
    },
    model: {
      value: (_vm.taxData.sussExclusionTo),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussExclusionTo", $$v)
      },
      expression: "taxData.sussExclusionTo"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.sussExclusionNumber !=
    _vm.provider.logCompanyTaxData.sussExclusionNumber
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Número' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.sussExclusionFrom !=
    _vm.provider.logCompanyTaxData.sussExclusionFrom
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Fecha desde' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.earningsExclusionTo !=
    _vm.provider.logCompanyTaxData.sussExclusionTo
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Fecha hasta' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.sussExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.sussExclusionPdf,
      "habModificaPdf": !!_vm.taxData.sussExclusionNumber,
      "titulo": "* Exclusión",
      "id": "uploadPdfExclusion",
      "prop": "sussExclusionPdf"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "sussExclusionPdf", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "sussExclusionPdf", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', [(this.user !== null) ? _c('div', [(_vm.provider && _vm.provider.certifSuss.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [(this.certificationSussList.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e()])], 1), _vm._v(" "), _c('el-divider', [_vm._v("Retención I.V.A.")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "label": "¿Es agente de retención?",
      "prop": 'ivaRetentionAgent',
      "disabled": _vm.disabledData
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Si",
      "inactive-text": "No",
      "active-value": "1",
      "inactive-value": "0",
      "disabled": _vm.disabledData
    },
    model: {
      value: (_vm.taxData.ivaRetentionAgent),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ivaRetentionAgent", $$v)
      },
      expression: "taxData.ivaRetentionAgent"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ivaRetentionAgent !=
    _vm.provider.logCompanyTaxData.ivaRetentionAgent
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (this.user !== null) ? _c('div', {
    staticStyle: {
      "padding-left": "25%"
    }
  }, [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [(_vm.provider && _vm.provider.certifRg18.length > 0) ? _c('span', [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Certificado RG18")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationRg18List()
      }
    }
  }, [_vm._v("Ver")])], 1)], 1) : _c('span', [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Certificado RG18")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('el-tag', {
    staticStyle: {
      "margin-left": "0%"
    },
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [(this.certificationRg18List.length > 0) ? _c('span', [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Certificado RG18")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationRg18List()
      }
    }
  }, [_vm._v("Ver")])], 1)], 1) : _c('span', [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Certificado RG18")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('el-tag', {
    staticStyle: {
      "margin-left": "0%"
    },
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)], 1)])], 1) : _vm._e()], 1), _vm._v(" "), (
    _vm.taxData.ivaRetentionAgent &&
    _vm.taxData.ivaRetentionAgent !== '1'
  ) ? _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.ivaResolutionPdf,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "* Resolución",
      "id": "uploadPdfResolucion",
      "prop": "sussExclusionPdf"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "ivaResolutionPdf", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "ivaResolutionPdf", $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "taxDataForm",
    attrs: {
      "model": _vm.taxData,
      "id": "formDatosImpositivos",
      "label-position": "left",
      "label-width": "25%",
      "rules": _vm.rulesTaxDataIvaResolutionPdf
    }
  }, [(
    _vm.taxData.ivaRetentionAgent &&
    _vm.taxData.ivaRetentionAgent === '1'
  ) ? _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.ivaResolutionPdf,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "* Resolución",
      "id": "ivaResolutionPdf",
      "prop": "ivaResolutionPdf"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "ivaResolutionPdf", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "ivaResolutionPdf", $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Régimen de retención",
      "prop": "ivaIdRetentionRegime"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "regimenRetencion",
      "filterable": "",
      "clearable": "",
      "disabled": _vm.disabledData
    },
    on: {
      "change": _vm.updateIvaRetentionCategory
    },
    model: {
      value: (_vm.taxData.ivaIdRetentionRegime),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ivaIdRetentionRegime", $$v)
      },
      expression: "taxData.ivaIdRetentionRegime"
    }
  }, _vm._l((_vm.retentionRegimesVAT), function(item) {
    return _c('el-option', {
      key: item.idRetentionRegime,
      attrs: {
        "label": item.retentionRegime,
        "value": item.idRetentionRegime
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ivaIdRetentionRegime !=
    _vm.provider.logCompanyTaxData.ivaIdRetentionRegime
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Categoría a retener",
      "prop": "ivaIdCategoryRetain"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "categoriaRetener",
      "filterable": "",
      "clearable": "",
      "disabled": _vm.disabledData
    },
    model: {
      value: (_vm.taxData.ivaIdCategoryRetain),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ivaIdCategoryRetain", $$v)
      },
      expression: "taxData.ivaIdCategoryRetain"
    }
  }, _vm._l((_vm.ivaRetentionCategories), function(item) {
    return _c('el-option', {
      key: item.idCategoryRetain,
      attrs: {
        "label": item.categoryRetain,
        "value": item.idCategoryRetain
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ivaIdCategoryRetain !=
    _vm.provider.logCompanyTaxData.ivaIdCategoryRetain
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1), _vm._v(" "), (this.user !== null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exclusión")]), _vm._v(" "), (_vm.provider && _vm.provider.certifRg17.length > 0) ? _c('span', [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Certificado RG17")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "0px"
    },
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationRg17List()
      }
    }
  }, [_vm._v("Ver")])], 1)], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)])], 1) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exclusión")]), _vm._v(" "), (this.certificationRg17List.length > 0) ? _c('span', [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Certificado RG17")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "0px"
    },
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationRg17List()
      }
    }
  }, [_vm._v("Ver")])], 1)], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)])], 1) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": 'ivaExclusionNumber',
      "label": "Número"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "30"
    },
    model: {
      value: (_vm.taxData.ivaExclusionNumber),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ivaExclusionNumber", $$v)
      },
      expression: "taxData.ivaExclusionNumber"
    }
  })], 1)], 1), _vm._v(" "), (_vm.taxData.ivaExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "0px",
      "label": "",
      "prop": 'ivaExclusionFrom'
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "disabled": !_vm.taxData.ivaExclusionNumber,
      "type": "date",
      "placeholder": "Desde"
    },
    model: {
      value: (_vm.taxData.ivaExclusionFrom),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ivaExclusionFrom", $$v)
      },
      expression: "taxData.ivaExclusionFrom"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.ivaExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "label-width": "0px",
      "prop": 'ivaExclusionTo'
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.disabledDates,
      "disabled": !_vm.taxData.ivaExclusionNumber,
      "type": "date",
      "placeholder": "Hasta"
    },
    model: {
      value: (_vm.taxData.ivaExclusionTo),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ivaExclusionTo", $$v)
      },
      expression: "taxData.ivaExclusionTo"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ivaExclusionNumber !=
    _vm.provider.logCompanyTaxData.ivaExclusionNumber
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Número' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ivaExclusionFrom !=
    _vm.provider.logCompanyTaxData.ivaExclusionFrom
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Fecha desde' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ivaExclusionTo !=
    _vm.provider.logCompanyTaxData.ivaExclusionTo
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Fecha hasta' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.ivaExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.ivaExclusionPdf,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "",
      "id": "ivaExclusionPdf",
      "prop": "ivaExclusionPdf"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "ivaExclusionPdf", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "ivaExclusionPdf", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', [(this.user !== null) ? _c('div', [(_vm.provider && _vm.provider.certifRg17.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [(this.certificationRg17List.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e()])], 1), _vm._v(" "), _c('el-divider', [_vm._v("Otros impuestos")]), _vm._v(" "), _c('el-form', {
    ref: "taxDataForm",
    attrs: {
      "model": _vm.taxData,
      "id": "formDatosImpositivosOi",
      "label-position": "left",
      "label-width": "25%",
      "rules": _vm.rulesTaxDataOtros,
      "disabled": _vm.disabledData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Régimen de retención",
      "prop": "otrosIdRetentionRegime"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "regimenRetencion",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.updateOtrosRetentionCategory
    },
    model: {
      value: (_vm.taxData.otrosIdRetentionRegime),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "otrosIdRetentionRegime", $$v)
      },
      expression: "taxData.otrosIdRetentionRegime"
    }
  }, _vm._l((_vm.retentionRegimesOTROS), function(item) {
    return _c('el-option', {
      key: item.idRetentionRegime,
      attrs: {
        "label": item.retentionRegime,
        "value": item.idRetentionRegime
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.otrosIdRetentionRegime !=
    _vm.provider.logCompanyTaxData.otrosIdRetentionRegime
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "taxDataForm",
    attrs: {
      "model": _vm.taxData,
      "id": "formDatosImpositivosRe",
      "label-position": "left",
      "label-width": "25%",
      "rules": _vm.rulesTaxDataOtros
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Categoría a retener",
      "prop": "otrosIdCategoryRetain"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "categoriaRetener",
      "filterable": "",
      "clearable": "",
      "disabled": _vm.disabledData
    },
    model: {
      value: (_vm.taxData.otrosIdCategoryRetain),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "otrosIdCategoryRetain", $$v)
      },
      expression: "taxData.otrosIdCategoryRetain"
    }
  }, _vm._l((_vm.otrosRetentionCategories), function(item) {
    return _c('el-option', {
      key: item.idCategoryRetain,
      attrs: {
        "label": item.categoryRetain,
        "value": item.idCategoryRetain
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.otrosIdCategoryRetain !=
    _vm.provider.logCompanyTaxData.otrosIdCategoryRetain
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.step === 3 && !_vm.provider) ? _c('el-form', {
    ref: "userDataForm",
    attrs: {
      "model": _vm.userData,
      "rules": _vm.rulesUserData,
      "label-position": "left",
      "label-width": "25%",
      "id": "formUsuario"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nombre y Apellido",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.userData.name),
      callback: function($$v) {
        _vm.$set(_vm.userData, "name", $$v)
      },
      expression: "userData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Correo electrónico",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.userData.email),
      callback: function($$v) {
        _vm.$set(_vm.userData, "email", $$v)
      },
      expression: "userData.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Contraseña",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.userData.password),
      callback: function($$v) {
        _vm.$set(_vm.userData, "password", $$v)
      },
      expression: "userData.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Repetir contraseña",
      "prop": "passwordRe",
      "rules": [{
          pattern: _vm.userData.password,
          message: 'Las contraseñas deben coincidir',
          trigger: 'change',
        },
        {
          required: true,
          message: 'Campo obligatorio',
          trigger: '',
        } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.userData.passwordRe),
      callback: function($$v) {
        _vm.$set(_vm.userData, "passwordRe", $$v)
      },
      expression: "userData.passwordRe"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider[_vm.activeTab()].idCompanyDataStatus ===
    _vm.status.ESPERANDO_CONFIRMACION &&
    !_vm.user.isProvider
  ) ? _c('div', {
    staticClass: "row text-center"
  }, [_c('el-divider', [_vm._v(" Aceptar datos ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "data-cy": "btn-rechazar"
    },
    on: {
      "click": function($event) {
        return _vm.verifyPermission()
      }
    }
  }, [_vm._v("\n                  Rechazar "), _c('i', {
    staticClass: "el-icon-close"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "data-cy": "btn-aceptar"
    },
    on: {
      "click": function($event) {
        return _vm.acceptCompanyData()
      }
    }
  }, [_vm._v("\n                  Aceptar "), _c('i', {
    staticClass: "el-icon-check"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider[_vm.activeTab()].idCompanyDataStatus ===
    _vm.status.DEVUELTO
  ) ? _c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Observaciones")])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_vm._v("\n                  " + _vm._s(_vm.provider[_vm.activeTab()].observation) + "\n                ")])]) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider[_vm.activeTab()].idCompanyDataStatus ===
    _vm.status.DEVUELTO &&
    _vm.user.isProvider
  ) ? _c('div', {
    staticClass: "row text-center"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.reSendCompanyData
    }
  }, [_vm._v("\n                  Volver a enviar los datos\n                ")])], 1) : _vm._e(), _vm._v(" "), (
    _vm.userByRoles ||
    (_vm.dataAfip &&
      (_vm.userIsAdmin || (_vm.user ? _vm.user.isProvider : true)))
  ) ? _c('el-button-group', [(_vm.step > 0 && !_vm.editing) ? _c('el-button', {
    attrs: {
      "data-cy": "btn-anterior",
      "type": "primary",
      "icon": "el-icon-arrow-left"
    },
    on: {
      "click": function($event) {
        return _vm.previousStep()
      }
    }
  }, [_vm._v("Anterior")]) : _vm._e(), _vm._v(" "), ((_vm.step < 2 || (_vm.step === 2 && !_vm.provider)) && !_vm.editing) ? _c('el-button', {
    attrs: {
      "data-cy": "btn-siguiente",
      "type": "primary",
      "icon": "el-icon-arrow-right"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("Siguiente")]) : _vm._e(), _vm._v(" "), (_vm.step === 3 && !_vm.provider) ? _c('el-button', {
    attrs: {
      "type": "success",
      "icon": "el-check"
    },
    on: {
      "click": _vm.openModalTerminosYCond
    }
  }, [_vm._v("Confirmar")]) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.response) ? _c('div', {
    staticClass: "col-md-12 text-center",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, _vm._l((_vm.response), function(field) {
    return _c('div', {
      key: field,
      staticClass: "info-box-info"
    }, _vm._l((field), function(error, index) {
      return _c('ul', {
        key: index,
        staticStyle: {
          "font-size": "6px"
        }
      }, [_vm._v("\n                        " + _vm._s(error) + "\n                      ")])
    }), 0)
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "col-md-12 text-center",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.success))])])])])]) : _vm._e()])], 1)])]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Rechazar datos",
      "visible": _vm.rejectCompanyDataVisible,
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.rejectCompanyDataVisible = $event
      }
    }
  }, [_vm._v("\n      Escriba el motivo por el cual rechaza los datos:\n      "), _c('el-input', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "textarea",
      "rows": 4,
      "maxlength": "400",
      "placeholder": "Ingrese el motivo",
      "show-word-limit": true
    },
    model: {
      value: (_vm.newObservation),
      callback: function($$v) {
        _vm.newObservation = $$v
      },
      expression: "newObservation"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.rejectCompanyData()
      }
    }
  }, [_vm._v("\n          Aceptar\n        ")])], 1)], 1)], 1)], 1) : (_vm.actualCountry === 'PE') ? _c('div', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('company-data-peru')], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-red"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-green"
  }, [_c('i', {
    staticClass: "ion ion-android-checkmark-circle"
  })])
}]}

/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.buyOrder) ? _c('div', [_c('section', {
    staticClass: "content"
  }, [(_vm.buyOrder) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('el-badge', {
    attrs: {
      "value": _vm.getBuyOrderStatusName(_vm.buyOrder.statusId),
      "type": "info"
    }
  }, [(_vm.buyOrder.nic) ? _c('span', {
    staticStyle: {
      "text-align": "left",
      "position": "relative"
    },
    style: ([_vm.buyOrder.history ? {
      'color': '#4370b7',
      'cursor': 'pointer'
    } : {}])
  }, [_c('font', {
    attrs: {
      "size": "6"
    }
  }, [_vm._v("OC: " + _vm._s(_vm.buyOrder.nic))])], 1) : _vm._e()]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "display": "inline-block",
      "float": "right",
      "transition": "all 1s"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-left"
  }), _vm._v("\n                  Volver\n                ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "position": "relative"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Razón Social")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.buyOrder.company))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Fecha de Liberación")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.buyOrder.fecha_liberacion))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("OC (PDF)")]), _vm._v(" "), (_vm.buyOrder.pdf) ? _c('td', [_c('a', {
    attrs: {
      "href": _vm.buyOrder.pdf,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v("  Ver")])]) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider && !_vm.buyOrder.pdf) ? _c('td', [_c('input', {
    ref: "fileBuyOrder",
    staticClass: "form-control-file",
    staticStyle: {
      "width": "80%",
      "float": "left"
    },
    attrs: {
      "type": "file",
      "accept": "application/pdf"
    },
    on: {
      "change": _vm.handleFileChange
    }
  }), _vm._v(" "), (_vm.showUpload) ? _c('el-button', {
    staticStyle: {
      "margin-left": "6%"
    },
    attrs: {
      "type": "primary",
      "circle": "",
      "icon": "el-icon-upload"
    },
    on: {
      "click": _vm.uploadBuyOrder
    }
  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), (!_vm.user.isProvider && _vm.buyOrder.statusId === '2' || _vm.buyOrder.statusId === '9' || _vm.buyOrder.statusId === '3') ? _c('tr', [_c('th', [_vm._v("Cargar código de Operación")]), _vm._v(" "), _c('td', [_c('upload-order', {
    attrs: {
      "idBuyOrder": _vm.buyOrder.idBuyOrder
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider && _vm.buyOrder.statusId === '1') ? _c('tr', [_c('th'), _vm._v(" "), _c('td', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.activarBuyOrder()
      }
    }
  }, [_vm._v("Activar "), _c('i', {
    staticClass: "el-icon-check"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.rechazarBuyOrder()
      }
    }
  }, [_vm._v("Rechazar "), _c('i', {
    staticClass: "el-icon-close"
  })])], 1)]) : _vm._e(), _vm._v(" "), (_vm.buyOrder.hes.length > 0) ? _c('tr', [_c('th', [_vm._v("HES Asociada")]), _vm._v(" "), _c('td', _vm._l((_vm.buyOrder.hes), function(value) {
    return _c('ul', {
      key: value.idHes
    }, [(value.number !== '0' && value.type === 'HES') ? [_vm._v("\n                              " + _vm._s(value.number) + " -\n                              " + _vm._s(value.description) + "\n                            ")] : void 0], 2)
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.buyOrder.hes.length > 0) ? _c('tr', [_c('th', [_vm._v("MIGO Asociada")]), _vm._v(" "), _c('td', _vm._l((_vm.buyOrder.hes), function(value) {
    return _c('ul', {
      key: value.idMigo
    }, [(value.number !== '0' && value.type === 'MIGO') ? [_vm._v("\n                              " + _vm._s(value.number) + " -\n                              " + _vm._s(value.description) + "\n                              ")] : void 0], 2)
  }), 0)]) : _vm._e()])])])]), _vm._v(" "), (_vm.buyOrder.documents && _vm.buyOrder.statusId >= '3') ? _c('div', [_c('h2', [_vm._v(" Documentos (Facturas, NC, ND) ")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "margin-right": "15px",
      "margin": "10px"
    },
    attrs: {
      "xs": 8,
      "sm": 6,
      "md": 4
    }
  }, [_c('upload-receipt', {
    attrs: {
      "idCompany": _vm.buyOrder.idCompany,
      "idBuyOrder": _vm.buyOrder.idBuyOrder,
      "loadOperationType": false
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Tipo de documento",
      "multiple": ""
    },
    model: {
      value: (_vm.filters[0].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[0], "value", $$v)
      },
      expression: "filters[0].value"
    }
  }, _vm._l((_vm.buyOrderDocumentType), function(item) {
    return _c('el-option', {
      key: item.buyOrderDocumentType,
      attrs: {
        "value": item.idBuyOrderDocumentType,
        "label": item.description
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Estado",
      "multiple": ""
    },
    model: {
      value: (_vm.filters[1].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[1], "value", $$v)
      },
      expression: "filters[1].value"
    }
  }, _vm._l((_vm.buyOrderDocumentStatus), function(item) {
    return _c('el-option', {
      key: item.idBuyOrderDocumentStatus,
      attrs: {
        "value": item.idBuyOrderDocumentStatus,
        "label": item.description
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('data-tables', {
    attrs: {
      "data": _vm.buyOrder.documents,
      "filters": _vm.filters,
      "pagination-props": {
        pageSizes: [5, 10, 15]
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Tipo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(_vm.getTypeName(scope.row.documentType)) + "\n                    ")]
      }
    }], null, false, 3365448194)
  }), _vm._v(" "), _vm._l((_vm.titleDocument), function(title) {
    return _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "sortable": "custom"
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Estado"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(_vm.getStatusName(scope.row.idBuyOrderDocumentStatus)) + "\n                    ")]
      }
    }], null, false, 3181800591)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Código"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(scope.row.number) + "\n                    ")]
      }
    }], null, false, 1543526206)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tipo de código"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(scope.row.type) + "\n                    ")]
      }
    }], null, false, 383852069)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Archivo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.pdf !== '0') ? _c('a', {
          staticStyle: {
            "padding-right": "20px"
          },
          attrs: {
            "href": scope.row.pdf,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        }), _vm._v(" PDF\n                      ")]) : _vm._e()]
      }
    }], null, false, 3638233972)
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "-10vh",
      "overflow": "hidden"
    },
    attrs: {
      "title": "Confirmar cambios",
      "visible": _vm.showModalConfirmarDocumentacion,
      "max-width": "700px",
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalConfirmarDocumentacion = $event
      },
      "close": function($event) {
        return _vm.cerrarModalConfirmarDocumentacion()
      }
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": 'Documentos aceptados (' + _vm.documentosAceptados.length + ')'
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.documentosAceptados
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Tipo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                          " + _vm._s(_vm.getTypeName(scope.row.documentType)) + "\n                        ")]
      }
    }], null, false, 2897878530)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "date",
      "label": "Fecha"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Archivo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "padding-right": "20px"
          },
          attrs: {
            "href": scope.row.pdf,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        }), _vm._v(" PDF\n                          ")])]
      }
    }], null, false, 2690731464)
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": 'Documentos rechazados (' + _vm.documentosRechazados.length + ')'
    }
  }, [_c('el-table', {
    staticStyle: {
      "max-height": "calc("
    },
    attrs: {
      "data": _vm.documentosRechazados
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Tipo",
      "width": "130px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                          " + _vm._s(_vm.getTypeName(scope.row.documentType)) + "\n                        ")]
      }
    }], null, false, 2897878530)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "date",
      "label": "Fecha",
      "width": "200px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Archivo",
      "width": "90px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "padding-right": "20px"
          },
          attrs: {
            "href": scope.row.pdf,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        }), _vm._v(" PDF\n                          ")])]
      }
    }], null, false, 2690731464)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Mensaje",
      "span": 12
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "Seleccione un motivo"
          },
          model: {
            value: (scope.row.mensajeRechazo),
            callback: function($$v) {
              _vm.$set(scope.row, "mensajeRechazo", $$v)
            },
            expression: "scope.row.mensajeRechazo"
          }
        }, _vm._l((_vm.rejectReasons), function(reason) {
          return _c('el-option', {
            key: reason.value,
            attrs: {
              "label": reason.value,
              "value": reason.value
            }
          })
        }), 1)]
      }
    }], null, false, 974881842)
  })], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.cerrarModalConfirmarDocumentacion()
      }
    }
  }, [_vm._v("\n                    Cancelar\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.confirmarDocumentos()
      }
    }
  }, [_vm._v("\n                    Guardar\n                  ")])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Precarga de Documento (Factura / ND / NC)",
      "visible": _vm.showModalCreateDocument,
      "width": "90%",
      "lock-scroll": false,
      "max-width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalCreateDocument = $event
      },
      "close": function($event) {
        return _vm.resetNuevoDocumento()
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "150px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Fecha Vencimiento",
      "prop": "linea"
    }
  }, [_c('el-date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "Fecha Vencimiento"
    },
    model: {
      value: (_vm.nuevoDocumento.FechaVencimiento),
      callback: function($$v) {
        _vm.$set(_vm.nuevoDocumento, "FechaVencimiento", $$v)
      },
      expression: "nuevoDocumento.FechaVencimiento"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tipo",
      "prop": "linea"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Tipo de documento",
      "required": ""
    },
    model: {
      value: (_vm.nuevoDocumento.documentType),
      callback: function($$v) {
        _vm.$set(_vm.nuevoDocumento, "documentType", $$v)
      },
      expression: "nuevoDocumento.documentType"
    }
  }, _vm._l((_vm.buyOrderDocumentType), function(item) {
    return _c('el-option', {
      key: item.idBuyOrderDocumentType,
      attrs: {
        "disabled": (!(item.idBuyOrderDocumentType === '1' || _vm.tieneFacturaAceptada())) && _vm.buyOrder.nic !== null,
        "value": item.idBuyOrderDocumentType,
        "label": item.description
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Código AFIP",
      "required": ""
    },
    model: {
      value: (_vm.nuevoDocumento.documentTypeCode),
      callback: function($$v) {
        _vm.$set(_vm.nuevoDocumento, "documentTypeCode", $$v)
      },
      expression: "nuevoDocumento.documentTypeCode"
    }
  }, _vm._l((_vm.buyOrderDocumentTypeCode), function(item) {
    return _c('el-option', {
      key: item.idBuyOrderDocumentTypeCode,
      attrs: {
        "value": item.idBuyOrderDocumentTypeCode,
        "label": item.description
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tipo",
      "prop": "Nª"
    }
  }, [_c('el-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "required": "",
      "name": "letra",
      "placeholder": "Letra",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.nuevoDocumento.letra),
      callback: function($$v) {
        _vm.$set(_vm.nuevoDocumento, "letra", $$v)
      },
      expression: "nuevoDocumento.letra"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "A",
      "value": "A"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "B",
      "value": "B"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "C",
      "value": "C"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "required": "",
      "name": "puntoVenta",
      "placeholder": "Punto de Venta"
    },
    model: {
      value: (_vm.nuevoDocumento.puntoVenta),
      callback: function($$v) {
        _vm.$set(_vm.nuevoDocumento, "puntoVenta", $$v)
      },
      expression: "nuevoDocumento.puntoVenta"
    }
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "type": "text",
      "required": "",
      "name": "numero",
      "placeholder": "Numero"
    },
    model: {
      value: (_vm.nuevoDocumento.numero),
      callback: function($$v) {
        _vm.$set(_vm.nuevoDocumento, "numero", $$v)
      },
      expression: "nuevoDocumento.numero"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Moneda"
    }
  }, [_c('el-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "required": "",
      "name": "letra",
      "placeholder": " Moneda",
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.nuevoDocumento.moneda),
      callback: function($$v) {
        _vm.$set(_vm.nuevoDocumento, "moneda", $$v)
      },
      expression: "nuevoDocumento.moneda"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "$",
      "value": "$"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "U$A",
      "value": "U$A"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Tipo de Cambio"
    },
    model: {
      value: (_vm.nuevoDocumento.tipoCambio),
      callback: function($$v) {
        _vm.$set(_vm.nuevoDocumento, "tipoCambio", $$v)
      },
      expression: "nuevoDocumento.tipoCambio"
    }
  })], 1), _vm._v(" "), (_vm.buyOrder.hes.length > 0) ? [_c('el-form-item', {
    attrs: {
      "label": "Asociar HES"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "Seleccionar HES"
    },
    model: {
      value: (_vm.nuevoDocumento.hes),
      callback: function($$v) {
        _vm.$set(_vm.nuevoDocumento, "hes", $$v)
      },
      expression: "nuevoDocumento.hes"
    }
  }, _vm._l((_vm.buyOrder.hes), function(item) {
    return _c('el-option', {
      key: item.idHes,
      attrs: {
        "label": item.number + '-' + item.description,
        "value": item.idHes
      }
    })
  }), 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.buyOrder.hes.length > 0) ? [_c('el-form-item', {
    attrs: {
      "label": "Asociar MIGO"
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "Seleccionar Migo"
    },
    model: {
      value: (_vm.nuevoDocumento.migo),
      callback: function($$v) {
        _vm.$set(_vm.nuevoDocumento, "migo", $$v)
      },
      expression: "nuevoDocumento.migo"
    }
  }, _vm._l((_vm.buyOrder.migo), function(item) {
    return _c('el-option', {
      key: item.idMigo,
      attrs: {
        "label": item.number + '-' + item.description + '- Cantidad: ' + item.quantity,
        "value": item.idMigo
      }
    })
  }), 1)], 1)] : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "PDF"
    }
  }, [_c('input', {
    ref: "fileDocument",
    staticClass: "form-control-file",
    staticStyle: {
      "width": "80%",
      "float": "left"
    },
    attrs: {
      "type": "file",
      "accept": "application/pdf"
    },
    on: {
      "change": _vm.handleFileChange
    }
  })])], 2), _vm._v(" "), _c('el-divider', [_vm._v("Linea")]), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label-width": "0",
      "prop": "linea"
    }
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "align": "center",
      "type": "flex",
      "justify": "center",
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_vm._v("\n                      Código\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                      Producto/Servicio\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_vm._v("\n                      Cant.\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_vm._v("\n                      U. Medida\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      Prec. Unitario\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_vm._v("\n                      % Bon.\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      Importe Bon.\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_vm._v("\n                      Subtotal\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      Alicuota IVA\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      Subtotal C/IVA\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.nuevoDocumento.lineas), function(linea, lineaId) {
    return _c('el-row', {
      key: lineaId,
      staticStyle: {
        "text-align": "center",
        "margin-bottom": "15px"
      },
      attrs: {
        "align": "center",
        "type": "flex",
        "justify": "center",
        "gutter": 5
      }
    }, [_c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'linea.' + linea + '.codigo'
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "required": "",
        "name": "Codigo",
        "placeholder": "Codigo"
      },
      model: {
        value: (linea.codigo),
        callback: function($$v) {
          _vm.$set(linea, "codigo", $$v)
        },
        expression: "linea.codigo"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'linea.' + linea + '.descripcion'
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "required": "",
        "name": "Descripcion",
        "placeholder": "Descripcion"
      },
      model: {
        value: (linea.descripcion),
        callback: function($$v) {
          _vm.$set(linea, "descripcion", $$v)
        },
        expression: "linea.descripcion"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'linea.' + linea + '.cantidad'
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "required": "",
        "name": "Cantidad",
        "placeholder": "Cantidad"
      },
      model: {
        value: (linea.cantidad),
        callback: function($$v) {
          _vm.$set(linea, "cantidad", $$v)
        },
        expression: "linea.cantidad"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'linea.' + linea + '.medida'
      }
    }, [_c('el-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "required": "",
        "name": "Medida",
        "placeholder": "Medida",
        "filterable": "",
        "clearable": ""
      },
      model: {
        value: (linea.medida),
        callback: function($$v) {
          _vm.$set(linea, "medida", $$v)
        },
        expression: "linea.medida"
      }
    }, [_c('el-option', {
      attrs: {
        "label": "Unidades",
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "Kilogramos",
        "value": "2"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "Metros",
        "value": "3"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "Otro",
        "value": "4"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'linea.' + linea + '.precio'
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "required": "",
        "name": "precio",
        "placeholder": "precio"
      },
      on: {
        "change": function($event) {
          return _vm.updateLinea(linea)
        }
      },
      model: {
        value: (linea.precio),
        callback: function($$v) {
          _vm.$set(linea, "precio", $$v)
        },
        expression: "linea.precio"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'linea.' + linea + '.porBoni'
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "required": "",
        "name": "porBoni",
        "placeholder": "% Bonif."
      },
      on: {
        "change": function($event) {
          return _vm.updateLinea(linea)
        }
      },
      model: {
        value: (linea.porBoni),
        callback: function($$v) {
          _vm.$set(linea, "porBoni", $$v)
        },
        expression: "linea.porBoni"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'linea.' + linea + '.importeBoni'
      }
    }, [_vm._v("\n                               " + _vm._s('$' + linea.importeBoni) + "\n                      ")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'linea.' + linea + '.subtotal'
      }
    }, [_vm._v("\n                        " + _vm._s('$' + linea.subtotal) + "\n                          \n                      ")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'linea.' + linea + '.iva'
      }
    }, [_c('el-select', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "required": "",
        "name": "Iva",
        "placeholder": "Iva",
        "filterable": "",
        "clearable": ""
      },
      on: {
        "change": function($event) {
          return _vm.updateLinea(linea)
        }
      },
      model: {
        value: (linea.iva),
        callback: function($$v) {
          _vm.$set(linea, "iva", $$v)
        },
        expression: "linea.iva"
      }
    }, [_c('el-option', {
      attrs: {
        "label": "Exento",
        "value": "1"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "2,5%",
        "value": "1.025"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "0,5%",
        "value": "1.05"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "21%",
        "value": "1.21"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "27%",
        "value": "1.27"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'linea.' + linea + '.subtotalIva'
      }
    }, [_vm._v("                       \n                     " + _vm._s('$' + linea.subtotalIva) + "\n                      ")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 1
      }
    }, [_c('el-button', {
      attrs: {
        "type": "warning",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.deleteLinea(linea)
        }
      }
    }, [_vm._v("X")])], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "justify": "center"
    },
    on: {
      "click": function($event) {
        return _vm.addLinea()
      }
    }
  }, [_vm._v("Agregar linea")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-divider', [_vm._v("Otros Impuestos")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "0",
      "prop": "impuesto"
    }
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "align": "center",
      "type": "flex",
      "justify": "center",
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                      Descripción\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                      Detalle\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      Base Imponible\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      Alicuota %\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      Importe\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  })], 1), _vm._v(" "), _vm._l((_vm.nuevoDocumento.impuestos), function(impuesto, impuestoId) {
    return _c('el-row', {
      key: impuestoId,
      staticStyle: {
        "text-align": "center",
        "margin-bottom": "15px"
      },
      attrs: {
        "align": "center",
        "type": "flex",
        "justify": "center",
        "gutter": 5
      }
    }, [_c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'impuesto.' + impuesto + '.descripcion'
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "required": "",
        "name": "Descripcion",
        "placeholder": "Descripcion"
      },
      model: {
        value: (impuesto.descripcion),
        callback: function($$v) {
          _vm.$set(impuesto, "descripcion", $$v)
        },
        expression: "impuesto.descripcion"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'impuesto.' + impuesto + '.detalle'
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "required": "",
        "name": "Detalle",
        "placeholder": "Detalle"
      },
      model: {
        value: (impuesto.detalle),
        callback: function($$v) {
          _vm.$set(impuesto, "detalle", $$v)
        },
        expression: "impuesto.detalle"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'impuesto.' + impuesto + '.baseImponible'
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "required": "",
        "name": "baseImponible",
        "placeholder": "Base Imponible"
      },
      on: {
        "change": function($event) {
          return _vm.updateImpuesto(impuesto)
        }
      },
      model: {
        value: (impuesto.baseImponible),
        callback: function($$v) {
          _vm.$set(impuesto, "baseImponible", $$v)
        },
        expression: "impuesto.baseImponible"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'impuesto.' + impuesto + '.alicuota'
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "required": "",
        "name": "alicuota",
        "placeholder": "Alicuota"
      },
      on: {
        "change": function($event) {
          return _vm.updateImpuesto(impuesto)
        }
      },
      model: {
        value: (impuesto.alicuota),
        callback: function($$v) {
          _vm.$set(impuesto, "alicuota", $$v)
        },
        expression: "impuesto.alicuota"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'impuesto.' + impuesto + '.importe'
      }
    }, [_vm._v("\n                       " + _vm._s('$' + impuesto.importe) + "\n                      ")])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 1
      }
    }), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 1
      }
    }), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 1
      }
    }, [_c('el-button', {
      attrs: {
        "type": "warning",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.deleteImpuesto(impuesto)
        }
      }
    }, [_vm._v("X")])], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "justify": "center"
    },
    on: {
      "click": function($event) {
        return _vm.addImpuesto()
      }
    }
  }, [_vm._v("Agregar Impuesto")])], 1)], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "0",
      "prop": "linea"
    }
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "align": "center",
      "type": "flex",
      "justify": "center",
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "align": "center",
      "type": "flex",
      "justify": "center",
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      Total sin Impuesto\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      " + _vm._s('$' + this.nuevoDocumento.importeTotal) + "\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "align": "center",
      "type": "flex",
      "justify": "center",
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      Total con IVA\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      " + _vm._s('$' + this.nuevoDocumento.importeImpuesto) + "\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "align": "center",
      "type": "flex",
      "justify": "center",
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                      Total Otros Impuestos\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      " + _vm._s('$' + this.nuevoDocumento.importeOtrosImpuesto) + "\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "align": "center",
      "type": "flex",
      "justify": "center",
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      Total con IVA\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      " + _vm._s('$' + this.nuevoDocumento.importeImpuesto) + "\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "align": "center",
      "type": "flex",
      "justify": "center",
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                      Total con Impuestos\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      " + _vm._s('$' + this.nuevoDocumento.importeTotalImpuesto) + "\n                    ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  })], 1)], 1)], 2), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.hideModal()
      }
    }
  }, [_vm._v("\n                    Cancelar\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.createDocument()
      }
    }
  }, [_vm._v("\n                    Enviar\n                  ")])])], 1), _vm._v(" "), (_vm.buyOrderDocument) ? _c('el-dialog', {
    staticStyle: {
      "margin-top": "-10vh",
      "overflow": "hidden"
    },
    attrs: {
      "title": 'Orden de pago',
      "visible": _vm.showModalPaymentOrder,
      "width": "70%",
      "lock-scroll": false,
      "max-width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalPaymentOrder = $event
      },
      "close": function($event) {
        return _vm.resetNewPaymentOrder()
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_vm._v("Orden de Pago / Retenciones")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [(_vm.buyOrderDocument.paymentOrder && _vm.buyOrderDocument.paymentOrder.pdf) ? _c('td', [(_vm.buyOrderDocument.paymentOrder.pdf !== '0') ? _c('a', {
    attrs: {
      "href": _vm.buyOrderDocument.paymentOrder.pdf,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v("  Ver")]) : _c('span', [_vm._v("No se cargo un archivo")])]) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider && (!_vm.buyOrderDocument.paymentOrder || !_vm.buyOrderDocument.paymentOrder.pdf)) ? _c('span', [_c('input', {
    ref: "filePayment",
    staticClass: "form-control-file",
    staticStyle: {
      "width": "80%",
      "float": "left"
    },
    attrs: {
      "type": "file",
      "accept": "application/pdf"
    },
    on: {
      "change": _vm.handleFileChange
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_vm._v("Información de Pago")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('td', [(_vm.buyOrderDocument.idBuyOrderDocumentStatus === '4' && _vm.buyOrderDocument.paymentOrder) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.buyOrderDocument.paymentOrder.comment)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.buyOrderDocument.idBuyOrderDocumentStatus === '2' && !_vm.user.isProvider && !_vm.buyOrderDocument.paymentOrder) ? _c('span', [_c('vue-editor', {
    model: {
      value: (_vm.newPaymentOrder.comment),
      callback: function($$v) {
        _vm.$set(_vm.newPaymentOrder, "comment", $$v)
      },
      expression: "newPaymentOrder.comment"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.buyOrderDocument.paymentOrder) ? _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.hideModalPaymentOrder()
      }
    }
  }, [_vm._v("\n                    Cancelar\n                  ")]) : _vm._e(), _vm._v(" "), (!_vm.buyOrderDocument.paymentOrder) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.uploadPayment()
      }
    }
  }, [_vm._v("\n                    Guardar\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.buyOrderDocument.paymentOrder) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.hideModalPaymentOrder()
      }
    }
  }, [_vm._v("\n                    Aceptar\n                  ")]) : _vm._e()])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.buyOrder.historial && !_vm.user.isProvider) ? _c('h2', [_vm._v(" Historial ")]) : _vm._e(), _vm._v(" "), (_vm.buyOrder.historial && !_vm.user.isProvider) ? _c('data-tables', {
    attrs: {
      "data": _vm.buyOrder.historial,
      "pagination-props": {
        pageSizes: [5, 10, 15]
      }
    }
  }, _vm._l(([{
    'prop': 'detalle',
    'label': 'Detalle'
  }, {
    'prop': 'date',
    label: 'Fecha'
  }]), function(title) {
    return _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "default-sort": {
          prop: 'date',
          order: 'ascending'
        },
        "sortable": "custom"
      }
    })
  }), 1) : _vm._e()], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), (!_vm.user.isProvider) ? _c('div', {
    staticClass: "box-body"
  }, [_c('h4', [_vm._v(" Proveedores activos ")]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Buscar"
    },
    model: {
      value: (_vm.filters[0].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[0], "value", $$v)
      },
      expression: "filters[0].value"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('data-tables', {
    attrs: {
      "data": _vm.activeProviders,
      "pagination-props": {
        pageSizes: [10, 20, 30]
      },
      "filters": _vm.filters
    }
  }, [_vm._l((_vm.titles), function(title) {
    return _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "sortable": "custom"
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Calificación"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-rate', {
          staticStyle: {
            "float": "left"
          },
          attrs: {
            "disabled": true
          },
          model: {
            value: (scope.row.calification),
            callback: function($$v) {
              _vm.$set(scope.row, "calification", _vm._n($$v))
            },
            expression: "scope.row.calification"
          }
        })]
      }
    }], null, false, 3861342489)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Rubros"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.rubros), function(rubro, index) {
          return _c('span', {
            key: rubro.idRubro
          }, [_vm._v("\n              " + _vm._s(rubro.nombre) + "\n              "), ((index + 1) < scope.row.rubros.length) ? _c('span', [_vm._v("\n                /\n              ")]) : _vm._e()])
        })
      }
    }], null, false, 915629365)
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider && !_vm.userIsPayments) ? _c('div', {
    staticClass: "box-body"
  }, [_c('h4', [_vm._v(" Proveedores mejor calificados ")]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Buscar"
    },
    model: {
      value: (_vm.filtersCalif[0].value),
      callback: function($$v) {
        _vm.$set(_vm.filtersCalif[0], "value", $$v)
      },
      expression: "filtersCalif[0].value"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('data-tables', {
    attrs: {
      "data": _vm.calificatedProviders,
      "pagination-props": {
        pageSizes: [10, 20, 30]
      },
      "filters": _vm.filtersCalif
    }
  }, [_vm._l((_vm.titles), function(title) {
    return _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "sortable": "custom"
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Calificación"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-rate', {
          staticStyle: {
            "float": "left"
          },
          attrs: {
            "disabled": true
          },
          model: {
            value: (scope.row.calification),
            callback: function($$v) {
              _vm.$set(scope.row, "calification", _vm._n($$v))
            },
            expression: "scope.row.calification"
          }
        })]
      }
    }], null, false, 3861342489)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Rubros"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.rubros), function(rubro, index) {
          return _c('span', {
            key: rubro.idRubro
          }, [_vm._v("\n              " + _vm._s(rubro.nombre) + "\n              "), ((index + 1) < scope.row.rubros.length) ? _c('span', [_vm._v("\n                /\n              ")]) : _vm._e()])
        })
      }
    }], null, false, 915629365)
  })], 2)], 1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 graph"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border",
    attrs: {
      "id": "invoiceChart"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Operaciones por estado")])]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "nicBar"
    }
  })])])])])])
}]}

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_c('ul', {
    staticClass: "timeline"
  }, [_vm._m(0), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "timeline-item col-md-10"
  }, [_c('div', {
    staticClass: "timeline-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, _vm._l((_vm.manualsInstructive), function(manual) {
    return _c('div', {
      staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12"
    }, [_c('a', {
      staticClass: "progress-description",
      staticStyle: {
        "color": "#FFF"
      },
      attrs: {
        "href": manual.path,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "info-box",
      staticStyle: {
        "background-color": "#909090"
      }
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "info-box-content",
      staticStyle: {
        "max-height": "90px"
      }
    }, [_c('span', {
      staticClass: "info-box-number",
      staticStyle: {
        "white-space": "pre-line",
        "text-overflow": "ellipsis"
      }
    }, [_vm._v(_vm._s(manual.name))])])])])])
  }), 0)])])])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "timeline-item col-md-10"
  }, [_c('div', {
    staticClass: "timeline-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, _vm._l((_vm.manualsNorms), function(manual) {
    return _c('div', {
      staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12"
    }, [_c('a', {
      staticClass: "progress-description",
      staticStyle: {
        "color": "#FFF"
      },
      attrs: {
        "href": manual.path,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "info-box",
      staticStyle: {
        "background-color": "#909090"
      }
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "info-box-content",
      staticStyle: {
        "max-height": "90px"
      }
    }, [_c('span', {
      staticClass: "info-box-number",
      staticStyle: {
        "white-space": "pre-line",
        "text-overflow": "ellipsis"
      }
    }, [_vm._v(_vm._s(manual.name))])])])])])
  }), 0)])])])])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "time-label"
  }, [_c('span', {
    staticClass: "bg-green"
  }, [_vm._v("Instructivo del Portal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon"
  }, [_c('i', {
    staticClass: "fa fa-book"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "time-label"
  }, [_c('span', {
    staticClass: "bg-red"
  }, [_vm._v("Normas y Procedimientos para Proveedores")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon"
  }, [_c('i', {
    staticClass: "fa fa-book"
  })])
}]}

/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.response) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Advertencia")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.response))])])])])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Información")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.success))])])])])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('router-link', {
    class: 'btn btn-primary btn-lg',
    attrs: {
      "to": "/login",
      "tag": "button"
    }
  }, [_vm._v("Iniciar sesión")])], 1)]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-green"
  }, [_c('i', {
    staticClass: "ion ion-android-checkmark-circle"
  })])
}]}

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container contenedor"
  }, [_c('div', {}, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-7 col-lg-7 left-panel"
  }, [_c('div', {
    staticClass: "row formulario",
    staticStyle: {
      "float": "right"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-center loginForm"
  }, [_c('form', {
    staticClass: "separador",
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "start"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkCreds.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "name": "username",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "highlight"
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }), _vm._v(" "), _c('label', [_vm._v("Nombre de usuario")])]), _vm._v(" "), _c('div', {
    staticClass: "group",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "name": "password",
      "type": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "highlight"
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }), _vm._v(" "), _c('label', [_vm._v("Clave del usuario")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/reestablecer"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-cy": "olvidaste"
    }
  }, [_c('el-link', {
    staticStyle: {
      "font-weight": "bold",
      "position": "relative"
    },
    attrs: {
      "type": "primary",
      "underline": false
    }
  }, [_vm._v("¿Olvidaste tu contraseña?")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "margin-top": "15px",
      "width": "100%"
    }
  }, [_c('button', {
    class: 'btn btn-lg el-button--primary ' + _vm.loading,
    attrs: {
      "type": "submit"
    }
  }, [(_vm.loadingGif) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e(), _vm._v("\n              Iniciar sesión\n              ")])])], 1), _vm._v(" "), (_vm.response) ? _c('div', {
    staticClass: "text-red"
  }, [_c('p', [_vm._v(_vm._s(_vm.response))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "divider",
    staticStyle: {
      "display": "flex",
      "width": "50%",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('el-divider'), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "18px",
      "text-wrap": "nowrap",
      "margin": "0 10px 0 10px"
    }
  }, [_vm._v("¿Primera vez que ingresás?")]), _vm._v(" "), _c('el-divider')], 1), _vm._v(" "), _c('div', {
    staticClass: "create-provider"
  }, [(this.availableCountries.length === 1) ? _c('router-link', {
    attrs: {
      "to": '/userActivation' + this.availableCountries[0].codCountry
    }
  }, [_c('el-link', {
    staticClass: "create-provider_text",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "underline": false
    }
  }, [_c('el-link', {
    staticClass: "create-provider_text",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("Darse de alta")])], 1)], 1) : _c('el-link', {
    staticClass: "create-provider_text",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.flags = !_vm.flags
      }
    }
  }, [_vm._v("Darse de alta")])], 1), _vm._v(" "), (_vm.flags === true) ? _c('div', {
    staticClass: "providerflags-container"
  }, [_c('div', [(this.availableCountries.length > 0) ? _c('p', {
    staticClass: "create-provider_subtitle"
  }, [_vm._v("Seleccione en que país desea operar")]) : _c('p', {
    staticClass: "create-provider_subtitle",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("No hay países disponibles para cargar proveedores")])]), _vm._v(" "), _vm._l((_vm.availableCountries), function(country) {
    return _c('router-link', {
      key: country.codCountry,
      attrs: {
        "to": '/userActivation' + country.codCountry
      }
    }, [_c('el-link', {
      attrs: {
        "underline": false
      }
    }, [_c('img', {
      staticClass: "flag",
      attrs: {
        "src": 'static/img/' + country.codCountry + '_Flag.png'
      }
    })])], 1)
  })], 2) : _vm._e(), _vm._v(" "), _c('h6', {
    staticStyle: {
      "color": "grey",
      "margin-top": "18px"
    }
  }, [_vm._v("Operar con el Portal de Proveedores implica aceptar el "), _c('strong', [_c('el-link', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "1em"
    },
    attrs: {
      "type": "primary",
      "target": "_blank",
      "href": _vm.configuration
    }
  }, [_vm._v("\n          Código de Conducta para Proveedores")])], 1)])])]), _vm._v(" "), (_vm.entorno) ? _c('div', {
    staticClass: "entorno"
  }, [_vm._v(_vm._s(_vm.entorno))]) : _vm._e()])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    },
    attrs: {
      "href": "/"
    }
  }, [_c('div', {
    staticClass: "row logo"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/logok.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-5 col-lg-5 right-panel login-image"
  }, [_c('div', {
    staticClass: "row mx-auto my-auto"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "50%"
    }
  }, [_c('div', {
    staticClass: "titulo",
    staticStyle: {
      "background-color": "RGB(0,0,0,.7)",
      "border-radius": "3px",
      "padding": "30px"
    }
  }, [_vm._v("\n                Bienvenido al "), _c('br'), _vm._v(" Portal de Compras y Proveedores")])])])])
}]}

/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [(!_vm.paramError) ? _c('div', {
    staticClass: "row"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkIndividuals.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row entrada"
  }, [_c('label', {
    staticClass: "control-label col-lg-4 col-md-3 col-sm-3 col-xs-3 text-right",
    attrs: {
      "for": "rut"
    }
  }, [_vm._v("CUIT")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-9 col-sm-9 col-xs-9"
  }, [_c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": _vm.rutMask,
      "guide": false,
      "type": "text",
      "name": "rut",
      "id": "rut",
      "placeholder": "CUIT",
      "required": ""
    },
    model: {
      value: (_vm.rut),
      callback: function($$v) {
        _vm.rut = $$v
      },
      expression: "rut"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row entrada"
  }, [_c('label', {
    staticClass: "control-label col-lg-4 col-md-3 col-sm-3 col-xs-3 text-right",
    attrs: {
      "for": "rut"
    }
  }, [_vm._v("Tipo Documento")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-9 col-sm-9 col-xs-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.typeDoc),
      expression: "typeDoc"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "typeDoc",
      "id": "typeDoc",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.typeDoc = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "factura"
    }
  }, [_vm._v("FACTURA")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row entrada"
  }, [_c('label', {
    staticClass: "control-label col-lg-4 col-md-3 col-sm-3 col-xs-3 text-right",
    attrs: {
      "for": "rut"
    }
  }, [_vm._v("Nro Factura")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-9 col-sm-9 col-xs-9"
  }, [_c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": _vm.invoiceMask,
      "guide": false,
      "type": "text",
      "name": "numberInvoice",
      "id": "numberInvoice",
      "placeholder": "Nro Factura",
      "required": ""
    },
    model: {
      value: (_vm.numberInvoice),
      callback: function($$v) {
        _vm.numberInvoice = $$v
      },
      expression: "numberInvoice"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row entrada"
  }, [_c('label', {
    staticClass: "control-label col-lg-4 col-md-3 col-sm-3 col-xs-3 text-right",
    attrs: {
      "for": "rut"
    }
  }, [_vm._v("Fecha Emision")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-9 col-sm-9 col-xs-9"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dateEmission),
      expression: "dateEmission"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "format": "DDMMYYYY",
      "name": "dateEmission",
      "id": "dateEmission",
      "required": ""
    },
    domProps: {
      "value": (_vm.dateEmission)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateEmission = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row entrada"
  }, [_c('label', {
    staticClass: "control-label col-lg-4 col-md-3 col-sm-3 col-xs-3 text-right",
    attrs: {
      "for": "rut"
    }
  }, [_vm._v("Monto")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-9 col-sm-9 col-xs-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "amount",
      "id": "amount",
      "placeholder": "Monto",
      "required": ""
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row entrada"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
  }, [_c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Consulta")])])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.response) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Advertencia")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.response))])])])])]) : _vm._e()]), _vm._v(" "), (_vm.invoices) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    attrs: {
      "if": "invoices"
    }
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Información")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v("Fecha de Pago : " + _vm._s(_vm.invoices.datePayment))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v("Estado        : " + _vm._s(_vm.invoices.invoiceStatus))])])])])]) : _vm._e(), _vm._v(" "), (_vm.paramError) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Advertencia")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.paramError))])])])])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-green"
  }, [_c('i', {
    staticClass: "ion ion-android-checkmark-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-red"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
}]}

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('form', {
    staticClass: "sidebar-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('sidebar-menu')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "search form-control",
    attrs: {
      "type": "text",
      "name": "search",
      "id": "search",
      "data-toggle": "hideseek",
      "p": "",
      "laceholder": "Search Menus",
      "data-list": ".sidebar-menu"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-flat",
    attrs: {
      "type": "submit",
      "name": "search",
      "id": "search-btn"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])
}]}

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.changePassword.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPsw),
      expression: "newPsw"
    }],
    staticClass: "form-control col-md-12",
    attrs: {
      "type": "password",
      "name": "newPsw",
      "id": "newPsw",
      "placeholder": "Nueva clave",
      "required": ""
    },
    domProps: {
      "value": (_vm.newPsw)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPsw = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPswRe),
      expression: "newPswRe"
    }],
    staticClass: "form-control col-md-12",
    attrs: {
      "type": "password",
      "name": "newPswRe",
      "id": "newPswRe",
      "placeholder": "Repetir clave",
      "required": ""
    },
    domProps: {
      "value": (_vm.newPswRe)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPswRe = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Finalizar registro")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.response) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Advertencia")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.response))])])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 form-label"
  }, [_c('label', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "for": "newPsw"
    }
  }, [_vm._v("Nueva clave")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 form-label"
  }, [_c('label', {
    attrs: {
      "for": "newPswRe"
    }
  }, [_vm._v("Repetir clave")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
}]}

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": (_vm.type + " (sin guiones)")
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 100
    }
  }, [_c('el-col', {
    attrs: {
      "span": 21
    }
  }, [_c('el-input', {
    class: {
      'input-warning': _vm.id.model.length === 0
    },
    attrs: {
      "disabled": _vm.isDisabled || _vm.disabled,
      "maxlength": "11",
      "show-word-limit": ""
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.id.model, 'id')
      }
    },
    model: {
      value: (_vm.id.model),
      callback: function($$v) {
        _vm.$set(_vm.id, "model", $$v)
      },
      expression: "id.model"
    }
  })], 1), _vm._v(" "), (_vm.id.model.length === 0) ? _c('el-alert', {
    staticClass: "message-warning-id",
    attrs: {
      "title": "Ruc Invalido",
      "type": "error",
      "closable": false
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(!_vm.disabled) ? _c('el-button', {
    staticClass: "button-id",
    attrs: {
      "id": "verificarID",
      "size": "small",
      "disabled": _vm.idLength !== 11,
      "type": _vm.buttonType
    },
    on: {
      "click": _vm.buttonClickHandler
    }
  }, [_vm._v("\n          " + _vm._s(_vm.buttonText) + "\n        ")]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body fondo"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "info-box fondo"
  }, [_c('ul', {
    staticClass: "timeline"
  }, [_vm._m(0), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-user bg-red"
  }), _vm._v(" "), _c('div', {
    staticClass: "timeline-item col-md-10"
  }, [_c('h3', {
    staticClass: "timeline-header control-label bg-danger"
  }, [_vm._v("Nombre y apellido")]), _vm._v(" "), _c('div', {
    staticClass: "timeline-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "rows": "1",
      "name": "name",
      "id": "name",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "change": _vm.nameChange,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-envelope bg-red"
  }), _vm._v(" "), _c('div', {
    staticClass: "timeline-item col-md-10"
  }, [_c('h3', {
    staticClass: "timeline-header control-label bg-danger"
  }, [_vm._v("Correo electrónico")]), _vm._v(" "), _c('div', {
    staticClass: "timeline-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("\n                                                    " + _vm._s(_vm.user.email) + "\n                                                  ")])])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), (_vm.user.company) ? _c('li', {
    staticClass: "time-label"
  }, [_c('span', {
    staticClass: "bg-red"
  }, [_vm._v("Datos de la compañia")])]) : _vm._e(), _vm._v(" "), (_vm.user.company) ? _c('li', [_c('i', {
    staticClass: "fa fa-building bg-red"
  }), _vm._v(" "), _c('div', {
    staticClass: "timeline-item col-md-10 bg-danger"
  }, [_c('h3', {
    staticClass: "timeline-header control-label bg-danger"
  }, [_vm._v("Datos de la compañia")]), _vm._v(" "), _c('div', {
    staticClass: "timeline-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, _vm._l((_vm.availableCountries), function(country) {
    return _c('el-button', {
      key: country.codCountry,
      attrs: {
        "type": "danger",
        "disabled": _vm.idFIT != _vm.countryData[country.codCountry].idFIT
      },
      on: {
        "click": function($event) {
          _vm.currentCountry = country.codCountry
        }
      }
    }, [_vm._v("\n                                                        " + _vm._s(_vm.countryData[country.codCountry].name) + "\n                                                    ")])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [(_vm.currentCountry.length > 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.currentCountry.length <= 0
    },
    on: {
      "click": function($event) {
        return _vm.viewCompanyData(0)
      }
    }
  }, [_vm._v("Ver datos generales")]) : _vm._e(), _vm._v(" "), (_vm.currentCountry !== 'PE' && _vm.currentCountry.length > 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.currentCountry.length <= 0
    },
    on: {
      "click": function($event) {
        return _vm.viewCompanyData(1)
      }
    }
  }, [_vm._v("Ver datos bancarios")]) : _vm._e(), _vm._v(" "), (_vm.currentCountry !== 'PE' && _vm.currentCountry.length > 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.currentCountry.length <= 0
    },
    on: {
      "click": function($event) {
        return _vm.viewCompanyData(2)
      }
    }
  }, [_vm._v("Ver datos impositivos")]) : _vm._e(), _vm._v(" "), (_vm.currentCountry === 'PE') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.currentCountry.length <= 0
    },
    on: {
      "click": function($event) {
        return _vm.viewCompanyData(1)
      }
    }
  }, [_vm._v("Ver datos impositivos")]) : _vm._e(), _vm._v(" "), (_vm.currentCountry === 'PE') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.currentCountry.length <= 0
    },
    on: {
      "click": function($event) {
        return _vm.viewCompanyData(2)
      }
    }
  }, [_vm._v("Ver datos bancarios")]) : _vm._e()], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.user.isProvider) ? _c('li', [_c('i', {
    staticClass: "fa fa-building bg-blue"
  }), _vm._v(" "), _c('div', {
    staticClass: "timeline-item col-md-10"
  }, [_c('h3', {
    staticClass: "timeline-header control-label bg-green"
  }, [_vm._v("Documentación vigente")]), _vm._v(" "), _c('div', {
    staticClass: "timeline-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, _vm._l((_vm.user.documentation), function(document, index) {
    return _c('div', {
      staticClass: "col-lg-6 col-md-9 col-sm-9 col-xs-12"
    }, [_c('div', {
      staticClass: "info-box bg-blue",
      on: {
        "click": function($event) {
          return _vm.loadDocument(_vm.user.document[index].url)
        }
      }
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "info-box-content"
    }, [_c('h3', [_c('span', [_vm._v(_vm._s(document.documentName))])]), _vm._v(" "), _c('h6', [_c('span', [_vm._v("Fecha de emisión: " + _vm._s(_vm.user.document[index].emisionDate))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Fecha de alta: " + _vm._s(_vm.user.document[index].date))])])])])])
  }), 0)])])])]) : _vm._e()])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.response) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Advertencia")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.response))])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.success) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.success))])])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "time-label"
  }, [_c('span', {
    staticClass: "bg-red"
  }, [_vm._v("Datos personales")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline-footer text-center"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline-footer text-center"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon",
    staticStyle: {
      "height": "16vh",
      "width": "16vh"
    }
  }, [_c('i', {
    staticClass: "fa fa-book"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-green"
  }, [_c('i', {
    staticClass: "ion ion-android-checkmark-circle"
  })])
}]}

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "Prorrogar Compulsa",
      "visible": _vm.extendDateDialog,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.extendDateDialog = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("¿Desea notificar a los participantes de la compulsa?")]), _vm._v(" "), _c('el-switch', {
    staticStyle: {
      "display": "block",
      "margin-top": "20px"
    },
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949",
      "active-text": "Si",
      "inactive-text": "No"
    },
    model: {
      value: (_vm.checkBoxSendMail),
      callback: function($$v) {
        _vm.checkBoxSendMail = $$v
      },
      expression: "checkBoxSendMail"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.extendDateDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.extendLicitacionDate(_vm.licitacion)
      }
    }
  }, [_vm._v("Confirmar")])], 1)])]), _vm._v(" "), (_vm.licitacion) ? _c('el-dialog', {
    attrs: {
      "title": 'Proceso de Compra',
      "visible": _vm.showModalLicitacion,
      "close-on-click-modal": false,
      "width": "100%",
      "fullscreen": true,
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalLicitacion = $event
      },
      "closed": function($event) {
        return _vm.resetLicitacion()
      }
    }
  }, [_c('div', [(!_vm.user.isProvider && !_vm.licitacionTerminada() && this.licitacion.status.idLicitacionStatus !== '4' && this.licitacion.status.idLicitacionStatus !== '3') ? _c('div', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "La compulsa de precio aún no ha finalizado",
      "type": "warning",
      "closable": false,
      "description": "No se mostrarán las propuestas hasta que la licitación finalice",
      "show-icon": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider && !_vm.licitacionTerminada() && this.licitacion.status.idLicitacionStatus === '4') ? _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "La compulsa de precio ha sido cancelada",
      "type": "error",
      "closable": false,
      "description": "No se podran enviar y/o editar mas propuestas",
      "show-icon": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.user.isProvider && this.licitacion.status.idLicitacionStatus === '3') ? _c('div', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "La compulsa de precio ha finalizado",
      "type": "warning",
      "closable": false,
      "description": "No podrá enviar y/o editar una propuesta",
      "show-icon": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider && this.licitacion.status.idLicitacionStatus === '3') ? _c('div', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "La compulsa de precio ha finalizado",
      "type": "warning",
      "description": "No se podran enviar y/o editar mas propuestas",
      "closable": false,
      "show-icon": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('p', {
    staticStyle: {
      "padding-right": "30px",
      "marginBottom": "-15px",
      "font-size": "22px",
      "color": "#333333",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.licitacion.nombre))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [(_vm.licitacion.codPO != null) ? _c('p', {
    staticStyle: {
      "font-size": "13px",
      "font-weight": "bold",
      "color": "#5e6c84"
    }
  }, [_vm._v("Codigo: " + _vm._s(_vm.licitacion.codPO))]) : _vm._e(), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold",
      "color": "#172b4d"
    }
  }, [_vm._v("Descripción")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify",
      "text-justify": "auto",
      "word-break": "keep-all",
      "marginTop": "25px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.licitacion.cuerpo)
    }
  })], 1), _vm._v(" "), (_vm.licitacion) ? _c('el-col', {
    staticStyle: {
      "margin-left": "5%"
    },
    attrs: {
      "span": 4
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "12px",
      "color": "#5e6c84"
    }
  }, [_vm._v("ESTADO")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#172b4d"
    }
  }, [_vm._v(_vm._s(_vm.licitacion.status.descripcion))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px",
      "margin-top": "25px",
      "color": "#5e6c84",
      "word-break": "keep-all"
    }
  }, [_vm._v("FECHA DE INICIO")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "15px",
      "color": "#172b4d"
    }
  }, [_vm._v(_vm._s(_vm.licitacion.fecha_inicio))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px",
      "margin-top": "25px",
      "word-break": "keep-all",
      "color": "#5e6c84"
    }
  }, [_vm._v("FECHA DE FINALIZACIÓN")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "15px",
      "color": "#172b4d"
    }
  }, [_vm._v(_vm._s(_vm.licitacion.fecha_fin))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px",
      "margin-top": "25px",
      "color": "#5e6c84"
    }
  }, [_vm._v("SUPERVISOR")]), _vm._v(" "), (_vm.licitacion.supervisor != null) ? _c('div', [_c('p', {
    staticStyle: {
      "font-size": "15px",
      "color": "#172b4d"
    }
  }, [_vm._v(_vm._s(_vm.licitacion.supervisorName))])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px",
      "margin-top": "25px",
      "color": "#5e6c84"
    }
  }, [_vm._v("RESPONSABLES")]), _vm._v(" "), _vm._l((_vm.licitacion.buyersNames), function(manager, index) {
    return _c('span', {
      key: manager,
      staticStyle: {
        "font-size": "15px",
        "color": "#172b4d",
        "text-align": "justify",
        "text-justify": "auto",
        "word-break": "keep-all"
      }
    }, [(index == _vm.licitacion.buyersNames.length - 1) ? _c('span', [_vm._v(_vm._s(manager))]) : _c('span', [_vm._v(_vm._s(manager) + ", ")])])
  }), _vm._v(" "), (_vm.licitacion.buyers.length <= 0) ? _c('div', [_c('p', [_vm._v("-")])]) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider) ? _c('div', [_c('p', {
    staticStyle: {
      "font-size": "12px",
      "margin-top": "25px",
      "color": "#5e6c84"
    }
  }, [_vm._v("OFERTAS PRESENTADAS")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "word-break": "keep-all"
    }
  }, [_vm._v(_vm._s(_vm.offerAmount) + "/" + _vm._s(_vm.licitacion.proveedores.length))])]) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider && !_vm.licitacionTerminada()) ? _c('div', [_c('el-date-picker', {
    staticStyle: {
      "margin-top": "20px",
      "width": "188px"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "Seleccionar fecha",
      "picker-options": {
        disabledDate: function disabledDate(date) {
          return _vm.pastDateToday(date)
        }
      }
    },
    model: {
      value: (_vm.extensionDate),
      callback: function($$v) {
        _vm.extensionDate = $$v
      },
      expression: "extensionDate"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.extensionDate === null,
      "icon": "el-icon-timer"
    },
    on: {
      "click": function($event) {
        _vm.extendDateDialog = true
      }
    }
  }, [_vm._v("Prorrogar Compulsa")])], 1) : _vm._e()], 2) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "50px",
      "margin-right": "-1%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold",
      "color": "#172b4d"
    }
  }, [_vm._v("Archivos de la compulsa")])]), _vm._v(" "), _c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.licitacion.documents,
      "height": "auto"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "comment",
      "label": "Comentario",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "Fecha"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "PDF"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": scope.row.url,
            "target": "_blank"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-document",
            "circle": ""
          }
        })], 1)]
      }
    }], null, false, 258742780)
  })], 1)], 1)], 1), _vm._v(" "), (!_vm.user.isProvider && !_vm.licitacionTerminada()) ? _c('div', [_c('el-col', {
    staticStyle: {
      "margin-top": "5%"
    },
    attrs: {
      "span": 4,
      "offset": 1
    }
  }, [_c('div', [_c('span', {
    staticStyle: {
      "color": "#5e6c84"
    }
  }, [_vm._v("Adjuntar un documento")])]), _vm._v(" "), _c('div', [_c('el-input', {
    staticStyle: {
      "width": "70%",
      "margin-top": "10px"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "Inserte comentario"
    },
    model: {
      value: (_vm.documentComment),
      callback: function($$v) {
        _vm.documentComment = $$v
      },
      expression: "documentComment"
    }
  }), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "limit": 1,
      "accept": "application/pdf",
      "action": _vm.serverURI + 'api/uploadFile',
      "auto-upload": false,
      "on-success": _vm.handlePdfCompulsa,
      "multiple": "",
      "show-file-list": true,
      "data": {
        folder: 'documentsCompulsa'
      }
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("Seleccionar documento")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "success"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v("Subir")])], 1)], 1)])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "span": 24
    }
  }, [(!_vm.user.isProvider && _vm.licitacionTerminada()) ? _c('div', {
    staticStyle: {
      "font-size": "14px",
      "color": "#172b4d",
      "font-weight": "bold"
    }
  }, [_vm._v("Oferta"), (!_vm.user.isProvider) ? _c('span', [_vm._v("s")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.user.isProvider && _vm.licitacion.status.idLicitacionStatus === '2') ? _c('table', {
    staticClass: "table",
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold",
      "color": "#172b4d"
    }
  }, [_vm._v("Ofertas")])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Oferta técnica")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [(!_vm.licitacion.oferta_tec || _vm.editTec) ? _c('input', {
    ref: "fileOfertaTec",
    staticClass: "form-control-file",
    staticStyle: {
      "width": "80%",
      "float": "left",
      "font-size": "14px"
    },
    attrs: {
      "type": "file",
      "accept": "application/pdf",
      "data-cy": "oferta-tecnica"
    },
    on: {
      "change": function($event) {
        return _vm.uploadOferta('tec')
      }
    }
  }) : _c('div', [_c('a', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "href": _vm.licitacion.oferta_tec,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" PDF\n                            ")]), _vm._v(" "), (_vm.licitacion.visto !== '2') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-edit"
    },
    on: {
      "click": function($event) {
        _vm.editTec = true
      }
    }
  }, [_vm._v("Editar")]) : _vm._e()], 1)])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "height": "70px"
    }
  }, [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Oferta económica")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [(!_vm.licitacion.oferta_eco || _vm.editEco) ? _c('input', {
    ref: "fileOfertaEco",
    staticClass: "form-control-file",
    staticStyle: {
      "width": "80%",
      "float": "left",
      "font-size": "14px"
    },
    attrs: {
      "type": "file",
      "accept": "application/pdf",
      "data-cy": "oferta-economica"
    },
    on: {
      "change": function($event) {
        return _vm.uploadOferta('eco')
      }
    }
  }) : _c('div', [_c('a', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "href": _vm.licitacion.oferta_eco,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" PDF\n                            ")]), _vm._v(" "), (_vm.licitacion.visto !== '2') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-edit"
    },
    on: {
      "click": function($event) {
        _vm.editEco = true
      }
    }
  }, [_vm._v("Editar")]) : _vm._e()], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  })]), _c('tr', {
    attrs: {
      "width": "100%"
    }
  }, [(_vm.showUpload) ? _c('el-button', {
    staticStyle: {
      "float": "left",
      "margin-bottom": "50px"
    },
    attrs: {
      "type": "primary",
      "icon": "el-icon-upload"
    },
    on: {
      "click": _vm.uploadOfertas
    }
  }, [_vm._v("\n                        Subir ofertas\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.showUpload && _vm.canConfirm) ? _c('el-button', {
    staticStyle: {
      "margin-left": "6%",
      "margin-bottom": "50px"
    },
    attrs: {
      "type": "success",
      "icon": "el-icon-check"
    },
    on: {
      "click": _vm.confirmOfertas
    }
  }, [_vm._v("\n                        Confirmar Oferta\n                      ")]) : _vm._e()], 1), _vm._v(" "), _c('el-divider')], 1) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider && _vm.licitacion.status.idLicitacionStatus === '3') ? _c('div', [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold",
      "color": "#172b4d"
    }
  }, [_vm._v("Ofertas de los Proveedores")])]), _vm._v(" "), _c('data-tables', {
    attrs: {
      "data": _vm.licitacion.propuestas,
      "pagination-props": {
        pageSizes: [5, 10, 15]
      }
    }
  }, [_vm._l((_vm.propuestasTable), function(title) {
    return _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "sortable": "custom"
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Oferta Técnica"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "padding-right": "20px"
          },
          attrs: {
            "href": scope.row.oferta_tec,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        }), _vm._v(" PDF\n                          ")])]
      }
    }], null, false, 2169091004)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Oferta Económica"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "padding-right": "20px"
          },
          attrs: {
            "href": scope.row.oferta_eco,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        }), _vm._v(" PDF\n                          ")])]
      }
    }], null, false, 1741807207)
  })], 2)], 1) : _vm._e()]), _vm._v(" "), _c('div'), _vm._v(" "), (_vm.user.isProvider) ? _c('div', [(!_vm.licitacionTerminada()) ? _c('div', [_c('div', {
    staticStyle: {
      "color": "black",
      "font-size": "14px",
      "font-weight": "bold",
      "margin-left": "15px",
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n                    Nueva consulta")]), _vm._v(" "), _c('div', {
    staticClass: "entrada"
  }, [_c('div', [_c('el-input', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "textarea",
      "required": "",
      "placeholder": "Consulta",
      "rows": 3,
      "resize": 'vertical'
    },
    model: {
      value: (_vm.newQuestion),
      callback: function($$v) {
        _vm.newQuestion = $$v
      },
      expression: "newQuestion"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.sendConsulta(null, 0, 2)
      }
    }
  }, [_vm._v("\n                              Enviar Consulta\n                          ")])])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "font-size": "20px",
      "color": "#303133"
    }
  }, [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold",
      "color": "#172b4d"
    }
  }, [_vm._v("Tus consultas")])]), _vm._v(" "), (_vm.queries.length == 0) ? _c('el-alert', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "title": "No hay consultas",
      "type": "warning",
      "closable": false,
      "description": "Aun no has hecho ninguna consulta.",
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('el-collapse', {
    model: {
      value: (_vm.activeQuestions),
      callback: function($$v) {
        _vm.activeQuestions = $$v
      },
      expression: "activeQuestions"
    }
  }, _vm._l((_vm.questions), function(item) {
    return _c('el-collapse-item', {
      key: item.idMessage,
      attrs: {
        "name": item.idMessage
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(item.message))])]), _vm._v(" "), (item.answer) ? _c('div', {
      staticStyle: {
        "padding-left": "20px"
      }
    }, [_c('i', {
      staticClass: "far fa-comment-dots"
    }), _vm._v(" " + _vm._s(item.message) + " ")]) : _vm._e(), _vm._v(" "), (!item.answer) ? _c('div', {
      staticStyle: {
        "padding-left": "20px"
      }
    }, [_vm._v("Aun no hay respuesta para esta consulta")]) : _vm._e()], 2)
  }), 1), _vm._v(" "), (_vm.queries.length > 0) ? _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "50px"
    },
    attrs: {
      "data": _vm.queries,
      "default-expand-all": true,
      "show-header": false,
      "height": "400px"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('p', [_vm._v(_vm._s(props.row.respuesta.message))]), _vm._v(" "), (props.row.respuesta.message == '') ? _c('div', {
          staticStyle: {
            "margin-left": "3%",
            "font-size": "12px"
          }
        }, [_c('b', [_vm._v("Esta consulta aun no tiene respuesta")])]) : _vm._e()]
      }
    }], null, false, 2974492279)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "400",
      "prop": "message"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "font-size": "20px",
      "color": "#303133",
      "padding-bottom": "100px"
    }
  }, [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold",
      "color": "#172b4d"
    }
  }, [_vm._v("Consultas Frecuentes")])]), _vm._v(" "), (_vm.FAQ.length == 0) ? _c('el-alert', {
    attrs: {
      "title": "No hay consultas frecuentes",
      "type": "warning",
      "closable": false,
      "description": "Aun no se ha marcado ninguna pregunta como frecuente.",
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.FAQ.length > 0) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.FAQ,
      "default-expand-all": true,
      "show-header": false,
      "height": "400px"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('p', [_vm._v(_vm._s(props.row.respuesta.message))])]
      }
    }], null, false, 642903549)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "400",
      "prop": "message"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date"
    }
  })], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider) ? _c('div', {
    staticStyle: {
      "margin-top": "2%"
    }
  }, [(_vm.queries.length > 0) ? _c('span', {
    staticStyle: {
      "padding-left": "10px",
      "font-size": "20px",
      "color": "#303133"
    }
  }, [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold",
      "color": "#172b4d"
    }
  }, [_vm._v("Consultas")])])], 1) : _vm._e(), _vm._v(" "), (_vm.queries.length === 0) ? _c('span', {
    staticStyle: {
      "padding-left": "10px",
      "font-size": "20px",
      "color": "#303133"
    }
  }, [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold",
      "color": "#172b4d"
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.queries.length > 0) ? _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "50px"
    },
    attrs: {
      "data": _vm.queries,
      "default-expand-all": true,
      "show-header": false,
      "height": "400px"
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "300",
      "prop": "message"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "50",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(props.row.respuesta.message != '') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Consulta Frecuente",
            "placement": "left-start"
          }
        }, [_c('el-switch', {
          attrs: {
            "active-value": "1",
            "inactive-value": "2"
          },
          on: {
            "change": function($event) {
              return _vm.actualizarTipoConsulta(props.row)
            }
          },
          model: {
            value: (props.row.messageType),
            callback: function($$v) {
              _vm.$set(props.row, "messageType", $$v)
            },
            expression: "props.row.messageType"
          }
        })], 1) : _vm._e()]
      }
    }], null, false, 4051403753)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('p', [_vm._v(_vm._s(props.row.respuesta.message))]), _vm._v(" "), _c('p', {
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v(_vm._s(props.row.respuesta.name))]), _vm._v(" "), (props.row.respuesta.message == '') ? _c('div', [_c('el-input', {
          attrs: {
            "type": "textarea",
            "required": "",
            "placeholder": "Respuesta",
            "rows": 3,
            "resize": 'none'
          },
          model: {
            value: (_vm.respuestas[props.row.idMessage]),
            callback: function($$v) {
              _vm.$set(_vm.respuestas, props.row.idMessage, $$v)
            },
            expression: "respuestas[props.row.idMessage]"
          }
        }), _vm._v(" "), _c('button', {
          staticClass: "btn btn-primary",
          staticStyle: {
            "float": "right"
          },
          on: {
            "click": function($event) {
              return _vm.sendAnswer(props.row.idMessage, props.row.idEmisor, _vm.respuestas[props.row.idMessage], props.row)
            }
          }
        }, [_vm._v("Enviar Respuesta")])], 1) : _vm._e()]
      }
    }], null, false, 2066910626)
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold",
      "color": "#172b4d"
    }
  }, [_vm._v("Consultas Frecuentes")])])], 1), _vm._v(" "), (_vm.FAQ.length == 0) ? _c('el-alert', {
    attrs: {
      "title": "No hay consultas frecuentes",
      "type": "warning",
      "closable": false,
      "description": "Aun no se ha marcado ninguna pregunta como frecuente.",
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.FAQ.length > 0) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.FAQ,
      "default-expand-all": true,
      "show-header": false,
      "height": "400px"
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "250",
      "prop": "message"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Eliminar Consulta",
            "placement": "left-start"
          }
        }, [_c('el-button', {
          staticStyle: {
            "margin-left": "90px"
          },
          attrs: {
            "type": "danger",
            "size": "mini",
            "round": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteLicitacionesConsulta(props.row)
            }
          }
        }, [_vm._v("Eliminar")])], 1)]
      }
    }], null, false, 457737662)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [(props.row.idEmisor !== '1') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Consulta Frecuente",
            "placement": "left-start"
          }
        }, [_c('el-switch', {
          attrs: {
            "active-value": "1",
            "inactive-value": "2"
          },
          on: {
            "change": function($event) {
              return _vm.actualizarTipoConsulta(props.row)
            }
          },
          model: {
            value: (props.row.messageType),
            callback: function($$v) {
              _vm.$set(props.row, "messageType", $$v)
            },
            expression: "props.row.messageType"
          }
        })], 1) : _vm._e()]
      }
    }], null, false, 1240699936)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('p', [_vm._v(_vm._s(props.row.respuesta.message))])]
      }
    }], null, false, 642903549)
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider && !_vm.licitacionTerminada()) ? _c('div', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold",
      "color": "#172b4d"
    }
  }, [_vm._v("Crear nuevas consultas frecuentes")])]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-bottom": "25px",
      "margin-top": "10px"
    },
    attrs: {
      "type": "textarea",
      "required": "",
      "placeholder": "Pregunta",
      "rows": 4,
      "resize": 'none'
    },
    model: {
      value: (_vm.newQuestion),
      callback: function($$v) {
        _vm.newQuestion = $$v
      },
      expression: "newQuestion"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('el-input', {
    staticStyle: {
      "margin-left": "-15px"
    },
    attrs: {
      "type": "textarea",
      "required": "",
      "placeholder": "Respuesta",
      "rows": 3,
      "resize": 'none'
    },
    model: {
      value: (_vm.respuestaFrecuente),
      callback: function($$v) {
        _vm.respuestaFrecuente = $$v
      },
      expression: "respuestaFrecuente"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "50px"
    },
    on: {
      "click": function($event) {
        return _vm.sendConsultaFrecuente()
      }
    }
  }, [_vm._v("\n                  Agregar pregunta frecuente\n              ")])], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.providers && !_vm.user.isProvider && _vm.licitacion) ? _c('el-dialog', {
    attrs: {
      "title": 'Proveedores de la compulsa ' + _vm.licitacion.nombre,
      "visible": _vm.showModalLicitacionProviders,
      "fullscreen": true,
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalLicitacionProviders = $event
      },
      "closed": function($event) {
        _vm.licitacion = ''
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Rubro",
      "multiple": ""
    },
    model: {
      value: (_vm.filtersRubro[0].value),
      callback: function($$v) {
        _vm.$set(_vm.filtersRubro[0], "value", $$v)
      },
      expression: "filtersRubro[0].value"
    }
  }, _vm._l((_vm.rubros), function(item, index) {
    return _c('el-option', {
      key: item.idRubro,
      attrs: {
        "value": item.idRubro + index,
        "label": item.nombre
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Identificación Fiscal / Nombre"
    },
    model: {
      value: (_vm.filtersRubro[1].value),
      callback: function($$v) {
        _vm.$set(_vm.filtersRubro[1], "value", $$v)
      },
      expression: "filtersRubro[1].value"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('data-tables', {
    staticClass: "table-responsive",
    attrs: {
      "data": _vm.providersParaCompulsa,
      "pagination-props": {
        pageSizes: [10, 20, 30]
      },
      "filters": _vm.filtersRubro
    }
  }, [(_vm.needProviders(_vm.licitacion)) ? _c('el-table-column', {
    attrs: {
      "width": "55"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.providersSelected),
            expression: "providersSelected"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "value": scope.row.idCompany,
            "checked": Array.isArray(_vm.providersSelected) ? _vm._i(_vm.providersSelected, scope.row.idCompany) > -1 : (_vm.providersSelected)
          },
          on: {
            "change": function($event) {
              var $$a = _vm.providersSelected,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = scope.row.idCompany,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.providersSelected = $$a.concat([$$v]))
                } else {
                  $$i > -1 && (_vm.providersSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.providersSelected = $$c
              }
            }
          }
        })]
      }
    }], null, false, 645316143)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "fiscalId",
      "label": "Id Fiscal"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "idType",
      "label": "Id Tipo"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Proveedor"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm.getCompanyName(scope.row)) + "\n              ")]
      }
    }], null, false, 978644772)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Rubros"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.rubros), function(rubro, index) {
          return _c('span', {
            key: rubro.idRubro + index
          }, [_vm._v("\n                      " + _vm._s(rubro.nombre) + "\n                      "), ((index + 1) < scope.row.rubros.length) ? _c('span', [_vm._v("\n                        /\n                      ")]) : _vm._e()])
        })
      }
    }], null, false, 641394912)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Calificación"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "display": "none"
          }
        }, [_vm._v(_vm._s(scope.row.calification = Number(scope.row.calification)))]), _vm._v(" "), _c('el-rate', {
          attrs: {
            "disabled": ""
          },
          model: {
            value: (scope.row.calification),
            callback: function($$v) {
              _vm.$set(scope.row, "calification", $$v)
            },
            expression: "scope.row.calification"
          }
        })]
      }
    }], null, false, 2555398763)
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.needProviders(_vm.licitacion)) ? _c('div', [_c('button', {
    staticClass: "btn btn-secondary",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": function($event) {
        _vm.providersSelected = []
      }
    }
  }, [_vm._v("\n          Limpiar selección\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": _vm.guardarProveedores
    }
  }, [_vm._v("\n          Guardar proveedores\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "disabled": _vm.providersSelected.length === 0
    },
    on: {
      "click": _vm.invitarProviders
    }
  }, [_vm._v("\n          Invitar proveedor"), (_vm.providersSelected.length > 1) ? _c('span', [_vm._v("es (" + _vm._s(_vm.providersSelected.length) + ")")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.showModalLicitacionProviders = false
      }
    }
  }, [_vm._v("\n          Aceptar\n      ")])])], 1) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('el-dialog', {
    attrs: {
      "title": "Agregar una compulsa",
      "visible": _vm.showModal,
      "width": "90%",
      "lock-scroll": false,
      "max-width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      "close": function($event) {
        return _vm.resetLicitacion()
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "Nombre"
    },
    model: {
      value: (_vm.licitacionNueva.nombre),
      callback: function($$v) {
        _vm.$set(_vm.licitacionNueva, "nombre", $$v)
      },
      expression: "licitacionNueva.nombre"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Descripción")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('vue-editor', {
    model: {
      value: (_vm.licitacionNueva.cuerpo),
      callback: function($$v) {
        _vm.$set(_vm.licitacionNueva, "cuerpo", $$v)
      },
      expression: "licitacionNueva.cuerpo"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Fecha de inicio")])]), _vm._v(" "), (!_vm.editing) ? _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "Seleccionar fecha",
      "picker-options": {
        disabledDate: function disabledDate(date) {
          return _vm.pastDateToday(date)
        }
      }
    },
    on: {
      "change": function($event) {
        return _vm.checkFinalDate()
      }
    },
    model: {
      value: (_vm.licitacionNueva.fecha_inicio),
      callback: function($$v) {
        _vm.$set(_vm.licitacionNueva, "fecha_inicio", $$v)
      },
      expression: "licitacionNueva.fecha_inicio"
    }
  })], 1) : _c('div', {
    staticClass: "col-sm-9",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.licitacionNueva.fecha_inicio) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Fecha de finalización")])]), _vm._v(" "), (!_vm.editing) ? _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "Seleccionar fecha",
      "picker-options": {
        disabledDate: function disabledDate(date) {
          if (date !== null) {
            return _vm.pastDateInitialDate(date) || _vm.pastDateToday(date)
          }
        }
      }
    },
    model: {
      value: (_vm.licitacionNueva.fecha_fin),
      callback: function($$v) {
        _vm.$set(_vm.licitacionNueva, "fecha_fin", $$v)
      },
      expression: "licitacionNueva.fecha_fin"
    }
  })], 1) : _c('div', {
    staticClass: "col-sm-9",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.licitacionNueva.fecha_inicio) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Comprador")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-select', {
    attrs: {
      "required": "",
      "multiple": "",
      "placeholder": "Seleccionar Comprador"
    },
    model: {
      value: (_vm.currentIdBuyer),
      callback: function($$v) {
        _vm.currentIdBuyer = $$v
      },
      expression: "currentIdBuyer"
    }
  }, _vm._l((_vm.buyers.userJobs), function(item) {
    return _c('el-option', {
      key: item.idUser,
      attrs: {
        "value": item.idUser,
        "label": item.name
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Supervisor")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-select', {
    attrs: {
      "required": "",
      "placeholder": "Seleccionar Supervisor"
    },
    model: {
      value: (_vm.licitacionNueva.supervisor),
      callback: function($$v) {
        _vm.$set(_vm.licitacionNueva, "supervisor", $$v)
      },
      expression: "licitacionNueva.supervisor"
    }
  }, _vm._l((_vm.boss.userJobs), function(item) {
    return _c('el-option', {
      key: item.idUser,
      attrs: {
        "value": item.idUser,
        "label": item.name
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [(_vm.licitacionAlert) ? _c('el-alert', {
    attrs: {
      "type": "error",
      "closable": false,
      "show-icon": ""
    }
  }, [_c('ul', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, _vm._l((_vm.erroresLicitacion), function(error, index) {
    return _c('li', {
      key: index
    }, [_vm._v("\n                        " + _vm._s(error) + "\n                    ")])
  }), 0)]) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.guardarLicitacion()
      }
    }
  }, [_vm._v("\n        Guardar\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.hideModal()
      }
    }
  }, [_vm._v("\n        Cancelar\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {}, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-row', [(!_vm.user.isProvider) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        return _vm.openModal()
      }
    }
  }, [_vm._v("Agregar")])], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Buscar"
    },
    model: {
      value: (_vm.filters[0].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[0], "value", $$v)
      },
      expression: "filters[0].value"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "Estado"
    },
    model: {
      value: (_vm.filters[1].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[1], "value", $$v)
      },
      expression: "filters[1].value"
    }
  }, _vm._l((_vm.licitacionesStatus), function(item) {
    return _c('el-option', {
      key: item.idLicitacionStatus,
      attrs: {
        "value": item.descripcion,
        "label": item.descripcion
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('data-tables', {
    attrs: {
      "data": _vm.licitaciones,
      "pagination-props": {
        pageSizes: [10, 20, 30]
      },
      "filters": _vm.filters
    }
  }, [_vm._l((_vm.titles), function(title) {
    return _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "sortable": "custom"
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Actividad"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.status.descripcion) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), (_vm.user.isProvider) ? _c('el-table-column', {
    attrs: {
      "label": "Estado",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.visto === '0') ? _c('span', [_vm._v(" Invitado ")]) : _vm._e(), _vm._v(" "), (scope.row.visto === '1') ? _c('span', [_vm._v(" Visto ")]) : _vm._e(), _vm._v(" "), (scope.row.visto === '2') ? _c('span', [_vm._v(" Enviado ")]) : _vm._e()]
      }
    }], null, false, 3336981154)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "align": 'center',
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!_vm.user.isProvider) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Consultas a responder",
            "placement": "top-end"
          }
        }, [_c('el-badge', {
          staticClass: "item",
          attrs: {
            "value": _vm.questionsWithoutResponse(scope.row)
          }
        }, [_c('el-button', {
          staticStyle: {
            "cursor": "default"
          },
          attrs: {
            "disabled": "",
            "type": "warning",
            "size": "mini",
            "icon": "el-icon-bell",
            "circle": ""
          }
        })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Detalles",
            "placement": "top-end"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-view",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.seeDetails(scope.row)
            }
          }
        })], 1), _vm._v(" "), (!_vm.user.isProvider) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.needProviders(scope.row) ? 'Agregar proveedores' : 'Ver proveedores',
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": _vm.needProviders(scope.row) ? 'success' : 'info',
            "icon": _vm.needProviders(scope.row) ? 'el-icon-plus' : 'fa fa-user',
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.seeProviders(scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider && scope.row.status.idLicitacionStatus !== '1' && scope.row.status.idLicitacionStatus !== '4') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Cancelar compulsa",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "danger",
            "icon": "el-icon-video-pause",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.cancelarLicitacion(scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider && scope.row.status.idLicitacionStatus == '1' && scope.row.status.idLicitacionStatus !== '4') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Borrar compulsa",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "danger",
            "icon": "el-icon-delete",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.borrarLicitacion(scope.row)
            }
          }
        })], 1) : _vm._e()]
      }
    }])
  })], 2)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "prebillContainer"
  }, [_c('el-divider'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('el-form', {
    staticClass: "form-container",
    attrs: {
      "model": _vm.document,
      "label-position": "right",
      "label-width": "200px",
      "disabled": true
    }
  }, [_c('el-divider', [_vm._v("Documentación Adjunta")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-select",
    attrs: {
      "size": "small",
      "label": "Código de Documentación"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Código de Documentación"
    },
    on: {
      "change": _vm.updateDescriptionTipo
    },
    model: {
      value: (_vm.document.code),
      callback: function($$v) {
        _vm.$set(_vm.document, "code", $$v)
      },
      expression: "document.code"
    }
  }, _vm._l((_vm.hesMigo), function(item) {
    return _c('el-option', {
      key: item.idHes,
      attrs: {
        "label": item.number,
        "value": item.idHes
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', [_c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Descripción",
      "size": "small"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.document.description),
      callback: function($$v) {
        _vm.$set(_vm.document, "description", $$v)
      },
      expression: "document.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Tipo de Documentación",
      "size": "small"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.document.tipo),
      callback: function($$v) {
        _vm.$set(_vm.document, "tipo", $$v)
      },
      expression: "document.tipo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-divider', [_vm._v(" Datos del Documento ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-select",
    attrs: {
      "size": "small",
      "label": "Tipo de operación"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Tipo de operación"
    },
    model: {
      value: (_vm.document.documenttype),
      callback: function($$v) {
        _vm.$set(_vm.document, "documenttype", $$v)
      },
      expression: "document.documenttype"
    }
  }, _vm._l((_vm.documentType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Código de AFIP",
      "size": "small"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.codigoAFIP),
      callback: function($$v) {
        _vm.$set(_vm.document, "codigoAFIP", $$v)
      },
      expression: "document.codigoAFIP"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Letra",
      "size": "small"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.letra),
      callback: function($$v) {
        _vm.$set(_vm.document, "letra", $$v)
      },
      expression: "document.letra"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Número",
      "size": "small"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.numero),
      callback: function($$v) {
        _vm.$set(_vm.document, "numero", $$v)
      },
      expression: "document.numero"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Proveedor",
      "size": "small"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.document.proveedor),
      callback: function($$v) {
        _vm.$set(_vm.document, "proveedor", $$v)
      },
      expression: "document.proveedor"
    }
  }, _vm._l((_vm.providers), function(item) {
    return _c('el-option', {
      key: item.idCompany,
      attrs: {
        "label": item.company,
        "value": item.idCompany
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-divider', [_vm._v("Datos CAE")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Fecha de Vencimiento",
      "size": "small"
    }
  }, [_c('el-date-picker', {
    staticClass: "form-date",
    attrs: {
      "type": "date",
      "placeholder": "Selecciona fecha de vencimiento",
      "default-value": new Date()
    },
    model: {
      value: (_vm.document.fechaVencimiento),
      callback: function($$v) {
        _vm.$set(_vm.document, "fechaVencimiento", $$v)
      },
      expression: "document.fechaVencimiento"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Nº",
      "size": "small"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.NroCAE),
      callback: function($$v) {
        _vm.$set(_vm.document, "NroCAE", $$v)
      },
      expression: "document.NroCAE"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-upload",
    attrs: {
      "size": "small",
      "label": "PDF"
    }
  }, [_c('pdf-file', {
    staticClass: "form-pdf",
    attrs: {
      "pdfFilePath": _vm.document.pdfDoc,
      "habModificaPdf": _vm.habModificaPdf,
      "id": "documento"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.document, "pdfDoc", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.document, "pdfDoc", $event)
      }
    }
  })], 1), _vm._v(" "), (_vm.loadOperationType === true) ? _c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_vm._v("Datos de Referencia")]) : _vm._e(), _vm._v(" "), (_vm.loadOperationType === true) ? _c('el-form-item', {
    staticClass: "form-select",
    attrs: {
      "size": "small",
      "label": "Tipo de transacción"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Tipo de transacción"
    },
    model: {
      value: (_vm.document.ocType),
      callback: function($$v) {
        _vm.$set(_vm.document, "ocType", $$v)
      },
      expression: "document.ocType"
    }
  }, _vm._l((_vm.acceptanceType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.document.ocType === '1') ? _c('el-form-item', {
    key: _vm.index,
    staticClass: "form-input",
    attrs: {
      "size": "small"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', {
    staticClass: "input-text"
  }, [_vm._v("Número de operación")])]), _vm._v(" "), _c('el-col', {
    staticClass: "input-view1",
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Numero de HES"
    },
    model: {
      value: (_vm.document.ocNumber),
      callback: function($$v) {
        _vm.$set(_vm.document, "ocNumber", $$v)
      },
      expression: "document.ocNumber"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "input-view2",
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "35px"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.addOcNumber
    }
  }, [_vm._v("+")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.document.ocNumbers), function(ocNumber, index) {
    return (_vm.document.ocType === '1') ? _c('el-form-item', {
      key: index,
      staticClass: "form-input",
      attrs: {
        "size": "small"
      }
    }, [_c('el-row', [_c('el-col', {
      staticClass: "input-view1",
      attrs: {
        "span": 12
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Numero de HES"
      },
      model: {
        value: (ocNumber.value),
        callback: function($$v) {
          _vm.$set(ocNumber, "value", $$v)
        },
        expression: "ocNumber.value"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticClass: "input-view2",
      attrs: {
        "span": 12
      }
    }, [_c('el-button', {
      staticStyle: {
        "margin-left": "35px"
      },
      attrs: {
        "type": "warning"
      },
      on: {
        "click": function($event) {
          return _vm.deleteOcNumber(index)
        }
      }
    }, [_vm._v("-")])], 1)], 1)], 1) : _vm._e()
  }), _vm._v(" "), (_vm.document.ocType === '2') ? _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "size": "small"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', {
    staticClass: "input-text"
  }, [_vm._v("Número de operación")])]), _vm._v(" "), _c('el-col', {
    staticClass: "input-view1",
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Numero de MIGO"
    },
    model: {
      value: (_vm.document.migoNumber),
      callback: function($$v) {
        _vm.$set(_vm.document, "migoNumber", $$v)
      },
      expression: "document.migoNumber"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-divider', [_vm._v("Importes")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Importe Total",
      "size": "small"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.importeTotal),
      callback: function($$v) {
        _vm.$set(_vm.document, "importeTotal", $$v)
      },
      expression: "document.importeTotal"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Importe Impuesto",
      "size": "small"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.importeImpuesto),
      callback: function($$v) {
        _vm.$set(_vm.document, "importeImpuesto", $$v)
      },
      expression: "document.importeImpuesto"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Porcentaje Impuesto",
      "size": "small"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.porcentajeImpuesto),
      callback: function($$v) {
        _vm.$set(_vm.document, "porcentajeImpuesto", $$v)
      },
      expression: "document.porcentajeImpuesto"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Moneda",
      "size": "small"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.moneda),
      callback: function($$v) {
        _vm.$set(_vm.document, "moneda", $$v)
      },
      expression: "document.moneda"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Tipo de Cambio",
      "size": "small"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.tipoDeCambio),
      callback: function($$v) {
        _vm.$set(_vm.document, "tipoDeCambio", $$v)
      },
      expression: "document.tipoDeCambio"
    }
  })], 1)], 2)], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("\n                            Factura\n                        ")])])
}]}

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": _vm.modalTitle,
      "visible": _vm.showModal,
      "width": "90%",
      "lock-scroll": false,
      "max-width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Nombre")])]), _vm._v(" "), (_vm.editing) ? _c('div', {
    staticClass: "col-sm-9 contact-form-field"
  }, [_c('p', [_vm._v(_vm._s(_vm.contact.name))])]) : _c('div', {
    staticClass: "col-sm-9 contact-form-field"
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "name": "nombre",
      "required": "",
      "placeholder": "Nombre"
    },
    model: {
      value: (_vm.contact.name),
      callback: function($$v) {
        _vm.$set(_vm.contact, "name", $$v)
      },
      expression: "contact.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Email")])]), _vm._v(" "), (_vm.editing) ? _c('div', {
    staticClass: "col-sm-9 contact-form-field"
  }, [_c('p', [_vm._v(_vm._s(_vm.contact.user))])]) : _c('div', {
    staticClass: "col-sm-9 contact-form-field"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "name": "email",
      "type": "text",
      "required": "",
      "placeholder": "Email"
    },
    model: {
      value: (_vm.contact.user),
      callback: function($$v) {
        _vm.$set(_vm.contact, "user", $$v)
      },
      expression: "contact.user"
    }
  })], 1), _vm._v(" "), (_vm.user.roles.every(function (rol) { return rol.rolesId != 20; }) && this.user.isAdmin != 1) ? _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Empresa")])]) : _vm._e(), _vm._v(" "), (_vm.user.roles.every(function (rol) { return rol.rolesId != 20; }) && this.user.isAdmin != 1) ? _c('div', {
    staticClass: "col-sm-9 contact-form-field"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Seleccione Compania"
    },
    model: {
      value: (_vm.contact.idCompany),
      callback: function($$v) {
        _vm.$set(_vm.contact, "idCompany", $$v)
      },
      expression: "contact.idCompany"
    }
  }, _vm._l((_vm.providers), function(item) {
    return _c('el-option', {
      key: item.idCompany,
      attrs: {
        "label": item.company,
        "value": item.idCompany
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.user.roles.find(function (rol) { return rol.rolesId == 20; })) ? _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Empresa")])]) : _vm._e(), _vm._v(" "), (_vm.user.roles.find(function (rol) { return rol.rolesId == 20; })) ? _c('div', {
    staticClass: "col-sm-9 contact-form-field"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Seleccione Compania",
      "disabled": ""
    },
    model: {
      value: (_vm.contact.idCompany),
      callback: function($$v) {
        _vm.$set(_vm.contact, "idCompany", $$v)
      },
      expression: "contact.idCompany"
    }
  }, _vm._l((_vm.providers), function(item) {
    return _c('el-option', {
      key: item.idCompany,
      attrs: {
        "label": item.company,
        "value": item.idCompany
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('div', {
    staticClass: "col-md-9s entrada"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Estado")])]), _vm._v(" "), (_vm.user.roles.every(function (rol) { return rol.rolesId != 20; })) ? _c('div', {
    staticClass: "col-md-9 contact-form-field"
  }, [(_vm.contact.active) ? _c('el-select', {
    attrs: {
      "placeholder": "Seleccione Estado"
    },
    model: {
      value: (_vm.contact.idProviderStatus),
      callback: function($$v) {
        _vm.$set(_vm.contact, "idProviderStatus", $$v)
      },
      expression: "contact.idProviderStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "value": '2',
      "label": 'Activo'
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": '6',
      "label": 'Rechazado'
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": '5',
      "label": 'Suspendido'
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.contact.active) ? _c('p', [_vm._v("Solicitado")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.user.roles.find(function (rol) { return rol.rolesId == 20; })) ? _c('div', {
    staticClass: "col-md-9 contact-form-field"
  }, [(_vm.contact.active) ? _c('el-select', {
    attrs: {
      "placeholder": "Seleccione Estado",
      "disabled": ""
    },
    model: {
      value: (_vm.contact.idProviderStatus),
      callback: function($$v) {
        _vm.$set(_vm.contact, "idProviderStatus", $$v)
      },
      expression: "contact.idProviderStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "value": '2',
      "label": 'Activo'
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": '6',
      "label": 'Rechazado'
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": '5',
      "label": 'Suspendido'
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.contact.active) ? _c('p', [_vm._v("Solicitado")]) : _vm._e()], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.editing) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.saveContact()
      }
    }
  }, [_vm._v("\n        Guardar\n      ")]) : _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.createContact()
      }
    }
  }, [_vm._v("Crear")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.hideModal()
      }
    }
  }, [_vm._v("Cancelar")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {}, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [(_vm.user.roles.every(function (rol) { return rol.rolesId != 20; })) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.modalAddContact
    }
  }, [_vm._v("Agregar")]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Buscar"
    },
    model: {
      value: (_vm.filters[0].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[0], "value", $$v)
      },
      expression: "filters[0].value"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "Estado"
    },
    model: {
      value: (_vm.filters[1].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[1], "value", $$v)
      },
      expression: "filters[1].value"
    }
  }, _vm._l((_vm.providerStatus), function(item) {
    return _c('el-option', {
      key: item.idProviderStatus,
      attrs: {
        "value": item.idProviderStatus,
        "label": item.description
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('data-tables', {
    attrs: {
      "data": _vm.contacts,
      "pagination-props": {
        pageSizes: [10, 20, 30]
      },
      "table-props": {
        defaultSort: {
          prop: 'status',
          order: 'descending'
        }
      },
      "filters": _vm.filters
    }
  }, [_vm._l((_vm.titles), function(title) {
    return _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "sortable": "custom"
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 'Solicitado') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Enviar mail activación",
            "placement": "top"
          }
        }, [(_vm.user.roles.every(function (rol) { return rol.rolesId != 20; })) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-message",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.sendActivationMail(scope.row)
            }
          }
        }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Detalles",
            "placement": "top-end"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-view",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.viewDetails(scope.row)
            }
          }
        })], 1)]
      }
    }])
  })], 2)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "Agregar una Empresa",
      "visible": _vm.showModal,
      "width": "90%",
      "lock-scroll": false,
      "max-width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      "close": function($event) {}
    }
  }, [_c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Nombre")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Nombre de la compañia"
    },
    model: {
      value: (_vm.companyNew.nombre),
      callback: function($$v) {
        _vm.$set(_vm.companyNew, "nombre", $$v)
      },
      expression: "companyNew.nombre"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Razón Social")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "Razon Social",
      "required": "",
      "placeholder": "Razón Social"
    },
    model: {
      value: (_vm.companyNew.razonSocial),
      callback: function($$v) {
        _vm.$set(_vm.companyNew, "razonSocial", $$v)
      },
      expression: "companyNew.razonSocial"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("CUIT")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "CUIT"
    },
    model: {
      value: (_vm.companyNew.cuit),
      callback: function($$v) {
        _vm.$set(_vm.companyNew, "cuit", $$v)
      },
      expression: "companyNew.cuit"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Rubros")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-select', {
    attrs: {
      "required": "",
      "multiple": "",
      "placeholder": "Seleccionar Rubro"
    },
    model: {
      value: (_vm.currentIdRubro),
      callback: function($$v) {
        _vm.currentIdRubro = $$v
      },
      expression: "currentIdRubro"
    }
  }, _vm._l((_vm.rubros), function(item) {
    return _c('el-option', {
      key: item.idRubro,
      attrs: {
        "value": item.idRubro,
        "label": item.nombre
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Comentarios sobre la Empresa:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "maxlength": "255",
      "show-word-limit": "",
      "rows": 5
    },
    model: {
      value: (_vm.companyNew.descripcion),
      callback: function($$v) {
        _vm.$set(_vm.companyNew, "descripcion", $$v)
      },
      expression: "companyNew.descripcion"
    }
  })], 1)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.saveCompany()
      }
    }
  }, [_vm._v("Guardar")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.hideModal()
      }
    }
  }, [_vm._v("Cancelar")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Detalle",
      "visible": _vm.showModalDetails,
      "width": "90%",
      "lock-scroll": false,
      "max-width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalDetails = $event
      },
      "close": function($event) {
        this.currentIdRubro = []
      }
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.viewCompanyData(0, _vm.currentCompany.idCompany, _vm.currentCompany.codCountry)
      }
    }
  }, [_vm._v("Datos generales")]), _vm._v(" "), (_vm.currentCompany.codCountry === 'AR') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.viewCompanyData(1, _vm.currentCompany.idCompany, _vm.currentCompany.codCountry)
      }
    }
  }, [_vm._v("Datos bancarios")]) : _vm._e(), _vm._v(" "), (_vm.currentCompany.codCountry === 'PE') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.viewCompanyData(2, _vm.currentCompany.idCompany, _vm.currentCompany.codCountry)
      }
    }
  }, [_vm._v("Datos bancarios")]) : _vm._e(), _vm._v(" "), (_vm.currentCompany.codCountry === 'AR') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.viewCompanyData(2, _vm.currentCompany.idCompany, _vm.currentCompany.codCountry)
      }
    }
  }, [_vm._v("Datos impositivos")]) : _vm._e(), _vm._v(" "), (_vm.currentCompany.codCountry === 'PE') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.viewCompanyData(1, _vm.currentCompany.idCompany, _vm.currentCompany.codCountry)
      }
    }
  }, [_vm._v("Datos impositivos")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Nombre")])]), _vm._v(" "), (_vm.user.roles.every(function (rol) { return rol.rolesId != 20; })) ? _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": _vm.currentCompany.company
    },
    model: {
      value: (_vm.currentCompany.company),
      callback: function($$v) {
        _vm.$set(_vm.currentCompany, "company", $$v)
      },
      expression: "currentCompany.company"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.user.roles.find(function (rol) { return rol.rolesId == 20; })) ? _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": "",
      "required": "",
      "placeholder": _vm.currentCompany.company
    },
    model: {
      value: (_vm.currentCompany.company),
      callback: function($$v) {
        _vm.$set(_vm.currentCompany, "company", $$v)
      },
      expression: "currentCompany.company"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Razón Social")])]), _vm._v(" "), (_vm.user.roles.every(function (rol) { return rol.rolesId != 20; })) ? _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": _vm.currentCompany.companyName
    },
    model: {
      value: (_vm.currentCompany.companyName),
      callback: function($$v) {
        _vm.$set(_vm.currentCompany, "companyName", $$v)
      },
      expression: "currentCompany.companyName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.user.roles.find(function (rol) { return rol.rolesId == 20; })) ? _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": "",
      "required": "",
      "placeholder": _vm.currentCompany.companyName
    },
    model: {
      value: (_vm.currentCompany.companyName),
      callback: function($$v) {
        _vm.$set(_vm.currentCompany, "companyName", $$v)
      },
      expression: "currentCompany.companyName"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("ID FISCAL")])]), _vm._v(" "), (_vm.user.roles.every(function (rol) { return rol.rolesId != 20; })) ? _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": _vm.currentCompany.cuit
    },
    model: {
      value: (_vm.currentCompany.cuit),
      callback: function($$v) {
        _vm.$set(_vm.currentCompany, "cuit", $$v)
      },
      expression: "currentCompany.cuit"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.user.roles.find(function (rol) { return rol.rolesId == 20; })) ? _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": "",
      "required": "",
      "placeholder": _vm.currentCompany.cuit
    },
    model: {
      value: (_vm.currentCompany.cuit),
      callback: function($$v) {
        _vm.$set(_vm.currentCompany, "cuit", $$v)
      },
      expression: "currentCompany.cuit"
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.user.roles.every(function (rol) { return rol.rolesId != 20; })) ? _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Comentarios sobre la Empresa:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "maxlength": "255",
      "show-word-limit": "",
      "rows": 5
    },
    model: {
      value: (_vm.currentCompany.reasonCalification),
      callback: function($$v) {
        _vm.$set(_vm.currentCompany, "reasonCalification", $$v)
      },
      expression: "currentCompany.reasonCalification"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.user.roles.find(function (rol) { return rol.rolesId == 20; })) ? _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Comentarios sobre la Empresa:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "disabled": "",
      "maxlength": "255",
      "show-word-limit": "",
      "rows": 5
    },
    model: {
      value: (_vm.currentCompany.reasonCalification),
      callback: function($$v) {
        _vm.$set(_vm.currentCompany, "reasonCalification", $$v)
      },
      expression: "currentCompany.reasonCalification"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Información Adicional:")])]), _vm._v(" "), (_vm.user.roles.every(function (rol) { return rol.rolesId != 20; })) ? _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "required": "",
      "maxlength": "255",
      "show-word-limit": "",
      "rows": 5,
      "placeholder": _vm.currentCompany.comments
    },
    model: {
      value: (_vm.currentCompany.comments),
      callback: function($$v) {
        _vm.$set(_vm.currentCompany, "comments", $$v)
      },
      expression: "currentCompany.comments"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.user.roles.find(function (rol) { return rol.rolesId == 20; })) ? _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "disabled": "",
      "maxlength": "255",
      "show-word-limit": "",
      "rows": 5,
      "required": "",
      "placeholder": _vm.currentCompany.comments
    },
    model: {
      value: (_vm.currentCompany.comments),
      callback: function($$v) {
        _vm.$set(_vm.currentCompany, "comments", $$v)
      },
      expression: "currentCompany.comments"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.updateCompany()
      }
    }
  }, [_vm._v("Guardar")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        (_vm.showModalDetails = false), _vm.$parent.getProviders()
      }
    }
  }, [_vm._v("\n        Cancelar\n      ")])])]), _vm._v(" "), _c('div', [_c('el-dialog', {
    attrs: {
      "title": "Agregar  Comentario",
      "visible": _vm.showModalComment,
      "width": "90%",
      "lock-scroll": false,
      "max-width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalComment = $event
      },
      "close": function($event) {}
    }
  }, [_c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.updateCalification(_vm.company, 'true')
      }
    }
  }, [_vm._v("\n          Guardar\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.hideModalComment()
      }
    }
  }, [_vm._v("Cancelar")])])])], 1), _vm._v(" "), _c('div', [_c('el-dialog', {
    attrs: {
      "title": "Agregar  Comentario",
      "visible": _vm.showModalComment,
      "width": "90%",
      "lock-scroll": false,
      "max-width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalComment = $event
      },
      "close": function($event) {}
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Calificación")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-rate', {
    staticStyle: {
      "float": "left"
    },
    model: {
      value: (_vm.company.calification),
      callback: function($$v) {
        _vm.$set(_vm.company, "calification", $$v)
      },
      expression: "company.calification"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Descripción de La Empresa:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "show-word-limit": "",
      "maxlength": "256",
      "rows": 5
    },
    model: {
      value: (_vm.company.reasonCalification),
      callback: function($$v) {
        _vm.$set(_vm.company, "reasonCalification", $$v)
      },
      expression: "company.reasonCalification"
    }
  }, [_vm._v(_vm._s(_vm.company.reasonCalification))])], 1)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.updateCalification(_vm.company, 'true')
      }
    }
  }, [_vm._v("\n          Guardar\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.hideModalComment()
      }
    }
  }, [_vm._v("Cancelar")])])])], 1), _vm._v(" "), _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('el-dialog', {
    attrs: {
      "title": 'Documentación de ' + _vm.company.companyName,
      "visible": _vm.showModalDocumentation,
      "width": "40%",
      "lock-scroll": true,
      "before-close": _vm.closeDocumentation
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalDocumentation = $event
      }
    }
  }, [_vm._l((_vm.documents), function(doc, index) {
    return _c('el-row', {
      key: doc.idDocument + index,
      staticClass: "entrada"
    }, [_c('el-col', {
      staticStyle: {
        "margin-bottom": "10px"
      },
      attrs: {
        "span": 4
      }
    }, [(_vm.filteredDocuments[index]) ? _c('span', [_c('a', {
      attrs: {
        "href": _vm.filteredDocuments[index].url,
        "target": "blank"
      }
    }, [_c('el-button', {
      attrs: {
        "type": "primary",
        "icon": "el-icon-document",
        "circle": ""
      }
    })], 1)]) : _c('span', [_c('el-button', {
      attrs: {
        "type": "danger",
        "icon": "el-icon-close",
        "circle": ""
      }
    })], 1)]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin-top": "10px"
      },
      attrs: {
        "span": 12
      }
    }, [_vm._v("\n            " + _vm._s(doc.documentName) + "\n          ")]), _vm._v(" "), (_vm.previousDocuments[index]) ? _c('span', [_c('br'), _c('br'), _vm._v(" "), _c('el-tree', {
      staticStyle: {
        "color": "#1f8ef0",
        "margin-left": "50px"
      },
      attrs: {
        "data": _vm.previousDocuments[index]
      },
      on: {
        "node-click": _vm.openNodeUrl
      }
    })], 1) : _vm._e()], 1)
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.saveDocumentation
    }
  }, [_vm._v("Guardar")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.closeDocumentation
    }
  }, [_vm._v("Cancelar")])])], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": 'Operaciones de ' + _vm.company.companyName,
      "visible": _vm.showModalOperations,
      "width": "90%",
      "fullscreen": true,
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalOperations = $event
      },
      "close": function($event) {
        _vm.showModalOperations = false
      }
    }
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "max-height": "100%",
      "overflow": "auto"
    }
  }, [_c('div', {}, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 6
    }
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v(" Estado ")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "Estado",
      "multiple": ""
    },
    model: {
      value: (_vm.filtersOperations[2].value),
      callback: function($$v) {
        _vm.$set(_vm.filtersOperations[2], "value", $$v)
      },
      expression: "filtersOperations[2].value"
    }
  }, _vm._l((_vm.statusList), function(item) {
    return _c('el-option', {
      key: item.statusId,
      attrs: {
        "value": item.statusId,
        "label": item.description
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "8px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v(" OC ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "OC"
    },
    model: {
      value: (_vm.filtersOperations[0].value),
      callback: function($$v) {
        _vm.$set(_vm.filtersOperations[0], "value", $$v)
      },
      expression: "filtersOperations[0].value"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 10
    }
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v(" Fecha ")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "A",
      "start-placeholder": "Desde",
      "end-placeholder": "Hasta",
      "unlink-panels": ""
    },
    model: {
      value: (_vm.filtersOperations[1].value),
      callback: function($$v) {
        _vm.$set(_vm.filtersOperations[1], "value", $$v)
      },
      expression: "filtersOperations[1].value"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('data-tables', {
    attrs: {
      "data": _vm.company.operations,
      "pagination-props": {
        pageSizes: [5, 10, 15]
      },
      "filters": _vm.filtersOperations
    }
  }, [_vm._l((_vm.titlesOperations), function(title) {
    return _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "sortable": "custom"
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "PDF"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "padding-right": "20px"
          },
          attrs: {
            "href": scope.row.pdf,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        }), _vm._v(" Ver\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Estado",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(_vm.getStatusName(scope.row.statusId)) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Detalles",
            "placement": "top"
          }
        }, [(_vm.user.roles.every(function (rol) { return rol.rolesId != 20; })) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-view",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.goToDetails(scope.row.idBuyOrder)
            }
          }
        }) : _vm._e()], 1)]
      }
    }])
  })], 2)], 1)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeOperations
    }
  }, [_vm._v("Aceptar")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "id": "dialogUsuarioAsociado",
      "title": 'Usuarios asociados de: ' + _vm.company.companyName,
      "visible": _vm.showModalAssociatedUsers,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalAssociatedUsers = false
      }
    }
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "max-height": "100%",
      "overflow": "auto"
    }
  }, [_c('div', {}, [_c('data-tables', {
    attrs: {
      "data": _vm.company.users,
      "pagination-props": {
        pageSizes: [5, 10, 15]
      },
      "filters": _vm.filtersAssociatedUsers
    }
  }, _vm._l((_vm.titlesAssociatedUsers), function(title) {
    return _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "sortable": "custom"
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeAssociatedUsers
    }
  }, [_vm._v("Aceptar")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": 'Documentación de ' + _vm.company.companyName,
      "visible": _vm.showModalDocumentRecord,
      "width": "40%",
      "lock-scroll": true,
      "before-close": _vm.closeDocumentRecord
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalDocumentRecord = $event
      }
    }
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "max-height": "100%",
      "overflow": "auto"
    }
  }, [_c('div', {}, [_c('data-tables', {
    attrs: {
      "data": _vm.company.users,
      "pagination-props": {
        pageSizes: [5, 10, 15]
      },
      "filters": _vm.filtersDocumentRecord
    }
  }, _vm._l((_vm.titlesAssociatedUsers), function(title) {
    return _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "sortable": "custom"
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeDocumentRecord
    }
  }, [_vm._v("Aceptar")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {}, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [(_vm.user.roles.every(function (rol) { return rol.rolesId != 20; })) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        return _vm.goToNewProv()
      }
    }
  }, [_vm._v("Agregar por país")]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "1%"
    }
  }, [_c('countries-group', {
    attrs: {
      "filter": _vm.filters[2]
    },
    on: {
      "update-filter": _vm.updateFilter
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Buscar",
      "clearable": ""
    },
    on: {
      "blur": function($event) {
        _vm.filters[0].value = _vm.dummyFilter
      },
      "clear": function($event) {
        _vm.filters[0].value = _vm.dummyFilter
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.filters[0].value = _vm.dummyFilter
      }
    },
    model: {
      value: (_vm.dummyFilter),
      callback: function($$v) {
        _vm.dummyFilter = $$v
      },
      expression: "dummyFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [(_vm.newProvFlags === true) ? _c('el-col', {
    staticClass: "flags__container",
    attrs: {
      "span": 6
    }
  }, [(!_vm.paramErrorProv) ? _c('router-link', {
    attrs: {
      "to": "/userActivation"
    }
  }, [_c('el-link', {
    attrs: {
      "underline": false
    }
  }, [_c('img', {
    staticClass: "flag",
    attrs: {
      "src": "static/img/AR_Flag.png"
    }
  })])], 1) : _vm._e(), _vm._v(" "), (!_vm.paramErrorProv) ? _c('router-link', {
    attrs: {
      "to": "/userActivationPeru"
    }
  }, [_c('el-link', {
    attrs: {
      "underline": false
    }
  }, [_c('img', {
    staticClass: "flag",
    attrs: {
      "src": "static/img/PE_Flag.png"
    }
  })])], 1) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('data-tables-server', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingProviders),
      expression: "loadingProviders"
    }],
    attrs: {
      "data": _vm.providersOrdered,
      "total": _vm.totalProviders,
      "pagination-props": {
        pageSizes: [10, 20, 30]
      },
      "filters": _vm.filters
    },
    on: {
      "query-change": _vm.getProviders
    }
  }, [_vm._l((_vm.titles), function(title) {
    return _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "sortable": title.sortable
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Calificación"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-rate', {
          staticStyle: {
            "float": "left"
          },
          attrs: {
            "disabled": ""
          },
          on: {
            "change": function($event) {
              return _vm.updateCalification(scope.row, false)
            }
          },
          model: {
            value: (scope.row.calification),
            callback: function($$v) {
              _vm.$set(scope.row, "calification", _vm._n($$v))
            },
            expression: "scope.row.calification"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Rubros",
      "width": 150
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.rubros), function(rubro, index) {
          return _c('span', {
            key: rubro.idRubro + index
          }, [_vm._v("\n                  " + _vm._s(rubro.nombre) + "\n                  "), (index + 1 < scope.row.rubros.length) ? _c('span', [_vm._v(" / ")]) : _vm._e()])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "align": 'center',
      "width": 300
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.idCompanyStatus === '5') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Detalles",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "data-cy": 'btn-detalles-' + scope.row.cuit,
            "type": "info",
            "icon": "fas fa-user",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.showDetails(scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (scope.row.idCompanyStatus === '2') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Detalles",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "data-cy": 'btn-detalles-' + scope.row.cuit,
            "type": "warning",
            "icon": "fas fa-user",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.showDetails(scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (scope.row.idCompanyStatus === '2') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Usuarios asociados",
            "placement": "top-end"
          }
        }, [_c('el-button', {
          attrs: {
            "data-cy": 'btn-asoc-' + scope.row.cuit,
            "type": "primary",
            "icon": "el-icon-view",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.getAssociatedUsers(scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (scope.row.idCompanyStatus === '5' && false) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Operaciones",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "data-cy": 'btn-oper-' + scope.row.cuit,
            "type": "info",
            "icon": "el-icon-tickets",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.getOperations(scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (scope.row.idCompanyStatus === '2' && false) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Operaciones",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "data-cy": 'btn-asoc-' + scope.row.cuit,
            "type": "primary",
            "icon": "el-icon-tickets",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.getOperations(scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (scope.row.idCompanyStatus === '5' && false) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Documentación",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "data-cy": 'btn-doc-' + scope.row.cuit,
            "type": "info",
            "icon": "el-icon-document",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.getDocumentation(scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (scope.row.idCompanyStatus === '2' && false) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Documentación",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "data-cy": 'btn-doc-' + scope.row.cuit,
            "type": "success",
            "icon": "el-icon-document",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.getDocumentation(scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (scope.row.idCompanyStatus === '5') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Activar",
            "placement": "top"
          }
        }, [(_vm.user.roles.every(function (rol) { return rol.rolesId != 20; })) ? _c('el-button', {
          attrs: {
            "data-cy": 'btn-start-' + scope.row.cuit,
            "type": "success",
            "icon": "el-icon-right",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.startCompany(scope.row)
            }
          }
        }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (scope.row.idCompanyStatus === '2') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Suspender",
            "placement": "top"
          }
        }, [(_vm.user.roles.length > 0 && _vm.user.roles.every(function (rol) { return rol.rolesId != 20; })) ? _c('el-button', {
          attrs: {
            "data-cy": 'btn-stop-' + scope.row.cuit,
            "type": "danger",
            "icon": "el-icon-switch-button",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.stopCompany(scope.row)
            }
          }
        }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Comentario",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "data-cy": 'btn-comment-' + scope.row.cuit,
            "type": "info",
            "icon": "fa fa-comment",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.commentCompany(scope.row)
            }
          }
        })], 1)]
      }
    }])
  })], 2)], 1)])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "label": _vm.data.label
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    class: _vm.verifyFields(_vm.data, _vm.validation) && !_vm.disabled ? 'input-warning' : '',
    staticStyle: {
      "margin-left": "11%"
    },
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.data.placeholder,
      "required": _vm.data.required
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.data.model, _vm.data.name)
      }
    },
    model: {
      value: (_vm.data.model),
      callback: function($$v) {
        _vm.$set(_vm.data, "model", $$v)
      },
      expression: "data.model"
    }
  }, _vm._l((_vm.data.optionValue), function(option, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": option.label,
        "value": option.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 23
    }
  }, [(_vm.verifyFields(_vm.data, _vm.validation) && !_vm.disabled) ? _c('el-alert', {
    staticClass: "message-warning",
    attrs: {
      "title": ("Falta completar: " + (_vm.data.label)),
      "type": "error",
      "closable": false
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Solicitud para restablecer contraseña")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v(" Ingrese su correo electrónico al cual se le enviarán las instrucciones para reestablecer su clave.")]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    staticClass: "ui form solicitudForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkData.apply(null, arguments)
      }
    }
  }, [_c('h4', [_vm._v("Correo electrónico")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "placeholder": "Correo electrónico",
      "type": "email",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    attrs: {
      "type": "submit"
    }
  }, [(_vm.loadingGif) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e(), _vm._v("\n                    Enviar solicitud\n                    ")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.response) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Advertencia")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.response))])])])])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Información")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.success))])])])])]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "far fa-envelope",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-green"
  }, [_c('i', {
    staticClass: "ion ion-android-checkmark-circle"
  })])
}]}

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "switch-box"
  }, [_c('el-row', [_c('p', {}, [_vm._v("\n        " + _vm._s(_vm.data.label) + "\n      ")])]), _vm._v(" "), _c('el-form-item', [_c('el-switch', {
    staticStyle: {
      "--el-switch-on-color": "#13ce66",
      "--el-switch-off-color": "#ff4949"
    },
    attrs: {
      "disabled": _vm.disabled,
      "size": "",
      "active-text": "Si",
      "inactive-text": "No"
    },
    on: {
      "change": function($event) {
        return _vm.saveDataToLocalStorage(_vm.data.model, _vm.data.name)
      }
    },
    model: {
      value: (_vm.data.model),
      callback: function($$v) {
        _vm.$set(_vm.data, "model", $$v)
      },
      expression: "data.model"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.changePassword.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actualPsw),
      expression: "actualPsw"
    }],
    staticClass: "form-control col-md-12",
    attrs: {
      "type": "password",
      "name": "actualPsw",
      "id": "actualPsw",
      "placeholder": "Clave actual",
      "required": ""
    },
    domProps: {
      "value": (_vm.actualPsw)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.actualPsw = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPsw),
      expression: "newPsw"
    }],
    staticClass: "form-control col-md-12",
    attrs: {
      "type": "password",
      "name": "newPsw",
      "id": "newPsw",
      "placeholder": "Nueva clave",
      "required": ""
    },
    domProps: {
      "value": (_vm.newPsw)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPsw = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPswRe),
      expression: "newPswRe"
    }],
    staticClass: "form-control col-md-12",
    attrs: {
      "type": "password",
      "name": "newPswRe",
      "id": "newPswRe",
      "placeholder": "Repetir clave",
      "required": ""
    },
    domProps: {
      "value": (_vm.newPswRe)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPswRe = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Cambiar clave")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.response) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Advertencia")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.response))])])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "actualPsw"
    }
  }, [_vm._v("Clave Actual")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "newPsw"
    }
  }, [_vm._v("Nueva clave")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "newPswRe"
    }
  }, [_vm._v("Repetir clave")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
}]}

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('el-dialog', {
    attrs: {
      "title": "Generar OC",
      "visible": _vm.showModal,
      "width": "90%",
      "lock-scroll": false,
      "max-width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Razón Social")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "Razon Social",
      "required": "",
      "placeholder": "Razón Social"
    },
    model: {
      value: (_vm.totalBuyOrders),
      callback: function($$v) {
        _vm.totalBuyOrders = $$v
      },
      expression: "totalBuyOrders"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Fecha de liberacion")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.fecha),
      callback: function($$v) {
        _vm.fecha = $$v
      },
      expression: "fecha"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("OC")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.totalBuyOrders),
      callback: function($$v) {
        _vm.totalBuyOrders = $$v
      },
      expression: "totalBuyOrders"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("OC (PDF)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    ref: "fileBuyOrder",
    staticClass: "form-control-file",
    staticStyle: {
      "width": "80%",
      "float": "left"
    },
    attrs: {
      "type": "file",
      "accept": "application/pdf"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "6%"
    },
    attrs: {
      "type": "primary",
      "circle": "",
      "icon": "el-icon-upload"
    }
  })], 1)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.saveNIC()
      }
    }
  }, [_vm._v("\n            Guardar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")])])]), _vm._v(" "), _c('h3', [_vm._v(" Panel de control ")]), _vm._v(" "), (_vm.statusList) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "'font-size": "15px",
      "text-align": "center"
    }
  }, _vm._l((_vm.statusList), function(item) {
    return _c('th', {
      key: item.statusId,
      style: ('text-align: center; vertical-align: middle;width: ' + (100 / _vm.statusList.length) + '%')
    }, [_vm._v("asd" + _vm._s(item.description))])
  }), 0)]), _vm._v(" "), _c('tbody', [_c('tr', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingStatus),
      expression: "loadingStatus"
    }],
    staticStyle: {
      "font-size": "25px",
      "text-align": "center"
    }
  }, _vm._l((_vm.statusList), function(item) {
    return _c('td', {
      key: item.statusId,
      staticClass: "statusHover",
      on: {
        "click": function($event) {
          return _vm.searchStatus(item.statusId)
        }
      }
    }, [_vm._v(_vm._s(_vm.statusCount[item.statusId]))])
  }), 0)])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.response) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Advertencia")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.response))])])])])]) : _vm._e()]), _vm._v(" "), (_vm.$route.path === '/buyOrders') ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("Nuevo...")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('h3', [_vm._v(" Filtros ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "filter",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "xs": 24,
      "sm": 2,
      "md": 1
    }
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v(" OC ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 8,
      "md": 6
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "OC",
      "clearable": ""
    },
    on: {
      "blur": function($event) {
        _vm.filters[2].value = _vm.nicFilter
      },
      "clear": function($event) {
        _vm.filters[2].value = _vm.nicFilter
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.filters[2].value = _vm.nicFilter
      }
    },
    model: {
      value: (_vm.nicFilter),
      callback: function($$v) {
        _vm.nicFilter = $$v
      },
      expression: "nicFilter"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "filter",
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "xs": 24,
      "sm": 2,
      "md": 1
    }
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v(" Estado ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 8,
      "md": 4
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "Estado",
      "multiple": ""
    },
    model: {
      value: (_vm.filters[0].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[0], "value", $$v)
      },
      expression: "filters[0].value"
    }
  }, _vm._l((_vm.statusList), function(item) {
    return _c('el-option', {
      key: item.statusId,
      attrs: {
        "value": item.statusId,
        "label": item.description
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "filter",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "xs": 24,
      "sm": 2,
      "md": 1
    }
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v(" Fecha ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 19,
      "md": 6
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "range-separator": "A",
      "start-placeholder": "Desde",
      "end-placeholder": "Hasta",
      "value-format": "yyyy-MM-dd",
      "unlink-panels": ""
    },
    model: {
      value: (_vm.filters[1].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[1], "value", $$v)
      },
      expression: "filters[1].value"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('h3', [_vm._v(" Resultados ")]), _vm._v(" "), _c('data-tables-server', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingBuyOrders),
      expression: "loadingBuyOrders"
    }],
    staticClass: "table-responsive",
    attrs: {
      "data": _vm.buyOrders,
      "total": _vm.totalBuyOrders,
      "pagination-props": {
        pageSizes: [10, 20, 30]
      },
      "filters": _vm.filters
    },
    on: {
      "query-change": _vm.getBuyOrders
    }
  }, [_vm._l((_vm.titles), function(title) {
    return _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "sortable": title.sortable
      }
    })
  }), _vm._v(" "), (_vm.$route.path !== '/toBill') ? _c('el-table-column', {
    attrs: {
      "prop": "fecha_liberacion",
      "label": "Liberación",
      "sortable": "custom"
    }
  }) : _c('el-table-column', {
    attrs: {
      "sortable": "custom",
      "prop": "documentDate",
      "label": "Documentación enviada"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Estado",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.getStatusName(scope.row.statusId)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), (_vm.user.isProvider) ? _c('el-table-column', {
    attrs: {
      "align": 'center',
      "label": 'Aceptado',
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.view === '0' && (scope.row.statusId === '2' || scope.row.statusId === '3')) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Recibido",
            "placement": "right"
          }
        }, [_c('i', {
          staticClass: "el-icon-message"
        })]) : _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Aceptado",
            "placement": "right"
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        })])]
      }
    }], null, false, 1839679790)
  }) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider) ? _c('el-table-column', {
    attrs: {
      "align": 'center',
      "label": 'Tarea',
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.documents) ? _c('span', [(scope.row.view === '0' && (scope.row.statusId === '4')) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Recibido",
            "placement": "right"
          }
        }, [_c('i', {
          staticClass: "el-icon-message"
        })]) : _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Aceptado",
            "placement": "right"
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        })])], 1) : _c('span', [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "No posee",
            "placement": "right"
          }
        }, [_c('i', {
          staticClass: "el-icon-minus"
        })])], 1)]
      }
    }], null, false, 4263317506)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Detalles",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-view",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.goToDetails(scope.row.idBuyOrder)
            }
          }
        })], 1)]
      }
    }])
  })], 2)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
}]}

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "block"
  }, _vm._l((_vm.news.slice().reverse()), function(item) {
    return _c('el-timeline', {
      key: item.idNews,
      attrs: {
        "label": item.headLine,
        "value": item.idGroupCompany
      }
    }, [_c('el-timeline-item', {
      attrs: {
        "timestamp": item.dateLine,
        "placement": "top"
      }
    }, [_c('el-card', [_c('h4', [_vm._v(_vm._s(item.headLine))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.body))])])], 1)], 1)
  }), 1)])])
},staticRenderFns: []}

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "datetime-picker",
    style: ({
      width: _vm.width
    })
  }, [_c('input', {
    style: (_vm.styleObj),
    attrs: {
      "type": "text",
      "readonly": _vm.readonly
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "picker-wrap"
  }, [_c('table', {
    staticClass: "date-picker"
  }, [_c('thead', [_c('tr', {
    staticClass: "date-head"
  }, [_c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', {
    staticClass: "btn-prev",
    on: {
      "click": function($event) {
        return _vm.yearClick(-1)
      }
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('span', {
    staticClass: "show-year"
  }, [_vm._v(_vm._s(_vm.now.getFullYear()))]), _vm._v(" "), _c('span', {
    staticClass: "btn-next",
    on: {
      "click": function($event) {
        return _vm.yearClick(1)
      }
    }
  }, [_vm._v(">")])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', {
    staticClass: "btn-prev",
    on: {
      "click": function($event) {
        return _vm.monthClick(-1)
      }
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('span', {
    staticClass: "show-month"
  }, [_vm._v(_vm._s(_vm.months[_vm.now.getMonth()]))]), _vm._v(" "), _c('span', {
    staticClass: "btn-next",
    on: {
      "click": function($event) {
        return _vm.monthClick(1)
      }
    }
  }, [_vm._v(">")])])]), _vm._v(" "), _c('tr', {
    staticClass: "date-days"
  }, _vm._l((_vm.days), function(day) {
    return _c('th', [_vm._v(_vm._s(day))])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((6), function(i) {
    return _c('tr', _vm._l((7), function(j) {
      return _c('td', {
        class: _vm.date[i * 7 + j] && _vm.date[i * 7 + j].status,
        attrs: {
          "date": _vm.date[i * 7 + j] && _vm.date[i * 7 + j].date
        },
        on: {
          "click": function($event) {
            return _vm.pickDate(i * 7 + j)
          }
        }
      }, [_vm._v(_vm._s(_vm.date[i * 7 + j] && _vm.date[i * 7 + j].text))])
    }), 0)
  }), 0)])])])
},staticRenderFns: []}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    staticStyle: {
      "margin-top": "-12vh",
      "height": "auto",
      "overflow-y": "hidden"
    },
    attrs: {
      "title": "Términos y Condiciones",
      "visible": _vm.centerDialogVisible,
      "width": "80%",
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "60vh",
      "overflow": "auto"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.configuration))]), _c('br'), _c('br')]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    staticStyle: {
      "width": "15px",
      "float": "left",
      "margin-right": "5px"
    },
    attrs: {
      "type": "checkbox",
      "name": "aceptoTerminos",
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, null) > -1 : (_vm.checked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked = $$c
        }
      }
    }
  }), _vm._v("Acepto los términos y condiciones del sitio")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked2),
      expression: "checked2"
    }],
    staticStyle: {
      "width": "15px",
      "float": "left",
      "margin-right": "5px"
    },
    attrs: {
      "type": "checkbox",
      "name": "aceptoCodigoEtica",
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.checked2) ? _vm._i(_vm.checked2, null) > -1 : (_vm.checked2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checked2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checked2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked2 = $$c
        }
      }
    }
  }), _vm._v("\n      Acepto el "), _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.codigoEtica
    }
  }, [_vm._v("código de ética")]), _vm._v(" para proveedores de contreras.\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    staticStyle: {
      "position": "relative",
      "left": "45%"
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.checked2 || !_vm.checked
    },
    on: {
      "click": function($event) {
        return _vm.submitFormSolicitud()
      }
    }
  }, [_vm._v("Aceptar")])])])]), _vm._v(" "), (!_vm.paramError) ? _c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Pedido de usuario nuevo del Portal")]) : _vm._e(), _vm._v(" "), (!_vm.paramError) ? _c('p', {
    staticClass: "text-center"
  }, [_vm._v(" Para solicitar un usuario nuevo del portal, es necesario validar su identidad y la de su empresa. Por favor complete los siguientes datos:")]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [(_vm.paramError) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Advertencia")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.paramError))])])])])])]) : _vm._e(), _vm._v(" "), (!_vm.paramError) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    staticClass: "ui form solicitudForm",
    attrs: {
      "id": "formSolicitud"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitFormSolicitud()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-10 col-sm-6 col-md-4 col-lg-4"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('masked-input', {
    attrs: {
      "mask": _vm.cuitMask,
      "guide": false,
      "placeholder": "",
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.rut),
      callback: function($$v) {
        _vm.rut = $$v
      },
      expression: "rut"
    }
  }), _vm._v(" "), _c('label', [_vm._v("CUIT de la compañia")])], 1)])]), _vm._v(" "), (!_vm.paramInvoices) ? _c('h4', [_vm._v("Datos últimas 3 facturas")]) : _vm._e(), _vm._v(" "), (!_vm.paramInvoices) ? _c('div', {
    staticClass: "row entradas"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "input-group entradas_min"
  }, [_vm._m(2), _vm._v(" "), _c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": _vm.invoiceMask,
      "guide": false,
      "name": "invoice0",
      "placeholder": "Nro factura 1",
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.invoice0),
      callback: function($$v) {
        _vm.invoice0 = $$v
      },
      expression: "invoice0"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "input-group entradas_min"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.date0),
      expression: "date0"
    }],
    staticClass: "form-control col-md-12",
    attrs: {
      "type": "date",
      "format": "DDMMYYYY",
      "name": "date0",
      "id": "date0",
      "required": ""
    },
    domProps: {
      "value": (_vm.date0)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.date0 = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (!_vm.paramInvoices) ? _c('div', {
    staticClass: "row entradas"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "input-group entradas_min"
  }, [_vm._m(4), _vm._v(" "), _c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": _vm.invoiceMask,
      "guide": false,
      "name": "invoice1",
      "placeholder": "Nro factura 2",
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.invoice1),
      callback: function($$v) {
        _vm.invoice1 = $$v
      },
      expression: "invoice1"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "input-group entradas_min"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.date1),
      expression: "date1"
    }],
    staticClass: "form-control col-md-12",
    attrs: {
      "type": "date",
      "format": "DDMMYYYY",
      "name": "date1",
      "id": "date1",
      "required": ""
    },
    domProps: {
      "value": (_vm.date1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.date1 = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (!_vm.paramInvoices) ? _c('div', {
    staticClass: "row entradas"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "input-group entradas_min"
  }, [_vm._m(6), _vm._v(" "), _c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": _vm.invoiceMask,
      "guide": false,
      "name": "invoice2",
      "placeholder": "Nro factura 3",
      "type": "text",
      "required": ""
    },
    model: {
      value: (_vm.invoice2),
      callback: function($$v) {
        _vm.invoice2 = $$v
      },
      expression: "invoice2"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "input-group entradas_min"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.date2),
      expression: "date2"
    }],
    staticClass: "form-control col-md-12",
    attrs: {
      "type": "date",
      "format": "DDMMYYYY",
      "name": "date2",
      "id": "date2",
      "required": ""
    },
    domProps: {
      "value": (_vm.date2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.date2 = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v("Nombre y Apellido")]), _vm._v(" "), _c('div', {
    staticClass: "input-group entradas_min"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "name",
      "placeholder": "Nombre y Apellido",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("Motivo ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group entradas_min"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason),
      expression: "reason"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "reason",
      "placeholder": "Motivo del pedido de alta de usuario",
      "type": "text"
    },
    domProps: {
      "value": (_vm.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reason = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("Correo electrónico ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group entradas_min"
  }, [_vm._m(10), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "placeholder": "Correo electrónico",
      "type": "email",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group entradas_min"
  }, [_c('vue-recaptcha', {
    attrs: {
      "sitekey": _vm.siteKey,
      "loadRecaptchaScript": true
    },
    on: {
      "verify": function($event) {
        return _vm.captchaVerificado()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    attrs: {
      "type": "submit",
      "disabled": !_vm.captcha
    }
  }, [_vm._v(" Enviar solicitud")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.response) ? _c('div', {
    staticClass: "col-md-12 text-center",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.response))])])])])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "col-md-12 text-center",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.success))])])])])]) : _vm._e()])])])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-red"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Datos de la Compañia")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fas fa-sort-numeric-asc",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-sort-numeric-asc",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-sort-numeric-asc",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "far fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "far fa-envelope",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-green"
  }, [_c('i', {
    staticClass: "ion ion-android-checkmark-circle"
  })])
}]}

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.dataForm), function(data, index) {
    return [(data.dataType === 'input') ? _c('simple-input', {
      key: 'input-' + index,
      attrs: {
        "data": data,
        "validation": _vm.validation,
        "disabled": _vm.disabled
      }
    }) : _vm._e(), _vm._v(" "), (data.dataType === 'input-double') ? _c('double-input', {
      key: 'input-' + index,
      attrs: {
        "data": data,
        "validation": _vm.validation,
        "disabled": _vm.disabled
      }
    }) : _vm._e(), _vm._v(" "), (data.dataType === 'select') ? _c('select-input', {
      key: 'select-' + index,
      attrs: {
        "data": data,
        "locations": _vm.locations,
        "banks": _vm.banks,
        "bankAccountTypes": _vm.bankAccountTypes,
        "validation": _vm.validation,
        "disabled": _vm.disabled
      }
    }) : _vm._e(), _vm._v(" "), (data.dataType === 'upload') ? _c('el-row', {
      key: 'upload-' + index
    }, [_c('el-col', {
      staticStyle: {
        "marginbottom": "25px"
      },
      attrs: {
        "span": 8
      }
    }, [_c('pdf-file', {
      attrs: {
        "pdfFilePath": data.model,
        "habModificaPdf": _vm.habModificaPdf,
        "titulo": data.label,
        "id": data.label,
        "prop": data.name,
        "country": 'PER',
        "disabled": _vm.disabled
      },
      on: {
        "update:pdfFilePath": function($event) {
          return _vm.$set(data, "model", $event)
        },
        "update:pdf-file-path": function($event) {
          return _vm.$set(data, "model", $event)
        }
      }
    })], 1), _vm._v(" "), (_vm.verifyFields(data, _vm.validation)) ? _c('el-alert', {
      staticClass: "message-warning",
      attrs: {
        "title": ("Falta completar: " + (data.label)),
        "type": "error",
        "closable": false
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (data.dataType === 'switch-perception') ? _c('switch-perception', {
      key: 'switch-perception' + index,
      attrs: {
        "data": data,
        "validation": _vm.validation,
        "disabled": _vm.disabled
      }
    }) : _vm._e(), _vm._v(" "), (data.dataType === 'switch-retention') ? _c('switch-retention', {
      key: 'switch-retention' + index,
      attrs: {
        "data": data,
        "denominaciones": _vm.denominaciones,
        "validation": _vm.validation,
        "disabled": _vm.disabled
      }
    }) : _vm._e(), _vm._v(" "), (data.dataType === 'switch-detraction') ? _c('switch-detraction', {
      key: 'switch-detraction' + index,
      attrs: {
        "data": data,
        "validation": _vm.validation,
        "disabled": _vm.disabled
      }
    }) : _vm._e()]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {}, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-row', {
    staticClass: "filters-container",
    attrs: {
      "type": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "1%"
    }
  }, [_c('countries-group', {
    attrs: {
      "filter": _vm.filters[1],
      "show-all-button": true
    },
    on: {
      "update-filter": _vm.updateFilter
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Buscar"
    },
    on: {
      "input": _vm.filtrando
    },
    model: {
      value: (_vm.filters[0].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[0], "value", $$v)
      },
      expression: "filters[0].value"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "1%"
    },
    attrs: {
      "span": 8
    }
  }, [(_vm.download_report_visible) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "data-cy": "generarReporte"
    },
    on: {
      "click": _vm.downloadProvidersData
    }
  }, [_vm._v("Generar Reporte")]) : _vm._e()], 1)], 1)], 1)]), _vm._v(" "), _c('data-tables', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "tablaReporteProveedores",
      "data": _vm.providersData,
      "pagination-props": {
        pageSizes: [10, 20, 30]
      },
      "filters": _vm.filters
    }
  }, _vm._l((_vm.titles), function(title) {
    return _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "width": "200",
        "align": title.align
      }
    })
  }), 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box-body"
  })])])
}]}

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-button-group', {
    model: {
      value: (_vm.selectedCountries),
      callback: function($$v) {
        _vm.selectedCountries = $$v
      },
      expression: "selectedCountries"
    }
  }, [(_vm.showAllButton && _vm.countries.length > 1) ? _c('el-button', {
    attrs: {
      "type": _vm.allButtonType
    },
    on: {
      "click": function($event) {
        return _vm.filterPerCountry('All')
      }
    }
  }, [_vm._v("Todos")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.countries), function(country) {
    return (_vm.countries.length > 1) ? _c('el-button', {
      key: country.codCountry,
      attrs: {
        "type": _vm.getButtonType(country.codCountry)
      },
      on: {
        "click": function($event) {
          return _vm.filterPerCountry(country.codCountry)
        }
      }
    }, [_vm._v(_vm._s(_vm.getCountryName(country.codCountry)))]) : _vm._e()
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.provider) ? _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('el-button', {
    staticStyle: {
      "display": "inline-block",
      "float": "right",
      "transition": "all 1s",
      "margin-right": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-left"
  }), _vm._v("\n          Volver\n        ")])], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('el-row', {
    staticStyle: {
      "height": "90px",
      "padding-top": "20px",
      "text-align": "right"
    }
  }, [_c('el-tag', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "effect": "dark",
      "type": _vm.statusType
    }
  }, [_vm._v("\n              " + _vm._s(_vm.getStatusNameOfTab()) + "\n            ")])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Datos generales",
      "name": "generalData"
    }
  }, [_c('el-row', {
    staticStyle: {
      "height": "70px",
      "text-align": "justify"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Cuit: " + _vm._s(_vm.provider.cuit) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Razón Social: " + _vm._s(_vm.provider.company) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Nombre de Fantasía: " + _vm._s(_vm.provider.companyName ? _vm.provider.companyName : '-') + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Servicios: \n                "), _vm._l((_vm.provider.rubros), function(rubro, index) {
    return _c('span', {
      key: rubro.idRubro
    }, [_vm._v("\n                " + _vm._s(rubro.nombre) + "\n                "), ((index + 1) < _vm.provider.rubros.length) ? _c('span', [_vm._v("\n                  /\n                ")]) : _vm._e()])
  })], 2)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "height": "70px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              País: " + _vm._s(_vm.countryName(_vm.provider.generalData.idCountry)) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Provincia: " + _vm._s(_vm.provinceName(_vm.provider.generalData.idProvince)) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Ciudad: " + _vm._s(_vm.provider.generalData.city) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Dirección: " + _vm._s(_vm.provider.generalData.address + ' ' + _vm.provider.generalData.addressNumber) + "\n            ")])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "height": "70px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Teléfono: " + _vm._s(_vm.provider.generalData.phone) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              E-mail pago: " + _vm._s(_vm.provider.generalData.paymentEmail) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              E-mail recepción: " + _vm._s(_vm.provider.generalData.receiptEmail) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Código postal: " + _vm._s(_vm.provider.generalData.zipCode) + "\n            ")])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "height": "70px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Sujeto IVA: " + _vm._s(_vm.provider.generalData.typeIVA) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Persona: " + _vm._s(_vm.provider.generalData.personType) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Subtipo persona: " + _vm._s(_vm.provider.generalData.personSubType === 'Otro' ? _vm.provider.generalData.personSubTypeOther : (_vm.provider.generalData.personSubType ? _vm.provider.generalData.personSubType : '-')) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Alta de AFIP: \n              "), (_vm.provider.generalData.pdfAfip !== '0') ? _c('a', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "href": _vm.provider.generalData.pdfAfip,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" Ver\n              ")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Datos de pago",
      "name": "paymentData"
    }
  }, [_c('el-row', {
    staticStyle: {
      "height": "70px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Sucursal ICBC: " + _vm._s(_vm.bankBranchName(_vm.provider.paymentData.idBankBranch) ? _vm.bankBranchName(_vm.provider.paymentData.idBankBranch) : '-') + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Banco: " + _vm._s(_vm.bankName(_vm.provider.paymentData.idBank)) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Número de cta: " + _vm._s(_vm.provider.paymentData.accountNumber) + "\n            ")])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "height": "70px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Tipo de cta: " + _vm._s(_vm.bankAccountName(_vm.provider.paymentData.idBankAccountType)) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              CBU: " + _vm._s(_vm.provider.paymentData.cbu) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Constancia: \n              "), (_vm.provider.paymentData.pdfBank !== '0') ? _c('a', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "href": _vm.provider.paymentData.pdfBank,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" Ver\n              ")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Datos impositivos",
      "name": "taxData"
    }
  }, [_c('el-divider', [_vm._v(" Ingresos Brutos ")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "height": "70px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Constancia: \n              "), _c('a', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "href": _vm.provider.taxData.pdfIb,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" Ver\n              ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Tipo: " + _vm._s(_vm.provider.taxData.ibType) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v(" "), _c('el-dropdown', {
    on: {
      "command": _vm.handlePdfsExempt
    }
  }, [_c('span', {
    class: _vm.provider.taxData.pdfsExempt.length > 0 ? 'el-dropdown-link' : ''
  }, [_vm._v("\n                  Constancia de exento"), (_vm.provider.taxData.pdfsExempt.length > 0) ? _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  }) : _vm._e()]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.provider.taxData.pdfsExempt), function(pdf, index) {
    return _c('el-dropdown-item', {
      key: pdf.idPdfExemption,
      attrs: {
        "command": pdf.pdfExempt
      }
    }, [_vm._v("PDF " + _vm._s(index))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "height": "70px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Regimen de convenio: " + _vm._s(_vm.agreementRegimeTypeName(_vm.provider.taxData.idAgreementRegimeType)) + "\n            ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              CM05:\n              "), (_vm.provider.taxData.pdfCM05) ? _c('a', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "href": _vm.provider.taxData.pdfCM05,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" Ver\n              ")]) : _c('span', [_vm._v(" - ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n              Jurisdicción sede: " + _vm._s(_vm.jurisdictionName(_vm.provider.taxData.jurisdictionHeadquarters)) + "\n            ")])], 1), _vm._v(" "), _c('el-row', [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v("\n            Jurisdicciones:\n            "), (false) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.provider.taxData.jurisdictions,
      "height": "250",
      "disabled": true
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.provider[_vm.activeTab].idCompanyDataStatus === '1') ? _c('div', {
    staticClass: "row text-center"
  }, [_c('el-divider', [_vm._v(" Aceptar datos ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.rejectCompanyDataVisible = true
      }
    }
  }, [_vm._v(" Rechazar "), _c('i', {
    staticClass: "el-icon-close"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.acceptCompanyData()
      }
    }
  }, [_vm._v(" Aceptar "), _c('i', {
    staticClass: "el-icon-check"
  })])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Rechazar datos",
      "visible": _vm.rejectCompanyDataVisible,
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.rejectCompanyDataVisible = $event
      }
    }
  }, [_vm._v("\n    Escriba el motivo por el cual rechaza los datos:\n    "), _c('el-input', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "textarea",
      "rows": 4,
      "maxlength": "400",
      "placeholder": "Ingrese el motivo",
      "show-word-limit": true
    },
    model: {
      value: (_vm.newObservation),
      callback: function($$v) {
        _vm.newObservation = $$v
      },
      expression: "newObservation"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.rejectCompanyData()
      }
    }
  }, [_vm._v("\n        Aceptar\n      ")])], 1)], 1)], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.user) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [(_vm.inactiveUser) ? _c('el-alert', {
    attrs: {
      "title": "Usuario Solicitado",
      "type": "warning",
      "description": "Los datos de alta han sido enviados y se encuentran en espera de confirmación",
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.returnedUser) ? _c('el-alert', {
    attrs: {
      "title": "Usuario Devuelto",
      "type": "error",
      "description": "Los datos de alta han sido devueltos, por favor verifique y vuelva a enviarlos",
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.rowsModules), function(row) {
    return _c('el-row', {
      key: row.idModule,
      attrs: {
        "gutter": 12
      }
    }, _vm._l((row), function(fModule) {
      return (_vm.moduleVisible(fModule)) ? _c('el-col', {
        key: fModule.idModule,
        staticClass: "dashboard_block",
        attrs: {
          "xs": 24,
          "sm": 24,
          "md": 24 / row.length
        }
      }, [_c('el-card', {
        staticStyle: {
          "min-height": "350px"
        },
        attrs: {
          "shadow": "always",
          "align": "center"
        }
      }, [_c('p', [_c('strong', [_c('img', {
        staticClass: "alignnone wp-image-238 size-full",
        attrs: {
          "src": (_vm.userHasModule(fModule) && (fModule.html.inactiveCompany || !_vm.inactiveUser)) ? fModule.html.imgEnabled : fModule.html.imgDisabled,
          "alt": "",
          "width": "91",
          "height": "91"
        }
      })])]), _vm._v(" "), _c('div', {
        class: (_vm.userHasModule(fModule) && (fModule.html.inactiveCompany || !_vm.inactiveUser)) ? 'title' : 'title_disabled'
      }, [_vm._v(_vm._s(fModule.html.title))]), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "flex",
          "flex-direction": "column"
        }
      }, [_c('el-divider'), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "flex",
          "justify-content": "start",
          "align-items": "center",
          "flex-direction": "column"
        }
      }, [_c('div', _vm._l((fModule.html.links), function(link) {
        return _c('div', {
          key: link.title,
          staticStyle: {
            "display": "flex",
            "align-items": "center",
            "margin": "4px 0 4px 0"
          }
        }, [_c('router-link', {
          staticClass: "dashboardLink",
          staticStyle: {
            "display": "flex",
            "gap": "8px",
            "align-items": "center"
          },
          attrs: {
            "tag": (_vm.userHasModule(fModule) && (fModule.html.inactiveCompany || !_vm.inactiveUser)) ? 'a' : 'span',
            "to": (_vm.userHasModule(fModule) && (fModule.html.inactiveCompany || !_vm.inactiveUser)) ? link.route : ''
          },
          nativeOn: {
            "click": function($event) {
              return link.atClick.apply(null, arguments)
            }
          }
        }, [_c('svg', {
          staticStyle: {
            "shape-rendering": "geometricPrecision",
            "text-rendering": "geometricPrecision",
            "image-rendering": "optimizeQuality",
            "fill-rule": "evenodd",
            "clip-rule": "evenodd"
          },
          attrs: {
            "xmlns": "http://www.w3.org/2000/svg",
            "version": "1.1",
            "width": "20",
            "height": "25",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            "viewBox": "0 0 512 512"
          }
        }, [_c('g', [_c('path', {
          staticStyle: {
            "opacity": "1"
          },
          attrs: {
            "fill": "currentColor",
            "d": "M 232.5,-0.5 C 240.167,-0.5 247.833,-0.5 255.5,-0.5C 255.5,38.8333 255.5,78.1667 255.5,117.5C 255.5,142.167 255.5,166.833 255.5,191.5C 211.44,191.016 167.44,191.516 123.5,193C 115.606,196.561 110.106,202.395 107,210.5C 106.5,225.496 106.333,240.496 106.5,255.5C 106.062,271.557 106.562,287.557 108,303.5C 111.555,310.055 116.721,314.888 123.5,318C 167.44,319.484 211.44,319.984 255.5,319.5C 255.5,344.167 255.5,368.833 255.5,393.5C 255.5,432.833 255.5,472.167 255.5,511.5C 247.833,511.5 240.167,511.5 232.5,511.5C 132.727,498.549 61.5605,446.549 19,355.5C 8.86392,330.621 2.36392,304.954 -0.5,278.5C -0.5,263.167 -0.5,247.833 -0.5,232.5C 12.4486,132.729 64.4486,61.5622 155.5,19C 180.379,8.86392 206.046,2.36392 232.5,-0.5 Z"
          }
        })]), _c('g', [_c('path', {
          staticStyle: {
            "opacity": "0.998"
          },
          attrs: {
            "fill": "currentColor",
            "d": "M 255.5,-0.5 C 263.167,-0.5 270.833,-0.5 278.5,-0.5C 378.271,12.4486 449.438,64.4486 492,155.5C 502.136,180.379 508.636,206.046 511.5,232.5C 511.5,247.833 511.5,263.167 511.5,278.5C 498.551,378.271 446.551,449.438 355.5,492C 330.622,502.136 304.955,508.636 278.5,511.5C 270.833,511.5 263.167,511.5 255.5,511.5C 255.5,472.167 255.5,432.833 255.5,393.5C 261.71,405.185 270.71,407.685 282.5,401C 329.03,355.469 375.863,310.303 423,265.5C 426.293,261.093 427.127,256.427 425.5,251.5C 422.887,245.372 418.887,240.205 413.5,236C 370.197,195.031 327.197,153.697 284.5,112C 272.73,103.239 263.063,105.072 255.5,117.5C 255.5,78.1667 255.5,38.8333 255.5,-0.5 Z"
          }
        })]), _c('g', [_c('path', {
          staticStyle: {
            "opacity": "1"
          },
          attrs: {
            "fill": "#fefefe",
            "d": "M 425.5,251.5 C 425.5,252.833 425.5,254.167 425.5,255.5C 319.167,255.5 212.833,255.5 106.5,255.5C 106.333,240.496 106.5,225.496 107,210.5C 110.106,202.395 115.606,196.561 123.5,193C 167.44,191.516 211.44,191.016 255.5,191.5C 255.5,166.833 255.5,142.167 255.5,117.5C 263.063,105.072 272.73,103.239 284.5,112C 327.197,153.697 370.197,195.031 413.5,236C 418.887,240.205 422.887,245.372 425.5,251.5 Z"
          }
        })]), _c('g', [_c('path', {
          staticStyle: {
            "opacity": "1"
          },
          attrs: {
            "fill": "#ddddde",
            "d": "M 425.5,251.5 C 427.127,256.427 426.293,261.093 423,265.5C 375.863,310.303 329.03,355.469 282.5,401C 270.71,407.685 261.71,405.185 255.5,393.5C 255.5,368.833 255.5,344.167 255.5,319.5C 211.44,319.984 167.44,319.484 123.5,318C 116.721,314.888 111.555,310.055 108,303.5C 106.562,287.557 106.062,271.557 106.5,255.5C 212.833,255.5 319.167,255.5 425.5,255.5C 425.5,254.167 425.5,252.833 425.5,251.5 Z"
          }
        })])]), _vm._v(" "), _c('div', [_c('span', {
          class: (_vm.userHasModule(fModule) && (fModule.html.inactiveCompany || !_vm.inactiveUser)) ? '' : 'link_title_disabled',
          staticStyle: {
            "vertical-align": "top"
          },
          attrs: {
            "data-cy": 'lnk_' + link.title
          }
        }, [_vm._v(_vm._s(link.title))]), _vm._v(" "), ((!link.badgeHiddenCond && _vm.userHasModule(fModule)) && (fModule.html.inactiveCompany || !_vm.inactiveUser) && link.route != '/allComments') ? _c('el-badge', {
          attrs: {
            "hidden": link.badgeHiddenCond,
            "value": link.badgeValue,
            "max": 99
          }
        }) : _vm._e(), _vm._v(" "), ((!_vm.badgeChatHidden && _vm.userHasModule(fModule)) && (fModule.html.inactiveCompany || !_vm.inactiveUser) && (link.route == '/allComments')) ? _c('el-badge', {
          attrs: {
            "hidden": _vm.badgeChatHidden,
            "value": _vm.badgeChatValue,
            "max": 99
          }
        }) : _vm._e()], 1)]), _vm._v(" "), _c('br')], 1)
      }), 0)])], 1)])], 1) : _vm._e()
    }), 1)
  })], 2) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "-80px"
    },
    attrs: {
      "title": "Política de Pagos",
      "visible": _vm.showModalPaymentPolicies,
      "width": "85%",
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalPaymentPolicies = $event
      }
    }
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "calc(100vh - 233px)"
    },
    attrs: {
      "src": _vm.urlPaymentPolicies
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "margin-top": "-20px"
    },
    on: {
      "click": function($event) {
        _vm.showModalPaymentPolicies = false
      }
    }
  }, [_vm._v("\n        Cerrar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "-80px"
    },
    attrs: {
      "title": "Política de Compras",
      "visible": _vm.showModalBuyPolicies,
      "width": "85%",
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalBuyPolicies = $event
      }
    }
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "calc(100vh - 233px"
    },
    attrs: {
      "src": _vm.urlBuyPolicies
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "margin-top": "-20px"
    },
    on: {
      "click": function($event) {
        _vm.showModalBuyPolicies = false
      }
    }
  }, [_vm._v("\n        Cerrar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "-80px"
    },
    attrs: {
      "title": "Código de Conducta",
      "visible": _vm.showModalEthicsPolicies,
      "width": "85%",
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalEthicsPolicies = $event
      }
    }
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "calc(100vh - 233px)"
    },
    attrs: {
      "src": _vm.urlEthicsPolicies
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "margin-top": "-20px"
    },
    attrs: {
      "data-cy": "btn-cc-cerrar"
    },
    on: {
      "click": function($event) {
        _vm.showModalEthicsPolicies = false
      }
    }
  }, [_vm._v("\n        Cerrar\n      ")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('el-dialog', {
    attrs: {
      "title": "Generar OC",
      "visible": _vm.showModal,
      "width": "90%",
      "lock-scroll": false,
      "max-width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Razón Social")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "name": "Razon Social",
      "required": "",
      "placeholder": "Razón Social"
    },
    model: {
      value: (_vm.totalBuyOrders),
      callback: function($$v) {
        _vm.totalBuyOrders = $$v
      },
      expression: "totalBuyOrders"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Fecha de liberación")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.fecha),
      callback: function($$v) {
        _vm.fecha = $$v
      },
      expression: "fecha"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("OC")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "name": "nombre",
      "placeholder": "Numero de OC"
    },
    model: {
      value: (_vm.totalBuyOrders),
      callback: function($$v) {
        _vm.totalBuyOrders = $$v
      },
      expression: "totalBuyOrders"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 entrada"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("OC (PDF)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    ref: "fileBuyOrder",
    staticClass: "form-control-file",
    staticStyle: {
      "width": "80%",
      "float": "left"
    },
    attrs: {
      "type": "file",
      "accept": "application/pdf"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "6%"
    },
    attrs: {
      "type": "primary",
      "circle": "",
      "icon": "el-icon-upload"
    }
  })], 1)]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.saveNIC()
      }
    }
  }, [_vm._v("\n            Guardar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")])])]), _vm._v(" "), _c('h3', [_vm._v(" Panel de control")]), _vm._v(" "), (_vm.statusList) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "'font-size": "15px",
      "text-align": "center"
    }
  }, _vm._l((_vm.statusList), function(item) {
    return _c('th', {
      key: item.statusId,
      style: ('text-align: center; vertical-align: middle;width: ' + (100 / _vm.statusList.length) + '%')
    }, [_vm._v(_vm._s(item.description))])
  }), 0)]), _vm._v(" "), _c('tbody', [_c('tr', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingStatus),
      expression: "loadingStatus"
    }],
    staticStyle: {
      "font-size": "25px",
      "text-align": "center"
    }
  }, _vm._l((_vm.statusList), function(item) {
    return _c('td', {
      key: item.statusId,
      staticClass: "statusHover",
      on: {
        "click": function($event) {
          return _vm.searchStatus(item.statusId)
        }
      }
    }, [_vm._v(_vm._s(_vm.statusCount[item.statusId]))])
  }), 0)])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.response) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Advertencia")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.response))])])])])]) : _vm._e()]), _vm._v(" "), (_vm.$route.path === '/buyOrders') ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("Nuevo...")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('h3', [_vm._v(" Filtros ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "filter",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "xs": 24,
      "sm": 2,
      "md": 1
    }
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v(" OC ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 8,
      "md": 6
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "OC",
      "clearable": ""
    },
    on: {
      "blur": function($event) {
        _vm.filters[2].value = _vm.nicFilter
      },
      "clear": function($event) {
        _vm.filters[2].value = _vm.nicFilter
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.filters[2].value = _vm.nicFilter
      }
    },
    model: {
      value: (_vm.nicFilter),
      callback: function($$v) {
        _vm.nicFilter = $$v
      },
      expression: "nicFilter"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "filter",
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "xs": 24,
      "sm": 2,
      "md": 1
    }
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v(" Estado ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 8,
      "md": 4
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "Estado",
      "multiple": ""
    },
    model: {
      value: (_vm.filters[0].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[0], "value", $$v)
      },
      expression: "filters[0].value"
    }
  }, _vm._l((_vm.statusList), function(item) {
    return _c('el-option', {
      key: item.statusId,
      attrs: {
        "value": item.statusId,
        "label": item.description
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "filter",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "xs": 24,
      "sm": 2,
      "md": 1
    }
  }, [_c('span', {
    staticClass: "input-label"
  }, [_vm._v(" Fecha ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 19,
      "md": 6
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "range-separator": "A",
      "start-placeholder": "Desde",
      "end-placeholder": "Hasta",
      "value-format": "yyyy-MM-dd",
      "unlink-panels": ""
    },
    model: {
      value: (_vm.filters[1].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[1], "value", $$v)
      },
      expression: "filters[1].value"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('h3', [_vm._v(" Resultados ")]), _vm._v(" "), _c('data-tables-server', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingBuyOrders),
      expression: "loadingBuyOrders"
    }],
    staticClass: "table-responsive",
    attrs: {
      "data": _vm.buyOrders,
      "total": _vm.totalBuyOrders,
      "pagination-props": {
        pageSizes: [10, 20, 30]
      },
      "filters": _vm.filters
    },
    on: {
      "query-change": _vm.getBuyOrders
    }
  }, [_vm._l((_vm.titles), function(title) {
    return _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "sortable": title.sortable
      }
    })
  }), _vm._v(" "), (_vm.$route.path !== '/toBill') ? _c('el-table-column', {
    attrs: {
      "prop": "fecha_liberacion",
      "label": "Liberación",
      "sortable": "custom"
    }
  }) : _c('el-table-column', {
    attrs: {
      "sortable": "custom",
      "prop": "documentDate",
      "label": "Documentación enviada"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Estado",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.getStatusName(scope.row.statusId)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), (_vm.user.isProvider) ? _c('el-table-column', {
    attrs: {
      "align": 'center',
      "label": 'Aceptado',
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.view === '0' && (scope.row.statusId === '2' || scope.row.statusId === '3')) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Recibido",
            "placement": "right"
          }
        }, [_c('i', {
          staticClass: "el-icon-message"
        })]) : _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Aceptado",
            "placement": "right"
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        })])]
      }
    }], null, false, 1839679790)
  }) : _vm._e(), _vm._v(" "), ( false) ? _c('el-table-column', {
    attrs: {
      "align": 'center',
      "label": 'Factura',
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.mensajeFacturaRechazada === null) ? _c('span', [(scope.row.statusId === '4') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Enviada",
            "placement": "right"
          }
        }, [_c('i', {
          staticClass: "el-icon-upload2"
        })]) : _vm._e(), _vm._v(" "), (scope.row.statusId === '5') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Aceptada",
            "placement": "right"
          }
        }, [_c('i', {
          staticClass: "el-icon-check"
        })]) : _vm._e(), _vm._v(" "), (scope.row.statusId <= '3') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Sin subir",
            "placement": "right"
          }
        }, [_c('i', {
          staticClass: "el-icon-minus"
        })]) : _vm._e()], 1) : _c('span', [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Rechazada",
            "placement": "right"
          }
        }, [_c('i', {
          staticClass: "el-icon-close"
        })])], 1)]
      }
    }], null, false, 3012484627)
  }) : _vm._e(), _vm._v(" "), ( false) ? _c('el-table-column', {
    attrs: {
      "align": 'center',
      "label": 'G. Pago',
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.payment) ? _c('span', [(scope.row.payment.visto === '0') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Recibido",
            "placement": "right"
          }
        }, [_c('i', {
          staticClass: "el-icon-message"
        })]) : _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Visto",
            "placement": "right"
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        })])], 1) : _c('span', [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "No posee",
            "placement": "right"
          }
        }, [_c('i', {
          staticClass: "el-icon-minus"
        })])], 1)]
      }
    }], null, false, 2333380837)
  }) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider) ? _c('el-table-column', {
    attrs: {
      "align": 'center',
      "label": 'Tarea',
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.documents) ? _c('span', [(scope.row.view === '0' && (scope.row.statusId === '4')) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Recibido",
            "placement": "right"
          }
        }, [_c('i', {
          staticClass: "el-icon-message"
        })]) : _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Aceptado",
            "placement": "right"
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        })])], 1) : _c('span', [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "No posee",
            "placement": "right"
          }
        }, [_c('i', {
          staticClass: "el-icon-minus"
        })])], 1)]
      }
    }], null, false, 4263317506)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Detalles",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-view",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.goToDetails(scope.row.idBuyOrder)
            }
          }
        })], 1)]
      }
    }])
  })], 2)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
}]}

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('header', {
    staticClass: "main-header"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [(_vm.user) ? _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [(!_vm.user.isProvider && false) ? _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": "Usuarios por activar",
      "placement": "bottom"
    }
  }, [_c('li', {
    staticClass: "dropdown messages-menu"
  }, [_c('router-link', {
    staticClass: "dropdown-toggle",
    attrs: {
      "to": "/contacts",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fas fa-user-plus"
  }), _vm._v(" "), (_vm.newContacts.length > 0) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.newContacts.length))]) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider && false) ? _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": "Mensajes nuevos",
      "placement": "bottom"
    }
  }, [_c('li', {
    staticClass: "dropdown messages-menu"
  }, [_c('router-link', {
    staticClass: "dropdown-toggle",
    attrs: {
      "to": "/allComments",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" "), (_vm.receivedNew.length > 0) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.receivedNew.length))]) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), (_vm.user.isProvider && false) ? _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": "Pagos",
      "placement": "bottom"
    }
  }, [_c('li', {
    staticClass: "dropdown messages-menu"
  }, [_c('router-link', {
    staticClass: "dropdown-toggle",
    attrs: {
      "to": {
        'name': 'Búsqueda',
        params: {
          statusId: ['6']
        }
      },
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "el-icon-tickets"
  }), _vm._v(" "), (_vm.newPayments.length > 0) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.newPayments.length))]) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), (_vm.user.isProvider && false) ? _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": "Mensajes nuevos",
      "placement": "bottom"
    }
  }, [_c('li', {
    staticClass: "dropdown messages-menu"
  }, [_c('router-link', {
    staticClass: "dropdown-toggle",
    attrs: {
      "to": "/allComments",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-comment"
  }), _vm._v(" "), (_vm.providerNewMessages.length > 0) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.providerNewMessages.length))]) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), (_vm.user.isProvider && false) ? _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": "Invitaciones a compulsas",
      "placement": "bottom"
    }
  }, [_c('li', {
    staticClass: "dropdown messages-menu"
  }, [_c('router-link', {
    staticClass: "dropdown-toggle",
    attrs: {
      "to": "/compulsas",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" "), (_vm.newCompulsas.length > 0) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.newCompulsas.length))]) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "dashUsername"
  }, [_vm._v(_vm._s(_vm.user.name))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header",
    staticStyle: {
      "height": "auto",
      "min-height": "85px",
      "padding-bottom": "15px"
    }
  }, [_c('p', [_c('span', [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('small', [_vm._v(" Puesto: " + _vm._s(_vm.user.job.job))]), _vm._v(" "), _c('small', [_vm._v(" " + _vm._s(_vm.user.email))])])]), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [(_vm.user) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-sign-out-alt text-red"
  }), _vm._v(" "), _c('span', {
    staticClass: "page",
    staticStyle: {
      "color": "var(--primary-color)"
    }
  }, [_vm._v("Cerrar Sesión")])])])]) : _vm._e()], 1)])])], 1)]) : _vm._e()])]), _vm._v(" "), _c('sidebar'), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.$route.name.toUpperCase()) + "\n          "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-home",
    attrs: {
      "data-cy": "home"
    }
  }), _vm._v("Home")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.name.toUpperCase()))])])]), _vm._v(" "), _c('router-view', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "element-loading-text": "Cargando información, aguarde un momento"
    }
  })], 1), _vm._v(" "), _c('footer', {
    staticClass: "main-footer text-center"
  }, [(_vm.entorno) ? _c('div', {
    staticClass: "entorno"
  }, [_vm._v(_vm._s(_vm.entorno))]) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v("Copyright © " + _vm._s(_vm.year) + "\n        "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }), _vm._v(".")]), _vm._v(" powered by PowerSuppliers.io\n    ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {}, [_c('div', {
    staticClass: "logo-mini gradiente"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "left-block logo",
    attrs: {
      "src": "/static/img/logo.png",
      "alt": "PowerSuppliers"
    }
  })])])])
}]}

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.user.isProvider) ? _c('div', [_c('div', {
    staticClass: "filter"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Buscar"
    },
    on: {
      "input": _vm.sendFilterResponse
    },
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  })], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider && _vm.provMessages.length > 0) ? _c('div', [_c('el-dialog', {
    attrs: {
      "title": 'Mensajes de ' + _vm.message.name,
      "visible": _vm.showModalMessage,
      "width": "90%",
      "fullscreen": true,
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalMessage = $event
      },
      "close": this.closeMessage,
      "opened": function($event) {
        return _vm.updateChat('messages-container')
      }
    }
  }, [_c('div', {
    staticClass: "box-body messages-container",
    staticStyle: {
      "max-height": "100%",
      "overflow": "auto"
    },
    attrs: {
      "id": "messages-container"
    }
  }, _vm._l((_vm.conversation), function(msg) {
    return _c('tr', {
      key: msg.idMessage,
      staticStyle: {
        "width": "100%",
        "float": "right"
      },
      attrs: {
        "id": msg.idMessage
      }
    }, [_c('div', {
      class: {
        'messages-rec': msg.idEmisor !== _vm.idUser,
        'messages-env': msg.idEmisor === _vm.idUser
      }
    }, [(msg.idEmisor !== _vm.idUser) ? _c('div', {
      staticStyle: {
        "font-weight": "600"
      }
    }, [_vm._v("\n              " + _vm._s(msg.senderType) + " - " + _vm._s('\n' + msg.sender) + " \n            ")]) : _vm._e(), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatMessage(msg.message))
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "padding-left": "15px",
        "font-size": "10px",
        "opacity": "0.8",
        "padding-top": "3px"
      }
    }, [_vm._v("\n              " + _vm._s(_vm.formatDate(msg.date)) + " \n              "), (msg.idEmisor === _vm.idUser && msg.status === '0') ? _c('i', {
      staticClass: "el-icon-more-outline"
    }) : _vm._e(), _vm._v(" "), (msg.idEmisor === _vm.idUser && msg.status === '1') ? _c('i', {
      staticClass: "el-icon-view"
    }) : _vm._e()])])])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newMessage),
      expression: "newMessage"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "calc(100% - 100px)",
      "margin-top": "-30px",
      "float": "left",
      "resize": "none"
    },
    attrs: {
      "rows": "3",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.newMessage)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.sendMessage(_vm.message.idUser)
      },
      "click": function($event) {
        return _vm.updateMsgStatus(_vm.message.idUser, 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.sendMessage(_vm.message.idUser)
      }
    }
  }, [_vm._v("\n          Enviar \n          "), (!_vm.loadingMsg) ? _c('i', {
    staticClass: "el-icon-arrow-right"
  }) : _vm._e(), _vm._v(" "), (_vm.loadingMsg) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e()])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Envio de mensaje masivo",
      "visible": _vm.showModalMassiveMessage,
      "width": "90%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalMassiveMessage = $event
      },
      "close": function($event) {
        _vm.showModalMessage = false
      },
      "opened": function($event) {
        return _vm.updateScroll('messages-container')
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newMessage),
      expression: "newMessage"
    }],
    staticStyle: {
      "width": "calc(100% - 1px)",
      "margin-top": "-30px",
      "float": "left",
      "resize": "none"
    },
    attrs: {
      "rows": "15"
    },
    domProps: {
      "value": (_vm.newMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newMessage = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right",
      "margin-top": "1%"
    },
    attrs: {
      "disabled": _vm.newMessage.length <= 0
    },
    on: {
      "click": function($event) {
        return _vm.sendMassiveMessage(_vm.providersSelected)
      }
    }
  }, [_vm._v(" Enviar Mensaje")])])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "top": "10px",
      "title": "Seleccionar Destinatarios",
      "visible": _vm.showModalMassiveMessageRecipients,
      "width": "50%",
      "height": "50%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalMassiveMessageRecipients = $event
      },
      "close": function($event) {
        _vm.showModalMessage = false
      }
    }
  }, [_c('div', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "CUIT / Nombre"
    },
    model: {
      value: (_vm.filtersRubro[1].value),
      callback: function($$v) {
        _vm.$set(_vm.filtersRubro[1], "value", $$v)
      },
      expression: "filtersRubro[1].value"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('data-tables', {
    staticClass: "table-responsive",
    attrs: {
      "data": _vm.contacts,
      "pagination-props": {
        pageSizes: [10, 20, 30]
      },
      "filters": _vm.filtersRubro
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "55"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.providersSelected),
            expression: "providersSelected"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "value": scope.row.idUser,
            "checked": Array.isArray(_vm.providersSelected) ? _vm._i(_vm.providersSelected, scope.row.idUser) > -1 : (_vm.providersSelected)
          },
          on: {
            "change": function($event) {
              var $$a = _vm.providersSelected,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = scope.row.idUser,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.providersSelected = $$a.concat([$$v]))
                } else {
                  $$i > -1 && (_vm.providersSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.providersSelected = $$c
              }
            }
          }
        })]
      }
    }], null, false, 71342713)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "name",
      "label": "Nombre"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "user",
      "label": "Email"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "company",
      "label": "Compañia"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "20px",
      "float": "right"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.providersSelected.length <= 0
    },
    on: {
      "click": function($event) {
        return _vm.openMassiveMessage()
      }
    }
  }, [_vm._v("\n        Siguiente\n      ")])], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {}, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 0
    }
  }, [_c('p')]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.selectMassiveMessageRecipients()
      }
    }
  }, [_vm._v("Enviar mensaje masivo")])], 1)], 1)], 1), _vm._v(" "), _c('data-tables-server', {
    attrs: {
      "data": this.providersMessages,
      "filters": _vm.filters,
      "pagination-props": {
        pageSizes: [10, 20, 30],
        currentPage: this.currentPage
      },
      "total": this.$store.state.contacts.length
    },
    on: {
      "query-change": _vm.loadData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": 'email',
      "align": 'center',
      "label": 'Usuario',
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": 'center',
      "label": "Mensaje"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.messages.length > 0) ? [_vm._v("\n                  " + _vm._s(_vm.getMostRecentMessage(scope.row.messages).message) + "\n              ")] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": 'Fecha',
      "align": 'center',
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.messages.length > 0) ? [_vm._v("\n                " + _vm._s(_vm.formatDate(_vm.getMostRecentMessage(scope.row.messages).date)) + "\n              ")] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": 'center',
      "label": 'Estado',
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.messages.length > 0) ? [_vm._v("\n                " + _vm._s(_vm.getMostRecentMessage(scope.row.messages).status === '0' ? _vm.getMostRecentMessage(scope.row.messages).idEmisor === _vm.idUser ? 'Enviado' : 'Recibido' : 'Visto') + "\n              ")] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "align": 'center',
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Ver",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-view",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.seeMessage(scope.row)
            }
          }
        })], 1)]
      }
    }], null, false, 2740672783)
  })], 1)], 1)])])], 1) : _vm._e(), _vm._v(" "), (_vm.user.isProvider && _vm.myMessages.length > 0) ? _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-body messages-container",
    staticStyle: {
      "max-height": "100%",
      "overflow": "auto",
      "height": "calc(100vh - 230px)"
    },
    attrs: {
      "id": "messages-container"
    }
  }, _vm._l((_vm.myMessages), function(msg) {
    return _c('tr', {
      key: msg.idMessage,
      staticStyle: {
        "width": "100%",
        "float": "right"
      }
    }, [_c('div', {
      class: {
        'messages-rec': msg.idEmisor !== _vm.idUser,
        'messages-env': msg.idEmisor === _vm.idUser
      }
    }, [(msg.idEmisor !== _vm.idUser) ? _c('div', {
      staticStyle: {
        "font-weight": "600"
      }
    }, [_vm._v("\n                " + _vm._s(msg.senderType) + " - " + _vm._s(msg.sender) + " \n              ")]) : _vm._e(), _vm._v("\n              " + _vm._s(_vm.formatMessage(msg.message)) + "\n              "), _c('span', {
      staticStyle: {
        "float": "right",
        "padding-left": "15px",
        "font-size": "10px",
        "opacity": "0.8",
        "padding-top": "3px"
      }
    }, [_vm._v(" \n                " + _vm._s(_vm.formatDate(msg.date)) + " \n                "), (msg.idEmisor === _vm.idUser && msg.status === '0') ? _c('i', {
      staticClass: "el-icon-more-outline"
    }) : _vm._e(), _vm._v(" "), (msg.idEmisor === _vm.idUser && msg.status === '1') ? _c('i', {
      staticClass: "el-icon-view"
    }) : _vm._e()])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "messages-footer"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newMessage),
      expression: "newMessage"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "calc(100% - 100px)",
      "float": "left",
      "resize": "none"
    },
    attrs: {
      "rows": "3",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.newMessage)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.sendMessage(0)
      },
      "click": function($event) {
        return _vm.updateMsgStatus(_vm.idUser, 2)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "20px",
      "float": "right",
      "margin-right": "7px"
    },
    on: {
      "click": function($event) {
        return _vm.sendMessage(0)
      }
    }
  }, [_vm._v("\n            Enviar \n            "), (!_vm.loadingMsg) ? _c('i', {
    staticClass: "el-icon-arrow-right"
  }) : _vm._e(), _vm._v(" "), (_vm.loadingMsg) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e()])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": _vm.titulo
    }
  }, [(_vm.filePath) ? _c('span', [_c('a', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "href": _vm.filePath,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" Ver\n      ")])]) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1), _vm._v(" "), _c('el-upload', {
    ref: "refFile",
    staticClass: "upload-demo",
    attrs: {
      "v-if": _vm.habModificaPdf,
      "id": _vm.id,
      "action": _vm.serverURI + 'api/uploadPdfFile',
      "auto-upload": true,
      "accept": "application/pdf",
      "on-success": _vm.handlePdf,
      "on-exceed": _vm.handleExceed,
      "on-remove": _vm.handleRemove,
      "show-file-list": false,
      "data": {
        folder: 'altaProveedor',
      },
      "limit": 0
    }
  }, [(_vm.habModificaPdf) ? _c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("Seleccionar archivo")]) : _vm._e(), _vm._v(" "), (_vm.fileName) ? _c('el-button', {
    attrs: {
      "size": "small",
      "enable": "false",
      "type": "secondary"
    }
  }, [_vm._v(_vm._s(_vm.fileName ? _vm.fileName + ".pdf" : "-"))]) : _vm._e(), _vm._v(" "), (_vm.filePath && _vm.habModificaPdf) ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.removePdf
    }
  }, [_vm._v("X")]) : _vm._e(), _vm._v(" "), (_vm.habModificaPdf && !_vm.disabled) ? _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("Solo se permiten archivos PDF")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', [_c('el-dialog', {
    staticStyle: {
      "margin-top": "-10vh",
      "overflow": "hidden"
    },
    attrs: {
      "title": "Confirmar cambios",
      "visible": _vm.showModalConfirmarDocumentacion,
      "max-width": "700px",
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalConfirmarDocumentacion = $event
      },
      "close": function($event) {
        return _vm.cerrarModalConfirmarDocumentacion()
      }
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": 'Documentos aceptados (' + _vm.documentosAceptados.length + ')'
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.documentosAceptados
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Tipo de documento"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.document) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "date",
      "label": "Fecha"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Archivo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "padding-right": "20px"
          },
          attrs: {
            "href": scope.row.url,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        }), _vm._v(" PDF\n                  ")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": 'Documentos rechazados (' + _vm.documentosRechazados.length + ')'
    }
  }, [_c('el-table', {
    staticStyle: {
      "max-height": "calc("
    },
    attrs: {
      "data": _vm.documentosRechazados
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Tipo de documento",
      "width": "130px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(scope.row.document) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "emisionDate",
      "label": "Fecha de emisión",
      "width": "200px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Archivo",
      "width": "90px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "padding-right": "20px"
          },
          attrs: {
            "href": scope.row.url,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o"
        }), _vm._v(" PDF\n                  ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Mensaje",
      "span": 12
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "textarea",
            "resize": "none",
            "rows": 3
          },
          model: {
            value: (scope.row.mensajeRechazo),
            callback: function($$v) {
              _vm.$set(scope.row, "mensajeRechazo", $$v)
            },
            expression: "scope.row.mensajeRechazo"
          }
        })]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.cerrarModalConfirmarDocumentacion()
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.confirmarDocumentos()
      }
    }
  }, [_vm._v("\n            Guardar\n          ")])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Documentación",
      "visible": _vm.showModalDocumentation,
      "width": "70%",
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showModalDocumentation = $event
      },
      "close": function($event) {
        _vm.showModalDocumentation = false
      }
    }
  }, [(!_vm.user.isProvider) ? _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Compañia")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Seleccione Compania"
    },
    model: {
      value: (_vm.idCompany),
      callback: function($$v) {
        _vm.idCompany = $$v
      },
      expression: "idCompany"
    }
  }, _vm._l((_vm.providers), function(item) {
    return _c('el-option', {
      key: item.idCompany,
      attrs: {
        "label": item.companyName,
        "value": item.idCompany
      }
    })
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Fecha de emisión")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "value-format": "yyyy/MM/dd",
      "placeholder": "Fecha de emisión"
    },
    model: {
      value: (_vm.emisionDate),
      callback: function($$v) {
        _vm.emisionDate = $$v
      },
      expression: "emisionDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Tipo de documento")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Tipo de documento"
    },
    model: {
      value: (_vm.idDocument),
      callback: function($$v) {
        _vm.idDocument = $$v
      },
      expression: "idDocument"
    }
  }, _vm._l((_vm.documentType), function(item) {
    return _c('el-option', {
      key: item.idDocument,
      attrs: {
        "label": item.documentName,
        "value": item.idDocument
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("PDF")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    ref: "fileDocument",
    staticStyle: {
      "width": "80%",
      "float": "left"
    },
    attrs: {
      "type": "file",
      "accept": "application/pdf"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.showModalDocumentation = false, _vm.resetModal()
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.uploadDocumentation()
      }
    }
  }, [_vm._v("\n            Enviar\n          ")])])])], 1), _vm._v(" "), (_vm.providerDocumentStatus) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "'font-size": "15px",
      "text-align": "center"
    }
  }, _vm._l((_vm.providerDocumentStatus), function(item, index) {
    return _c('th', {
      style: ('text-align: center; vertical-align: middle;width: ' + (100 / _vm.providerDocumentStatus.length) + '%')
    }, [_vm._v(_vm._s(item.description))])
  }), 0)]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "font-size": "25px",
      "text-align": "center"
    }
  }, _vm._l((_vm.providerDocumentStatus), function(item, index) {
    return _c('td', {
      staticClass: "statusHover",
      on: {
        "click": function($event) {
          return _vm.searchStatus(item.idProviderDocumentStatus)
        }
      }
    }, [_vm._v(_vm._s(_vm.getCountByStatus(item.idProviderDocumentStatus)))])
  }), 0)])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.response) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Advertencia")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.response))])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    staticStyle: {
      "background-color": "#bf0532",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.showModalDocumentation = true
      }
    }
  }, [_vm._v("\n                Subir Documentación\n            ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "Estado"
    },
    model: {
      value: (_vm.filters[0].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[0], "value", $$v)
      },
      expression: "filters[0].value"
    }
  }, _vm._l((_vm.providerDocumentStatus), function(item) {
    return _c('el-option', {
      key: item.idProviderDocumentStatus,
      attrs: {
        "value": item.idProviderDocumentStatus,
        "label": item.description
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "A",
      "start-placeholder": "Desde",
      "end-placeholder": "Hasta",
      "unlink-panels": ""
    },
    model: {
      value: (_vm.filters[1].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[1], "value", $$v)
      },
      expression: "filters[1].value"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('data-tables', {
    staticClass: "table-responsive",
    attrs: {
      "data": _vm.documents,
      "pagination-props": {
        pageSizes: [10, 20, 30]
      },
      "filters": _vm.filters
    }
  }, [(!_vm.user.isProvider) ? _c('el-table-column', {
    attrs: {
      "label": "Compañia",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.companyName) + "\n          ")]
      }
    }], null, false, 1737064925)
  }) : _vm._e(), _vm._v(" "), (!_vm.user.isProvider) ? _c('el-table-column', {
    attrs: {
      "label": "CUIT",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.cuit) + "\n          ")]
      }
    }], null, false, 2208011766)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Fecha de alta",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.date) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Fecha de emisión",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.emisionDate) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Estado",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.status) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tipo de documento",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.document) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Justificacion Rechazo",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.mostrarMensajeCompleto(scope.row.mensajeRechazo)
            }
          }
        }, [_vm._v("\n              " + _vm._s(scope.row.mensajeRechazo) + "\n            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Documento",
      "align": 'center'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": scope.row.url,
            "target": "_blank"
          }
        }, [_c('el-button', {
          attrs: {
            "circle": "",
            "type": "primary",
            "icon": "el-icon-document"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), (!_vm.user.isProvider && _vm.documents.some(function (el) { return el.status === 'Enviado'; })) ? _c('el-table-column', {
    attrs: {
      "label": "Aceptar",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "disabled": _vm.documentosAceptados.length === 0 && _vm.documentosRechazados.length === 0,
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.abrirModalConfirmacion()
            }
          }
        }, [_vm._v("\n              Aceptar\n            ")])]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return (scope.row.status === 'Enviado') ? [_c('el-button-group', [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": (_vm.documentosAceptados.includes(scope.row)) ? 'success' : ''
          },
          on: {
            "click": function($event) {
              return _vm.handleIncluirDocumento(scope.row, 1)
            }
          }
        }, [_vm._v("\n                Si\n              ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": (_vm.documentosRechazados.includes(scope.row)) ? 'danger' : ''
          },
          on: {
            "click": function($event) {
              return _vm.handleIncluirDocumento(scope.row, 2)
            }
          }
        }, [_vm._v("\n                No\n              ")])], 1)] : undefined
      }
    }], null, true)
  }) : _vm._e()], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
}]}

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendComment.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "rows": "5",
      "name": "comment",
      "id": "comment",
      "placeholder": "Pedido de actualización de datos",
      "required": ""
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Enviar pedido")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.response) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Advertencia")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.response))])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.success) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.success))])])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "comment"
    }
  }, [_vm._v("Pedido")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-green"
  }, [_c('i', {
    staticClass: "ion ion-android-checkmark-circle"
  })])
}]}

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "Certificado de exclusión: Retención Ganancias",
      "visible": _vm.showModalCertificationExgain,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationExgain = false
      }
    }
  }, [(this.certificationExgain[0]) ? _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticClass: "tg",
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "222px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0lax"
  }, [_vm._v("Certificado:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].number))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-j58y"
  }, [_vm._v("Cuit:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].cuit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Período fiscal:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].period))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Porcentaje:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].percentage))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Resolución:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].resolution))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Estado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].state))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Fecha de Publicación:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("\n                " + _vm._s(_vm.certificationExgain[0].publication) + "\n              ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Fecha de Vigencia:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationExgain[0].validity))])])])])], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationExgain
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Lista de certificados de exclusión: Retención Ganancias",
      "visible": _vm.showModalCertificationsExgainList,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationsExgainList = false
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "140px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "140px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "135px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "20px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Nro Certificado:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de emisión:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de vigencia:")])]), _vm._v(" "), _vm._l((_vm.certificationExgainList), function(item) {
    return _c('tr', {
      key: item.IdCertificationExGain
    }, [_c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.publication))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.validity))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4B"
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary",
        "plain": "",
        "icon": "el-icon-view"
      },
      on: {
        "click": function($event) {
          return _vm.getCertificationExgain(item.IdCertificationExGain)
        }
      }
    })], 1)])
  })], 2)])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationsExgainList
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Certificado de exención: RG2681",
      "visible": _vm.showModalCertificationRg2681,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationRg2681 = false
      }
    }
  }, [(this.certificationRg2681[0]) ? _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticClass: "tg",
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "222px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0lax"
  }, [_vm._v("Cuit:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].cuit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Tipo de sujeto:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].type))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Cod. Estado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].state))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Desc. Estado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("\n                " + _vm._s(_vm.certificationRg2681[0].stateDescription) + "\n              ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Fecha de Emisión del Certificado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].emision))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Fecha Adm. Formal:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("\n                " + _vm._s(_vm.certificationRg2681[0].administrationDate) + "\n              ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Autoriza Deducción:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].auth))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Obligado Pres. DDJJ:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].ddjj))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Código Inciso:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].subsection))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Vigencia desde:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].since))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Vigencia hasta:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].until))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Nro Certificado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].number))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Por orden judicial:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg2681[0].orderJud))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Fecha última modificación:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("\n                " + _vm._s(_vm.certificationRg2681[0].modificationDate) + "\n              ")])])])])], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationRg2681
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Datos adicionales del certificado",
      "visible": _vm.showModalCertificationDatosAdicionales,
      "width": "30%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationDatosAdicionales = false
      }
    }
  }, [(_vm.taxData.jurisdictions[_vm.activeJurisdiction]) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "Seleccionar"
    },
    model: {
      value: (_vm.taxData.jurisdictions[_vm.activeJurisdiction].certificateFrom),
      callback: function($$v) {
        _vm.$set(_vm.taxData.jurisdictions[_vm.activeJurisdiction], "certificateFrom", $$v)
      },
      expression: "taxData.jurisdictions[activeJurisdiction].certificateFrom"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.disabledDates,
      "type": "date",
      "placeholder": "Seleccionar"
    },
    model: {
      value: (_vm.taxData.jurisdictions[_vm.activeJurisdiction].certificateTo),
      callback: function($$v) {
        _vm.$set(_vm.taxData.jurisdictions[_vm.activeJurisdiction], "certificateTo", $$v)
      },
      expression: "taxData.jurisdictions[activeJurisdiction].certificateTo"
    }
  })], 1), _vm._v(" "), _c('div', [_c('el-upload', {
    ref: 'jurisdictions\[' + _vm.jurId + '\]\[\'certificatePdf\'\]',
    staticClass: "upload-demo",
    attrs: {
      "id": "uploadCertificatePdf",
      "action": _vm.serverURI + 'api/uploadFile',
      "auto-upload": true,
      "accept": "application/pdf",
      "on-success": _vm.handlePdfCertificate,
      "on-exceed": _vm.handleExceed,
      "data": {
        folder: 'altaProveedor',
      },
      "limit": 1
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("Seleccionar archivo")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("\n            Solo se permiten archivos PDF\n          ")])], 1), _vm._v(" "), _c('span', [(_vm.taxData.jurisdictions[_vm.activeJurisdiction].certificatePdf) ? _c('a', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "href": _vm.taxData.jurisdictions[_vm.activeJurisdiction].certificatePdf,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" Ver\n          ")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showModalCertificationDatosAdicionales = false
      }
    }
  }, [_vm._v("Confirmar")])], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Formulario 1276",
      "visible": _vm.showModalForm1276,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalForm1276 = false
      }
    }
  }, [(_vm.taxData.jurisdictions[_vm.activeJurisdiction]) ? _c('div', [_c('div', [_c('el-upload', {
    ref: 'jurisdictions\[' + _vm.jurId + '\]\[\'form1276pdf\'\]',
    staticClass: "upload-demo",
    attrs: {
      "id": "uploadForm1276",
      "action": _vm.serverURI + 'api/uploadFile',
      "auto-upload": true,
      "accept": "application/pdf",
      "on-success": _vm.handlePdfForm1276,
      "on-exceed": _vm.handleExceed,
      "data": {
        folder: 'altaProveedor',
      },
      "limit": 1
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("Seleccionar archivo")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("\n            Solo se permiten archivos PDF\n          ")])], 1), _vm._v(" "), _c('span', [(_vm.taxData.jurisdictions[_vm.activeJurisdiction].form1276pdf) ? _c('a', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "href": _vm.taxData.jurisdictions[_vm.activeJurisdiction].form1276pdf,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" Ver\n          ")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showModalForm1276 = false
      }
    }
  }, [_vm._v("Confirmar")])], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Lista de certificados de exención: RG2681",
      "visible": _vm.showModalCertificationRg2681List,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationRg2681List = false
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "140px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "140px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "135px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "20px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Nro Certificado:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de emisión:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de vigencia:")])]), _vm._v(" "), _vm._l((_vm.certificationRg2681List), function(item) {
    return _c('tr', {
      key: item.idCertificationRG2681
    }, [_c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.emision))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.until))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4B"
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary",
        "plain": "",
        "icon": "el-icon-view"
      },
      on: {
        "click": function($event) {
          return _vm.getCertificationRg2681(item.idCertificationRG2681)
        }
      }
    })], 1)])
  })], 2)])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationsRg2681List
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Certificado de exclusión: Retención SUSS",
      "visible": _vm.showModalCertificationSuss,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationSuss = false
      }
    }
  }, [(this.certificationSuss[0]) ? _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticClass: "tg",
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "222px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0lax"
  }, [_vm._v("Certificado:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].number))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-j58y"
  }, [_vm._v("Cuit:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].cuit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Período fiscal:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].period))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Porcentaje:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].percentage))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Resolución:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].resolution))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Estado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].state))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Fecha de Publicación:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].since))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Fecha de Vigencia:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationSuss[0].until))])])])])], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationSuss
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Lista de certificados de exclusión: SUSS",
      "visible": _vm.showModalCertificationSussList,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationSussList = false
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "140px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "140px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "135px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "20px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Nro Certificado:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de emisión:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de vigencia:")])]), _vm._v(" "), _vm._l((_vm.certificationSussList), function(item) {
    return _c('tr', {
      key: item.idCertificaction
    }, [_c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.since))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.until))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4B"
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary",
        "plain": "",
        "icon": "el-icon-view"
      },
      on: {
        "click": function($event) {
          return _vm.getCertificationSuss(item.idCertificaction)
        }
      }
    })], 1)])
  })], 2)])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationsSussList
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Certificado de agente de retención RG18: Retención I.V.A",
      "visible": _vm.showModalCertificationRg18,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationRg18 = false
      }
    }
  }, [(this.certificationRg18[0]) ? _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticClass: "tg",
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "222px"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-j58y"
  }, [_vm._v("Cuit:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg18[0].cuit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Razón Social:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg18[0].name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("INCISO RG:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg18[0].type))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Fecha de Publicación:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg18[0].since))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Fecha de Vigencia:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg18[0].until))])])])])], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationRg18
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Lista de agente de retención: RG18",
      "visible": _vm.showModalCertificationRg18List,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationRg18List = false
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "150px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de emisión:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de vigencia:")])]), _vm._v(" "), _vm._l((_vm.certificationRg18List), function(item) {
    return _c('tr', {
      key: item.idCertificationRG18
    }, [_c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.since))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.until))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4B"
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary",
        "plain": "",
        "icon": "el-icon-view"
      },
      on: {
        "click": function($event) {
          return _vm.getCertificationRg18(item.idCertificationRG18)
        }
      }
    })], 1)])
  })], 2)])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationsRg18List
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Certificado de exclusión RG17: Retención I.V.A",
      "visible": _vm.showModalCertificationRg17,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationRg17 = false
      }
    }
  }, [(this.certificationRg17[0]) ? _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticClass: "tg",
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "222px"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-j58y"
  }, [_vm._v("Cuit:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].cuit))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Razón Social:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].name))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Porcentaje:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].percentage))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("INCISO RG:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].rg))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Tipo de Certificado:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].type))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v("Fecha de Publicación:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-0lax"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].since))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v("Fecha de Vigencia:")]), _vm._v(" "), _c('td', {
    staticClass: "tg-buh4"
  }, [_vm._v(_vm._s(_vm.certificationRg17[0].until))])])])])], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationRg17
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Lista de certificados de exclusión: RG17",
      "visible": _vm.showModalCertificationRg17List,
      "width": "40%",
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "close": function($event) {
        _vm.showModalCertificationRg17List = false
      }
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-card', {
    attrs: {
      "shadow": "always"
    }
  }, [_c('table', {
    staticStyle: {
      "table-layout": "fixed",
      "width": "429px"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "207px"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "150px"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de emisión:")]), _vm._v(" "), _c('th', {
    staticClass: "tg-0laxA"
  }, [_vm._v("Fecha de vigencia:")])]), _vm._v(" "), _vm._l((_vm.certificationRg17List), function(item) {
    return _c('tr', {
      key: item.idCertificationRG17
    }, [_c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.since))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4A"
    }, [_vm._v(_vm._s(item.until))]), _vm._v(" "), _c('td', {
      staticClass: "td-buh4B"
    }, [_c('el-button', {
      attrs: {
        "size": "mini",
        "type": "primary",
        "plain": "",
        "icon": "el-icon-view"
      },
      on: {
        "click": function($event) {
          return _vm.getCertificationRg17(item.idCertificationRG17)
        }
      }
    })], 1)])
  })], 2)])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeCertificationsRg17List
    }
  }, [_vm._v("\n        Aceptar\n      ")])])]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "-12vh",
      "height": "auto",
      "overflow-y": "hidden"
    },
    attrs: {
      "title": "Confirmar Alta de Proveedor",
      "visible": _vm.terminosYCondVisible,
      "width": "80%",
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.terminosYCondVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "60vh",
      "overflow": "auto"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.configuration))]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked2),
      expression: "checked2"
    }],
    staticStyle: {
      "width": "15px",
      "float": "left",
      "margin-right": "5px"
    },
    attrs: {
      "type": "checkbox",
      "name": "aceptoCodigoEtica",
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.checked2) ? _vm._i(_vm.checked2, null) > -1 : (_vm.checked2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checked2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checked2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked2 = $$c
        }
      }
    }
  }), _vm._v("\n        Acepto el\n        "), _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.codigoEtica
    }
  }, [_vm._v("Código de Ética y Conducta")]), _vm._v(".\n      ")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    staticStyle: {
      "width": "15px",
      "float": "left",
      "margin-right": "5px"
    },
    attrs: {
      "type": "checkbox",
      "name": "aceptoTerminos",
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, null) > -1 : (_vm.checked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked = $$c
        }
      }
    }
  }), _vm._v("\n        Acepto las políticas:\n        "), _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.politicaAnticorrupcion
    }
  }, [_vm._v("Política Anticorrupción")]), _vm._v("\n        y\n        "), _c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.politicaRelacionamiento
    }
  }, [_vm._v("Política de Relacionamiento con Funcionarios Públicos.")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    staticStyle: {
      "position": "relative",
      "left": "45%"
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.checked2 || !_vm.checked
    },
    on: {
      "click": function($event) {
        return _vm.submitFormSolicitud()
      }
    }
  }, [_vm._v("\n          Aceptar\n        ")])])])]), _vm._v(" "), (!_vm.paramError && !_vm.provider) ? _c('h1', {
    staticClass: "text-center"
  }, [_vm._v("\n    SOLICITAR SER PROVEEDOR\n  ")]) : _vm._e(), _vm._v(" "), (!_vm.paramError && !_vm.provider) ? _c('p', {
    staticClass: "text-center"
  }, [_vm._v("\n    Complete el formulario\n  ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "text-center text-danger",
    staticStyle: {
      "font-weight": "bold",
      "font-size": "15px"
    }
  }, [_vm._v("Usted está aprobando/rechazando los datos para que la empresa pueda operar en " + _vm._s(_vm.actualCountryFull))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('el-button', {
    staticStyle: {
      "display": "inline-block",
      "float": "right",
      "transition": "all 1s",
      "margin-right": "30px",
      "margin-top": "20px"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-left"
  }), _vm._v("\n      Volver\n    ")])], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [(_vm.paramError) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Advertencia")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.paramError))])])])])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('el-steps', {
    attrs: {
      "active": _vm.step,
      "finish-status": "success",
      "align-center": ""
    }
  }, [_c('el-step', {
    attrs: {
      "title": "Datos Generales"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "Datos Bancarios"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "Datos Impositivos"
    }
  }), _vm._v(" "), (!_vm.provider) ? _c('el-step', {
    attrs: {
      "title": "Usuario"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (!_vm.paramError) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [(_vm.step === 0) ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Datos Generales")]) : _vm._e(), _vm._v(" "), (_vm.provider.generalData) ? _c('span', [(_vm.step === 0) ? _c('h5', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "-3.3%"
    }
  }, [_vm._v("\n                Ultima modificación: " + _vm._s(_vm.provider.generalData.modifDate) + "\n              ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.step === 1) ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Datos de Pago")]) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Datos Impositivos")]) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Usuario")]) : _vm._e()]), _vm._v(" "), (
    _vm.user &&
    _vm.user.isProvider &&
    _vm.provider &&
    _vm.provider[_vm.activeTab()].idCompanyDataStatus ===
    _vm.status.ESPERANDO_CONFIRMACION
  ) ? _c('el-alert', {
    attrs: {
      "title": "Etapa en verificacion",
      "type": "warning",
      "description": "Los datos de esta etapa estan siendo verificados.",
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), (
    (_vm.user &&
      _vm.user.isProvider &&
      _vm.provider &&
      _vm.provider[_vm.activeTab()].idCompanyDataStatus === _vm.status.ACEPTADO) ||
    (_vm.user &&
      !_vm.user.isProvider &&
      _vm.provider &&
      _vm.provider[_vm.activeTab()].idCompanyDataStatus === _vm.status.ESPERANDO_CONFIRMACION)
  ) ? _c('div', {
    staticClass: "col-md-12"
  }, [(!_vm.editing) ? _c('el-button', {
    staticStyle: {
      "float": "left",
      "margin-top": "1%"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.editData
    }
  }, [_vm._v("Editar")]) : _c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v("Guardar")]), _vm._v(" "), (_vm.editing === true) ? _c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.cancelData
    }
  }, [_vm._v("Cancelar")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.providerLoaded && this.user && this.idCompany),
      expression: "!providerLoaded && this.user && this.idCompany"
    }],
    staticClass: "box-body"
  }, [_c('el-col', {
    staticStyle: {
      "width": "80%",
      "margin-left": "10%"
    }
  }, [(_vm.provider && false) ? _c('el-row', {
    staticStyle: {
      "height": "90px",
      "padding-top": "20px",
      "text-align": "right"
    }
  }, [_c('el-tag', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "effect": "dark",
      "type": _vm.statusType
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.getStatusNameOfTab()) + "\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.step === 0) ? _c('el-form', {
    ref: "generalDataForm",
    attrs: {
      "model": _vm.generalData,
      "disabled": _vm.disabledData,
      "rules": _vm.rulesGeneralData,
      "label-position": "left",
      "label-width": "25%",
      "id": "formDatosGenerales"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "info-box-content"
  }, [_c('p', {
    staticClass: "text-danger"
  }, [_vm._v("\n                    Los campos acompañados con asterisco(*) son obligatorios.\n                  ")])]), _vm._v(" "), _c('h5', {
    staticStyle: {
      "margin-top": "-3%"
    }
  }, [_vm._v("\n                  Fecha de creación: " + _vm._s(_vm.provider.creationDate) + "\n                ")]), _vm._v(" "), _c('el-divider', [_vm._v("Datos de la empresa")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "CUIT (sin guiones)",
      "prop": "cuit"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "id": "cuit",
      "type": "text",
      "maxlength": "11",
      "show-word-limit": "",
      "disabled": _vm.dataAfip !== ''
    },
    model: {
      value: (_vm.generalData.cuit),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "cuit", _vm._n($$v))
      },
      expression: "generalData.cuit"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16,
      "align": "center"
    }
  }, [(!_vm.dataAfip) ? _c('el-button', {
    attrs: {
      "id": "verificarAFIP",
      "size": "mini",
      "disabled": _vm.generalData.cuit.toString().length !== 11,
      "type": "primary"
    },
    on: {
      "click": _vm.verifyCuit
    }
  }, [_vm._v("\n                      Verificar AFIP\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.dataAfip && !this.provider) ? _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "warning"
    },
    on: {
      "click": _vm.editCuit
    }
  }, [_vm._v("\n                      Editar\n                    ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dataAfip),
      expression: "dataAfip"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "Razón Social / Denominación",
      "prop": "company"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "255",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.generalData.company),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "company", $$v)
      },
      expression: "generalData.company"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nombre de Fantasía",
      "prop": "companyName"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "maxlength": "255"
    },
    model: {
      value: (_vm.generalData.companyName),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "companyName", $$v)
      },
      expression: "generalData.companyName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Fecha de inicio de Actividades",
      "prop": "start_date"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "Inicio de Actividades",
      "disabled": !_vm.editing
    },
    on: {
      "change": function($event) {
        return _vm.saveDataToLocalStorage(_vm.generalData.start_date, 'start_date')
      }
    },
    model: {
      value: (_vm.generalData.start_date),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "start_date", $$v)
      },
      expression: "generalData.start_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "¿En qué central prestará el servicio?",
      "prop": "centrales"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "centrales",
      "multiple": "",
      "filterable": "",
      "clearable": "",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.generalData.centrales),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "centrales", $$v)
      },
      expression: "generalData.centrales"
    }
  }, _vm._l((_vm.centrales), function(item) {
    return _c('el-option', {
      key: item.idCentral,
      attrs: {
        "label": item.central,
        "value": item.idCentral
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Servicio / Actividad",
      "prop": "rubros"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "filterable": "",
      "clearable": "",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.generalData.rubros),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "rubros", $$v)
      },
      expression: "generalData.rubros"
    }
  }, _vm._l((_vm.services), function(item) {
    return _c('el-option', {
      key: item.idRubro,
      attrs: {
        "label": item.nombre,
        "value": item.idRubro
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "Calle",
      "prop": "address"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 19
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.address),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "address", $$v)
      },
      expression: "generalData.address"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "label": "Nº",
      "prop": "addressNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "maxlength": "200"
    },
    model: {
      value: (_vm.generalData.addressNumber),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "addressNumber", $$v)
      },
      expression: "generalData.addressNumber"
    }
  })], 1)], 1), _vm._v(" "), (_vm.provider.generalData) ? _c('span', [(
    _vm.provider.logCompanyGeneralData &&
    (_vm.provider.generalData.address !=
      _vm.provider.logCompanyGeneralData.address ||
      _vm.provider.generalData.addressNumber !=
      _vm.provider.logCompanyGeneralData
      .addressNumber)
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Código Postal",
      "prop": "zipCode"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "type": "text",
      "maxlength": "20",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.generalData.zipCode),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "zipCode", $$v)
      },
      expression: "generalData.zipCode"
    }
  })], 1), _vm._v(" "), (_vm.provider.generalData) ? _c('span', [(
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.zipCode !=
    _vm.provider.logCompanyGeneralData.zipCode
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                              Campo\n                              "), _vm._v("modificado\n                            ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "País",
      "prop": "idCountry"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "country",
      "filterable": "",
      "clearable": "",
      "disabled": !_vm.editing
    },
    on: {
      "change": _vm.updateProvinces
    },
    model: {
      value: (_vm.generalData.idCountry),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "idCountry", $$v)
      },
      expression: "generalData.idCountry"
    }
  }, _vm._l((_vm.countries), function(item) {
    return _c('el-option', {
      key: item.idCountry,
      attrs: {
        "label": item.country,
        "value": item.idCountry
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.idCountry !=
    _vm.provider.logCompanyGeneralData.idCountry
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                              Campo\n                              "), _vm._v("modificado\n                            ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Provincia",
      "prop": "idProvince"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "state",
      "disabled": _vm.generalData.idCountry === '' || !_vm.editing,
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.generalData.idProvince),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "idProvince", $$v)
      },
      expression: "generalData.idProvince"
    }
  }, _vm._l((_vm.provinces), function(item) {
    return _c('el-option', {
      key: item.idProvince,
      attrs: {
        "label": item.province,
        "value": item.idProvince
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.idProvince !=
    _vm.provider.logCompanyGeneralData.idProvince
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Ciudad",
      "prop": "city"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.city),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "city", $$v)
      },
      expression: "generalData.city"
    }
  })], 1), _vm._v(" "), (_vm.provider.generalData) ? _c('span', [(
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.city !=
    _vm.provider.logCompanyGeneralData.city
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                              Campo\n                              "), _vm._v("modificado\n                            ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "E-mail aviso de Pago",
      "prop": "paymentEmail"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.paymentEmail),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "paymentEmail", $$v)
      },
      expression: "generalData.paymentEmail"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.paymentEmail !=
    _vm.provider.logCompanyGeneralData.paymentEmail
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "E-mail aviso de Recepción",
      "prop": "receiptEmail"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.receiptEmail),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "receiptEmail", $$v)
      },
      expression: "generalData.receiptEmail"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.receiptEmail !=
    _vm.provider.logCompanyGeneralData.receiptEmail
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sujeto IVA",
      "prop": "typeIVA"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "sujeto",
      "filterable": "",
      "clearable": "",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.generalData.typeIVA),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "typeIVA", $$v)
      },
      expression: "generalData.typeIVA"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "IVA Responsable Inscripto",
      "value": "01"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IVA Responsable no Inscripto",
      "value": "02"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IVA No Responsable",
      "value": "03"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IVA Sujeto a exención",
      "value": "04"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "IVA consumidor final",
      "value": "05"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Responsable Monotributo Bienes",
      "value": "06"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Responsable Monotributo Servicios",
      "value": "006"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Sujeto no Categorizado",
      "value": "07"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Proveedor del exterior",
      "value": "08"
    }
  })], 1)], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.typeIVA !=
    _vm.provider.logCompanyGeneralData.typeIVA
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                              Campo\n                              "), _vm._v("modificado\n                            ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Persona",
      "prop": "personType"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "persona",
      "filterable": "",
      "clearable": "",
      "disabled": !_vm.editing
    },
    on: {
      "change": function($event) {
        _vm.generalData.personSubType = ''
      }
    },
    model: {
      value: (_vm.generalData.personType),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "personType", $$v)
      },
      expression: "generalData.personType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Física",
      "value": "Física"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Jurídica",
      "value": "Jurídica"
    }
  })], 1)], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.personType !=
    _vm.provider.logCompanyGeneralData.personType
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                              Campo\n                              "), _vm._v("modificado\n                            ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.generalData.personType === 'Jurídica') ? _c('el-form-item', {
    attrs: {
      "label": "Subtipo",
      "prop": "personSubType"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "disabled": !_vm.editing
    },
    on: {
      "change": function($event) {
        _vm.generalData.personSubTypeOther = ''
      }
    },
    model: {
      value: (_vm.generalData.personSubType),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "personSubType", $$v)
      },
      expression: "generalData.personSubType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "S.A.",
      "value": "S.A."
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "S.R.L.",
      "value": "S.R.L."
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "S.H.",
      "value": "S.H."
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Otro",
      "value": "Otro"
    }
  })], 1)], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.personSubType !=
    _vm.provider.logCompanyGeneralData.personSubType
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                              Campo\n                              "), _vm._v("modificado\n                            ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.generalData.personSubType === 'Otro') ? _c('el-form-item', [_c('el-form-item', {
    attrs: {
      "label": "Otro subtipo",
      "prop": "personSubTypeOther"
    }
  }, [_c('el-form-item', [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.personSubTypeOther),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "personSubTypeOther", $$v)
      },
      expression: "generalData.personSubTypeOther"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.personSubTypeOther !=
    _vm.provider.logCompanyGeneralData
    .personSubTypeOther
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                                Campo\n                                "), _vm._v("modificado\n                              ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.generalData.pdfAfip,
      "habModificaPdf": _vm.editing,
      "titulo": "* Alta de AFIP actualizada a la fecha",
      "id": "altadeAfip",
      "prop": "pdfAfip"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.generalData, "pdfAfip", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.generalData, "pdfAfip", $event)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_vm._v("Contacto principal")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nombre",
      "prop": "namePrincipalContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.namePrincipalContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "namePrincipalContact", $$v)
      },
      expression: "generalData.namePrincipalContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.namePrincipalContact !=
    _vm.provider.logCompanyGeneralData
    .namePrincipalContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Apellido",
      "prop": "surnamePrincipalContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.surnamePrincipalContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "surnamePrincipalContact", $$v)
      },
      expression: "generalData.surnamePrincipalContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.surnamePrincipalContact !=
    _vm.provider.logCompanyGeneralData
    .surnamePrincipalContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Teléfono",
      "prop": "phonePrincipalContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.phonePrincipalContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "phonePrincipalContact", $$v)
      },
      expression: "generalData.phonePrincipalContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.phonePrincipalContact !=
    _vm.provider.logCompanyGeneralData
    .phonePrincipalContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "E-mail",
      "prop": "emailPrincipalContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.emailPrincipalContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "emailPrincipalContact", $$v)
      },
      expression: "generalData.emailPrincipalContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.emailPrincipalContact !=
    _vm.provider.logCompanyGeneralData
    .emailPrincipalContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_vm._v("Contacto comercial")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nombre",
      "prop": "nameCommercialContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.nameCommercialContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "nameCommercialContact", $$v)
      },
      expression: "generalData.nameCommercialContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.nameCommercialContact !=
    _vm.provider.logCompanyGeneralData
    .nameCommercialContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Apellido",
      "prop": "surnameCommercialContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "100",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.generalData.surnameCommercialContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "surnameCommercialContact", $$v)
      },
      expression: "generalData.surnameCommercialContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.surnameCommercialContact !=
    _vm.provider.logCompanyGeneralData
    .surnameCommercialContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Teléfono",
      "prop": "phoneCommercialContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.phoneCommercialContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "phoneCommercialContact", $$v)
      },
      expression: "generalData.phoneCommercialContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.phoneCommercialContact !=
    _vm.provider.logCompanyGeneralData
    .phoneCommercialContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "E-mail",
      "prop": "emailCommercialContact"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "maxlength": "100"
    },
    model: {
      value: (_vm.generalData.emailCommercialContact),
      callback: function($$v) {
        _vm.$set(_vm.generalData, "emailCommercialContact", $$v)
      },
      expression: "generalData.emailCommercialContact"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.generalData &&
    _vm.provider.logCompanyGeneralData &&
    _vm.provider.generalData.emailCommercialContact !=
    _vm.provider.logCompanyGeneralData
    .emailCommercialContact
  ) ? _c('el-col', {
    staticStyle: {
      "padding-left": "20px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            Campo\n                            "), _vm._v("modificado\n                          ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('br')], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.step === 1) ? _c('el-form', {
    ref: "paymentDataForm",
    attrs: {
      "model": _vm.paymentData,
      "disabled": false,
      "rules": _vm.rulesPaymentData,
      "label-position": "left",
      "label-width": "25%",
      "id": "formDatosPagos"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(false) ? _c('div', [_c('el-divider', [_vm._v("Cheque")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sucursal de retiro",
      "prop": "idBankBranch"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.paymentData.idBankBranch),
      callback: function($$v) {
        _vm.$set(_vm.paymentData, "idBankBranch", $$v)
      },
      expression: "paymentData.idBankBranch"
    }
  }, _vm._l((_vm.bankBranches), function(item) {
    return _c('el-option', {
      key: item.idBankBranch,
      attrs: {
        "label": item.bankBranch,
        "value": item.idBankBranch
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.paymentData &&
    _vm.provider.logCompanyPaymentData &&
    _vm.provider.paymentData.idBankBranch !=
    _vm.provider.logCompanyPaymentData.idBankBranch
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v("\n                  Fecha de creación: " + _vm._s(_vm.provider.creationDate) + "\n                ")]), _vm._v(" "), _c('el-divider', [_vm._v("Transferencia")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Banco",
      "prop": "idBank"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "bank",
      "filterable": "",
      "clearable": "",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.paymentData.idBank),
      callback: function($$v) {
        _vm.$set(_vm.paymentData, "idBank", $$v)
      },
      expression: "paymentData.idBank"
    }
  }, _vm._l((_vm.banks), function(item) {
    return _c('el-option', {
      key: item.idBank,
      attrs: {
        "label": item.bank,
        "value": item.idBank
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.paymentData &&
    _vm.provider.logCompanyPaymentData &&
    _vm.provider.paymentData.idBank !=
    _vm.provider.logCompanyPaymentData.idBank
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tipo de cuenta",
      "prop": "idBankAccountType"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "accounttype",
      "filterable": "",
      "clearable": "",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.paymentData.idBankAccountType),
      callback: function($$v) {
        _vm.$set(_vm.paymentData, "idBankAccountType", $$v)
      },
      expression: "paymentData.idBankAccountType"
    }
  }, _vm._l((_vm.accountTypes), function(item) {
    return _c('el-option', {
      key: item.idBankAccountType,
      attrs: {
        "label": item.bankAccountType,
        "value": item.idBankAccountType
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.paymentData &&
    _vm.provider.logCompanyPaymentData &&
    _vm.provider.paymentData.idBankAccountType !=
    _vm.provider.logCompanyPaymentData.idBankAccountType
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nro. de cuenta",
      "prop": "accountNumber"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 15
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "id": "accountnumber",
      "maxlength": "50",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.paymentData.accountNumber),
      callback: function($$v) {
        _vm.$set(_vm.paymentData, "accountNumber", $$v)
      },
      expression: "paymentData.accountNumber"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.paymentData &&
    _vm.provider.logCompanyPaymentData &&
    _vm.provider.paymentData.accountNumber !=
    _vm.provider.logCompanyPaymentData.accountNumber
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nro. CBU",
      "prop": "cbu"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 15
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "id": "nrocbu",
      "maxlength": "22",
      "show-word-limit": "",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.paymentData.cbu),
      callback: function($$v) {
        _vm.$set(_vm.paymentData, "cbu", $$v)
      },
      expression: "paymentData.cbu"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.paymentData &&
    _vm.provider.logCompanyPaymentData &&
    _vm.provider.paymentData.cbu !=
    _vm.provider.logCompanyPaymentData.cbu
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.paymentData.pdfBank,
      "habModificaPdf": _vm.editing,
      "titulo": "* Constancia",
      "id": "formPdfBank",
      "prop": "pdfBank"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.paymentData, "pdfBank", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.paymentData, "pdfBank", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('el-form', {
    ref: "taxDataForm",
    attrs: {
      "model": _vm.taxData,
      "disabled": _vm.disabledData,
      "rules": _vm.rulesTaxData,
      "label-position": "left",
      "label-width": "25%",
      "id": "formDatosImpositivosIb"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('h5', [_vm._v("\n                  Fecha de creación: " + _vm._s(_vm.provider.creationDate) + "\n                ")]), _vm._v(" "), _c('el-divider', [_vm._v("Ingresos Brutos")]), _vm._v(" "), _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.pdfIb,
      "habModificaPdf": _vm.editing,
      "titulo": "* Constancia IB actualizada a la fecha",
      "id": "formIB",
      "prop": "pdfIb"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "pdfIb", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "pdfIb", $event)
      }
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tipo",
      "prop": "ibType"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "typeib",
      "clearable": "",
      "disabled": !_vm.editing
    },
    on: {
      "change": _vm.handleIbType
    },
    model: {
      value: (_vm.taxData.ibType),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ibType", $$v)
      },
      expression: "taxData.ibType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Multilateral",
      "value": "Multilateral"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Local",
      "value": "Local"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Exento",
      "value": "Exento"
    }
  })], 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ibType !=
    _vm.provider.logCompanyTaxData.ibType
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.taxData.ibType === 'Exento') ? _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.pdfsExempt,
      "habModificaPdf": _vm.editing,
      "titulo": "* Constancia de exento",
      "id": "uploadConstanciaExcento",
      "prop": "pdfExempt"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "pdfsExempt", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "pdfsExempt", $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.taxData.ibType === 'Multilateral') ? _c('el-form-item', {
    attrs: {
      "label": "Regimen de convenio",
      "prop": "idAgreementRegimeType"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "regimenConvenio",
      "filterable": "",
      "clearable": "",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.taxData.idAgreementRegimeType),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "idAgreementRegimeType", $$v)
      },
      expression: "taxData.idAgreementRegimeType"
    }
  }, _vm._l((_vm.regimenTypes), function(item) {
    return _c('el-option', {
      key: item.idAgreementRegimeType,
      attrs: {
        "label": item.agreementRegimeType,
        "value": item.idAgreementRegimeType
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.idAgreementRegimeType !=
    _vm.provider.logCompanyTaxData.idAgreementRegimeType
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.ibType === 'Multilateral') ? _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.pdfCM05,
      "habModificaPdf": _vm.editing,
      "titulo": "* CM05",
      "id": "uploadPdfCM05",
      "prop": "pdfCM05"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "pdfCM05", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "pdfCM05", $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.jurisdicciones) ? _c('el-form-item', {
    attrs: {
      "label": "Jurisdicción sede",
      "prop": "jurisdictionHeadquarters"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "jsede",
      "filterable": "",
      "clearable": "",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.taxData.jurisdictionHeadquarters),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "jurisdictionHeadquarters", $$v)
      },
      expression: "taxData.jurisdictionHeadquarters"
    }
  }, _vm._l((_vm.jurisdictions), function(item) {
    return _c('el-option', {
      key: item.idJurisdictions,
      attrs: {
        "label": item.jurisdictions,
        "value": item.idJurisdictions
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.jurisdictionHeadquarters !=
    _vm.provider.logCompanyTaxData.jurisdictionHeadquarters
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "0",
      "prop": "jurisdictions"
    }
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "align": "center",
      "type": "flex",
      "justify": "center",
      "gutter": 10
    }
  }, [(this.doc1276 === false) ? _c('el-col', {
    staticStyle: {
      "padding-right": "45px"
    },
    attrs: {
      "span": 6
    }
  }, [_vm._v("\n                      Jurisdicción\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v("\n                      Jurisdicción\n                    ")]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v(" Alicuota** ")]), _vm._v(" "), (this.doc1276 === false) ? _c('el-col', {
    staticStyle: {
      "padding-right": "45px"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                      Coef. Unificado\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    staticStyle: {
      "padding-right": "1%"
    },
    attrs: {
      "span": 5
    }
  }, [_vm._v("\n                      Coef. Unificado\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === false) ? _c('el-col', {
    staticStyle: {
      "margin-right": "60px"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                      N° de Certificado\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    staticStyle: {
      "margin-right": "40px"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      N° de Certificado\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === false) ? _c('el-col', {
    staticStyle: {
      "margin-left": "-50px"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n                      Datos adicionales\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    staticStyle: {
      "padding-left": "10px"
    },
    attrs: {
      "span": 6
    }
  }, [_vm._v("\n                      Datos adicionales\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === false) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("\n                      Agente de Retención\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    staticStyle: {
      "padding-left": "45px",
      "line-height": "30px"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      Agente de Retención\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === false) ? _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n                      Agente de Percepción\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    staticStyle: {
      "padding-left": "50px",
      "line-height": "30px"
    },
    attrs: {
      "span": 2
    }
  }, [_vm._v("\n                      Agente de Percepción\n                    ")]) : _vm._e(), _vm._v(" "), (this.doc1276 === true) ? _c('el-col', {
    staticStyle: {
      "padding-left": "80px"
    },
    attrs: {
      "span": 3
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v("Formulario 1276\n                    ")]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  })], 1), _vm._v(" "), _vm._l((_vm.taxData.jurisdictions), function(jurisdict, jurId) {
    return _c('el-row', {
      key: jurId,
      staticStyle: {
        "text-align": "center",
        "margin-bottom": "15px"
      },
      attrs: {
        "align": "center",
        "type": "flex",
        "justify": "center",
        "gutter": 5
      }
    }, [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "'jurisdictions\\[' + jurId + '\\]\\[\\'idJurisdiction\\'\\]'"
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "95%"
      },
      attrs: {
        "filterable": "",
        "clearable": "",
        "disabled": !_vm.editing
      },
      on: {
        "change": function($event) {
          return _vm.updateAliquot(
            jurisdict.idJurisdiction,
            jurId
          )
        }
      },
      model: {
        value: (jurisdict.idJurisdiction),
        callback: function($$v) {
          _vm.$set(jurisdict, "idJurisdiction", $$v)
        },
        expression: "jurisdict.idJurisdiction"
      }
    }, _vm._l((_vm.jurisdictionsHabilitadas), function(item) {
      return _c('el-option', {
        key: item.idJurisdictions,
        attrs: {
          "label": item.jurisdictions,
          "value": item.idJurisdictions
        }
      })
    }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [(!_vm.isAlicuotList(jurisdict.idJurisdiction, jurId)) ? _c('el-form-item', {
      attrs: {
        "prop": "'jurisdictions\\[' + jurId + '\\]\\[\\'aliquot\\'\\]'",
        "rules": [{
            required: _vm.isSantaFe(jurisdict.idJurisdiction),
            message: 'Campo obligatorio',
            trigger: 'change',
          },
          {
            trigger: 'change'
          } ]
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number",
        "disabled": !_vm.editing
      },
      model: {
        value: (jurisdict.aliquota_value),
        callback: function($$v) {
          _vm.$set(jurisdict, "aliquota_value", _vm._n($$v))
        },
        expression: "jurisdict.aliquota_value"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isAlicuotList(jurisdict.idJurisdiction, jurId)) ? _c('el-form-item', {
      attrs: {
        "prop": "'jurisdictions\\[' + jurId + '\\]\\[\\'aliquot\\'\\]'",
        "rules": [{
            required: _vm.isSantaFe(jurisdict.idJurisdiction),
            message: 'Campo obligatorio',
            trigger: 'change',
          },
          {
            trigger: 'change'
          } ]
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "filterable": "",
        "clearable": "",
        "disabled": !_vm.editing
      },
      model: {
        value: (jurisdict.aliquot),
        callback: function($$v) {
          _vm.$set(jurisdict, "aliquot", $$v)
        },
        expression: "jurisdict.aliquot"
      }
    }, _vm._l((_vm.retentionCategoriesAliquot[jurId]), function(item) {
      return _c('el-option', {
        key: item.idCategoryRetain,
        attrs: {
          "label": item.categoryRetain,
          "value": item.idCategoryRetain
        }
      })
    }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'jurisdictions\[' + jurId + '\]\[\'coefficient\'\]'
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": !_vm.editing
      },
      on: {
        "input": function($event) {
          return _vm.validateCoefficient($event, jurId)
        }
      },
      model: {
        value: (jurisdict.coefficient),
        callback: function($$v) {
          _vm.$set(jurisdict, "coefficient", $$v)
        },
        expression: "jurisdict.coefficient"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'certificateNumber\'\]'
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": !_vm.editing
      },
      model: {
        value: (jurisdict.certificateNumber),
        callback: function($$v) {
          _vm.$set(jurisdict, "certificateNumber", $$v)
        },
        expression: "jurisdict.certificateNumber"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-button', {
      attrs: {
        "type": "primary",
        "disabled": !jurisdict.certificateNumber && !_vm.editing
      },
      on: {
        "click": function($event) {
          return _vm.openModalCertificateDetails(jurId)
        }
      }
    }, [_vm._v("\n                        Editar\n                      ")]), _vm._v(" "), _c('el-dialog', {
      attrs: {
        "title": "Datos adicionales del certificado",
        "visible": jurisdict.certficateDetailsVisible,
        "width": "40%"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }]
    }, [_c('el-form-item', {
      attrs: {
        "label": "Desde",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'certificateFrom\'\]',
        "rules": [{
          required: true,
          message: 'Campo obligatorio',
          trigger: 'change',
        } ]
      }
    }, [_c('el-date-picker', {
      attrs: {
        "format": "dd/MM/yyyy",
        "value-format": "yyyy-MM-dd",
        "type": "date",
        "placeholder": "Seleccionar"
      },
      model: {
        value: (jurisdict.certificateFrom),
        callback: function($$v) {
          _vm.$set(jurisdict, "certificateFrom", $$v)
        },
        expression: "jurisdict.certificateFrom"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Hasta",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'certificateTo\'\]',
        "rules": [{
          required: true,
          message: 'Campo obligatorio',
          trigger: 'change',
        } ]
      }
    }, [_c('el-date-picker', {
      attrs: {
        "format": "dd/MM/yyyy",
        "value-format": "yyyy-MM-dd",
        "type": "date",
        "placeholder": "Seleccionar"
      },
      model: {
        value: (jurisdict.certificateTo),
        callback: function($$v) {
          _vm.$set(jurisdict, "certificateTo", $$v)
        },
        expression: "jurisdict.certificateTo"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Constancia",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'certificatePdf\'\]',
        "rules": [{
          required: true,
          message: 'Campo obligatorio',
          trigger: 'change',
        } ]
      }
    }, [(_vm.habModificaPdf) ? _c('el-upload', {
      ref: 'jurisdictions\[' +
        jurId +
        '\]\[\'certificatePdf\'\]',
      refInFor: true,
      staticClass: "upload-demo",
      attrs: {
        "action": _vm.serverURI + 'api/uploadFile',
        "auto-upload": true,
        "accept": "application/pdf",
        "on-success": _vm.handlePdfCertificate,
        "on-exceed": _vm.handleExceed,
        "data": {
          folder: 'altaProveedor',
        },
        "limit": 1
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "trigger",
        "size": "small",
        "type": "primary"
      },
      slot: "trigger"
    }, [_vm._v("Seleccionar archivo")]), _vm._v(" "), _c('div', {
      staticClass: "el-upload__tip",
      attrs: {
        "slot": "tip"
      },
      slot: "tip"
    }, [_vm._v("\n                                Solo se permiten archivos PDF\n                              ")])], 1) : _c('span', [(jurisdict.certificatePdf) ? _c('a', {
      staticStyle: {
        "padding-right": "20px"
      },
      attrs: {
        "href": jurisdict.certificatePdf,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o"
    }), _vm._v(" Ver\n                              ")]) : _c('span', [_vm._v(" - ")])])], 1), _vm._v(" "), _c('span', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          jurisdict.certficateDetailsVisible = false
        }
      }
    }, [_vm._v("Confirmar")])], 1)], 1)])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'retentionAgentHas\'\]'
      }
    }, [_c('el-switch', {
      attrs: {
        "active-text": "Si",
        "inactive-text": "No",
        "active-value": "1",
        "inactive-value": "0",
        "disabled": !_vm.editing
      },
      on: {
        "change": function($event) {
          return _vm.openModalRetentionAgent(jurId)
        }
      },
      model: {
        value: (jurisdict.retentionAgentHas),
        callback: function($$v) {
          _vm.$set(jurisdict, "retentionAgentHas", $$v)
        },
        expression: "jurisdict.retentionAgentHas"
      }
    }), _vm._v(" "), (jurisdict.retentionAgentHas === '1') ? _c('el-button', {
      staticStyle: {
        "margin-left": "5px"
      },
      attrs: {
        "type": "success",
        "size": "small",
        "circle": "",
        "icon": "el-icon-edit"
      },
      on: {
        "click": function($event) {
          return _vm.openModalRetentionAgent(jurId)
        }
      }
    }) : _vm._e(), _vm._v(" "), (jurisdict.retentionAgentHas === '1') ? _c('el-form-item', {
      attrs: {
        "label": "",
        "label-width": "0",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'retentionAgentPdf\'\]'
      }
    }) : _vm._e(), _vm._v(" "), (jurisdict.retentionAgentHas === '1') ? _c('el-form-item', {
      attrs: {
        "label": "",
        "label-width": "0",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'retentionAgentDate\'\]'
      }
    }) : _vm._e(), _vm._v(" "), (jurisdict.retentionAgentHas === '1') ? _c('el-dialog', {
      attrs: {
        "title": "Agente de retención.",
        "visible": jurisdict.retentionAgentVisible,
        "width": "40%",
        "before-close": function () { return (jurisdict.retentionAgentHas = '0'); }
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Fecha de alta",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'retentionAgentDate\'\]'
      }
    }, [_c('el-date-picker', {
      attrs: {
        "format": "dd/MM/yyyy",
        "value-format": "yyyy-MM-dd",
        "type": "date",
        "placeholder": "Seleccionar"
      },
      model: {
        value: (jurisdict.retentionAgentDate),
        callback: function($$v) {
          _vm.$set(jurisdict, "retentionAgentDate", $$v)
        },
        expression: "jurisdict.retentionAgentDate"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Constancia",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'retentionAgentPdf\'\]'
      }
    }, [(_vm.habModificaPdf) ? _c('el-upload', {
      ref: 'jurisdictions\[' +
        jurId +
        '\]\[\'retentionAgentPdf\'\]',
      refInFor: true,
      staticClass: "upload-demo",
      attrs: {
        "action": _vm.serverURI + 'api/uploadFile',
        "auto-upload": true,
        "accept": "application/pdf",
        "on-success": _vm.handlePdfRetentionAgent,
        "on-exceed": _vm.handleExceed,
        "data": {
          folder: 'altaProveedor',
        },
        "limit": 1
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "trigger",
        "size": "small",
        "type": "primary"
      },
      slot: "trigger"
    }, [_vm._v("Seleccionar archivo")]), _vm._v(" "), _c('div', {
      staticClass: "el-upload__tip",
      attrs: {
        "slot": "tip"
      },
      slot: "tip"
    }, [_vm._v("\n                                Solo se permiten archivos PDF\n                              ")])], 1) : _c('span', [(jurisdict.retentionAgentPdf) ? _c('a', {
      staticStyle: {
        "padding-right": "20px"
      },
      attrs: {
        "href": jurisdict.retentionAgentPdf,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o"
    }), _vm._v(" Ver\n                              ")]) : _c('span', [_vm._v(" - ")])])], 1), _vm._v(" "), _c('span', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          jurisdict.retentionAgentVisible = false
        }
      }
    }, [_vm._v("Confirmar")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'perceptionAgentHas\'\]'
      }
    }, [_c('el-col', {
      staticStyle: {
        "padding-right": "20px"
      },
      attrs: {
        "span": 25
      }
    }, [_c('el-switch', {
      attrs: {
        "active-text": "Si",
        "inactive-text": "No",
        "active-value": "1",
        "inactive-value": "0",
        "disabled": !_vm.editing
      },
      on: {
        "change": function($event) {
          return _vm.openModalPerceptionAgent(jurId)
        }
      },
      model: {
        value: (jurisdict.perceptionAgentHas),
        callback: function($$v) {
          _vm.$set(jurisdict, "perceptionAgentHas", $$v)
        },
        expression: "jurisdict.perceptionAgentHas"
      }
    })], 1), _vm._v(" "), (jurisdict.perceptionAgentHas === '1') ? _c('el-button', {
      staticStyle: {
        "margin-left": "5px"
      },
      attrs: {
        "type": "success",
        "size": "small",
        "circle": "",
        "icon": "el-icon-edit"
      },
      on: {
        "click": function($event) {
          return _vm.openModalPerceptionAgent(jurId)
        }
      }
    }) : _vm._e(), _vm._v(" "), (jurisdict.perceptionAgentHas === '1') ? _c('el-form-item', {
      attrs: {
        "label": "",
        "label-width": "0",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'retentionAgentPdf\'\]'
      }
    }) : _vm._e(), _vm._v(" "), (jurisdict.perceptionAgentHas === '1') ? _c('el-form-item', {
      attrs: {
        "label": "",
        "label-width": "0",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'perceptionAgentDate\'\]'
      }
    }) : _vm._e(), _vm._v(" "), (jurisdict.perceptionAgentHas === '1') ? _c('el-dialog', {
      attrs: {
        "title": "Agente de percepción.",
        "visible": jurisdict.perceptionAgentVisible,
        "width": "40%",
        "before-close": function () { return (jurisdict.perceptionAgentHas = '0'); }
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Fecha de alta",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'perceptionAgentDate\'\]'
      }
    }, [_c('el-date-picker', {
      attrs: {
        "format": "dd/MM/yyyy",
        "value-format": "yyyy-MM-dd",
        "type": "date",
        "placeholder": "Seleccionar"
      },
      model: {
        value: (jurisdict.perceptionAgentDate),
        callback: function($$v) {
          _vm.$set(jurisdict, "perceptionAgentDate", $$v)
        },
        expression: "jurisdict.perceptionAgentDate"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Constancia",
        "prop": 'jurisdictions\[' +
          jurId +
          '\]\[\'perceptionAgentPdf\'\]'
      }
    }, [(_vm.habModificaPdf) ? _c('el-upload', {
      ref: 'jurisdictions\[' +
        jurId +
        '\]\[\'perceptionAgentPdf\'\]',
      refInFor: true,
      staticClass: "upload-demo",
      attrs: {
        "action": _vm.serverURI + 'api/uploadFile',
        "auto-upload": true,
        "accept": "application/pdf",
        "on-success": _vm.handlePdfPerceptionAgent,
        "on-exceed": _vm.handleExceed,
        "data": {
          folder: 'altaProveedor',
        },
        "limit": 1
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "trigger",
        "size": "small",
        "type": "primary"
      },
      slot: "trigger"
    }, [_vm._v("Seleccionar archivo")]), _vm._v(" "), _c('div', {
      staticClass: "el-upload__tip",
      attrs: {
        "slot": "tip"
      },
      slot: "tip"
    }, [_vm._v("\n                                Solo se permiten archivos PDF\n                              ")])], 1) : _c('span', [(jurisdict.perceptionAgentPdf) ? _c('a', {
      staticStyle: {
        "padding-right": "20px"
      },
      attrs: {
        "href": jurisdict.perceptionAgentPdf,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o"
    }), _vm._v(" Ver\n                              ")]) : _c('span', [_vm._v(" - ")])])], 1), _vm._v(" "), _c('span', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          jurisdict.perceptionAgentVisible = false
        }
      }
    }, [_vm._v("Confirmar")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), (jurisdict.idJurisdiction === '13') ? _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('el-form', {
      attrs: {
        "disabledData": false
      }
    }, [_c('el-button', {
      staticStyle: {
        "font-size": "10px"
      },
      attrs: {
        "size": "mini",
        "type": "primary",
        "disabled": !_vm.editing
      },
      on: {
        "click": function($event) {
          return _vm.openModalForm1276(jurId)
        }
      }
    }, [_vm._v("\n                          Seleccionar archivo\n                        ")])], 1)], 1) : _vm._e(), _vm._v(" "), (['1', '2', '22', '14', '15'].includes(jurisdict.idJurisdiction)) ? _c('el-form-item', {
      staticStyle: {
        "width": "250px",
        "margin-right": "-250px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (jurisdict.agentDontOperateHere),
        expression: "jurisdict.agentDontOperateHere"
      }],
      staticStyle: {
        "width": "15px",
        "float": "left",
        "cursor": "pointer",
        "margin-right": "25px",
        "margin-top": "13px"
      },
      attrs: {
        "type": "checkbox",
        "name": "operaAqui",
        "disabled": !_vm.editing,
        "required": ""
      },
      domProps: {
        "checked": Array.isArray(jurisdict.agentDontOperateHere) ? _vm._i(jurisdict.agentDontOperateHere, null) > -1 : (jurisdict.agentDontOperateHere)
      },
      on: {
        "change": function($event) {
          var $$a = jurisdict.agentDontOperateHere,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(jurisdict, "agentDontOperateHere", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(jurisdict, "agentDontOperateHere", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(jurisdict, "agentDontOperateHere", $$c)
          }
        }
      }
    }), _c('span', {
      staticStyle: {
        "margin-left": "-80px",
        "margin-top": "15px"
      }
    }, [_vm._v("No Presta Servicio aqui")])]) : _vm._e(), _vm._v(" "), (!['1', '2', '22', '14', '15'].includes(jurisdict.idJurisdiction) && jurisdict.idJurisdiction !== '13') ? _c('el-col', {
      staticStyle: {
        "margin-left": "-75px"
      },
      attrs: {
        "span": 3
      }
    }, [(
      ((_vm.taxData.ibType === 'Multilateral' && jurId > 1) ||
        (_vm.taxData.ibType !== 'Multilateral' &&
          jurId > 0)) &&
      !_vm.provider
    ) ? _c('el-button', {
      staticStyle: {
        "padding-left": "10px"
      },
      attrs: {
        "type": "warning",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.deleteJurisdiction(jurisdict)
        }
      }
    }, [_vm._v("X")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (['1', '2', '22', '14', '15'].includes(jurisdict.idJurisdiction)) ? _c('el-col', {
      staticStyle: {
        "float": "right",
        "margin-right": "-250px"
      },
      attrs: {
        "span": 5,
        "offset": 2
      }
    }, [(
      ((_vm.taxData.ibType === 'Multilateral' && jurId > 1) ||
        (_vm.taxData.ibType !== 'Multilateral' &&
          jurId > 0)) &&
      !_vm.provider
    ) ? _c('el-button', {
      staticStyle: {
        "padding-left": "10px"
      },
      attrs: {
        "type": "warning",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.deleteJurisdiction(jurisdict)
        }
      }
    }, [_vm._v("X")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (jurisdict.idJurisdiction === '13') ? _c('el-col', {
      staticStyle: {
        "margin-left": "-25px"
      },
      attrs: {
        "span": 3
      }
    }, [(
      ((_vm.taxData.ibType === 'Multilateral' && jurId > 1) ||
        (_vm.taxData.ibType !== 'Multilateral' &&
          jurId > 0)) &&
      !_vm.provider
    ) ? _c('el-button', {
      staticStyle: {
        "padding-left": "10px"
      },
      attrs: {
        "type": "warning",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.deleteJurisdiction(jurisdict)
        }
      }
    }, [_vm._v("X")]) : _vm._e()], 1) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.taxData.ibType === 'Multilateral') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": !_vm.editing
    },
    on: {
      "click": function($event) {
        return _vm.addJurisdiction()
      }
    }
  }, [_vm._v("Agregar jurisdicción")]) : _vm._e()], 2), _vm._v(" "), _c('p', [_vm._v("** Alicuota a aplicar por el agente de retención")]), _vm._v(" "), _c('el-divider', [_vm._v("Retención Ganancias")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tipo",
      "prop": "earningsRetentionType"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "typeGanancias",
      "filterable": "",
      "clearable": "",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.taxData.earningsRetentionType),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "earningsRetentionType", $$v)
      },
      expression: "taxData.earningsRetentionType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Inscripto",
      "value": "Inscripto"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Exento",
      "value": "Exento"
    }
  })], 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.earningsRetentionType !=
    _vm.provider.logCompanyTaxData.earningsRetentionType
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), (
    _vm.taxData.earningsRetentionType === 'Inscripto' &&
    _vm.generalData.typeIVA !== '06'
  ) ? _c('el-form-item', {
    attrs: {
      "label": "Régimen de Retención",
      "prop": "retentionRegimen"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "retencion",
      "filterable": "",
      "clearable": "",
      "disabled": !_vm.editing
    },
    on: {
      "change": _vm.updateRetentionCategory
    },
    model: {
      value: (_vm.taxData.retentionRegimen),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "retentionRegimen", $$v)
      },
      expression: "taxData.retentionRegimen"
    }
  }, _vm._l((_vm.retentionRegimes), function(item) {
    return _c('el-option', {
      key: item.idRetentionRegime,
      attrs: {
        "label": item.retentionRegime,
        "value": item.idRetentionRegime
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.retentionRegimen !=
    _vm.provider.logCompanyTaxData.retentionRegimen
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
    _vm.taxData.earningsRetentionType === 'Inscripto' &&
    _vm.generalData.typeIVA === '06'
  ) ? _c('el-form-item', {
    attrs: {
      "label": "Régimen de Retención",
      "prop": "retentionRegimen"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.updateRetentionCategory
    },
    model: {
      value: (_vm.taxData.retentionRegimen),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "retentionRegimen", $$v)
      },
      expression: "taxData.retentionRegimen"
    }
  }, _vm._l((_vm.retentionRegimeList), function(item) {
    return _c('el-option', {
      key: item.idRetentionRegime,
      attrs: {
        "label": item.retentionRegime,
        "value": item.idRetentionRegime
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.retentionRegimen !=
    _vm.provider.logCompanyTaxData.retentionRegimen
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.earningsRetentionType === 'Inscripto') ? _c('el-form-item', {
    attrs: {
      "label": "Categoría a retener",
      "prop": "idEarningCategoryRetain"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "categoriaR",
      "filterable": "",
      "clearable": "",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.taxData.idEarningCategoryRetain),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "idEarningCategoryRetain", $$v)
      },
      expression: "taxData.idEarningCategoryRetain"
    }
  }, _vm._l((_vm.retentionCategories2), function(item) {
    return _c('el-option', {
      key: item.idCategoryRetain,
      attrs: {
        "label": item.categoryRetain,
        "value": item.idCategoryRetain
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.idEarningCategoryRetain !=
    _vm.provider.logCompanyTaxData.idEarningCategoryRetain
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.user !== null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exclusión Retención Ganancias")]), _vm._v(" "), (_vm.provider && _vm.provider.certifExgain.length > 0) ? _c('span', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationExgainList()
      }
    }
  }, [_vm._v("Ver")])], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)])], 1) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exclusión Retención Ganancias")]), _vm._v(" "), (this.certificationExgainList.length > 0) ? _c('span', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationExgainList()
      }
    }
  }, [_vm._v("Ver")])], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)])], 1) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (this.user !== null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exención RG2681")]), _vm._v(" "), (_vm.provider && _vm.provider.certifRg2681.length > 0) ? _c('span', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationRg2681List()
      }
    }
  }, [_vm._v("Ver")])], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1), _vm._v(" "), _c('br'), _c('br')])], 1) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exención RG2681")]), _vm._v(" "), (this.certificationRg2681List.length > 0) ? _c('span', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationRg2681List()
      }
    }
  }, [_vm._v("Ver")])], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1), _vm._v(" "), _c('br'), _c('br')])], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": 'earningsExclusionNumber',
      "label": "Número"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.taxData.earningsExclusionNumber),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "earningsExclusionNumber", $$v)
      },
      expression: "taxData.earningsExclusionNumber"
    }
  })], 1)], 1), _vm._v(" "), (_vm.taxData.earningsExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "0px",
      "label": "",
      "prop": 'earningsExclusionFrom'
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "disabled": !_vm.taxData.earningsExclusionNumber,
      "type": "date",
      "placeholder": "Desde"
    },
    model: {
      value: (_vm.taxData.earningsExclusionFrom),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "earningsExclusionFrom", $$v)
      },
      expression: "taxData.earningsExclusionFrom"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.earningsExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "label-width": "0px",
      "prop": 'earningsExclusionTo'
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "disabled": !_vm.taxData.earningsExclusionNumber,
      "picker-options": _vm.disabledDates,
      "type": "date",
      "placeholder": "Hasta"
    },
    model: {
      value: (_vm.taxData.earningsExclusionTo),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "earningsExclusionTo", $$v)
      },
      expression: "taxData.earningsExclusionTo"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.earningsExclusionNumber !=
    _vm.provider.logCompanyTaxData.earningsExclusionNumber
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Número' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.earningsExclusionFrom !=
    _vm.provider.logCompanyTaxData.earningsExclusionFrom
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Fecha desde' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.earningsExclusionTo !=
    _vm.provider.logCompanyTaxData.earningsExclusionTo
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Fecha hasta' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.earningsExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.earningsExclusionPdf,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "* Certificado exclusión",
      "id": "uploadPdfearningsExclusion",
      "prop": "earningsExclusionPdf"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "earningsExclusionPdf", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "earningsExclusionPdf", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', [(this.user !== null) ? _c('div', [(_vm.provider && _vm.provider.certifExgain.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [(this.certificationExgainList.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e()]), _vm._v(" "), _c('el-col', [(this.user !== null) ? _c('div', [(_vm.provider && _vm.provider.certifRg2681.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [(this.certificationRg2681List.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e()])], 1), _vm._v(" "), _c('el-divider', [_vm._v("Retención SUSS")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Empleador",
      "prop": 'sussEmployeer'
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Si",
      "inactive-text": "No",
      "active-value": "1",
      "inactive-value": "0",
      "disabled": !_vm.editing
    },
    on: {
      "change": function($event) {
        _vm.taxData.sussEmployeer ?
          (_vm.taxData.sussRetentionRegimen =
            _vm.taxData.sussEmployeer) :
          _vm.taxData.sussEmployeer
      }
    },
    model: {
      value: (_vm.taxData.sussEmployeer),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussEmployeer", $$v)
      },
      expression: "taxData.sussEmployeer"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.sussEmployeer !=
    _vm.provider.logCompanyTaxData.sussEmployeer
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Agente de retención",
      "prop": 'retentionRegime'
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-switch', {
    attrs: {
      "disabled": _vm.taxData.sussEmployeer === '0' || !_vm.editing,
      "active-value": "1",
      "inactive-value": "0",
      "active-text": "Si",
      "inactive-text": "No"
    },
    on: {
      "change": function($event) {
        return _vm.sussIdCategoryRetainClear()
      }
    },
    model: {
      value: (_vm.taxData.sussRetentionRegimen),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussRetentionRegimen", $$v)
      },
      expression: "taxData.sussRetentionRegimen"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.sussRetentionRegimen !=
    _vm.provider.logCompanyTaxData.sussRetentionRegimen
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), (
    _vm.taxData.sussEmployeer &&
    _vm.taxData.sussRetentionRegimen === '1'
  ) ? _c('el-form-item', {
    attrs: {
      "label": "Régimen a retener",
      "prop": "sussIdCategoryRetain"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.taxData.sussIdCategoryRetain),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussIdCategoryRetain", $$v)
      },
      expression: "taxData.sussIdCategoryRetain"
    }
  }, _vm._l((_vm.sussRetentionCategory), function(item) {
    return _c('el-option', {
      key: item.idCategoryRetain,
      attrs: {
        "label": item.categoryRetain,
        "value": item.idCategoryRetain
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.sussIdCategoryRetain !=
    _vm.provider.logCompanyTaxData.sussIdCategoryRetain
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
    _vm.taxData.sussEmployeer == '1' &&
    _vm.taxData.sussRetentionRegimen == '0'
  ) ? _c('el-form-item', {
    attrs: {
      "label": "Régimen a retener",
      "prop": "sussIdCategoryRetain"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": ""
    },
    model: {
      value: (_vm.taxData.sussIdCategoryRetain),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussIdCategoryRetain", $$v)
      },
      expression: "taxData.sussIdCategoryRetain"
    }
  }, _vm._l((_vm.sussRetentionCategory), function(item) {
    return _c('el-option', {
      key: item.idCategoryRetain,
      attrs: {
        "label": item.categoryRetain,
        "value": item.idCategoryRetain
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.sussIdCategoryRetain !=
    _vm.provider.logCompanyTaxData.sussIdCategoryRetain
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.user !== null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exclusión")]), _vm._v(" "), (_vm.provider && _vm.provider.certifSuss.length > 0) ? _c('span', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationSussList()
      }
    }
  }, [_vm._v("Ver")])], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)])], 1) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exclusión")]), _vm._v(" "), (this.certificationSussList.length > 0) ? _c('span', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationSussList()
      }
    }
  }, [_vm._v("Ver")])], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)])], 1) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": 'sussExclusionNumber',
      "label": "Número"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "30",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.taxData.sussExclusionNumber),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussExclusionNumber", $$v)
      },
      expression: "taxData.sussExclusionNumber"
    }
  })], 1)], 1), _vm._v(" "), (_vm.taxData.sussExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "0px",
      "label": "",
      "prop": 'sussExclusionFrom'
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "disabled": !_vm.taxData.sussExclusionNumber,
      "type": "date",
      "placeholder": "Desde"
    },
    model: {
      value: (_vm.taxData.sussExclusionFrom),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussExclusionFrom", $$v)
      },
      expression: "taxData.sussExclusionFrom"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.sussExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "label-width": "0px",
      "prop": 'sussExclusionTo'
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.disabledDates,
      "disabled": !_vm.taxData.sussExclusionNumber,
      "type": "date",
      "placeholder": "Hasta"
    },
    model: {
      value: (_vm.taxData.sussExclusionTo),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "sussExclusionTo", $$v)
      },
      expression: "taxData.sussExclusionTo"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.sussExclusionNumber !=
    _vm.provider.logCompanyTaxData.sussExclusionNumber
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Número' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.sussExclusionFrom !=
    _vm.provider.logCompanyTaxData.sussExclusionFrom
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Fecha desde' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.earningsExclusionTo !=
    _vm.provider.logCompanyTaxData.sussExclusionTo
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Fecha hasta' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.sussExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.sussExclusionPdf,
      "habModificaPdf": !!_vm.taxData.sussExclusionNumber,
      "titulo": "* Exclusión",
      "id": "uploadPdfExclusion",
      "prop": "sussExclusionPdf"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "sussExclusionPdf", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "sussExclusionPdf", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', [(this.user !== null) ? _c('div', [(_vm.provider && _vm.provider.certifSuss.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [(this.certificationSussList.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e()])], 1), _vm._v(" "), _c('el-divider', [_vm._v("Retención I.V.A.")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "label": "¿Es agente de retención?",
      "prop": 'ivaRetentionAgent'
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Si",
      "inactive-text": "No",
      "active-value": "1",
      "inactive-value": "0",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.taxData.ivaRetentionAgent),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ivaRetentionAgent", $$v)
      },
      expression: "taxData.ivaRetentionAgent"
    }
  })], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ivaRetentionAgent !=
    _vm.provider.logCompanyTaxData.ivaRetentionAgent
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (this.user !== null) ? _c('div', {
    staticStyle: {
      "padding-left": "25%"
    }
  }, [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [(_vm.provider && _vm.provider.certifRg18.length > 0) ? _c('span', [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Certificado RG18")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationRg18List()
      }
    }
  }, [_vm._v("Ver")])], 1)], 1) : _c('span', [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Certificado RG18")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('el-tag', {
    staticStyle: {
      "margin-left": "0%"
    },
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [(this.certificationRg18List.length > 0) ? _c('span', [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Certificado RG18")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-bottom": "0px"
    },
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationRg18List()
      }
    }
  }, [_vm._v("Ver")])], 1)], 1) : _c('span', [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Certificado RG18")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('el-tag', {
    staticStyle: {
      "margin-left": "0%"
    },
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)], 1)])], 1) : _vm._e()], 1), _vm._v(" "), (
    _vm.taxData.ivaRetentionAgent &&
    _vm.taxData.ivaRetentionAgent !== '1'
  ) ? _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.ivaResolutionPdf,
      "habModificaPdf": _vm.editing,
      "titulo": "* Resolución",
      "id": "uploadPdfResolucion",
      "prop": "sussExclusionPdf"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "ivaResolutionPdf", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "ivaResolutionPdf", $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "taxDataForm",
    attrs: {
      "model": _vm.taxData,
      "id": "formDatosImpositivos",
      "label-position": "left",
      "label-width": "25%",
      "rules": _vm.rulesTaxDataIvaResolutionPdf
    }
  }, [(
    _vm.taxData.ivaRetentionAgent &&
    _vm.taxData.ivaRetentionAgent === '1'
  ) ? _c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.ivaResolutionPdf,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "* Resolución",
      "id": "ivaResolutionPdf",
      "prop": "ivaResolutionPdf"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "ivaResolutionPdf", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "ivaResolutionPdf", $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Régimen de retención",
      "prop": "ivaIdRetentionRegime"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "regimenRetencion",
      "filterable": "",
      "clearable": "",
      "disabled": !_vm.editing
    },
    on: {
      "change": _vm.updateIvaRetentionCategory
    },
    model: {
      value: (_vm.taxData.ivaIdRetentionRegime),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ivaIdRetentionRegime", $$v)
      },
      expression: "taxData.ivaIdRetentionRegime"
    }
  }, _vm._l((_vm.retentionRegimesVAT), function(item) {
    return _c('el-option', {
      key: item.idRetentionRegime,
      attrs: {
        "label": item.retentionRegime,
        "value": item.idRetentionRegime
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ivaIdRetentionRegime !=
    _vm.provider.logCompanyTaxData.ivaIdRetentionRegime
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Categoría a retener",
      "prop": "ivaIdCategoryRetain"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "categoriaRetener",
      "filterable": "",
      "clearable": "",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.taxData.ivaIdCategoryRetain),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ivaIdCategoryRetain", $$v)
      },
      expression: "taxData.ivaIdCategoryRetain"
    }
  }, _vm._l((_vm.ivaRetentionCategories), function(item) {
    return _c('el-option', {
      key: item.idCategoryRetain,
      attrs: {
        "label": item.categoryRetain,
        "value": item.idCategoryRetain
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ivaIdCategoryRetain !=
    _vm.provider.logCompanyTaxData.ivaIdCategoryRetain
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1), _vm._v(" "), (this.user !== null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exclusión")]), _vm._v(" "), (_vm.provider && _vm.provider.certifRg17.length > 0) ? _c('span', [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Certificado RG17")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "0px"
    },
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationRg17List()
      }
    }
  }, [_vm._v("Ver")])], 1)], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)])], 1) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [_c('el-form', {
    attrs: {
      "disabledData": false
    }
  }, [_c('span', [_vm._v("Certificado de exclusión")]), _vm._v(" "), (this.certificationRg17List.length > 0) ? _c('span', [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Certificado RG17")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "0px"
    },
    attrs: {
      "size": "mini",
      "type": "primary",
      "plain": "",
      "icon": "el-icon-view"
    },
    on: {
      "click": function($event) {
        return _vm.openCertificationRg17List()
      }
    }
  }, [_vm._v("Ver")])], 1)], 1) : _c('span', [_c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("No se encontró")])], 1)])], 1) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": 'ivaExclusionNumber',
      "label": "Número"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "30",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.taxData.ivaExclusionNumber),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ivaExclusionNumber", $$v)
      },
      expression: "taxData.ivaExclusionNumber"
    }
  })], 1)], 1), _vm._v(" "), (_vm.taxData.ivaExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "0px",
      "label": "",
      "prop": 'ivaExclusionFrom'
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "disabled": !_vm.taxData.ivaExclusionNumber,
      "type": "date",
      "placeholder": "Desde"
    },
    model: {
      value: (_vm.taxData.ivaExclusionFrom),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ivaExclusionFrom", $$v)
      },
      expression: "taxData.ivaExclusionFrom"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.ivaExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "label-width": "0px",
      "prop": 'ivaExclusionTo'
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.disabledDates,
      "disabled": !_vm.taxData.ivaExclusionNumber,
      "type": "date",
      "placeholder": "Hasta"
    },
    model: {
      value: (_vm.taxData.ivaExclusionTo),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "ivaExclusionTo", $$v)
      },
      expression: "taxData.ivaExclusionTo"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ivaExclusionNumber !=
    _vm.provider.logCompanyTaxData.ivaExclusionNumber
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Número' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ivaExclusionFrom !=
    _vm.provider.logCompanyTaxData.ivaExclusionFrom
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Fecha desde' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.ivaExclusionTo !=
    _vm.provider.logCompanyTaxData.ivaExclusionTo
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                        Campo 'Fecha hasta' "), _c('br'), _vm._v("\n                        modificado\n                      ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.taxData.ivaExclusionNumber) ? _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('pdf-file', {
    attrs: {
      "pdfFilePath": _vm.taxData.ivaExclusionPdf,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": "",
      "id": "ivaExclusionPdf",
      "prop": "ivaExclusionPdf"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.taxData, "ivaExclusionPdf", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.taxData, "ivaExclusionPdf", $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-col', [(this.user !== null) ? _c('div', [(_vm.provider && _vm.provider.certifRg17.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e(), _vm._v(" "), (this.user === null) ? _c('div', [(this.certificationRg17List.length > 0) ? _c('span', [_c('el-alert', {
    attrs: {
      "title": "Tiene un certificado de exclusión vigente, por favor completar lo que corresponda",
      "type": "info",
      "closable": false
    }
  })], 1) : _c('span')]) : _vm._e()])], 1), _vm._v(" "), _c('el-divider', [_vm._v("Otros impuestos")]), _vm._v(" "), _c('el-form', {
    ref: "taxDataForm",
    attrs: {
      "model": _vm.taxData,
      "id": "formDatosImpositivosOi",
      "label-position": "left",
      "label-width": "25%",
      "rules": _vm.rulesTaxDataOtros
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Régimen de retención",
      "prop": "otrosIdRetentionRegime"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "regimenRetencion",
      "filterable": "",
      "clearable": "",
      "disabled": !_vm.editing
    },
    on: {
      "change": _vm.updateOtrosRetentionCategory
    },
    model: {
      value: (_vm.taxData.otrosIdRetentionRegime),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "otrosIdRetentionRegime", $$v)
      },
      expression: "taxData.otrosIdRetentionRegime"
    }
  }, _vm._l((_vm.retentionRegimesOTROS), function(item) {
    return _c('el-option', {
      key: item.idRetentionRegime,
      attrs: {
        "label": item.retentionRegime,
        "value": item.idRetentionRegime
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.otrosIdRetentionRegime !=
    _vm.provider.logCompanyTaxData.otrosIdRetentionRegime
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "taxDataForm",
    attrs: {
      "model": _vm.taxData,
      "id": "formDatosImpositivosRe",
      "label-position": "left",
      "label-width": "25%",
      "rules": _vm.rulesTaxDataOtros
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Categoría a retener",
      "prop": "otrosIdCategoryRetain"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": 25
    }
  }, [_c('el-select', {
    attrs: {
      "id": "categoriaRetener",
      "filterable": "",
      "clearable": "",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.taxData.otrosIdCategoryRetain),
      callback: function($$v) {
        _vm.$set(_vm.taxData, "otrosIdCategoryRetain", $$v)
      },
      expression: "taxData.otrosIdCategoryRetain"
    }
  }, _vm._l((_vm.otrosRetentionCategories), function(item) {
    return _c('el-option', {
      key: item.idCategoryRetain,
      attrs: {
        "label": item.categoryRetain,
        "value": item.idCategoryRetain
      }
    })
  }), 1)], 1), _vm._v(" "), (
    _vm.provider.taxData &&
    _vm.provider.logCompanyTaxData &&
    _vm.provider.taxData.otrosIdCategoryRetain !=
    _vm.provider.logCompanyTaxData.otrosIdCategoryRetain
  ) ? _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("Campo modificado")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-info"
  })])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.step === 3 && !_vm.provider) ? _c('el-form', {
    ref: "userDataForm",
    attrs: {
      "model": _vm.userData,
      "rules": _vm.rulesUserData,
      "label-position": "left",
      "label-width": "25%",
      "id": "formUsuario"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Nombre y Apellido",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.userData.name),
      callback: function($$v) {
        _vm.$set(_vm.userData, "name", $$v)
      },
      expression: "userData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Correo electrónico",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.userData.email),
      callback: function($$v) {
        _vm.$set(_vm.userData, "email", $$v)
      },
      expression: "userData.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Contraseña",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.userData.password),
      callback: function($$v) {
        _vm.$set(_vm.userData, "password", $$v)
      },
      expression: "userData.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Repetir contraseña",
      "prop": "passwordRe",
      "rules": [{
          pattern: _vm.userData.password,
          message: 'Las contraseñas deben coincidir',
          trigger: 'change',
        },
        {
          required: true,
          message: 'Campo obligatorio',
          trigger: '',
        } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.userData.passwordRe),
      callback: function($$v) {
        _vm.$set(_vm.userData, "passwordRe", $$v)
      },
      expression: "userData.passwordRe"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider[_vm.activeTab()].idCompanyDataStatus ===
    _vm.status.ESPERANDO_CONFIRMACION &&
    !_vm.user.isProvider
  ) ? _c('div', {
    staticClass: "row text-center"
  }, [_c('el-divider', [_vm._v(" Aceptar datos ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "data-cy": "btn-rechazar"
    },
    on: {
      "click": function($event) {
        return _vm.verifyPermission()
      }
    }
  }, [_vm._v("\n                  Rechazar "), _c('i', {
    staticClass: "el-icon-close"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "data-cy": "btn-aceptar"
    },
    on: {
      "click": function($event) {
        return _vm.acceptCompanyData()
      }
    }
  }, [_vm._v("\n                  Aceptar "), _c('i', {
    staticClass: "el-icon-check"
  })])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider[_vm.activeTab()].idCompanyDataStatus ===
    _vm.status.DEVUELTO
  ) ? _c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Observaciones")])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_vm._v("\n                  " + _vm._s(_vm.provider[_vm.activeTab()].observation) + "\n                ")])]) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider[_vm.activeTab()].idCompanyDataStatus ===
    _vm.status.DEVUELTO &&
    _vm.user.isProvider
  ) ? _c('div', {
    staticClass: "row text-center"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.reSendCompanyData
    }
  }, [_vm._v("\n                  Volver a enviar los datos\n                ")])], 1) : _vm._e(), _vm._v(" "), (
    _vm.userByRoles ||
    (_vm.dataAfip &&
      (_vm.userIsAdmin || (_vm.user ? _vm.user.isProvider : true)))
  ) ? _c('el-button-group', [(_vm.step > 0 && !_vm.editing) ? _c('el-button', {
    attrs: {
      "data-cy": "btn-anterior",
      "type": "primary",
      "icon": "el-icon-arrow-left"
    },
    on: {
      "click": function($event) {
        return _vm.previousStep()
      }
    }
  }, [_vm._v("Anterior")]) : _vm._e(), _vm._v(" "), ((_vm.step < 2 || (_vm.step === 2 && !_vm.provider)) && !_vm.editing) ? _c('el-button', {
    attrs: {
      "data-cy": "btn-siguiente",
      "type": "primary",
      "icon": "el-icon-arrow-right"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("Siguiente")]) : _vm._e(), _vm._v(" "), (_vm.step === 3 && !_vm.provider) ? _c('el-button', {
    attrs: {
      "type": "success",
      "icon": "el-check"
    },
    on: {
      "click": _vm.openModalTerminosYCond
    }
  }, [_vm._v("Confirmar")]) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.response) ? _c('div', {
    staticClass: "col-md-12 text-center",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, _vm._l((_vm.response), function(field) {
    return _c('div', {
      key: field,
      staticClass: "info-box-info"
    }, _vm._l((field), function(error, index) {
      return _c('ul', {
        key: index,
        staticStyle: {
          "font-size": "6px"
        }
      }, [_vm._v("\n                        " + _vm._s(error) + "\n                      ")])
    }), 0)
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "col-md-12 text-center",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-info"
  }, [_vm._v(_vm._s(_vm.success))])])])])]) : _vm._e()])], 1)])]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Rechazar datos",
      "visible": _vm.rejectCompanyDataVisible,
      "fullscreen": false,
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.rejectCompanyDataVisible = $event
      }
    }
  }, [_vm._v("\n      Escriba el motivo por el cual rechaza los datos:\n      "), _c('el-input', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "textarea",
      "rows": 4,
      "maxlength": "400",
      "placeholder": "Ingrese el motivo",
      "show-word-limit": true
    },
    model: {
      value: (_vm.newObservation),
      callback: function($$v) {
        _vm.newObservation = $$v
      },
      expression: "newObservation"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.rejectCompanyData()
      }
    }
  }, [_vm._v("\n          Aceptar\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-red"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon bg-green"
  }, [_c('i', {
    staticClass: "ion ion-android-checkmark-circle"
  })])
}]}

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("Cargar HES / MIGO")])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "mobile",
    attrs: {
      "title": "Cargar datos de operación",
      "visible": _vm.showModal,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      }
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "-20px",
      "font-weight": "300"
    }
  }, [_vm._v("Datos de la operación")]), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-form', {
    ref: "formRef",
    attrs: {
      "model": _vm.document,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    staticClass: "form-select",
    attrs: {
      "size": "small",
      "label": "Tipo de operación*"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Tipo de operación"
    },
    model: {
      value: (_vm.document.ocType),
      callback: function($$v) {
        _vm.$set(_vm.document, "ocType", $$v)
      },
      expression: "document.ocType"
    }
  }, _vm._l((_vm.acceptanceType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.document.ocType === '1') ? _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "size": "small"
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "input-view1-text",
    attrs: {
      "span": 12
    }
  }, [_vm._v("\n                        Agregar HES\n                    ")]), _vm._v(" "), _c('el-col', {
    staticClass: "input-view2",
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "-10px"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.addOcNumber
    }
  }, [_vm._v("+")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.document.ocType === '1') ? _c('el-divider') : _vm._e(), _vm._v(" "), _vm._l((_vm.document.hesNumbers), function(ocNumber, index) {
    return (_vm.document.ocType === '1') ? _c('el-form-item', {
      key: index,
      staticClass: "form-input",
      attrs: {
        "size": "small"
      }
    }, [_c('el-row', {
      staticStyle: {
        "margin-bottom": "10px",
        "margin-left": "-100px"
      },
      attrs: {
        "span": 24
      }
    }, [_c('b', [_vm._v("Carga de HES " + _vm._s(index + 1))])]), _vm._v(" "), _c('el-row', [_c('el-col', {
      staticClass: "input-view1",
      staticStyle: {
        "margin-left": "-120px"
      },
      attrs: {
        "span": 12
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Numero de HES*"
      },
      model: {
        value: (_vm.document.hesNumbers[index]),
        callback: function($$v) {
          _vm.$set(_vm.document.hesNumbers, index, $$v)
        },
        expression: "document.hesNumbers[index]"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticClass: "input-view2",
      attrs: {
        "span": 12
      }
    }, [_c('el-button', {
      staticStyle: {
        "margin-left": "35px"
      },
      attrs: {
        "type": "warning"
      },
      on: {
        "click": function($event) {
          return _vm.deleteOcNumber(index)
        }
      }
    }, [_vm._v("-")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-row', {
      staticStyle: {
        "margin-bottom": "5px",
        "margin-left": "-100px",
        "margin-top": "10px"
      },
      attrs: {
        "span": 24
      }
    }, [_vm._v("Breve descripción*")]), _vm._v(" "), _c('el-form-item', [_c('el-col', {
      staticStyle: {
        "margin-left": "-120px"
      },
      attrs: {
        "span": 12
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "400px"
      },
      attrs: {
        "placeholder": "Breve Descripcion"
      },
      model: {
        value: (_vm.document.hesDescription[index]),
        callback: function($$v) {
          _vm.$set(_vm.document.hesDescription, index, $$v)
        },
        expression: "document.hesDescription[index]"
      }
    })], 1)], 1), _vm._v(" "), (_vm.document.ocType !== '') ? _c('el-form-item', {
      staticClass: "form-upload",
      attrs: {
        "size": "small",
        "label": ""
      }
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('p', {
      staticStyle: {
        "margin-left": "-65px",
        "margin-top": "10px"
      }
    }, [_vm._v("Adjuntar Documento")])]), _vm._v(" "), _c('el-col', {
      staticClass: "form-pdf",
      staticStyle: {
        "margin-left": "-65px"
      }
    }, [_c('pdf-file', {
      attrs: {
        "pdfFilePath": _vm.document.hesFile[index],
        "habModificaPdf": _vm.habModificaPdf,
        "id": "documento"
      },
      on: {
        "update:pdfFilePath": function($event) {
          return _vm.$set(_vm.document.hesFile, index, $event)
        },
        "update:pdf-file-path": function($event) {
          return _vm.$set(_vm.document.hesFile, index, $event)
        }
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-bottom": "-20px"
      }
    })], 1)], 1) : _vm._e()
  }), _vm._v(" "), (_vm.document.ocType === '2') ? _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "size": "small"
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "input-view1-text",
    attrs: {
      "span": 12
    }
  }, [_vm._v("\n                        Agregar MIGO\n                    ")]), _vm._v(" "), _c('el-col', {
    staticClass: "input-view2",
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "-10px"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.addMigoNumber
    }
  }, [_vm._v("+")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.document.ocType === '2') ? _c('el-divider') : _vm._e(), _vm._v(" "), _vm._l((_vm.document.migoNumbers), function(ocNumber, index) {
    return (_vm.document.ocType === '2') ? _c('el-form-item', {
      key: index,
      staticClass: "form-input",
      attrs: {
        "size": "small"
      }
    }, [_c('el-row', {
      staticStyle: {
        "margin-bottom": "10px",
        "margin-left": "-100px"
      },
      attrs: {
        "span": 24
      }
    }, [_c('b', [_vm._v("Carga de MIGO " + _vm._s(index + 1))])]), _vm._v(" "), _c('el-row', [_c('el-col', {
      staticClass: "input-view1",
      staticStyle: {
        "margin-left": "-120px"
      },
      attrs: {
        "span": 12
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Numero de MIGO*"
      },
      model: {
        value: (_vm.document.migoNumbers[index]),
        callback: function($$v) {
          _vm.$set(_vm.document.migoNumbers, index, $$v)
        },
        expression: "document.migoNumbers[index]"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticClass: "input-view2",
      attrs: {
        "span": 12
      }
    }, [_c('el-button', {
      staticStyle: {
        "margin-left": "35px"
      },
      attrs: {
        "type": "warning"
      },
      on: {
        "click": function($event) {
          return _vm.deleteMigoNumber(index)
        }
      }
    }, [_vm._v("-")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-row', {
      staticStyle: {
        "margin-bottom": "5px",
        "margin-left": "-100px",
        "margin-top": "10px"
      },
      attrs: {
        "span": 24
      }
    }, [_vm._v("Breve descripción*")]), _vm._v(" "), _c('el-form-item', [_c('el-col', {
      staticStyle: {
        "margin-left": "-120px"
      },
      attrs: {
        "span": 12
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "400px"
      },
      attrs: {
        "placeholder": "Breve Descripcion"
      },
      model: {
        value: (_vm.document.migoDescription[index]),
        callback: function($$v) {
          _vm.$set(_vm.document.migoDescription, index, $$v)
        },
        expression: "document.migoDescription[index]"
      }
    })], 1)], 1), _vm._v(" "), (_vm.document.ocType !== '') ? _c('el-form-item', {
      staticClass: "form-upload",
      attrs: {
        "size": "small",
        "label": ""
      }
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('p', {
      staticStyle: {
        "margin-left": "-65px",
        "margin-top": "10px"
      }
    }, [_vm._v("Adjuntar Documento")])]), _vm._v(" "), _c('el-col', {
      staticClass: "form-pdf",
      staticStyle: {
        "margin-left": "-65px"
      }
    }, [_c('pdf-file', {
      attrs: {
        "pdfFilePath": _vm.document.migoFile[index],
        "habModificaPdf": _vm.habModificaPdf,
        "id": "documento",
        "prop": "documento"
      },
      on: {
        "update:pdfFilePath": function($event) {
          return _vm.$set(_vm.document.migoFile, index, $event)
        },
        "update:pdf-file-path": function($event) {
          return _vm.$set(_vm.document.migoFile, index, $event)
        }
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-bottom": "-20px"
      }
    })], 1)], 1) : _vm._e()
  })], 2), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.saveOperationData
    }
  }, [_vm._v("\n            Guardar\n        ")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "info",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("\n            Cancelar\n        ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("Ingresar Factura, NC o ND")])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "mobile",
    attrs: {
      "title": "Cargar Factura, NC o ND",
      "visible": _vm.showModal,
      "append-to-body": true,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      }
    }
  }, [_c('el-divider'), _vm._v(" "), _c('el-form', {
    ref: "formRef",
    staticClass: "form-container",
    attrs: {
      "rules": _vm.formRules,
      "model": _vm.document,
      "label-width": "160px"
    }
  }, [(_vm.hesMigo.length !== 0) ? _c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_vm._v("Código de Documentación")]) : _vm._e(), _vm._v(" "), (_vm.hesMigo.length !== 0) ? _c('el-form-item', {
    staticClass: "form-select",
    attrs: {
      "size": "small",
      "label": "Código de Documentación"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Código de Documentación"
    },
    on: {
      "change": _vm.updateDescriptionTipo
    },
    model: {
      value: (_vm.document.code),
      callback: function($$v) {
        _vm.$set(_vm.document, "code", $$v)
      },
      expression: "document.code"
    }
  }, _vm._l((_vm.hesMigo), function(item) {
    return _c('el-option', {
      key: item.idHes,
      attrs: {
        "label": item.number,
        "value": item.idHes
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.hesMigo.length !== 0) ? _c('div', [_c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Descripción",
      "size": "small"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.document.description),
      callback: function($$v) {
        _vm.$set(_vm.document, "description", $$v)
      },
      expression: "document.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Tipo de código",
      "size": "small"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.document.tipo),
      callback: function($$v) {
        _vm.$set(_vm.document, "tipo", $$v)
      },
      expression: "document.tipo"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_vm._v("Datos de la operacion")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-select",
    attrs: {
      "size": "small",
      "label": "Tipo de operación",
      "prop": "documenttype"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Tipo de operación"
    },
    model: {
      value: (_vm.document.documenttype),
      callback: function($$v) {
        _vm.$set(_vm.document, "documenttype", $$v)
      },
      expression: "document.documenttype"
    }
  }, _vm._l((_vm.documentType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Código de AFIP",
      "size": "small",
      "prop": "codigoAFIP"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.codigoAFIP),
      callback: function($$v) {
        _vm.$set(_vm.document, "codigoAFIP", $$v)
      },
      expression: "document.codigoAFIP"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Letra",
      "size": "small",
      "prop": "letra"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.letra),
      callback: function($$v) {
        _vm.$set(_vm.document, "letra", $$v)
      },
      expression: "document.letra"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Numero",
      "size": "small",
      "prop": "numero"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.numero),
      callback: function($$v) {
        _vm.$set(_vm.document, "numero", $$v)
      },
      expression: "document.numero"
    }
  })], 1), _vm._v(" "), _c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_vm._v("Datos CAE")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Fecha de Vencimiento",
      "size": "small",
      "prop": "fechaVencimiento"
    }
  }, [_c('el-date-picker', {
    staticClass: "form-date",
    attrs: {
      "type": "date",
      "placeholder": "Selecciona fecha de Vencimiento",
      "default-value": new Date()
    },
    model: {
      value: (_vm.document.fechaVencimiento),
      callback: function($$v) {
        _vm.$set(_vm.document, "fechaVencimiento", $$v)
      },
      expression: "document.fechaVencimiento"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Nº",
      "size": "small",
      "prop": "NroCAE"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.NroCAE),
      callback: function($$v) {
        _vm.$set(_vm.document, "NroCAE", $$v)
      },
      expression: "document.NroCAE"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-upload",
    attrs: {
      "size": "small",
      "label": "PDF",
      "prop": "pdfDoc"
    }
  }, [_c('pdf-file', {
    staticClass: "form-pdf",
    attrs: {
      "pdfFilePath": _vm.document.pdfDoc,
      "habModificaPdf": _vm.habModificaPdf,
      "id": "documento",
      "prop": "documento"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.document, "pdfDoc", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.document, "pdfDoc", $event)
      }
    }
  })], 1), _vm._v(" "), (_vm.loadOperationType === true) ? _c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_vm._v("Datos de Referencia")]) : _vm._e(), _vm._v(" "), (_vm.loadOperationType === true) ? _c('el-form-item', {
    staticClass: "form-select",
    attrs: {
      "size": "small",
      "label": "Tipo de transacción"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Tipo de transacción"
    },
    model: {
      value: (_vm.document.ocType),
      callback: function($$v) {
        _vm.$set(_vm.document, "ocType", $$v)
      },
      expression: "document.ocType"
    }
  }, _vm._l((_vm.acceptanceType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.document.ocType === '1') ? _c('el-form-item', {
    key: _vm.index,
    staticClass: "form-input",
    attrs: {
      "size": "small"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', {
    staticClass: "input-text"
  }, [_vm._v("Número de operación")])]), _vm._v(" "), _c('el-col', {
    staticClass: "input-view1",
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Numero de HES"
    },
    model: {
      value: (_vm.document.ocNumber),
      callback: function($$v) {
        _vm.$set(_vm.document, "ocNumber", $$v)
      },
      expression: "document.ocNumber"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "input-view2",
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "35px"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.addOcNumber
    }
  }, [_vm._v("+")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.document.ocNumbers), function(ocNumber, index) {
    return (_vm.document.ocType === '1') ? _c('el-form-item', {
      key: index,
      staticClass: "form-input",
      attrs: {
        "size": "small"
      }
    }, [_c('el-row', [_c('el-col', {
      staticClass: "input-view1",
      attrs: {
        "span": 12
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Numero de HES"
      },
      model: {
        value: (ocNumber.value),
        callback: function($$v) {
          _vm.$set(ocNumber, "value", $$v)
        },
        expression: "ocNumber.value"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticClass: "input-view2",
      attrs: {
        "span": 12
      }
    }, [_c('el-button', {
      staticStyle: {
        "margin-left": "35px"
      },
      attrs: {
        "type": "warning"
      },
      on: {
        "click": function($event) {
          return _vm.deleteOcNumber(index)
        }
      }
    }, [_vm._v("-")])], 1)], 1)], 1) : _vm._e()
  }), _vm._v(" "), (_vm.document.ocType === '2') ? _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "size": "small"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', {
    staticClass: "input-text"
  }, [_vm._v("Número de operación")])]), _vm._v(" "), _c('el-col', {
    staticClass: "input-view1",
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Numero de MIGO"
    },
    model: {
      value: (_vm.document.migoNumber),
      callback: function($$v) {
        _vm.$set(_vm.document, "migoNumber", $$v)
      },
      expression: "document.migoNumber"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_vm._v("Importes")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Importe Total",
      "size": "small",
      "prop": "importeTotal"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.importeTotal),
      callback: function($$v) {
        _vm.$set(_vm.document, "importeTotal", $$v)
      },
      expression: "document.importeTotal"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Importe Impuesto",
      "size": "small",
      "prop": "importeImpuesto"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.importeImpuesto),
      callback: function($$v) {
        _vm.$set(_vm.document, "importeImpuesto", $$v)
      },
      expression: "document.importeImpuesto"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Porcentaje Impuesto",
      "size": "small",
      "prop": "porcentajeImpuesto"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.porcentajeImpuesto),
      callback: function($$v) {
        _vm.$set(_vm.document, "porcentajeImpuesto", $$v)
      },
      expression: "document.porcentajeImpuesto"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Moneda",
      "size": "small",
      "prop": "moneda"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.moneda),
      callback: function($$v) {
        _vm.$set(_vm.document, "moneda", $$v)
      },
      expression: "document.moneda"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Tipo de Cambio",
      "size": "small",
      "prop": "tipoDeCambio"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.tipoDeCambio),
      callback: function($$v) {
        _vm.$set(_vm.document, "tipoDeCambio", $$v)
      },
      expression: "document.tipoDeCambio"
    }
  })], 1)], 2), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.validateForm
    }
  }, [_vm._v("\n            Guardar\n        ")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "info"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("\n            Cancelar\n        ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-steps', {
    staticStyle: {
      "margintop": "50px"
    },
    attrs: {
      "active": _vm.activeStep,
      "finish-status": "success",
      "align-center": ""
    }
  }, [_c('el-step', {
    attrs: {
      "title": "Datos Generales"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "Datos Impositivos"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "Datos Bancarios"
    }
  }), _vm._v(" "), (!_vm.isConfirmProvider) ? _c('el-step', {
    attrs: {
      "title": "Usuario"
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "label": _vm.data.label
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    class: _vm.verifyFields(_vm.data, _vm.validation) ? 'input-warning' : '',
    staticStyle: {
      "margin-left": "4.5%"
    },
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.data.model, _vm.data.name)
      }
    },
    model: {
      value: (_vm.data.model),
      callback: function($$v) {
        _vm.$set(_vm.data, "model", $$v)
      },
      expression: "data.model"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    class: _vm.verifyFieldsDoubleInput(_vm.data) ? 'input-warning' : '',
    staticStyle: {
      "margin-left": "32%"
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": "number",
      "placeholder": _vm.data.label2
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.data.model2, _vm.data.label2)
      }
    },
    model: {
      value: (_vm.data.model2),
      callback: function($$v) {
        _vm.$set(_vm.data, "model2", $$v)
      },
      expression: "data.model2"
    }
  })], 1), _vm._v(" "), (_vm.verifyFields(_vm.data, _vm.validation)) ? _c('el-alert', {
    staticClass: "message-warning",
    attrs: {
      "title": ("Falta completar: " + (_vm.data.label)),
      "type": "error",
      "closable": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.verifyFieldsDoubleInput(_vm.data)) ? _c('el-alert', {
    staticClass: "message-warning",
    attrs: {
      "title": ("Falta completar: " + (_vm.data.label2)),
      "type": "error",
      "closable": false
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "prebillContainer"
  }, [_c('el-divider'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('el-form', {
    ref: "formRef",
    staticClass: "form-container",
    attrs: {
      "model": _vm.document,
      "rules": _vm.formRules,
      "label-width": "160px"
    }
  }, [_c('el-divider', [_vm._v(" Datos del Documento ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-select",
    attrs: {
      "size": "small",
      "label": "Tipo de operación",
      "prop": "documenttype"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Tipo de operación"
    },
    model: {
      value: (_vm.document.documenttype),
      callback: function($$v) {
        _vm.$set(_vm.document, "documenttype", $$v)
      },
      expression: "document.documenttype"
    }
  }, _vm._l((_vm.documentType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Código de AFIP",
      "size": "small",
      "prop": "codigoAFIP"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.codigoAFIP),
      callback: function($$v) {
        _vm.$set(_vm.document, "codigoAFIP", $$v)
      },
      expression: "document.codigoAFIP"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Letra",
      "size": "small",
      "prop": "letra"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.letra),
      callback: function($$v) {
        _vm.$set(_vm.document, "letra", $$v)
      },
      expression: "document.letra"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Número",
      "size": "small",
      "prop": "numero"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.numero),
      callback: function($$v) {
        _vm.$set(_vm.document, "numero", $$v)
      },
      expression: "document.numero"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Proveedor",
      "size": "small",
      "prop": "proveedor"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.document.proveedor),
      callback: function($$v) {
        _vm.$set(_vm.document, "proveedor", $$v)
      },
      expression: "document.proveedor"
    }
  }, _vm._l((_vm.providers), function(item) {
    return _c('el-option', {
      key: item.idCompany,
      attrs: {
        "label": item.company,
        "value": item.idCompany
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-divider', [_vm._v("Datos CAE")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Fecha de Vencimiento",
      "size": "small",
      "prop": "fechaVencimiento"
    }
  }, [_c('el-date-picker', {
    staticClass: "form-date",
    attrs: {
      "type": "date",
      "placeholder": "Selecciona fecha de vencimiento",
      "default-value": new Date()
    },
    model: {
      value: (_vm.document.fechaVencimiento),
      callback: function($$v) {
        _vm.$set(_vm.document, "fechaVencimiento", $$v)
      },
      expression: "document.fechaVencimiento"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Nº",
      "size": "small",
      "prop": "NroCAE"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.NroCAE),
      callback: function($$v) {
        _vm.$set(_vm.document, "NroCAE", $$v)
      },
      expression: "document.NroCAE"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-upload",
    attrs: {
      "size": "small",
      "label": "PDF",
      "prop": "pdfDoc"
    }
  }, [_c('pdf-file', {
    staticClass: "form-pdf",
    attrs: {
      "pdfFilePath": _vm.document.pdfDoc,
      "habModificaPdf": _vm.habModificaPdf,
      "id": "documento",
      "prop": "pdfDoc"
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.document, "pdfDoc", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.document, "pdfDoc", $event)
      }
    }
  })], 1), _vm._v(" "), (_vm.loadOperationType === true) ? _c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_vm._v("Datos de Referencia")]) : _vm._e(), _vm._v(" "), (_vm.loadOperationType === true) ? _c('el-form-item', {
    staticClass: "form-select",
    attrs: {
      "size": "small",
      "label": "Tipo de transacción"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Tipo de transacción"
    },
    model: {
      value: (_vm.document.ocType),
      callback: function($$v) {
        _vm.$set(_vm.document, "ocType", $$v)
      },
      expression: "document.ocType"
    }
  }, _vm._l((_vm.acceptanceType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.document.ocType === '1') ? _c('el-form-item', {
    key: _vm.index,
    staticClass: "form-input",
    attrs: {
      "size": "small"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', {
    staticClass: "input-text"
  }, [_vm._v("Número de operación")])]), _vm._v(" "), _c('el-col', {
    staticClass: "input-view1",
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Numero de HES"
    },
    model: {
      value: (_vm.document.ocNumber),
      callback: function($$v) {
        _vm.$set(_vm.document, "ocNumber", $$v)
      },
      expression: "document.ocNumber"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "input-view2",
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "35px"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.addOcNumber
    }
  }, [_vm._v("+")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.document.ocNumbers), function(ocNumber, index) {
    return (_vm.document.ocType === '1') ? _c('el-form-item', {
      key: index,
      staticClass: "form-input",
      attrs: {
        "size": "small"
      }
    }, [_c('el-row', [_c('el-col', {
      staticClass: "input-view1",
      attrs: {
        "span": 12
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Numero de HES"
      },
      model: {
        value: (ocNumber.value),
        callback: function($$v) {
          _vm.$set(ocNumber, "value", $$v)
        },
        expression: "ocNumber.value"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticClass: "input-view2",
      attrs: {
        "span": 12
      }
    }, [_c('el-button', {
      staticStyle: {
        "margin-left": "35px"
      },
      attrs: {
        "type": "warning"
      },
      on: {
        "click": function($event) {
          return _vm.deleteOcNumber(index)
        }
      }
    }, [_vm._v("-")])], 1)], 1)], 1) : _vm._e()
  }), _vm._v(" "), (_vm.document.ocType === '2') ? _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "size": "small"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', {
    staticClass: "input-text"
  }, [_vm._v("Número de operación")])]), _vm._v(" "), _c('el-col', {
    staticClass: "input-view1",
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Numero de MIGO"
    },
    model: {
      value: (_vm.document.migoNumber),
      callback: function($$v) {
        _vm.$set(_vm.document, "migoNumber", $$v)
      },
      expression: "document.migoNumber"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-divider', [_vm._v("Importes")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Importe Total",
      "size": "small",
      "prop": "importeTotal"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.importeTotal),
      callback: function($$v) {
        _vm.$set(_vm.document, "importeTotal", $$v)
      },
      expression: "document.importeTotal"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Importe Impuesto",
      "size": "small",
      "prop": "importeImpuesto"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.importeImpuesto),
      callback: function($$v) {
        _vm.$set(_vm.document, "importeImpuesto", $$v)
      },
      expression: "document.importeImpuesto"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Porcentaje Impuesto",
      "size": "small",
      "prop": "porcentajeImpuesto"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.porcentajeImpuesto),
      callback: function($$v) {
        _vm.$set(_vm.document, "porcentajeImpuesto", $$v)
      },
      expression: "document.porcentajeImpuesto"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Moneda",
      "size": "small",
      "prop": "moneda"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.moneda),
      callback: function($$v) {
        _vm.$set(_vm.document, "moneda", $$v)
      },
      expression: "document.moneda"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-input",
    attrs: {
      "label": "Tipo de Cambio",
      "size": "small",
      "prop": "tipoDeCambio"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.document.tipoDeCambio),
      callback: function($$v) {
        _vm.$set(_vm.document, "tipoDeCambio", $$v)
      },
      expression: "document.tipoDeCambio"
    }
  })], 1)], 2), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.showModal,
      "title": "Confirmar acción",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(" ¿Está seguro que desea envíar el documento? ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "2rem",
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.createDocument
    }
  }, [_vm._v("\n                                            Confirmar\n                                        ")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function () { return _vm.showModal = false; }
    }
  }, [_vm._v("\n                                            Cancelar\n                                        ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "gap": "1rem"
    }
  }, [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.validateForm
    }
  }, [_vm._v("\n                                Guardar\n                            ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "info"
    }
  }, [_vm._v("\n                                    Volver\n                                ")])], 1)], 1)], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("\n                            Cargar Documento\n                        ")])])
}]}

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.availableCountries.some(function (country) { return country.codCountry === 'PE'; })) ? _c('div', [_c('error404')], 1) : _c('div', {
    staticClass: "info-box-content"
  }, [_c('div', [_c('h1', [_vm._v("SOLICITAR SER PROVEEDOR")]), _vm._v(" "), _c('h6', [_vm._v("Complete el formulario")]), _vm._v(" "), _c('div', {
    staticClass: "back-btn"
  }, [_c('el-button', {
    on: {
      "click": _vm.goBackPage
    }
  }, [_vm._v("< Volver")])], 1)]), _vm._v(" "), _c('div', [_c('steps-pagination', {
    attrs: {
      "activeStep": _vm.step
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.step == 0) ? _c('el-card', {
    staticClass: "box-card",
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "card-header"
        }, [_c('p', [_vm._v("Datos generales")])])]
      },
      proxy: true
    }], null, false, 725694500)
  }, [_vm._v(" "), _c('p', {
    staticClass: "text-danger"
  }, [_vm._v("\n          Los campos acompañados con asterisco(*) son obligatorios\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.step === 0) ? _c('el-form', {
    ref: "generalDataForm",
    staticStyle: {
      "width": "80%",
      "margin": "auto"
    },
    attrs: {
      "label-width": "200px"
    }
  }, [_c('el-divider', [_vm._v("Datos de la empresa")]), _vm._v(" "), _c('alta-id', {
    attrs: {
      "idStatus": _vm.idStatus,
      "type": _vm.idType,
      "id": _vm.id
    },
    on: {
      "validate-id": _vm.validateIDHandler
    }
  }), _vm._v(" "), (_vm.validateRuc) ? _c('alta-form', {
    attrs: {
      "locations": _vm.locations,
      "dataForm": _vm.generalData,
      "validation": _vm.nextStepFlag
    }
  }) : _vm._e(), _vm._v(" "), _c('el-divider'), _vm._v(" "), (_vm.validateRuc) ? _c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("\n              Siguiente >\n            ")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.emailSoporte !== '') ? _c('div', {
    staticClass: "email__consultas-container",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('el-col', {
    staticClass: "email__consultas",
    attrs: {
      "span": 8
    }
  }, [_vm._v("Si tiene alguna duda o consulta técnica, por favor contactese\n            con: "), _c('b', [_vm._v(_vm._s(_vm.emailSoporte))])])], 1) : _vm._e()]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.step === 1) ? _c('el-card', {
    staticClass: "box-card",
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "card-header"
        }, [_c('p', [_vm._v("Datos Impositivos")])])]
      },
      proxy: true
    }], null, false, 498538162)
  }, [_vm._v(" "), _c('p', {
    staticClass: "text-danger"
  }, [_vm._v("\n          Los campos acompañados con asterisco(*) son obligatorios\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.step == 1) ? _c('el-form', {
    staticStyle: {
      "width": "80%",
      "margin": "auto"
    },
    attrs: {
      "label-width": "200px"
    }
  }, [_c('el-divider', [_vm._v("Datos Impositivos")]), _vm._v(" "), _c('alta-form', {
    attrs: {
      "dataForm": _vm.companyTaxData,
      "denominaciones": _vm.denominaciones,
      "validation": _vm.nextStepFlag
    }
  }), _vm._v(" "), _c('el-divider'), _vm._v(" "), (_vm.validateRuc) ? _c('el-button-group', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.backStep
    }
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Siguiente >")])], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.emailSoporte !== '') ? _c('div', {
    staticClass: "email__consultas-container",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('el-col', {
    staticClass: "email__consultas",
    attrs: {
      "span": 8
    }
  }, [_vm._v("Si tiene alguna duda o consulta técnica, por favor contactese\n            con: "), _c('b', [_vm._v(_vm._s(_vm.emailSoporte))])])], 1) : _vm._e()]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.step === 2) ? _c('el-card', {
    staticClass: "box-card",
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "card-header"
        }, [_c('p', [_vm._v("Datos Bancarios")])])]
      },
      proxy: true
    }], null, false, 894485228)
  }, [_vm._v(" "), _c('p', {
    staticClass: "text-danger"
  }, [_vm._v("\n          Los campos acompañados con asterisco(*) son obligatorios\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.step == 2) ? _c('el-form', {
    staticStyle: {
      "width": "80%",
      "margin": "auto"
    },
    attrs: {
      "label-width": "200px"
    }
  }, [_c('el-divider', [_vm._v("Datos Bancarios 1")]), _vm._v(" "), _c('alta-form', {
    attrs: {
      "dataForm": _vm.paymentData1,
      "banks": _vm.banks,
      "bankAccountTypes": _vm.bankAccountTypes,
      "validation": _vm.nextStepFlag
    }
  }), _vm._v(" "), _c('el-divider', [_vm._v("Datos Bancarios 2 (Opcional)")]), _vm._v(" "), _c('el-switch', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "active-text": "Activar",
      "inactive-text": "Desactivar"
    },
    on: {
      "change": function($event) {
        return _vm.clearOptionalPaymentData(_vm.optionalPaymentFlag.model)
      }
    },
    model: {
      value: (_vm.optionalPaymentFlag.model),
      callback: function($$v) {
        _vm.$set(_vm.optionalPaymentFlag, "model", $$v)
      },
      expression: "optionalPaymentFlag.model"
    }
  }), _vm._v(" "), _c('alta-form', {
    attrs: {
      "dataForm": _vm.paymentData2,
      "banks": _vm.banks,
      "bankAccountTypes": _vm.bankAccountTypes,
      "disabled": !_vm.optionalPaymentFlag.model
    }
  }), _vm._v(" "), (_vm.companyTaxData.detractionSwitch.model) ? _c('el-divider') : _vm._e(), _vm._v(" "), (_vm.companyTaxData.detractionSwitch.model) ? _c('div', [_c('h6', [_vm._v("En caso de realizar actividades sujetas a detracción, por favor completar")]), _vm._v(" "), _c('alta-form', {
    attrs: {
      "dataForm": _vm.paymentData3,
      "validation": _vm.nextStepFlag
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-divider'), _vm._v(" "), (_vm.validateRuc) ? _c('el-button-group', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.backStep
    }
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Siguiente >")])], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.emailSoporte !== '') ? _c('div', {
    staticClass: "email__consultas-container",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('el-col', {
    staticClass: "email__consultas",
    attrs: {
      "span": 8
    }
  }, [_vm._v("Si tiene alguna duda o consulta técnica, por favor contactese\n            con: "), _c('b', [_vm._v(_vm._s(_vm.emailSoporte))])])], 1) : _vm._e()]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.step == 3) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card",
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "card-header"
        }, [_c('p', [_vm._v("Usuario")])])]
      },
      proxy: true
    }], null, false, 516869071)
  }, [_vm._v(" "), _c('p', {
    staticClass: "text-danger"
  }, [_vm._v("\n          Los campos acompañados con asterisco(*) son obligatorios\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-form', {
    staticStyle: {
      "width": "80%",
      "margin": "auto"
    },
    attrs: {
      "label-width": "200px"
    }
  }, [_c('alta-form', {
    attrs: {
      "dataForm": _vm.userData,
      "validation": _vm.nextStepFlag
    }
  }), _vm._v(" "), (this.response) ? _c('p', {
    staticStyle: {
      "color": "#a94442"
    }
  }, [_vm._v("\n            " + _vm._s(this.response) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('el-divider'), _vm._v(" "), (_vm.validateRuc) ? _c('el-button-group', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.backStep
    }
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.openModalTerminosYCondiciones
    }
  }, [_vm._v("Confirmar")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.emailSoporte !== '') ? _c('div', {
    staticClass: "email__consultas-container",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('el-col', {
    staticClass: "email__consultas",
    attrs: {
      "span": 8
    }
  }, [_vm._v("Si tiene alguna duda o consulta técnica, por favor contactese\n            con: "), _c('b', [_vm._v(_vm._s(_vm.emailSoporte))])])], 1) : _vm._e()])], 1), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "-12vh",
      "height": "auto",
      "overflow-y": "hidden"
    },
    attrs: {
      "title": "Confirmar Alta de Proveedor",
      "visible": _vm.showTerminosYCondiciones,
      "width": "80%",
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showTerminosYCondiciones = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "60vh",
      "overflow": "auto"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.configuration))]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked2),
      expression: "checked2"
    }],
    staticStyle: {
      "width": "15px",
      "margin": "0 5px 0 0",
      "padding-bottom": "5px"
    },
    attrs: {
      "type": "checkbox",
      "name": "aceptoCodigoEtica",
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.checked2) ? _vm._i(_vm.checked2, null) > -1 : (_vm.checked2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checked2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checked2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked2 = $$c
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Acepto el\n            "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.codigoEtica
    }
  }, [_vm._v("Código de Ética y Conducta\n            ")]), _vm._v(".\n          ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    staticStyle: {
      "width": "15px",
      "margin": "0 5px 0 0"
    },
    attrs: {
      "type": "checkbox",
      "name": "aceptoTerminos",
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, null) > -1 : (_vm.checked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked = $$c
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("\n            Acepto las políticas:\n            "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.politicaAnticorrupcion
    }
  }, [_vm._v("Política Anticorrupción")]), _vm._v("\n            y\n            "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.politicaRelacionamiento
    }
  }, [_vm._v("Política de Relacionamiento con Funcionarios Públicos.")])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    attrs: {
      "type": "submit",
      "disabled": !_vm.checked2 || !_vm.checked
    },
    on: {
      "click": function($event) {
        return _vm.submitFormSolicitud()
      }
    }
  }, [_vm._v("\n        Aceptar\n        ")])])])])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li"
    },
    on: {
      "click": _vm.reload
    }
  }, [_vm._m(0)]), _vm._v(" "), (_vm.user) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("OPERACIONES")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Inicio")])])]), _vm._v(" "), (false) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/individual"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Consulta individual")])])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "header"
  }, [_vm._v("CUENTA")]), _vm._v(" "), (!_vm.user) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/login"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fas fa-sign-in-alt text-yellow"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Ingresar al Portal")])])]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/changePsw"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fas fa-key"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Cambiar clave")])])]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/selfdata"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Mis datos")])])]) : _vm._e(), _vm._v(" "), (_vm.user && false) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/comments"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Actualice sus datos")])])]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('li', {
    staticClass: "pageLink",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._m(1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "fa fa-repeat"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Actualizar datos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "fa fa-sign-out-alt text-red"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Cerrar Sesión")])])
}]}

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [(_vm.statusList) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingProviders),
      expression: "loadingProviders"
    }],
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "'font-size": "15px",
      "text-align": "center"
    }
  }, _vm._l((_vm.statusList), function(item1) {
    return _c('th', {
      key: item1.idCompanyDataStatus,
      style: ('text-align: center; vertical-align: middle; width: ' + (100 / 3) + '%')
    }, [_vm._v(_vm._s(item1.description))])
  }), 0)]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "font-size": "25px",
      "text-align": "center"
    }
  }, _vm._l((_vm.companyDataStatus), function(item1) {
    return _c('td', {
      key: item1.idCompanyDataStatus,
      staticClass: "statusHover",
      on: {
        "click": function($event) {
          return _vm.searchStatus(item1.idCompanyDataStatus)
        }
      }
    }, [_vm._v(_vm._s(_vm.getCountByStatus(item1.idCompanyDataStatus)))])
  }), 0)])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "margin-top": "-20px",
      "margin-bottom": "10px"
    },
    attrs: {
      "span": 8
    }
  }, [_c('countries-group', {
    attrs: {
      "filter": _vm.filters[3],
      "show-all-button": false
    },
    on: {
      "update-filter": _vm.updateFilter
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-row', {
    staticClass: "filters-container",
    attrs: {
      "type": "flex",
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Buscar"
    },
    model: {
      value: (_vm.filters[0].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[0], "value", $$v)
      },
      expression: "filters[0].value"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "Etapa"
    },
    model: {
      value: (_vm.filters[2].value),
      callback: function($$v) {
        _vm.$set(_vm.filters[2], "value", $$v)
      },
      expression: "filters[2].value"
    }
  }, _vm._l((_vm.companyDataStage), function(item) {
    return _c('el-option', {
      key: item.stage,
      attrs: {
        "value": item.idStage,
        "label": item.stage
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('data-tables', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingProviders),
      expression: "loadingProviders"
    }],
    attrs: {
      "id": "tablaProveedores",
      "data": _vm.newProviders,
      "pagination-props": {
        pageSizes: [10, 20, 30]
      },
      "filters": _vm.filters
    }
  }, [_vm._l((_vm.titles), function(title) {
    return (_vm.country === 'Argentina') ? _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "sortable": "custom"
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.titlesPeru), function(title) {
    return (_vm.country === 'Peru') ? _c('el-table-column', {
      key: title.prop,
      attrs: {
        "prop": title.prop,
        "label": title.label,
        "sortable": "custom"
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.country !== 'Peru') ? _c('el-table-column', {
    attrs: {
      "label": "Servicios",
      "width": 150
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.rubros), function(rubro, index) {
          return _c('span', {
            key: rubro.idRubro
          }, [_vm._v("\n                    " + _vm._s(rubro.nombre) + "\n                    "), ((index + 1) < scope.row.rubros.length) ? _c('span', [_vm._v("\n                      /\n                    ")]) : _vm._e()])
        })
      }
    }], null, false, 3548534837)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "align": 'center',
      "width": 100,
      "label": 'Alta de Usuario'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.country === 'Argentina') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Ver",
            "placement": "top-end"
          }
        }, [_c('el-button', {
          attrs: {
            "data-cy": 'btn-' + scope.row.fiscalId,
            "type": "primary",
            "icon": "el-icon-view",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.goToDetails(scope.row.idCompany, scope.row.idFIT, scope.row.codCountry)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.country === 'Peru') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Ver",
            "placement": "top-end"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "danger",
            "icon": "el-icon-view",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.goToDetails(scope.row.idCompany, scope.row.idFIT, scope.row.codCountry)
            }
          }
        })], 1) : _vm._e()]
      }
    }])
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "label": _vm.data.label
    }
  }, [_c('el-col', {
    attrs: {
      "span": 23
    }
  }, [_c('el-input', {
    class: (_vm.verifyFields(_vm.data, _vm.validation) ||
        _vm.verifyEmail(_vm.data) ||
        _vm.verifyNumbers(_vm.data) ||
        _vm.verifyPasswords(_vm.data)) &&
      !_vm.disabled ? 'input-warning' : '',
    staticStyle: {
      "margin-left": "4%"
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": _vm.data.type,
      "maxlength": _vm.data.max,
      "show-word-limit": ""
    },
    on: {
      "input": function($event) {
        _vm.data.type !== 'password' && _vm.saveDataToLocalStorage(_vm.data.model, _vm.data.name)
      }
    },
    model: {
      value: (_vm.data.model),
      callback: function($$v) {
        _vm.$set(_vm.data, "model", $$v)
      },
      expression: "data.model"
    }
  })], 1), _vm._v(" "), (_vm.verifyFields(_vm.data, _vm.validation) && !_vm.disabled) ? _c('el-alert', {
    staticClass: "message-warning",
    attrs: {
      "title": ("Falta completar: " + (_vm.data.label)),
      "type": "error",
      "closable": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.verifyEmail(_vm.data)) ? _c('el-alert', {
    staticClass: "message-warning",
    attrs: {
      "title": "Ingresar Email valido",
      "type": "error",
      "closable": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.verifyNumbers(_vm.data)) ? _c('el-alert', {
    staticClass: "message-warning",
    attrs: {
      "title": ("Ingresar " + (_vm.data.max) + " valores numericos"),
      "type": "error",
      "closable": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.verifyPasswordLength(_vm.data)) ? _c('el-alert', {
    staticClass: "message-warning",
    attrs: {
      "title": "Las contraseñas deben tener mas de 6 caracteres",
      "type": "error",
      "closable": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.verifyPasswords(_vm.data)) ? _c('el-alert', {
    staticClass: "message-warning",
    attrs: {
      "title": "Las contraseñas no coinciden",
      "type": "error",
      "closable": false
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-table"
  }, [_c('div', {
    staticClass: "row vertical-10p"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/logok.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-6 col-sm-offset-3"
  }, [_c('h1', [_vm._v("Requerimiento errado.")]), _vm._v(" "), _c('h4', [_vm._v("La página solicitada no existe.")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Ir a inicio.")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [(_vm.answer) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "13%"
    }
  }, [_vm._v("Descripción:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding-right": "30px"
    }
  }, [_vm._v(_vm._s(_vm.answer.description))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Fecha y hora:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.answer.dateComments))])]), _vm._v(" "), (_vm.answer.idRefenceTo) ? _c('tr', [_c('th', [_vm._v("En respuesta a:")]), _vm._v(" "), _c('td', _vm._l((_vm.comments), function(item, index) {
    return _c('span', [(item.idComments === _vm.answer.idRefenceTo) ? _c('font', [_vm._v(_vm._s(item.description))]) : _vm._e()], 1)
  }), 0)]) : _vm._e()])])])])])]) : _vm._e(), _vm._v(" "), (!_vm.answer) ? _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('router-link', {
    class: 'btn btn-primary btn-lg',
    attrs: {
      "to": "/allComments",
      "tag": "button"
    }
  }, [_vm._v("Ver todos los mensajes")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_c('span', {
    staticClass: "info-box-icon bg-yellow"
  }, [_c('i', {
    staticClass: "ion ion-android-alert"
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v("Advertencia")]), _vm._v(" "), _c('span', {
    staticClass: "info-box-info"
  }, [_vm._v("Comentario no encontrado")])])])])
}]}

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "switch-box"
  }, [_c('el-row', [_c('p', {}, [_vm._v("\n      " + _vm._s(_vm.data.label) + "\n    ")])]), _vm._v(" "), _c('el-form-item', [_c('el-switch', {
    staticStyle: {
      "--el-switch-on-color": "#13ce66",
      "--el-switch-off-color": "#ff4949"
    },
    attrs: {
      "disabled": _vm.disabled,
      "size": "",
      "active-text": "Si",
      "inactive-text": "No"
    },
    on: {
      "change": function($event) {
        return _vm.saveDataToLocalStorage(_vm.data.model, _vm.data.name)
      }
    },
    model: {
      value: (_vm.data.model),
      callback: function($$v) {
        _vm.$set(_vm.data, "model", $$v)
      },
      expression: "data.model"
    }
  })], 1), _vm._v(" "), (_vm.data.model) ? _c('el-form-item', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "label": _vm.data.companyDataRetention.label
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    class: _vm.verifyFields(_vm.data.companyDataRetention, _vm.validation) ? 'input-warning' : '',
    staticStyle: {
      "margin-left": "11%"
    },
    attrs: {
      "multiple": "",
      "disabled": _vm.disabled,
      "multiple-limit": 2,
      "placeholder": _vm.data.companyDataRetention.placeholder,
      "required": _vm.data.companyDataRetention.required
    },
    on: {
      "change": function($event) {
        return _vm.generateAliquotOptions(_vm.data.companyDataRetention.model)
      },
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.data.companyDataRetention.model, _vm.data.companyDataRetention.name)
      }
    },
    model: {
      value: (_vm.data.companyDataRetention.model),
      callback: function($$v) {
        _vm.$set(_vm.data.companyDataRetention, "model", $$v)
      },
      expression: "data.companyDataRetention.model"
    }
  }, _vm._l((_vm.data.companyDataRetention.optionValue), function(option) {
    return _c('el-option', {
      key: option.idRetentionRegime,
      attrs: {
        "label": option.retentionRegime,
        "value": option.idRetentionRegime
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 23
    }
  }, [(_vm.verifyFields(_vm.data.companyDataRetention, _vm.validation)) ? _c('el-alert', {
    staticClass: "message-warning",
    attrs: {
      "title": ("Falta completar: " + (_vm.data.companyDataRetention.label)),
      "type": "error",
      "closable": false
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.data.model) ? _c('el-form-item', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "label": _vm.data.companyRetentionFields.label
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-select', {
    class: _vm.verifyFields(_vm.data.companyRetentionFields, _vm.validation) ? 'input-warning' : '',
    staticStyle: {
      "margin-left": "11%"
    },
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.data.companyRetentionFields.placeholder,
      "required": _vm.data.companyRetentionFields.required
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.data.companyRetentionFields.model, _vm.data.companyRetentionFields.name)
      }
    },
    model: {
      value: (_vm.data.companyRetentionFields.model),
      callback: function($$v) {
        _vm.$set(_vm.data.companyRetentionFields, "model", $$v)
      },
      expression: "data.companyRetentionFields.model"
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('el-option', {
      key: option.idCategoryRetain,
      attrs: {
        "label": option.categoryRetain,
        "value": option.idCategoryRetain
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 23
    }
  }, [(_vm.verifyFields(_vm.data.companyRetentionFields, _vm.validation)) ? _c('el-alert', {
    staticClass: "message-warning",
    attrs: {
      "title": ("Falta completar: " + (_vm.data.companyRetentionFields.label)),
      "type": "error",
      "closable": false
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.data.companyDataRetention.model.includes('Retención Detracciones') && _vm.data.model)) ? _c('p', [_vm._v("Suspensión")]) : _vm._e(), _vm._v(" "), ((_vm.data.companyDataRetention.model.includes('Retención Detracciones') && _vm.data.model)) ? _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.data.companySuspensionNumber.label
    }
  }, [_c('el-input', {
    class: _vm.verifyFields(_vm.data.companySuspensionNumber, _vm.validation) ? 'input-warning' : '',
    staticStyle: {
      "margin-left": "4%"
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": _vm.data.companySuspensionNumber.type
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.data.companySuspensionNumber.model, _vm.data.companySuspensionNumber.name)
      }
    },
    model: {
      value: (_vm.data.companySuspensionNumber.model),
      callback: function($$v) {
        _vm.$set(_vm.data.companySuspensionNumber, "model", $$v)
      },
      expression: "data.companySuspensionNumber.model"
    }
  })], 1), _vm._v(" "), (_vm.verifyFields(_vm.data.companySuspensionNumber, _vm.validation)) ? _c('el-alert', {
    staticClass: "message-warning",
    staticStyle: {
      "margin-left": "34%",
      "margin-top": "-20px",
      "margin-bottom": "10px"
    },
    attrs: {
      "title": ("Falta completar: " + (_vm.data.companySuspensionNumber.label)),
      "type": "error",
      "closable": false
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-date-picker', {
    class: _vm.verifyFields(_vm.data.firstDate, _vm.validation) ? 'input-warning' : '',
    staticStyle: {
      "margin-left": "2.5%"
    },
    attrs: {
      "disabled": _vm.disabled,
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "Desde"
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.data.firstDate.model, _vm.data.firstDate.name)
      }
    },
    model: {
      value: (_vm.data.firstDate.model),
      callback: function($$v) {
        _vm.$set(_vm.data.firstDate, "model", $$v)
      },
      expression: "data.firstDate.model"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    class: _vm.verifyFields(_vm.data.lastDate, _vm.validation) ? 'input-warning' : '',
    attrs: {
      "disabled": _vm.disabled,
      "format": "dd/MM/yyyy",
      "value-format": "yyyy-MM-dd",
      "type": "date",
      "placeholder": "Hasta",
      "picker-options": _vm.disabledDates
    },
    on: {
      "input": function($event) {
        return _vm.saveDataToLocalStorage(_vm.data.lastDate.model, _vm.data.lastDate.name)
      }
    },
    model: {
      value: (_vm.data.lastDate.model),
      callback: function($$v) {
        _vm.$set(_vm.data.lastDate, "model", $$v)
      },
      expression: "data.lastDate.model"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "span": 12
    }
  }, [_c('pdf-file', {
    attrs: {
      "disabled": _vm.disabled,
      "pdfFilePath": _vm.data.pdfSuspension.model,
      "habModificaPdf": _vm.habModificaPdf,
      "titulo": _vm.data.pdfSuspension.label,
      "id": _vm.data.pdfSuspension.label,
      "prop": _vm.data.pdfSuspension.name,
      "country": 'PER'
    },
    on: {
      "update:pdfFilePath": function($event) {
        return _vm.$set(_vm.data.pdfSuspension, "model", $event)
      },
      "update:pdf-file-path": function($event) {
        return _vm.$set(_vm.data.pdfSuspension, "model", $event)
      }
    }
  })], 1), _vm._v(" "), (_vm.verifyFields(_vm.data.pdfSuspension, _vm.validation)) ? _c('el-alert', {
    staticClass: "message-warning",
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "title": ("Falta completar: " + (_vm.data.pdfSuspension.label)),
      "type": "error",
      "closable": false
    }
  }) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box-content"
  }, [_c('div', [_c('div', {
    staticClass: "back-btn"
  }, [_c('el-button', {
    on: {
      "click": _vm.goBackPage
    }
  }, [_vm._v("< Volver")])], 1)]), _vm._v(" "), _c('div', [_c('steps-pagination', {
    attrs: {
      "activeStep": _vm.step,
      "isConfirmProvider": true
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.step == 0) ? _c('el-card', {
    staticClass: "box-card",
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "card-header"
        }, [_c('p', [_vm._v("Datos generales")])])]
      },
      proxy: true
    }], null, false, 725694500)
  }, [_vm._v(" "), (
    _vm.provider &&
    _vm.provider.generalData.idCompanyDataStatus !==
    _vm.status.DEVUELTO &&
    _vm.user.isProvider
  ) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "start"
    }
  }, [(!_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.editing = true
      }
    }
  }, [_vm._v("Editar")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.modifyData('generalData')
      }
    }
  }, [_vm._v("Guardar")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.editing = false
      }
    }
  }, [_vm._v("Cancelar")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "margin-top": "5rem"
    }
  }, [(_vm.step === 0) ? _c('el-form', {
    ref: "generalDataForm",
    staticStyle: {
      "width": "80%",
      "margin": "auto"
    },
    attrs: {
      "label-width": "200px"
    }
  }, [_c('el-divider', [_vm._v("Datos de la empresa")]), _vm._v(" "), _c('alta-id', {
    attrs: {
      "idStatus": _vm.idStatus,
      "type": _vm.idType,
      "id": _vm.id,
      "disabled": true
    },
    on: {
      "validate-id": _vm.validateIDHandler
    }
  }), _vm._v(" "), _c('alta-form', {
    attrs: {
      "dataForm": _vm.generalData,
      "locations": _vm.locations,
      "validation": _vm.nextStepFlag,
      "disabled": !_vm.editing
    }
  }), _vm._v(" "), (
    _vm.provider &&
    _vm.provider.generalData.idCompanyDataStatus ===
    _vm.status.DEVUELTO
  ) ? _c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "300",
      "float": "left"
    }
  }, [_vm._v("Observaciones")])]), _vm._v(" "), _c('div', {
    staticClass: "text item",
    staticStyle: {
      "font-weight": "300"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.provider.generalData.observation) + "\n              ")])]) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider.generalData.idCompanyDataStatus ===
    _vm.status.DEVUELTO &&
    _vm.user.isProvider
  ) ? _c('div', {
    key: _vm.editing,
    staticClass: "row text-center",
    staticStyle: {
      "marginRight": "120px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.modifyData('generalData')
      }
    }
  }, [_vm._v("\n                Volver a enviar los datos\n              ")])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider.generalData.idCompanyDataStatus ===
    _vm.status.ESPERANDO_CONFIRMACION
  ) ? _c('div', {
    staticClass: "row text-center"
  }) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("\n              Siguiente >\n            ")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.emailSoporte !== '') ? _c('div', {
    staticClass: "email__consultas-container",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('el-col', {
    staticClass: "email__consultas",
    attrs: {
      "span": 8
    }
  }, [_vm._v("Si tiene alguna duda o consulta técnica, por favor contactese\n            con: "), _c('b', [_vm._v(_vm._s(_vm.emailSoporte))])])], 1) : _vm._e()]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.step === 1) ? _c('el-card', {
    staticClass: "box-card",
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "card-header"
        }, [_c('p', [_vm._v("Datos Impositivos")])])]
      },
      proxy: true
    }], null, false, 498538162)
  }, [_vm._v(" "), (
    _vm.provider &&
    _vm.provider.taxData.idCompanyDataStatus !==
    _vm.status.DEVUELTO &&
    _vm.user.isProvider
  ) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "start"
    }
  }, [(!_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.editing = true
      }
    }
  }, [_vm._v("Editar")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.modifyData('taxData')
      }
    }
  }, [_vm._v("Guardar")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.editing = false
      }
    }
  }, [_vm._v("Cancelar")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "text-danger"
  }, [_vm._v("\n          Los campos acompañados con asterisco(*) son obligatorios\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.step == 1) ? _c('el-form', {
    staticStyle: {
      "width": "80%",
      "margin": "auto"
    },
    attrs: {
      "label-width": "200px"
    }
  }, [_c('el-divider', [_vm._v("Datos Impositivos")]), _vm._v(" "), _c('alta-form', {
    attrs: {
      "dataForm": _vm.companyTaxData,
      "validation": _vm.nextStepFlag,
      "disabled": !_vm.editing
    }
  }), _vm._v(" "), (
    _vm.provider &&
    _vm.provider.taxData.idCompanyDataStatus ===
    _vm.status.DEVUELTO
  ) ? _c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "300",
      "float": "left"
    }
  }, [_vm._v("Observaciones")])]), _vm._v(" "), _c('div', {
    staticClass: "text item",
    staticStyle: {
      "font-weight": "300"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.provider.taxData.observation) + "\n              ")])]) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider.taxData.idCompanyDataStatus ===
    _vm.status.DEVUELTO &&
    _vm.user.isProvider
  ) ? _c('div', {
    key: _vm.editing,
    staticClass: "row text-center",
    staticStyle: {
      "marginRight": "120px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.modifyData('taxData')
      }
    }
  }, [_vm._v("\n                Volver a enviar los datos\n              ")])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider.taxData.idCompanyDataStatus ===
    _vm.status.ESPERANDO_CONFIRMACION
  ) ? _c('div', {
    staticClass: "row text-center"
  }) : _vm._e(), _vm._v(" "), _c('el-button-group', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.backStep
    }
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Siguiente >")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.emailSoporte !== '') ? _c('div', {
    staticClass: "email__consultas-container",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('el-col', {
    staticClass: "email__consultas",
    attrs: {
      "span": 8
    }
  }, [_vm._v("Si tiene alguna duda o consulta técnica, por favor contactese\n            con: "), _c('b', [_vm._v(_vm._s(_vm.emailSoporte))])])], 1) : _vm._e()]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.step === 2) ? _c('el-card', {
    staticClass: "box-card",
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "card-header"
        }, [_c('p', [_vm._v("Datos Bancarios")])])]
      },
      proxy: true
    }], null, false, 894485228)
  }, [_vm._v(" "), (
    _vm.provider &&
    _vm.provider.paymentData.idCompanyDataStatus !==
    _vm.status.DEVUELTO &&
    _vm.user.isProvider
  ) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "start"
    }
  }, [(!_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.editing = true
      }
    }
  }, [_vm._v("Editar")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.modifyData('paymentData')
      }
    }
  }, [_vm._v("Guardar")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        _vm.editing = false
      }
    }
  }, [_vm._v("Cancelar")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "text-danger"
  }, [_vm._v("\n          Los campos acompañados con asterisco(*) son obligatorios\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.step == 2) ? _c('el-form', {
    staticStyle: {
      "width": "80%",
      "margin": "auto"
    },
    attrs: {
      "label-width": "200px"
    }
  }, [_c('el-divider', [_vm._v("Datos Bancarios 1")]), _vm._v(" "), _c('alta-form', {
    attrs: {
      "dataForm": _vm.paymentData1,
      "banks": _vm.banks,
      "bankAccountTypes": _vm.bankAccountTypes,
      "validation": _vm.nextStepFlag,
      "disabled": !_vm.editing
    }
  }), _vm._v(" "), _c('el-divider', [_vm._v("Datos Bancarios 2 (Opcional)")]), _vm._v(" "), _c('el-switch', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "disabled": !_vm.editing,
      "active-text": "Activar",
      "inactive-text": "Desactivar"
    },
    on: {
      "change": function($event) {
        return _vm.clearOptionalPaymentData(_vm.optionalPaymentFlag.model)
      }
    },
    model: {
      value: (_vm.optionalPaymentFlag.model),
      callback: function($$v) {
        _vm.$set(_vm.optionalPaymentFlag, "model", $$v)
      },
      expression: "optionalPaymentFlag.model"
    }
  }), _vm._v(" "), _c('alta-form', {
    attrs: {
      "dataForm": _vm.paymentData2,
      "banks": _vm.banks,
      "bankAccountTypes": _vm.bankAccountTypes,
      "disabled": !_vm.optionalPaymentFlag.model || !_vm.editing
    }
  }), _vm._v(" "), (_vm.companyTaxData.detractionSwitch.model) ? _c('el-divider') : _vm._e(), _vm._v(" "), (_vm.companyTaxData.detractionSwitch.model) ? _c('div', [_c('h6', [_vm._v("En caso de realizar actividades sujetas a detracción, por favor completar")]), _vm._v(" "), _c('alta-form', {
    attrs: {
      "dataForm": _vm.paymentData3,
      "validation": _vm.nextStepFlag,
      "disabled": !_vm.editing
    }
  })], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider.paymentData.idCompanyDataStatus ===
    _vm.status.DEVUELTO
  ) ? _c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "300",
      "float": "left"
    }
  }, [_vm._v("Observaciones")])]), _vm._v(" "), _c('div', {
    staticClass: "text item",
    staticStyle: {
      "font-weight": "300"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.provider.paymentData.observation) + "\n              ")])]) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider.paymentData.idCompanyDataStatus ===
    _vm.status.DEVUELTO &&
    _vm.user.isProvider
  ) ? _c('div', {
    key: _vm.editing,
    staticClass: "row text-center",
    staticStyle: {
      "marginRight": "120px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.modifyData('paymentData')
      }
    }
  }, [_vm._v("\n                Volver a enviar los datos\n              ")])], 1) : _vm._e(), _vm._v(" "), (
    _vm.provider &&
    _vm.provider.paymentData.idCompanyDataStatus ===
    _vm.status.ESPERANDO_CONFIRMACION
  ) ? _c('div', {
    staticClass: "row text-center"
  }) : _vm._e(), _vm._v(" "), _c('el-button-group', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.backStep
    }
  }, [_vm._v("< Anterior")]), _vm._v(" "), (_vm.step <= 1) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Siguiente >")]) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.emailSoporte !== '') ? _c('div', {
    staticClass: "email__consultas-container",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('el-col', {
    staticClass: "email__consultas",
    attrs: {
      "span": 8
    }
  }, [_vm._v("Si tiene alguna duda o consulta técnica, por favor contactese\n            con: "), _c('b', [_vm._v(_vm._s(_vm.emailSoporte))])])], 1) : _vm._e()]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.step == 3) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-card', {
    staticClass: "box-card",
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "card-header"
        }, [_c('p', [_vm._v("Usuario")])])]
      },
      proxy: true
    }], null, false, 516869071)
  }, [_vm._v(" "), _c('p', {
    staticClass: "text-danger"
  }, [_vm._v("\n          Los campos acompañados con asterisco(*) son obligatorios\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-form', {
    staticStyle: {
      "width": "80%",
      "margin": "auto"
    },
    attrs: {
      "label-width": "200px"
    }
  }, [_c('alta-form', {
    attrs: {
      "dataForm": _vm.userData,
      "validation": _vm.nextStepFlag
    }
  }), _vm._v(" "), (this.response) ? _c('p', {
    staticStyle: {
      "color": "#a94442"
    }
  }, [_vm._v("\n            " + _vm._s(this.response) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('el-divider'), _vm._v(" "), (_vm.validateRuc) ? _c('el-button-group', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.backStep
    }
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.openModalTerminosYCondiciones
    }
  }, [_vm._v("Confirmar")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.emailSoporte !== '') ? _c('div', {
    staticClass: "email__consultas-container",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('el-col', {
    staticClass: "email__consultas",
    attrs: {
      "span": 8
    }
  }, [_vm._v("Si tiene alguna duda o consulta técnica, por favor contactese\n            con: "), _c('b', [_vm._v(_vm._s(_vm.emailSoporte))])])], 1) : _vm._e()])], 1), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "margin-top": "-12vh",
      "height": "auto",
      "overflow-y": "hidden"
    },
    attrs: {
      "title": "Confirmar Alta de Proveedor",
      "visible": _vm.showTerminosYCondiciones,
      "width": "80%",
      "lock-scroll": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showTerminosYCondiciones = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "60vh",
      "overflow": "auto"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.configuration))]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked2),
      expression: "checked2"
    }],
    staticStyle: {
      "width": "15px",
      "margin": "0 5px 0 0",
      "padding-bottom": "5px"
    },
    attrs: {
      "type": "checkbox",
      "name": "aceptoCodigoEtica",
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.checked2) ? _vm._i(_vm.checked2, null) > -1 : (_vm.checked2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checked2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked2 = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checked2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked2 = $$c
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Acepto el\n            "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.codigoEtica
    }
  }, [_vm._v("Código de Ética y Conducta\n            ")]), _vm._v(".\n          ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    staticStyle: {
      "width": "15px",
      "margin": "0 5px 0 0"
    },
    attrs: {
      "type": "checkbox",
      "name": "aceptoTerminos",
      "required": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, null) > -1 : (_vm.checked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked = $$c
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("\n            Acepto las políticas:\n            "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.politicaAnticorrupcion
    }
  }, [_vm._v("Política Anticorrupción")]), _vm._v("\n            y\n            "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "target": "_blank",
      "rel": "noopener noreferrer",
      "href": _vm.politicaRelacionamiento
    }
  }, [_vm._v("Política de Relacionamiento con Funcionarios Públicos.")])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    attrs: {
      "type": "submit",
      "disabled": !_vm.checked2 || !_vm.checked
    },
    on: {
      "click": function($event) {
        return _vm.submitFormSolicitud()
      }
    }
  }, [_vm._v("\n        Aceptar\n        ")])])])])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 662 */,
/* 663 */,
/* 664 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[370]);


// WEBPACK FOOTER //
// static/js/app.43942704383e0e8e1298.js